(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.CSVImporter = {}));
})(this, (function (exports) { 'use strict';

  function _mergeNamespaces(n, m) {
    m.forEach(function (e) {
      e && typeof e !== 'string' && !Array.isArray(e) && Object.keys(e).forEach(function (k) {
        if (k !== 'default' && !(k in n)) {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    });
    return Object.freeze(n);
  }

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
  };

  function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
  }

  function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
  }

  function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
  }

  function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  }

  typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn) {
    var module = { exports: {} };
  	return fn(module, module.exports), module.exports;
  }

  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var l$3=Symbol.for("react.element"),n$3=Symbol.for("react.portal"),p$5=Symbol.for("react.fragment"),q$4=Symbol.for("react.strict_mode"),r$4=Symbol.for("react.profiler"),t$4=Symbol.for("react.provider"),u$2=Symbol.for("react.context"),v$3=Symbol.for("react.forward_ref"),w$2=Symbol.for("react.suspense"),x$1=Symbol.for("react.memo"),y$1=Symbol.for("react.lazy"),z$2=Symbol.iterator;function A$2(a){if(null===a||"object"!==typeof a)return null;a=z$2&&a[z$2]||a["@@iterator"];return "function"===typeof a?a:null}
  var B$1={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C$1=Object.assign,D$1={};function E$1(a,b,e){this.props=a;this.context=b;this.refs=D$1;this.updater=e||B$1;}E$1.prototype.isReactComponent={};
  E$1.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState");};E$1.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};function F(){}F.prototype=E$1.prototype;function G$1(a,b,e){this.props=a;this.context=b;this.refs=D$1;this.updater=e||B$1;}var H$1=G$1.prototype=new F;
  H$1.constructor=G$1;C$1(H$1,E$1.prototype);H$1.isPureReactComponent=!0;var I$1=Array.isArray,J=Object.prototype.hasOwnProperty,K$1={current:null},L$1={key:!0,ref:!0,__self:!0,__source:!0};
  function M$1(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L$1.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f;}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return {$$typeof:l$3,type:a,key:k,ref:h,props:c,_owner:K$1.current}}
  function N$1(a,b){return {$$typeof:l$3,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O$1(a){return "object"===typeof a&&null!==a&&a.$$typeof===l$3}function escape$3(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var P$1=/\/+/g;function Q$1(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape$3(""+a.key):b.toString(36)}
  function R$1(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l$3:case n$3:h=!0;}}if(h)return h=a,c=c(h),a=""===d?"."+Q$1(h,0):d,I$1(c)?(e="",null!=a&&(e=a.replace(P$1,"$&/")+"/"),R$1(c,b,e,"",function(a){return a})):null!=c&&(O$1(c)&&(c=N$1(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P$1,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I$1(a))for(var g=0;g<a.length;g++){k=
  a[g];var f=d+Q$1(k,g);h+=R$1(k,b,e,f,c);}else if(f=A$2(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q$1(k,g++),h+=R$1(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
  function S$1(a,b,e){if(null==a)return a;var d=[],c=0;R$1(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T$1(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b;},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b;});-1===a._status&&(a._status=0,a._result=b);}if(1===a._status)return a._result.default;throw a._result;}
  var U$1={current:null},V$1={transition:null},W$1={ReactCurrentDispatcher:U$1,ReactCurrentBatchConfig:V$1,ReactCurrentOwner:K$1};var Children={map:S$1,forEach:function(a,b,e){S$1(a,function(){b.apply(this,arguments);},e);},count:function(a){var b=0;S$1(a,function(){b++;});return b},toArray:function(a){return S$1(a,function(a){return a})||[]},only:function(a){if(!O$1(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};var Component=E$1;var Fragment$2=p$5;
  var Profiler$1=r$4;var PureComponent=G$1;var StrictMode$1=q$4;var Suspense$1=w$2;var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED$1=W$1;
  var cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C$1({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K$1.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L$1.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
  for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g;}return {$$typeof:l$3,type:a.type,key:c,ref:k,props:d,_owner:h}};var createContext$2=function(a){a={$$typeof:u$2,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t$4,_context:a};return a.Consumer=a};var createElement=M$1;var createFactory=function(a){var b=M$1.bind(null,a);b.type=a;return b};var createRef=function(){return {current:null}};
  var forwardRef$1=function(a){return {$$typeof:v$3,render:a}};var isValidElement=O$1;var lazy=function(a){return {$$typeof:y$1,_payload:{_status:-1,_result:a},_init:T$1}};var memo$1=function(a,b){return {$$typeof:x$1,type:a,compare:void 0===b?null:b}};var startTransition=function(a){var b=V$1.transition;V$1.transition={};try{a();}finally{V$1.transition=b;}};var unstable_act=function(){throw Error("act(...) is not supported in production builds of React.");};
  var useCallback=function(a,b){return U$1.current.useCallback(a,b)};var useContext=function(a){return U$1.current.useContext(a)};var useDebugValue$1=function(){};var useDeferredValue=function(a){return U$1.current.useDeferredValue(a)};var useEffect=function(a,b){return U$1.current.useEffect(a,b)};var useId=function(){return U$1.current.useId()};var useImperativeHandle=function(a,b,e){return U$1.current.useImperativeHandle(a,b,e)};
  var useInsertionEffect$1=function(a,b){return U$1.current.useInsertionEffect(a,b)};var useLayoutEffect=function(a,b){return U$1.current.useLayoutEffect(a,b)};var useMemo=function(a,b){return U$1.current.useMemo(a,b)};var useReducer=function(a,b,e){return U$1.current.useReducer(a,b,e)};var useRef=function(a){return U$1.current.useRef(a)};var useState=function(a){return U$1.current.useState(a)};var useSyncExternalStore$1=function(a,b,e){return U$1.current.useSyncExternalStore(a,b,e)};
  var useTransition=function(){return U$1.current.useTransition()};var version$1="18.2.0";

  var react_production_min = {
  	Children: Children,
  	Component: Component,
  	Fragment: Fragment$2,
  	Profiler: Profiler$1,
  	PureComponent: PureComponent,
  	StrictMode: StrictMode$1,
  	Suspense: Suspense$1,
  	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED$1,
  	cloneElement: cloneElement,
  	createContext: createContext$2,
  	createElement: createElement,
  	createFactory: createFactory,
  	createRef: createRef,
  	forwardRef: forwardRef$1,
  	isValidElement: isValidElement,
  	lazy: lazy,
  	memo: memo$1,
  	startTransition: startTransition,
  	unstable_act: unstable_act,
  	useCallback: useCallback,
  	useContext: useContext,
  	useDebugValue: useDebugValue$1,
  	useDeferredValue: useDeferredValue,
  	useEffect: useEffect,
  	useId: useId,
  	useImperativeHandle: useImperativeHandle,
  	useInsertionEffect: useInsertionEffect$1,
  	useLayoutEffect: useLayoutEffect,
  	useMemo: useMemo,
  	useReducer: useReducer,
  	useRef: useRef,
  	useState: useState,
  	useSyncExternalStore: useSyncExternalStore$1,
  	useTransition: useTransition,
  	version: version$1
  };

  var react = createCommonjsModule(function (module) {

  {
    module.exports = react_production_min;
  }
  });

  var React = /*#__PURE__*/_mergeNamespaces({
    __proto__: null,
    'default': react
  }, [react]);

  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var k$2=Symbol.for("react.element"),l$2=Symbol.for("react.fragment"),m$2=Object.prototype.hasOwnProperty,n$2=react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p$4={key:!0,ref:!0,__self:!0,__source:!0};
  function q$3(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m$2.call(a,b)&&!p$4.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k$2,type:c,key:e,ref:h,props:d,_owner:n$2.current}}var Fragment$1=l$2;var jsx=q$3;var jsxs=q$3;

  var reactJsxRuntime_production_min = {
  	Fragment: Fragment$1,
  	jsx: jsx,
  	jsxs: jsxs
  };

  var jsxRuntime = createCommonjsModule(function (module) {

  {
    module.exports = reactJsxRuntime_production_min;
  }
  });

  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var scheduler_production_min = createCommonjsModule(function (module, exports) {
  function f(a,b){var c=a.length;a.push(b);a:for(;0<c;){var d=c-1>>>1,e=a[d];if(0<g(e,b))a[d]=b,a[c]=e,c=d;else break a}}function h(a){return 0===a.length?null:a[0]}function k(a){if(0===a.length)return null;var b=a[0],c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length,w=e>>>1;d<w;){var m=2*(d+1)-1,C=a[m],n=m+1,x=a[n];if(0>g(C,c))n<e&&0>g(x,C)?(a[d]=x,a[n]=c,d=n):(a[d]=C,a[m]=c,d=m);else if(n<e&&0>g(x,c))a[d]=x,a[n]=c,d=n;else break a}}return b}
  function g(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()};}else {var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q};}var r=[],t=[],u=1,v=null,y=3,z=!1,A=!1,B=!1,D="function"===typeof setTimeout?setTimeout:null,E="function"===typeof clearTimeout?clearTimeout:null,F="undefined"!==typeof setImmediate?setImmediate:null;
  "undefined"!==typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function G(a){for(var b=h(t);null!==b;){if(null===b.callback)k(t);else if(b.startTime<=a)k(t),b.sortIndex=b.expirationTime,f(r,b);else break;b=h(t);}}function H(a){B=!1;G(a);if(!A)if(null!==h(r))A=!0,I(J);else {var b=h(t);null!==b&&K(H,b.startTime-a);}}
  function J(a,b){A=!1;B&&(B=!1,E(L),L=-1);z=!0;var c=y;try{G(b);for(v=h(r);null!==v&&(!(v.expirationTime>b)||a&&!M());){var d=v.callback;if("function"===typeof d){v.callback=null;y=v.priorityLevel;var e=d(v.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?v.callback=e:v===h(r)&&k(r);G(b);}else k(r);v=h(r);}if(null!==v)var w=!0;else {var m=h(t);null!==m&&K(H,m.startTime-b);w=!1;}return w}finally{v=null,y=c,z=!1;}}var N=!1,O=null,L=-1,P=5,Q=-1;
  function M(){return exports.unstable_now()-Q<P?!1:!0}function R(){if(null!==O){var a=exports.unstable_now();Q=a;var b=!0;try{b=O(!0,a);}finally{b?S():(N=!1,O=null);}}else N=!1;}var S;if("function"===typeof F)S=function(){F(R);};else if("undefined"!==typeof MessageChannel){var T=new MessageChannel,U=T.port2;T.port1.onmessage=R;S=function(){U.postMessage(null);};}else S=function(){D(R,0);};function I(a){O=a;N||(N=!0,S());}function K(a,b){L=D(function(){a(exports.unstable_now());},b);}
  exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null;};exports.unstable_continueExecution=function(){A||z||(A=!0,I(J));};
  exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):P=0<a?Math.floor(1E3/a):5;};exports.unstable_getCurrentPriorityLevel=function(){return y};exports.unstable_getFirstCallbackNode=function(){return h(r)};exports.unstable_next=function(a){switch(y){case 1:case 2:case 3:var b=3;break;default:b=y;}var c=y;y=b;try{return a()}finally{y=c;}};exports.unstable_pauseExecution=function(){};
  exports.unstable_requestPaint=function(){};exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3;}var c=y;y=a;try{return b()}finally{y=c;}};
  exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3;}e=c+e;a={id:u++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,f(t,a),null===h(r)&&a===h(t)&&(B?(E(L),L=-1):B=!0,K(H,c-d))):(a.sortIndex=e,f(r,a),A||z||(A=!0,I(J)));return a};
  exports.unstable_shouldYield=M;exports.unstable_wrapCallback=function(a){var b=y;return function(){var c=y;y=b;try{return a.apply(this,arguments)}finally{y=c;}}};
  });

  var scheduler = createCommonjsModule(function (module) {

  {
    module.exports = scheduler_production_min;
  }
  });

  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function p$3(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var da=new Set,ea={};function fa(a,b){ha(a,b);ha(a+"Capture",b);}
  function ha(a,b){ea[a]=b;for(a=0;a<b.length;a++)da.add(b[a]);}
  var ia=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ja=Object.prototype.hasOwnProperty,ka=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,la=
  {},ma={};function oa(a){if(ja.call(ma,a))return !0;if(ja.call(la,a))return !1;if(ka.test(a))return ma[a]=!0;la[a]=!0;return !1}function pa(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
  function qa(a,b,c,d){if(null===b||"undefined"===typeof b||pa(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function v$2(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g;}var z$1={};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z$1[a]=new v$2(a,0,!1,a,null,!1,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z$1[b]=new v$2(b,1,!1,a[1],null,!1,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z$1[a]=new v$2(a,2,!1,a.toLowerCase(),null,!1,!1);});
  ["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z$1[a]=new v$2(a,2,!1,a,null,!1,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z$1[a]=new v$2(a,3,!1,a.toLowerCase(),null,!1,!1);});
  ["checked","multiple","muted","selected"].forEach(function(a){z$1[a]=new v$2(a,3,!0,a,null,!1,!1);});["capture","download"].forEach(function(a){z$1[a]=new v$2(a,4,!1,a,null,!1,!1);});["cols","rows","size","span"].forEach(function(a){z$1[a]=new v$2(a,6,!1,a,null,!1,!1);});["rowSpan","start"].forEach(function(a){z$1[a]=new v$2(a,5,!1,a.toLowerCase(),null,!1,!1);});var ra=/[\-:]([a-z])/g;function sa(a){return a[1].toUpperCase()}
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ra,
  sa);z$1[b]=new v$2(b,1,!1,a,null,!1,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ra,sa);z$1[b]=new v$2(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ra,sa);z$1[b]=new v$2(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1);});["tabIndex","crossOrigin"].forEach(function(a){z$1[a]=new v$2(a,1,!1,a.toLowerCase(),null,!1,!1);});
  z$1.xlinkHref=new v$2("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){z$1[a]=new v$2(a,1,!1,a.toLowerCase(),null,!0,!0);});
  function ta(a,b,c,d){var e=z$1.hasOwnProperty(b)?z$1[b]:null;if(null!==e?0!==e.type:d||!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1])qa(b,c,e,d)&&(c=null),d||null===e?oa(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c)));}
  var ua=react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,va=Symbol.for("react.element"),wa=Symbol.for("react.portal"),ya=Symbol.for("react.fragment"),za=Symbol.for("react.strict_mode"),Aa=Symbol.for("react.profiler"),Ba=Symbol.for("react.provider"),Ca=Symbol.for("react.context"),Da=Symbol.for("react.forward_ref"),Ea=Symbol.for("react.suspense"),Fa=Symbol.for("react.suspense_list"),Ga=Symbol.for("react.memo"),Ha=Symbol.for("react.lazy");var Ia=Symbol.for("react.offscreen");var Ja=Symbol.iterator;function Ka(a){if(null===a||"object"!==typeof a)return null;a=Ja&&a[Ja]||a["@@iterator"];return "function"===typeof a?a:null}var A$1=Object.assign,La;function Ma(a){if(void 0===La)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);La=b&&b[1]||"";}return "\n"+La+a}var Na=!1;
  function Oa(a,b){if(!a||Na)return "";Na=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[]);}catch(l){var d=l;}Reflect.construct(a,[],b);}else {try{b.call();}catch(l){d=l;}a.call(b.prototype);}else {try{throw Error();}catch(l){d=l;}a();}}catch(l){if(l&&d&&"string"===typeof l.stack){for(var e=l.stack.split("\n"),
  f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h]){var k="\n"+e[g].replace(" at new "," at ");a.displayName&&k.includes("<anonymous>")&&(k=k.replace("<anonymous>",a.displayName));return k}while(1<=g&&0<=h)}break}}}finally{Na=!1,Error.prepareStackTrace=c;}return (a=a?a.displayName||a.name:"")?Ma(a):""}
  function Pa(a){switch(a.tag){case 5:return Ma(a.type);case 16:return Ma("Lazy");case 13:return Ma("Suspense");case 19:return Ma("SuspenseList");case 0:case 2:case 15:return a=Oa(a.type,!1),a;case 11:return a=Oa(a.type.render,!1),a;case 1:return a=Oa(a.type,!0),a;default:return ""}}
  function Qa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ya:return "Fragment";case wa:return "Portal";case Aa:return "Profiler";case za:return "StrictMode";case Ea:return "Suspense";case Fa:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ca:return (a.displayName||"Context")+".Consumer";case Ba:return (a._context.displayName||"Context")+".Provider";case Da:var b=a.render;a=a.displayName;a||(a=b.displayName||
  b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Ga:return b=a.displayName||null,null!==b?b:Qa(a.type)||"Memo";case Ha:b=a._payload;a=a._init;try{return Qa(a(b))}catch(c){}}return null}
  function Ra(a){var b=a.type;switch(a.tag){case 24:return "Cache";case 9:return (b.displayName||"Context")+".Consumer";case 10:return (b._context.displayName||"Context")+".Provider";case 18:return "DehydratedFragment";case 11:return a=b.render,a=a.displayName||a.name||"",b.displayName||(""!==a?"ForwardRef("+a+")":"ForwardRef");case 7:return "Fragment";case 5:return b;case 4:return "Portal";case 3:return "Root";case 6:return "Text";case 16:return Qa(b);case 8:return b===za?"StrictMode":"Mode";case 22:return "Offscreen";
  case 12:return "Profiler";case 21:return "Scope";case 13:return "Suspense";case 19:return "SuspenseList";case 25:return "TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"===typeof b)return b.displayName||b.name||null;if("string"===typeof b)return b}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "string":case "undefined":return a;case "object":return a;default:return ""}}
  function Ta(a){var b=a.type;return (a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
  function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a);}});Object.defineProperty(a,b,{enumerable:c.enumerable});return {getValue:function(){return d},setValue:function(a){d=""+a;},stopTracking:function(){a._valueTracker=
  null;delete a[b];}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a));}function Wa(a){if(!a)return !1;var b=a._valueTracker;if(!b)return !0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
  function Ya(a,b){var c=b.checked;return A$1({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value};}function ab(a,b){b=b.checked;null!=b&&ta(a,"checked",b,!1);}
  function bb(a,b){ab(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c;}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?cb(a,b.type,c):b.hasOwnProperty("defaultValue")&&cb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked);}
  function db(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b;}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c);}
  function cb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c);}var eb=Array.isArray;
  function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0);}else {c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e]);}null!==b&&(b.selected=!0);}}
  function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(p$3(91));return A$1({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(p$3(92));if(eb(c)){if(1<c.length)throw Error(p$3(93));c=c[0];}b=c;}null==b&&(b="");c=b;}a._wrapperState={initialValue:Sa(c)};}
  function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d);}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b);}function kb(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}
  function lb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?kb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
  var mb,nb=function(a){return "undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)});}:a}(function(a,b){if("http://www.w3.org/2000/svg"!==a.namespaceURI||"innerHTML"in a)a.innerHTML=b;else {mb=mb||document.createElement("div");mb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=mb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild);}});
  function ob(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b;}
  var pb={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,
  zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qb=["Webkit","ms","Moz","O"];Object.keys(pb).forEach(function(a){qb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pb[b]=pb[a];});});function rb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pb.hasOwnProperty(a)&&pb[a]?(""+b).trim():b+"px"}
  function sb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=rb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e;}}var tb=A$1({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
  function ub(a,b){if(b){if(tb[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(p$3(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(p$3(60));if("object"!==typeof b.dangerouslySetInnerHTML||!("__html"in b.dangerouslySetInnerHTML))throw Error(p$3(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(p$3(62));}}
  function vb(a,b){if(-1===a.indexOf("-"))return "string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return !1;default:return !0}}var wb=null;function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
  function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(p$3(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b));}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a;}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a]);}}function Gb(a,b){return a(b)}function Hb(){}var Ib=!1;function Jb(a,b,c){if(Ib)return a(b,c);Ib=!0;try{return Gb(a,b,c)}finally{if(Ib=!1,null!==zb||null!==Ab)Hb(),Fb();}}
  function Kb(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1;}if(a)return null;if(c&&"function"!==
  typeof c)throw Error(p$3(231,b,typeof c));return c}var Lb=!1;if(ia)try{var Mb={};Object.defineProperty(Mb,"passive",{get:function(){Lb=!0;}});window.addEventListener("test",Mb,Mb);window.removeEventListener("test",Mb,Mb);}catch(a){Lb=!1;}function Nb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l);}catch(m){this.onError(m);}}var Ob=!1,Pb=null,Qb=!1,Rb=null,Sb={onError:function(a){Ob=!0;Pb=a;}};function Tb(a,b,c,d,e,f,g,h,k){Ob=!1;Pb=null;Nb.apply(Sb,arguments);}
  function Ub(a,b,c,d,e,f,g,h,k){Tb.apply(this,arguments);if(Ob){if(Ob){var l=Pb;Ob=!1;Pb=null;}else throw Error(p$3(198));Qb||(Qb=!0,Rb=l);}}function Vb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else {a=b;do b=a,0!==(b.flags&4098)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Wb(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function Xb(a){if(Vb(a)!==a)throw Error(p$3(188));}
  function Yb(a){var b=a.alternate;if(!b){b=Vb(a);if(null===b)throw Error(p$3(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Xb(e),a;if(f===d)return Xb(e),b;f=f.sibling;}throw Error(p$3(188));}if(c.return!==d.return)c=e,d=f;else {for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling;}if(!g){for(h=f.child;h;){if(h===
  c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling;}if(!g)throw Error(p$3(189));}}if(c.alternate!==d)throw Error(p$3(190));}if(3!==c.tag)throw Error(p$3(188));return c.stateNode.current===c?a:b}function Zb(a){a=Yb(a);return null!==a?$b(a):null}function $b(a){if(5===a.tag||6===a.tag)return a;for(a=a.child;null!==a;){var b=$b(a);if(null!==b)return b;a=a.sibling;}return null}
  var ac=scheduler.unstable_scheduleCallback,bc=scheduler.unstable_cancelCallback,cc=scheduler.unstable_shouldYield,dc=scheduler.unstable_requestPaint,B=scheduler.unstable_now,ec=scheduler.unstable_getCurrentPriorityLevel,fc=scheduler.unstable_ImmediatePriority,gc=scheduler.unstable_UserBlockingPriority,hc=scheduler.unstable_NormalPriority,ic=scheduler.unstable_LowPriority,jc=scheduler.unstable_IdlePriority,kc=null,lc=null;function mc(a){if(lc&&"function"===typeof lc.onCommitFiberRoot)try{lc.onCommitFiberRoot(kc,a,void 0,128===(a.current.flags&128));}catch(b){}}
  var oc=Math.clz32?Math.clz32:nc,pc=Math.log,qc=Math.LN2;function nc(a){a>>>=0;return 0===a?32:31-(pc(a)/qc|0)|0}var rc=64,sc=4194304;
  function tc(a){switch(a&-a){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return a&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return a&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;
  default:return a}}function uc(a,b){var c=a.pendingLanes;if(0===c)return 0;var d=0,e=a.suspendedLanes,f=a.pingedLanes,g=c&268435455;if(0!==g){var h=g&~e;0!==h?d=tc(h):(f&=g,0!==f&&(d=tc(f)));}else g=c&~e,0!==g?d=tc(g):0!==f&&(d=tc(f));if(0===d)return 0;if(0!==b&&b!==d&&0===(b&e)&&(e=d&-d,f=b&-b,e>=f||16===e&&0!==(f&4194240)))return b;0!==(d&4)&&(d|=c&16);b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-oc(b),e=1<<c,d|=a[c],b&=~e;return d}
  function vc(a,b){switch(a){case 1:case 2:case 4:return b+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return b+5E3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return -1;case 134217728:case 268435456:case 536870912:case 1073741824:return -1;default:return -1}}
  function wc(a,b){for(var c=a.suspendedLanes,d=a.pingedLanes,e=a.expirationTimes,f=a.pendingLanes;0<f;){var g=31-oc(f),h=1<<g,k=e[g];if(-1===k){if(0===(h&c)||0!==(h&d))e[g]=vc(h,b);}else k<=b&&(a.expiredLanes|=h);f&=~h;}}function xc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function yc(){var a=rc;rc<<=1;0===(rc&4194240)&&(rc=64);return a}function zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
  function Ac(a,b,c){a.pendingLanes|=b;536870912!==b&&(a.suspendedLanes=0,a.pingedLanes=0);a=a.eventTimes;b=31-oc(b);a[b]=c;}function Bc(a,b){var c=a.pendingLanes&~b;a.pendingLanes=b;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=b;a.mutableReadLanes&=b;a.entangledLanes&=b;b=a.entanglements;var d=a.eventTimes;for(a=a.expirationTimes;0<c;){var e=31-oc(c),f=1<<e;b[e]=0;d[e]=-1;a[e]=-1;c&=~f;}}
  function Cc(a,b){var c=a.entangledLanes|=b;for(a=a.entanglements;c;){var d=31-oc(c),e=1<<d;e&b|a[d]&b&&(a[d]|=b);c&=~e;}}var C=0;function Dc(a){a&=-a;return 1<a?4<a?0!==(a&268435455)?16:536870912:4:1}var Ec,Fc,Gc,Hc,Ic,Jc=!1,Kc=[],Lc=null,Mc=null,Nc=null,Oc=new Map,Pc=new Map,Qc=[],Rc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function Sc(a,b){switch(a){case "focusin":case "focusout":Lc=null;break;case "dragenter":case "dragleave":Mc=null;break;case "mouseover":case "mouseout":Nc=null;break;case "pointerover":case "pointerout":Oc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Pc.delete(b.pointerId);}}
  function Tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a={blockedOn:b,domEventName:c,eventSystemFlags:d,nativeEvent:f,targetContainers:[e]},null!==b&&(b=Cb(b),null!==b&&Fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
  function Uc(a,b,c,d,e){switch(b){case "focusin":return Lc=Tc(Lc,a,b,c,d,e),!0;case "dragenter":return Mc=Tc(Mc,a,b,c,d,e),!0;case "mouseover":return Nc=Tc(Nc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Oc.set(f,Tc(Oc.get(f)||null,a,b,c,d,e));return !0;case "gotpointercapture":return f=e.pointerId,Pc.set(f,Tc(Pc.get(f)||null,a,b,c,d,e)),!0}return !1}
  function Vc(a){var b=Wc(a.target);if(null!==b){var c=Vb(b);if(null!==c)if(b=c.tag,13===b){if(b=Wb(c),null!==b){a.blockedOn=b;Ic(a.priority,function(){Gc(c);});return}}else if(3===b&&c.stateNode.current.memoizedState.isDehydrated){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null;}
  function Xc(a){if(null!==a.blockedOn)return !1;for(var b=a.targetContainers;0<b.length;){var c=Yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null===c){c=a.nativeEvent;var d=new c.constructor(c.type,c);wb=d;c.target.dispatchEvent(d);wb=null;}else return b=Cb(c),null!==b&&Fc(b),a.blockedOn=c,!1;b.shift();}return !0}function Zc(a,b,c){Xc(a)&&c.delete(b);}function $c(){Jc=!1;null!==Lc&&Xc(Lc)&&(Lc=null);null!==Mc&&Xc(Mc)&&(Mc=null);null!==Nc&&Xc(Nc)&&(Nc=null);Oc.forEach(Zc);Pc.forEach(Zc);}
  function ad(a,b){a.blockedOn===b&&(a.blockedOn=null,Jc||(Jc=!0,scheduler.unstable_scheduleCallback(scheduler.unstable_NormalPriority,$c)));}
  function bd(a){function b(b){return ad(b,a)}if(0<Kc.length){ad(Kc[0],a);for(var c=1;c<Kc.length;c++){var d=Kc[c];d.blockedOn===a&&(d.blockedOn=null);}}null!==Lc&&ad(Lc,a);null!==Mc&&ad(Mc,a);null!==Nc&&ad(Nc,a);Oc.forEach(b);Pc.forEach(b);for(c=0;c<Qc.length;c++)d=Qc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Qc.length&&(c=Qc[0],null===c.blockedOn);)Vc(c),null===c.blockedOn&&Qc.shift();}var cd=ua.ReactCurrentBatchConfig,dd=!0;
  function ed(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=1,fd(a,b,c,d);}finally{C=e,cd.transition=f;}}function gd(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=4,fd(a,b,c,d);}finally{C=e,cd.transition=f;}}
  function fd(a,b,c,d){if(dd){var e=Yc(a,b,c,d);if(null===e)hd(a,b,d,id$2,c),Sc(a,d);else if(Uc(e,a,b,c,d))d.stopPropagation();else if(Sc(a,d),b&4&&-1<Rc.indexOf(a)){for(;null!==e;){var f=Cb(e);null!==f&&Ec(f);f=Yc(a,b,c,d);null===f&&hd(a,b,d,id$2,c);if(f===e)break;e=f;}null!==e&&d.stopPropagation();}else hd(a,b,d,null,c);}}var id$2=null;
  function Yc(a,b,c,d){id$2=null;a=xb(d);a=Wc(a);if(null!==a)if(b=Vb(a),null===b)a=null;else if(c=b.tag,13===c){a=Wb(b);if(null!==a)return a;a=null;}else if(3===c){if(b.stateNode.current.memoizedState.isDehydrated)return 3===b.tag?b.stateNode.containerInfo:null;a=null;}else b!==a&&(a=null);id$2=a;return null}
  function jd(a){switch(a){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return 1;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return 4;
  case "message":switch(ec()){case fc:return 1;case gc:return 4;case hc:case ic:return 16;case jc:return 536870912;default:return 16}default:return 16}}var kd=null,ld=null,md=null;function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}
  function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return !0}function qd(){return !1}
  function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}A$1(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
  (a.returnValue=!1),this.isDefaultPrevented=pd);},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd);},persist:function(){},isPersistent:pd});return b}
  var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=A$1({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=A$1({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
  a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return "movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=A$1({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=A$1({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=A$1({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=A$1({},sd,{clipboardData:function(a){return "clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=A$1({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
  Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
  119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
  var Qd=A$1({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return "keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return "keypress"===a.type?od(a):0},keyCode:function(a){return "keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return "keypress"===
  a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=A$1({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=A$1({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=A$1({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=A$1({},Ad,{deltaX:function(a){return "deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
  deltaY:function(a){return "deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=ia&&"CompositionEvent"in window,be=null;ia&&"documentMode"in document&&(be=document.documentMode);var ce=ia&&"TextEvent"in window&&!be,de=ia&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
  function ge(a,b){switch(a){case "keyup":return -1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return !0;default:return !1}}function he(a){a=a.detail;return "object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
  function ke(a,b){if(ie)return "compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
  var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return "input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}));}var pe=null,qe=null;function re(a){se(a,0);}function te(a){var b=ue(a);if(Wa(b))return a}
  function ve(a,b){if("change"===a)return b}var we=!1;if(ia){var xe;if(ia){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput;}xe=ye;}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode);}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null);}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));Jb(re,b);}}
  function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae();}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge;
  function Ie(a,b){if(He(a,b))return !0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return !1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return !1;for(d=0;d<c.length;d++){var e=c[d];if(!ja.call(b,e)||!He(a[e],b[e]))return !1}return !0}function Je(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
  function Ke(a,b){var c=Je(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return {node:c,offset:b-a};a=d;}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode;}c=void 0;}c=Je(c);}}function Le(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Le(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
  function Me(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href;}catch(d){c=!1;}if(c)a=b.contentWindow;else break;b=Xa(a.document);}return b}function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
  function Oe(a){var b=Me(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Le(c.ownerDocument.documentElement,c)){if(null!==d&&Ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ke(c,f);var g=Ke(c,
  d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)));}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top;}}
  var Pe=ia&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
  function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Ne(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Ie(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)));}
  function Ve(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var We={animationend:Ve("Animation","AnimationEnd"),animationiteration:Ve("Animation","AnimationIteration"),animationstart:Ve("Animation","AnimationStart"),transitionend:Ve("Transition","TransitionEnd")},Xe={},Ye={};
  ia&&(Ye=document.createElement("div").style,"AnimationEvent"in window||(delete We.animationend.animation,delete We.animationiteration.animation,delete We.animationstart.animation),"TransitionEvent"in window||delete We.transitionend.transition);function Ze(a){if(Xe[a])return Xe[a];if(!We[a])return a;var b=We[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Ye)return Xe[a]=b[c];return a}var $e=Ze("animationend"),af=Ze("animationiteration"),bf=Ze("animationstart"),cf=Ze("transitionend"),df=new Map,ef="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function ff(a,b){df.set(a,b);fa(b,[a]);}for(var gf=0;gf<ef.length;gf++){var hf=ef[gf],jf=hf.toLowerCase(),kf=hf[0].toUpperCase()+hf.slice(1);ff(jf,"on"+kf);}ff($e,"onAnimationEnd");ff(af,"onAnimationIteration");ff(bf,"onAnimationStart");ff("dblclick","onDoubleClick");ff("focusin","onFocus");ff("focusout","onBlur");ff(cf,"onTransitionEnd");ha("onMouseEnter",["mouseout","mouseover"]);ha("onMouseLeave",["mouseout","mouseover"]);ha("onPointerEnter",["pointerout","pointerover"]);
  ha("onPointerLeave",["pointerout","pointerover"]);fa("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));fa("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));fa("onBeforeInput",["compositionend","keypress","textInput","paste"]);fa("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));fa("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));
  fa("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var lf="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mf=new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
  function nf(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Ub(d,b,void 0,a);a.currentTarget=null;}
  function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k;}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k;}}}if(Qb)throw a=Rb,Qb=!1,Rb=null,a;}
  function D(a,b){var c=b[of];void 0===c&&(c=b[of]=new Set);var d=a+"__bubble";c.has(d)||(pf(b,a,2,!1),c.add(d));}function qf(a,b,c){var d=0;b&&(d|=4);pf(c,a,d,b);}var rf="_reactListening"+Math.random().toString(36).slice(2);function sf(a){if(!a[rf]){a[rf]=!0;da.forEach(function(b){"selectionchange"!==b&&(mf.has(b)||qf(b,!1,a),qf(b,!0,a));});var b=9===a.nodeType?a:a.ownerDocument;null===b||b[rf]||(b[rf]=!0,qf("selectionchange",!1,b));}}
  function pf(a,b,c,d){switch(jd(b)){case 1:var e=ed;break;case 4:e=gd;break;default:e=fd;}c=e.bind(null,b,c,a);e=void 0;!Lb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1);}
  function hd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return;}for(;null!==h;){g=Wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode;}}d=d.return;}Jb(function(){var d=f,e=xb(c),g=[];
  a:{var h=df.get(a);if(void 0!==h){var k=td,n=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":n="focus";k=Fd;break;case "focusout":n="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
  Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case $e:case af:case bf:k=Hd;break;case cf:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td;}var t=0!==(b&4),J=!t&&"scroll"===a,x=t?null!==h?h+"Capture":null:h;t=[];for(var w=d,u;null!==
  w;){u=w;var F=u.stateNode;5===u.tag&&null!==F&&(u=F,null!==x&&(F=Kb(w,x),null!=F&&t.push(tf(w,F,u))));if(J)break;w=w.return;}0<t.length&&(h=new k(h,n,null,c,e),g.push({event:h,listeners:t}));}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&c!==wb&&(n=c.relatedTarget||c.fromElement)&&(Wc(n)||n[uf]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(n=c.relatedTarget||c.toElement,k=d,n=n?Wc(n):null,null!==
  n&&(J=Vb(n),n!==J||5!==n.tag&&6!==n.tag))n=null;}else k=null,n=d;if(k!==n){t=Bd;F="onMouseLeave";x="onMouseEnter";w="mouse";if("pointerout"===a||"pointerover"===a)t=Td,F="onPointerLeave",x="onPointerEnter",w="pointer";J=null==k?h:ue(k);u=null==n?h:ue(n);h=new t(F,w+"leave",k,c,e);h.target=J;h.relatedTarget=u;F=null;Wc(e)===d&&(t=new t(x,w+"enter",n,c,e),t.target=u,t.relatedTarget=J,F=t);J=F;if(k&&n)b:{t=k;x=n;w=0;for(u=t;u;u=vf(u))w++;u=0;for(F=x;F;F=vf(F))u++;for(;0<w-u;)t=vf(t),w--;for(;0<u-w;)x=
  vf(x),u--;for(;w--;){if(t===x||null!==x&&t===x.alternate)break b;t=vf(t);x=vf(x);}t=null;}else t=null;null!==k&&wf(g,h,k,t,!1);null!==n&&null!==J&&wf(g,J,n,t,!0);}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var na=ve;else if(me(h))if(we)na=Fe;else {na=De;var xa=Ce;}else (k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(na=Ee);if(na&&(na=na(a,d))){ne(g,na,c,e);break a}xa&&xa(a,h,d);"focusout"===a&&(xa=h._wrapperState)&&
  xa.controlled&&"number"===h.type&&cb(h,"number",h.value);}xa=d?ue(d):window;switch(a){case "focusin":if(me(xa)||"true"===xa.contentEditable)Qe=xa,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e);}var $a;if(ae)b:{switch(a){case "compositionstart":var ba="onCompositionStart";break b;case "compositionend":ba="onCompositionEnd";
  break b;case "compositionupdate":ba="onCompositionUpdate";break b}ba=void 0;}else ie?ge(a,c)&&(ba="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(ba="onCompositionStart");ba&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==ba?"onCompositionEnd"===ba&&ie&&($a=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),xa=oe(d,ba),0<xa.length&&(ba=new Ld(ba,a,null,c,e),g.push({event:ba,listeners:xa}),$a?ba.data=$a:($a=he(c),null!==$a&&(ba.data=$a))));if($a=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),
  0<d.length&&(e=new Ld("onBeforeInput","beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=$a);}se(g,b);});}function tf(a,b,c){return {instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Kb(a,c),null!=f&&d.unshift(tf(a,f,e)),f=Kb(a,b),null!=f&&d.push(tf(a,f,e)));a=a.return;}return d}function vf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
  function wf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Kb(c,f),null!=k&&g.unshift(tf(c,k,h))):e||(k=Kb(c,f),null!=k&&g.push(tf(c,k,h))));c=c.return;}0!==g.length&&a.push({event:b,listeners:g});}var xf=/\r\n?/g,yf=/\u0000|\uFFFD/g;function zf(a){return ("string"===typeof a?a:""+a).replace(xf,"\n").replace(yf,"")}function Af(a,b,c){b=zf(b);if(zf(a)!==b&&c)throw Error(p$3(425));}function Bf(){}
  var Cf=null,Df=null;function Ef(a,b){return "textarea"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
  var Ff="function"===typeof setTimeout?setTimeout:void 0,Gf="function"===typeof clearTimeout?clearTimeout:void 0,Hf="function"===typeof Promise?Promise:void 0,Jf="function"===typeof queueMicrotask?queueMicrotask:"undefined"!==typeof Hf?function(a){return Hf.resolve(null).then(a).catch(If)}:Ff;function If(a){setTimeout(function(){throw a;});}
  function Kf(a,b){var c=b,d=0;do{var e=c.nextSibling;a.removeChild(c);if(e&&8===e.nodeType)if(c=e.data,"/$"===c){if(0===d){a.removeChild(e);bd(b);return}d--;}else "$"!==c&&"$?"!==c&&"$!"!==c||d++;c=e;}while(c);bd(b);}function Lf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break;if(8===b){b=a.data;if("$"===b||"$!"===b||"$?"===b)break;if("/$"===b)return null}}return a}
  function Mf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--;}else "/$"===c&&b++;}a=a.previousSibling;}return null}var Nf=Math.random().toString(36).slice(2),Of="__reactFiber$"+Nf,Pf="__reactProps$"+Nf,uf="__reactContainer$"+Nf,of="__reactEvents$"+Nf,Qf="__reactListeners$"+Nf,Rf="__reactHandles$"+Nf;
  function Wc(a){var b=a[Of];if(b)return b;for(var c=a.parentNode;c;){if(b=c[uf]||c[Of]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Mf(a);null!==a;){if(c=a[Of])return c;a=Mf(a);}return b}a=c;c=a.parentNode;}return null}function Cb(a){a=a[Of]||a[uf];return !a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(p$3(33));}function Db(a){return a[Pf]||null}var Sf=[],Tf=-1;function Uf(a){return {current:a}}
  function E(a){0>Tf||(a.current=Sf[Tf],Sf[Tf]=null,Tf--);}function G(a,b){Tf++;Sf[Tf]=a.current;a.current=b;}var Vf={},H=Uf(Vf),Wf=Uf(!1),Xf=Vf;function Yf(a,b){var c=a.type.contextTypes;if(!c)return Vf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}
  function Zf(a){a=a.childContextTypes;return null!==a&&void 0!==a}function $f(){E(Wf);E(H);}function ag(a,b,c){if(H.current!==Vf)throw Error(p$3(168));G(H,b);G(Wf,c);}function bg(a,b,c){var d=a.stateNode;b=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in b))throw Error(p$3(108,Ra(a)||"Unknown",e));return A$1({},c,d)}
  function cg(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Vf;Xf=H.current;G(H,a);G(Wf,Wf.current);return !0}function dg(a,b,c){var d=a.stateNode;if(!d)throw Error(p$3(169));c?(a=bg(a,b,Xf),d.__reactInternalMemoizedMergedChildContext=a,E(Wf),E(H),G(H,a)):E(Wf);G(Wf,c);}var eg=null,fg=!1,gg=!1;function hg(a){null===eg?eg=[a]:eg.push(a);}function ig(a){fg=!0;hg(a);}
  function jg(){if(!gg&&null!==eg){gg=!0;var a=0,b=C;try{var c=eg;for(C=1;a<c.length;a++){var d=c[a];do d=d(!0);while(null!==d)}eg=null;fg=!1;}catch(e){throw null!==eg&&(eg=eg.slice(a+1)),ac(fc,jg),e;}finally{C=b,gg=!1;}}return null}var kg=[],lg=0,mg=null,ng=0,og=[],pg=0,qg=null,rg=1,sg="";function tg(a,b){kg[lg++]=ng;kg[lg++]=mg;mg=a;ng=b;}
  function ug(a,b,c){og[pg++]=rg;og[pg++]=sg;og[pg++]=qg;qg=a;var d=rg;a=sg;var e=32-oc(d)-1;d&=~(1<<e);c+=1;var f=32-oc(b)+e;if(30<f){var g=e-e%5;f=(d&(1<<g)-1).toString(32);d>>=g;e-=g;rg=1<<32-oc(b)+e|c<<e|d;sg=f+a;}else rg=1<<f|c<<e|d,sg=a;}function vg(a){null!==a.return&&(tg(a,1),ug(a,1,0));}function wg(a){for(;a===mg;)mg=kg[--lg],kg[lg]=null,ng=kg[--lg],kg[lg]=null;for(;a===qg;)qg=og[--pg],og[pg]=null,sg=og[--pg],og[pg]=null,rg=og[--pg],og[pg]=null;}var xg=null,yg=null,I=!1,zg=null;
  function Ag(a,b){var c=Bg(5,null,null,0);c.elementType="DELETED";c.stateNode=b;c.return=a;b=a.deletions;null===b?(a.deletions=[c],a.flags|=16):b.push(c);}
  function Cg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,xg=a,yg=Lf(b.firstChild),!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,xg=a,yg=null,!0):!1;case 13:return b=8!==b.nodeType?null:b,null!==b?(c=null!==qg?{id:rg,overflow:sg}:null,a.memoizedState={dehydrated:b,treeContext:c,retryLane:1073741824},c=Bg(18,null,null,0),c.stateNode=b,c.return=a,a.child=c,xg=a,yg=
  null,!0):!1;default:return !1}}function Dg(a){return 0!==(a.mode&1)&&0===(a.flags&128)}function Eg(a){if(I){var b=yg;if(b){var c=b;if(!Cg(a,b)){if(Dg(a))throw Error(p$3(418));b=Lf(c.nextSibling);var d=xg;b&&Cg(a,b)?Ag(d,c):(a.flags=a.flags&-4097|2,I=!1,xg=a);}}else {if(Dg(a))throw Error(p$3(418));a.flags=a.flags&-4097|2;I=!1;xg=a;}}}function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;xg=a;}
  function Gg(a){if(a!==xg)return !1;if(!I)return Fg(a),I=!0,!1;var b;(b=3!==a.tag)&&!(b=5!==a.tag)&&(b=a.type,b="head"!==b&&"body"!==b&&!Ef(a.type,a.memoizedProps));if(b&&(b=yg)){if(Dg(a))throw Hg(),Error(p$3(418));for(;b;)Ag(a,b),b=Lf(b.nextSibling);}Fg(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(p$3(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){yg=Lf(a.nextSibling);break a}b--;}else "$"!==c&&"$!"!==c&&"$?"!==c||b++;}a=a.nextSibling;}yg=
  null;}}else yg=xg?Lf(a.stateNode.nextSibling):null;return !0}function Hg(){for(var a=yg;a;)a=Lf(a.nextSibling);}function Ig(){yg=xg=null;I=!1;}function Jg(a){null===zg?zg=[a]:zg.push(a);}var Kg=ua.ReactCurrentBatchConfig;function Lg(a,b){if(a&&a.defaultProps){b=A$1({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var Mg=Uf(null),Ng=null,Og=null,Pg=null;function Qg(){Pg=Og=Ng=null;}function Rg(a){var b=Mg.current;E(Mg);a._currentValue=b;}
  function Sg(a,b,c){for(;null!==a;){var d=a.alternate;(a.childLanes&b)!==b?(a.childLanes|=b,null!==d&&(d.childLanes|=b)):null!==d&&(d.childLanes&b)!==b&&(d.childLanes|=b);if(a===c)break;a=a.return;}}function Tg(a,b){Ng=a;Pg=Og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(Ug=!0),a.firstContext=null);}
  function Vg(a){var b=a._currentValue;if(Pg!==a)if(a={context:a,memoizedValue:b,next:null},null===Og){if(null===Ng)throw Error(p$3(308));Og=a;Ng.dependencies={lanes:0,firstContext:a};}else Og=Og.next=a;return b}var Wg=null;function Xg(a){null===Wg?Wg=[a]:Wg.push(a);}function Yg(a,b,c,d){var e=b.interleaved;null===e?(c.next=c,Xg(b)):(c.next=e.next,e.next=c);b.interleaved=c;return Zg(a,d)}
  function Zg(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}var $g=!1;function ah(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null};}
  function bh(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects});}function ch(a,b){return {eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}
  function dh(a,b,c){var d=a.updateQueue;if(null===d)return null;d=d.shared;if(0!==(K&2)){var e=d.pending;null===e?b.next=b:(b.next=e.next,e.next=b);d.pending=b;return Zg(a,c)}e=d.interleaved;null===e?(b.next=b,Xg(d)):(b.next=e.next,e.next=b);d.interleaved=b;return Zg(a,c)}function eh(a,b,c){b=b.updateQueue;if(null!==b&&(b=b.shared,0!==(c&4194240))){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c);}}
  function fh(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next;}while(null!==c);null===f?e=f=b:f=f.next=b;}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
  b;c.lastBaseUpdate=b;}
  function gh(a,b,c,d){var e=a.updateQueue;$g=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var m=a.alternate;null!==m&&(m=m.updateQueue,h=m.lastBaseUpdate,h!==g&&(null===h?m.firstBaseUpdate=l:h.next=l,m.lastBaseUpdate=k));}if(null!==f){var q=e.baseState;g=0;m=l=k=null;h=f;do{var r=h.lane,y=h.eventTime;if((d&r)===r){null!==m&&(m=m.next={eventTime:y,lane:0,tag:h.tag,payload:h.payload,callback:h.callback,
  next:null});a:{var n=a,t=h;r=b;y=c;switch(t.tag){case 1:n=t.payload;if("function"===typeof n){q=n.call(y,q,r);break a}q=n;break a;case 3:n.flags=n.flags&-65537|128;case 0:n=t.payload;r="function"===typeof n?n.call(y,q,r):n;if(null===r||void 0===r)break a;q=A$1({},q,r);break a;case 2:$g=!0;}}null!==h.callback&&0!==h.lane&&(a.flags|=64,r=e.effects,null===r?e.effects=[h]:r.push(h));}else y={eventTime:y,lane:r,tag:h.tag,payload:h.payload,callback:h.callback,next:null},null===m?(l=m=y,k=q):m=m.next=y,g|=r;
  h=h.next;if(null===h)if(h=e.shared.pending,null===h)break;else r=h,h=r.next,r.next=null,e.lastBaseUpdate=r,e.shared.pending=null;}while(1);null===m&&(k=q);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=m;b=e.shared.interleaved;if(null!==b){e=b;do g|=e.lane,e=e.next;while(e!==b)}else null===f&&(e.shared.lanes=0);hh|=g;a.lanes=g;a.memoizedState=q;}}
  function ih(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(p$3(191,e));e.call(d);}}}var jh=(new react.Component).refs;function kh(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:A$1({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c);}
  var nh={isMounted:function(a){return (a=a._reactInternals)?Vb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=L(),e=lh(a),f=ch(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=dh(a,f,e);null!==b&&(mh(b,a,e,d),eh(b,a,e));},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=L(),e=lh(a),f=ch(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=dh(a,f,e);null!==b&&(mh(b,a,e,d),eh(b,a,e));},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=L(),d=
  lh(a),e=ch(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=b);b=dh(a,e,d);null!==b&&(mh(b,a,d,c),eh(b,a,d));}};function oh(a,b,c,d,e,f,g){a=a.stateNode;return "function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Ie(c,d)||!Ie(e,f):!0}
  function ph(a,b,c){var d=!1,e=Vf;var f=b.contextType;"object"===typeof f&&null!==f?f=Vg(f):(e=Zf(b)?Xf:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Yf(a,e):Vf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=nh;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
  function qh(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&nh.enqueueReplaceState(b,b.state,null);}
  function rh(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jh;ah(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=Vg(f):(f=Zf(b)?Xf:H.current,e.context=Yf(a,f));e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(kh(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,
  "function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&nh.enqueueReplaceState(e,e.state,null),gh(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4194308);}
  function sh(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(p$3(309));var d=c.stateNode;}if(!d)throw Error(p$3(147,a));var e=d,f=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===f)return b.ref;b=function(a){var b=e.refs;b===jh&&(b=e.refs={});null===a?delete b[f]:b[f]=a;};b._stringRef=f;return b}if("string"!==typeof a)throw Error(p$3(284));if(!c._owner)throw Error(p$3(290,a));}return a}
  function th(a,b){a=Object.prototype.toString.call(b);throw Error(p$3(31,"[object Object]"===a?"object with keys {"+Object.keys(b).join(", ")+"}":a));}function uh(a){var b=a._init;return b(a._payload)}
  function vh$1(a){function b(b,c){if(a){var d=b.deletions;null===d?(b.deletions=[c],b.flags|=16):d.push(c);}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=wh(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return b.flags|=1048576,c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags|=2,c):d;b.flags|=2;return c}function g(b){a&&
  null===b.alternate&&(b.flags|=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=xh(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){var f=c.type;if(f===ya)return m(a,b,c.props.children,d,c.key);if(null!==b&&(b.elementType===f||"object"===typeof f&&null!==f&&f.$$typeof===Ha&&uh(f)===b.type))return d=e(b,c.props),d.ref=sh(a,b,c),d.return=a,d;d=yh(c.type,c.key,c.props,null,a.mode,d);d.ref=sh(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||
  b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=zh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ah(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function q(a,b,c){if("string"===typeof b&&""!==b||"number"===typeof b)return b=xh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case va:return c=yh(b.type,b.key,b.props,null,a.mode,c),
  c.ref=sh(a,null,b),c.return=a,c;case wa:return b=zh(b,a.mode,c),b.return=a,b;case Ha:var d=b._init;return q(a,d(b._payload),c)}if(eb(b)||Ka(b))return b=Ah(b,a.mode,c,null),b.return=a,b;th(a,b);}return null}function r(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c&&""!==c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case va:return c.key===e?k(a,b,c,d):null;case wa:return c.key===e?l(a,b,c,d):null;case Ha:return e=c._init,r(a,
  b,e(c._payload),d)}if(eb(c)||Ka(c))return null!==e?null:m(a,b,c,d,null);th(a,c);}return null}function y(a,b,c,d,e){if("string"===typeof d&&""!==d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case va:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e);case wa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e);case Ha:var f=d._init;return y(a,b,c,f(d._payload),e)}if(eb(d)||Ka(d))return a=a.get(c)||null,m(b,a,d,e,null);th(b,d);}return null}
  function n(e,g,h,k){for(var l=null,m=null,u=g,w=g=0,x=null;null!==u&&w<h.length;w++){u.index>w?(x=u,u=null):x=u.sibling;var n=r(e,u,h[w],k);if(null===n){null===u&&(u=x);break}a&&u&&null===n.alternate&&b(e,u);g=f(n,g,w);null===m?l=n:m.sibling=n;m=n;u=x;}if(w===h.length)return c(e,u),I&&tg(e,w),l;if(null===u){for(;w<h.length;w++)u=q(e,h[w],k),null!==u&&(g=f(u,g,w),null===m?l=u:m.sibling=u,m=u);I&&tg(e,w);return l}for(u=d(e,u);w<h.length;w++)x=y(u,e,w,h[w],k),null!==x&&(a&&null!==x.alternate&&u.delete(null===
  x.key?w:x.key),g=f(x,g,w),null===m?l=x:m.sibling=x,m=x);a&&u.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function t(e,g,h,k){var l=Ka(h);if("function"!==typeof l)throw Error(p$3(150));h=l.call(h);if(null==h)throw Error(p$3(151));for(var u=l=null,m=g,w=g=0,x=null,n=h.next();null!==m&&!n.done;w++,n=h.next()){m.index>w?(x=m,m=null):x=m.sibling;var t=r(e,m,n.value,k);if(null===t){null===m&&(m=x);break}a&&m&&null===t.alternate&&b(e,m);g=f(t,g,w);null===u?l=t:u.sibling=t;u=t;m=x;}if(n.done)return c(e,
  m),I&&tg(e,w),l;if(null===m){for(;!n.done;w++,n=h.next())n=q(e,n.value,k),null!==n&&(g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);I&&tg(e,w);return l}for(m=d(e,m);!n.done;w++,n=h.next())n=y(m,e,w,n.value,k),null!==n&&(a&&null!==n.alternate&&m.delete(null===n.key?w:n.key),g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);a&&m.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function J(a,d,f,h){"object"===typeof f&&null!==f&&f.type===ya&&null===f.key&&(f=f.props.children);if("object"===typeof f&&null!==f){switch(f.$$typeof){case va:a:{for(var k=
  f.key,l=d;null!==l;){if(l.key===k){k=f.type;if(k===ya){if(7===l.tag){c(a,l.sibling);d=e(l,f.props.children);d.return=a;a=d;break a}}else if(l.elementType===k||"object"===typeof k&&null!==k&&k.$$typeof===Ha&&uh(k)===l.type){c(a,l.sibling);d=e(l,f.props);d.ref=sh(a,l,f);d.return=a;a=d;break a}c(a,l);break}else b(a,l);l=l.sibling;}f.type===ya?(d=Ah(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=yh(f.type,f.key,f.props,null,a.mode,h),h.ref=sh(a,d,f),h.return=a,a=h);}return g(a);case wa:a:{for(l=f.key;null!==
  d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else {c(a,d);break}else b(a,d);d=d.sibling;}d=zh(f,a.mode,h);d.return=a;a=d;}return g(a);case Ha:return l=f._init,J(a,d,l(f._payload),h)}if(eb(f))return n(a,d,f,h);if(Ka(f))return t(a,d,f,h);th(a,f);}return "string"===typeof f&&""!==f||"number"===typeof f?(f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):
  (c(a,d),d=xh(f,a.mode,h),d.return=a,a=d),g(a)):c(a,d)}return J}var Bh=vh$1(!0),Ch=vh$1(!1),Dh={},Eh=Uf(Dh),Fh=Uf(Dh),Gh=Uf(Dh);function Hh(a){if(a===Dh)throw Error(p$3(174));return a}function Ih(a,b){G(Gh,b);G(Fh,a);G(Eh,Dh);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:lb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=lb(b,a);}E(Eh);G(Eh,b);}function Jh(){E(Eh);E(Fh);E(Gh);}
  function Kh(a){Hh(Gh.current);var b=Hh(Eh.current);var c=lb(b,a.type);b!==c&&(G(Fh,a),G(Eh,c));}function Lh(a){Fh.current===a&&(E(Eh),E(Fh));}var M=Uf(0);
  function Mh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&128))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return;}b.sibling.return=b.return;b=b.sibling;}return null}var Nh=[];
  function Oh(){for(var a=0;a<Nh.length;a++)Nh[a]._workInProgressVersionPrimary=null;Nh.length=0;}var Ph=ua.ReactCurrentDispatcher,Qh=ua.ReactCurrentBatchConfig,Rh=0,N=null,O=null,P=null,Sh=!1,Th=!1,Uh=0,Vh=0;function Q(){throw Error(p$3(321));}function Wh(a,b){if(null===b)return !1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return !1;return !0}
  function Xh(a,b,c,d,e,f){Rh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;Ph.current=null===a||null===a.memoizedState?Yh:Zh;a=c(d,e);if(Th){f=0;do{Th=!1;Uh=0;if(25<=f)throw Error(p$3(301));f+=1;P=O=null;b.updateQueue=null;Ph.current=$h;a=c(d,e);}while(Th)}Ph.current=ai;b=null!==O&&null!==O.next;Rh=0;P=O=N=null;Sh=!1;if(b)throw Error(p$3(300));return a}function bi(){var a=0!==Uh;Uh=0;return a}
  function ci(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function di(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null;}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else {if(null===a)throw Error(p$3(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a;}return P}
  function ei(a,b){return "function"===typeof b?b(a):b}
  function fi(a){var b=di(),c=b.queue;if(null===c)throw Error(p$3(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g;}d.baseQueue=e=f;c.pending=null;}if(null!==e){f=e.next;d=d.baseState;var h=g=null,k=null,l=f;do{var m=l.lane;if((Rh&m)===m)null!==k&&(k=k.next={lane:0,action:l.action,hasEagerState:l.hasEagerState,eagerState:l.eagerState,next:null}),d=l.hasEagerState?l.eagerState:a(d,l.action);else {var q={lane:m,action:l.action,hasEagerState:l.hasEagerState,
  eagerState:l.eagerState,next:null};null===k?(h=k=q,g=d):k=k.next=q;N.lanes|=m;hh|=m;}l=l.next;}while(null!==l&&l!==f);null===k?g=d:k.next=h;He(d,b.memoizedState)||(Ug=!0);b.memoizedState=d;b.baseState=g;b.baseQueue=k;c.lastRenderedState=d;}a=c.interleaved;if(null!==a){e=a;do f=e.lane,N.lanes|=f,hh|=f,e=e.next;while(e!==a)}else null===e&&(c.lanes=0);return [b.memoizedState,c.dispatch]}
  function gi(a){var b=di(),c=b.queue;if(null===c)throw Error(p$3(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(Ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f;}return [f,d]}function hi(){}
  function ii(a,b){var c=N,d=di(),e=b(),f=!He(d.memoizedState,e);f&&(d.memoizedState=e,Ug=!0);d=d.queue;ji(ki.bind(null,c,d,a),[a]);if(d.getSnapshot!==b||f||null!==P&&P.memoizedState.tag&1){c.flags|=2048;li(9,mi.bind(null,c,d,e,b),void 0,null);if(null===R)throw Error(p$3(349));0!==(Rh&30)||ni(c,b,e);}return e}function ni(a,b,c){a.flags|=16384;a={getSnapshot:b,value:c};b=N.updateQueue;null===b?(b={lastEffect:null,stores:null},N.updateQueue=b,b.stores=[a]):(c=b.stores,null===c?b.stores=[a]:c.push(a));}
  function mi(a,b,c,d){b.value=c;b.getSnapshot=d;oi(b)&&pi(a);}function ki(a,b,c){return c(function(){oi(b)&&pi(a);})}function oi(a){var b=a.getSnapshot;a=a.value;try{var c=b();return !He(a,c)}catch(d){return !0}}function pi(a){var b=Zg(a,1);null!==b&&mh(b,a,1,-1);}
  function qi(a){var b=ci();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:ei,lastRenderedState:a};b.queue=a;a=a.dispatch=ri.bind(null,N,a);return [b.memoizedState,a]}
  function li(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null,stores:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function si(){return di().memoizedState}function ti(a,b,c,d){var e=ci();N.flags|=a;e.memoizedState=li(1|b,c,void 0,void 0===d?null:d);}
  function ui(a,b,c,d){var e=di();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Wh(d,g.deps)){e.memoizedState=li(b,c,f,d);return}}N.flags|=a;e.memoizedState=li(1|b,c,f,d);}function vi(a,b){return ti(8390656,8,a,b)}function ji(a,b){return ui(2048,8,a,b)}function wi(a,b){return ui(4,2,a,b)}function xi(a,b){return ui(4,4,a,b)}
  function yi(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null);};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null;}}function zi(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ui(4,4,yi.bind(null,b,a),c)}function Ai(){}function Bi(a,b){var c=di();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Wh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
  function Ci(a,b){var c=di();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Wh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Di(a,b,c){if(0===(Rh&21))return a.baseState&&(a.baseState=!1,Ug=!0),a.memoizedState=c;He(c,b)||(c=yc(),N.lanes|=c,hh|=c,a.baseState=!0);return b}function Ei(a,b){var c=C;C=0!==c&&4>c?c:4;a(!0);var d=Qh.transition;Qh.transition={};try{a(!1),b();}finally{C=c,Qh.transition=d;}}function Fi(){return di().memoizedState}
  function Gi(a,b,c){var d=lh(a);c={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(Hi(a))Ii(b,c);else if(c=Yg(a,b,c,d),null!==c){var e=L();mh(c,a,d,e);Ji(c,b,d);}}
  function ri(a,b,c){var d=lh(a),e={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(Hi(a))Ii(b,e);else {var f=a.alternate;if(0===a.lanes&&(null===f||0===f.lanes)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.hasEagerState=!0;e.eagerState=h;if(He(h,g)){var k=b.interleaved;null===k?(e.next=e,Xg(b)):(e.next=k.next,k.next=e);b.interleaved=e;return}}catch(l){}finally{}c=Yg(a,b,e,d);null!==c&&(e=L(),mh(c,a,d,e),Ji(c,b,d));}}
  function Hi(a){var b=a.alternate;return a===N||null!==b&&b===N}function Ii(a,b){Th=Sh=!0;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b;}function Ji(a,b,c){if(0!==(c&4194240)){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c);}}
  var ai={readContext:Vg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useInsertionEffect:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useDeferredValue:Q,useTransition:Q,useMutableSource:Q,useSyncExternalStore:Q,useId:Q,unstable_isNewReconciler:!1},Yh={readContext:Vg,useCallback:function(a,b){ci().memoizedState=[a,void 0===b?null:b];return a},useContext:Vg,useEffect:vi,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ti(4194308,
  4,yi.bind(null,b,a),c)},useLayoutEffect:function(a,b){return ti(4194308,4,a,b)},useInsertionEffect:function(a,b){return ti(4,2,a,b)},useMemo:function(a,b){var c=ci();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=ci();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};d.queue=a;a=a.dispatch=Gi.bind(null,N,a);return [d.memoizedState,a]},useRef:function(a){var b=
  ci();a={current:a};return b.memoizedState=a},useState:qi,useDebugValue:Ai,useDeferredValue:function(a){return ci().memoizedState=a},useTransition:function(){var a=qi(!1),b=a[0];a=Ei.bind(null,a[1]);ci().memoizedState=a;return [b,a]},useMutableSource:function(){},useSyncExternalStore:function(a,b,c){var d=N,e=ci();if(I){if(void 0===c)throw Error(p$3(407));c=c();}else {c=b();if(null===R)throw Error(p$3(349));0!==(Rh&30)||ni(d,b,c);}e.memoizedState=c;var f={value:c,getSnapshot:b};e.queue=f;vi(ki.bind(null,d,
  f,a),[a]);d.flags|=2048;li(9,mi.bind(null,d,f,c,b),void 0,null);return c},useId:function(){var a=ci(),b=R.identifierPrefix;if(I){var c=sg;var d=rg;c=(d&~(1<<32-oc(d)-1)).toString(32)+c;b=":"+b+"R"+c;c=Uh++;0<c&&(b+="H"+c.toString(32));b+=":";}else c=Vh++,b=":"+b+"r"+c.toString(32)+":";return a.memoizedState=b},unstable_isNewReconciler:!1},Zh={readContext:Vg,useCallback:Bi,useContext:Vg,useEffect:ji,useImperativeHandle:zi,useInsertionEffect:wi,useLayoutEffect:xi,useMemo:Ci,useReducer:fi,useRef:si,useState:function(){return fi(ei)},
  useDebugValue:Ai,useDeferredValue:function(a){var b=di();return Di(b,O.memoizedState,a)},useTransition:function(){var a=fi(ei)[0],b=di().memoizedState;return [a,b]},useMutableSource:hi,useSyncExternalStore:ii,useId:Fi,unstable_isNewReconciler:!1},$h={readContext:Vg,useCallback:Bi,useContext:Vg,useEffect:ji,useImperativeHandle:zi,useInsertionEffect:wi,useLayoutEffect:xi,useMemo:Ci,useReducer:gi,useRef:si,useState:function(){return gi(ei)},useDebugValue:Ai,useDeferredValue:function(a){var b=di();return null===
  O?b.memoizedState=a:Di(b,O.memoizedState,a)},useTransition:function(){var a=gi(ei)[0],b=di().memoizedState;return [a,b]},useMutableSource:hi,useSyncExternalStore:ii,useId:Fi,unstable_isNewReconciler:!1};function Ki(a,b){try{var c="",d=b;do c+=Pa(d),d=d.return;while(d);var e=c;}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack;}return {value:a,source:b,stack:e,digest:null}}function Li(a,b,c){return {value:a,source:null,stack:null!=c?c:null,digest:null!=b?b:null}}
  function Mi(a,b){try{console.error(b.value);}catch(c){setTimeout(function(){throw c;});}}var Ni="function"===typeof WeakMap?WeakMap:Map;function Oi(a,b,c){c=ch(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Pi||(Pi=!0,Qi=d);Mi(a,b);};return c}
  function Ri(a,b,c){c=ch(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)};c.callback=function(){Mi(a,b);};}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){Mi(a,b);"function"!==typeof d&&(null===Si?Si=new Set([this]):Si.add(this));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""});});return c}
  function Ti(a,b,c){var d=a.pingCache;if(null===d){d=a.pingCache=new Ni;var e=new Set;d.set(b,e);}else e=d.get(b),void 0===e&&(e=new Set,d.set(b,e));e.has(c)||(e.add(c),a=Ui.bind(null,a,b,c),b.then(a,a));}function Vi(a){do{var b;if(b=13===a.tag)b=a.memoizedState,b=null!==b?null!==b.dehydrated?!0:!1:!0;if(b)return a;a=a.return;}while(null!==a);return null}
  function Wi(a,b,c,d,e){if(0===(a.mode&1))return a===b?a.flags|=65536:(a.flags|=128,c.flags|=131072,c.flags&=-52805,1===c.tag&&(null===c.alternate?c.tag=17:(b=ch(-1,1),b.tag=2,dh(c,b,1))),c.lanes|=1),a;a.flags|=65536;a.lanes=e;return a}var Xi=ua.ReactCurrentOwner,Ug=!1;function Yi(a,b,c,d){b.child=null===a?Ch(b,null,c,d):Bh(b,a.child,c,d);}
  function Zi(a,b,c,d,e){c=c.render;var f=b.ref;Tg(b,e);d=Xh(a,b,c,d,f,e);c=bi();if(null!==a&&!Ug)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,$i(a,b,e);I&&c&&vg(b);b.flags|=1;Yi(a,b,d,e);return b.child}
  function aj(a,b,c,d,e){if(null===a){var f=c.type;if("function"===typeof f&&!bj(f)&&void 0===f.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=f,cj(a,b,f,d,e);a=yh(c.type,null,d,b,b.mode,e);a.ref=b.ref;a.return=b;return b.child=a}f=a.child;if(0===(a.lanes&e)){var g=f.memoizedProps;c=c.compare;c=null!==c?c:Ie;if(c(g,d)&&a.ref===b.ref)return $i(a,b,e)}b.flags|=1;a=wh(f,d);a.ref=b.ref;a.return=b;return b.child=a}
  function cj(a,b,c,d,e){if(null!==a){var f=a.memoizedProps;if(Ie(f,d)&&a.ref===b.ref)if(Ug=!1,b.pendingProps=d=f,0!==(a.lanes&e))0!==(a.flags&131072)&&(Ug=!0);else return b.lanes=a.lanes,$i(a,b,e)}return dj(a,b,c,d,e)}
  function ej(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode)if(0===(b.mode&1))b.memoizedState={baseLanes:0,cachePool:null,transitions:null},G(fj,gj),gj|=c;else {if(0===(c&1073741824))return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a,cachePool:null,transitions:null},b.updateQueue=null,G(fj,gj),gj|=a,null;b.memoizedState={baseLanes:0,cachePool:null,transitions:null};d=null!==f?f.baseLanes:c;G(fj,gj);gj|=d;}else null!==
  f?(d=f.baseLanes|c,b.memoizedState=null):d=c,G(fj,gj),gj|=d;Yi(a,b,e,c);return b.child}function hj(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=512,b.flags|=2097152;}function dj(a,b,c,d,e){var f=Zf(c)?Xf:H.current;f=Yf(b,f);Tg(b,e);c=Xh(a,b,c,d,f,e);d=bi();if(null!==a&&!Ug)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,$i(a,b,e);I&&d&&vg(b);b.flags|=1;Yi(a,b,c,e);return b.child}
  function ij(a,b,c,d,e){if(Zf(c)){var f=!0;cg(b);}else f=!1;Tg(b,e);if(null===b.stateNode)jj(a,b),ph(b,c,d),rh(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Vg(l):(l=Zf(c)?Xf:H.current,l=Yf(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||
  (h!==d||k!==l)&&qh(b,g,d,l);$g=!1;var r=b.memoizedState;g.state=r;gh(b,d,g,e);k=b.memoizedState;h!==d||r!==k||Wf.current||$g?("function"===typeof m&&(kh(b,c,m,d),k=b.memoizedState),(h=$g||oh(b,c,h,d,r,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.flags|=4194308)):
  ("function"===typeof g.componentDidMount&&(b.flags|=4194308),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4194308),d=!1);}else {g=b.stateNode;bh(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:Lg(b.type,h);g.props=l;q=b.pendingProps;r=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=Vg(k):(k=Zf(c)?Xf:H.current,k=Yf(b,k));var y=c.getDerivedStateFromProps;(m="function"===typeof y||"function"===typeof g.getSnapshotBeforeUpdate)||
  "function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==q||r!==k)&&qh(b,g,d,k);$g=!1;r=b.memoizedState;g.state=r;gh(b,d,g,e);var n=b.memoizedState;h!==q||r!==n||Wf.current||$g?("function"===typeof y&&(kh(b,c,y,d),n=b.memoizedState),(l=$g||oh(b,c,l,d,r,n,k)||!1)?(m||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,n,k),"function"===typeof g.UNSAFE_componentWillUpdate&&
  g.UNSAFE_componentWillUpdate(d,n,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=1024)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),b.memoizedProps=d,b.memoizedState=n),g.props=d,g.state=n,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===
  a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),d=!1);}return kj(a,b,c,d,f,e)}
  function kj(a,b,c,d,e,f){hj(a,b);var g=0!==(b.flags&128);if(!d&&!g)return e&&dg(b,c,!1),$i(a,b,f);d=b.stateNode;Xi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Bh(b,a.child,null,f),b.child=Bh(b,null,h,f)):Yi(a,b,h,f);b.memoizedState=d.state;e&&dg(b,c,!0);return b.child}function lj(a){var b=a.stateNode;b.pendingContext?ag(a,b.pendingContext,b.pendingContext!==b.context):b.context&&ag(a,b.context,!1);Ih(a,b.containerInfo);}
  function mj(a,b,c,d,e){Ig();Jg(e);b.flags|=256;Yi(a,b,c,d);return b.child}var nj={dehydrated:null,treeContext:null,retryLane:0};function oj(a){return {baseLanes:a,cachePool:null,transitions:null}}
  function pj(a,b,c){var d=b.pendingProps,e=M.current,f=!1,g=0!==(b.flags&128),h;(h=g)||(h=null!==a&&null===a.memoizedState?!1:0!==(e&2));if(h)f=!0,b.flags&=-129;else if(null===a||null!==a.memoizedState)e|=1;G(M,e&1);if(null===a){Eg(b);a=b.memoizedState;if(null!==a&&(a=a.dehydrated,null!==a))return 0===(b.mode&1)?b.lanes=1:"$!"===a.data?b.lanes=8:b.lanes=1073741824,null;g=d.children;a=d.fallback;return f?(d=b.mode,f=b.child,g={mode:"hidden",children:g},0===(d&1)&&null!==f?(f.childLanes=0,f.pendingProps=
  g):f=qj(g,d,0,null),a=Ah(a,d,c,null),f.return=b,a.return=b,f.sibling=a,b.child=f,b.child.memoizedState=oj(c),b.memoizedState=nj,a):rj(b,g)}e=a.memoizedState;if(null!==e&&(h=e.dehydrated,null!==h))return sj(a,b,g,d,h,e,c);if(f){f=d.fallback;g=b.mode;e=a.child;h=e.sibling;var k={mode:"hidden",children:d.children};0===(g&1)&&b.child!==e?(d=b.child,d.childLanes=0,d.pendingProps=k,b.deletions=null):(d=wh(e,k),d.subtreeFlags=e.subtreeFlags&14680064);null!==h?f=wh(h,f):(f=Ah(f,g,c,null),f.flags|=2);f.return=
  b;d.return=b;d.sibling=f;b.child=d;d=f;f=b.child;g=a.child.memoizedState;g=null===g?oj(c):{baseLanes:g.baseLanes|c,cachePool:null,transitions:g.transitions};f.memoizedState=g;f.childLanes=a.childLanes&~c;b.memoizedState=nj;return d}f=a.child;a=f.sibling;d=wh(f,{mode:"visible",children:d.children});0===(b.mode&1)&&(d.lanes=c);d.return=b;d.sibling=null;null!==a&&(c=b.deletions,null===c?(b.deletions=[a],b.flags|=16):c.push(a));b.child=d;b.memoizedState=null;return d}
  function rj(a,b){b=qj({mode:"visible",children:b},a.mode,0,null);b.return=a;return a.child=b}function tj(a,b,c,d){null!==d&&Jg(d);Bh(b,a.child,null,c);a=rj(b,b.pendingProps.children);a.flags|=2;b.memoizedState=null;return a}
  function sj(a,b,c,d,e,f,g){if(c){if(b.flags&256)return b.flags&=-257,d=Li(Error(p$3(422))),tj(a,b,g,d);if(null!==b.memoizedState)return b.child=a.child,b.flags|=128,null;f=d.fallback;e=b.mode;d=qj({mode:"visible",children:d.children},e,0,null);f=Ah(f,e,g,null);f.flags|=2;d.return=b;f.return=b;d.sibling=f;b.child=d;0!==(b.mode&1)&&Bh(b,a.child,null,g);b.child.memoizedState=oj(g);b.memoizedState=nj;return f}if(0===(b.mode&1))return tj(a,b,g,null);if("$!"===e.data){d=e.nextSibling&&e.nextSibling.dataset;
  if(d)var h=d.dgst;d=h;f=Error(p$3(419));d=Li(f,d,void 0);return tj(a,b,g,d)}h=0!==(g&a.childLanes);if(Ug||h){d=R;if(null!==d){switch(g&-g){case 4:e=2;break;case 16:e=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:e=32;break;case 536870912:e=268435456;break;default:e=0;}e=0!==(e&(d.suspendedLanes|g))?0:e;
  0!==e&&e!==f.retryLane&&(f.retryLane=e,Zg(a,e),mh(d,a,e,-1));}uj();d=Li(Error(p$3(421)));return tj(a,b,g,d)}if("$?"===e.data)return b.flags|=128,b.child=a.child,b=vj.bind(null,a),e._reactRetry=b,null;a=f.treeContext;yg=Lf(e.nextSibling);xg=b;I=!0;zg=null;null!==a&&(og[pg++]=rg,og[pg++]=sg,og[pg++]=qg,rg=a.id,sg=a.overflow,qg=b);b=rj(b,d.children);b.flags|=4096;return b}function wj(a,b,c){a.lanes|=b;var d=a.alternate;null!==d&&(d.lanes|=b);Sg(a.return,b,c);}
  function xj(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.renderingStartTime=0,f.last=d,f.tail=c,f.tailMode=e);}
  function yj(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;Yi(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.flags|=128;else {if(null!==a&&0!==(a.flags&128))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&wj(a,c,b);else if(19===a.tag)wj(a,c,b);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return;}a.sibling.return=a.return;a=a.sibling;}d&=1;}G(M,d);if(0===(b.mode&1))b.memoizedState=
  null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===Mh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);xj(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===Mh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a;}xj(b,!0,c,null,f);break;case "together":xj(b,!1,null,null,void 0);break;default:b.memoizedState=null;}return b.child}
  function jj(a,b){0===(b.mode&1)&&null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);}function $i(a,b,c){null!==a&&(b.dependencies=a.dependencies);hh|=b.lanes;if(0===(c&b.childLanes))return null;if(null!==a&&b.child!==a.child)throw Error(p$3(153));if(null!==b.child){a=b.child;c=wh(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=wh(a,a.pendingProps),c.return=b;c.sibling=null;}return b.child}
  function zj(a,b,c){switch(b.tag){case 3:lj(b);Ig();break;case 5:Kh(b);break;case 1:Zf(b.type)&&cg(b);break;case 4:Ih(b,b.stateNode.containerInfo);break;case 10:var d=b.type._context,e=b.memoizedProps.value;G(Mg,d._currentValue);d._currentValue=e;break;case 13:d=b.memoizedState;if(null!==d){if(null!==d.dehydrated)return G(M,M.current&1),b.flags|=128,null;if(0!==(c&b.child.childLanes))return pj(a,b,c);G(M,M.current&1);a=$i(a,b,c);return null!==a?a.sibling:null}G(M,M.current&1);break;case 19:d=0!==(c&
  b.childLanes);if(0!==(a.flags&128)){if(d)return yj(a,b,c);b.flags|=128;}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);G(M,M.current);if(d)break;else return null;case 22:case 23:return b.lanes=0,ej(a,b,c)}return $i(a,b,c)}var Aj,Bj,Cj,Dj;
  Aj=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;}c.sibling.return=c.return;c=c.sibling;}};Bj=function(){};
  Cj=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;Hh(Eh.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "select":e=A$1({},e,{value:void 0});d=A$1({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=Bf);}ub(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&
  (c||(c={}),c[g]="");}else "dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ea.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||(c={}),c[g]=k[g]);}else c||(f||(f=[]),f.push(l,
  c)),c=k;else "dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ea.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&D("scroll",a),f||h===k||(f=[])):(f=f||[]).push(l,k));}c&&(f=f||[]).push("style",c);var l=f;if(b.updateQueue=l)b.flags|=4;}};Dj=function(a,b,c,d){c!==d&&(b.flags|=4);};
  function Ej(a,b){if(!I)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null;}}
  function S(a){var b=null!==a.alternate&&a.alternate.child===a.child,c=0,d=0;if(b)for(var e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags&14680064,d|=e.flags&14680064,e.return=a,e=e.sibling;else for(e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags,d|=e.flags,e.return=a,e=e.sibling;a.subtreeFlags|=d;a.childLanes=c;return b}
  function Fj(a,b,c){var d=b.pendingProps;wg(b);switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return S(b),null;case 1:return Zf(b.type)&&$f(),S(b),null;case 3:d=b.stateNode;Jh();E(Wf);E(H);Oh();d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b)?b.flags|=4:null===a||a.memoizedState.isDehydrated&&0===(b.flags&256)||(b.flags|=1024,null!==zg&&(Gj(zg),zg=null));Bj(a,b);S(b);return null;case 5:Lh(b);var e=Hh(Gh.current);
  c=b.type;if(null!==a&&null!=b.stateNode)Cj(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=512,b.flags|=2097152);else {if(!d){if(null===b.stateNode)throw Error(p$3(166));S(b);return null}a=Hh(Eh.current);if(Gg(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[Of]=b;d[Pf]=f;a=0!==(b.mode&1);switch(c){case "dialog":D("cancel",d);D("close",d);break;case "iframe":case "object":case "embed":D("load",d);break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],d);break;case "source":D("error",d);break;case "img":case "image":case "link":D("error",
  d);D("load",d);break;case "details":D("toggle",d);break;case "input":Za(d,f);D("invalid",d);break;case "select":d._wrapperState={wasMultiple:!!f.multiple};D("invalid",d);break;case "textarea":hb(d,f),D("invalid",d);}ub(c,f);e=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,h,a),e=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,
  h,a),e=["children",""+h]):ea.hasOwnProperty(g)&&null!=h&&"onScroll"===g&&D("scroll",d);}switch(c){case "input":Va(d);db(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=Bf);}d=e;b.updateQueue=d;null!==d&&(b.flags|=4);}else {g=9===e.nodeType?e:e.ownerDocument;"http://www.w3.org/1999/xhtml"===a&&(a=kb(c));"http://www.w3.org/1999/xhtml"===a?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):
  "string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[Of]=b;a[Pf]=d;Aj(a,b,!1,!1);b.stateNode=a;a:{g=vb(c,d);switch(c){case "dialog":D("cancel",a);D("close",a);e=d;break;case "iframe":case "object":case "embed":D("load",a);e=d;break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],a);e=d;break;case "source":D("error",a);e=d;break;case "img":case "image":case "link":D("error",
  a);D("load",a);e=d;break;case "details":D("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);D("invalid",a);break;case "option":e=d;break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=A$1({},d,{value:void 0});D("invalid",a);break;case "textarea":hb(a,d);e=gb(a,d);D("invalid",a);break;default:e=d;}ub(c,e);h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?sb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&nb(a,k)):"children"===f?"string"===typeof k?("textarea"!==
  c||""!==k)&&ob(a,k):"number"===typeof k&&ob(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ea.hasOwnProperty(f)?null!=k&&"onScroll"===f&&D("scroll",a):null!=k&&ta(a,f,k,g));}switch(c){case "input":Va(a);db(a,d,!1);break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,
  !0);break;default:"function"===typeof e.onClick&&(a.onclick=Bf);}switch(c){case "button":case "input":case "select":case "textarea":d=!!d.autoFocus;break a;case "img":d=!0;break a;default:d=!1;}}d&&(b.flags|=4);}null!==b.ref&&(b.flags|=512,b.flags|=2097152);}S(b);return null;case 6:if(a&&null!=b.stateNode)Dj(a,b,a.memoizedProps,d);else {if("string"!==typeof d&&null===b.stateNode)throw Error(p$3(166));c=Hh(Gh.current);Hh(Eh.current);if(Gg(b)){d=b.stateNode;c=b.memoizedProps;d[Of]=b;if(f=d.nodeValue!==c)if(a=
  xg,null!==a)switch(a.tag){case 3:Af(d.nodeValue,c,0!==(a.mode&1));break;case 5:!0!==a.memoizedProps.suppressHydrationWarning&&Af(d.nodeValue,c,0!==(a.mode&1));}f&&(b.flags|=4);}else d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[Of]=b,b.stateNode=d;}S(b);return null;case 13:E(M);d=b.memoizedState;if(null===a||null!==a.memoizedState&&null!==a.memoizedState.dehydrated){if(I&&null!==yg&&0!==(b.mode&1)&&0===(b.flags&128))Hg(),Ig(),b.flags|=98560,f=!1;else if(f=Gg(b),null!==d&&null!==d.dehydrated){if(null===
  a){if(!f)throw Error(p$3(318));f=b.memoizedState;f=null!==f?f.dehydrated:null;if(!f)throw Error(p$3(317));f[Of]=b;}else Ig(),0===(b.flags&128)&&(b.memoizedState=null),b.flags|=4;S(b);f=!1;}else null!==zg&&(Gj(zg),zg=null),f=!0;if(!f)return b.flags&65536?b:null}if(0!==(b.flags&128))return b.lanes=c,b;d=null!==d;d!==(null!==a&&null!==a.memoizedState)&&d&&(b.child.flags|=8192,0!==(b.mode&1)&&(null===a||0!==(M.current&1)?0===T&&(T=3):uj()));null!==b.updateQueue&&(b.flags|=4);S(b);return null;case 4:return Jh(),
  Bj(a,b),null===a&&sf(b.stateNode.containerInfo),S(b),null;case 10:return Rg(b.type._context),S(b),null;case 17:return Zf(b.type)&&$f(),S(b),null;case 19:E(M);f=b.memoizedState;if(null===f)return S(b),null;d=0!==(b.flags&128);g=f.rendering;if(null===g)if(d)Ej(f,!1);else {if(0!==T||null!==a&&0!==(a.flags&128))for(a=b.child;null!==a;){g=Mh(a);if(null!==g){b.flags|=128;Ej(f,!1);d=g.updateQueue;null!==d&&(b.updateQueue=d,b.flags|=4);b.subtreeFlags=0;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=14680066,
  g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.subtreeFlags=0,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.subtreeFlags=0,f.deletions=null,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;G(M,M.current&1|2);return b.child}a=
  a.sibling;}null!==f.tail&&B()>Hj&&(b.flags|=128,d=!0,Ej(f,!1),b.lanes=4194304);}else {if(!d)if(a=Mh(g),null!==a){if(b.flags|=128,d=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Ej(f,!0),null===f.tail&&"hidden"===f.tailMode&&!g.alternate&&!I)return S(b),null}else 2*B()-f.renderingStartTime>Hj&&1073741824!==c&&(b.flags|=128,d=!0,Ej(f,!1),b.lanes=4194304);f.isBackwards?(g.sibling=b.child,b.child=g):(c=f.last,null!==c?c.sibling=g:b.child=g,f.last=g);}if(null!==f.tail)return b=f.tail,f.rendering=
  b,f.tail=b.sibling,f.renderingStartTime=B(),b.sibling=null,c=M.current,G(M,d?c&1|2:c&1),b;S(b);return null;case 22:case 23:return Ij(),d=null!==b.memoizedState,null!==a&&null!==a.memoizedState!==d&&(b.flags|=8192),d&&0!==(b.mode&1)?0!==(gj&1073741824)&&(S(b),b.subtreeFlags&6&&(b.flags|=8192)):S(b),null;case 24:return null;case 25:return null}throw Error(p$3(156,b.tag));}
  function Jj(a,b){wg(b);switch(b.tag){case 1:return Zf(b.type)&&$f(),a=b.flags,a&65536?(b.flags=a&-65537|128,b):null;case 3:return Jh(),E(Wf),E(H),Oh(),a=b.flags,0!==(a&65536)&&0===(a&128)?(b.flags=a&-65537|128,b):null;case 5:return Lh(b),null;case 13:E(M);a=b.memoizedState;if(null!==a&&null!==a.dehydrated){if(null===b.alternate)throw Error(p$3(340));Ig();}a=b.flags;return a&65536?(b.flags=a&-65537|128,b):null;case 19:return E(M),null;case 4:return Jh(),null;case 10:return Rg(b.type._context),null;case 22:case 23:return Ij(),
  null;case 24:return null;default:return null}}var Kj=!1,U=!1,Lj="function"===typeof WeakSet?WeakSet:Set,V=null;function Mj(a,b){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null);}catch(d){W(a,b,d);}else c.current=null;}function Nj(a,b,c){try{c();}catch(d){W(a,b,d);}}var Oj=!1;
  function Pj(a,b){Cf=dd;a=Me();if(Ne(a)){if("selectionStart"in a)var c={start:a.selectionStart,end:a.selectionEnd};else a:{c=(c=a.ownerDocument)&&c.defaultView||window;var d=c.getSelection&&c.getSelection();if(d&&0!==d.rangeCount){c=d.anchorNode;var e=d.anchorOffset,f=d.focusNode;d=d.focusOffset;try{c.nodeType,f.nodeType;}catch(F){c=null;break a}var g=0,h=-1,k=-1,l=0,m=0,q=a,r=null;b:for(;;){for(var y;;){q!==c||0!==e&&3!==q.nodeType||(h=g+e);q!==f||0!==d&&3!==q.nodeType||(k=g+d);3===q.nodeType&&(g+=
  q.nodeValue.length);if(null===(y=q.firstChild))break;r=q;q=y;}for(;;){if(q===a)break b;r===c&&++l===e&&(h=g);r===f&&++m===d&&(k=g);if(null!==(y=q.nextSibling))break;q=r;r=q.parentNode;}q=y;}c=-1===h||-1===k?null:{start:h,end:k};}else c=null;}c=c||{start:0,end:0};}else c=null;Df={focusedElem:a,selectionRange:c};dd=!1;for(V=b;null!==V;)if(b=V,a=b.child,0!==(b.subtreeFlags&1028)&&null!==a)a.return=b,V=a;else for(;null!==V;){b=V;try{var n=b.alternate;if(0!==(b.flags&1024))switch(b.tag){case 0:case 11:case 15:break;
  case 1:if(null!==n){var t=n.memoizedProps,J=n.memoizedState,x=b.stateNode,w=x.getSnapshotBeforeUpdate(b.elementType===b.type?t:Lg(b.type,t),J);x.__reactInternalSnapshotBeforeUpdate=w;}break;case 3:var u=b.stateNode.containerInfo;1===u.nodeType?u.textContent="":9===u.nodeType&&u.documentElement&&u.removeChild(u.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(p$3(163));}}catch(F){W(b,b.return,F);}a=b.sibling;if(null!==a){a.return=b.return;V=a;break}V=b.return;}n=Oj;Oj=!1;return n}
  function Qj(a,b,c){var d=b.updateQueue;d=null!==d?d.lastEffect:null;if(null!==d){var e=d=d.next;do{if((e.tag&a)===a){var f=e.destroy;e.destroy=void 0;void 0!==f&&Nj(b,c,f);}e=e.next;}while(e!==d)}}function Rj(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d();}c=c.next;}while(c!==b)}}function Sj(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=c;break;default:a=c;}"function"===typeof b?b(a):b.current=a;}}
  function Tj(a){var b=a.alternate;null!==b&&(a.alternate=null,Tj(b));a.child=null;a.deletions=null;a.sibling=null;5===a.tag&&(b=a.stateNode,null!==b&&(delete b[Of],delete b[Pf],delete b[of],delete b[Qf],delete b[Rf]));a.stateNode=null;a.return=null;a.dependencies=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.stateNode=null;a.updateQueue=null;}function Uj(a){return 5===a.tag||3===a.tag||4===a.tag}
  function Vj(a){a:for(;;){for(;null===a.sibling;){if(null===a.return||Uj(a.return))return null;a=a.return;}a.sibling.return=a.return;for(a=a.sibling;5!==a.tag&&6!==a.tag&&18!==a.tag;){if(a.flags&2)continue a;if(null===a.child||4===a.tag)continue a;else a.child.return=a,a=a.child;}if(!(a.flags&2))return a.stateNode}}
  function Wj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=Bf));else if(4!==d&&(a=a.child,null!==a))for(Wj(a,b,c),a=a.sibling;null!==a;)Wj(a,b,c),a=a.sibling;}
  function Xj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Xj(a,b,c),a=a.sibling;null!==a;)Xj(a,b,c),a=a.sibling;}var X=null,Yj=!1;function Zj(a,b,c){for(c=c.child;null!==c;)ak(a,b,c),c=c.sibling;}
  function ak(a,b,c){if(lc&&"function"===typeof lc.onCommitFiberUnmount)try{lc.onCommitFiberUnmount(kc,c);}catch(h){}switch(c.tag){case 5:U||Mj(c,b);case 6:var d=X,e=Yj;X=null;Zj(a,b,c);X=d;Yj=e;null!==X&&(Yj?(a=X,c=c.stateNode,8===a.nodeType?a.parentNode.removeChild(c):a.removeChild(c)):X.removeChild(c.stateNode));break;case 18:null!==X&&(Yj?(a=X,c=c.stateNode,8===a.nodeType?Kf(a.parentNode,c):1===a.nodeType&&Kf(a,c),bd(a)):Kf(X,c.stateNode));break;case 4:d=X;e=Yj;X=c.stateNode.containerInfo;Yj=!0;
  Zj(a,b,c);X=d;Yj=e;break;case 0:case 11:case 14:case 15:if(!U&&(d=c.updateQueue,null!==d&&(d=d.lastEffect,null!==d))){e=d=d.next;do{var f=e,g=f.destroy;f=f.tag;void 0!==g&&(0!==(f&2)?Nj(c,b,g):0!==(f&4)&&Nj(c,b,g));e=e.next;}while(e!==d)}Zj(a,b,c);break;case 1:if(!U&&(Mj(c,b),d=c.stateNode,"function"===typeof d.componentWillUnmount))try{d.props=c.memoizedProps,d.state=c.memoizedState,d.componentWillUnmount();}catch(h){W(c,b,h);}Zj(a,b,c);break;case 21:Zj(a,b,c);break;case 22:c.mode&1?(U=(d=U)||null!==
  c.memoizedState,Zj(a,b,c),U=d):Zj(a,b,c);break;default:Zj(a,b,c);}}function bk(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Lj);b.forEach(function(b){var d=ck.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d));});}}
  function dk(a,b){var c=b.deletions;if(null!==c)for(var d=0;d<c.length;d++){var e=c[d];try{var f=a,g=b,h=g;a:for(;null!==h;){switch(h.tag){case 5:X=h.stateNode;Yj=!1;break a;case 3:X=h.stateNode.containerInfo;Yj=!0;break a;case 4:X=h.stateNode.containerInfo;Yj=!0;break a}h=h.return;}if(null===X)throw Error(p$3(160));ak(f,g,e);X=null;Yj=!1;var k=e.alternate;null!==k&&(k.return=null);e.return=null;}catch(l){W(e,b,l);}}if(b.subtreeFlags&12854)for(b=b.child;null!==b;)ek(b,a),b=b.sibling;}
  function ek(a,b){var c=a.alternate,d=a.flags;switch(a.tag){case 0:case 11:case 14:case 15:dk(b,a);fk(a);if(d&4){try{Qj(3,a,a.return),Rj(3,a);}catch(t){W(a,a.return,t);}try{Qj(5,a,a.return);}catch(t){W(a,a.return,t);}}break;case 1:dk(b,a);fk(a);d&512&&null!==c&&Mj(c,c.return);break;case 5:dk(b,a);fk(a);d&512&&null!==c&&Mj(c,c.return);if(a.flags&32){var e=a.stateNode;try{ob(e,"");}catch(t){W(a,a.return,t);}}if(d&4&&(e=a.stateNode,null!=e)){var f=a.memoizedProps,g=null!==c?c.memoizedProps:f,h=a.type,k=a.updateQueue;
  a.updateQueue=null;if(null!==k)try{"input"===h&&"radio"===f.type&&null!=f.name&&ab(e,f);vb(h,g);var l=vb(h,f);for(g=0;g<k.length;g+=2){var m=k[g],q=k[g+1];"style"===m?sb(e,q):"dangerouslySetInnerHTML"===m?nb(e,q):"children"===m?ob(e,q):ta(e,m,q,l);}switch(h){case "input":bb(e,f);break;case "textarea":ib(e,f);break;case "select":var r=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=!!f.multiple;var y=f.value;null!=y?fb(e,!!f.multiple,y,!1):r!==!!f.multiple&&(null!=f.defaultValue?fb(e,!!f.multiple,
  f.defaultValue,!0):fb(e,!!f.multiple,f.multiple?[]:"",!1));}e[Pf]=f;}catch(t){W(a,a.return,t);}}break;case 6:dk(b,a);fk(a);if(d&4){if(null===a.stateNode)throw Error(p$3(162));e=a.stateNode;f=a.memoizedProps;try{e.nodeValue=f;}catch(t){W(a,a.return,t);}}break;case 3:dk(b,a);fk(a);if(d&4&&null!==c&&c.memoizedState.isDehydrated)try{bd(b.containerInfo);}catch(t){W(a,a.return,t);}break;case 4:dk(b,a);fk(a);break;case 13:dk(b,a);fk(a);e=a.child;e.flags&8192&&(f=null!==e.memoizedState,e.stateNode.isHidden=f,!f||
  null!==e.alternate&&null!==e.alternate.memoizedState||(gk=B()));d&4&&bk(a);break;case 22:m=null!==c&&null!==c.memoizedState;a.mode&1?(U=(l=U)||m,dk(b,a),U=l):dk(b,a);fk(a);if(d&8192){l=null!==a.memoizedState;if((a.stateNode.isHidden=l)&&!m&&0!==(a.mode&1))for(V=a,m=a.child;null!==m;){for(q=V=m;null!==V;){r=V;y=r.child;switch(r.tag){case 0:case 11:case 14:case 15:Qj(4,r,r.return);break;case 1:Mj(r,r.return);var n=r.stateNode;if("function"===typeof n.componentWillUnmount){d=r;c=r.return;try{b=d,n.props=
  b.memoizedProps,n.state=b.memoizedState,n.componentWillUnmount();}catch(t){W(d,c,t);}}break;case 5:Mj(r,r.return);break;case 22:if(null!==r.memoizedState){hk(q);continue}}null!==y?(y.return=r,V=y):hk(q);}m=m.sibling;}a:for(m=null,q=a;;){if(5===q.tag){if(null===m){m=q;try{e=q.stateNode,l?(f=e.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(h=q.stateNode,k=q.memoizedProps.style,g=void 0!==k&&null!==k&&k.hasOwnProperty("display")?k.display:null,h.style.display=
  rb("display",g));}catch(t){W(a,a.return,t);}}}else if(6===q.tag){if(null===m)try{q.stateNode.nodeValue=l?"":q.memoizedProps;}catch(t){W(a,a.return,t);}}else if((22!==q.tag&&23!==q.tag||null===q.memoizedState||q===a)&&null!==q.child){q.child.return=q;q=q.child;continue}if(q===a)break a;for(;null===q.sibling;){if(null===q.return||q.return===a)break a;m===q&&(m=null);q=q.return;}m===q&&(m=null);q.sibling.return=q.return;q=q.sibling;}}break;case 19:dk(b,a);fk(a);d&4&&bk(a);break;case 21:break;default:dk(b,
  a),fk(a);}}function fk(a){var b=a.flags;if(b&2){try{a:{for(var c=a.return;null!==c;){if(Uj(c)){var d=c;break a}c=c.return;}throw Error(p$3(160));}switch(d.tag){case 5:var e=d.stateNode;d.flags&32&&(ob(e,""),d.flags&=-33);var f=Vj(a);Xj(a,f,e);break;case 3:case 4:var g=d.stateNode.containerInfo,h=Vj(a);Wj(a,h,g);break;default:throw Error(p$3(161));}}catch(k){W(a,a.return,k);}a.flags&=-3;}b&4096&&(a.flags&=-4097);}function ik(a,b,c){V=a;jk(a);}
  function jk(a,b,c){for(var d=0!==(a.mode&1);null!==V;){var e=V,f=e.child;if(22===e.tag&&d){var g=null!==e.memoizedState||Kj;if(!g){var h=e.alternate,k=null!==h&&null!==h.memoizedState||U;h=Kj;var l=U;Kj=g;if((U=k)&&!l)for(V=e;null!==V;)g=V,k=g.child,22===g.tag&&null!==g.memoizedState?kk(e):null!==k?(k.return=g,V=k):kk(e);for(;null!==f;)V=f,jk(f),f=f.sibling;V=e;Kj=h;U=l;}lk(a);}else 0!==(e.subtreeFlags&8772)&&null!==f?(f.return=e,V=f):lk(a);}}
  function lk(a){for(;null!==V;){var b=V;if(0!==(b.flags&8772)){var c=b.alternate;try{if(0!==(b.flags&8772))switch(b.tag){case 0:case 11:case 15:U||Rj(5,b);break;case 1:var d=b.stateNode;if(b.flags&4&&!U)if(null===c)d.componentDidMount();else {var e=b.elementType===b.type?c.memoizedProps:Lg(b.type,c.memoizedProps);d.componentDidUpdate(e,c.memoizedState,d.__reactInternalSnapshotBeforeUpdate);}var f=b.updateQueue;null!==f&&ih(b,f,d);break;case 3:var g=b.updateQueue;if(null!==g){c=null;if(null!==b.child)switch(b.child.tag){case 5:c=
  b.child.stateNode;break;case 1:c=b.child.stateNode;}ih(b,g,c);}break;case 5:var h=b.stateNode;if(null===c&&b.flags&4){c=h;var k=b.memoizedProps;switch(b.type){case "button":case "input":case "select":case "textarea":k.autoFocus&&c.focus();break;case "img":k.src&&(c.src=k.src);}}break;case 6:break;case 4:break;case 12:break;case 13:if(null===b.memoizedState){var l=b.alternate;if(null!==l){var m=l.memoizedState;if(null!==m){var q=m.dehydrated;null!==q&&bd(q);}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;
  default:throw Error(p$3(163));}U||b.flags&512&&Sj(b);}catch(r){W(b,b.return,r);}}if(b===a){V=null;break}c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return;}}function hk(a){for(;null!==V;){var b=V;if(b===a){V=null;break}var c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return;}}
  function kk(a){for(;null!==V;){var b=V;try{switch(b.tag){case 0:case 11:case 15:var c=b.return;try{Rj(4,b);}catch(k){W(b,c,k);}break;case 1:var d=b.stateNode;if("function"===typeof d.componentDidMount){var e=b.return;try{d.componentDidMount();}catch(k){W(b,e,k);}}var f=b.return;try{Sj(b);}catch(k){W(b,f,k);}break;case 5:var g=b.return;try{Sj(b);}catch(k){W(b,g,k);}}}catch(k){W(b,b.return,k);}if(b===a){V=null;break}var h=b.sibling;if(null!==h){h.return=b.return;V=h;break}V=b.return;}}
  var mk=Math.ceil,nk=ua.ReactCurrentDispatcher,ok=ua.ReactCurrentOwner,pk=ua.ReactCurrentBatchConfig,K=0,R=null,Y=null,Z=0,gj=0,fj=Uf(0),T=0,qk=null,hh=0,rk=0,sk=0,tk=null,uk=null,gk=0,Hj=Infinity,vk=null,Pi=!1,Qi=null,Si=null,wk=!1,xk=null,yk=0,zk=0,Ak=null,Bk=-1,Ck=0;function L(){return 0!==(K&6)?B():-1!==Bk?Bk:Bk=B()}
  function lh(a){if(0===(a.mode&1))return 1;if(0!==(K&2)&&0!==Z)return Z&-Z;if(null!==Kg.transition)return 0===Ck&&(Ck=yc()),Ck;a=C;if(0!==a)return a;a=window.event;a=void 0===a?16:jd(a.type);return a}function mh(a,b,c,d){if(50<zk)throw zk=0,Ak=null,Error(p$3(185));Ac(a,c,d);if(0===(K&2)||a!==R)a===R&&(0===(K&2)&&(rk|=c),4===T&&Dk(a,Z)),Ek(a,d),1===c&&0===K&&0===(b.mode&1)&&(Hj=B()+500,fg&&jg());}
  function Ek(a,b){var c=a.callbackNode;wc(a,b);var d=uc(a,a===R?Z:0);if(0===d)null!==c&&bc(c),a.callbackNode=null,a.callbackPriority=0;else if(b=d&-d,a.callbackPriority!==b){null!=c&&bc(c);if(1===b)0===a.tag?ig(Fk.bind(null,a)):hg(Fk.bind(null,a)),Jf(function(){0===(K&6)&&jg();}),c=null;else {switch(Dc(d)){case 1:c=fc;break;case 4:c=gc;break;case 16:c=hc;break;case 536870912:c=jc;break;default:c=hc;}c=Gk(c,Hk.bind(null,a));}a.callbackPriority=b;a.callbackNode=c;}}
  function Hk(a,b){Bk=-1;Ck=0;if(0!==(K&6))throw Error(p$3(327));var c=a.callbackNode;if(Ik()&&a.callbackNode!==c)return null;var d=uc(a,a===R?Z:0);if(0===d)return null;if(0!==(d&30)||0!==(d&a.expiredLanes)||b)b=Jk(a,d);else {b=d;var e=K;K|=2;var f=Kk();if(R!==a||Z!==b)vk=null,Hj=B()+500,Lk(a,b);do try{Mk();break}catch(h){Nk(a,h);}while(1);Qg();nk.current=f;K=e;null!==Y?b=0:(R=null,Z=0,b=T);}if(0!==b){2===b&&(e=xc(a),0!==e&&(d=e,b=Ok(a,e)));if(1===b)throw c=qk,Lk(a,0),Dk(a,d),Ek(a,B()),c;if(6===b)Dk(a,d);
  else {e=a.current.alternate;if(0===(d&30)&&!Pk(e)&&(b=Jk(a,d),2===b&&(f=xc(a),0!==f&&(d=f,b=Ok(a,f))),1===b))throw c=qk,Lk(a,0),Dk(a,d),Ek(a,B()),c;a.finishedWork=e;a.finishedLanes=d;switch(b){case 0:case 1:throw Error(p$3(345));case 2:Qk(a,uk,vk);break;case 3:Dk(a,d);if((d&130023424)===d&&(b=gk+500-B(),10<b)){if(0!==uc(a,0))break;e=a.suspendedLanes;if((e&d)!==d){L();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=Ff(Qk.bind(null,a,uk,vk),b);break}Qk(a,uk,vk);break;case 4:Dk(a,d);if((d&4194240)===
  d)break;b=a.eventTimes;for(e=-1;0<d;){var g=31-oc(d);f=1<<g;g=b[g];g>e&&(e=g);d&=~f;}d=e;d=B()-d;d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*mk(d/1960))-d;if(10<d){a.timeoutHandle=Ff(Qk.bind(null,a,uk,vk),d);break}Qk(a,uk,vk);break;case 5:Qk(a,uk,vk);break;default:throw Error(p$3(329));}}}Ek(a,B());return a.callbackNode===c?Hk.bind(null,a):null}
  function Ok(a,b){var c=tk;a.current.memoizedState.isDehydrated&&(Lk(a,b).flags|=256);a=Jk(a,b);2!==a&&(b=uk,uk=c,null!==b&&Gj(b));return a}function Gj(a){null===uk?uk=a:uk.push.apply(uk,a);}
  function Pk(a){for(var b=a;;){if(b.flags&16384){var c=b.updateQueue;if(null!==c&&(c=c.stores,null!==c))for(var d=0;d<c.length;d++){var e=c[d],f=e.getSnapshot;e=e.value;try{if(!He(f(),e))return !1}catch(g){return !1}}}c=b.child;if(b.subtreeFlags&16384&&null!==c)c.return=b,b=c;else {if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return !0;b=b.return;}b.sibling.return=b.return;b=b.sibling;}}return !0}
  function Dk(a,b){b&=~sk;b&=~rk;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-oc(b),d=1<<c;a[c]=-1;b&=~d;}}function Fk(a){if(0!==(K&6))throw Error(p$3(327));Ik();var b=uc(a,0);if(0===(b&1))return Ek(a,B()),null;var c=Jk(a,b);if(0!==a.tag&&2===c){var d=xc(a);0!==d&&(b=d,c=Ok(a,d));}if(1===c)throw c=qk,Lk(a,0),Dk(a,b),Ek(a,B()),c;if(6===c)throw Error(p$3(345));a.finishedWork=a.current.alternate;a.finishedLanes=b;Qk(a,uk,vk);Ek(a,B());return null}
  function Rk(a,b){var c=K;K|=1;try{return a(b)}finally{K=c,0===K&&(Hj=B()+500,fg&&jg());}}function Sk(a){null!==xk&&0===xk.tag&&0===(K&6)&&Ik();var b=K;K|=1;var c=pk.transition,d=C;try{if(pk.transition=null,C=1,a)return a()}finally{C=d,pk.transition=c,K=b,0===(K&6)&&jg();}}function Ij(){gj=fj.current;E(fj);}
  function Lk(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Gf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;wg(d);switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&$f();break;case 3:Jh();E(Wf);E(H);Oh();break;case 5:Lh(d);break;case 4:Jh();break;case 13:E(M);break;case 19:E(M);break;case 10:Rg(d.type._context);break;case 22:case 23:Ij();}c=c.return;}R=a;Y=a=wh(a.current,null);Z=gj=b;T=0;qk=null;sk=rk=hh=0;uk=tk=null;if(null!==Wg){for(b=
  0;b<Wg.length;b++)if(c=Wg[b],d=c.interleaved,null!==d){c.interleaved=null;var e=d.next,f=c.pending;if(null!==f){var g=f.next;f.next=e;d.next=g;}c.pending=d;}Wg=null;}return a}
  function Nk(a,b){do{var c=Y;try{Qg();Ph.current=ai;if(Sh){for(var d=N.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next;}Sh=!1;}Rh=0;P=O=N=null;Th=!1;Uh=0;ok.current=null;if(null===c||null===c.return){T=1;qk=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=Z;h.flags|=32768;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k,m=h,q=m.tag;if(0===(m.mode&1)&&(0===q||11===q||15===q)){var r=m.alternate;r?(m.updateQueue=r.updateQueue,m.memoizedState=r.memoizedState,
  m.lanes=r.lanes):(m.updateQueue=null,m.memoizedState=null);}var y=Vi(g);if(null!==y){y.flags&=-257;Wi(y,g,h,f,b);y.mode&1&&Ti(f,l,b);b=y;k=l;var n=b.updateQueue;if(null===n){var t=new Set;t.add(k);b.updateQueue=t;}else n.add(k);break a}else {if(0===(b&1)){Ti(f,l,b);uj();break a}k=Error(p$3(426));}}else if(I&&h.mode&1){var J=Vi(g);if(null!==J){0===(J.flags&65536)&&(J.flags|=256);Wi(J,g,h,f,b);Jg(Ki(k,h));break a}}f=k=Ki(k,h);4!==T&&(T=2);null===tk?tk=[f]:tk.push(f);f=g;do{switch(f.tag){case 3:f.flags|=65536;
  b&=-b;f.lanes|=b;var x=Oi(f,k,b);fh(f,x);break a;case 1:h=k;var w=f.type,u=f.stateNode;if(0===(f.flags&128)&&("function"===typeof w.getDerivedStateFromError||null!==u&&"function"===typeof u.componentDidCatch&&(null===Si||!Si.has(u)))){f.flags|=65536;b&=-b;f.lanes|=b;var F=Ri(f,h,b);fh(f,F);break a}}f=f.return;}while(null!==f)}Tk(c);}catch(na){b=na;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}function Kk(){var a=nk.current;nk.current=ai;return null===a?ai:a}
  function uj(){if(0===T||3===T||2===T)T=4;null===R||0===(hh&268435455)&&0===(rk&268435455)||Dk(R,Z);}function Jk(a,b){var c=K;K|=2;var d=Kk();if(R!==a||Z!==b)vk=null,Lk(a,b);do try{Uk();break}catch(e){Nk(a,e);}while(1);Qg();K=c;nk.current=d;if(null!==Y)throw Error(p$3(261));R=null;Z=0;return T}function Uk(){for(;null!==Y;)Vk(Y);}function Mk(){for(;null!==Y&&!cc();)Vk(Y);}function Vk(a){var b=Wk(a.alternate,a,gj);a.memoizedProps=a.pendingProps;null===b?Tk(a):Y=b;ok.current=null;}
  function Tk(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&32768)){if(c=Fj(c,b,gj),null!==c){Y=c;return}}else {c=Jj(c,b);if(null!==c){c.flags&=32767;Y=c;return}if(null!==a)a.flags|=32768,a.subtreeFlags=0,a.deletions=null;else {T=6;Y=null;return}}b=b.sibling;if(null!==b){Y=b;return}Y=b=a;}while(null!==b);0===T&&(T=5);}function Qk(a,b,c){var d=C,e=pk.transition;try{pk.transition=null,C=1,Xk(a,b,c,d);}finally{pk.transition=e,C=d;}return null}
  function Xk(a,b,c,d){do Ik();while(null!==xk);if(0!==(K&6))throw Error(p$3(327));c=a.finishedWork;var e=a.finishedLanes;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(p$3(177));a.callbackNode=null;a.callbackPriority=0;var f=c.lanes|c.childLanes;Bc(a,f);a===R&&(Y=R=null,Z=0);0===(c.subtreeFlags&2064)&&0===(c.flags&2064)||wk||(wk=!0,Gk(hc,function(){Ik();return null}));f=0!==(c.flags&15990);if(0!==(c.subtreeFlags&15990)||f){f=pk.transition;pk.transition=null;
  var g=C;C=1;var h=K;K|=4;ok.current=null;Pj(a,c);ek(c,a);Oe(Df);dd=!!Cf;Df=Cf=null;a.current=c;ik(c);dc();K=h;C=g;pk.transition=f;}else a.current=c;wk&&(wk=!1,xk=a,yk=e);f=a.pendingLanes;0===f&&(Si=null);mc(c.stateNode);Ek(a,B());if(null!==b)for(d=a.onRecoverableError,c=0;c<b.length;c++)e=b[c],d(e.value,{componentStack:e.stack,digest:e.digest});if(Pi)throw Pi=!1,a=Qi,Qi=null,a;0!==(yk&1)&&0!==a.tag&&Ik();f=a.pendingLanes;0!==(f&1)?a===Ak?zk++:(zk=0,Ak=a):zk=0;jg();return null}
  function Ik(){if(null!==xk){var a=Dc(yk),b=pk.transition,c=C;try{pk.transition=null;C=16>a?16:a;if(null===xk)var d=!1;else {a=xk;xk=null;yk=0;if(0!==(K&6))throw Error(p$3(331));var e=K;K|=4;for(V=a.current;null!==V;){var f=V,g=f.child;if(0!==(V.flags&16)){var h=f.deletions;if(null!==h){for(var k=0;k<h.length;k++){var l=h[k];for(V=l;null!==V;){var m=V;switch(m.tag){case 0:case 11:case 15:Qj(8,m,f);}var q=m.child;if(null!==q)q.return=m,V=q;else for(;null!==V;){m=V;var r=m.sibling,y=m.return;Tj(m);if(m===
  l){V=null;break}if(null!==r){r.return=y;V=r;break}V=y;}}}var n=f.alternate;if(null!==n){var t=n.child;if(null!==t){n.child=null;do{var J=t.sibling;t.sibling=null;t=J;}while(null!==t)}}V=f;}}if(0!==(f.subtreeFlags&2064)&&null!==g)g.return=f,V=g;else b:for(;null!==V;){f=V;if(0!==(f.flags&2048))switch(f.tag){case 0:case 11:case 15:Qj(9,f,f.return);}var x=f.sibling;if(null!==x){x.return=f.return;V=x;break b}V=f.return;}}var w=a.current;for(V=w;null!==V;){g=V;var u=g.child;if(0!==(g.subtreeFlags&2064)&&null!==
  u)u.return=g,V=u;else b:for(g=w;null!==V;){h=V;if(0!==(h.flags&2048))try{switch(h.tag){case 0:case 11:case 15:Rj(9,h);}}catch(na){W(h,h.return,na);}if(h===g){V=null;break b}var F=h.sibling;if(null!==F){F.return=h.return;V=F;break b}V=h.return;}}K=e;jg();if(lc&&"function"===typeof lc.onPostCommitFiberRoot)try{lc.onPostCommitFiberRoot(kc,a);}catch(na){}d=!0;}return d}finally{C=c,pk.transition=b;}}return !1}function Yk(a,b,c){b=Ki(c,b);b=Oi(a,b,1);a=dh(a,b,1);b=L();null!==a&&(Ac(a,1,b),Ek(a,b));}
  function W(a,b,c){if(3===a.tag)Yk(a,a,c);else for(;null!==b;){if(3===b.tag){Yk(b,a,c);break}else if(1===b.tag){var d=b.stateNode;if("function"===typeof b.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Si||!Si.has(d))){a=Ki(c,a);a=Ri(b,a,1);b=dh(b,a,1);a=L();null!==b&&(Ac(b,1,a),Ek(b,a));break}}b=b.return;}}
  function Ui(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=L();a.pingedLanes|=a.suspendedLanes&c;R===a&&(Z&c)===c&&(4===T||3===T&&(Z&130023424)===Z&&500>B()-gk?Lk(a,0):sk|=c);Ek(a,b);}function Zk(a,b){0===b&&(0===(a.mode&1)?b=1:(b=sc,sc<<=1,0===(sc&130023424)&&(sc=4194304)));var c=L();a=Zg(a,b);null!==a&&(Ac(a,b,c),Ek(a,c));}function vj(a){var b=a.memoizedState,c=0;null!==b&&(c=b.retryLane);Zk(a,c);}
  function ck(a,b){var c=0;switch(a.tag){case 13:var d=a.stateNode;var e=a.memoizedState;null!==e&&(c=e.retryLane);break;case 19:d=a.stateNode;break;default:throw Error(p$3(314));}null!==d&&d.delete(b);Zk(a,c);}var Wk;
  Wk=function(a,b,c){if(null!==a)if(a.memoizedProps!==b.pendingProps||Wf.current)Ug=!0;else {if(0===(a.lanes&c)&&0===(b.flags&128))return Ug=!1,zj(a,b,c);Ug=0!==(a.flags&131072)?!0:!1;}else Ug=!1,I&&0!==(b.flags&1048576)&&ug(b,ng,b.index);b.lanes=0;switch(b.tag){case 2:var d=b.type;jj(a,b);a=b.pendingProps;var e=Yf(b,H.current);Tg(b,c);e=Xh(null,b,d,a,e,c);var f=bi();b.flags|=1;"object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof?(b.tag=1,b.memoizedState=null,b.updateQueue=
  null,Zf(d)?(f=!0,cg(b)):f=!1,b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null,ah(b),e.updater=nh,b.stateNode=e,e._reactInternals=b,rh(b,d,a,c),b=kj(null,b,d,!0,f,c)):(b.tag=0,I&&f&&vg(b),Yi(null,b,e,c),b=b.child);return b;case 16:d=b.elementType;a:{jj(a,b);a=b.pendingProps;e=d._init;d=e(d._payload);b.type=d;e=b.tag=$k(d);a=Lg(d,a);switch(e){case 0:b=dj(null,b,d,a,c);break a;case 1:b=ij(null,b,d,a,c);break a;case 11:b=Zi(null,b,d,a,c);break a;case 14:b=aj(null,b,d,Lg(d.type,a),c);break a}throw Error(p$3(306,
  d,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),dj(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),ij(a,b,d,e,c);case 3:a:{lj(b);if(null===a)throw Error(p$3(387));d=b.pendingProps;f=b.memoizedState;e=f.element;bh(a,b);gh(b,d,null,c);var g=b.memoizedState;d=g.element;if(f.isDehydrated)if(f={element:d,isDehydrated:!1,cache:g.cache,pendingSuspenseBoundaries:g.pendingSuspenseBoundaries,transitions:g.transitions},b.updateQueue.baseState=
  f,b.memoizedState=f,b.flags&256){e=Ki(Error(p$3(423)),b);b=mj(a,b,d,c,e);break a}else if(d!==e){e=Ki(Error(p$3(424)),b);b=mj(a,b,d,c,e);break a}else for(yg=Lf(b.stateNode.containerInfo.firstChild),xg=b,I=!0,zg=null,c=Ch(b,null,d,c),b.child=c;c;)c.flags=c.flags&-3|4096,c=c.sibling;else {Ig();if(d===e){b=$i(a,b,c);break a}Yi(a,b,d,c);}b=b.child;}return b;case 5:return Kh(b),null===a&&Eg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ef(d,e)?g=null:null!==f&&Ef(d,f)&&(b.flags|=32),
  hj(a,b),Yi(a,b,g,c),b.child;case 6:return null===a&&Eg(b),null;case 13:return pj(a,b,c);case 4:return Ih(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Bh(b,null,d,c):Yi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),Zi(a,b,d,e,c);case 7:return Yi(a,b,b.pendingProps,c),b.child;case 8:return Yi(a,b,b.pendingProps.children,c),b.child;case 12:return Yi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;f=b.memoizedProps;
  g=e.value;G(Mg,d._currentValue);d._currentValue=g;if(null!==f)if(He(f.value,g)){if(f.children===e.children&&!Wf.current){b=$i(a,b,c);break a}}else for(f=b.child,null!==f&&(f.return=b);null!==f;){var h=f.dependencies;if(null!==h){g=f.child;for(var k=h.firstContext;null!==k;){if(k.context===d){if(1===f.tag){k=ch(-1,c&-c);k.tag=2;var l=f.updateQueue;if(null!==l){l=l.shared;var m=l.pending;null===m?k.next=k:(k.next=m.next,m.next=k);l.pending=k;}}f.lanes|=c;k=f.alternate;null!==k&&(k.lanes|=c);Sg(f.return,
  c,b);h.lanes|=c;break}k=k.next;}}else if(10===f.tag)g=f.type===b.type?null:f.child;else if(18===f.tag){g=f.return;if(null===g)throw Error(p$3(341));g.lanes|=c;h=g.alternate;null!==h&&(h.lanes|=c);Sg(g,c,b);g=f.sibling;}else g=f.child;if(null!==g)g.return=f;else for(g=f;null!==g;){if(g===b){g=null;break}f=g.sibling;if(null!==f){f.return=g.return;g=f;break}g=g.return;}f=g;}Yi(a,b,e.children,c);b=b.child;}return b;case 9:return e=b.type,d=b.pendingProps.children,Tg(b,c),e=Vg(e),d=d(e),b.flags|=1,Yi(a,b,d,c),
  b.child;case 14:return d=b.type,e=Lg(d,b.pendingProps),e=Lg(d.type,e),aj(a,b,d,e,c);case 15:return cj(a,b,b.type,b.pendingProps,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),jj(a,b),b.tag=1,Zf(d)?(a=!0,cg(b)):a=!1,Tg(b,c),ph(b,d,e),rh(b,d,e,c),kj(null,b,d,!0,a,c);case 19:return yj(a,b,c);case 22:return ej(a,b,c)}throw Error(p$3(156,b.tag));};function Gk(a,b){return ac(a,b)}
  function al(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.subtreeFlags=this.flags=0;this.deletions=null;this.childLanes=this.lanes=0;this.alternate=null;}function Bg(a,b,c,d){return new al(a,b,c,d)}function bj(a){a=a.prototype;return !(!a||!a.isReactComponent)}
  function $k(a){if("function"===typeof a)return bj(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Da)return 11;if(a===Ga)return 14}return 2}
  function wh(a,b){var c=a.alternate;null===c?(c=Bg(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.subtreeFlags=0,c.deletions=null);c.flags=a.flags&14680064;c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
  c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
  function yh(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bj(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ya:return Ah(c.children,e,f,b);case za:g=8;e|=8;break;case Aa:return a=Bg(12,c,b,e|2),a.elementType=Aa,a.lanes=f,a;case Ea:return a=Bg(13,c,b,e),a.elementType=Ea,a.lanes=f,a;case Fa:return a=Bg(19,c,b,e),a.elementType=Fa,a.lanes=f,a;case Ia:return qj(c,e,f,b);default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ba:g=10;break a;case Ca:g=9;break a;case Da:g=11;
  break a;case Ga:g=14;break a;case Ha:g=16;d=null;break a}throw Error(p$3(130,null==a?a:typeof a,""));}b=Bg(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Ah(a,b,c,d){a=Bg(7,a,d,b);a.lanes=c;return a}function qj(a,b,c,d){a=Bg(22,a,d,b);a.elementType=Ia;a.lanes=c;a.stateNode={isHidden:!1};return a}function xh(a,b,c){a=Bg(6,a,null,b);a.lanes=c;return a}
  function zh(a,b,c){b=Bg(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
  function bl(a,b,c,d,e){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.callbackNode=this.pendingContext=this.context=null;this.callbackPriority=0;this.eventTimes=zc(0);this.expirationTimes=zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=zc(0);this.identifierPrefix=d;this.onRecoverableError=e;this.mutableSourceEagerHydrationData=
  null;}function cl(a,b,c,d,e,f,g,h,k){a=new bl(a,b,c,h,k);1===b?(b=1,!0===f&&(b|=8)):b=0;f=Bg(3,null,null,b);a.current=f;f.stateNode=a;f.memoizedState={element:d,isDehydrated:c,cache:null,transitions:null,pendingSuspenseBoundaries:null};ah(f);return a}function dl(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return {$$typeof:wa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
  function el(a){if(!a)return Vf;a=a._reactInternals;a:{if(Vb(a)!==a||1!==a.tag)throw Error(p$3(170));var b=a;do{switch(b.tag){case 3:b=b.stateNode.context;break a;case 1:if(Zf(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return;}while(null!==b);throw Error(p$3(171));}if(1===a.tag){var c=a.type;if(Zf(c))return bg(a,c,b)}return b}
  function fl(a,b,c,d,e,f,g,h,k){a=cl(c,d,!0,a,e,f,g,h,k);a.context=el(null);c=a.current;d=L();e=lh(c);f=ch(d,e);f.callback=void 0!==b&&null!==b?b:null;dh(c,f,e);a.current.lanes=e;Ac(a,e,d);Ek(a,d);return a}function gl(a,b,c,d){var e=b.current,f=L(),g=lh(e);c=el(c);null===b.context?b.context=c:b.pendingContext=c;b=ch(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);a=dh(e,b,g);null!==a&&(mh(a,e,g,f),eh(a,e,g));return g}
  function hl(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function il(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b;}}function jl(a,b){il(a,b);(a=a.alternate)&&il(a,b);}function kl(){return null}var ll="function"===typeof reportError?reportError:function(a){console.error(a);};function ml(a){this._internalRoot=a;}
  nl.prototype.render=ml.prototype.render=function(a){var b=this._internalRoot;if(null===b)throw Error(p$3(409));gl(a,b,null,null);};nl.prototype.unmount=ml.prototype.unmount=function(){var a=this._internalRoot;if(null!==a){this._internalRoot=null;var b=a.containerInfo;Sk(function(){gl(null,a,null,null);});b[uf]=null;}};function nl(a){this._internalRoot=a;}
  nl.prototype.unstable_scheduleHydration=function(a){if(a){var b=Hc();a={blockedOn:null,target:a,priority:b};for(var c=0;c<Qc.length&&0!==b&&b<Qc[c].priority;c++);Qc.splice(c,0,a);0===c&&Vc(a);}};function ol(a){return !(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType)}function pl(a){return !(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function ql(){}
  function rl(a,b,c,d,e){if(e){if("function"===typeof d){var f=d;d=function(){var a=hl(g);f.call(a);};}var g=fl(b,d,a,0,null,!1,!1,"",ql);a._reactRootContainer=g;a[uf]=g.current;sf(8===a.nodeType?a.parentNode:a);Sk();return g}for(;e=a.lastChild;)a.removeChild(e);if("function"===typeof d){var h=d;d=function(){var a=hl(k);h.call(a);};}var k=cl(a,0,!1,null,null,!1,!1,"",ql);a._reactRootContainer=k;a[uf]=k.current;sf(8===a.nodeType?a.parentNode:a);Sk(function(){gl(b,k,c,d);});return k}
  function sl(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f;if("function"===typeof e){var h=e;e=function(){var a=hl(g);h.call(a);};}gl(b,g,a,e);}else g=rl(c,b,a,e,d);return hl(g)}Ec=function(a){switch(a.tag){case 3:var b=a.stateNode;if(b.current.memoizedState.isDehydrated){var c=tc(b.pendingLanes);0!==c&&(Cc(b,c|1),Ek(b,B()),0===(K&6)&&(Hj=B()+500,jg()));}break;case 13:Sk(function(){var b=Zg(a,1);if(null!==b){var c=L();mh(b,a,1,c);}}),jl(a,1);}};
  Fc=function(a){if(13===a.tag){var b=Zg(a,134217728);if(null!==b){var c=L();mh(b,a,134217728,c);}jl(a,134217728);}};Gc=function(a){if(13===a.tag){var b=lh(a),c=Zg(a,b);if(null!==c){var d=L();mh(c,a,b,d);}jl(a,b);}};Hc=function(){return C};Ic=function(a,b){var c=C;try{return C=a,b()}finally{C=c;}};
  yb=function(a,b,c){switch(b){case "input":bb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(p$3(90));Wa(d);bb(d,e);}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1);}};Gb=Rk;Hb=Sk;
  var tl={usingClientEntryPoint:!1,Events:[Cb,ue,Db,Eb,Fb,Rk]},ul={findFiberByHostInstance:Wc,bundleType:0,version:"18.2.0",rendererPackageName:"react-dom"};
  var vl={bundleType:ul.bundleType,version:ul.version,rendererPackageName:ul.rendererPackageName,rendererConfig:ul.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ua.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Zb(a);return null===a?null:a.stateNode},findFiberByHostInstance:ul.findFiberByHostInstance||
  kl,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.2.0-next-9e3b772b8-20220608"};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var wl=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!wl.isDisabled&&wl.supportsFiber)try{kc=wl.inject(vl),lc=wl;}catch(a){}}var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=tl;
  var createPortal=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!ol(b))throw Error(p$3(200));return dl(a,b,null,c)};var createRoot=function(a,b){if(!ol(a))throw Error(p$3(299));var c=!1,d="",e=ll;null!==b&&void 0!==b&&(!0===b.unstable_strictMode&&(c=!0),void 0!==b.identifierPrefix&&(d=b.identifierPrefix),void 0!==b.onRecoverableError&&(e=b.onRecoverableError));b=cl(a,1,!1,null,null,c,!1,d,e);a[uf]=b.current;sf(8===a.nodeType?a.parentNode:a);return new ml(b)};
  var findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(p$3(188));a=Object.keys(a).join(",");throw Error(p$3(268,a));}a=Zb(b);a=null===a?null:a.stateNode;return a};var flushSync=function(a){return Sk(a)};var hydrate=function(a,b,c){if(!pl(b))throw Error(p$3(200));return sl(null,a,b,!0,c)};
  var hydrateRoot=function(a,b,c){if(!ol(a))throw Error(p$3(405));var d=null!=c&&c.hydratedSources||null,e=!1,f="",g=ll;null!==c&&void 0!==c&&(!0===c.unstable_strictMode&&(e=!0),void 0!==c.identifierPrefix&&(f=c.identifierPrefix),void 0!==c.onRecoverableError&&(g=c.onRecoverableError));b=fl(b,null,a,1,null!=c?c:null,e,!1,f,g);a[uf]=b.current;sf(a);if(d)for(a=0;a<d.length;a++)c=d[a],e=c._getVersion,e=e(c._source),null==b.mutableSourceEagerHydrationData?b.mutableSourceEagerHydrationData=[c,e]:b.mutableSourceEagerHydrationData.push(c,
  e);return new nl(b)};var render=function(a,b,c){if(!pl(b))throw Error(p$3(200));return sl(null,a,b,!1,c)};var unmountComponentAtNode=function(a){if(!pl(a))throw Error(p$3(40));return a._reactRootContainer?(Sk(function(){sl(null,null,a,!1,function(){a._reactRootContainer=null;a[uf]=null;});}),!0):!1};var unstable_batchedUpdates=Rk;
  var unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!pl(c))throw Error(p$3(200));if(null==a||void 0===a._reactInternals)throw Error(p$3(38));return sl(a,b,c,!1,d)};var version="18.2.0-next-9e3b772b8-20220608";

  var reactDom_production_min = {
  	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  	createPortal: createPortal,
  	createRoot: createRoot,
  	findDOMNode: findDOMNode,
  	flushSync: flushSync,
  	hydrate: hydrate,
  	hydrateRoot: hydrateRoot,
  	render: render,
  	unmountComponentAtNode: unmountComponentAtNode,
  	unstable_batchedUpdates: unstable_batchedUpdates,
  	unstable_renderSubtreeIntoContainer: unstable_renderSubtreeIntoContainer,
  	version: version
  };

  var reactDom = createCommonjsModule(function (module) {

  function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
    if (
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
    ) {
      return;
    }
    try {
      // Verify that the code above has been dead code eliminated (DCE'd).
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      // DevTools shouldn't crash React, no matter what.
      // We should still report in case we break this code.
      console.error(err);
    }
  }

  {
    // DCE check should happen before ReactDOM bundle executes so that
    // DevTools can report bad minification during injection.
    checkDCE();
    module.exports = reactDom_production_min;
  }
  });

  function warn() {
    if (console && console.warn) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
      console.warn(...args);
    }
  }
  const alreadyWarned = {};
  function warnOnce() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
    warn(...args);
  }
  const loadedClb = (i18n, cb) => () => {
    if (i18n.isInitialized) {
      cb();
    } else {
      const initialized = () => {
        setTimeout(() => {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  };
  function loadNamespaces(i18n, ns, cb) {
    i18n.loadNamespaces(ns, loadedClb(i18n, cb));
  }
  function loadLanguages(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [ns];
    ns.forEach(n => {
      if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, loadedClb(i18n, cb));
  }
  function oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  function hasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
      warnOnce('i18n.languages were undefined or empty', i18n.languages);
      return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) {
      return oldI18nextHasLoadedNamespace(ns, i18n, options);
    }
    return i18n.hasLoadedNamespace(ns, {
      lng: options.lng,
      precheck: (i18nInstance, loadNotPending) => {
        if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
      }
    });
  }

  const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
  const htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': '©',
    '&#169;': '©',
    '&reg;': '®',
    '&#174;': '®',
    '&hellip;': '…',
    '&#8230;': '…',
    '&#x2F;': '/',
    '&#47;': '/'
  };
  const unescapeHtmlEntity = m => htmlEntities[m];
  const unescape = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);

  let defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    useSuspense: true,
    unescape
  };
  function setDefaults() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    defaultOptions = {
      ...defaultOptions,
      ...options
    };
  }
  function getDefaults$1() {
    return defaultOptions;
  }

  let i18nInstance;
  function setI18n(instance) {
    i18nInstance = instance;
  }
  function getI18n() {
    return i18nInstance;
  }

  const initReactI18next = {
    type: '3rdParty',
    init(instance) {
      setDefaults(instance.options.react);
      setI18n(instance);
    }
  };

  const I18nContext = react.createContext();
  class ReportNamespaces {
    constructor() {
      this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
      namespaces.forEach(ns => {
        if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
      });
    }
    getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }

  const usePrevious = (value, ignore) => {
    const ref = react.useRef();
    react.useEffect(() => {
      ref.current = ignore ? ref.current : value;
    }, [value, ignore]);
    return ref.current;
  };
  function alwaysNewT(i18n, language, namespace, keyPrefix) {
    return i18n.getFixedT(language, namespace, keyPrefix);
  }
  function useMemoizedT(i18n, language, namespace, keyPrefix) {
    return react.useCallback(alwaysNewT(i18n, language, namespace, keyPrefix), [i18n, language, namespace, keyPrefix]);
  }
  function useTranslation(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      i18n: i18nFromProps
    } = props;
    const {
      i18n: i18nFromContext,
      defaultNS: defaultNSFromContext
    } = react.useContext(I18nContext) || {};
    const i18n = i18nFromProps || i18nFromContext || getI18n();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
    if (!i18n) {
      warnOnce('You will need to pass in an i18next instance by using initReactI18next');
      const notReadyT = (k, optsOrDefaultValue) => {
        if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
        if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
        return Array.isArray(k) ? k[k.length - 1] : k;
      };
      const retNotReady = [notReadyT, {}, false];
      retNotReady.t = notReadyT;
      retNotReady.i18n = {};
      retNotReady.ready = false;
      return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
      ...getDefaults$1(),
      ...i18n.options.react,
      ...props
    };
    const {
      useSuspense,
      keyPrefix
    } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
    const memoGetT = useMemoizedT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const getT = () => memoGetT;
    const getNewT = () => alwaysNewT(i18n, props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    const [t, setT] = react.useState(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = usePrevious(joinedNS);
    const isMounted = react.useRef(true);
    react.useEffect(() => {
      const {
        bindI18n,
        bindI18nStore
      } = i18nOptions;
      isMounted.current = true;
      if (!ready && !useSuspense) {
        if (props.lng) {
          loadLanguages(i18n, props.lng, namespaces, () => {
            if (isMounted.current) setT(getNewT);
          });
        } else {
          loadNamespaces(i18n, namespaces, () => {
            if (isMounted.current) setT(getNewT);
          });
        }
      }
      if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
        setT(getNewT);
      }
      function boundReset() {
        if (isMounted.current) setT(getNewT);
      }
      if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
      if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
      return () => {
        isMounted.current = false;
        if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
        if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
      };
    }, [i18n, joinedNS]);
    react.useEffect(() => {
      if (isMounted.current && ready) {
        setT(getT);
      }
    }, [i18n, keyPrefix, ready]);
    const ret = [t, i18n, ready];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(resolve => {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => resolve());
      } else {
        loadNamespaces(i18n, namespaces, () => resolve());
      }
    });
  }

  const consoleLogger = {
    type: 'logger',
    log(args) {
      this.output('log', args);
    },
    warn(args) {
      this.output('warn', args);
    },
    error(args) {
      this.output('error', args);
    },
    output(type, args) {
      if (console && console[type]) console[type].apply(console, args);
    }
  };
  class Logger {
    constructor(concreteLogger) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.init(concreteLogger, options);
    }
    init(concreteLogger) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
    log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
    warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
    error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
    deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
      return this.logger[lvl](args);
    }
    create(moduleName) {
      return new Logger(this.logger, {
        ...{
          prefix: `${this.prefix}:${moduleName}:`
        },
        ...this.options
      });
    }
    clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }
  var baseLogger = new Logger();

  class EventEmitter {
    constructor() {
      this.observers = {};
    }
    on(events, listener) {
      events.split(' ').forEach(event => {
        if (!this.observers[event]) this.observers[event] = new Map();
        const numListeners = this.observers[event].get(listener) || 0;
        this.observers[event].set(listener, numListeners + 1);
      });
      return this;
    }
    off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event].delete(listener);
    }
    emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        const cloned = Array.from(this.observers[event].entries());
        cloned.forEach(_ref => {
          let [observer, numTimesAdded] = _ref;
          for (let i = 0; i < numTimesAdded; i++) {
            observer(...args);
          }
        });
      }
      if (this.observers['*']) {
        const cloned = Array.from(this.observers['*'].entries());
        cloned.forEach(_ref2 => {
          let [observer, numTimesAdded] = _ref2;
          for (let i = 0; i < numTimesAdded; i++) {
            observer.apply(observer, [event, ...args]);
          }
        });
      }
    }
  }

  function defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject) => {
      res = resolve;
      rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
  }
  function makeString(object) {
    if (object == null) return '';
    return '' + object;
  }
  function copy$1(a, s, t) {
    a.forEach(m => {
      if (s[m]) t[m] = s[m];
    });
  }
  const lastOfPathSeparatorRegExp = /###/g;
  function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
      return key && key.indexOf('###') > -1 ? key.replace(lastOfPathSeparatorRegExp, '.') : key;
    }
    function canNotTraverseDeeper() {
      return !object || typeof object === 'string';
    }
    const stack = typeof path !== 'string' ? path : path.split('.');
    let stackIndex = 0;
    while (stackIndex < stack.length - 1) {
      if (canNotTraverseDeeper()) return {};
      const key = cleanKey(stack[stackIndex]);
      if (!object[key] && Empty) object[key] = new Empty();
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        object = object[key];
      } else {
        object = {};
      }
      ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
      obj: object,
      k: cleanKey(stack[stackIndex])
    };
  }
  function setPath(object, path, newValue) {
    const {
      obj,
      k
    } = getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
      obj[k] = newValue;
      return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = getLastOfPath(object, p, Object);
    while (last.obj === undefined && p.length) {
      e = `${p[p.length - 1]}.${e}`;
      p = p.slice(0, p.length - 1);
      last = getLastOfPath(object, p, Object);
      if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== 'undefined') {
        last.obj = undefined;
      }
    }
    last.obj[`${last.k}.${e}`] = newValue;
  }
  function pushPath(object, path, newValue, concat) {
    const {
      obj,
      k
    } = getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
  }
  function getPath(object, path) {
    const {
      obj,
      k
    } = getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
  }
  function getPathWithDefaults(data, defaultData, key) {
    const value = getPath(data, key);
    if (value !== undefined) {
      return value;
    }
    return getPath(defaultData, key);
  }
  function deepExtend(target, source, overwrite) {
    for (const prop in source) {
      if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
          if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
            if (overwrite) target[prop] = source[prop];
          } else {
            deepExtend(target[prop], source[prop], overwrite);
          }
        } else {
          target[prop] = source[prop];
        }
      }
    }
    return target;
  }
  function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  }
  var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
  };
  function escape$2(data) {
    if (typeof data === 'string') {
      return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
    }
    return data;
  }
  class RegExpCache {
    constructor(capacity) {
      this.capacity = capacity;
      this.regExpMap = new Map();
      this.regExpQueue = [];
    }
    getRegExp(pattern) {
      const regExpFromCache = this.regExpMap.get(pattern);
      if (regExpFromCache !== undefined) {
        return regExpFromCache;
      }
      const regExpNew = new RegExp(pattern);
      if (this.regExpQueue.length === this.capacity) {
        this.regExpMap.delete(this.regExpQueue.shift());
      }
      this.regExpMap.set(pattern, regExpNew);
      this.regExpQueue.push(pattern);
      return regExpNew;
    }
  }
  const chars = [' ', ',', '?', '!', ';'];
  const looksLikeObjectPathRegExpCache = new RegExpCache(20);
  function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
      const ki = key.indexOf(keySeparator);
      if (ki > 0 && !r.test(key.substring(0, ki))) {
        matched = true;
      }
    }
    return matched;
  }
  function deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for (let i = 0; i < tokens.length;) {
      if (!current || typeof current !== 'object') {
        return undefined;
      }
      let next;
      let nextPath = '';
      for (let j = i; j < tokens.length; ++j) {
        if (j !== i) {
          nextPath += keySeparator;
        }
        nextPath += tokens[j];
        next = current[nextPath];
        if (next !== undefined) {
          if (['string', 'number', 'boolean'].indexOf(typeof next) > -1 && j < tokens.length - 1) {
            continue;
          }
          i += j - i + 1;
          break;
        }
      }
      current = next;
    }
    return current;
  }
  function getCleanedCode(code) {
    if (code && code.indexOf('_') > 0) return code.replace('_', '-');
    return code;
  }

  class ResourceStore extends EventEmitter {
    constructor(data) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        ns: ['translation'],
        defaultNS: 'translation'
      };
      super();
      this.data = data || {};
      this.options = options;
      if (this.options.keySeparator === undefined) {
        this.options.keySeparator = '.';
      }
      if (this.options.ignoreJSONStructure === undefined) {
        this.options.ignoreJSONStructure = true;
      }
    }
    addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
    removeNamespaces(ns) {
      const index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
    getResource(lng, ns, key) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      let path;
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      } else {
        path = [lng, ns];
        if (key) {
          if (Array.isArray(key)) {
            path.push(...key);
          } else if (typeof key === 'string' && keySeparator) {
            path.push(...key.split(keySeparator));
          } else {
            path.push(key);
          }
        }
      }
      const result = getPath(this.data, path);
      if (!result && !ns && !key && lng.indexOf('.') > -1) {
        lng = path[0];
        ns = path[1];
        key = path.slice(2).join('.');
      }
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
      let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      let path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (const m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
      let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false,
        skipCopy: false
      };
      let path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      let pack = getPath(this.data, path) || {};
      if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = {
          ...pack,
          ...resources
        };
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return {
        ...{},
        ...this.getResource(lng, ns)
      };
      return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
      return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
      const data = this.getDataByLanguage(lng);
      const n = data && Object.keys(data) || [];
      return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
      return this.data;
    }
  }

  var postProcessor = {
    processors: {},
    addPostProcessor(module) {
      this.processors[module.name] = module;
    },
    handle(processors, value, key, options, translator) {
      processors.forEach(processor => {
        if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
      });
      return value;
    }
  };

  const checkedLoadedFor = {};
  class Translator extends EventEmitter {
    constructor(services) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      copy$1(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
      this.options = options;
      if (this.options.keySeparator === undefined) {
        this.options.keySeparator = '.';
      }
      this.logger = baseLogger.create('translator');
    }
    changeLanguage(lng) {
      if (lng) this.language = lng;
    }
    exists(key) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      const resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
      let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      let namespaces = options.ns || this.options.defaultNS || [];
      const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        const m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key,
            namespaces
          };
        }
        const parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key,
        namespaces
      };
    }
    translate(keys, options, lastKey) {
      if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (typeof options === 'object') options = {
        ...options
      };
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      const {
        key,
        namespaces
      } = this.extractFromKey(keys[keys.length - 1], options);
      const namespace = namespaces[namespaces.length - 1];
      const lng = options.lng || this.language;
      const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          const nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: `${namespace}${nsSeparator}${key}`,
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace,
              usedParams: this.getUsedParamsDetails(options)
            };
          }
          return `${namespace}${nsSeparator}${key}`;
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(options)
          };
        }
        return key;
      }
      const resolved = this.resolve(keys, options);
      let res = resolved && resolved.res;
      const resUsedKey = resolved && resolved.usedKey || key;
      const resExactUsedKey = resolved && resolved.exactUsedKey || key;
      const resType = Object.prototype.toString.apply(res);
      const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
            ...options,
            ns: namespaces
          }) : `key '${key} (${this.language})' returned an object instead of string.`;
          if (returnDetails) {
            resolved.res = r;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          const resTypeIsArray = resType === '[object Array]';
          const copy = resTypeIsArray ? [] : {};
          const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (const m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              const deepKey = `${newKeyToUse}${keySeparator}${m}`;
              copy[m] = this.translate(deepKey, {
                ...options,
                ...{
                  joinArrays: false,
                  ns: namespaces
                }
              });
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        let usedDefault = false;
        let usedKey = false;
        const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        const hasDefaultValue = Translator.hasDefaultValue(options);
        const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
          ordinal: false
        }) : '';
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
        const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            const fk = this.resolve(key, {
              ...options,
              keySeparator: false
            });
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          let lngs = [];
          const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (let i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          const send = (l, k, specificDefaultValue) => {
            const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (this.options.missingKeyHandler) {
              this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (this.backendConnector && this.backendConnector.saveMissing) {
              this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            this.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(language => {
                const suffixes = this.pluralResolver.getSuffixes(language, options);
                if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                  suffixes.push(`${this.options.pluralSeparator}zero`);
                }
                suffixes.forEach(suffix => {
                  send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        resolved.usedParams = this.getUsedParamsDetails(options);
        return resolved;
      }
      return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
      var _this = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, {
          ...this.options.interpolation.defaultVariables,
          ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init({
          ...options,
          ...{
            interpolation: {
              ...this.options.interpolation,
              ...options.interpolation
            }
          }
        });
        const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        let nestBef;
        if (skipOnVariables) {
          const nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = {
          ...this.options.interpolation.defaultVariables,
          ...data
        };
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          const na = res.match(this.interpolator.nestingRegexp);
          const nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
            return null;
          }
          return _this.translate(...args, key);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      const postProcess = options.postProcess || this.options.postProcess;
      const postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
          i18nResolved: {
            ...resolved,
            usedParams: this.getUsedParamsDetails(options)
          },
          ...options
        } : options, this);
      }
      return res;
    }
    resolve(keys) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let found;
      let usedKey;
      let exactUsedKey;
      let usedLng;
      let usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(k => {
        if (this.isValidLookup(found)) return;
        const extracted = this.extractFromKey(k, options);
        const key = extracted.key;
        usedKey = key;
        let namespaces = extracted.namespaces;
        if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
        const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
        const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
        namespaces.forEach(ns => {
          if (this.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor[`${codes[0]}-${ns}`] = true;
            this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(code => {
            if (this.isValidLookup(found)) return;
            usedLng = code;
            const finalKeys = [key];
            if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
              this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              let pluralSuffix;
              if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
              const zeroSuffix = `${this.options.pluralSeparator}zero`;
              const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                    finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                  }
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            let possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!this.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = this.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey,
        exactUsedKey,
        usedLng,
        usedNS
      };
    }
    isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const optionsKeys = ['defaultValue', 'ordinal', 'context', 'replace', 'lng', 'lngs', 'fallbackLng', 'ns', 'keySeparator', 'nsSeparator', 'returnObjects', 'returnDetails', 'joinArrays', 'postProcess', 'interpolation'];
      const useOptionsReplaceForData = options.replace && typeof options.replace !== 'string';
      let data = useOptionsReplaceForData ? options.replace : options;
      if (useOptionsReplaceForData && typeof options.count !== 'undefined') {
        data.count = options.count;
      }
      if (this.options.interpolation.defaultVariables) {
        data = {
          ...this.options.interpolation.defaultVariables,
          ...data
        };
      }
      if (!useOptionsReplaceForData) {
        data = {
          ...data
        };
        for (const key of optionsKeys) {
          delete data[key];
        }
      }
      return data;
    }
    static hasDefaultValue(options) {
      const prefix = 'defaultValue';
      for (const option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }

  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  class LanguageUtil {
    constructor(options) {
      this.options = options;
      this.supportedLngs = this.options.supportedLngs || false;
      this.logger = baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
      code = getCleanedCode(code);
      if (!code || code.indexOf('-') < 0) return null;
      const p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
      code = getCleanedCode(code);
      if (!code || code.indexOf('-') < 0) return code;
      const p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        let p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(part => part.toLowerCase());
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
      if (!codes) return null;
      let found;
      codes.forEach(code => {
        if (found) return;
        const cleanedLng = this.formatLanguageCode(code);
        if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(code => {
          if (found) return;
          const lngOnly = this.getLanguagePartFromCode(code);
          if (this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = this.options.supportedLngs.find(supportedLng => {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf('-') > 0 && lngOnly.indexOf('-') < 0 && supportedLng.substring(0, supportedLng.indexOf('-')) === lngOnly) return supportedLng;
            if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
    getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks.default || [];
      let found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks.default;
      return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
      const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      const codes = [];
      const addCode = c => {
        if (!c) return;
        if (this.isSupportedCode(c)) {
          codes.push(c);
        } else {
          this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        }
      };
      if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(fc => {
        if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
      });
      return codes;
    }
  }

  let sets = [{
    lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
    nr: [1, 2],
    fc: 1
  }, {
    lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
    nr: [1, 2],
    fc: 2
  }, {
    lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
    nr: [1],
    fc: 3
  }, {
    lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
    nr: [1, 2, 5],
    fc: 4
  }, {
    lngs: ['ar'],
    nr: [0, 1, 2, 3, 11, 100],
    fc: 5
  }, {
    lngs: ['cs', 'sk'],
    nr: [1, 2, 5],
    fc: 6
  }, {
    lngs: ['csb', 'pl'],
    nr: [1, 2, 5],
    fc: 7
  }, {
    lngs: ['cy'],
    nr: [1, 2, 3, 8],
    fc: 8
  }, {
    lngs: ['fr'],
    nr: [1, 2],
    fc: 9
  }, {
    lngs: ['ga'],
    nr: [1, 2, 3, 7, 11],
    fc: 10
  }, {
    lngs: ['gd'],
    nr: [1, 2, 3, 20],
    fc: 11
  }, {
    lngs: ['is'],
    nr: [1, 2],
    fc: 12
  }, {
    lngs: ['jv'],
    nr: [0, 1],
    fc: 13
  }, {
    lngs: ['kw'],
    nr: [1, 2, 3, 4],
    fc: 14
  }, {
    lngs: ['lt'],
    nr: [1, 2, 10],
    fc: 15
  }, {
    lngs: ['lv'],
    nr: [1, 2, 0],
    fc: 16
  }, {
    lngs: ['mk'],
    nr: [1, 2],
    fc: 17
  }, {
    lngs: ['mnk'],
    nr: [0, 1, 2],
    fc: 18
  }, {
    lngs: ['mt'],
    nr: [1, 2, 11, 20],
    fc: 19
  }, {
    lngs: ['or'],
    nr: [2, 1],
    fc: 2
  }, {
    lngs: ['ro'],
    nr: [1, 2, 20],
    fc: 20
  }, {
    lngs: ['sl'],
    nr: [5, 1, 2, 3],
    fc: 21
  }, {
    lngs: ['he', 'iw'],
    nr: [1, 2, 20, 21],
    fc: 22
  }];
  let _rulesPluralsTypes = {
    1: function (n) {
      return Number(n > 1);
    },
    2: function (n) {
      return Number(n != 1);
    },
    3: function (n) {
      return 0;
    },
    4: function (n) {
      return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function (n) {
      return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function (n) {
      return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function (n) {
      return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function (n) {
      return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function (n) {
      return Number(n >= 2);
    },
    10: function (n) {
      return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function (n) {
      return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function (n) {
      return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function (n) {
      return Number(n !== 0);
    },
    14: function (n) {
      return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function (n) {
      return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function (n) {
      return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function (n) {
      return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function (n) {
      return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function (n) {
      return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function (n) {
      return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function (n) {
      return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function (n) {
      return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
  };
  const nonIntlVersions = ['v1', 'v2', 'v3'];
  const intlVersions = ['v4'];
  const suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
  };
  function createRules() {
    const rules = {};
    sets.forEach(set => {
      set.lngs.forEach(l => {
        rules[l] = {
          numbers: set.nr,
          plurals: _rulesPluralsTypes[set.fc]
        };
      });
    });
    return rules;
  }
  class PluralResolver {
    constructor(languageUtils) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.languageUtils = languageUtils;
      this.options = options;
      this.logger = baseLogger.create('pluralResolver');
      if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
        this.options.compatibilityJSON = 'v3';
        this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
      }
      this.rules = createRules();
    }
    addRule(lng, obj) {
      this.rules[lng] = obj;
    }
    getRule(code) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(getCleanedCode(code === 'dev' ? 'en' : code), {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (err) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
    }
    getSuffixes(code) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
      }
      return rule.numbers.map(number => this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn(`no plural rule found for: ${code}`);
      return '';
    }
    getSuffixRetroCompatible(rule, count) {
      const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      let suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
      return !nonIntlVersions.includes(this.options.compatibilityJSON);
    }
  }

  function deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
      path = deepFind(data, key, keySeparator);
      if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
  }
  class Interpolator {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.logger = baseLogger.create('interpolator');
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || (value => value);
      this.init(options);
    }
    init() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      const iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape$2;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
    reset() {
      if (this.options) this.init(this.options);
    }
    resetRegExp() {
      const getOrResetRegExp = (existingRegExp, pattern) => {
        if (existingRegExp && existingRegExp.source === pattern) {
          existingRegExp.lastIndex = 0;
          return existingRegExp;
        }
        return new RegExp(pattern, 'g');
      };
      this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
      this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
      this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
      let match;
      let value;
      let replaces;
      const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      const handleFormat = key => {
        if (key.indexOf(this.formatSeparator) < 0) {
          const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
          return this.alwaysFormat ? this.format(path, undefined, lng, {
            ...options,
            ...data,
            interpolationkey: key
          }) : path;
        }
        const p = key.split(this.formatSeparator);
        const k = p.shift().trim();
        const f = p.join(this.formatSeparator).trim();
        return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
          ...options,
          ...data,
          interpolationkey: k
        });
      };
      this.resetRegExp();
      const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      const todos = [{
        regex: this.regexpUnescape,
        safeValue: val => regexSafe(val)
      }, {
        regex: this.regexp,
        safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
      }];
      todos.forEach(todo => {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          const matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              const temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
              value = '';
            }
          } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
            value = makeString(value);
          }
          const safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
    nest(str, fc) {
      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let match;
      let value;
      let clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        const sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        const c = key.split(new RegExp(`${sep}[ ]*{`));
        let optionsString = `{${c[1]}`;
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        const matchedSingleQuotes = optionsString.match(/'/g);
        const matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = {
            ...inheritedOptions,
            ...clonedOptions
          };
        } catch (e) {
          this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
          return `${key}${sep}${optionsString}`;
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        let formatters = [];
        clonedOptions = {
          ...options
        };
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        let doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
            ...options,
            interpolationkey: match[1].trim()
          }), value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }

  function parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
      const p = formatStr.split('(');
      formatName = p[0].toLowerCase().trim();
      const optStr = p[1].substring(0, p[1].length - 1);
      if (formatName === 'currency' && optStr.indexOf(':') < 0) {
        if (!formatOptions.currency) formatOptions.currency = optStr.trim();
      } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
        if (!formatOptions.range) formatOptions.range = optStr.trim();
      } else {
        const opts = optStr.split(';');
        opts.forEach(opt => {
          if (!opt) return;
          const [key, ...rest] = opt.split(':');
          const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
          if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
          if (val === 'false') formatOptions[key.trim()] = false;
          if (val === 'true') formatOptions[key.trim()] = true;
          if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
        });
      }
    }
    return {
      formatName,
      formatOptions
    };
  }
  function createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
      const key = lng + JSON.stringify(options);
      let formatter = cache[key];
      if (!formatter) {
        formatter = fn(getCleanedCode(lng), options);
        cache[key] = formatter;
      }
      return formatter(val);
    };
  }
  class Formatter {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.logger = baseLogger.create('formatter');
      this.options = options;
      this.formats = {
        number: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.NumberFormat(lng, {
            ...opt
          });
          return val => formatter.format(val);
        }),
        currency: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.NumberFormat(lng, {
            ...opt,
            style: 'currency'
          });
          return val => formatter.format(val);
        }),
        datetime: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.DateTimeFormat(lng, {
            ...opt
          });
          return val => formatter.format(val);
        }),
        relativetime: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.RelativeTimeFormat(lng, {
            ...opt
          });
          return val => formatter.format(val, opt.range || 'day');
        }),
        list: createCachedFormatter((lng, opt) => {
          const formatter = new Intl.ListFormat(lng, {
            ...opt
          });
          return val => formatter.format(val);
        })
      };
      this.init(options);
    }
    init(services) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      const iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
    add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
    format(value, format, lng) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      const formats = format.split(this.formatSeparator);
      const result = formats.reduce((mem, f) => {
        const {
          formatName,
          formatOptions
        } = parseFormatStr(f);
        if (this.formats[formatName]) {
          let formatted = mem;
          try {
            const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = this.formats[formatName](mem, l, {
              ...formatOptions,
              ...options,
              ...valOptions
            });
          } catch (error) {
            this.logger.warn(error);
          }
          return formatted;
        } else {
          this.logger.warn(`there was no format function for ${formatName}`);
        }
        return mem;
      }, value);
      return result;
    }
  }

  function removePending(q, name) {
    if (q.pending[name] !== undefined) {
      delete q.pending[name];
      q.pendingCount--;
    }
  }
  class Connector extends EventEmitter {
    constructor(backend, store, services) {
      let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      super();
      this.backend = backend;
      this.store = store;
      this.services = services;
      this.languageUtils = services.languageUtils;
      this.options = options;
      this.logger = baseLogger.create('backendConnector');
      this.waitingReads = [];
      this.maxParallelReads = options.maxParallelReads || 10;
      this.readingCalls = 0;
      this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
      this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
      this.state = {};
      this.queue = [];
      if (this.backend && this.backend.init) {
        this.backend.init(services, options.backend, options);
      }
    }
    queueLoad(languages, namespaces, options, callback) {
      const toLoad = {};
      const pending = {};
      const toLoadLanguages = {};
      const toLoadNamespaces = {};
      languages.forEach(lng => {
        let hasAllNamespaces = true;
        namespaces.forEach(ns => {
          const name = `${lng}|${ns}`;
          if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
            this.state[name] = 2;
          } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            this.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
    loaded(name, err, data) {
      const s = name.split('|');
      const lng = s[0];
      const ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
          skipCopy: true
        });
      }
      this.state[name] = err ? -1 : 2;
      const loaded = {};
      this.queue.forEach(q => {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(l => {
            if (!loaded[l]) loaded[l] = {};
            const loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(n => {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(q => !q.done);
    }
    read(lng, ns, fcName) {
      let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      let callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng,
          ns,
          fcName,
          tried,
          wait,
          callback
        });
        return;
      }
      this.readingCalls++;
      const resolver = (err, data) => {
        this.readingCalls--;
        if (this.waitingReads.length > 0) {
          const next = this.waitingReads.shift();
          this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < this.maxRetries) {
          setTimeout(() => {
            this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      const fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          const r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(data => resolver(null, data)).catch(resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      let callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      const toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(name => {
        this.loadOne(name);
      });
    }
    load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
    loadOne(name) {
      let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      const s = name.split('|');
      const lng = s[0];
      const ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
        if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
        if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
        this.loaded(name, err, data);
      });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        const opts = {
          ...options,
          isUpdate
        };
        const fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            let r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(data => clb(null, data)).catch(clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }

  function get$2() {
    return {
      debug: false,
      initImmediate: true,
      ns: ['translation'],
      defaultNS: ['translation'],
      fallbackLng: ['dev'],
      fallbackNS: false,
      supportedLngs: false,
      nonExplicitSupportedLngs: false,
      load: 'all',
      preload: false,
      simplifyPluralSuffix: true,
      keySeparator: '.',
      nsSeparator: ':',
      pluralSeparator: '_',
      contextSeparator: '_',
      partialBundledLanguages: false,
      saveMissing: false,
      updateMissing: false,
      saveMissingTo: 'fallback',
      saveMissingPlurals: true,
      missingKeyHandler: false,
      missingInterpolationHandler: false,
      postProcess: false,
      postProcessPassResolved: false,
      returnNull: false,
      returnEmptyString: true,
      returnObjects: false,
      joinArrays: false,
      returnedObjectHandler: false,
      parseMissingKeyHandler: false,
      appendNamespaceToMissingKey: false,
      appendNamespaceToCIMode: false,
      overloadTranslationOptionHandler: function handle(args) {
        let ret = {};
        if (typeof args[1] === 'object') ret = args[1];
        if (typeof args[1] === 'string') ret.defaultValue = args[1];
        if (typeof args[2] === 'string') ret.tDescription = args[2];
        if (typeof args[2] === 'object' || typeof args[3] === 'object') {
          const options = args[3] || args[2];
          Object.keys(options).forEach(key => {
            ret[key] = options[key];
          });
        }
        return ret;
      },
      interpolation: {
        escapeValue: true,
        format: value => value,
        prefix: '{{',
        suffix: '}}',
        formatSeparator: ',',
        unescapePrefix: '-',
        nestingPrefix: '$t(',
        nestingSuffix: ')',
        nestingOptionsSeparator: ',',
        maxReplaces: 1000,
        skipOnVariables: true
      }
    };
  }
  function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [options.ns];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
      options.supportedLngs = options.supportedLngs.concat(['cimode']);
    }
    return options;
  }

  function noop$3() {}
  function bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(mem => {
      if (typeof inst[mem] === 'function') {
        inst[mem] = inst[mem].bind(inst);
      }
    });
  }
  class I18n extends EventEmitter {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : undefined;
      super();
      this.options = transformOptions(options);
      this.services = {};
      this.logger = baseLogger;
      this.modules = {
        external: []
      };
      bindMemberFunctions(this);
      if (callback && !this.isInitialized && !options.isClone) {
        if (!this.options.initImmediate) {
          this.init(options, callback);
          return this;
        }
        setTimeout(() => {
          this.init(options, callback);
        }, 0);
      }
    }
    init() {
      var _this = this;
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : undefined;
      this.isInitializing = true;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      const defOpts = get$2();
      this.options = {
        ...defOpts,
        ...this.options,
        ...transformOptions(options)
      };
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = {
          ...defOpts.interpolation,
          ...this.options.interpolation
        };
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        let formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        const lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        const s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this.emit(event, ...args);
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this.emit(event, ...args);
        });
        this.modules.external.forEach(m => {
          if (m.init) m.init(this);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$3;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(fcName => {
        this[fcName] = function () {
          return _this.store[fcName](...arguments);
        };
      });
      const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(fcName => {
        this[fcName] = function () {
          _this.store[fcName](...arguments);
          return _this;
        };
      });
      const deferred = defer();
      const load = () => {
        const finish = (err, t) => {
          this.isInitializing = false;
          if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
          this.isInitialized = true;
          if (!this.options.isClone) this.logger.log('initialized', this.options);
          this.emit('initialized', this.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
        this.changeLanguage(this.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
    loadResources(language) {
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$3;
      let usedCallback = callback;
      const usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
        const toLoad = [];
        const append = lng => {
          if (!lng) return;
          if (lng === 'cimode') return;
          const lngs = this.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(l => {
            if (l === 'cimode') return;
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(l => append(l));
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(l => append(l));
        }
        this.services.backendConnector.load(toLoad, this.options.ns, e => {
          if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
    reloadResources(lngs, ns, callback) {
      const deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$3;
      this.services.backendConnector.reload(lngs, ns, err => {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
    use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
    setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (let li = 0; li < this.languages.length; li++) {
        const lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
    changeLanguage(lng, callback) {
      var _this2 = this;
      this.isLanguageChangingTo = lng;
      const deferred = defer();
      this.emit('languageChanging', lng);
      const setLngProps = l => {
        this.language = l;
        this.languages = this.services.languageUtils.toResolveHierarchy(l);
        this.resolvedLanguage = undefined;
        this.setResolvedLanguage(l);
      };
      const done = (err, l) => {
        if (l) {
          setLngProps(l);
          this.translator.changeLanguage(l);
          this.isLanguageChangingTo = undefined;
          this.emit('languageChanged', l);
          this.logger.log('languageChanged', l);
        } else {
          this.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this2.t(...arguments);
        });
        if (callback) callback(err, function () {
          return _this2.t(...arguments);
        });
      };
      const setLng = lngs => {
        if (!lng && !lngs && this.services.languageDetector) lngs = [];
        const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!this.language) {
            setLngProps(l);
          }
          if (!this.translator.language) this.translator.changeLanguage(l);
          if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
        }
        this.loadResources(l, err => {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
      var _this3 = this;
      const fixedT = function (key, opts) {
        let options;
        if (typeof opts !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = {
            ...opts
          };
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        const keySeparator = _this3.options.keySeparator || '.';
        let resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
        } else {
          resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
        }
        return _this3.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
    t() {
      return this.translator && this.translator.translate(...arguments);
    }
    exists() {
      return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      const lng = options.lng || this.resolvedLanguage || this.languages[0];
      const fallbackLng = this.options ? this.options.fallbackLng : false;
      const lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      const loadNotPending = (l, n) => {
        const loadState = this.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        const preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
    loadNamespaces(ns, callback) {
      const deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(n => {
        if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
      });
      this.loadResources(err => {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
    loadLanguages(lngs, callback) {
      const deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      const preloaded = this.options.preload || [];
      const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0);
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(err => {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
    dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get$2());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
    cloneInstance() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$3;
      const forkResourceStore = options.forkResourceStore;
      if (forkResourceStore) delete options.forkResourceStore;
      const mergedOptions = {
        ...this.options,
        ...options,
        ...{
          isClone: true
        }
      };
      const clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      const membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(m => {
        clone[m] = this[m];
      });
      clone.services = {
        ...this.services
      };
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      if (forkResourceStore) {
        clone.store = new ResourceStore(this.store.data, mergedOptions);
        clone.services.resourceStore = clone.store;
      }
      clone.translator = new Translator(clone.services, mergedOptions);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit(event, ...args);
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = mergedOptions;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
    toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }
  const instance = I18n.createInstance();
  instance.createInstance = I18n.createInstance;

  instance.createInstance;
  instance.dir;
  instance.init;
  instance.loadResources;
  instance.reloadResources;
  instance.use;
  instance.changeLanguage;
  instance.getFixedT;
  instance.t;
  instance.exists;
  instance.setDefaultNamespace;
  instance.hasLoadedNamespace;
  instance.loadNamespaces;
  instance.loadLanguages;

  var translations$3 = {
      Upload: "Subir",
      "Select header": "Seleccionar encabezado",
      "Map columns": "Mapear columnas",
      "Expected column": "Columnas esperadas",
      Required: "Requerido",
      "Drop your file here": "Suelta tu archivo aquí",
      or: "o",
      "Browse files": "Examinar archivos",
      "Download template": "Descargar plantilla",
      "Only CSV, XLS, and XLSX files can be uploaded": "Solo se pueden subir archivos CSV, XLS y XLSX",
      "Select header row": "Seleccionar fila de encabezado",
      "Select the row which contains the column headers": "Selecciona la fila que contiene los encabezados de las columnas",
      "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": " Solo se importará la primera hoja (&quot;{{sheet}}&quot;) del archivo de Excel. Para importar varias hojas, sube cada hoja individualmente.",
      "Cancel": "Cancelar",
      "Continue": "Continuar",
      "Your file column": "Tu columna del archivo",
      "Your sample data": "Tus datos de muestra",
      "Destination column": "Columna de destino",
      "Include": "Incluir",
      "Submit": "Enviar",
      "Loading...": "Cargando...",
      "Please include all required columns": "Por favor incluye todas las columnas requeridas",
      "Back": "Atrás",
      "- Select one -": "- Selecciona uno -",
      "- empty -": "- vacío -",
      "Import successful": "Importación exitosa",
      "Upload successful": "Se ha subido con éxito",
      "Done": "Listo",
      "Upload another file": "Subir otro archivo",
  };

  // Translations in french
  //TODO:  Double the translations
  var translations$2 = {
      Upload: "Télécharger",
      "Select header": "Sélectionner l'en-tête",
      "Map columns": "Mapper les colonnes",
      "Expected column": "Colonne attendue",
      Required: "Requis",
      "Drop your file here": "Déposez votre fichier ici",
      or: "ou",
      "Browse files": "Parcourir les fichiers",
      "Download template": "Télécharger le modèle",
      "Only CSV, XLS, and XLSX files can be uploaded": "Seuls les fichiers CSV, XLS et XLSX peuvent être téléchargés",
      "Select header row": "Sélectionner la ligne d'en-tête",
      "Select the row which contains the column headers": "Sélectionnez la ligne qui contient les en-têtes de colonne",
      "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Seule la première feuille (&quot;{{sheet}}&quot;) du fichier Excel sera importée. Pour importer plusieurs feuilles, veuillez télécharger chaque feuille individuellement.",
      "Cancel": "Annuler",
      "Continue": "Continuer",
      "Your file column": "Votre colonne de fichier",
      "Your sample data": "Vos données d'échantillon",
      "Destination column": "Colonne de destination",
      "Include": "Inclure",
      "Submit": "Soumettre",
      "Loading...": "Chargement...",
      "Please include all required columns": "Veuillez inclure toutes les colonnes requises",
      "Back": "Retour",
      "- Select one -": "- Sélectionnez un -",
      "- empty -": "- vide -",
      "Import successful": "Importation réussie",
      "Upload successful": "Téléchargement réussi",
      "Done": "Terminé",
      "Upload another file": "Télécharger un autre fichier",
  };

  // Translations in Italian
  var translations$1 = {
      Upload: "Caricare",
      "Select header": "Seleziona intestazione",
      "Map columns": "Mappa colonne",
      "Expected column": "Colonna prevista",
      Required: "Richiesto",
      "Drop your file here": "Trascina il tuo file qui",
      or: "oppure",
      "Browse files": "Sfoglia file",
      "Download template": "Scarica il modello",
      "Only CSV, XLS, and XLSX files can be uploaded": "Solo i file CSV, XLS e XLSX possono essere caricati",
      "Select header row": "Seleziona la riga di intestazione",
      "Select the row which contains the column headers": "Seleziona la riga che contiene le intestazioni delle colonne",
      "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Solo il primo foglio (&quot;{{sheet}}&quot;) del file Excel verrà importato. Per importare più fogli, carica ogni foglio singolarmente.",
      "Cancel": "Annulla",
      "Continue": "Continua",
      "Your file column": "La tua colonna di file",
      "Your sample data": "I tuoi dati di esempio",
      "Destination column": "Colonna di destinazione",
      "Include": "Includere",
      "Submit": "Invia",
      "Loading...": "Caricamento...",
      "Please include all required columns": "Si prega di includere tutte le colonne richieste",
      "Back": "Indietro",
      "- Select one -": "- Selezionane uno -",
      "- empty -": "- vuoto -",
      "Import successful": "Importazione riuscita",
      "Upload successful": "Caricamento riuscito",
      "Done": "Fatto",
      "Upload another file": "Carica un altro file",
  };

  var translations = {
      Upload: "Hochladen",
      "Select header": "Kopfzeile auswählen",
      "Map columns": "Spalten zuordnen",
      "Expected column": "Erwartete Spalten",
      Required: "Erforderlich",
      "Drop your file here": "Datei hier ablegen",
      or: "oder",
      "Browse files": "Dateien durchsuchen",
      "Download template": "Vorlage herunterladen",
      "Only CSV, XLS, and XLSX files can be uploaded": "Nur CSV-, XLS- und XLSX-Dateien können hochgeladen werden",
      "Select header row": "Kopfzeilenreihe auswählen",
      "Select the row which contains the column headers": "Wähle die Zeile, die die Spaltenüberschriften enthält",
      "Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.": "Nur das erste Blatt (&quot;{{sheet}}&quot;) der Excel-Datei wird importiert. Um mehrere Blätter zu importieren, lade bitte jedes Blatt einzeln hoch.",
      "Cancel": "Abbrechen",
      "Continue": "Weiter",
      "Your file column": "Deine Spalte der Datei",
      "Your sample data": "Deine Beispieldaten",
      "Destination column": "Zielspalte",
      "Include": "Einfügen",
      "Submit": "Senden",
      "Loading...": "Laden...",
      "Please include all required columns": "Bitte alle erforderlichen Spalten einfügen",
      "Back": "Zurück",
      "- Select one -": "- Wähle eine aus -",
      "- empty -": "- leer -",
      "Import successful": "Import erfolgreich",
      "Upload successful": "Upload erfolgreich",
      "Done": "Fertig",
      "Upload another file": "Eine weitere Datei hochladen",
  };

  var resources = {
      en: {
          translation: {},
      },
      fr: {
          translation: translations$2,
      },
      es: {
          translation: translations$3,
      },
      it: {
          translation: translations$1,
      },
      de: {
          translation: translations,
      },
  };
  instance.use(initReactI18next).init({
      resources: resources,
      lng: "en",
      keySeparator: false,
      interpolation: {
          escapeValue: false,
      },
  });

  /* @license
  Papa Parse
  v5.4.1
  https://github.com/mholt/PapaParse
  License: MIT
  */

  var papaparse_min = createCommonjsModule(function (module, exports) {
  !function(e,t){module.exports=t();}(commonjsGlobal,function s(){var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=f.IS_PAPA_WORKER||!1,a={},u=0,b={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;J(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!J(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var i=function(){if(!b.WORKERS_SUPPORTED)return !1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),b.BLOB_URL||(b.BLOB_URL=r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ","(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=u++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=J(t.step),t.chunk=J(t.chunk),t.complete=J(t.complete),t.error=J(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?(e=function(e){if(65279===e.charCodeAt(0))return e.slice(1);return e}(e),n=t.download?new l(t):new p(t)):!0===e.readable&&J(e.read)&&J(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,r=!1,i=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return -1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");i=t.columns;}void 0!==t.escapeChar&&(a=t.escapeChar+s);("boolean"==typeof t.escapeFormulae||t.escapeFormulae instanceof RegExp)&&(o=t.escapeFormulae instanceof RegExp?t.escapeFormulae:/^[=+\-@\t\r].*$/);}();var u=new RegExp(Q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,r);if("object"==typeof e[0])return h(i||Object.keys(e[0]),e,r)}else if("object"==typeof e)return "string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields||i),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y);}for(var o=0;o<t.length;o++){var u=n?e.length:t[o].length,h=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(h="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<u;l++){var c=s?e[l]:l;d.push(t[o][c]);}h=""===d.join("").trim();}if(!h){for(var p=0;p<u;p++){0<p&&!f&&(i+=m);var g=n&&s?e[p]:p;i+=v(t[o][g],p);}o<t.length-1&&(!r||0<u&&!f)&&(i+=y);}}return i}function v(e,t){if(null==e)return "";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);var r=!1;o&&"string"==typeof e&&o.test(e)&&(e="'"+e,r=!0);var i=e.toString().replace(u,a);return (r=r||!0===n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return !0;return !1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1))?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=r,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},u=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return !0;for(var t=0;t<this.files.length;t++)u.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)});}),e(),this;function e(){if(0!==u.length){var e,t,r,i,n=u[0];if(J(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(J(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void h();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config));}else if("skip"===s)return void h()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){J(a)&&a(e,n.file,n.inputElem),h();},b.parse(n.file,n.instanceConfig);}else J(o.complete)&&o.complete();}function h(){u.splice(0,1),e();}};}function h(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t;}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&J(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r);}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(J(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0;}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!J(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0;},this._sendError=function(e){J(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1});};}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),h.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded();}:function(){this._readChunk();},this.stream=function(e){this._input=e,this._nextChunk();},this._readChunk=function(){if(this._finished)this._chunkLoaded();else {if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)),i.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t]);}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r);}try{i.send(this._config.downloadRequestBody);}catch(e){this._chunkError(e.message);}n&&0===i.status&&this._chunkError();}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:i.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return -1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)));},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t));};}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),h.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)):i=new FileReaderSync,this._nextChunk();},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk();},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t);}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}});},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result);},this._chunkError=function(){this._sendError(i.error);};}function p(e){var r;h.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=r.substring(0,t),r=r.substring(t)):(e=r,r=""),this._finished=!r,this.parseChunk(e)}};}function g(e){h.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){h.prototype.pause.apply(this,arguments),this._input.pause();},this.resume=function(){h.prototype.resume.apply(this,arguments),this._input.resume();},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError);},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0);},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0;},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()));}catch(e){this._streamError(e);}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e);},this),this._streamEnd=v(function(){this._streamCleanUp(),i=!0,this._streamData("");},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError);},this);}function r(m){var a,o,u,i=Math.pow(2,53),n=-i,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,h=/^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,t=this,r=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(J(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else {if(g(),0===c.data.length)return;r+=e.data.length,m.preview&&r>m.preview?o.abort():(c.data=c.data[0],p(c,t));}};}function y(e){return "greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){return c&&u&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),u=!1),m.skipEmptyLines&&(c.data=c.data.filter(function(e){return !y(e)})),_()&&function(){if(!c)return;function e(e,t){J(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e);}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1);}else c.data.forEach(e);}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var r,i=m.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];m.header&&(n=r>=l.length?"__parsed_extra":l[r]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s;}return m.header&&(r>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+r,f+t):r<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+r,f+t)),i}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return r=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[r]&&(m.dynamicTyping[r]=m.dynamicTypingFunction(r)),!0===(m.dynamicTyping[r]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<i)return !0}return !1}(t)?parseFloat(t):h.test(t)?new Date(t):""===t?null:t):t;var r;}function k(e,t,r,i){var n={type:e,code:t,message:r};void 0!==i&&(n.row=i),c.errors.push(n);}this.parse=function(e,t,r){var i=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(Q(t)+"([^]*?)"+Q(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return "\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),u=!1,m.delimiter)J(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else {var n=function(e,t,r,i,n){var s,a,o,u;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var h=0;h<n.length;h++){var f=n[h],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:i,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(r&&y(p.data[g]))c++;else {var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_;}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===u||u<l)&&1.99<l&&(a=d,s=f,u=l);}return {successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(u=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter;}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,r),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=J(m.chunk)?"":a.substring(o.getCharIndex());},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3);},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,J(m.complete)&&m.complete(c),a="";};}function Q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(j){var z,M=(j=j||{}).delimiter,P=j.newline,U=j.comments,q=j.step,N=j.preview,B=j.fastMode,K=z=void 0===j.quoteChar||null===j.quoteChar?'"':j.quoteChar;if(void 0!==j.escapeChar&&(K=j.escapeChar),("string"!=typeof M||-1<b.BAD_DELIMITERS.indexOf(M))&&(M=","),U===M)throw new Error("Comment character same as delimiter");!0===U?U="#":("string"!=typeof U||-1<b.BAD_DELIMITERS.indexOf(U))&&(U=!1),"\n"!==P&&"\r"!==P&&"\r\n"!==P&&(P="\n");var W=0,H=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw new Error("Input must be a string");var n=i.length,e=M.length,s=P.length,a=U.length,o=J(q),u=[],h=[],f=[],d=W=0;if(!i)return L();if(j.header&&!t){var l=i.split(P)[0].split(M),c=[],p={},g=!1;for(var _ in l){var m=l[_];J(j.transformHeader)&&(m=j.transformHeader(m,_));var y=m,v=p[m]||0;for(0<v&&(g=!0,y=m+"_"+v),p[m]=v+1;c.includes(y);)y=y+"_"+v;c.push(y);}if(g){var k=i.split(P);k[0]=c.join(M),i=k.join(P);}}if(B||!1!==B&&-1===i.indexOf(z)){for(var b=i.split(P),E=0;E<b.length;E++){if(f=b[E],W+=f.length,E!==b.length-1)W+=P.length;else if(r)return L();if(!U||f.substring(0,a)!==U){if(o){if(u=[],I(f.split(M)),F(),H)return L()}else I(f.split(M));if(N&&N<=E)return u=u.slice(0,N),L(!0)}}return L()}for(var w=i.indexOf(M,W),R=i.indexOf(P,W),C=new RegExp(Q(K)+Q(z),"g"),S=i.indexOf(z,W);;)if(i[W]!==z)if(U&&0===f.length&&i.substring(W,W+a)===U){if(-1===R)return L();W=R+s,R=i.indexOf(P,W),w=i.indexOf(M,W);}else if(-1!==w&&(w<R||-1===R))f.push(i.substring(W,w)),W=w+e,w=i.indexOf(M,W);else {if(-1===R)break;if(f.push(i.substring(W,R)),D(R+s),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0)}else for(S=W,W++;;){if(-1===(S=i.indexOf(z,S+1)))return r||h.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:u.length,index:W}),T();if(S===n-1)return T(i.substring(W,S).replace(C,z));if(z!==K||i[S+1]!==K){if(z===K||0===S||i[S-1]!==K){-1!==w&&w<S+1&&(w=i.indexOf(M,S+1)),-1!==R&&R<S+1&&(R=i.indexOf(P,S+1));var O=A(-1===R?w:Math.min(w,R));if(i.substr(S+1+O,e)===M){f.push(i.substring(W,S).replace(C,z)),i[W=S+1+O+e]!==z&&(S=i.indexOf(z,W)),w=i.indexOf(M,W),R=i.indexOf(P,W);break}var x=A(R);if(i.substring(S+1+x,S+1+x+s)===P){if(f.push(i.substring(W,S).replace(C,z)),D(S+1+x+s),w=i.indexOf(M,W),S=i.indexOf(z,W),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0);break}h.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:u.length,index:W}),S++;}}else S++;}return T();function I(e){u.push(e),d=W;}function A(e){var t=0;if(-1!==e){var r=i.substring(S+1,e);r&&""===r.trim()&&(t=r.length);}return t}function T(e){return r||(void 0===e&&(e=i.substring(W)),f.push(e),W=n,I(f),o&&F()),L()}function D(e){W=e,I(f),f=[],R=i.indexOf(P,W);}function L(e){return {data:u,errors:h,meta:{delimiter:M,linebreak:P,aborted:H,truncated:!!e,cursor:d+(t||0)}}}function F(){q(L()),u=[],h=[];}},this.abort=function(){H=!0;},this.getCharIndex=function(){return W};}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}});},pause:y,resume:y};if(J(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results;}else J(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results);}t.finished&&!i&&m(t.workerId,t.results);}function m(e,t){var r=a[e];J(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e];}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=w(e[r]);return t}function v(e,t){return function(){e.apply(t,arguments);}}function J(e){return "function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=b.parse(t.input,t.config);r&&f.postMessage({workerId:b.WORKER_ID,results:r,finished:!0});}}),(l.prototype=Object.create(h.prototype)).constructor=l,(c.prototype=Object.create(h.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(h.prototype)).constructor=g,b});
  });

  /*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
  var current_ansi = 1252;

  var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
  /* ECMA-376 Part I 18.4.1 charset to codepage mapping */
  var CS2CP = ({
  	/*::[*/0/*::]*/:    1252, /* ANSI */
  	/*::[*/1/*::]*/:   65001, /* DEFAULT */
  	/*::[*/2/*::]*/:   65001, /* SYMBOL */
  	/*::[*/77/*::]*/:  10000, /* MAC */
  	/*::[*/128/*::]*/:   932, /* SHIFTJIS */
  	/*::[*/129/*::]*/:   949, /* HANGUL */
  	/*::[*/130/*::]*/:  1361, /* JOHAB */
  	/*::[*/134/*::]*/:   936, /* GB2312 */
  	/*::[*/136/*::]*/:   950, /* CHINESEBIG5 */
  	/*::[*/161/*::]*/:  1253, /* GREEK */
  	/*::[*/162/*::]*/:  1254, /* TURKISH */
  	/*::[*/163/*::]*/:  1258, /* VIETNAMESE */
  	/*::[*/177/*::]*/:  1255, /* HEBREW */
  	/*::[*/178/*::]*/:  1256, /* ARABIC */
  	/*::[*/186/*::]*/:  1257, /* BALTIC */
  	/*::[*/204/*::]*/:  1251, /* RUSSIAN */
  	/*::[*/222/*::]*/:   874, /* THAI */
  	/*::[*/238/*::]*/:  1250, /* EASTEUROPE */
  	/*::[*/255/*::]*/:  1252, /* OEM */
  	/*::[*/69/*::]*/:   6969  /* MISC */
  }/*:any*/);

  var set_ansi = function(cp/*:number*/) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
  function reset_ansi() { set_ansi(1252); }

  var set_cp = function(cp/*:number*/) { set_ansi(cp); };
  function reset_cp() { set_cp(1200); reset_ansi(); }

  function char_codes(data/*:string*/)/*:Array<number>*/ { var o/*:Array<number>*/ = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }

  function utf16leread(data/*:string*/)/*:string*/ {
  	var o/*:Array<string>*/ = [];
  	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
  	return o.join("");
  }
  function utf16beread(data/*:string*/)/*:string*/ {
  	var o/*:Array<string>*/ = [];
  	for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
  	return o.join("");
  }

  var debom = function(data/*:string*/)/*:string*/ {
  	var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
  	if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
  	if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
  	if(c1 == 0xFEFF) return data.slice(1);
  	return data;
  };

  var _getchar = function _gc1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };
  var _getansi = function _ga1(x/*:number*/)/*:string*/ { return String.fromCharCode(x); };

  var $cptable;
  var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  function Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for (var i = 0; i < input.length; ) {
      c1 = input.charCodeAt(i++);
      e1 = c1 >> 2;
      c2 = input.charCodeAt(i++);
      e2 = (c1 & 3) << 4 | c2 >> 4;
      c3 = input.charCodeAt(i++);
      e3 = (c2 & 15) << 2 | c3 >> 6;
      e4 = c3 & 63;
      if (isNaN(c2)) {
        e3 = e4 = 64;
      } else if (isNaN(c3)) {
        e4 = 64;
      }
      o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
    }
    return o;
  }
  function Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    input = input.replace(/[^\w\+\/\=]/g, "");
    for (var i = 0; i < input.length; ) {
      e1 = Base64_map.indexOf(input.charAt(i++));
      e2 = Base64_map.indexOf(input.charAt(i++));
      c1 = e1 << 2 | e2 >> 4;
      o += String.fromCharCode(c1);
      e3 = Base64_map.indexOf(input.charAt(i++));
      c2 = (e2 & 15) << 4 | e3 >> 2;
      if (e3 !== 64) {
        o += String.fromCharCode(c2);
      }
      e4 = Base64_map.indexOf(input.charAt(i++));
      c3 = (e3 & 3) << 6 | e4;
      if (e4 !== 64) {
        o += String.fromCharCode(c3);
      }
    }
    return o;
  }
  var has_buf = /*#__PURE__*/(function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();

  var Buffer_from = /*#__PURE__*/(function() {
  	if(typeof Buffer !== 'undefined') {
  		var nbfs = !Buffer.from;
  		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
  		return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
  	}
  	return function() {};
  })();


  function new_raw_buf(len/*:number*/) {
  	/* jshint -W056 */
  	if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
  	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
  	/* jshint +W056 */
  }

  function new_unsafe_buf(len/*:number*/) {
  	/* jshint -W056 */
  	if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
  	return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
  	/* jshint +W056 */
  }

  var s2a = function s2a(s/*:string*/)/*:any*/ {
  	if(has_buf) return Buffer_from(s, "binary");
  	return s.split("").map(function(x/*:string*/)/*:number*/{ return x.charCodeAt(0) & 0xff; });
  };

  function a2s(data/*:any*/)/*:string*/ {
  	if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
  	var o/*:Array<string>*/ = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
  }

  function ab2a(data/*:ArrayBuffer|Uint8Array*/)/*:Array<number>*/ {
  	if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
  	if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
  	/*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */
  	var o = new Array(data.length);
  	for(var i = 0; i < data.length; ++i) o[i] = data[i];
  	return o;
  }

  var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
  	if(typeof Uint8Array !== "undefined") {
  		var i = 0, maxlen = 0;
  		for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
  		var o = new Uint8Array(maxlen);
  		var len = 0;
  		for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
  			len = bufs[i].length;
  			if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
  			else if(typeof bufs[i] == "string") { throw "wtf"; }
  			else o.set(new Uint8Array(bufs[i]), maxlen);
  		}
  		return o;
  	}
  	return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
  };

  function utf8decode(content/*:string*/) {
  	var out = [], widx = 0, L = content.length + 250;
  	var o = new_raw_buf(content.length + 255);
  	for(var ridx = 0; ridx < content.length; ++ridx) {
  		var c = content.charCodeAt(ridx);
  		if(c < 0x80) o[widx++] = c;
  		else if(c < 0x800) {
  			o[widx++] = (192|((c>>6)&31));
  			o[widx++] = (128|(c&63));
  		} else if(c >= 0xD800 && c < 0xE000) {
  			c = (c&1023)+64;
  			var d = content.charCodeAt(++ridx)&1023;
  			o[widx++] = (240|((c>>8)&7));
  			o[widx++] = (128|((c>>2)&63));
  			o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
  			o[widx++] = (128|(d&63));
  		} else {
  			o[widx++] = (224|((c>>12)&15));
  			o[widx++] = (128|((c>>6)&63));
  			o[widx++] = (128|(c&63));
  		}
  		if(widx > L) {
  			out.push(o.slice(0, widx));
  			widx = 0;
  			o = new_raw_buf(65535);
  			L = 65530;
  		}
  	}
  	out.push(o.slice(0, widx));
  	return bconcat(out);
  }

  var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
  /*::
  declare type Block = any;
  declare type BufArray = {
  	newblk(sz:number):Block;
  	next(sz:number):Block;
  	end():any;
  	push(buf:Block):void;
  };

  type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

  type EvertType = {[string]:string};
  type EvertNumType = {[string]:number};
  type EvertArrType = {[string]:Array<string>};

  type StringConv = {(string):string};

  */
  /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
  /*jshint -W041 */
  function _strrev(x/*:string*/)/*:string*/ { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
  function pad0(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
  function pad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
  function rpad_(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
  function pad0r1(v/*:any*/,d/*:number*/)/*:string*/{var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
  function pad0r2(v/*:any*/,d/*:number*/)/*:string*/{var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
  var p2_32 = /*#__PURE__*/Math.pow(2,32);
  function pad0r(v/*:any*/,d/*:number*/)/*:string*/{if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
  /* yes, in 2022 this is still faster than string compare */
  function SSF_isgeneral(s/*:string*/, i/*:?number*/)/*:boolean*/ { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
  var days/*:Array<Array<string> >*/ = [
  	['Sun', 'Sunday'],
  	['Mon', 'Monday'],
  	['Tue', 'Tuesday'],
  	['Wed', 'Wednesday'],
  	['Thu', 'Thursday'],
  	['Fri', 'Friday'],
  	['Sat', 'Saturday']
  ];
  var months/*:Array<Array<string> >*/ = [
  	['J', 'Jan', 'January'],
  	['F', 'Feb', 'February'],
  	['M', 'Mar', 'March'],
  	['A', 'Apr', 'April'],
  	['M', 'May', 'May'],
  	['J', 'Jun', 'June'],
  	['J', 'Jul', 'July'],
  	['A', 'Aug', 'August'],
  	['S', 'Sep', 'September'],
  	['O', 'Oct', 'October'],
  	['N', 'Nov', 'November'],
  	['D', 'Dec', 'December']
  ];
  function SSF_init_table(t/*:any*/) {
  	if(!t) t = {};
  	t[0]=  'General';
  	t[1]=  '0';
  	t[2]=  '0.00';
  	t[3]=  '#,##0';
  	t[4]=  '#,##0.00';
  	t[9]=  '0%';
  	t[10]= '0.00%';
  	t[11]= '0.00E+00';
  	t[12]= '# ?/?';
  	t[13]= '# ??/??';
  	t[14]= 'm/d/yy';
  	t[15]= 'd-mmm-yy';
  	t[16]= 'd-mmm';
  	t[17]= 'mmm-yy';
  	t[18]= 'h:mm AM/PM';
  	t[19]= 'h:mm:ss AM/PM';
  	t[20]= 'h:mm';
  	t[21]= 'h:mm:ss';
  	t[22]= 'm/d/yy h:mm';
  	t[37]= '#,##0 ;(#,##0)';
  	t[38]= '#,##0 ;[Red](#,##0)';
  	t[39]= '#,##0.00;(#,##0.00)';
  	t[40]= '#,##0.00;[Red](#,##0.00)';
  	t[45]= 'mm:ss';
  	t[46]= '[h]:mm:ss';
  	t[47]= 'mmss.0';
  	t[48]= '##0.0E+0';
  	t[49]= '@';
  	t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
  	return t;
  }
  /* repeated to satiate webpack */
  var table_fmt = {
  	0:  'General',
  	1:  '0',
  	2:  '0.00',
  	3:  '#,##0',
  	4:  '#,##0.00',
  	9:  '0%',
  	10: '0.00%',
  	11: '0.00E+00',
  	12: '# ?/?',
  	13: '# ??/??',
  	14: 'm/d/yy',
  	15: 'd-mmm-yy',
  	16: 'd-mmm',
  	17: 'mmm-yy',
  	18: 'h:mm AM/PM',
  	19: 'h:mm:ss AM/PM',
  	20: 'h:mm',
  	21: 'h:mm:ss',
  	22: 'm/d/yy h:mm',
  	37: '#,##0 ;(#,##0)',
  	38: '#,##0 ;[Red](#,##0)',
  	39: '#,##0.00;(#,##0.00)',
  	40: '#,##0.00;[Red](#,##0.00)',
  	45: 'mm:ss',
  	46: '[h]:mm:ss',
  	47: 'mmss.0',
  	48: '##0.0E+0',
  	49: '@',
  	56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
  };

  /* Defaults determined by systematically testing in Excel 2019 */

  /* These formats appear to default to other formats in the table */
  var SSF_default_map = {
  	5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40

  	23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0

  	27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14

  	50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
  	55: 14, 56: 14, 57: 14, 58: 14,
  	59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4

  	67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
  	69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
  	72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
  	76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
  	79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
  	82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
  };


  /* These formats technically refer to Accounting formats with no equivalent */
  var SSF_default_str = {
  	//  5 -- Currency,   0 decimal, black negative
  	5:  '"$"#,##0_);\\("$"#,##0\\)',
  	63: '"$"#,##0_);\\("$"#,##0\\)',

  	//  6 -- Currency,   0 decimal, red   negative
  	6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
  	64: '"$"#,##0_);[Red]\\("$"#,##0\\)',

  	//  7 -- Currency,   2 decimal, black negative
  	7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
  	65: '"$"#,##0.00_);\\("$"#,##0.00\\)',

  	//  8 -- Currency,   2 decimal, red   negative
  	8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  	66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',

  	// 41 -- Accounting, 0 decimal, No Symbol
  	41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',

  	// 42 -- Accounting, 0 decimal, $  Symbol
  	42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',

  	// 43 -- Accounting, 2 decimal, No Symbol
  	43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',

  	// 44 -- Accounting, 2 decimal, $  Symbol
  	44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
  };

  function SSF_frac(x/*:number*/, D/*:number*/, mixed/*:?boolean*/)/*:Array<number>*/ {
  	var sgn = x < 0 ? -1 : 1;
  	var B = x * sgn;
  	var P_2 = 0, P_1 = 1, P = 0;
  	var Q_2 = 1, Q_1 = 0, Q = 0;
  	var A = Math.floor(B);
  	while(Q_1 < D) {
  		A = Math.floor(B);
  		P = A * P_1 + P_2;
  		Q = A * Q_1 + Q_2;
  		if((B - A) < 0.00000005) break;
  		B = 1 / (B - A);
  		P_2 = P_1; P_1 = P;
  		Q_2 = Q_1; Q_1 = Q;
  	}
  	if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
  	if(!mixed) return [0, sgn * P, Q];
  	var q = Math.floor(sgn * P/Q);
  	return [q, sgn*P - q*Q, Q];
  }
  function SSF_parse_date_code(v/*:number*/,opts/*:?any*/,b2/*:?boolean*/) {
  	if(v > 2958465 || v < 0) return null;
  	var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
  	var dout=[];
  	var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
  	if(Math.abs(out.u) < 1e-6) out.u = 0;
  	if(opts && opts.date1904) date += 1462;
  	if(out.u > 0.9999) {
  		out.u = 0;
  		if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
  	}
  	if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
  	else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
  	else {
  		if(date > 60) --date;
  		/* 1 = Jan 1 1900 in Gregorian */
  		var d = new Date(1900, 0, 1);
  		d.setDate(d.getDate() + date - 1);
  		dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
  		dow = d.getDay();
  		if(date < 60) dow = (dow + 6) % 7;
  		if(b2) dow = SSF_fix_hijri(d, dout);
  	}
  	out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
  	out.S = time % 60; time = Math.floor(time / 60);
  	out.M = time % 60; time = Math.floor(time / 60);
  	out.H = time;
  	out.q = dow;
  	return out;
  }
  var SSFbasedate = /*#__PURE__*/new Date(1899, 11, 31, 0, 0, 0);
  var SSFdnthresh = /*#__PURE__*/SSFbasedate.getTime();
  var SSFbase1904 = /*#__PURE__*/new Date(1900, 2, 1, 0, 0, 0);
  function datenum_local(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
  	var epoch = /*#__PURE__*/v.getTime();
  	if(date1904) epoch -= 1461*24*60*60*1000;
  	else if(v >= SSFbase1904) epoch += 24*60*60*1000;
  	return (epoch - (SSFdnthresh + (/*#__PURE__*/v.getTimezoneOffset() - /*#__PURE__*/SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
  }
  /* ECMA-376 18.8.30 numFmt*/
  /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
  /* exponent >= -9 and <= 9 */
  function SSF_strip_decimal(o/*:string*/)/*:string*/ {
  	return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
  }

  /* General Exponential always shows 2 digits exp and trims the mantissa */
  function SSF_normalize_exp(o/*:string*/)/*:string*/ {
  	if(o.indexOf("E") == -1) return o;
  	return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
  }

  /* exponent >= -9 and <= 9 */
  function SSF_small_exp(v/*:number*/)/*:string*/ {
  	var w = (v<0?12:11);
  	var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
  	o = v.toPrecision(10); if(o.length <= w) return o;
  	return v.toExponential(5);
  }

  /* exponent >= 11 or <= -10 likely exponential */
  function SSF_large_exp(v/*:number*/)/*:string*/ {
  	var o = SSF_strip_decimal(v.toFixed(11));
  	return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
  }

  function SSF_general_num(v/*:number*/)/*:string*/ {
  	var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;

  	if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
  	else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
  	else if(V === 10) o = v.toFixed(10).substr(0,12);
  	else o = SSF_large_exp(v);

  	return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
  }


  /*
  	"General" rules:
  	- text is passed through ("@")
  	- booleans are rendered as TRUE/FALSE
  	- "up to 11 characters" displayed for numbers
  	- Default date format (code 14) used for Dates

  	The longest 32-bit integer text is "-2147483648", exactly 11 chars
  	TODO: technically the display depends on the width of the cell
  */
  function SSF_general(v/*:any*/, opts/*:any*/) {
  	switch(typeof v) {
  		case 'string': return v;
  		case 'boolean': return v ? "TRUE" : "FALSE";
  		case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
  		case 'undefined': return "";
  		case 'object':
  			if(v == null) return "";
  			if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
  	}
  	throw new Error("unsupported value in General format: " + v);
  }

  function SSF_fix_hijri(date/*:Date*/, o/*:[number, number, number]*/) {
    /* TODO: properly adjust y/m/d and  */
    o[0] -= 581;
    var dow = date.getDay();
    if(date < 60) dow = (dow + 6) % 7;
    return dow;
  }
  //var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
  function SSF_write_date(type/*:number*/, fmt/*:string*/, val, ss0/*:?number*/)/*:string*/ {
  	var o="", ss=0, tt=0, y = val.y, out, outl = 0;
  	switch(type) {
  		case 98: /* 'b' buddhist year */
  			y = val.y + 543;
  			/* falls through */
  		case 121: /* 'y' year */
  		switch(fmt.length) {
  			case 1: case 2: out = y % 100; outl = 2; break;
  			default: out = y % 10000; outl = 4; break;
  		} break;
  		case 109: /* 'm' month */
  		switch(fmt.length) {
  			case 1: case 2: out = val.m; outl = fmt.length; break;
  			case 3: return months[val.m-1][1];
  			case 5: return months[val.m-1][0];
  			default: return months[val.m-1][2];
  		} break;
  		case 100: /* 'd' day */
  		switch(fmt.length) {
  			case 1: case 2: out = val.d; outl = fmt.length; break;
  			case 3: return days[val.q][0];
  			default: return days[val.q][1];
  		} break;
  		case 104: /* 'h' 12-hour */
  		switch(fmt.length) {
  			case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
  			default: throw 'bad hour format: ' + fmt;
  		} break;
  		case 72: /* 'H' 24-hour */
  		switch(fmt.length) {
  			case 1: case 2: out = val.H; outl = fmt.length; break;
  			default: throw 'bad hour format: ' + fmt;
  		} break;
  		case 77: /* 'M' minutes */
  		switch(fmt.length) {
  			case 1: case 2: out = val.M; outl = fmt.length; break;
  			default: throw 'bad minute format: ' + fmt;
  		} break;
  		case 115: /* 's' seconds */
  			if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
  			if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
  			/*::if(!ss0) ss0 = 0; */
  			if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
  			else tt = ss0 === 1 ? 10 : 1;
  			ss = Math.round((tt)*(val.S + val.u));
  			if(ss >= 60*tt) ss = 0;
  			if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
  			o = pad0(ss,2 + ss0);
  			if(fmt === 'ss') return o.substr(0,2);
  			return "." + o.substr(2,fmt.length-1);
  		case 90: /* 'Z' absolute time */
  		switch(fmt) {
  			case '[h]': case '[hh]': out = val.D*24+val.H; break;
  			case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
  			case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
  			default: throw 'bad abstime format: ' + fmt;
  		} outl = fmt.length === 3 ? 1 : 2; break;
  		case 101: /* 'e' era */
  			out = y; outl = 1; break;
  	}
  	var outstr = outl > 0 ? pad0(out, outl) : "";
  	return outstr;
  }


  /*jshint -W086 */
  /*jshint +W086 */
  function commaify(s/*:string*/)/*:string*/ {
  	var w = 3;
  	if(s.length <= w) return s;
  	var j = (s.length % w), o = s.substr(0,j);
  	for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
  	return o;
  }
  var pct1 = /%/g;
  function write_num_pct(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
  	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
  	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
  }

  function write_num_cm(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
  	var idx = fmt.length - 1;
  	while(fmt.charCodeAt(idx-1) === 44) --idx;
  	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
  }

  function write_num_exp(fmt/*:string*/, val/*:number*/)/*:string*/{
  	var o/*:string*/;
  	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
  	if(fmt.match(/^#+0.0E\+0$/)) {
  		if(val == 0) return "0.0E+0";
  		else if(val < 0) return "-" + write_num_exp(fmt, -val);
  		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
  		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
  		if(ee < 0) ee += period;
  		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
  		if(o.indexOf("e") === -1) {
  			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
  			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
  			else o += "E+" + (fakee - ee);
  			while(o.substr(0,2) === "0.") {
  				o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
  				o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
  			}
  			o = o.replace(/\+-/,"-");
  		}
  		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
  	} else o = val.toExponential(idx);
  	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
  	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
  	return o.replace("e","E");
  }
  var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
  function write_num_f1(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
  	var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
  	var myn = (rr - base*den), myd = den;
  	return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
  }
  function write_num_f2(r/*:Array<string>*/, aval/*:number*/, sign/*:string*/)/*:string*/ {
  	return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
  }
  var dec1 = /^#*0*\.([0#]+)/;
  var closeparen = /\).*[0#]/;
  var phone = /\(###\) ###\\?-####/;
  function hashq(str/*:string*/)/*:string*/ {
  	var o = "", cc;
  	for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
  		case 35: break;
  		case 63: o+= " "; break;
  		case 48: o+= "0"; break;
  		default: o+= String.fromCharCode(cc);
  	}
  	return o;
  }
  function rnd(val/*:number*/, d/*:number*/)/*:string*/ { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
  function dec(val/*:number*/, d/*:number*/)/*:number*/ {
  	var _frac = val - Math.floor(val), dd = Math.pow(10,d);
  	if (d < ('' + Math.round(_frac * dd)).length) return 0;
  	return Math.round(_frac * dd);
  }
  function carry(val/*:number*/, d/*:number*/)/*:number*/ {
  	if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
  		return 1;
  	}
  	return 0;
  }
  function flr(val/*:number*/)/*:string*/ {
  	if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
  	return ""+Math.floor(val);
  }
  function write_num_flt(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
  	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
  		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
  		if(val >= 0) return write_num_flt('n', ffmt, val);
  		return '(' + write_num_flt('n', ffmt, -val) + ')';
  	}
  	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
  	if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
  	if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
  	if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
  	var o;
  	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
  	if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
  	if(fmt.match(/^[#?]+$/)) {
  		o = pad0r(val,0); if(o === "0") o = "";
  		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
  	}
  	if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
  	if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
  	if((r = fmt.match(dec1))) {
  		o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(/*::(*/r/*::||[""])*/[1]).length-$1.length); });
  		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
  	}
  	fmt = fmt.replace(/^#+([0.])/, "$1");
  	if((r = fmt.match(/^(0*)\.(#*)$/))) {
  		return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
  	}
  	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
  	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
  		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
  	}
  	if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
  	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
  		o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
  		ri = 0;
  		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
  	}
  	if(fmt.match(phone)) {
  		o = write_num_flt(type, "##########", val);
  		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
  	}
  	var oa = "";
  	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
  		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
  		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
  		o = "" + sign;
  		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
  		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
  		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
  		oa = rpad_(ff[2],ri);
  		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
  		o += oa;
  		return o;
  	}
  	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
  		ri = Math.min(Math.max(r[1].length, r[4].length),7);
  		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
  		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
  	}
  	if((r = fmt.match(/^[#0?]+$/))) {
  		o = pad0r(val, 0);
  		if(fmt.length <= o.length) return o;
  		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
  	}
  	if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
  		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
  		ri = o.indexOf(".");
  		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
  		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
  	}
  	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
  		ri = dec(val, r[1].length);
  		return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
  	}
  	switch(fmt) {
  		case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
  		case "###,###":
  		case "##,###":
  		case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
  		case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
  		case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
  	}
  	throw new Error("unsupported format |" + fmt + "|");
  }
  function write_num_cm2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
  	var idx = fmt.length - 1;
  	while(fmt.charCodeAt(idx-1) === 44) --idx;
  	return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
  }
  function write_num_pct2(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/{
  	var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
  	return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
  }
  function write_num_exp2(fmt/*:string*/, val/*:number*/)/*:string*/{
  	var o/*:string*/;
  	var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
  	if(fmt.match(/^#+0.0E\+0$/)) {
  		if(val == 0) return "0.0E+0";
  		else if(val < 0) return "-" + write_num_exp2(fmt, -val);
  		var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
  		var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
  		if(ee < 0) ee += period;
  		o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
  		if(!o.match(/[Ee]/)) {
  			var fakee = Math.floor(Math.log(val)*Math.LOG10E);
  			if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
  			else o += "E+" + (fakee - ee);
  			o = o.replace(/\+-/,"-");
  		}
  		o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
  	} else o = val.toExponential(idx);
  	if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
  	if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
  	return o.replace("e","E");
  }
  function write_num_int(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
  	if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
  		var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
  		if(val >= 0) return write_num_int('n', ffmt, val);
  		return '(' + write_num_int('n', ffmt, -val) + ')';
  	}
  	if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
  	if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
  	if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
  	if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
  	var o;
  	var r/*:?Array<string>*/, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
  	if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
  	if(fmt.match(/^[#?]+$/)) {
  		o = (""+val); if(val === 0) o = "";
  		return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
  	}
  	if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
  	if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
  	if((r = fmt.match(dec1))) {
  		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
  		o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
  		o = o.replace(/\.(\d*)$/,function($$, $1) {
  		/*:: if(!Array.isArray(r)) throw new Error("unreachable"); */
  			return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
  		return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
  	}
  	fmt = fmt.replace(/^#+([0.])/, "$1");
  	if((r = fmt.match(/^(0*)\.(#*)$/))) {
  		return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
  	}
  	if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
  	if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
  		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
  	}
  	if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
  	if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
  		o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
  		ri = 0;
  		return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
  	}
  	if(fmt.match(phone)) {
  		o = write_num_int(type, "##########", val);
  		return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
  	}
  	var oa = "";
  	if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
  		ri = Math.min(/*::String(*/r[4]/*::)*/.length,7);
  		ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
  		o = "" + sign;
  		oa = write_num("n", /*::String(*/r[1]/*::)*/, ff[1]);
  		if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
  		o += oa + /*::String(*/r[2]/*::)*/ + "/" + /*::String(*/r[3]/*::)*/;
  		oa = rpad_(ff[2],ri);
  		if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
  		o += oa;
  		return o;
  	}
  	if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
  		ri = Math.min(Math.max(r[1].length, r[4].length),7);
  		ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
  		return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
  	}
  	if((r = fmt.match(/^[#0?]+$/))) {
  		o = "" + val;
  		if(fmt.length <= o.length) return o;
  		return hashq(fmt.substr(0,fmt.length-o.length)) + o;
  	}
  	if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
  		o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
  		ri = o.indexOf(".");
  		var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
  		return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
  	}
  	if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
  		return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
  	}
  	switch(fmt) {
  		case "###,###":
  		case "##,###":
  		case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
  		default:
  			if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
  	}
  	throw new Error("unsupported format |" + fmt + "|");
  }
  function write_num(type/*:string*/, fmt/*:string*/, val/*:number*/)/*:string*/ {
  	return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
  }
  function SSF_split_fmt(fmt/*:string*/)/*:Array<string>*/ {
  	var out/*:Array<string>*/ = [];
  	var in_str = false/*, cc*/;
  	for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
  		case 34: /* '"' */
  			in_str = !in_str; break;
  		case 95: case 42: case 92: /* '_' '*' '\\' */
  			++i; break;
  		case 59: /* ';' */
  			out[out.length] = fmt.substr(j,i-j);
  			j = i+1;
  	}
  	out[out.length] = fmt.substr(j);
  	if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
  	return out;
  }

  var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
  function fmt_is_date(fmt/*:string*/)/*:boolean*/ {
  	var i = 0, /*cc = 0,*/ c = "", o = "";
  	while(i < fmt.length) {
  		switch((c = fmt.charAt(i))) {
  			case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
  			case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
  			case '\\': i+=2; break;
  			case '_': i+=2; break;
  			case '@': ++i; break;
  			case 'B': case 'b':
  				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
  				/* falls through */
  			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
  				/* falls through */
  			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
  			case 'A': case 'a': case '上':
  				if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
  				if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
  				if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
  				++i; break;
  			case '[':
  				o = c;
  				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
  				if(o.match(SSF_abstime)) return true;
  				break;
  			case '.':
  				/* falls through */
  			case '0': case '#':
  				while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
  				break;
  			case '?': while(fmt.charAt(++i) === c){/* empty */} break;
  			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
  			case '(': case ')': ++i; break;
  			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
  				while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
  			case ' ': ++i; break;
  			default: ++i; break;
  		}
  	}
  	return false;
  }

  function eval_fmt(fmt/*:string*/, v/*:any*/, opts/*:any*/, flen/*:number*/) {
  	var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
  	var hr='H';
  	/* Tokenize */
  	while(i < fmt.length) {
  		switch((c = fmt.charAt(i))) {
  			case 'G': /* General */
  				if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
  				out[out.length] = {t:'G', v:'General'}; i+=7; break;
  			case '"': /* Literal text */
  				for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
  				out[out.length] = {t:'t', v:o}; ++i; break;
  			case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
  				out[out.length] = {t:t, v:w}; ++i; break;
  			case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
  			case '@': /* Text Placeholder */
  				out[out.length] = {t:'T', v:v}; ++i; break;
  			case 'B': case 'b':
  				if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
  					if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
  					out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
  				}
  				/* falls through */
  			case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
  				c = c.toLowerCase();
  				/* falls through */
  			case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
  				if(v < 0) return "";
  				if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
  				o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
  				if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
  				if(c === 'h') c = hr;
  				out[out.length] = {t:c, v:o}; lst = c; break;
  			case 'A': case 'a': case '上':
  				var q={t:c, v:c};
  				if(dt==null) dt=SSF_parse_date_code(v, opts);
  				if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
  				else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
  				else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
  				else { q.t = "t"; ++i; }
  				if(dt==null && q.t === 'T') return "";
  				out[out.length] = q; lst = c; break;
  			case '[':
  				o = c;
  				while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
  				if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
  				if(o.match(SSF_abstime)) {
  					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
  					out[out.length] = {t:'Z', v:o.toLowerCase()};
  					lst = o.charAt(1);
  				} else if(o.indexOf("$") > -1) {
  					o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
  					if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
  				}
  				break;
  			/* Numbers */
  			case '.':
  				if(dt != null) {
  					o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
  					out[out.length] = {t:'s', v:o}; break;
  				}
  				/* falls through */
  			case '0': case '#':
  				o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
  				out[out.length] = {t:'n', v:o}; break;
  			case '?':
  				o = c; while(fmt.charAt(++i) === c) o+=c;
  				out[out.length] = {t:c, v:o}; lst = c; break;
  			case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
  			case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
  			case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
  				o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
  				out[out.length] = {t:'D', v:o}; break;
  			case ' ': out[out.length] = {t:c, v:c}; ++i; break;
  			case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
  			default:
  				if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
  				out[out.length] = {t:'t', v:c}; ++i; break;
  		}
  	}

  	/* Scan for date/time parts */
  	var bt = 0, ss0 = 0, ssm;
  	for(i=out.length-1, lst='t'; i >= 0; --i) {
  		switch(out[i].t) {
  			case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
  			case 's':
  				if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
  				if(bt < 3) bt = 3;
  			/* falls through */
  			case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
  			case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
  			case 'X': /*if(out[i].v === "B2");*/
  				break;
  			case 'Z':
  				if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
  				if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
  				if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
  		}
  	}
  	/* time rounding depends on presence of minute / second / usec fields */
  	switch(bt) {
  		case 0: break;
  		case 1:
  			/*::if(!dt) break;*/
  			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
  			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
  			if(dt.M >=  60) { dt.M = 0; ++dt.H; }
  			break;
  		case 2:
  			/*::if(!dt) break;*/
  			if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
  			if(dt.S >=  60) { dt.S = 0; ++dt.M; }
  			break;
  	}

  	/* replace fields */
  	var nstr = "", jj;
  	for(i=0; i < out.length; ++i) {
  		switch(out[i].t) {
  			case 't': case 'T': case ' ': case 'D': break;
  			case 'X': out[i].v = ""; out[i].t = ";"; break;
  			case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
  				/*::if(!dt) throw "unreachable"; */
  				out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
  				out[i].t = 't'; break;
  			case 'n': case '?':
  				jj = i+1;
  				while(out[jj] != null && (
  					(c=out[jj].t) === "?" || c === "D" ||
  					((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
  					(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
  					(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
  				)) {
  					out[i].v += out[jj].v;
  					out[jj] = {v:"", t:";"}; ++jj;
  				}
  				nstr += out[i].v;
  				i = jj-1; break;
  			case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
  		}
  	}
  	var vv = "", myv, ostr;
  	if(nstr.length > 0) {
  		if(nstr.charCodeAt(0) == 40) /* '(' */ {
  			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
  			ostr = write_num('n', nstr, myv);
  		} else {
  			myv = (v<0 && flen > 1 ? -v : v);
  			ostr = write_num('n', nstr, myv);
  			if(myv < 0 && out[0] && out[0].t == 't') {
  				ostr = ostr.substr(1);
  				out[0].v = "-" + out[0].v;
  			}
  		}
  		jj=ostr.length-1;
  		var decpt = out.length;
  		for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
  		var lasti=out.length;
  		if(decpt === out.length && ostr.indexOf("E") === -1) {
  			for(i=out.length-1; i>= 0;--i) {
  				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
  				if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
  				else if(jj < 0) out[i].v = "";
  				else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
  				out[i].t = 't';
  				lasti = i;
  			}
  			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
  		}
  		else if(decpt !== out.length && ostr.indexOf("E") === -1) {
  			jj = ostr.indexOf(".")-1;
  			for(i=decpt; i>= 0; --i) {
  				if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
  				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
  				vv = out[i].v.substr(j+1);
  				for(; j>=0; --j) {
  					if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
  				}
  				out[i].v = vv;
  				out[i].t = 't';
  				lasti = i;
  			}
  			if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
  			jj = ostr.indexOf(".")+1;
  			for(i=decpt; i<out.length; ++i) {
  				if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
  				j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
  				vv = out[i].v.substr(0,j);
  				for(; j<out[i].v.length; ++j) {
  					if(jj<ostr.length) vv += ostr.charAt(jj++);
  				}
  				out[i].v = vv;
  				out[i].t = 't';
  				lasti = i;
  			}
  		}
  	}
  	for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
  		myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
  		out[i].v = write_num(out[i].t, out[i].v, myv);
  		out[i].t = 't';
  	}
  	var retval = "";
  	for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
  	return retval;
  }

  var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
  function chkcond(v, rr) {
  	if(rr == null) return false;
  	var thresh = parseFloat(rr[2]);
  	switch(rr[1]) {
  		case "=":  if(v == thresh) return true; break;
  		case ">":  if(v >  thresh) return true; break;
  		case "<":  if(v <  thresh) return true; break;
  		case "<>": if(v != thresh) return true; break;
  		case ">=": if(v >= thresh) return true; break;
  		case "<=": if(v <= thresh) return true; break;
  	}
  	return false;
  }
  function choose_fmt(f/*:string*/, v/*:any*/) {
  	var fmt = SSF_split_fmt(f);
  	var l = fmt.length, lat = fmt[l-1].indexOf("@");
  	if(l<4 && lat>-1) --l;
  	if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
  	if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
  	switch(fmt.length) {
  		case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
  		case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
  		case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
  	}
  	var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
  	if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
  	if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
  		var m1 = fmt[0].match(cfregex2);
  		var m2 = fmt[1].match(cfregex2);
  		return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
  	}
  	return [l, ff];
  }
  function SSF_format(fmt/*:string|number*/,v/*:any*/,o/*:?any*/) {
  	if(o == null) o = {};
  	var sfmt = "";
  	switch(typeof fmt) {
  		case "string":
  			if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
  			else sfmt = fmt;
  			break;
  		case "number":
  			if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
  			else sfmt = (o.table != null ? (o.table/*:any*/) : table_fmt)[fmt];
  			if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
  			if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
  			break;
  	}
  	if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
  	if(v instanceof Date) v = datenum_local(v, o.date1904);
  	var f = choose_fmt(sfmt, v);
  	if(SSF_isgeneral(f[1])) return SSF_general(v, o);
  	if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
  	else if(v === "" || v == null) return "";
  	return eval_fmt(f[1], v, o, f[0]);
  }
  function SSF_load(fmt/*:string*/, idx/*:?number*/)/*:number*/ {
  	if(typeof idx != 'number') {
  		idx = +idx || -1;
  /*::if(typeof idx != 'number') return 0x188; */
  		for(var i = 0; i < 0x0188; ++i) {
  /*::if(typeof idx != 'number') return 0x188; */
  			if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
  			if(table_fmt[i] == fmt) { idx = i; break; }
  		}
  /*::if(typeof idx != 'number') return 0x188; */
  		if(idx < 0) idx = 0x187;
  	}
  /*::if(typeof idx != 'number') return 0x188; */
  	table_fmt[idx] = fmt;
  	return idx;
  }

  function make_ssf() {
  	table_fmt = SSF_init_table();
  }

  var SSFImplicit/*{[number]:string}*/ = ({
  	"5": '"$"#,##0_);\\("$"#,##0\\)',
  	"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
  	"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
  	"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  	"23": 'General', "24": 'General', "25": 'General', "26": 'General',
  	"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
  	"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
  	"36": 'm/d/yy',
  	"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
  	"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
  	"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
  	"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
  	"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
  	"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
  	"59": '0',
  	"60": '0.00',
  	"61": '#,##0',
  	"62": '#,##0.00',
  	"63": '"$"#,##0_);\\("$"#,##0\\)',
  	"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
  	"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
  	"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  	"67": '0%',
  	"68": '0.00%',
  	"69": '# ?/?',
  	"70": '# ??/??',
  	"71": 'm/d/yy',
  	"72": 'm/d/yy',
  	"73": 'd-mmm-yy',
  	"74": 'd-mmm',
  	"75": 'mmm-yy',
  	"76": 'h:mm',
  	"77": 'h:mm:ss',
  	"78": 'm/d/yy h:mm',
  	"79": 'mm:ss',
  	"80": '[h]:mm:ss',
  	"81": 'mmss.0'
  }/*:any*/);

  /* dateNF parse TODO: move to SSF */
  var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
  function dateNF_regex(dateNF/*:string|number*/)/*:RegExp*/ {
  	var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
  	fmt = fmt.replace(dateNFregex, "(\\d+)");
  	return new RegExp("^" + fmt + "$");
  }
  function dateNF_fix(str/*:string*/, dateNF/*:string*/, match/*:Array<string>*/)/*:string*/ {
  	var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
  	(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
  		var v = parseInt(match[i+1], 10);
  		switch(n.toLowerCase().charAt(0)) {
  			case 'y': Y = v; break; case 'd': d = v; break;
  			case 'h': H = v; break; case 's': S = v; break;
  			case 'm': if(H >= 0) M = v; else m = v; break;
  		}
  	});
  	if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
  	var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
  	if(datestr.length == 7) datestr = "0" + datestr;
  	if(datestr.length == 8) datestr = "20" + datestr;
  	var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
  	if(H == -1 && M == -1 && S == -1) return datestr;
  	if(Y == -1 && m == -1 && d == -1) return timestr;
  	return datestr + "T" + timestr;
  }

  /*::
  declare var ReadShift:any;
  declare var CheckField:any;
  declare var prep_blob:any;
  declare var __readUInt32LE:any;
  declare var __readInt32LE:any;
  declare var __toBuffer:any;
  declare var __utf16le:any;
  declare var bconcat:any;
  declare var s2a:any;
  declare var chr0:any;
  declare var chr1:any;
  declare var has_buf:boolean;
  declare var new_buf:any;
  declare var new_raw_buf:any;
  declare var new_unsafe_buf:any;
  declare var Buffer_from:any;
  */
  /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
  /* vim: set ts=2: */
  /*jshint eqnull:true */
  /*exported CFB */
  /*global Uint8Array:false, Uint16Array:false */

  /*::
  type SectorEntry = {
  	name?:string;
  	nodes?:Array<number>;
  	data:RawBytes;
  };
  type SectorList = {
  	[k:string|number]:SectorEntry;
  	name:?string;
  	fat_addrs:Array<number>;
  	ssz:number;
  }
  type CFBFiles = {[n:string]:CFBEntry};
  */
  /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
  /* vim: set ts=2: */
  /*exported CRC32 */
  var CRC32 = /*#__PURE__*/(function() {
  var CRC32 = {};
  CRC32.version = '1.2.0';
  /* see perf/crc32table.js */
  /*global Int32Array */
  function signed_crc_table()/*:any*/ {
  	var c = 0, table/*:Array<number>*/ = new Array(256);

  	for(var n =0; n != 256; ++n){
  		c = n;
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
  		table[n] = c;
  	}

  	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
  }

  var T0 = signed_crc_table();
  function slice_by_16_tables(T) {
  	var c = 0, v = 0, n = 0, table/*:Array<number>*/ = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;

  	for(n = 0; n != 256; ++n) table[n] = T[n];
  	for(n = 0; n != 256; ++n) {
  		v = T[n];
  		for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
  	}
  	var out = [];
  	for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
  	return out;
  }
  var TT = slice_by_16_tables(T0);
  var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
  var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
  var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
  function crc32_bstr(bstr/*:string*/, seed/*:number*/)/*:number*/ {
  	var C = seed/*:: ? 0 : 0 */ ^ -1;
  	for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
  	return ~C;
  }

  function crc32_buf(B/*:Uint8Array|Array<number>*/, seed/*:number*/)/*:number*/ {
  	var C = seed/*:: ? 0 : 0 */ ^ -1, L = B.length - 15, i = 0;
  	for(; i < L;) C =
  		Tf[B[i++] ^ (C & 255)] ^
  		Te[B[i++] ^ ((C >> 8) & 255)] ^
  		Td[B[i++] ^ ((C >> 16) & 255)] ^
  		Tc[B[i++] ^ (C >>> 24)] ^
  		Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
  		T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
  		T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
  	L += 15;
  	while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
  	return ~C;
  }

  function crc32_str(str/*:string*/, seed/*:number*/)/*:number*/ {
  	var C = seed ^ -1;
  	for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
  		c = str.charCodeAt(i++);
  		if(c < 0x80) {
  			C = (C>>>8) ^ T0[(C^c)&0xFF];
  		} else if(c < 0x800) {
  			C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
  		} else if(c >= 0xD800 && c < 0xE000) {
  			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
  			C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
  		} else {
  			C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
  			C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
  		}
  	}
  	return ~C;
  }
  CRC32.table = T0;
  CRC32.bstr = crc32_bstr;
  CRC32.buf = crc32_buf;
  CRC32.str = crc32_str;
  return CRC32;
  })();
  /* [MS-CFB] v20171201 */
  var CFB = /*#__PURE__*/(function _CFB(){
  var exports = {};
  exports.version = '1.2.1';
  /* [MS-CFB] 2.6.4 */
  function namecmp(l/*:string*/, r/*:string*/)/*:number*/ {
  	var L = l.split("/"), R = r.split("/");
  	for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
  		if((c = L[i].length - R[i].length)) return c;
  		if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
  	}
  	return L.length - R.length;
  }
  function dirname(p/*:string*/)/*:string*/ {
  	if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
  	var c = p.lastIndexOf("/");
  	return (c === -1) ? p : p.slice(0, c+1);
  }

  function filename(p/*:string*/)/*:string*/ {
  	if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
  	var c = p.lastIndexOf("/");
  	return (c === -1) ? p : p.slice(c+1);
  }
  /* -------------------------------------------------------------------------- */
  /* DOS Date format:
     high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
     add 1980 to stored year
     stored second should be doubled
  */

  /* write JS date to buf as a DOS date */
  function write_dos_date(buf/*:CFBlob*/, date/*:Date|string*/) {
  	if(typeof date === "string") date = new Date(date);
  	var hms/*:number*/ = date.getHours();
  	hms = hms << 6 | date.getMinutes();
  	hms = hms << 5 | (date.getSeconds()>>>1);
  	buf.write_shift(2, hms);
  	var ymd/*:number*/ = (date.getFullYear() - 1980);
  	ymd = ymd << 4 | (date.getMonth()+1);
  	ymd = ymd << 5 | date.getDate();
  	buf.write_shift(2, ymd);
  }

  /* read four bytes from buf and interpret as a DOS date */
  function parse_dos_date(buf/*:CFBlob*/)/*:Date*/ {
  	var hms = buf.read_shift(2) & 0xFFFF;
  	var ymd = buf.read_shift(2) & 0xFFFF;
  	var val = new Date();
  	var d = ymd & 0x1F; ymd >>>= 5;
  	var m = ymd & 0x0F; ymd >>>= 4;
  	val.setMilliseconds(0);
  	val.setFullYear(ymd + 1980);
  	val.setMonth(m-1);
  	val.setDate(d);
  	var S = hms & 0x1F; hms >>>= 5;
  	var M = hms & 0x3F; hms >>>= 6;
  	val.setHours(hms);
  	val.setMinutes(M);
  	val.setSeconds(S<<1);
  	return val;
  }
  function parse_extra_field(blob/*:CFBlob*/)/*:any*/ {
  	prep_blob(blob, 0);
  	var o = /*::(*/{}/*:: :any)*/;
  	var flags = 0;
  	while(blob.l <= blob.length - 4) {
  		var type = blob.read_shift(2);
  		var sz = blob.read_shift(2), tgt = blob.l + sz;
  		var p = {};
  		switch(type) {
  			/* UNIX-style Timestamps */
  			case 0x5455: {
  				flags = blob.read_shift(1);
  				if(flags & 1) p.mtime = blob.read_shift(4);
  				/* for some reason, CD flag corresponds to LFH */
  				if(sz > 5) {
  					if(flags & 2) p.atime = blob.read_shift(4);
  					if(flags & 4) p.ctime = blob.read_shift(4);
  				}
  				if(p.mtime) p.mt = new Date(p.mtime*1000);
  			}
  			break;
  		}
  		blob.l = tgt;
  		o[type] = p;
  	}
  	return o;
  }
  var fs/*:: = require('fs'); */;
  function get_fs() { return fs || (fs = {}); }
  function parse(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
  if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
  if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
  if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
  var mver = 3;
  var ssz = 512;
  var nmfs = 0; // number of mini FAT sectors
  var difat_sec_cnt = 0;
  var dir_start = 0;
  var minifat_start = 0;
  var difat_start = 0;

  var fat_addrs/*:Array<number>*/ = []; // locations of FAT sectors

  /* [MS-CFB] 2.2 Compound File Header */
  var blob/*:CFBlob*/ = /*::(*/file.slice(0,512)/*:: :any)*/;
  prep_blob(blob, 0);

  /* major version */
  var mv = check_get_mver(blob);
  mver = mv[0];
  switch(mver) {
  	case 3: ssz = 512; break; case 4: ssz = 4096; break;
  	case 0: if(mv[1] == 0) return parse_zip(file, options);
  	/* falls through */
  	default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
  }

  /* reprocess header */
  if(ssz !== 512) { blob = /*::(*/file.slice(0,ssz)/*:: :any)*/; prep_blob(blob, 28 /* blob.l */); }
  /* Save header for final object */
  var header/*:RawBytes*/ = file.slice(0,ssz);

  check_shifts(blob, mver);

  // Number of Directory Sectors
  var dir_cnt/*:number*/ = blob.read_shift(4, 'i');
  if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);

  // Number of FAT Sectors
  blob.l += 4;

  // First Directory Sector Location
  dir_start = blob.read_shift(4, 'i');

  // Transaction Signature
  blob.l += 4;

  // Mini Stream Cutoff Size
  blob.chk('00100000', 'Mini Stream Cutoff Size: ');

  // First Mini FAT Sector Location
  minifat_start = blob.read_shift(4, 'i');

  // Number of Mini FAT Sectors
  nmfs = blob.read_shift(4, 'i');

  // First DIFAT sector location
  difat_start = blob.read_shift(4, 'i');

  // Number of DIFAT Sectors
  difat_sec_cnt = blob.read_shift(4, 'i');

  // Grab FAT Sector Locations
  for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
  	q = blob.read_shift(4, 'i');
  	if(q<0) break;
  	fat_addrs[j] = q;
  }

  /** Break the file up into sectors */
  var sectors/*:Array<RawBytes>*/ = sectorify(file, ssz);

  sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);

  /** Chains */
  var sector_list/*:SectorList*/ = make_sector_list(sectors, dir_start, fat_addrs, ssz);

  sector_list[dir_start].name = "!Directory";
  if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
  sector_list[fat_addrs[0]].name = "!FAT";
  sector_list.fat_addrs = fat_addrs;
  sector_list.ssz = ssz;

  /* [MS-CFB] 2.6.1 Compound File Directory Entry */
  var files/*:CFBFiles*/ = {}, Paths/*:Array<string>*/ = [], FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
  read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);

  build_full_paths(FileIndex, FullPaths, Paths);
  Paths.shift();

  var o = {
  	FileIndex: FileIndex,
  	FullPaths: FullPaths
  };

  // $FlowIgnore
  if(options && options.raw) o.raw = {header: header, sectors: sectors};
  return o;
  } // parse

  /* [MS-CFB] 2.2 Compound File Header -- read up to major version */
  function check_get_mver(blob/*:CFBlob*/)/*:[number, number]*/ {
  	if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
  	// header signature 8
  	blob.chk(HEADER_SIGNATURE, 'Header Signature: ');

  	// clsid 16
  	//blob.chk(HEADER_CLSID, 'CLSID: ');
  	blob.l += 16;

  	// minor version 2
  	var mver/*:number*/ = blob.read_shift(2, 'u');

  	return [blob.read_shift(2,'u'), mver];
  }
  function check_shifts(blob/*:CFBlob*/, mver/*:number*/)/*:void*/ {
  	var shift = 0x09;

  	// Byte Order
  	//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
  	blob.l += 2;

  	// Sector Shift
  	switch((shift = blob.read_shift(2))) {
  		case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
  		case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
  		default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
  	}

  	// Mini Sector Shift
  	blob.chk('0600', 'Mini Sector Shift: ');

  	// Reserved
  	blob.chk('000000000000', 'Reserved: ');
  }

  /** Break the file up into sectors */
  function sectorify(file/*:RawBytes*/, ssz/*:number*/)/*:Array<RawBytes>*/ {
  	var nsectors = Math.ceil(file.length/ssz)-1;
  	var sectors/*:Array<RawBytes>*/ = [];
  	for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
  	sectors[nsectors-1] = file.slice(nsectors*ssz);
  	return sectors;
  }

  /* [MS-CFB] 2.6.4 Red-Black Tree */
  function build_full_paths(FI/*:CFBFileIndex*/, FP/*:Array<string>*/, Paths/*:Array<string>*/)/*:void*/ {
  	var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
  	var dad/*:Array<number>*/ = [], q/*:Array<number>*/ = [];

  	for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }

  	for(; j < q.length; ++j) {
  		i = q[j];
  		L = FI[i].L; R = FI[i].R; C = FI[i].C;
  		if(dad[i] === i) {
  			if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
  			if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
  		}
  		if(C !== -1 /*NOSTREAM*/) dad[C] = i;
  		if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
  		if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
  	}
  	for(i=1; i < pl; ++i) if(dad[i] === i) {
  		if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
  		else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
  	}

  	for(i=1; i < pl; ++i) {
  		if(FI[i].type === 0 /* unknown */) continue;
  		j = i;
  		if(j != dad[j]) do {
  			j = dad[j];
  			FP[i] = FP[j] + "/" + FP[i];
  		} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
  		dad[i] = -1;
  	}

  	FP[0] += "/";
  	for(i=1; i < pl; ++i) {
  		if(FI[i].type !== 2 /* stream */) FP[i] += "/";
  	}
  }

  function get_mfat_entry(entry/*:CFBEntry*/, payload/*:RawBytes*/, mini/*:?RawBytes*/)/*:CFBlob*/ {
  	var start = entry.start, size = entry.size;
  	//return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
  	var o = [];
  	var idx = start;
  	while(mini && size > 0 && idx >= 0) {
  		o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
  		size -= MSSZ;
  		idx = __readInt32LE(mini, idx * 4);
  	}
  	if(o.length === 0) return (new_buf(0)/*:any*/);
  	return (bconcat(o).slice(0, entry.size)/*:any*/);
  }

  /** Chase down the rest of the DIFAT chain to build a comprehensive list
      DIFAT chains by storing the next sector number as the last 32 bits */
  function sleuth_fat(idx/*:number*/, cnt/*:number*/, sectors/*:Array<RawBytes>*/, ssz/*:number*/, fat_addrs)/*:void*/ {
  	var q/*:number*/ = ENDOFCHAIN;
  	if(idx === ENDOFCHAIN) {
  		if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
  	} else if(idx !== -1 /*FREESECT*/) {
  		var sector = sectors[idx], m = (ssz>>>2)-1;
  		if(!sector) return;
  		for(var i = 0; i < m; ++i) {
  			if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
  			fat_addrs.push(q);
  		}
  		sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
  	}
  }

  /** Follow the linked list of sectors for a given starting point */
  function get_sector_list(sectors/*:Array<RawBytes>*/, start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/, chkd/*:?Array<boolean>*/)/*:SectorEntry*/ {
  	var buf/*:Array<number>*/ = [], buf_chain/*:Array<any>*/ = [];
  	if(!chkd) chkd = [];
  	var modulus = ssz - 1, j = 0, jj = 0;
  	for(j=start; j>=0;) {
  		chkd[j] = true;
  		buf[buf.length] = j;
  		buf_chain.push(sectors[j]);
  		var addr = fat_addrs[Math.floor(j*4/ssz)];
  		jj = ((j*4) & modulus);
  		if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
  		if(!sectors[addr]) break;
  		j = __readInt32LE(sectors[addr], jj);
  	}
  	return {nodes: buf, data:__toBuffer([buf_chain])};
  }

  /** Chase down the sector linked lists */
  function make_sector_list(sectors/*:Array<RawBytes>*/, dir_start/*:number*/, fat_addrs/*:Array<number>*/, ssz/*:number*/)/*:SectorList*/ {
  	var sl = sectors.length, sector_list/*:SectorList*/ = ([]/*:any*/);
  	var chkd/*:Array<boolean>*/ = [], buf/*:Array<number>*/ = [], buf_chain/*:Array<RawBytes>*/ = [];
  	var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
  	for(i=0; i < sl; ++i) {
  		buf = ([]/*:Array<number>*/);
  		k = (i + dir_start); if(k >= sl) k-=sl;
  		if(chkd[k]) continue;
  		buf_chain = [];
  		var seen = [];
  		for(j=k; j>=0;) {
  			seen[j] = true;
  			chkd[j] = true;
  			buf[buf.length] = j;
  			buf_chain.push(sectors[j]);
  			var addr/*:number*/ = fat_addrs[Math.floor(j*4/ssz)];
  			jj = ((j*4) & modulus);
  			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
  			if(!sectors[addr]) break;
  			j = __readInt32LE(sectors[addr], jj);
  			if(seen[j]) break;
  		}
  		sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])}/*:SectorEntry*/);
  	}
  	return sector_list;
  }

  /* [MS-CFB] 2.6.1 Compound File Directory Entry */
  function read_directory(dir_start/*:number*/, sector_list/*:SectorList*/, sectors/*:Array<RawBytes>*/, Paths/*:Array<string>*/, nmfs, files, FileIndex, mini) {
  	var minifat_store = 0, pl = (Paths.length?2:0);
  	var sector = sector_list[dir_start].data;
  	var i = 0, namelen = 0, name;
  	for(; i < sector.length; i+= 128) {
  		var blob/*:CFBlob*/ = /*::(*/sector.slice(i, i+128)/*:: :any)*/;
  		prep_blob(blob, 64);
  		namelen = blob.read_shift(2);
  		name = __utf16le(blob,0,namelen-pl);
  		Paths.push(name);
  		var o/*:CFBEntry*/ = ({
  			name:  name,
  			type:  blob.read_shift(1),
  			color: blob.read_shift(1),
  			L:     blob.read_shift(4, 'i'),
  			R:     blob.read_shift(4, 'i'),
  			C:     blob.read_shift(4, 'i'),
  			clsid: blob.read_shift(16),
  			state: blob.read_shift(4, 'i'),
  			start: 0,
  			size: 0
  		});
  		var ctime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
  		if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
  		var mtime/*:number*/ = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
  		if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
  		o.start = blob.read_shift(4, 'i');
  		o.size = blob.read_shift(4, 'i');
  		if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
  		if(o.type === 5) { /* root */
  			minifat_store = o.start;
  			if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
  			/*minifat_size = o.size;*/
  		} else if(o.size >= 4096 /* MSCSZ */) {
  			o.storage = 'fat';
  			if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
  			sector_list[o.start].name = o.name;
  			o.content = (sector_list[o.start].data.slice(0,o.size)/*:any*/);
  		} else {
  			o.storage = 'minifat';
  			if(o.size < 0) o.size = 0;
  			else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
  				o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
  			}
  		}
  		if(o.content) prep_blob(o.content, 0);
  		files[name] = o;
  		FileIndex.push(o);
  	}
  }

  function read_date(blob/*:RawBytes|CFBlob*/, offset/*:number*/)/*:Date*/ {
  	return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
  }

  function read_file(filename/*:string*/, options/*:CFBReadOpts*/) {
  	get_fs();
  	return parse(fs.readFileSync(filename), options);
  }

  function read(blob/*:RawBytes|string*/, options/*:CFBReadOpts*/) {
  	var type = options && options.type;
  	if(!type) {
  		if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
  	}
  	switch(type || "base64") {
  		case "file": /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */return read_file(blob, options);
  		case "base64": /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */return parse(s2a(Base64_decode(blob)), options);
  		case "binary": /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */return parse(s2a(blob), options);
  	}
  	return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */blob, options);
  }

  function init_cfb(cfb/*:CFBContainer*/, opts/*:?any*/)/*:void*/ {
  	var o = opts || {}, root = o.root || "Root Entry";
  	if(!cfb.FullPaths) cfb.FullPaths = [];
  	if(!cfb.FileIndex) cfb.FileIndex = [];
  	if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
  	if(cfb.FullPaths.length === 0) {
  		cfb.FullPaths[0] = root + "/";
  		cfb.FileIndex[0] = ({ name: root, type: 5 }/*:any*/);
  	}
  	if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
  	seed_cfb(cfb);
  }
  function seed_cfb(cfb/*:CFBContainer*/)/*:void*/ {
  	var nm = "\u0001Sh33tJ5";
  	if(CFB.find(cfb, "/" + nm)) return;
  	var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
  	cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }/*:any*/));
  	cfb.FullPaths.push(cfb.FullPaths[0] + nm);
  	rebuild_cfb(cfb);
  }
  function rebuild_cfb(cfb/*:CFBContainer*/, f/*:?boolean*/)/*:void*/ {
  	init_cfb(cfb);
  	var gc = false, s = false;
  	for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
  		var _file = cfb.FileIndex[i];
  		switch(_file.type) {
  			case 0:
  				if(s) gc = true;
  				else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
  				break;
  			case 1: case 2: case 5:
  				s = true;
  				if(isNaN(_file.R * _file.L * _file.C)) gc = true;
  				if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
  				break;
  			default: gc = true; break;
  		}
  	}
  	if(!gc && !f) return;

  	var now = new Date(1987, 1, 19), j = 0;
  	// Track which names exist
  	var fullPaths = Object.create ? Object.create(null) : {};
  	var data/*:Array<[string, CFBEntry]>*/ = [];
  	for(i = 0; i < cfb.FullPaths.length; ++i) {
  		fullPaths[cfb.FullPaths[i]] = true;
  		if(cfb.FileIndex[i].type === 0) continue;
  		data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
  	}
  	for(i = 0; i < data.length; ++i) {
  		var dad = dirname(data[i][0]);
  		s = fullPaths[dad];
  		if(!s) {
  			data.push([dad, ({
  				name: filename(dad).replace("/",""),
  				type: 1,
  				clsid: HEADER_CLSID,
  				ct: now, mt: now,
  				content: null
  			}/*:any*/)]);
  			// Add name to set
  			fullPaths[dad] = true;
  		}
  	}

  	data.sort(function(x,y) { return namecmp(x[0], y[0]); });
  	cfb.FullPaths = []; cfb.FileIndex = [];
  	for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
  	for(i = 0; i < data.length; ++i) {
  		var elt = cfb.FileIndex[i];
  		var nm = cfb.FullPaths[i];

  		elt.name =  filename(nm).replace("/","");
  		elt.L = elt.R = elt.C = -(elt.color = 1);
  		elt.size = elt.content ? elt.content.length : 0;
  		elt.start = 0;
  		elt.clsid = (elt.clsid || HEADER_CLSID);
  		if(i === 0) {
  			elt.C = data.length > 1 ? 1 : -1;
  			elt.size = 0;
  			elt.type = 5;
  		} else if(nm.slice(-1) == "/") {
  			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
  			elt.C = j >= data.length ? -1 : j;
  			for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
  			elt.R = j >= data.length ? -1 : j;
  			elt.type = 1;
  		} else {
  			if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
  			elt.type = 2;
  		}
  	}

  }

  function _write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
  	var _opts = options || {};
  	/* MAD is order-sensitive, skip rebuild and sort */
  	if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
  	rebuild_cfb(cfb);
  	switch(_opts.fileType) {
  		case 'zip': return write_zip(cfb, _opts);
  		//case 'mad': return write_mad(cfb, _opts);
  	}
  	var L = (function(cfb/*:CFBContainer*/)/*:Array<number>*/{
  		var mini_size = 0, fat_size = 0;
  		for(var i = 0; i < cfb.FileIndex.length; ++i) {
  			var file = cfb.FileIndex[i];
  			if(!file.content) continue;
  			/*:: if(file.content == null) throw new Error("unreachable"); */
  			var flen = file.content.length;
  			if(flen > 0){
  				if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
  				else fat_size += (flen + 0x01FF) >> 9;
  			}
  		}
  		var dir_cnt = (cfb.FullPaths.length +3) >> 2;
  		var mini_cnt = (mini_size + 7) >> 3;
  		var mfat_cnt = (mini_size + 0x7F) >> 7;
  		var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
  		var fat_cnt = (fat_base + 0x7F) >> 7;
  		var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
  		while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
  		var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
  		cfb.FileIndex[0].size = mini_size << 6;
  		L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
  		return L;
  	})(cfb);
  	var o = new_buf(L[7] << 9);
  	var i = 0, T = 0;
  	{
  		for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
  		for(i = 0; i < 8; ++i) o.write_shift(2, 0);
  		o.write_shift(2, 0x003E);
  		o.write_shift(2, 0x0003);
  		o.write_shift(2, 0xFFFE);
  		o.write_shift(2, 0x0009);
  		o.write_shift(2, 0x0006);
  		for(i = 0; i < 3; ++i) o.write_shift(2, 0);
  		o.write_shift(4, 0);
  		o.write_shift(4, L[2]);
  		o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
  		o.write_shift(4, 0);
  		o.write_shift(4, 1<<12);
  		o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
  		o.write_shift(4, L[3]);
  		o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
  		o.write_shift(4, L[1]);
  		for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
  	}
  	if(L[1]) {
  		for(T = 0; T < L[1]; ++T) {
  			for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
  			o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
  		}
  	}
  	var chainit = function(w/*:number*/)/*:void*/ {
  		for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
  		if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
  	};
  	T = i = 0;
  	for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
  	for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
  	chainit(L[3]);
  	chainit(L[4]);
  	var j/*:number*/ = 0, flen/*:number*/ = 0;
  	var file/*:CFBEntry*/ = cfb.FileIndex[0];
  	for(; j < cfb.FileIndex.length; ++j) {
  		file = cfb.FileIndex[j];
  		if(!file.content) continue;
  		/*:: if(file.content == null) throw new Error("unreachable"); */
  		flen = file.content.length;
  		if(flen < 0x1000) continue;
  		file.start = T;
  		chainit((flen + 0x01FF) >> 9);
  	}
  	chainit((L[6] + 7) >> 3);
  	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
  	T = i = 0;
  	for(j = 0; j < cfb.FileIndex.length; ++j) {
  		file = cfb.FileIndex[j];
  		if(!file.content) continue;
  		/*:: if(file.content == null) throw new Error("unreachable"); */
  		flen = file.content.length;
  		if(!flen || flen >= 0x1000) continue;
  		file.start = T;
  		chainit((flen + 0x3F) >> 6);
  	}
  	while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
  	for(i = 0; i < L[4]<<2; ++i) {
  		var nm = cfb.FullPaths[i];
  		if(!nm || nm.length === 0) {
  			for(j = 0; j < 17; ++j) o.write_shift(4, 0);
  			for(j = 0; j < 3; ++j) o.write_shift(4, -1);
  			for(j = 0; j < 12; ++j) o.write_shift(4, 0);
  			continue;
  		}
  		file = cfb.FileIndex[i];
  		if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
  		var _nm/*:string*/ = (i === 0 && _opts.root) || file.name;
  		flen = 2*(_nm.length+1);
  		o.write_shift(64, _nm, "utf16le");
  		o.write_shift(2, flen);
  		o.write_shift(1, file.type);
  		o.write_shift(1, file.color);
  		o.write_shift(-4, file.L);
  		o.write_shift(-4, file.R);
  		o.write_shift(-4, file.C);
  		if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
  		else o.write_shift(16, file.clsid, "hex");
  		o.write_shift(4, file.state || 0);
  		o.write_shift(4, 0); o.write_shift(4, 0);
  		o.write_shift(4, 0); o.write_shift(4, 0);
  		o.write_shift(4, file.start);
  		o.write_shift(4, file.size); o.write_shift(4, 0);
  	}
  	for(i = 1; i < cfb.FileIndex.length; ++i) {
  		file = cfb.FileIndex[i];
  		/*:: if(!file.content) throw new Error("unreachable"); */
  		if(file.size >= 0x1000) {
  			o.l = (file.start+1) << 9;
  			if (has_buf && Buffer.isBuffer(file.content)) {
  				file.content.copy(o, o.l, 0, file.size);
  				// o is a 0-filled Buffer so just set next offset
  				o.l += (file.size + 511) & -512;
  			} else {
  				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
  				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
  			}
  		}
  	}
  	for(i = 1; i < cfb.FileIndex.length; ++i) {
  		file = cfb.FileIndex[i];
  		/*:: if(!file.content) throw new Error("unreachable"); */
  		if(file.size > 0 && file.size < 0x1000) {
  			if (has_buf && Buffer.isBuffer(file.content)) {
  				file.content.copy(o, o.l, 0, file.size);
  				// o is a 0-filled Buffer so just set next offset
  				o.l += (file.size + 63) & -64;
  			} else {
  				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
  				for(; j & 0x3F; ++j) o.write_shift(1, 0);
  			}
  		}
  	}
  	if (has_buf) {
  		o.l = o.length;
  	} else {
  		// When using Buffer, already 0-filled
  		while(o.l < o.length) o.write_shift(1, 0);
  	}
  	return o;
  }
  /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
  function find(cfb/*:CFBContainer*/, path/*:string*/)/*:?CFBEntry*/ {
  	var UCFullPaths/*:Array<string>*/ = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
  	var UCPaths/*:Array<string>*/ = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
  	var k/*:boolean*/ = false;
  	if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
  	else k = path.indexOf("/") !== -1;
  	var UCPath/*:string*/ = path.toUpperCase();
  	var w/*:number*/ = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
  	if(w !== -1) return cfb.FileIndex[w];

  	var m = !UCPath.match(chr1);
  	UCPath = UCPath.replace(chr0,'');
  	if(m) UCPath = UCPath.replace(chr1,'!');
  	for(w = 0; w < UCFullPaths.length; ++w) {
  		if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
  		if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
  	}
  	return null;
  }
  /** CFB Constants */
  var MSSZ = 64; /* Mini Sector Size = 1<<6 */
  //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
  /* 2.1 Compound File Sector Numbers and Types */
  var ENDOFCHAIN = -2;
  /* 2.2 Compound File Header */
  var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
  var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
  var HEADER_CLSID = '00000000000000000000000000000000';
  var consts = {
  	/* 2.1 Compund File Sector Numbers and Types */
  	MAXREGSECT: -6,
  	DIFSECT: -4,
  	FATSECT: -3,
  	ENDOFCHAIN: ENDOFCHAIN,
  	FREESECT: -1,
  	/* 2.2 Compound File Header */
  	HEADER_SIGNATURE: HEADER_SIGNATURE,
  	HEADER_MINOR_VERSION: '3e00',
  	MAXREGSID: -6,
  	NOSTREAM: -1,
  	HEADER_CLSID: HEADER_CLSID,
  	/* 2.6.1 Compound File Directory Entry */
  	EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
  };

  function write_file(cfb/*:CFBContainer*/, filename/*:string*/, options/*:CFBWriteOpts*/)/*:void*/ {
  	get_fs();
  	var o = _write(cfb, options);
  	/*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */
  	fs.writeFileSync(filename, o);
  }

  function a2s(o/*:RawBytes*/)/*:string*/ {
  	var out = new Array(o.length);
  	for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
  	return out.join("");
  }

  function write(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes|string*/ {
  	var o = _write(cfb, options);
  	switch(options && options.type || "buffer") {
  		case "file": get_fs(); fs.writeFileSync(options.filename, (o/*:any*/)); return o;
  		case "binary": return typeof o == "string" ? o : a2s(o);
  		case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
  		case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
  			/* falls through */
  		case "array": return typeof o == "string" ? s2a(o) : o;
  	}
  	return o;
  }
  /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
  var _zlib;
  function use_zlib(zlib) { try {
  	var InflateRaw = zlib.InflateRaw;
  	var InflRaw = new InflateRaw();
  	InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
  	if(InflRaw.bytesRead) _zlib = zlib;
  	else throw new Error("zlib does not expose bytesRead");
  } catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }

  function _inflateRawSync(payload, usz) {
  	if(!_zlib) return _inflate(payload, usz);
  	var InflateRaw = _zlib.InflateRaw;
  	var InflRaw = new InflateRaw();
  	var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
  	payload.l += InflRaw.bytesRead;
  	return out;
  }

  function _deflateRawSync(payload) {
  	return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
  }
  var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];

  /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
  var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];

  /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
  var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];

  function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }

  var use_typed_arrays = typeof Uint8Array !== 'undefined';

  var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
  for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);

  function bit_swap_n(n, b) {
  	var rev = bitswap8[n & 0xFF];
  	if(b <= 8) return rev >>> (8-b);
  	rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
  	if(b <= 16) return rev >>> (16-b);
  	rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
  	return rev >>> (24-b);
  }

  /* helpers for unaligned bit reads */
  function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
  function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
  function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
  function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
  function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }

  /* works up to n = 3 * 8 + 1 = 25 */
  function read_bits_n(buf, bl, n) {
  	var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
  	var v = buf[h] >>> w;
  	if(n < 8 - w) return v & f;
  	v |= buf[h+1]<<(8-w);
  	if(n < 16 - w) return v & f;
  	v |= buf[h+2]<<(16-w);
  	if(n < 24 - w) return v & f;
  	v |= buf[h+3]<<(24-w);
  	return v & f;
  }

  /* helpers for unaligned bit writes */
  function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
  	if(w <= 5) buf[h] |= (v & 7) << w;
  	else {
  		buf[h] |= (v << w) & 0xFF;
  		buf[h+1] = (v&7) >> (8-w);
  	}
  	return bl + 3;
  }

  function write_bits_1(buf, bl, v) {
  	var w = bl & 7, h = bl >>> 3;
  	v = (v&1) << w;
  	buf[h] |= v;
  	return bl + 1;
  }
  function write_bits_8(buf, bl, v) {
  	var w = bl & 7, h = bl >>> 3;
  	v <<= w;
  	buf[h] |=  v & 0xFF; v >>>= 8;
  	buf[h+1] = v;
  	return bl + 8;
  }
  function write_bits_16(buf, bl, v) {
  	var w = bl & 7, h = bl >>> 3;
  	v <<= w;
  	buf[h] |=  v & 0xFF; v >>>= 8;
  	buf[h+1] = v & 0xFF;
  	buf[h+2] = v >>> 8;
  	return bl + 16;
  }

  /* until ArrayBuffer#realloc is a thing, fake a realloc */
  function realloc(b, sz/*:number*/) {
  	var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
  	if(L >= sz) return b;
  	if(has_buf) {
  		var o = new_unsafe_buf(M);
  		// $FlowIgnore
  		if(b.copy) b.copy(o);
  		else for(; i < b.length; ++i) o[i] = b[i];
  		return o;
  	} else if(use_typed_arrays) {
  		var a = new Uint8Array(M);
  		if(a.set) a.set(b);
  		else for(; i < L; ++i) a[i] = b[i];
  		return a;
  	}
  	b.length = M;
  	return b;
  }

  /* zero-filled arrays for older browsers */
  function zero_fill_array(n) {
  	var o = new Array(n);
  	for(var i = 0; i < n; ++i) o[i] = 0;
  	return o;
  }

  /* build tree (used for literals and lengths) */
  function build_tree(clens, cmap, MAX/*:number*/)/*:number*/ {
  	var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;

  	var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
  	for(i = 0; i < 32; ++i) bl_count[i] = 0;

  	for(i = L; i < MAX; ++i) clens[i] = 0;
  	L = clens.length;

  	var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []

  	/* build code tree */
  	for(i = 0; i < L; ++i) {
  		bl_count[(w = clens[i])]++;
  		if(maxlen < w) maxlen = w;
  		ctree[i] = 0;
  	}
  	bl_count[0] = 0;
  	for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
  	for(i = 0; i < L; ++i) {
  		ccode = clens[i];
  		if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
  	}

  	/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
  	var cleni = 0;
  	for(i = 0; i < L; ++i) {
  		cleni = clens[i];
  		if(cleni != 0) {
  			ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
  			for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
  				cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
  		}
  	}
  	return maxlen;
  }

  /* Fixed Huffman */
  var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
  var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
  if(!use_typed_arrays) {
  	for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
  	for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
  }
  (function() {
  	var dlens/*:Array<number>*/ = [];
  	var i = 0;
  	for(;i<32; i++) dlens.push(5);
  	build_tree(dlens, fix_dmap, 32);

  	var clens/*:Array<number>*/ = [];
  	i = 0;
  	for(; i<=143; i++) clens.push(8);
  	for(; i<=255; i++) clens.push(9);
  	for(; i<=279; i++) clens.push(7);
  	for(; i<=287; i++) clens.push(8);
  	build_tree(clens, fix_lmap, 288);
  })();var _deflateRaw = /*#__PURE__*/(function _deflateRawIIFE() {
  	var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
  	var j = 0, k = 0;
  	for(; j < DST_LN.length - 1; ++j) {
  		for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
  	}
  	for(;k < 32768; ++k) DST_LN_RE[k] = 29;

  	var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
  	for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
  		for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
  	}

  	function write_stored(data, out) {
  		var boff = 0;
  		while(boff < data.length) {
  			var L = Math.min(0xFFFF, data.length - boff);
  			var h = boff + L == data.length;
  			out.write_shift(1, +h);
  			out.write_shift(2, L);
  			out.write_shift(2, (~L) & 0xFFFF);
  			while(L-- > 0) out[out.l++] = data[boff++];
  		}
  		return out.l;
  	}

  	/* Fixed Huffman */
  	function write_huff_fixed(data, out) {
  		var bl = 0;
  		var boff = 0;
  		var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
  		while(boff < data.length) {
  			var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);

  			/* write a stored block for short data */
  			if(L < 10) {
  				bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
  				if(bl & 7) bl += 8 - (bl & 7);
  				out.l = (bl / 8) | 0;
  				out.write_shift(2, L);
  				out.write_shift(2, (~L) & 0xFFFF);
  				while(L-- > 0) out[out.l++] = data[boff++];
  				bl = out.l * 8;
  				continue;
  			}

  			bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
  			var hash = 0;
  			while(L-- > 0) {
  				var d = data[boff];
  				hash = ((hash << 5) ^ d) & 0x7FFF;

  				var match = -1, mlen = 0;

  				if((match = addrs[hash])) {
  					match |= boff & ~0x7FFF;
  					if(match > boff) match -= 0x8000;
  					if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
  				}

  				if(mlen > 2) {
  					/* Copy Token  */
  					d = LEN_LN_RE[mlen];
  					if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
  					else {
  						write_bits_8(out, bl, 3);
  						bl += 5;
  						write_bits_8(out, bl, bitswap8[d-23]>>5);
  						bl += 3;
  					}
  					var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
  					if(len_eb > 0) {
  						write_bits_16(out, bl, mlen - LEN_LN[d]);
  						bl += len_eb;
  					}

  					d = DST_LN_RE[boff - match];
  					bl = write_bits_8(out, bl, bitswap8[d]>>3);
  					bl -= 3;

  					var dst_eb = d < 4 ? 0 : (d-2)>>1;
  					if(dst_eb > 0) {
  						write_bits_16(out, bl, boff - match - DST_LN[d]);
  						bl += dst_eb;
  					}
  					for(var q = 0; q < mlen; ++q) {
  						addrs[hash] = boff & 0x7FFF;
  						hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
  						++boff;
  					}
  					L-= mlen - 1;
  				} else {
  					/* Literal Token */
  					if(d <= 143) d = d + 48;
  					else bl = write_bits_1(out, bl, 1);
  					bl = write_bits_8(out, bl, bitswap8[d]);
  					addrs[hash] = boff & 0x7FFF;
  					++boff;
  				}
  			}

  			bl = write_bits_8(out, bl, 0) - 1;
  		}
  		out.l = ((bl + 7)/8)|0;
  		return out.l;
  	}
  	return function _deflateRaw(data, out) {
  		if(data.length < 8) return write_stored(data, out);
  		return write_huff_fixed(data, out);
  	};
  })();

  function _deflate(data) {
  	var buf = new_buf(50+Math.floor(data.length*1.1));
  	var off = _deflateRaw(data, buf);
  	return buf.slice(0, off);
  }
  /* modified inflate function also moves original read head */

  var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
  var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
  var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
  var dyn_len_1 = 1, dyn_len_2 = 1;

  /* 5.5.3 Expanding Huffman Codes */
  function dyn(data, boff/*:number*/) {
  	/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
  	var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
  	var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
  	var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
  	var w = 0;

  	/* grab and store code lengths */
  	var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
  	var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
  	var maxlen = 1;
  	var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
  	var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
  	var L = clens.length; /* 19 */
  	for(var i = 0; i < _HCLEN; ++i) {
  		clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
  		if(maxlen < w) maxlen = w;
  		bl_count[w]++;
  		boff += 3;
  	}

  	/* build code tree */
  	var ccode = 0;
  	bl_count[0] = 0;
  	for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
  	for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
  	/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
  	var cleni = 0;
  	for(i = 0; i < L; ++i) {
  		cleni = clens[i];
  		if(cleni != 0) {
  			ccode = bitswap8[ctree[i]]>>(8-cleni);
  			for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
  		}
  	}

  	/* read literal and dist codes at once */
  	var hcodes/*:Array<number>*/ = [];
  	maxlen = 1;
  	for(; hcodes.length < _HLIT + _HDIST;) {
  		ccode = dyn_cmap[read_bits_7(data, boff)];
  		boff += ccode & 7;
  		switch((ccode >>>= 3)) {
  			case 16:
  				w = 3 + read_bits_2(data, boff); boff += 2;
  				ccode = hcodes[hcodes.length - 1];
  				while(w-- > 0) hcodes.push(ccode);
  				break;
  			case 17:
  				w = 3 + read_bits_3(data, boff); boff += 3;
  				while(w-- > 0) hcodes.push(0);
  				break;
  			case 18:
  				w = 11 + read_bits_7(data, boff); boff += 7;
  				while(w -- > 0) hcodes.push(0);
  				break;
  			default:
  				hcodes.push(ccode);
  				if(maxlen < ccode) maxlen = ccode;
  				break;
  		}
  	}

  	/* build literal / length trees */
  	var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
  	for(i = _HLIT; i < 286; ++i) h1[i] = 0;
  	for(i = _HDIST; i < 30; ++i) h2[i] = 0;
  	dyn_len_1 = build_tree(h1, dyn_lmap, 286);
  	dyn_len_2 = build_tree(h2, dyn_dmap, 30);
  	return boff;
  }

  /* return [ data, bytesRead ] */
  function inflate(data, usz/*:number*/) {
  	/* shortcircuit for empty buffer [0x03, 0x00] */
  	if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }

  	/* bit offset */
  	var boff = 0;

  	/* header includes final bit and type bits */
  	var header = 0;

  	var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
  	var woff = 0;
  	var OL = outbuf.length>>>0;
  	var max_len_1 = 0, max_len_2 = 0;

  	while((header&1) == 0) {
  		header = read_bits_3(data, boff); boff += 3;
  		if((header >>> 1) == 0) {
  			/* Stored block */
  			if(boff & 7) boff += 8 - (boff&7);
  			/* 2 bytes sz, 2 bytes bit inverse */
  			var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
  			boff += 32;
  			/* push sz bytes */
  			if(sz > 0) {
  				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
  				while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
  			}
  			continue;
  		} else if((header >> 1) == 1) {
  			/* Fixed Huffman */
  			max_len_1 = 9; max_len_2 = 5;
  		} else {
  			/* Dynamic Huffman */
  			boff = dyn(data, boff);
  			max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
  		}
  		for(;;) { // while(true) is apparently out of vogue in modern JS circles
  			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
  			/* ingest code and move read head */
  			var bits = read_bits_n(data, boff, max_len_1);
  			var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
  			boff += code & 15; code >>>= 4;
  			/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
  			if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
  			else if(code == 256) break;
  			else {
  				code -= 257;
  				var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
  				var tgt = woff + LEN_LN[code];
  				/* length extra bits */
  				if(len_eb > 0) {
  					tgt += read_bits_n(data, boff, len_eb);
  					boff += len_eb;
  				}

  				/* dist code */
  				bits = read_bits_n(data, boff, max_len_2);
  				code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
  				boff += code & 15; code >>>= 4;
  				var dst_eb = (code < 4 ? 0 : (code-2)>>1);
  				var dst = DST_LN[code];
  				/* dist extra bits */
  				if(dst_eb > 0) {
  					dst += read_bits_n(data, boff, dst_eb);
  					boff += dst_eb;
  				}

  				/* in the common case, manual byte copy is faster than TA set / Buffer copy */
  				if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
  				while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
  			}
  		}
  	}
  	if(usz) return [outbuf, (boff+7)>>>3];
  	return [outbuf.slice(0, woff), (boff+7)>>>3];
  }

  function _inflate(payload, usz) {
  	var data = payload.slice(payload.l||0);
  	var out = inflate(data, usz);
  	payload.l += out[1];
  	return out[0];
  }

  function warn_or_throw(wrn, msg) {
  	if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
  	else throw new Error(msg);
  }

  function parse_zip(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
  	var blob/*:CFBlob*/ = /*::(*/file/*:: :any)*/;
  	prep_blob(blob, 0);

  	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
  	var o = {
  		FileIndex: FileIndex,
  		FullPaths: FullPaths
  	};
  	init_cfb(o, { root: options.root });

  	/* find end of central directory, start just after signature */
  	var i = blob.length - 4;
  	while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
  	blob.l = i + 4;

  	/* parse end of central directory */
  	blob.l += 4;
  	var fcnt = blob.read_shift(2);
  	blob.l += 6;
  	var start_cd = blob.read_shift(4);

  	/* parse central directory */
  	blob.l = start_cd;

  	for(i = 0; i < fcnt; ++i) {
  		/* trust local file header instead of CD entry */
  		blob.l += 20;
  		var csz = blob.read_shift(4);
  		var usz = blob.read_shift(4);
  		var namelen = blob.read_shift(2);
  		var efsz = blob.read_shift(2);
  		var fcsz = blob.read_shift(2);
  		blob.l += 8;
  		var offset = blob.read_shift(4);
  		var EF = parse_extra_field(/*::(*/blob.slice(blob.l+namelen, blob.l+namelen+efsz)/*:: :any)*/);
  		blob.l += namelen + efsz + fcsz;

  		var L = blob.l;
  		blob.l = offset + 4;
  		parse_local_file(blob, csz, usz, o, EF);
  		blob.l = L;
  	}
  	return o;
  }


  /* head starts just after local file header signature */
  function parse_local_file(blob/*:CFBlob*/, csz/*:number*/, usz/*:number*/, o/*:CFBContainer*/, EF) {
  	/* [local file header] */
  	blob.l += 2;
  	var flags = blob.read_shift(2);
  	var meth = blob.read_shift(2);
  	var date = parse_dos_date(blob);

  	if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
  	var crc32 = blob.read_shift(4);
  	var _csz = blob.read_shift(4);
  	var _usz = blob.read_shift(4);

  	var namelen = blob.read_shift(2);
  	var efsz = blob.read_shift(2);

  	// TODO: flags & (1<<11) // UTF8
  	var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
  	if(efsz) {
  		var ef = parse_extra_field(/*::(*/blob.slice(blob.l, blob.l + efsz)/*:: :any)*/);
  		if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
  		if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
  	}
  	blob.l += efsz;

  	/* [encryption header] */

  	/* [file data] */
  	var data = blob.slice(blob.l, blob.l + _csz);
  	switch(meth) {
  		case 8: data = _inflateRawSync(blob, _usz); break;
  		case 0: break; // TODO: scan for magic number
  		default: throw new Error("Unsupported ZIP Compression method " + meth);
  	}

  	/* [data descriptor] */
  	var wrn = false;
  	if(flags & 8) {
  		crc32 = blob.read_shift(4);
  		if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
  		_csz = blob.read_shift(4);
  		_usz = blob.read_shift(4);
  	}

  	if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
  	if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
  	//var _crc32 = CRC32.buf(data, 0);
  	//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
  	cfb_add(o, name, data, {unsafe: true, mt: date});
  }
  function write_zip(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:RawBytes*/ {
  	var _opts = options || {};
  	var out = [], cdirs = [];
  	var o/*:CFBlob*/ = new_buf(1);
  	var method = (_opts.compression ? 8 : 0), flags = 0;
  	var i = 0, j = 0;

  	var start_cd = 0, fcnt = 0;
  	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
  	var crcs = [];
  	var sz_cd = 0;

  	for(i = 1; i < cfb.FullPaths.length; ++i) {
  		fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
  		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
  		var start = start_cd;

  		/* TODO: CP437 filename */
  		var namebuf = new_buf(fp.length);
  		for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
  		namebuf = namebuf.slice(0, namebuf.l);
  		crcs[fcnt] = CRC32.buf(/*::((*/fi.content/*::||[]):any)*/, 0);

  		var outbuf = fi.content/*::||[]*/;
  		if(method == 8) outbuf = _deflateRawSync(outbuf);

  		/* local file header */
  		o = new_buf(30);
  		o.write_shift(4, 0x04034b50);
  		o.write_shift(2, 20);
  		o.write_shift(2, flags);
  		o.write_shift(2, method);
  		/* TODO: last mod file time/date */
  		if(fi.mt) write_dos_date(o, fi.mt);
  		else o.write_shift(4, 0);
  		o.write_shift(-4, crcs[fcnt]);
  		o.write_shift(4,  outbuf.length);
  		o.write_shift(4,  /*::(*/fi.content/*::||[])*/.length);
  		o.write_shift(2, namebuf.length);
  		o.write_shift(2, 0);

  		start_cd += o.length;
  		out.push(o);
  		start_cd += namebuf.length;
  		out.push(namebuf);

  		/* TODO: extra fields? */

  		/* TODO: encryption header ? */

  		start_cd += outbuf.length;
  		out.push(outbuf);

  		/* central directory */
  		o = new_buf(46);
  		o.write_shift(4, 0x02014b50);
  		o.write_shift(2, 0);
  		o.write_shift(2, 20);
  		o.write_shift(2, flags);
  		o.write_shift(2, method);
  		o.write_shift(4, 0); /* TODO: last mod file time/date */
  		o.write_shift(-4, crcs[fcnt]);

  		o.write_shift(4, outbuf.length);
  		o.write_shift(4, /*::(*/fi.content/*::||[])*/.length);
  		o.write_shift(2, namebuf.length);
  		o.write_shift(2, 0);
  		o.write_shift(2, 0);
  		o.write_shift(2, 0);
  		o.write_shift(2, 0);
  		o.write_shift(4, 0);
  		o.write_shift(4, start);

  		sz_cd += o.l;
  		cdirs.push(o);
  		sz_cd += namebuf.length;
  		cdirs.push(namebuf);
  		++fcnt;
  	}

  	/* end of central directory */
  	o = new_buf(22);
  	o.write_shift(4, 0x06054b50);
  	o.write_shift(2, 0);
  	o.write_shift(2, 0);
  	o.write_shift(2, fcnt);
  	o.write_shift(2, fcnt);
  	o.write_shift(4, sz_cd);
  	o.write_shift(4, start_cd);
  	o.write_shift(2, 0);

  	return bconcat(([bconcat((out/*:any*/)), bconcat(cdirs), o]/*:any*/));
  }
  var ContentTypeMap = ({
  	"htm": "text/html",
  	"xml": "text/xml",

  	"gif": "image/gif",
  	"jpg": "image/jpeg",
  	"png": "image/png",

  	"mso": "application/x-mso",
  	"thmx": "application/vnd.ms-officetheme",
  	"sh33tj5": "application/octet-stream"
  }/*:any*/);

  function get_content_type(fi/*:CFBEntry*/, fp/*:string*/)/*:string*/ {
  	if(fi.ctype) return fi.ctype;

  	var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
  	if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];

  	if(fp) {
  		m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
  		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
  	}

  	return "application/octet-stream";
  }

  /* 76 character chunks TODO: intertwine encoding */
  function write_base64_76(bstr/*:string*/)/*:string*/ {
  	var data = Base64_encode(bstr);
  	var o = [];
  	for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
  	return o.join("\r\n") + "\r\n";
  }

  /*
  Rules for QP:
  	- escape =## applies for all non-display characters and literal "="
  	- space or tab at end of line must be encoded
  	- \r\n newlines can be preserved, but bare \r and \n must be escaped
  	- lines must not exceed 76 characters, use soft breaks =\r\n

  TODO: Some files from word appear to write line extensions with bare equals:

  ```
  <table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
  ="70%"
  ```
  */
  function write_quoted_printable(text/*:string*/)/*:string*/ {
  	var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
  		var w = c.charCodeAt(0).toString(16).toUpperCase();
  		return "=" + (w.length == 1 ? "0" + w : w);
  	});

  	encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");

  	if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
  	encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");

  	var o/*:Array<string>*/ = [], split = encoded.split("\r\n");
  	for(var si = 0; si < split.length; ++si) {
  		var str = split[si];
  		if(str.length == 0) { o.push(""); continue; }
  		for(var i = 0; i < str.length;) {
  			var end = 76;
  			var tmp = str.slice(i, i + end);
  			if(tmp.charAt(end - 1) == "=") end --;
  			else if(tmp.charAt(end - 2) == "=") end -= 2;
  			else if(tmp.charAt(end - 3) == "=") end -= 3;
  			tmp = str.slice(i, i + end);
  			i += end;
  			if(i < str.length) tmp += "=";
  			o.push(tmp);
  		}
  	}

  	return o.join("\r\n");
  }
  function parse_quoted_printable(data/*:Array<string>*/)/*:RawBytes*/ {
  	var o = [];

  	/* unify long lines */
  	for(var di = 0; di < data.length; ++di) {
  		var line = data[di];
  		while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
  		o.push(line);
  	}

  	/* decode */
  	for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
  	return s2a(o.join("\r\n"));
  }


  function parse_mime(cfb/*:CFBContainer*/, data/*:Array<string>*/, root/*:string*/)/*:void*/ {
  	var fname = "", cte = "", ctype = "", fdata;
  	var di = 0;
  	for(;di < 10; ++di) {
  		var line = data[di];
  		if(!line || line.match(/^\s*$/)) break;
  		var m = line.match(/^(.*?):\s*([^\s].*)$/);
  		if(m) switch(m[1].toLowerCase()) {
  			case "content-location": fname = m[2].trim(); break;
  			case "content-type": ctype = m[2].trim(); break;
  			case "content-transfer-encoding": cte = m[2].trim(); break;
  		}
  	}
  	++di;
  	switch(cte.toLowerCase()) {
  		case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
  		case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
  		default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
  	}
  	var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
  	if(ctype) file.ctype = ctype;
  }

  function parse_mad(file/*:RawBytes*/, options/*:CFBReadOpts*/)/*:CFBContainer*/ {
  	if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
  	var root = (options && options.root || "");
  	// $FlowIgnore
  	var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
  	var di = 0, row = "";

  	/* if root is not specified, scan for the common prefix */
  	for(di = 0; di < data.length; ++di) {
  		row = data[di];
  		if(!/^Content-Location:/i.test(row)) continue;
  		row = row.slice(row.indexOf("file"));
  		if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
  		if(row.slice(0, root.length) == root) continue;
  		while(root.length > 0) {
  			root = root.slice(0, root.length - 1);
  			root = root.slice(0, root.lastIndexOf("/") + 1);
  			if(row.slice(0,root.length) == root) break;
  		}
  	}

  	var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
  	if(!mboundary) throw new Error("MAD cannot find boundary");
  	var boundary = "--" + (mboundary[1] || "");

  	var FileIndex/*:CFBFileIndex*/ = [], FullPaths/*:Array<string>*/ = [];
  	var o = {
  		FileIndex: FileIndex,
  		FullPaths: FullPaths
  	};
  	init_cfb(o);
  	var start_di, fcnt = 0;
  	for(di = 0; di < data.length; ++di) {
  		var line = data[di];
  		if(line !== boundary && line !== boundary + "--") continue;
  		if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
  		start_di = di;
  	}
  	return o;
  }

  function write_mad(cfb/*:CFBContainer*/, options/*:CFBWriteOpts*/)/*:string*/ {
  	var opts = options || {};
  	var boundary = opts.boundary || "SheetJS";
  	boundary = '------=' + boundary;

  	var out = [
  		'MIME-Version: 1.0',
  		'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
  		'',
  		'',
  		''
  	];

  	var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
  	for(var i = 1; i < cfb.FullPaths.length; ++i) {
  		fp = cfb.FullPaths[i].slice(root.length);
  		fi = cfb.FileIndex[i];
  		if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;

  		/* Normalize filename */
  		fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
  			return "_x" + c.charCodeAt(0).toString(16) + "_";
  		}).replace(/[\u0080-\uFFFF]/g, function(u) {
  			return "_u" + u.charCodeAt(0).toString(16) + "_";
  		});

  		/* Extract content as binary string */
  		var ca = fi.content;
  		// $FlowIgnore
  		var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);

  		/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
  		var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
  		for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
  		var qp = dispcnt >= L * 4 / 5;

  		out.push(boundary);
  		out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
  		out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
  		out.push('Content-Type: ' + get_content_type(fi, fp));
  		out.push('');

  		out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
  	}
  	out.push(boundary + '--\r\n');
  	return out.join("\r\n");
  }
  function cfb_new(opts/*:?any*/)/*:CFBContainer*/ {
  	var o/*:CFBContainer*/ = ({}/*:any*/);
  	init_cfb(o, opts);
  	return o;
  }

  function cfb_add(cfb/*:CFBContainer*/, name/*:string*/, content/*:?RawBytes*/, opts/*:?any*/)/*:CFBEntry*/ {
  	var unsafe = opts && opts.unsafe;
  	if(!unsafe) init_cfb(cfb);
  	var file = !unsafe && CFB.find(cfb, name);
  	if(!file) {
  		var fpath/*:string*/ = cfb.FullPaths[0];
  		if(name.slice(0, fpath.length) == fpath) fpath = name;
  		else {
  			if(fpath.slice(-1) != "/") fpath += "/";
  			fpath = (fpath + name).replace("//","/");
  		}
  		file = ({name: filename(name), type: 2}/*:any*/);
  		cfb.FileIndex.push(file);
  		cfb.FullPaths.push(fpath);
  		if(!unsafe) CFB.utils.cfb_gc(cfb);
  	}
  	/*:: if(!file) throw new Error("unreachable"); */
  	file.content = (content/*:any*/);
  	file.size = content ? content.length : 0;
  	if(opts) {
  		if(opts.CLSID) file.clsid = opts.CLSID;
  		if(opts.mt) file.mt = opts.mt;
  		if(opts.ct) file.ct = opts.ct;
  	}
  	return file;
  }

  function cfb_del(cfb/*:CFBContainer*/, name/*:string*/)/*:boolean*/ {
  	init_cfb(cfb);
  	var file = CFB.find(cfb, name);
  	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
  		cfb.FileIndex.splice(j, 1);
  		cfb.FullPaths.splice(j, 1);
  		return true;
  	}
  	return false;
  }

  function cfb_mov(cfb/*:CFBContainer*/, old_name/*:string*/, new_name/*:string*/)/*:boolean*/ {
  	init_cfb(cfb);
  	var file = CFB.find(cfb, old_name);
  	if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
  		cfb.FileIndex[j].name = filename(new_name);
  		cfb.FullPaths[j] = new_name;
  		return true;
  	}
  	return false;
  }

  function cfb_gc(cfb/*:CFBContainer*/)/*:void*/ { rebuild_cfb(cfb, true); }

  exports.find = find;
  exports.read = read;
  exports.parse = parse;
  exports.write = write;
  exports.writeFile = write_file;
  exports.utils = {
  	cfb_new: cfb_new,
  	cfb_add: cfb_add,
  	cfb_del: cfb_del,
  	cfb_mov: cfb_mov,
  	cfb_gc: cfb_gc,
  	ReadShift: ReadShift,
  	CheckField: CheckField,
  	prep_blob: prep_blob,
  	bconcat: bconcat,
  	use_zlib: use_zlib,
  	_deflateRaw: _deflate,
  	_inflateRaw: _inflate,
  	consts: consts
  };

  return exports;
  })();

  /* read binary data from file */
  function read_binary(path/*:string*/) {
  	if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
  	// $FlowIgnore
  	if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
  		// $FlowIgnore
  		var infile = File(path); infile.open("r"); infile.encoding = "binary";
  		var data = infile.read(); infile.close();
  		return data;
  	} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
  	throw new Error("Cannot access file " + path);
  }
  function keys$1(o/*:any*/)/*:Array<any>*/ {
  	var ks = Object.keys(o), o2 = [];
  	for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
  	return o2;
  }

  function evert(obj/*:any*/)/*:EvertType*/ {
  	var o = ([]/*:any*/), K = keys$1(obj);
  	for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
  	return o;
  }

  var basedate = /*#__PURE__*/new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
  function datenum(v/*:Date*/, date1904/*:?boolean*/)/*:number*/ {
  	var epoch = /*#__PURE__*/v.getTime();
  	if(date1904) epoch -= 1462*24*60*60*1000;
  	var dnthresh = /*#__PURE__*/basedate.getTime() + (/*#__PURE__*/v.getTimezoneOffset() - /*#__PURE__*/basedate.getTimezoneOffset()) * 60000;
  	return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
  }
  var refdate = /*#__PURE__*/new Date();
  var dnthresh = /*#__PURE__*/basedate.getTime() + (/*#__PURE__*/refdate.getTimezoneOffset() - /*#__PURE__*/basedate.getTimezoneOffset()) * 60000;
  var refoffset = /*#__PURE__*/refdate.getTimezoneOffset();
  function numdate(v/*:number*/)/*:Date*/ {
  	var out = new Date();
  	out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
  	if (out.getTimezoneOffset() !== refoffset) {
  		out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
  	}
  	return out;
  }

  /* ISO 8601 Duration */
  function parse_isodur(s) {
  	var sec = 0, mt = 0, time = false;
  	var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  	if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
  	for(var i = 1; i != m.length; ++i) {
  		if(!m[i]) continue;
  		mt = 1;
  		if(i > 3) time = true;
  		switch(m[i].slice(m[i].length-1)) {
  			case 'Y':
  				throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
  			case 'D': mt *= 24;
  				/* falls through */
  			case 'H': mt *= 60;
  				/* falls through */
  			case 'M':
  				if(!time) throw new Error("Unsupported ISO Duration Field: M");
  				else mt *= 60;
  		}
  		sec += mt * parseInt(m[i], 10);
  	}
  	return sec;
  }

  var good_pd_date_1 = /*#__PURE__*/new Date('2017-02-19T19:06:09.000Z');
  var good_pd_date = /*#__PURE__*/isNaN(/*#__PURE__*/good_pd_date_1.getFullYear()) ? /*#__PURE__*/new Date('2/19/17') : good_pd_date_1;
  var good_pd = /*#__PURE__*/good_pd_date.getFullYear() == 2017;
  /* parses a date as a local date */
  function parseDate(str/*:string|Date*/, fixdate/*:?number*/)/*:Date*/ {
  	var d = new Date(str);
  	if(good_pd) {
  		/*:: if(fixdate == null) fixdate = 0; */
  		if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
  		else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
  		return d;
  	}
  	if(str instanceof Date) return str;
  	if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
  		var s = d.getFullYear();
  		if(str.indexOf("" + s) > -1) return d;
  		d.setFullYear(d.getFullYear() + 100); return d;
  	}
  	var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
  	var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
  	if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
  	return out;
  }

  function cc2str(arr/*:Array<number>*/, debomit)/*:string*/ {
  	if(has_buf && Buffer.isBuffer(arr)) {
  		if(debomit) {
  			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
  			if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
  		}
  		return arr.toString("binary");
  	}

  	if(typeof TextDecoder !== "undefined") try {
  		if(debomit) {
  			if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
  			if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
  		}
  		var rev = {
  			"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
  			"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
  			"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
  			"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
  			"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
  			"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
  			"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
  		};
  		if(Array.isArray(arr)) arr = new Uint8Array(arr);
  		return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
  	} catch(e) {}

  	var o = [];
  	for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
  	return o.join("");
  }

  function dup(o/*:any*/)/*:any*/ {
  	if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
  	if(typeof o != 'object' || o == null) return o;
  	if(o instanceof Date) return new Date(o.getTime());
  	var out = {};
  	for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
  	return out;
  }

  function fill(c/*:string*/,l/*:number*/)/*:string*/ { var o = ""; while(o.length < l) o+=c; return o; }

  /* TODO: stress test */
  function fuzzynum(s/*:string*/)/*:number*/ {
  	var v/*:number*/ = Number(s);
  	if(!isNaN(v)) return isFinite(v) ? v : NaN;
  	if(!/\d/.test(s)) return v;
  	var wt = 1;
  	var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
  	if(!isNaN(v = Number(ss))) return v / wt;
  	ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
  	if(!isNaN(v = Number(ss))) return v / wt;
  	return v;
  }
  var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  function fuzzydate(s/*:string*/)/*:Date*/ {
  	var o = new Date(s), n = new Date(NaN);
  	var y = o.getYear(), m = o.getMonth(), d = o.getDate();
  	if(isNaN(d)) return n;
  	var lower = s.toLowerCase();
  	if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
  		lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
  		if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
  	} else if(lower.match(/[a-z]/)) return n;
  	if(y < 0 || y > 8099) return n;
  	if((m > 0 || d > 1) && y != 101) return o;
  	if(s.match(/[^-0-9:,\/\\]/)) return n;
  	return o;
  }

  var split_regex = /*#__PURE__*/(function() {
  	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
  	return function split_regex(str/*:string*/, re, def/*:string*/)/*:Array<string>*/ {
  		if(safe_split_regex || typeof re == "string") return str.split(re);
  		var p = str.split(re), o = [p[0]];
  		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
  		return o;
  	};
  })();
  function getdatastr(data)/*:?string*/ {
  	if(!data) return null;
  	if(data.content && data.type) return cc2str(data.content, true);
  	if(data.data) return debom(data.data);
  	if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
  	if(data.asBinary) return debom(data.asBinary());
  	if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
  	return null;
  }

  function getdatabin(data) {
  	if(!data) return null;
  	if(data.data) return char_codes(data.data);
  	if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
  	if(data._data && data._data.getContent) {
  		var o = data._data.getContent();
  		if(typeof o == "string") return char_codes(o);
  		return Array.prototype.slice.call(o);
  	}
  	if(data.content && data.type) return data.content;
  	return null;
  }

  function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }

  /* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
  /* OASIS does not comment on filename case sensitivity */
  function safegetzipfile(zip, file/*:string*/) {
  	var k = zip.FullPaths || keys$1(zip.files);
  	var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
  	for(var i=0; i<k.length; ++i) {
  		var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
  		if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
  	}
  	return null;
  }

  function getzipfile(zip, file/*:string*/) {
  	var o = safegetzipfile(zip, file);
  	if(o == null) throw new Error("Cannot find file " + file + " in zip");
  	return o;
  }

  function getzipdata(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
  	if(!safe) return getdata(getzipfile(zip, file));
  	if(!file) return null;
  	try { return getzipdata(zip, file); } catch(e) { return null; }
  }

  function getzipstr(zip, file/*:string*/, safe/*:?boolean*/)/*:?string*/ {
  	if(!safe) return getdatastr(getzipfile(zip, file));
  	if(!file) return null;
  	try { return getzipstr(zip, file); } catch(e) { return null; }
  }

  function getzipbin(zip, file/*:string*/, safe/*:?boolean*/)/*:any*/ {
  	if(!safe) return getdatabin(getzipfile(zip, file));
  	if(!file) return null;
  	try { return getzipbin(zip, file); } catch(e) { return null; }
  }

  function zipentries(zip) {
  	var k = zip.FullPaths || keys$1(zip.files), o = [];
  	for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
  	return o.sort();
  }

  function zip_add_file(zip, path, content) {
  	if(zip.FullPaths) {
  		if(typeof content == "string") {
  			var res;
  			if(has_buf) res = Buffer_from(content);
  			/* TODO: investigate performance in Edge 13 */
  			//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
  			else res = utf8decode(content);
  			return CFB.utils.cfb_add(zip, path, res);
  		}
  		CFB.utils.cfb_add(zip, path, content);
  	}
  	else zip.file(path, content);
  }

  function zip_read(d, o) {
  	switch(o.type) {
  		case "base64": return CFB.read(d, { type: "base64" });
  		case "binary": return CFB.read(d, { type: "binary" });
  		case "buffer": case "array": return CFB.read(d, { type: "buffer" });
  	}
  	throw new Error("Unrecognized type " + o.type);
  }

  function resolve_path(path/*:string*/, base/*:string*/)/*:string*/ {
  	if(path.charAt(0) == "/") return path.slice(1);
  	var result = base.split('/');
  	if(base.slice(-1) != "/") result.pop(); // folder path
  	var target = path.split('/');
  	while (target.length !== 0) {
  		var step = target.shift();
  		if (step === '..') result.pop();
  		else if (step !== '.') result.push(step);
  	}
  	return result.join('/');
  }
  var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
  var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
  var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
  var tagregex = /*#__PURE__*/XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
  var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
  function parsexmltag(tag/*:string*/, skip_root/*:?boolean*/, skip_LC/*:?boolean*/)/*:any*/ {
  	var z = ({}/*:any*/);
  	var eq = 0, c = 0;
  	for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
  	if(!skip_root) z[0] = tag.slice(0, eq);
  	if(eq === tag.length) return z;
  	var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
  	if(m) for(i = 0; i != m.length; ++i) {
  		cc = m[i];
  		for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
  		q = cc.slice(0,c).trim();
  		while(cc.charCodeAt(c+1) == 32) ++c;
  		quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
  		v = cc.slice(c+1+quot, cc.length-quot);
  		for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
  		if(j===q.length) {
  			if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
  			z[q] = v;
  			if(!skip_LC) z[q.toLowerCase()] = v;
  		}
  		else {
  			var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
  			if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
  			z[k] = v;
  			if(!skip_LC) z[k.toLowerCase()] = v;
  		}
  	}
  	return z;
  }
  function strip_ns(x/*:string*/)/*:string*/ { return x.replace(nsregex2, "<$1"); }

  var encodings = {
  	'&quot;': '"',
  	'&apos;': "'",
  	'&gt;': '>',
  	'&lt;': '<',
  	'&amp;': '&'
  };
  var rencoding = /*#__PURE__*/evert(encodings);
  //var rencstr = "&<>'\"".split("");

  // TODO: CP remap (need to read file version to determine OS)
  var unescapexml/*:StringConv*/ = /*#__PURE__*/(function() {
  	/* 22.4.2.4 bstr (Basic String) */
  	var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
  	return function unescapexml(text/*:string*/)/*:string*/ {
  		var s = text + '', i = s.indexOf("<![CDATA[");
  		if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
  		var j = s.indexOf("]]>");
  		return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
  	};
  })();

  var decregex=/[&<>'"]/g;

  var htmlcharegex = /[\u0000-\u001f]/g;
  function escapehtml(text/*:string*/)/*:string*/{
  	var s = text + '';
  	return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
  }

  /* TODO: handle codepages */
  var xlml_fixstr/*:StringConv*/ = /*#__PURE__*/(function() {
  	var entregex = /&#(\d+);/g;
  	function entrepl($$/*:string*/,$1/*:string*/)/*:string*/ { return String.fromCharCode(parseInt($1,10)); }
  	return function xlml_fixstr(str/*:string*/)/*:string*/ { return str.replace(entregex,entrepl); };
  })();

  function parsexmlbool(value/*:any*/)/*:boolean*/ {
  	switch(value) {
  		case 1: case true: case '1': case 'true': case 'TRUE': return true;
  		/* case '0': case 'false': case 'FALSE':*/
  		default: return false;
  	}
  }

  function utf8reada(orig/*:string*/)/*:string*/ {
  	var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
  	while (i < orig.length) {
  		c = orig.charCodeAt(i++);
  		if (c < 128) { out += String.fromCharCode(c); continue; }
  		d = orig.charCodeAt(i++);
  		if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
  		e = orig.charCodeAt(i++);
  		if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
  		f = orig.charCodeAt(i++);
  		w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
  		out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
  		out += String.fromCharCode(0xDC00 + (w&1023));
  	}
  	return out;
  }

  function utf8readb(data) {
  	var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
  	for(i = 0; i < data.length; i+=j) {
  		j = 1;
  		if((c=data.charCodeAt(i)) < 128) w = c;
  		else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
  		else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
  		else { j = 4;
  			w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
  			w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
  		}
  		if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
  		out[k++] = w%256; out[k++] = w>>>8;
  	}
  	return out.slice(0,k).toString('ucs2');
  }

  function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }

  var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
  var utf8read = has_buf && (/*#__PURE__*/utf8readc(utf8corpus) == /*#__PURE__*/utf8reada(utf8corpus) && utf8readc || /*#__PURE__*/utf8readb(utf8corpus) == /*#__PURE__*/utf8reada(utf8corpus) && utf8readb) || utf8reada;

  var utf8write/*:StringConv*/ = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig/*:string*/)/*:string*/ {
  	var out/*:Array<string>*/ = [], i = 0, c = 0, d = 0;
  	while(i < orig.length) {
  		c = orig.charCodeAt(i++);
  		switch(true) {
  			case c < 128: out.push(String.fromCharCode(c)); break;
  			case c < 2048:
  				out.push(String.fromCharCode(192 + (c >> 6)));
  				out.push(String.fromCharCode(128 + (c & 63)));
  				break;
  			case c >= 55296 && c < 57344:
  				c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
  				out.push(String.fromCharCode(240 + ((d >>18) & 7)));
  				out.push(String.fromCharCode(144 + ((d >>12) & 63)));
  				out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
  				out.push(String.fromCharCode(128 + (d & 63)));
  				break;
  			default:
  				out.push(String.fromCharCode(224 + (c >> 12)));
  				out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
  				out.push(String.fromCharCode(128 + (c & 63)));
  		}
  	}
  	return out.join("");
  };

  // matches <foo>...</foo> extracts content
  var matchtag = /*#__PURE__*/(function() {
  	var mtcache/*:{[k:string]:RegExp}*/ = ({}/*:any*/);
  	return function matchtag(f/*:string*/,g/*:?string*/)/*:RegExp*/ {
  		var t = f+"|"+(g||"");
  		if(mtcache[t]) return mtcache[t];
  		return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||"")/*:any*/)));
  	};
  })();

  var htmldecode/*:{(s:string):string}*/ = /*#__PURE__*/(function() {
  	var entities/*:Array<[RegExp, string]>*/ = [
  		['nbsp', ' '], ['middot', '·'],
  		['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
  	].map(function(x/*:[string, string]*/) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
  	return function htmldecode(str/*:string*/)/*:string*/ {
  		var o = str
  				// Remove new lines and spaces from start of content
  				.replace(/^[\t\n\r ]+/, "")
  				// Remove new lines and spaces from end of content
  				.replace(/[\t\n\r ]+$/,"")
  				// Added line which removes any white space characters after and before html tags
  				.replace(/>\s+/g,">").replace(/\s+</g,"<")
  				// Replace remaining new lines and spaces with space
  				.replace(/[\t\n\r ]+/g, " ")
  				// Replace <br> tags with new lines
  				.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
  				// Strip HTML elements
  				.replace(/<[^>]*>/g,"");
  		for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
  		return o;
  	};
  })();

  var vtregex = /*#__PURE__*/(function(){ var vt_cache = {};
  	return function vt_regex(bt) {
  		if(vt_cache[bt] !== undefined) return vt_cache[bt];
  		return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
  };})();
  var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
  function parseVector(data/*:string*/, opts)/*:Array<{v:string,t:string}>*/ {
  	var h = parsexmltag(data);

  	var matches/*:Array<string>*/ = data.match(vtregex(h.baseType))||[];
  	var res/*:Array<any>*/ = [];
  	if(matches.length != h.size) {
  		if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
  		return res;
  	}
  	matches.forEach(function(x/*:string*/) {
  		var v = x.replace(vtvregex,"").match(vtmregex);
  		if(v) res.push({v:utf8read(v[2]), t:v[1]});
  	});
  	return res;
  }

  var wtregex = /(^\s|\s$|\n)/;

  function wxt_helper(h)/*:string*/ { return keys$1(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
  function writextag(f/*:string*/,g/*:?string*/,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}

  function xlml_normalize(d)/*:string*/ {
  	if(has_buf &&/*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ Buffer.isBuffer(d)) return d.toString('utf8');
  	if(typeof d === 'string') return d;
  	/* duktape */
  	if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
  	throw new Error("Bad input format: expected Buffer or string");
  }
  /* UOS uses CJK in tags */
  var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
  //var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;

  var XMLNS = ({
  	CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
  	CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
  	EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
  	CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
  	RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
  	TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
  	'dc': 'http://purl.org/dc/elements/1.1/',
  	'dcterms': 'http://purl.org/dc/terms/',
  	'dcmitype': 'http://purl.org/dc/dcmitype/',
  	'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
  	'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
  	'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
  	'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
  	'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
  	'xsd': 'http://www.w3.org/2001/XMLSchema'
  }/*:any*/);

  var XMLNS_main = [
  	'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
  	'http://purl.oclc.org/ooxml/spreadsheetml/main',
  	'http://schemas.microsoft.com/office/excel/2006/main',
  	'http://schemas.microsoft.com/office/excel/2006/2'
  ];
  function read_double_le(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ {
  	var s = 1 - 2 * (b[idx + 7] >>> 7);
  	var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
  	var m = (b[idx+6]&0x0f);
  	for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
  	if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
  	if(e == 0) e = -1022;
  	else { e -= 1023; m += Math.pow(2,52); }
  	return s * Math.pow(2, e - 52) * m;
  }

  function write_double_le(b/*:RawBytes|CFBlob*/, v/*:number*/, idx/*:number*/) {
  	var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
  	var av = bs ? (-v) : v;
  	if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
  	else if(av == 0) e = m = 0;
  	else {
  		e = Math.floor(Math.log(av) / Math.LN2);
  		m = av * Math.pow(2, 52 - e);
  		if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
  		else { m -= Math.pow(2,52); e+=1023; }
  	}
  	for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
  	b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
  	b[idx + 7] = (e >> 4) | bs;
  }

  var ___toBuffer = function(bufs/*:Array<Array<RawBytes> >*/)/*:RawBytes*/ { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
  var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;

  var ___utf16le = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
  var __utf16le = has_buf ? function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/)/*:string*/ { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;

  var ___hexlify = function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { var ss/*:Array<string>*/=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
  var __hexlify = has_buf ? function(b/*:RawBytes|CFBlob*/,s/*:number*/,l/*:number*/)/*:string*/ { return Buffer.isBuffer(b)/*:: && b instanceof Buffer*/ ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;

  var ___utf8 = function(b/*:RawBytes|CFBlob*/,s/*:number*/,e/*:number*/) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
  var __utf8 = has_buf ? function utf8_b(b/*:RawBytes|CFBlob*/, s/*:number*/, e/*:number*/) { return (Buffer.isBuffer(b)/*:: && (b instanceof Buffer)*/) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;

  var ___lpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
  var __lpstr = ___lpstr;

  var ___cpstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
  var __cpstr = ___cpstr;

  var ___lpwstr = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
  var __lpwstr = ___lpwstr;

  var ___lpp4 = function lpp4_(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
  var __lpp4 = ___lpp4;

  var ___8lpp4 = function(b/*:RawBytes|CFBlob*/,i/*:number*/) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
  var __8lpp4 = ___8lpp4;

  var ___double = function(b/*:RawBytes|CFBlob*/, idx/*:number*/) { return read_double_le(b, idx);};
  var __double = ___double;

  var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };

  if(has_buf/*:: && typeof Buffer !== 'undefined'*/) {
  	__lpstr = function lpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
  	__cpstr = function cpstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
  	__lpwstr = function lpwstr_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
  	__lpp4 = function lpp4_b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
  	__8lpp4 = function lpp4_8b(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(!Buffer.isBuffer(b)/*:: || !(b instanceof Buffer)*/) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
  	__double = function double_(b/*:RawBytes|CFBlob*/, i/*:number*/) { if(Buffer.isBuffer(b)/*::&& b instanceof Buffer*/) return b.readDoubleLE(i); return ___double(b,i); };
  	is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
  }

  var __readUInt8 = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx]; };
  var __readUInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+1]*(1<<8))+b[idx]; };
  var __readInt16LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
  var __readUInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
  var __readInt32LE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
  var __readInt32BE = function(b/*:RawBytes|CFBlob*/, idx/*:number*/)/*:number*/ { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };

  function ReadShift(size/*:number*/, t/*:?string*/)/*:number|string*/ {
  	var o="", oI/*:: :number = 0*/, oR, oo=[], w, vv, i, loc;
  	switch(t) {
  		case 'dbcs':
  			loc = this.l;
  			if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
  			else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
  			size *= 2;
  			break;

  		case 'utf8': o = __utf8(this, this.l, this.l + size); break;
  		case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;

  		case 'wstr':
  			return ReadShift.call(this, size, 'dbcs');

  		/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
  		case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
  		case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
  		/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
  		case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
  		/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
  		case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
  		/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
  		case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;

  		case 'cstr': size = 0; o = "";
  			while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
  			o = oo.join(""); break;
  		case '_wstr': size = 0; o = "";
  			while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
  			size+=2; o = oo.join(""); break;

  		/* sbcs and dbcs support continue records in the SST way TODO codepages */
  		case 'dbcs-cont': o = ""; loc = this.l;
  			for(i = 0; i < size; ++i) {
  				if(this.lens && this.lens.indexOf(loc) !== -1) {
  					w = __readUInt8(this, loc);
  					this.l = loc + 1;
  					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
  					return oo.join("") + vv;
  				}
  				oo.push(_getchar(__readUInt16LE(this, loc)));
  				loc+=2;
  			} o = oo.join(""); size *= 2; break;

  		case 'cpstr':
  		/* falls through */
  		case 'sbcs-cont': o = ""; loc = this.l;
  			for(i = 0; i != size; ++i) {
  				if(this.lens && this.lens.indexOf(loc) !== -1) {
  					w = __readUInt8(this, loc);
  					this.l = loc + 1;
  					vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
  					return oo.join("") + vv;
  				}
  				oo.push(_getchar(__readUInt8(this, loc)));
  				loc+=1;
  			} o = oo.join(""); break;

  		default:
  	switch(size) {
  		case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
  		case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
  		case 4: case -4:
  			if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
  			else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
  		case 8: case -8:
  			if(t === 'f') {
  				if(size == 8) oR = __double(this, this.l);
  				else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
  				this.l += 8; return oR;
  			} else size = 8;
  		/* falls through */
  		case 16: o = __hexlify(this, this.l, size); break;
  	}}
  	this.l+=size; return o;
  }

  var __writeUInt32LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
  var __writeInt32LE  = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
  var __writeUInt16LE = function(b/*:RawBytes|CFBlob*/, val/*:number*/, idx/*:number*/)/*:void*/ { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };

  function WriteShift(t/*:number*/, val/*:string|number*/, f/*:?string*/)/*:any*/ {
  	var size = 0, i = 0;
  	if(f === 'dbcs') {
  		/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
  		for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
  		size = 2 * val.length;
  	} else if(f === 'sbcs') {
  		{
  			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
  			val = val.replace(/[^\x00-\x7F]/g, "_");
  			/*:: if(typeof val !== 'string') throw new Error("unreachable"); */
  			for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
  		}
  		size = val.length;
  	} else if(f === 'hex') {
  		for(; i < t; ++i) {
  			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
  			this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
  		} return this;
  	} else if(f === 'utf16le') {
  			/*:: if(typeof val !== "string") throw new Error("unreachable"); */
  			var end/*:number*/ = Math.min(this.l + t, this.length);
  			for(i = 0; i < Math.min(val.length, t); ++i) {
  				var cc = val.charCodeAt(i);
  				this[this.l++] = (cc & 0xff);
  				this[this.l++] = (cc >> 8);
  			}
  			while(this.l < end) this[this.l++] = 0;
  			return this;
  	} else /*:: if(typeof val === 'number') */ switch(t) {
  		case  1: size = 1; this[this.l] = val&0xFF; break;
  		case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
  		case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
  		case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
  		case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
  		/* falls through */
  		case 16: break;
  		case -4: size = 4; __writeInt32LE(this, val, this.l); break;
  	}
  	this.l += size; return this;
  }

  function CheckField(hexstr/*:string*/, fld/*:string*/)/*:void*/ {
  	var m = __hexlify(this,this.l,hexstr.length>>1);
  	if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
  	this.l += hexstr.length>>1;
  }

  function prep_blob(blob, pos/*:number*/)/*:void*/ {
  	blob.l = pos;
  	blob.read_shift = /*::(*/ReadShift/*:: :any)*/;
  	blob.chk = CheckField;
  	blob.write_shift = WriteShift;
  }

  function parsenoop(blob, length/*:: :number, opts?:any */) { blob.l += length; }

  function new_buf(sz/*:number*/)/*:Block*/ {
  	var o = new_raw_buf(sz);
  	prep_blob(o, 0);
  	return o;
  }

  /* [MS-XLSB] 2.1.4 Record */
  function recordhopper(data, cb/*:RecordHopperCB*/, opts/*:?any*/) {
  	if(!data) return;
  	var tmpbyte, cntbyte, length;
  	prep_blob(data, data.l || 0);
  	var L = data.length, RT = 0, tgt = 0;
  	while(data.l < L) {
  		RT = data.read_shift(1);
  		if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
  		var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
  		tmpbyte = data.read_shift(1);
  		length = tmpbyte & 0x7F;
  		for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
  		tgt = data.l + length;
  		var d = R.f && R.f(data, length, opts);
  		data.l = tgt;
  		if(cb(d, R, RT)) return;
  	}
  }

  /* control buffer usage for fixed-length buffers */
  function buf_array()/*:BufArray*/ {
  	var bufs/*:Array<Block>*/ = [], blksz = has_buf ? 256 : 2048;
  	var newblk = function ba_newblk(sz/*:number*/)/*:Block*/ {
  		var o/*:Block*/ = (new_buf(sz)/*:any*/);
  		prep_blob(o, 0);
  		return o;
  	};

  	var curbuf/*:Block*/ = newblk(blksz);

  	var endbuf = function ba_endbuf() {
  		if(!curbuf) return;
  		if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
  		if(curbuf.length > 0) bufs.push(curbuf);
  		curbuf = null;
  	};

  	var next = function ba_next(sz/*:number*/)/*:Block*/ {
  		if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
  		endbuf();
  		return (curbuf = newblk(Math.max(sz+1, blksz)));
  	};

  	var end = function ba_end() {
  		endbuf();
  		return bconcat(bufs);
  	};

  	var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };

  	return ({ next:next, push:push, end:end, _bufs:bufs }/*:any*/);
  }
  /* XLS ranges enforced */
  function shift_cell_xls(cell/*:CellAddress*/, tgt/*:any*/, opts/*:?any*/)/*:CellAddress*/ {
  	var out = dup(cell);
  	if(tgt.s) {
  		if(out.cRel) out.c += tgt.s.c;
  		if(out.rRel) out.r += tgt.s.r;
  	} else {
  		if(out.cRel) out.c += tgt.c;
  		if(out.rRel) out.r += tgt.r;
  	}
  	if(!opts || opts.biff < 12) {
  		while(out.c >= 0x100) out.c -= 0x100;
  		while(out.r >= 0x10000) out.r -= 0x10000;
  	}
  	return out;
  }

  function shift_range_xls(cell, range, opts) {
  	var out = dup(cell);
  	out.s = shift_cell_xls(out.s, range.s, opts);
  	out.e = shift_cell_xls(out.e, range.s, opts);
  	return out;
  }

  function encode_cell_xls(c/*:CellAddress*/, biff/*:number*/)/*:string*/ {
  	if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
  	if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
  	var s = encode_cell(c);
  	if(!c.cRel && c.cRel != null) s = fix_col(s);
  	if(!c.rRel && c.rRel != null) s = fix_row(s);
  	return s;
  }

  function encode_range_xls(r, opts)/*:string*/ {
  	if(r.s.r == 0 && !r.s.rRel) {
  		if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
  			return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
  		}
  	}
  	if(r.s.c == 0 && !r.s.cRel) {
  		if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
  			return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
  		}
  	}
  	return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
  }
  function decode_row(rowstr/*:string*/)/*:number*/ { return parseInt(unfix_row(rowstr),10) - 1; }
  function encode_row(row/*:number*/)/*:string*/ { return "" + (row + 1); }
  function fix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
  function unfix_row(cstr/*:string*/)/*:string*/ { return cstr.replace(/\$(\d+)$/,"$1"); }

  function decode_col(colstr/*:string*/)/*:number*/ { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
  function encode_col(col/*:number*/)/*:string*/ { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
  function fix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^([A-Z])/,"$$$1"); }
  function unfix_col(cstr/*:string*/)/*:string*/ { return cstr.replace(/^\$([A-Z])/,"$1"); }

  function split_cell(cstr/*:string*/)/*:Array<string>*/ { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
  //function decode_cell(cstr/*:string*/)/*:CellAddress*/ { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
  function decode_cell(cstr/*:string*/)/*:CellAddress*/ {
  	var R = 0, C = 0;
  	for(var i = 0; i < cstr.length; ++i) {
  		var cc = cstr.charCodeAt(i);
  		if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
  		else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
  	}
  	return { c: C - 1, r:R - 1 };
  }
  //function encode_cell(cell/*:CellAddress*/)/*:string*/ { return encode_col(cell.c) + encode_row(cell.r); }
  function encode_cell(cell/*:CellAddress*/)/*:string*/ {
  	var col = cell.c + 1;
  	var s="";
  	for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
  	return s + (cell.r + 1);
  }
  function decode_range(range/*:string*/)/*:Range*/ {
  	var idx = range.indexOf(":");
  	if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
  	return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
  }
  /*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */
  function encode_range(cs/*:CellAddrSpec|Range*/,ce/*:?CellAddrSpec*/)/*:string*/ {
  	if(typeof ce === 'undefined' || typeof ce === 'number') {
  /*:: if(!(cs instanceof Range)) throw "unreachable"; */
  		return encode_range(cs.s, cs.e);
  	}
  /*:: if((cs instanceof Range)) throw "unreachable"; */
  	if(typeof cs !== 'string') cs = encode_cell((cs/*:any*/));
  	if(typeof ce !== 'string') ce = encode_cell((ce/*:any*/));
  /*:: if(typeof cs !== 'string') throw "unreachable"; */
  /*:: if(typeof ce !== 'string') throw "unreachable"; */
  	return cs == ce ? cs : cs + ":" + ce;
  }

  function safe_decode_range(range/*:string*/)/*:Range*/ {
  	var o = {s:{c:0,r:0},e:{c:0,r:0}};
  	var idx = 0, i = 0, cc = 0;
  	var len = range.length;
  	for(idx = 0; i < len; ++i) {
  		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
  		idx = 26*idx + cc;
  	}
  	o.s.c = --idx;

  	for(idx = 0; i < len; ++i) {
  		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
  		idx = 10*idx + cc;
  	}
  	o.s.r = --idx;

  	if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
  	++i;

  	for(idx = 0; i != len; ++i) {
  		if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
  		idx = 26*idx + cc;
  	}
  	o.e.c = --idx;

  	for(idx = 0; i != len; ++i) {
  		if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
  		idx = 10*idx + cc;
  	}
  	o.e.r = --idx;
  	return o;
  }

  function safe_format_cell(cell/*:Cell*/, v/*:any*/) {
  	var q = (cell.t == 'd' && v instanceof Date);
  	if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
  	try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
  }

  function format_cell(cell/*:Cell*/, v/*:any*/, o/*:any*/) {
  	if(cell == null || cell.t == null || cell.t == 'z') return "";
  	if(cell.w !== undefined) return cell.w;
  	if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
  	if(cell.t == "e") return BErr[cell.v] || cell.v;
  	if(v == undefined) return safe_format_cell(cell, cell.v);
  	return safe_format_cell(cell, v);
  }

  function sheet_to_workbook(sheet/*:Worksheet*/, opts)/*:Workbook*/ {
  	var n = opts && opts.sheet ? opts.sheet : "Sheet1";
  	var sheets = {}; sheets[n] = sheet;
  	return { SheetNames: [n], Sheets: sheets };
  }

  function sheet_add_aoa(_ws/*:?Worksheet*/, data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ {
  	var o = opts || {};
  	var dense = _ws ? Array.isArray(_ws) : o.dense;
  	var ws/*:Worksheet*/ = _ws || (dense ? ([]/*:any*/) : ({}/*:any*/));
  	var _R = 0, _C = 0;
  	if(ws && o.origin != null) {
  		if(typeof o.origin == 'number') _R = o.origin;
  		else {
  			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
  			_R = _origin.r; _C = _origin.c;
  		}
  		if(!ws["!ref"]) ws["!ref"] = "A1:A1";
  	}
  	var range/*:Range*/ = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}}/*:any*/);
  	if(ws['!ref']) {
  		var _range = safe_decode_range(ws['!ref']);
  		range.s.c = _range.s.c;
  		range.s.r = _range.s.r;
  		range.e.c = Math.max(range.e.c, _range.e.c);
  		range.e.r = Math.max(range.e.r, _range.e.r);
  		if(_R == -1) range.e.r = _R = _range.e.r + 1;
  	}
  	for(var R = 0; R != data.length; ++R) {
  		if(!data[R]) continue;
  		if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
  		for(var C = 0; C != data[R].length; ++C) {
  			if(typeof data[R][C] === 'undefined') continue;
  			var cell/*:Cell*/ = ({v: data[R][C] }/*:any*/);
  			var __R = _R + R, __C = _C + C;
  			if(range.s.r > __R) range.s.r = __R;
  			if(range.s.c > __C) range.s.c = __C;
  			if(range.e.r < __R) range.e.r = __R;
  			if(range.e.c < __C) range.e.c = __C;
  			if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
  			else {
  				if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
  				if(cell.v === null) {
  					if(cell.f) cell.t = 'n';
  					else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
  					else if(!o.sheetStubs) continue;
  					else cell.t = 'z';
  				}
  				else if(typeof cell.v === 'number') cell.t = 'n';
  				else if(typeof cell.v === 'boolean') cell.t = 'b';
  				else if(cell.v instanceof Date) {
  					cell.z = o.dateNF || table_fmt[14];
  					if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
  					else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
  				}
  				else cell.t = 's';
  			}
  			if(dense) {
  				if(!ws[__R]) ws[__R] = [];
  				if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
  				ws[__R][__C] = cell;
  			} else {
  				var cell_ref = encode_cell(({c:__C,r:__R}/*:any*/));
  				if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
  				ws[cell_ref] = cell;
  			}
  		}
  	}
  	if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
  	return ws;
  }
  function aoa_to_sheet(data/*:AOA*/, opts/*:?any*/)/*:Worksheet*/ { return sheet_add_aoa(null, data, opts); }

  function parse_Int32LE(data) {
  	return data.read_shift(4, 'i');
  }

  /* [MS-XLSB] 2.5.168 */
  function parse_XLWideString(data/*::, length*/)/*:string*/ {
  	var cchCharacters = data.read_shift(4);
  	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
  }

  /* [MS-XLSB] 2.5.91 */
  //function parse_LPWideString(data/*::, length*/)/*:string*/ {
  //	var cchCharacters = data.read_shift(2);
  //	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
  //}

  /* [MS-XLSB] 2.5.143 */
  function parse_StrRun(data) {
  	return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
  }

  /* [MS-XLSB] 2.5.121 */
  function parse_RichStr(data, length/*:number*/)/*:XLString*/ {
  	var start = data.l;
  	var flags = data.read_shift(1);
  	var str = parse_XLWideString(data);
  	var rgsStrRun = [];
  	var z = ({ t: str, h: str }/*:any*/);
  	if ((flags & 1) !== 0) { /* fRichStr */
  		/* TODO: formatted string */
  		var dwSizeStrRun = data.read_shift(4);
  		for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
  		z.r = rgsStrRun;
  	}
  	else z.r = [{ ich: 0, ifnt: 0 }];
  	//if((flags & 2) !== 0) { /* fExtStr */
  	//	/* TODO: phonetic string */
  	//}
  	data.l = start + length;
  	return z;
  }
  /* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
  var parse_BrtCommentText = parse_RichStr;

  /* [MS-XLSB] 2.5.9 */
  function parse_XLSBCell(data)/*:any*/ {
  	var col = data.read_shift(4);
  	var iStyleRef = data.read_shift(2);
  	iStyleRef += data.read_shift(1) << 16;
  	data.l++; //var fPhShow = data.read_shift(1);
  	return { c: col, iStyleRef: iStyleRef };
  }

  /* Short XLSB Cell does not include column */
  function parse_XLSBShortCell(data)/*:any*/ {
  	var iStyleRef = data.read_shift(2);
  	iStyleRef += data.read_shift(1) <<16;
  	data.l++; //var fPhShow = data.read_shift(1);
  	return { c:-1, iStyleRef: iStyleRef };
  }

  /* [MS-XLSB] 2.5.21 */
  var parse_XLSBCodeName = parse_XLWideString;

  /* [MS-XLSB] 2.5.166 */
  function parse_XLNullableWideString(data/*::, length*/)/*:string*/ {
  	var cchCharacters = data.read_shift(4);
  	return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
  }

  /* [MS-XLSB] 2.5.165 */
  var parse_XLNameWideString = parse_XLWideString;
  //var write_XLNameWideString = write_XLWideString;

  /* [MS-XLSB] 2.5.114 */
  var parse_RelID = parse_XLNullableWideString;


  /* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
  function parse_RkNumber(data)/*:number*/ {
  	var b = data.slice(data.l, data.l + 4);
  	var fX100 = (b[0] & 1), fInt = (b[0] & 2);
  	data.l += 4;
  	var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
  	return fX100 ? (RK / 100) : RK;
  }


  /* [MS-XLSB] 2.5.117 RfX */
  function parse_RfX(data /*::, length*/)/*:Range*/ {
  	var cell/*:Range*/ = ({ s: {}, e: {} }/*:any*/);
  	cell.s.r = data.read_shift(4);
  	cell.e.r = data.read_shift(4);
  	cell.s.c = data.read_shift(4);
  	cell.e.c = data.read_shift(4);
  	return cell;
  }

  /* [MS-XLSB] 2.5.153 UncheckedRfX */
  var parse_UncheckedRfX = parse_RfX;

  /* [MS-XLSB] 2.5.155 UncheckedSqRfX */
  //function parse_UncheckedSqRfX(data) {
  //	var cnt = data.read_shift(4);
  //	var out = [];
  //	for(var i = 0; i < cnt; ++i) {
  //		var rng = parse_UncheckedRfX(data);
  //		out.push(encode_range(rng));
  //	}
  //	return out.join(",");
  //}
  //function write_UncheckedSqRfX(sqrfx/*:string*/) {
  //	var parts = sqrfx.split(/\s*,\s*/);
  //	var o = new_buf(4); o.write_shift(4, parts.length);
  //	var out = [o];
  //	parts.forEach(function(rng) {
  //		out.push(write_UncheckedRfX(safe_decode_range(rng)));
  //	});
  //	return bconcat(out);
  //}

  /* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
  /* TODO: error checking, NaN and Infinity values are not valid Xnum */
  function parse_Xnum(data/*::, length*/) {
  	if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
  	return data.read_shift(8, 'f');
  }

  /* [MS-XLSB] 2.4.324 BrtColor */
  function parse_BrtColor(data/*::, length*/) {
  	var out = {};
  	var d = data.read_shift(1);

  	//var fValidRGB = d & 1;
  	var xColorType = d >>> 1;

  	var index = data.read_shift(1);
  	var nTS = data.read_shift(2, 'i');
  	var bR = data.read_shift(1);
  	var bG = data.read_shift(1);
  	var bB = data.read_shift(1);
  	data.l++; //var bAlpha = data.read_shift(1);

  	switch (xColorType) {
  		case 0: out.auto = 1; break;
  		case 1:
  			out.index = index;
  			var icv = XLSIcv[index];
  			/* automatic pseudo index 81 */
  			if (icv) out.rgb = rgb2Hex(icv);
  			break;
  		case 2:
  			/* if(!fValidRGB) throw new Error("invalid"); */
  			out.rgb = rgb2Hex([bR, bG, bB]);
  			break;
  		case 3: out.theme = index; break;
  	}
  	if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;

  	return out;
  }

  /* [MS-XLSB] 2.5.52 */
  function parse_FontFlags(data/*::, length, opts*/) {
  	var d = data.read_shift(1);
  	data.l++;
  	var out = {
  		fBold: d & 0x01,
  		fItalic: d & 0x02,
  		fUnderline: d & 0x04,
  		fStrikeout: d & 0x08,
  		fOutline: d & 0x10,
  		fShadow: d & 0x20,
  		fCondense: d & 0x40,
  		fExtend: d & 0x80
  	};
  	return out;
  }

  /* [MS-OLEDS] 2.3.1 and 2.3.2 */
  function parse_ClipboardFormatOrString(o, w/*:number*/)/*:string*/ {
  	// $FlowIgnore
  	var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
  	var m/*:number*/ = o.read_shift(4);
  	switch (m) {
  		case 0x00000000: return "";
  		case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
  	}
  	if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
  	o.l -= 4;
  	return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
  }
  function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
  function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }

  /* [MS-OLEPS] 2.2 PropertyType */
  // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
  //var VT_EMPTY    = 0x0000;
  //var VT_NULL     = 0x0001;
  var VT_I2       = 0x0002;
  var VT_I4       = 0x0003;
  //var VT_R4       = 0x0004;
  //var VT_R8       = 0x0005;
  //var VT_CY       = 0x0006;
  //var VT_DATE     = 0x0007;
  //var VT_BSTR     = 0x0008;
  //var VT_ERROR    = 0x000A;
  var VT_BOOL     = 0x000B;
  var VT_VARIANT  = 0x000C;
  //var VT_DECIMAL  = 0x000E;
  //var VT_I1       = 0x0010;
  //var VT_UI1      = 0x0011;
  //var VT_UI2      = 0x0012;
  var VT_UI4      = 0x0013;
  //var VT_LPWSTR   = 0x001F;
  var VT_FILETIME = 0x0040;
  var VT_BLOB     = 0x0041;
  //var VT_STREAM   = 0x0042;
  //var VT_STORAGE  = 0x0043;
  //var VT_STREAMED_Object  = 0x0044;
  //var VT_STORED_Object    = 0x0045;
  //var VT_BLOB_Object      = 0x0046;
  var VT_CF       = 0x0047;
  var VT_VECTOR_VARIANT = 0x100C;
  var VT_VECTOR_LPSTR   = 0x101E;
  //var VT_ARRAY    = 0x2000;

  var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
  var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
  var VT_CUSTOM   = [VT_STRING, VT_USTR];

  /* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
  var DocSummaryPIDDSI = {
  	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
  	/*::[*/0x02/*::]*/: { n: 'Category', t: VT_STRING },
  	/*::[*/0x03/*::]*/: { n: 'PresentationFormat', t: VT_STRING },
  	/*::[*/0x04/*::]*/: { n: 'ByteCount', t: VT_I4 },
  	/*::[*/0x05/*::]*/: { n: 'LineCount', t: VT_I4 },
  	/*::[*/0x06/*::]*/: { n: 'ParagraphCount', t: VT_I4 },
  	/*::[*/0x07/*::]*/: { n: 'SlideCount', t: VT_I4 },
  	/*::[*/0x08/*::]*/: { n: 'NoteCount', t: VT_I4 },
  	/*::[*/0x09/*::]*/: { n: 'HiddenCount', t: VT_I4 },
  	/*::[*/0x0a/*::]*/: { n: 'MultimediaClipCount', t: VT_I4 },
  	/*::[*/0x0b/*::]*/: { n: 'ScaleCrop', t: VT_BOOL },
  	/*::[*/0x0c/*::]*/: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
  	/*::[*/0x0d/*::]*/: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
  	/*::[*/0x0e/*::]*/: { n: 'Manager', t: VT_STRING },
  	/*::[*/0x0f/*::]*/: { n: 'Company', t: VT_STRING },
  	/*::[*/0x10/*::]*/: { n: 'LinksUpToDate', t: VT_BOOL },
  	/*::[*/0x11/*::]*/: { n: 'CharacterCount', t: VT_I4 },
  	/*::[*/0x13/*::]*/: { n: 'SharedDoc', t: VT_BOOL },
  	/*::[*/0x16/*::]*/: { n: 'HyperlinksChanged', t: VT_BOOL },
  	/*::[*/0x17/*::]*/: { n: 'AppVersion', t: VT_I4, p: 'version' },
  	/*::[*/0x18/*::]*/: { n: 'DigSig', t: VT_BLOB },
  	/*::[*/0x1A/*::]*/: { n: 'ContentType', t: VT_STRING },
  	/*::[*/0x1B/*::]*/: { n: 'ContentStatus', t: VT_STRING },
  	/*::[*/0x1C/*::]*/: { n: 'Language', t: VT_STRING },
  	/*::[*/0x1D/*::]*/: { n: 'Version', t: VT_STRING },
  	/*::[*/0xFF/*::]*/: {},
  	/* [MS-OLEPS] 2.18 */
  	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
  	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
  	/*::[*/0x72627262/*::]*/: {}
  };

  /* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
  var SummaryPIDSI = {
  	/*::[*/0x01/*::]*/: { n: 'CodePage', t: VT_I2 },
  	/*::[*/0x02/*::]*/: { n: 'Title', t: VT_STRING },
  	/*::[*/0x03/*::]*/: { n: 'Subject', t: VT_STRING },
  	/*::[*/0x04/*::]*/: { n: 'Author', t: VT_STRING },
  	/*::[*/0x05/*::]*/: { n: 'Keywords', t: VT_STRING },
  	/*::[*/0x06/*::]*/: { n: 'Comments', t: VT_STRING },
  	/*::[*/0x07/*::]*/: { n: 'Template', t: VT_STRING },
  	/*::[*/0x08/*::]*/: { n: 'LastAuthor', t: VT_STRING },
  	/*::[*/0x09/*::]*/: { n: 'RevNumber', t: VT_STRING },
  	/*::[*/0x0A/*::]*/: { n: 'EditTime', t: VT_FILETIME },
  	/*::[*/0x0B/*::]*/: { n: 'LastPrinted', t: VT_FILETIME },
  	/*::[*/0x0C/*::]*/: { n: 'CreatedDate', t: VT_FILETIME },
  	/*::[*/0x0D/*::]*/: { n: 'ModifiedDate', t: VT_FILETIME },
  	/*::[*/0x0E/*::]*/: { n: 'PageCount', t: VT_I4 },
  	/*::[*/0x0F/*::]*/: { n: 'WordCount', t: VT_I4 },
  	/*::[*/0x10/*::]*/: { n: 'CharCount', t: VT_I4 },
  	/*::[*/0x11/*::]*/: { n: 'Thumbnail', t: VT_CF },
  	/*::[*/0x12/*::]*/: { n: 'Application', t: VT_STRING },
  	/*::[*/0x13/*::]*/: { n: 'DocSecurity', t: VT_I4 },
  	/*::[*/0xFF/*::]*/: {},
  	/* [MS-OLEPS] 2.18 */
  	/*::[*/0x80000000/*::]*/: { n: 'Locale', t: VT_UI4 },
  	/*::[*/0x80000003/*::]*/: { n: 'Behavior', t: VT_UI4 },
  	/*::[*/0x72627262/*::]*/: {}
  };

  /* [MS-XLS] 2.4.63 Country/Region codes */
  var CountryEnum = {
  	/*::[*/0x0001/*::]*/: "US", // United States
  	/*::[*/0x0002/*::]*/: "CA", // Canada
  	/*::[*/0x0003/*::]*/: "", // Latin America (except Brazil)
  	/*::[*/0x0007/*::]*/: "RU", // Russia
  	/*::[*/0x0014/*::]*/: "EG", // Egypt
  	/*::[*/0x001E/*::]*/: "GR", // Greece
  	/*::[*/0x001F/*::]*/: "NL", // Netherlands
  	/*::[*/0x0020/*::]*/: "BE", // Belgium
  	/*::[*/0x0021/*::]*/: "FR", // France
  	/*::[*/0x0022/*::]*/: "ES", // Spain
  	/*::[*/0x0024/*::]*/: "HU", // Hungary
  	/*::[*/0x0027/*::]*/: "IT", // Italy
  	/*::[*/0x0029/*::]*/: "CH", // Switzerland
  	/*::[*/0x002B/*::]*/: "AT", // Austria
  	/*::[*/0x002C/*::]*/: "GB", // United Kingdom
  	/*::[*/0x002D/*::]*/: "DK", // Denmark
  	/*::[*/0x002E/*::]*/: "SE", // Sweden
  	/*::[*/0x002F/*::]*/: "NO", // Norway
  	/*::[*/0x0030/*::]*/: "PL", // Poland
  	/*::[*/0x0031/*::]*/: "DE", // Germany
  	/*::[*/0x0034/*::]*/: "MX", // Mexico
  	/*::[*/0x0037/*::]*/: "BR", // Brazil
  	/*::[*/0x003d/*::]*/: "AU", // Australia
  	/*::[*/0x0040/*::]*/: "NZ", // New Zealand
  	/*::[*/0x0042/*::]*/: "TH", // Thailand
  	/*::[*/0x0051/*::]*/: "JP", // Japan
  	/*::[*/0x0052/*::]*/: "KR", // Korea
  	/*::[*/0x0054/*::]*/: "VN", // Viet Nam
  	/*::[*/0x0056/*::]*/: "CN", // China
  	/*::[*/0x005A/*::]*/: "TR", // Turkey
  	/*::[*/0x0069/*::]*/: "JS", // Ramastan
  	/*::[*/0x00D5/*::]*/: "DZ", // Algeria
  	/*::[*/0x00D8/*::]*/: "MA", // Morocco
  	/*::[*/0x00DA/*::]*/: "LY", // Libya
  	/*::[*/0x015F/*::]*/: "PT", // Portugal
  	/*::[*/0x0162/*::]*/: "IS", // Iceland
  	/*::[*/0x0166/*::]*/: "FI", // Finland
  	/*::[*/0x01A4/*::]*/: "CZ", // Czech Republic
  	/*::[*/0x0376/*::]*/: "TW", // Taiwan
  	/*::[*/0x03C1/*::]*/: "LB", // Lebanon
  	/*::[*/0x03C2/*::]*/: "JO", // Jordan
  	/*::[*/0x03C3/*::]*/: "SY", // Syria
  	/*::[*/0x03C4/*::]*/: "IQ", // Iraq
  	/*::[*/0x03C5/*::]*/: "KW", // Kuwait
  	/*::[*/0x03C6/*::]*/: "SA", // Saudi Arabia
  	/*::[*/0x03CB/*::]*/: "AE", // United Arab Emirates
  	/*::[*/0x03CC/*::]*/: "IL", // Israel
  	/*::[*/0x03CE/*::]*/: "QA", // Qatar
  	/*::[*/0x03D5/*::]*/: "IR", // Iran
  	/*::[*/0xFFFF/*::]*/: "US"  // United States
  };

  /* [MS-XLS] 2.5.127 */
  var XLSFillPattern = [
  	null,
  	'solid',
  	'mediumGray',
  	'darkGray',
  	'lightGray',
  	'darkHorizontal',
  	'darkVertical',
  	'darkDown',
  	'darkUp',
  	'darkGrid',
  	'darkTrellis',
  	'lightHorizontal',
  	'lightVertical',
  	'lightDown',
  	'lightUp',
  	'lightGrid',
  	'lightTrellis',
  	'gray125',
  	'gray0625'
  ];

  function rgbify(arr/*:Array<number>*/)/*:Array<[number, number, number]>*/ { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }

  /* [MS-XLS] 2.5.161 */
  /* [MS-XLSB] 2.5.75 Icv */
  var _XLSIcv = /*#__PURE__*/ rgbify([
  	/* Color Constants */
  	0x000000,
  	0xFFFFFF,
  	0xFF0000,
  	0x00FF00,
  	0x0000FF,
  	0xFFFF00,
  	0xFF00FF,
  	0x00FFFF,

  	/* Overridable Defaults */
  	0x000000,
  	0xFFFFFF,
  	0xFF0000,
  	0x00FF00,
  	0x0000FF,
  	0xFFFF00,
  	0xFF00FF,
  	0x00FFFF,

  	0x800000,
  	0x008000,
  	0x000080,
  	0x808000,
  	0x800080,
  	0x008080,
  	0xC0C0C0,
  	0x808080,
  	0x9999FF,
  	0x993366,
  	0xFFFFCC,
  	0xCCFFFF,
  	0x660066,
  	0xFF8080,
  	0x0066CC,
  	0xCCCCFF,

  	0x000080,
  	0xFF00FF,
  	0xFFFF00,
  	0x00FFFF,
  	0x800080,
  	0x800000,
  	0x008080,
  	0x0000FF,
  	0x00CCFF,
  	0xCCFFFF,
  	0xCCFFCC,
  	0xFFFF99,
  	0x99CCFF,
  	0xFF99CC,
  	0xCC99FF,
  	0xFFCC99,

  	0x3366FF,
  	0x33CCCC,
  	0x99CC00,
  	0xFFCC00,
  	0xFF9900,
  	0xFF6600,
  	0x666699,
  	0x969696,
  	0x003366,
  	0x339966,
  	0x003300,
  	0x333300,
  	0x993300,
  	0x993366,
  	0x333399,
  	0x333333,

  	/* Other entries to appease BIFF8/12 */
  	0xFFFFFF, /* 0x40 icvForeground ?? */
  	0x000000, /* 0x41 icvBackground ?? */
  	0x000000, /* 0x42 icvFrame ?? */
  	0x000000, /* 0x43 icv3D ?? */
  	0x000000, /* 0x44 icv3DText ?? */
  	0x000000, /* 0x45 icv3DHilite ?? */
  	0x000000, /* 0x46 icv3DShadow ?? */
  	0x000000, /* 0x47 icvHilite ?? */
  	0x000000, /* 0x48 icvCtlText ?? */
  	0x000000, /* 0x49 icvCtlScrl ?? */
  	0x000000, /* 0x4A icvCtlInv ?? */
  	0x000000, /* 0x4B icvCtlBody ?? */
  	0x000000, /* 0x4C icvCtlFrame ?? */
  	0x000000, /* 0x4D icvCtlFore ?? */
  	0x000000, /* 0x4E icvCtlBack ?? */
  	0x000000, /* 0x4F icvCtlNeutral */
  	0x000000, /* 0x50 icvInfoBk ?? */
  	0x000000 /* 0x51 icvInfoText ?? */
  ]);
  var XLSIcv = /*#__PURE__*/dup(_XLSIcv);

  /* [MS-XLSB] 2.5.97.2 */
  var BErr = {
  	/*::[*/0x00/*::]*/: "#NULL!",
  	/*::[*/0x07/*::]*/: "#DIV/0!",
  	/*::[*/0x0F/*::]*/: "#VALUE!",
  	/*::[*/0x17/*::]*/: "#REF!",
  	/*::[*/0x1D/*::]*/: "#NAME?",
  	/*::[*/0x24/*::]*/: "#NUM!",
  	/*::[*/0x2A/*::]*/: "#N/A",
  	/*::[*/0x2B/*::]*/: "#GETTING_DATA",
  	/*::[*/0xFF/*::]*/: "#WTF?"
  };
  //var RBErr = evert_num(BErr);
  var RBErr = {
  	"#NULL!":        0x00,
  	"#DIV/0!":       0x07,
  	"#VALUE!":       0x0F,
  	"#REF!":         0x17,
  	"#NAME?":        0x1D,
  	"#NUM!":         0x24,
  	"#N/A":          0x2A,
  	"#GETTING_DATA": 0x2B,
  	"#WTF?":         0xFF
  };

  /* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
  /* 12.3 Part Summary <SpreadsheetML> */
  /* 14.2 Part Summary <DrawingML> */
  /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
  var ct2type/*{[string]:string}*/ = ({
  	/* Workbook */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  	"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  	"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  	"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",

  	/* Worksheet */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  	"application/vnd.ms-excel.worksheet": "sheets",
  	"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */

  	/* Chartsheet */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  	"application/vnd.ms-excel.chartsheet": "charts",

  	/* Macrosheet */
  	"application/vnd.ms-excel.macrosheet+xml": "macros",
  	"application/vnd.ms-excel.macrosheet": "macros",
  	"application/vnd.ms-excel.intlmacrosheet": "TODO",
  	"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */

  	/* Dialogsheet */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  	"application/vnd.ms-excel.dialogsheet": "dialogs",

  	/* Shared Strings */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  	"application/vnd.ms-excel.sharedStrings": "strs",

  	/* Styles */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  	"application/vnd.ms-excel.styles": "styles",

  	/* File Properties */
  	"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  	"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  	"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",

  	/* Custom Data Properties */
  	"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",

  	/* Comments */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  	"application/vnd.ms-excel.comments": "comments",
  	"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  	"application/vnd.ms-excel.person+xml": "people",

  	/* Metadata (Stock/Geography and Dynamic Array) */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  	"application/vnd.ms-excel.sheetMetadata": "metadata",

  	/* PivotTable */
  	"application/vnd.ms-excel.pivotTable": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",

  	/* Chart Objects */
  	"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",

  	/* Chart Colors */
  	"application/vnd.ms-office.chartcolorstyle+xml": "TODO",

  	/* Chart Style */
  	"application/vnd.ms-office.chartstyle+xml": "TODO",

  	/* Chart Advanced */
  	"application/vnd.ms-office.chartex+xml": "TODO",

  	/* Calculation Chain */
  	"application/vnd.ms-excel.calcChain": "calcchains",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",

  	/* Printer Settings */
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",

  	/* ActiveX */
  	"application/vnd.ms-office.activeX": "TODO",
  	"application/vnd.ms-office.activeX+xml": "TODO",

  	/* Custom Toolbars */
  	"application/vnd.ms-excel.attachedToolbars": "TODO",

  	/* External Data Connections */
  	"application/vnd.ms-excel.connections": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",

  	/* External Links */
  	"application/vnd.ms-excel.externalLink": "links",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",

  	/* PivotCache */
  	"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  	"application/vnd.ms-excel.pivotCacheRecords": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",

  	/* Query Table */
  	"application/vnd.ms-excel.queryTable": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",

  	/* Shared Workbook */
  	"application/vnd.ms-excel.userNames": "TODO",
  	"application/vnd.ms-excel.revisionHeaders": "TODO",
  	"application/vnd.ms-excel.revisionLog": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",

  	/* Single Cell Table */
  	"application/vnd.ms-excel.tableSingleCells": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",

  	/* Slicer */
  	"application/vnd.ms-excel.slicer": "TODO",
  	"application/vnd.ms-excel.slicerCache": "TODO",
  	"application/vnd.ms-excel.slicer+xml": "TODO",
  	"application/vnd.ms-excel.slicerCache+xml": "TODO",

  	/* Sort Map */
  	"application/vnd.ms-excel.wsSortMap": "TODO",

  	/* Table */
  	"application/vnd.ms-excel.table": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",

  	/* Themes */
  	"application/vnd.openxmlformats-officedocument.theme+xml": "themes",

  	/* Theme Override */
  	"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",

  	/* Timeline */
  	"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
  	"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */

  	/* VBA */
  	"application/vnd.ms-office.vbaProject": "vba",
  	"application/vnd.ms-office.vbaProjectSignature": "TODO",

  	/* Volatile Dependencies */
  	"application/vnd.ms-office.volatileDependencies": "TODO",
  	"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",

  	/* Control Properties */
  	"application/vnd.ms-excel.controlproperties+xml": "TODO",

  	/* Data Model */
  	"application/vnd.openxmlformats-officedocument.model+data": "TODO",

  	/* Survey */
  	"application/vnd.ms-excel.Survey+xml": "TODO",

  	/* Drawing */
  	"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  	"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  	"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",

  	/* VML */
  	"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",

  	"application/vnd.openxmlformats-package.relationships+xml": "rels",
  	"application/vnd.openxmlformats-officedocument.oleObject": "TODO",

  	/* Image */
  	"image/png": "TODO",

  	"sheet": "js"
  }/*:any*/);

  function new_ct()/*:any*/ {
  	return ({
  		workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
  		rels:[], strs:[], comments:[], threadedcomments:[], links:[],
  		coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
  		calcchains:[], vba: [], drawings: [], metadata: [], people:[],
  		TODO:[], xmlns: "" }/*:any*/);
  }

  function parse_ct(data/*:?string*/) {
  	var ct = new_ct();
  	if(!data || !data.match) return ct;
  	var ctext = {};
  	(data.match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(y[0].replace(nsregex,"<")) {
  			case '<?xml': break;
  			case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
  			case '<Default': ctext[y.Extension] = y.ContentType; break;
  			case '<Override':
  				if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
  				break;
  		}
  	});
  	if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
  	ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
  	ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
  	ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
  	ct.defaults = ctext;
  	delete ct.calcchains;
  	return ct;
  }
  /* 9.3 Relationships */
  var RELS = ({
  	WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  	SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  	HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  	VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  	XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  	XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  	XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  	CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  	CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  	CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  	CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  	EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
  	CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
  	SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  	STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  	THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  	CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  	CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  	CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  	WS: [
  		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
  		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  	],
  	DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  	MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  	IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  	DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  	XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  	TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  	PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  	VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
  }/*:any*/);


  /* 9.3.3 Representing Relationships */
  function get_rels_path(file/*:string*/)/*:string*/ {
  	var n = file.lastIndexOf("/");
  	return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
  }

  function parse_rels(data/*:?string*/, currentFilePath/*:string*/) {
  	var rels = {"!id":{}};
  	if (!data) return rels;
  	if (currentFilePath.charAt(0) !== '/') {
  		currentFilePath = '/'+currentFilePath;
  	}
  	var hash = {};

  	(data.match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		/* 9.3.2.2 OPC_Relationships */
  		if (y[0] === '<Relationship') {
  			var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
  			var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
  			rels[canonictarget] = rel;
  			hash[y.Id] = rel;
  		}
  	});
  	rels["!id"] = hash;
  	return rels;
  }
  /* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
  /* Part 3 Section 4 Manifest File */
  var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
  function parse_manifest(d, opts) {
  	var str = xlml_normalize(d);
  	var Rn;
  	var FEtag;
  	while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
  		case 'manifest': break; // 4.2 <manifest:manifest>
  		case 'file-entry': // 4.3 <manifest:file-entry>
  			FEtag = parsexmltag(Rn[0], false);
  			if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
  			break;
  		case 'encryption-data': // 4.4 <manifest:encryption-data>
  		case 'algorithm': // 4.5 <manifest:algorithm>
  		case 'start-key-generation': // 4.6 <manifest:start-key-generation>
  		case 'key-derivation': // 4.7 <manifest:key-derivation>
  			throw new Error("Unsupported ODS Encryption");
  		default: if(opts && opts.WTF) throw Rn;
  	}
  }

  /* ECMA-376 Part II 11.1 Core Properties Part */
  /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
  var CORE_PROPS/*:Array<Array<string> >*/ = [
  	["cp:category", "Category"],
  	["cp:contentStatus", "ContentStatus"],
  	["cp:keywords", "Keywords"],
  	["cp:lastModifiedBy", "LastAuthor"],
  	["cp:lastPrinted", "LastPrinted"],
  	["cp:revision", "RevNumber"],
  	["cp:version", "Version"],
  	["dc:creator", "Author"],
  	["dc:description", "Comments"],
  	["dc:identifier", "Identifier"],
  	["dc:language", "Language"],
  	["dc:subject", "Subject"],
  	["dc:title", "Title"],
  	["dcterms:created", "CreatedDate", 'date'],
  	["dcterms:modified", "ModifiedDate", 'date']
  ];

  var CORE_PROPS_REGEX/*:Array<RegExp>*/ = /*#__PURE__*/(function() {
  	var r = new Array(CORE_PROPS.length);
  	for(var i = 0; i < CORE_PROPS.length; ++i) {
  		var f = CORE_PROPS[i];
  		var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
  		r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
  	}
  	return r;
  })();

  function parse_core_props(data) {
  	var p = {};
  	data = utf8read(data);

  	for(var i = 0; i < CORE_PROPS.length; ++i) {
  		var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
  		if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
  		if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
  	}

  	return p;
  }
  /* 15.2.12.3 Extended File Properties Part */
  /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
  var EXT_PROPS/*:Array<Array<string> >*/ = [
  	["Application", "Application", "string"],
  	["AppVersion", "AppVersion", "string"],
  	["Company", "Company", "string"],
  	["DocSecurity", "DocSecurity", "string"],
  	["Manager", "Manager", "string"],
  	["HyperlinksChanged", "HyperlinksChanged", "bool"],
  	["SharedDoc", "SharedDoc", "bool"],
  	["LinksUpToDate", "LinksUpToDate", "bool"],
  	["ScaleCrop", "ScaleCrop", "bool"],
  	["HeadingPairs", "HeadingPairs", "raw"],
  	["TitlesOfParts", "TitlesOfParts", "raw"]
  ];
  function load_props_pairs(HP/*:string|Array<Array<any>>*/, TOP, props, opts) {
  	var v = [];
  	if(typeof HP == "string") v = parseVector(HP, opts);
  	else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
  	var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
  	var idx = 0, len = 0;
  	if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
  		len = +(v[i+1].v);
  		switch(v[i].v) {
  			case "Worksheets":
  			case "工作表":
  			case "Листы":
  			case "أوراق العمل":
  			case "ワークシート":
  			case "גליונות עבודה":
  			case "Arbeitsblätter":
  			case "Çalışma Sayfaları":
  			case "Feuilles de calcul":
  			case "Fogli di lavoro":
  			case "Folhas de cálculo":
  			case "Planilhas":
  			case "Regneark":
  			case "Hojas de cálculo":
  			case "Werkbladen":
  				props.Worksheets = len;
  				props.SheetNames = parts.slice(idx, idx + len);
  				break;

  			case "Named Ranges":
  			case "Rangos con nombre":
  			case "名前付き一覧":
  			case "Benannte Bereiche":
  			case "Navngivne områder":
  				props.NamedRanges = len;
  				props.DefinedNames = parts.slice(idx, idx + len);
  				break;

  			case "Charts":
  			case "Diagramme":
  				props.Chartsheets = len;
  				props.ChartNames = parts.slice(idx, idx + len);
  				break;
  		}
  		idx += len;
  	}
  }

  function parse_ext_props(data, p, opts) {
  	var q = {}; if(!p) p = {};
  	data = utf8read(data);

  	EXT_PROPS.forEach(function(f) {
  		var xml = (data.match(matchtag(f[0]))||[])[1];
  		switch(f[2]) {
  			case "string": if(xml) p[f[1]] = unescapexml(xml); break;
  			case "bool": p[f[1]] = xml === "true"; break;
  			case "raw":
  				var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
  				if(cur && cur.length > 0) q[f[1]] = cur[1];
  				break;
  		}
  	});

  	if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);

  	return p;
  }
  /* 15.2.12.2 Custom File Properties Part */
  var custregex = /<[^>]+>[^<]*/g;
  function parse_cust_props(data/*:string*/, opts) {
  	var p = {}, name = "";
  	var m = data.match(custregex);
  	if(m) for(var i = 0; i != m.length; ++i) {
  		var x = m[i], y = parsexmltag(x);
  		switch(y[0]) {
  			case '<?xml': break;
  			case '<Properties': break;
  			case '<property': name = unescapexml(y.name); break;
  			case '</property>': name = null; break;
  			default: if (x.indexOf('<vt:') === 0) {
  				var toks = x.split('>');
  				var type = toks[0].slice(4), text = toks[1];
  				/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
  				switch(type) {
  					case 'lpstr': case 'bstr': case 'lpwstr':
  						p[name] = unescapexml(text);
  						break;
  					case 'bool':
  						p[name] = parsexmlbool(text);
  						break;
  					case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
  						p[name] = parseInt(text, 10);
  						break;
  					case 'r4': case 'r8': case 'decimal':
  						p[name] = parseFloat(text);
  						break;
  					case 'filetime': case 'date':
  						p[name] = parseDate(text);
  						break;
  					case 'cy': case 'error':
  						p[name] = unescapexml(text);
  						break;
  					default:
  						if(type.slice(-1) == '/') break;
  						if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
  				}
  			} else if(x.slice(0,2) === "</") ; else if(opts.WTF) throw new Error(x);
  		}
  	}
  	return p;
  }
  /* Common Name -> XLML Name */
  var XLMLDocPropsMap = {
  	Title: 'Title',
  	Subject: 'Subject',
  	Author: 'Author',
  	Keywords: 'Keywords',
  	Comments: 'Description',
  	LastAuthor: 'LastAuthor',
  	RevNumber: 'Revision',
  	Application: 'AppName',
  	/* TotalTime: 'TotalTime', */
  	LastPrinted: 'LastPrinted',
  	CreatedDate: 'Created',
  	ModifiedDate: 'LastSaved',
  	/* Pages */
  	/* Words */
  	/* Characters */
  	Category: 'Category',
  	/* PresentationFormat */
  	Manager: 'Manager',
  	Company: 'Company',
  	/* Guid */
  	/* HyperlinkBase */
  	/* Bytes */
  	/* Lines */
  	/* Paragraphs */
  	/* CharactersWithSpaces */
  	AppVersion: 'Version',

  	ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
  	Identifier: 'Identifier', /* NOTE: missing from schema */
  	Language: 'Language' /* NOTE: missing from schema */
  };
  var evert_XLMLDPM;

  function xlml_set_prop(Props, tag/*:string*/, val) {
  	if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
  	tag = evert_XLMLDPM[tag] || tag;
  	Props[tag] = val;
  }
  /* [MS-DTYP] 2.3.3 FILETIME */
  /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
  /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
  function parse_FILETIME(blob) {
  	var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
  	return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
  }

  /* [MS-OSHARED] 2.3.3.1.4 Lpstr */
  function parse_lpstr(blob, type, pad/*:?number*/) {
  	var start = blob.l;
  	var str = blob.read_shift(0, 'lpstr-cp');
  	if(pad) while((blob.l - start) & 3) ++blob.l;
  	return str;
  }

  /* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
  function parse_lpwstr(blob, type, pad) {
  	var str = blob.read_shift(0, 'lpwstr');
  	if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
  	return str;
  }


  /* [MS-OSHARED] 2.3.3.1.11 VtString */
  /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
  function parse_VtStringBase(blob, stringType, pad) {
  	if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
  	return parse_lpstr(blob, stringType, pad);
  }

  function parse_VtString(blob, t/*:number*/, pad/*:?boolean*/) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
  function parse_VtUnalignedString(blob, t/*:number*/) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }

  /* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
  function parse_VtVecLpwstrValue(blob)/*:Array<string>*/ {
  	var length = blob.read_shift(4);
  	var ret/*:Array<string>*/ = [];
  	for(var i = 0; i != length; ++i) {
  		var start = blob.l;
  		ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
  		if((blob.l - start) & 0x02) blob.l += 2;
  	}
  	return ret;
  }

  /* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
  function parse_VtVecUnalignedLpstrValue(blob)/*:Array<string>*/ {
  	var length = blob.read_shift(4);
  	var ret/*:Array<string>*/ = [];
  	for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
  	return ret;
  }


  /* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
  function parse_VtHeadingPair(blob) {
  	var start = blob.l;
  	var headingString = parse_TypedPropertyValue(blob, VT_USTR);
  	if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
  	var headerParts = parse_TypedPropertyValue(blob, VT_I4);
  	return [headingString, headerParts];
  }

  /* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
  function parse_VtVecHeadingPairValue(blob) {
  	var cElements = blob.read_shift(4);
  	var out = [];
  	for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
  	return out;
  }

  /* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
  function parse_dictionary(blob,CodePage) {
  	var cnt = blob.read_shift(4);
  	var dict/*:{[number]:string}*/ = ({}/*:any*/);
  	for(var j = 0; j != cnt; ++j) {
  		var pid = blob.read_shift(4);
  		var len = blob.read_shift(4);
  		dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
  		if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
  	}
  	if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
  	return dict;
  }

  /* [MS-OLEPS] 2.9 BLOB */
  function parse_BLOB(blob) {
  	var size = blob.read_shift(4);
  	var bytes = blob.slice(blob.l,blob.l+size);
  	blob.l += size;
  	if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
  	return bytes;
  }

  /* [MS-OLEPS] 2.11 ClipboardData */
  function parse_ClipboardData(blob) {
  	// TODO
  	var o = {};
  	o.Size = blob.read_shift(4);
  	//o.Format = blob.read_shift(4);
  	blob.l += o.Size + 3 - (o.Size - 1) % 4;
  	return o;
  }

  /* [MS-OLEPS] 2.15 TypedPropertyValue */
  function parse_TypedPropertyValue(blob, type/*:number*/, _opts)/*:any*/ {
  	var t = blob.read_shift(2), ret, opts = _opts||{};
  	blob.l += 2;
  	if(type !== VT_VARIANT)
  	if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
  	switch(type === VT_VARIANT ? t : type) {
  		case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
  		case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
  		case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
  		case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
  		case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
  		case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
  		case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
  		case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
  		case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
  		case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
  		case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
  		case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
  		case 0x101E /*VT_VECTOR|VT_LPSTR*/:
  		case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
  			return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
  		default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
  	}
  }

  /* [MS-OLEPS] 2.20 PropertySet */
  function parse_PropertySet(blob, PIDSI) {
  	var start_addr = blob.l;
  	var size = blob.read_shift(4);
  	var NumProps = blob.read_shift(4);
  	var Props = [], i = 0;
  	var CodePage = 0;
  	var Dictionary = -1, DictObj/*:{[number]:string}*/ = ({}/*:any*/);
  	for(i = 0; i != NumProps; ++i) {
  		var PropID = blob.read_shift(4);
  		var Offset = blob.read_shift(4);
  		Props[i] = [PropID, Offset + start_addr];
  	}
  	Props.sort(function(x,y) { return x[1] - y[1]; });
  	var PropH = {};
  	for(i = 0; i != NumProps; ++i) {
  		if(blob.l !== Props[i][1]) {
  			var fail = true;
  			if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
  				case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
  				case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
  				case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
  			}
  			if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
  			if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
  		}
  		if(PIDSI) {
  			var piddsi = PIDSI[Props[i][0]];
  			PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
  			if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
  			if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
  				case 0: PropH[piddsi.n] = 1252;
  					/* falls through */
  				case 874:
  				case 932:
  				case 936:
  				case 949:
  				case 950:
  				case 1250:
  				case 1251:
  				case 1253:
  				case 1254:
  				case 1255:
  				case 1256:
  				case 1257:
  				case 1258:
  				case 10000:
  				case 1200:
  				case 1201:
  				case 1252:
  				case 65000: case -536:
  				case 65001: case -535:
  					set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
  				default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
  			}
  		} else {
  			if(Props[i][0] === 0x1) {
  				CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2)/*:number*/);
  				set_cp(CodePage);
  				if(Dictionary !== -1) {
  					var oldpos = blob.l;
  					blob.l = Props[Dictionary][1];
  					DictObj = parse_dictionary(blob,CodePage);
  					blob.l = oldpos;
  				}
  			} else if(Props[i][0] === 0) {
  				if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
  				DictObj = parse_dictionary(blob,CodePage);
  			} else {
  				var name = DictObj[Props[i][0]];
  				var val;
  				/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
  				switch(blob[blob.l]) {
  					case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
  					case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
  					case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
  					case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
  					case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
  					case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
  					case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
  					case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
  					default: throw new Error("unparsed value: " + blob[blob.l]);
  				}
  				PropH[name] = val;
  			}
  		}
  	}
  	blob.l = start_addr + size; /* step ahead to skip padding */
  	return PropH;
  }

  /* [MS-OLEPS] 2.21 PropertySetStream */
  function parse_PropertySetStream(file, PIDSI, clsid) {
  	var blob = file.content;
  	if(!blob) return ({}/*:any*/);
  	prep_blob(blob, 0);

  	var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
  	blob.chk('feff', 'Byte Order: ');

  	/*var vers = */blob.read_shift(2); // TODO: check version
  	var SystemIdentifier = blob.read_shift(4);
  	var CLSID = blob.read_shift(16);
  	if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
  	NumSets = blob.read_shift(4);
  	if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
  	FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);

  	if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
  	else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
  	var PSet0 = parse_PropertySet(blob, PIDSI);

  	var rval = ({ SystemIdentifier: SystemIdentifier }/*:any*/);
  	for(var y in PSet0) rval[y] = PSet0[y];
  	//rval.blob = blob;
  	rval.FMTID = FMTID0;
  	//rval.PSet0 = PSet0;
  	if(NumSets === 1) return rval;
  	if(Offset1 - blob.l == 2) blob.l += 2;
  	if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
  	var PSet1;
  	try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
  	for(y in PSet1) rval[y] = PSet1[y];
  	rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
  	return rval;
  }

  function parsenoop2(blob, length) { blob.read_shift(length); return null; }

  function parslurp(blob, length, cb) {
  	var arr = [], target = blob.l + length;
  	while(blob.l < target) arr.push(cb(blob, target - blob.l));
  	if(target !== blob.l) throw new Error("Slurp error");
  	return arr;
  }

  function parsebool(blob, length/*:number*/) { return blob.read_shift(length) === 0x1; }

  function parseuint16(blob/*::, length:?number, opts:?any*/) { return blob.read_shift(2, 'u'); }
  function parseuint16a(blob, length/*:: :?number, opts:?any*/) { return parslurp(blob,length,parseuint16);}

  /* --- 2.5 Structures --- */

  /* [MS-XLS] 2.5.10 Bes (boolean or error) */
  function parse_Bes(blob/*::, length*/) {
  	var v = blob.read_shift(1), t = blob.read_shift(1);
  	return t === 0x01 ? v : v === 0x01;
  }

  /* [MS-XLS] 2.5.240 ShortXLUnicodeString */
  function parse_ShortXLUnicodeString(blob, length, opts) {
  	var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
  	var encoding = 'sbcs-cont';
  	if(opts && opts.biff >= 8) ;
  	if(!opts || opts.biff == 8 ) {
  		var fHighByte = blob.read_shift(1);
  		if(fHighByte) { encoding = 'dbcs-cont'; }
  	} else if(opts.biff == 12) {
  		encoding = 'wstr';
  	}
  	if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
  	var o = cch ? blob.read_shift(cch, encoding) : "";
  	return o;
  }

  /* 2.5.293 XLUnicodeRichExtendedString */
  function parse_XLUnicodeRichExtendedString(blob) {
  	var cch = blob.read_shift(2), flags = blob.read_shift(1);
  	var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
  	var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
  	var cRun = 0, cbExtRst;
  	var z = {};
  	if(fRichSt) cRun = blob.read_shift(2);
  	if(fExtSt) cbExtRst = blob.read_shift(4);
  	var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
  	var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
  	if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
  	if(fExtSt) blob.l += cbExtRst; //TODO: parse this
  	z.t = msg;
  	if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
  	return z;
  }

  /* 2.5.296 XLUnicodeStringNoCch */
  function parse_XLUnicodeStringNoCch(blob, cch, opts) {
  	var retval;
  	if(opts) {
  		if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
  		if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
  	}
  	var fHighByte = blob.read_shift(1);
  	if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
  	else { retval = blob.read_shift(cch, 'dbcs-cont'); }
  	return retval;
  }

  /* 2.5.294 XLUnicodeString */
  function parse_XLUnicodeString(blob, length, opts) {
  	var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	if(cch === 0) { blob.l++; return ""; }
  	return parse_XLUnicodeStringNoCch(blob, cch, opts);
  }
  /* BIFF5 override */
  function parse_XLUnicodeString2(blob, length, opts) {
  	if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
  	var cch = blob.read_shift(1);
  	if(cch === 0) { blob.l++; return ""; }
  	return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
  }

  /* [MS-XLS] 2.5.61 ControlInfo */
  function parse_ControlInfo(blob/*::, length, opts*/) {
  	var flags = blob.read_shift(1);
  	blob.l++;
  	var accel = blob.read_shift(2);
  	blob.l += 2;
  	return [flags, accel];
  }

  /* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
  function parse_URLMoniker(blob/*::, length, opts*/) {
  	var len = blob.read_shift(4), start = blob.l;
  	var extra = false;
  	if(len > 24) {
  		/* look ahead */
  		blob.l += len - 24;
  		if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
  		blob.l = start;
  	}
  	var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
  	if(extra) blob.l += 24;
  	return url;
  }

  /* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
  function parse_FileMoniker(blob/*::, length*/) {
  	var cAnti = blob.read_shift(2);
  	var preamble = ""; while(cAnti-- > 0) preamble += "../";
  	var ansiPath = blob.read_shift(0, 'lpstr-ansi');
  	blob.l += 2; //var endServer = blob.read_shift(2);
  	if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
  	var sz = blob.read_shift(4);
  	if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
  	var bytes = blob.read_shift(4);
  	if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
  	var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
  	return preamble + unicodePath;
  }

  /* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
  function parse_HyperlinkMoniker(blob, length) {
  	var clsid = blob.read_shift(16);	switch(clsid) {
  		case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob);
  		case "0303000000000000c000000000000046": return parse_FileMoniker(blob);
  		default: throw new Error("Unsupported Moniker " + clsid);
  	}
  }

  /* [MS-OSHARED] 2.3.7.9 HyperlinkString */
  function parse_HyperlinkString(blob/*::, length*/) {
  	var len = blob.read_shift(4);
  	var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
  	return o;
  }

  /* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
  function parse_Hyperlink(blob, length)/*:Hyperlink*/ {
  	var end = blob.l + length;
  	var sVer = blob.read_shift(4);
  	if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
  	var flags = blob.read_shift(2);
  	blob.l += 2;
  	var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
  	if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
  	if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
  	if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
  	if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
  	if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
  	if(flags & 0x0020) guid = blob.read_shift(16);
  	if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
  	blob.l = end;
  	var target = targetFrameName||moniker||oleMoniker||"";
  	if(target && Loc) target+="#"+Loc;
  	if(!target) target = "#" + Loc;
  	if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
  	var out = ({Target:target}/*:any*/);
  	if(guid) out.guid = guid;
  	if(fileTime) out.time = fileTime;
  	if(displayName) out.Tooltip = displayName;
  	return out;
  }

  /* 2.5.178 LongRGBA */
  function parse_LongRGBA(blob/*::, length*/) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }

  /* 2.5.177 LongRGB */
  function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob); x[3] = 0; return x; }


  /* [MS-XLS] 2.5.19 */
  function parse_XLSCell(blob/*::, length*/)/*:Cell*/ {
  	var rw = blob.read_shift(2); // 0-indexed
  	var col = blob.read_shift(2);
  	var ixfe = blob.read_shift(2);
  	return ({r:rw, c:col, ixfe:ixfe}/*:any*/);
  }

  /* [MS-XLS] 2.5.134 */
  function parse_frtHeader(blob) {
  	var rt = blob.read_shift(2);
  	var flags = blob.read_shift(2); // TODO: parse these flags
  	blob.l += 8;
  	return {type: rt, flags: flags};
  }



  function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }

  /* [MS-XLS] 2.5.344 */
  function parse_XTI(blob, length, opts) {
  	var w = opts.biff > 8 ? 4 : 2;
  	var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
  	return [iSupBook, itabFirst, itabLast];
  }

  /* [MS-XLS] 2.5.218 */
  function parse_RkRec(blob) {
  	var ixfe = blob.read_shift(2);
  	var RK = parse_RkNumber(blob);
  	return [ixfe, RK];
  }

  /* [MS-XLS] 2.5.1 */
  function parse_AddinUdf(blob, length, opts) {
  	blob.l += 4; length -= 4;
  	var l = blob.l + length;
  	var udfName = parse_ShortXLUnicodeString(blob, length, opts);
  	var cb = blob.read_shift(2);
  	l -= blob.l;
  	if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
  	blob.l += cb;
  	return udfName;
  }

  /* [MS-XLS] 2.5.209 TODO: Check sizes */
  function parse_Ref8U(blob/*::, length*/) {
  	var rwFirst = blob.read_shift(2);
  	var rwLast = blob.read_shift(2);
  	var colFirst = blob.read_shift(2);
  	var colLast = blob.read_shift(2);
  	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
  }

  /* [MS-XLS] 2.5.211 */
  function parse_RefU(blob/*::, length*/) {
  	var rwFirst = blob.read_shift(2);
  	var rwLast = blob.read_shift(2);
  	var colFirst = blob.read_shift(1);
  	var colLast = blob.read_shift(1);
  	return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
  }

  /* [MS-XLS] 2.5.207 */
  var parse_Ref = parse_RefU;

  /* [MS-XLS] 2.5.143 */
  function parse_FtCmo(blob/*::, length*/) {
  	blob.l += 4;
  	var ot = blob.read_shift(2);
  	var id = blob.read_shift(2);
  	var flags = blob.read_shift(2);
  	blob.l+=12;
  	return [id, ot, flags];
  }

  /* [MS-XLS] 2.5.149 */
  function parse_FtNts(blob) {
  	var out = {};
  	blob.l += 4;
  	blob.l += 16; // GUID TODO
  	out.fSharedNote = blob.read_shift(2);
  	blob.l += 4;
  	return out;
  }

  /* [MS-XLS] 2.5.142 */
  function parse_FtCf(blob) {
  	var out = {};
  	blob.l += 4;
  	blob.cf = blob.read_shift(2);
  	return out;
  }

  /* [MS-XLS] 2.5.140 - 2.5.154 and friends */
  function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
  var FtTab = {
  	/*::[*/0x00/*::]*/: parse_FtSkip,      /* FtEnd */
  	/*::[*/0x04/*::]*/: parse_FtSkip,      /* FtMacro */
  	/*::[*/0x05/*::]*/: parse_FtSkip,      /* FtButton */
  	/*::[*/0x06/*::]*/: parse_FtSkip,      /* FtGmo */
  	/*::[*/0x07/*::]*/: parse_FtCf,        /* FtCf */
  	/*::[*/0x08/*::]*/: parse_FtSkip,      /* FtPioGrbit */
  	/*::[*/0x09/*::]*/: parse_FtSkip,      /* FtPictFmla */
  	/*::[*/0x0A/*::]*/: parse_FtSkip,      /* FtCbls */
  	/*::[*/0x0B/*::]*/: parse_FtSkip,      /* FtRbo */
  	/*::[*/0x0C/*::]*/: parse_FtSkip,      /* FtSbs */
  	/*::[*/0x0D/*::]*/: parse_FtNts,       /* FtNts */
  	/*::[*/0x0E/*::]*/: parse_FtSkip,      /* FtSbsFmla */
  	/*::[*/0x0F/*::]*/: parse_FtSkip,      /* FtGboData */
  	/*::[*/0x10/*::]*/: parse_FtSkip,      /* FtEdoData */
  	/*::[*/0x11/*::]*/: parse_FtSkip,      /* FtRboData */
  	/*::[*/0x12/*::]*/: parse_FtSkip,      /* FtCblsData */
  	/*::[*/0x13/*::]*/: parse_FtSkip,      /* FtLbsData */
  	/*::[*/0x14/*::]*/: parse_FtSkip,      /* FtCblsFmla */
  	/*::[*/0x15/*::]*/: parse_FtCmo
  };
  function parse_FtArray(blob, length/*::, ot*/) {
  	var tgt = blob.l + length;
  	var fts = [];
  	while(blob.l < tgt) {
  		var ft = blob.read_shift(2);
  		blob.l-=2;
  		try {
  			fts.push(FtTab[ft](blob, tgt - blob.l));
  		} catch(e) { blob.l = tgt; return fts; }
  	}
  	if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
  	return fts;
  }

  /* --- 2.4 Records --- */

  /* [MS-XLS] 2.4.21 */
  function parse_BOF(blob, length) {
  	var o = {BIFFVer:0, dt:0};
  	o.BIFFVer = blob.read_shift(2); length -= 2;
  	if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
  	switch(o.BIFFVer) {
  		case 0x0600: /* BIFF8 */
  		case 0x0500: /* BIFF5 */
  		case 0x0400: /* BIFF4 */
  		case 0x0300: /* BIFF3 */
  		case 0x0200: /* BIFF2 */
  		case 0x0002: case 0x0007: /* BIFF2 */
  			break;
  		default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
  	}

  	blob.read_shift(length);
  	return o;
  }


  /* [MS-XLS] 2.4.146 */
  function parse_InterfaceHdr(blob, length) {
  	if(length === 0) return 0x04b0;
  	if((blob.read_shift(2))!==0x04b0);
  	return 0x04b0;
  }


  /* [MS-XLS] 2.4.349 */
  function parse_WriteAccess(blob, length, opts) {
  	if(opts.enc) { blob.l += length; return ""; }
  	var l = blob.l;
  	// TODO: make sure XLUnicodeString doesnt overrun
  	var UserName = parse_XLUnicodeString2(blob, 0, opts);
  	blob.read_shift(length + l - blob.l);
  	return UserName;
  }

  /* [MS-XLS] 2.4.351 */
  function parse_WsBool(blob, length, opts) {
  	var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
  	return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
  }

  /* [MS-XLS] 2.4.28 */
  function parse_BoundSheet8(blob, length, opts) {
  	var pos = blob.read_shift(4);
  	var hidden = blob.read_shift(1) & 0x03;
  	var dt = blob.read_shift(1);
  	switch(dt) {
  		case 0: dt = 'Worksheet'; break;
  		case 1: dt = 'Macrosheet'; break;
  		case 2: dt = 'Chartsheet'; break;
  		case 6: dt = 'VBAModule'; break;
  	}
  	var name = parse_ShortXLUnicodeString(blob, 0, opts);
  	if(name.length === 0) name = "Sheet1";
  	return { pos:pos, hs:hidden, dt:dt, name:name };
  }

  /* [MS-XLS] 2.4.265 TODO */
  function parse_SST(blob, length)/*:SST*/ {
  	var end = blob.l + length;
  	var cnt = blob.read_shift(4);
  	var ucnt = blob.read_shift(4);
  	var strs/*:SST*/ = ([]/*:any*/);
  	for(var i = 0; i != ucnt && blob.l < end; ++i) {
  		strs.push(parse_XLUnicodeRichExtendedString(blob));
  	}
  	strs.Count = cnt; strs.Unique = ucnt;
  	return strs;
  }

  /* [MS-XLS] 2.4.107 */
  function parse_ExtSST(blob, length) {
  	var extsst = {};
  	extsst.dsst = blob.read_shift(2);
  	blob.l += length-2;
  	return extsst;
  }


  /* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
  function parse_Row(blob) {
  	var z = ({}/*:any*/);
  	z.r = blob.read_shift(2);
  	z.c = blob.read_shift(2);
  	z.cnt = blob.read_shift(2) - z.c;
  	var miyRw = blob.read_shift(2);
  	blob.l += 4; // reserved(2), unused(2)
  	var flags = blob.read_shift(1); // various flags
  	blob.l += 3; // reserved(8), ixfe(12), flags(4)
  	if(flags & 0x07) z.level = flags & 0x07;
  	// collapsed: flags & 0x10
  	if(flags & 0x20) z.hidden = true;
  	if(flags & 0x40) z.hpt = miyRw / 20;
  	return z;
  }


  /* [MS-XLS] 2.4.125 */
  function parse_ForceFullCalculation(blob) {
  	var header = parse_frtHeader(blob);
  	if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
  	var fullcalc = blob.read_shift(4);
  	return fullcalc !== 0x0;
  }





  /* [MS-XLS] 2.4.215 rt */
  function parse_RecalcId(blob) {
  	blob.read_shift(2);
  	return blob.read_shift(4);
  }

  /* [MS-XLS] 2.4.87 */
  function parse_DefaultRowHeight(blob, length, opts) {
  	var f = 0;
  	if(!(opts && opts.biff == 2)) {
  		f = blob.read_shift(2);
  	}
  	var miyRw = blob.read_shift(2);
  	if((opts && opts.biff == 2)) {
  		f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
  	}
  	var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
  	return [fl, miyRw];
  }

  /* [MS-XLS] 2.4.345 TODO */
  function parse_Window1(blob) {
  	var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
  	var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
  	var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
  	return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
  		FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
  }
  /* [MS-XLS] 2.4.346 TODO */
  function parse_Window2(blob, length, opts) {
  	if(opts && opts.biff >= 2 && opts.biff < 5) return {};
  	var f = blob.read_shift(2);
  	return { RTL: f & 0x40 };
  }

  /* [MS-XLS] 2.4.189 TODO */
  function parse_Pane(/*blob, length, opts*/) {
  }

  /* [MS-XLS] 2.4.122 TODO */
  function parse_Font(blob, length, opts) {
  	var o/*:any*/ = {
  		dyHeight: blob.read_shift(2),
  		fl: blob.read_shift(2)
  	};
  	switch((opts && opts.biff) || 8) {
  		case 2: break;
  		case 3: case 4: blob.l += 2; break;
  		default: blob.l += 10; break;
  	}
  	o.name = parse_ShortXLUnicodeString(blob, 0, opts);
  	return o;
  }

  /* [MS-XLS] 2.4.149 */
  function parse_LabelSst(blob) {
  	var cell = parse_XLSCell(blob);
  	cell.isst = blob.read_shift(4);
  	return cell;
  }

  /* [MS-XLS] 2.4.148 */
  function parse_Label(blob, length, opts) {
  	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
  	var target = blob.l + length;
  	var cell = parse_XLSCell(blob);
  	if(opts.biff == 2) blob.l++;
  	var str = parse_XLUnicodeString(blob, target - blob.l, opts);
  	cell.val = str;
  	return cell;
  }


  /* [MS-XLS] 2.4.126 Number Formats */
  function parse_Format(blob, length, opts) {
  	var numFmtId = blob.read_shift(2);
  	var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
  	return [numFmtId, fmtstr];
  }
  var parse_BIFF2Format = parse_XLUnicodeString2;

  /* [MS-XLS] 2.4.90 */
  function parse_Dimensions(blob, length, opts) {
  	var end = blob.l + length;
  	var w = opts.biff == 8 || !opts.biff ? 4 : 2;
  	var r = blob.read_shift(w), R = blob.read_shift(w);
  	var c = blob.read_shift(2), C = blob.read_shift(2);
  	blob.l = end;
  	return {s: {r:r, c:c}, e: {r:R, c:C}};
  }

  /* [MS-XLS] 2.4.220 */
  function parse_RK(blob) {
  	var rw = blob.read_shift(2), col = blob.read_shift(2);
  	var rkrec = parse_RkRec(blob);
  	return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
  }

  /* [MS-XLS] 2.4.175 */
  function parse_MulRk(blob, length) {
  	var target = blob.l + length - 2;
  	var rw = blob.read_shift(2), col = blob.read_shift(2);
  	var rkrecs = [];
  	while(blob.l < target) rkrecs.push(parse_RkRec(blob));
  	if(blob.l !== target) throw new Error("MulRK read error");
  	var lastcol = blob.read_shift(2);
  	if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
  	return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
  }
  /* [MS-XLS] 2.4.174 */
  function parse_MulBlank(blob, length) {
  	var target = blob.l + length - 2;
  	var rw = blob.read_shift(2), col = blob.read_shift(2);
  	var ixfes = [];
  	while(blob.l < target) ixfes.push(blob.read_shift(2));
  	if(blob.l !== target) throw new Error("MulBlank read error");
  	var lastcol = blob.read_shift(2);
  	if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
  	return {r:rw, c:col, C:lastcol, ixfe:ixfes};
  }

  /* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
  function parse_CellStyleXF(blob, length, style, opts) {
  	var o = {};
  	var a = blob.read_shift(4), b = blob.read_shift(4);
  	var c = blob.read_shift(4), d = blob.read_shift(2);
  	o.patternType = XLSFillPattern[c >> 26];

  	if(!opts.cellStyles) return o;
  	o.alc = a & 0x07;
  	o.fWrap = (a >> 3) & 0x01;
  	o.alcV = (a >> 4) & 0x07;
  	o.fJustLast = (a >> 7) & 0x01;
  	o.trot = (a >> 8) & 0xFF;
  	o.cIndent = (a >> 16) & 0x0F;
  	o.fShrinkToFit = (a >> 20) & 0x01;
  	o.iReadOrder = (a >> 22) & 0x02;
  	o.fAtrNum = (a >> 26) & 0x01;
  	o.fAtrFnt = (a >> 27) & 0x01;
  	o.fAtrAlc = (a >> 28) & 0x01;
  	o.fAtrBdr = (a >> 29) & 0x01;
  	o.fAtrPat = (a >> 30) & 0x01;
  	o.fAtrProt = (a >> 31) & 0x01;

  	o.dgLeft = b & 0x0F;
  	o.dgRight = (b >> 4) & 0x0F;
  	o.dgTop = (b >> 8) & 0x0F;
  	o.dgBottom = (b >> 12) & 0x0F;
  	o.icvLeft = (b >> 16) & 0x7F;
  	o.icvRight = (b >> 23) & 0x7F;
  	o.grbitDiag = (b >> 30) & 0x03;

  	o.icvTop = c & 0x7F;
  	o.icvBottom = (c >> 7) & 0x7F;
  	o.icvDiag = (c >> 14) & 0x7F;
  	o.dgDiag = (c >> 21) & 0x0F;

  	o.icvFore = d & 0x7F;
  	o.icvBack = (d >> 7) & 0x7F;
  	o.fsxButton = (d >> 14) & 0x01;
  	return o;
  }
  //function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
  //function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}

  /* [MS-XLS] 2.4.353 TODO: actually do this right */
  function parse_XF(blob, length, opts) {
  	var o = {};
  	o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
  	o.fStyle = (o.flags >> 2) & 0x01;
  	length -= 6;
  	o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
  	return o;
  }

  /* [MS-XLS] 2.4.134 */
  function parse_Guts(blob) {
  	blob.l += 4;
  	var out = [blob.read_shift(2), blob.read_shift(2)];
  	if(out[0] !== 0) out[0]--;
  	if(out[1] !== 0) out[1]--;
  	if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
  	return out;
  }

  /* [MS-XLS] 2.4.24 */
  function parse_BoolErr(blob, length, opts) {
  	var cell = parse_XLSCell(blob);
  	if(opts.biff == 2 || length == 9) ++blob.l;
  	var val = parse_Bes(blob);
  	cell.val = val;
  	cell.t = (val === true || val === false) ? 'b' : 'e';
  	return cell;
  }

  /* [MS-XLS] 2.4.180 Number */
  function parse_Number(blob, length, opts) {
  	if(opts.biffguess && opts.biff == 2) opts.biff = 5;
  	var cell = parse_XLSCell(blob);
  	var xnum = parse_Xnum(blob);
  	cell.val = xnum;
  	return cell;
  }

  var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136

  /* [MS-XLS] 2.4.271 */
  function parse_SupBook(blob, length, opts) {
  	var end = blob.l + length;
  	var ctab = blob.read_shift(2);
  	var cch = blob.read_shift(2);
  	opts.sbcch = cch;
  	if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
  	if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
  	var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
  	/* TODO: 2.5.277 Virtual Path */
  	var rgst = [];
  	while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
  	return [cch, ctab, virtPath, rgst];
  }

  /* [MS-XLS] 2.4.105 TODO */
  function parse_ExternName(blob, length, opts) {
  	var flags = blob.read_shift(2);
  	var body;
  	var o = ({
  		fBuiltIn: flags & 0x01,
  		fWantAdvise: (flags >>> 1) & 0x01,
  		fWantPict: (flags >>> 2) & 0x01,
  		fOle: (flags >>> 3) & 0x01,
  		fOleLink: (flags >>> 4) & 0x01,
  		cf: (flags >>> 5) & 0x3FF,
  		fIcon: flags >>> 15 & 0x01
  	}/*:any*/);
  	if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
  	//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
  	o.body = body || blob.read_shift(length-2);
  	if(typeof body === "string") o.Name = body;
  	return o;
  }

  /* [MS-XLS] 2.4.150 TODO */
  var XLSLblBuiltIn = [
  	"_xlnm.Consolidate_Area",
  	"_xlnm.Auto_Open",
  	"_xlnm.Auto_Close",
  	"_xlnm.Extract",
  	"_xlnm.Database",
  	"_xlnm.Criteria",
  	"_xlnm.Print_Area",
  	"_xlnm.Print_Titles",
  	"_xlnm.Recorder",
  	"_xlnm.Data_Form",
  	"_xlnm.Auto_Activate",
  	"_xlnm.Auto_Deactivate",
  	"_xlnm.Sheet_Title",
  	"_xlnm._FilterDatabase"
  ];
  function parse_Lbl(blob, length, opts) {
  	var target = blob.l + length;
  	var flags = blob.read_shift(2);
  	var chKey = blob.read_shift(1);
  	var cch = blob.read_shift(1);
  	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	var itab = 0;
  	if(!opts || opts.biff >= 5) {
  		if(opts.biff != 5) blob.l += 2;
  		itab = blob.read_shift(2);
  		if(opts.biff == 5) blob.l += 2;
  		blob.l += 4;
  	}
  	var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
  	if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
  	var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
  	/*jshint -W018 */
  	var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
  	/*jshint +W018 */
  	return {
  		chKey: chKey,
  		Name: name,
  		itab: itab,
  		rgce: rgce
  	};
  }

  /* [MS-XLS] 2.4.106 TODO: verify filename encoding */
  function parse_ExternSheet(blob, length, opts) {
  	if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
  	var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
  	while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
  		// [iSupBook, itabFirst, itabLast];
  	if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
  	return o;
  }
  function parse_BIFF5ExternSheet(blob, length, opts) {
  	if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
  	var o = parse_ShortXLUnicodeString(blob, length, opts);
  	return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
  }

  /* [MS-XLS] 2.4.176 TODO: check older biff */
  function parse_NameCmt(blob, length, opts) {
  	if(opts.biff < 8) { blob.l += length; return; }
  	var cchName = blob.read_shift(2);
  	var cchComment = blob.read_shift(2);
  	var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
  	var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
  	return [name, comment];
  }

  /* [MS-XLS] 2.4.260 */
  function parse_ShrFmla(blob, length, opts) {
  	var ref = parse_RefU(blob);
  	blob.l++;
  	var cUse = blob.read_shift(1);
  	length -= 8;
  	return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
  }

  /* [MS-XLS] 2.4.4 TODO */
  function parse_Array(blob, length, opts) {
  	var ref = parse_Ref(blob);
  	/* TODO: fAlwaysCalc */
  	switch(opts.biff) {
  		case 2: blob.l ++; length -= 7; break;
  		case 3: case 4: blob.l += 2; length -= 8; break;
  		default: blob.l += 6; length -= 12;
  	}
  	return [ref, parse_ArrayParsedFormula(blob, length, opts)];
  }

  /* [MS-XLS] 2.4.173 */
  function parse_MTRSettings(blob) {
  	var fMTREnabled = blob.read_shift(4) !== 0x00;
  	var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
  	var cUserThreadCount = blob.read_shift(4);
  	return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
  }

  /* [MS-XLS] 2.5.186 TODO: BIFF5 */
  function parse_NoteSh(blob, length, opts) {
  	if(opts.biff < 8) return;
  	var row = blob.read_shift(2), col = blob.read_shift(2);
  	var flags = blob.read_shift(2), idObj = blob.read_shift(2);
  	var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
  	if(opts.biff < 8) blob.read_shift(1);
  	return [{r:row,c:col}, stAuthor, idObj, flags];
  }

  /* [MS-XLS] 2.4.179 */
  function parse_Note(blob, length, opts) {
  	/* TODO: Support revisions */
  	return parse_NoteSh(blob, length, opts);
  }

  /* [MS-XLS] 2.4.168 */
  function parse_MergeCells(blob, length)/*:Array<Range>*/ {
  	var merges/*:Array<Range>*/ = [];
  	var cmcs = blob.read_shift(2);
  	while (cmcs--) merges.push(parse_Ref8U(blob));
  	return merges;
  }

  /* [MS-XLS] 2.4.181 TODO: parse all the things! */
  function parse_Obj(blob, length, opts) {
  	if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
  	var cmo = parse_FtCmo(blob); // id, ot, flags
  	var fts = parse_FtArray(blob, length-22, cmo[1]);
  	return { cmo: cmo, ft:fts };
  }
  /* from older spec */
  var parse_BIFF5OT = {
  0x08: function(blob, length) {
  	var tgt = blob.l + length;
  	blob.l += 10; // todo
  	var cf = blob.read_shift(2);
  	blob.l += 4;
  	blob.l += 2; //var cbPictFmla = blob.read_shift(2);
  	blob.l += 2;
  	blob.l += 2; //var grbit = blob.read_shift(2);
  	blob.l += 4;
  	var cchName = blob.read_shift(1);
  	blob.l += cchName; // TODO: stName
  	blob.l = tgt; // TODO: fmla
  	return { fmt:cf };
  }
  };

  function parse_BIFF5Obj(blob, length, opts) {
  	blob.l += 4; //var cnt = blob.read_shift(4);
  	var ot = blob.read_shift(2);
  	var id = blob.read_shift(2);
  	var grbit = blob.read_shift(2);
  	blob.l += 2; //var colL = blob.read_shift(2);
  	blob.l += 2; //var dxL = blob.read_shift(2);
  	blob.l += 2; //var rwT = blob.read_shift(2);
  	blob.l += 2; //var dyT = blob.read_shift(2);
  	blob.l += 2; //var colR = blob.read_shift(2);
  	blob.l += 2; //var dxR = blob.read_shift(2);
  	blob.l += 2; //var rwB = blob.read_shift(2);
  	blob.l += 2; //var dyB = blob.read_shift(2);
  	blob.l += 2; //var cbMacro = blob.read_shift(2);
  	blob.l += 6;
  	length -= 36;
  	var fts = [];
  	fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
  	return { cmo: [id, ot, grbit], ft:fts };
  }

  /* [MS-XLS] 2.4.329 TODO: parse properly */
  function parse_TxO(blob, length, opts) {
  	var s = blob.l;
  	var texts = "";
  try {
  	blob.l += 4;
  	var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
  	var controlInfo; // eslint-disable-line no-unused-vars
  	if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
  	else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
  	var cchText = blob.read_shift(2);
  	/*var cbRuns = */blob.read_shift(2);
  	/*var ifntEmpty = */parseuint16(blob, 2);
  	var len = blob.read_shift(2);
  	blob.l += len;
  	//var fmla = parse_ObjFmla(blob, s + length - blob.l);

  	for(var i = 1; i < blob.lens.length-1; ++i) {
  		if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
  		var hdr = blob[blob.l];
  		var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
  		texts += t;
  		if(texts.length >= (hdr ? cchText : 2*cchText)) break;
  	}
  	if(texts.length !== cchText && texts.length !== cchText*2) {
  		throw new Error("cchText: " + cchText + " != " + texts.length);
  	}

  	blob.l = s + length;
  	/* [MS-XLS] 2.5.272 TxORuns */
  //	var rgTxoRuns = [];
  //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
  //	var cchText2 = blob.read_shift(2);
  //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
  //	blob.l += 6;
  //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
  	return { t: texts };
  } catch(e) { blob.l = s + length; return { t: texts }; }
  }

  /* [MS-XLS] 2.4.140 */
  function parse_HLink(blob, length) {
  	var ref = parse_Ref8U(blob);
  	blob.l += 16; /* CLSID */
  	var hlink = parse_Hyperlink(blob, length-24);
  	return [ref, hlink];
  }


  /* [MS-XLS] 2.4.141 */
  function parse_HLinkTooltip(blob, length) {
  	blob.read_shift(2);
  	var ref = parse_Ref8U(blob);
  	var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
  	wzTooltip = wzTooltip.replace(chr0,"");
  	return [ref, wzTooltip];
  }

  /* [MS-XLS] 2.4.63 */
  function parse_Country(blob)/*:[string|number, string|number]*/ {
  	var o = [0,0], d;
  	d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
  	d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
  	return o;
  }

  /* [MS-XLS] 2.4.50 ClrtClient */
  function parse_ClrtClient(blob) {
  	var ccv = blob.read_shift(2);
  	var o = [];
  	while(ccv-->0) o.push(parse_LongRGB(blob));
  	return o;
  }

  /* [MS-XLS] 2.4.188 */
  function parse_Palette(blob) {
  	var ccv = blob.read_shift(2);
  	var o = [];
  	while(ccv-->0) o.push(parse_LongRGB(blob));
  	return o;
  }

  /* [MS-XLS] 2.4.354 */
  function parse_XFCRC(blob) {
  	blob.l += 2;
  	var o = {cxfs:0, crc:0};
  	o.cxfs = blob.read_shift(2);
  	o.crc = blob.read_shift(4);
  	return o;
  }

  /* [MS-XLS] 2.4.53 TODO: parse flags */
  /* [MS-XLSB] 2.4.323 TODO: parse flags */
  function parse_ColInfo(blob, length, opts) {
  	if(!opts.cellStyles) return parsenoop(blob, length);
  	var w = opts && opts.biff >= 12 ? 4 : 2;
  	var colFirst = blob.read_shift(w);
  	var colLast = blob.read_shift(w);
  	var coldx = blob.read_shift(w);
  	var ixfe = blob.read_shift(w);
  	var flags = blob.read_shift(2);
  	if(w == 2) blob.l += 2;
  	var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags}/*:any*/);
  	if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
  	return o;
  }

  /* [MS-XLS] 2.4.257 */
  function parse_Setup(blob, length) {
  	var o = {};
  	if(length < 32) return o;
  	blob.l += 16;
  	o.header = parse_Xnum(blob);
  	o.footer = parse_Xnum(blob);
  	blob.l += 2;
  	return o;
  }

  /* [MS-XLS] 2.4.261 */
  function parse_ShtProps(blob, length, opts) {
  	var def = {area:false};
  	if(opts.biff != 5) { blob.l += length; return def; }
  	var d = blob.read_shift(1); blob.l += 3;
  	if((d & 0x10)) def.area = true;
  	return def;
  }

  var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
  var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
  var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */

  /* --- Specific to versions before BIFF8 --- */
  function parse_ImData(blob) {
  	var cf = blob.read_shift(2);
  	var env = blob.read_shift(2);
  	var lcb = blob.read_shift(4);
  	var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
  	blob.l += lcb;
  	return o;
  }

  /* BIFF2_??? where ??? is the name from [XLS] */
  function parse_BIFF2STR(blob, length, opts) {
  	if(opts.biffguess && opts.biff == 5) opts.biff = 2;
  	var cell = parse_XLSCell(blob);
  	++blob.l;
  	var str = parse_XLUnicodeString2(blob, length-7, opts);
  	cell.t = 'str';
  	cell.val = str;
  	return cell;
  }

  function parse_BIFF2NUM(blob/*::, length*/) {
  	var cell = parse_XLSCell(blob);
  	++blob.l;
  	var num = parse_Xnum(blob);
  	cell.t = 'n';
  	cell.val = num;
  	return cell;
  }

  function parse_BIFF2INT(blob) {
  	var cell = parse_XLSCell(blob);
  	++blob.l;
  	var num = blob.read_shift(2);
  	cell.t = 'n';
  	cell.val = num;
  	return cell;
  }

  function parse_BIFF2STRING(blob) {
  	var cch = blob.read_shift(1);
  	if(cch === 0) { blob.l++; return ""; }
  	return blob.read_shift(cch, 'sbcs-cont');
  }

  /* TODO: convert to BIFF8 font struct */
  function parse_BIFF2FONTXTRA(blob, length) {
  	blob.l += 6; // unknown
  	blob.l += 2; // font weight "bls"
  	blob.l += 1; // charset
  	blob.l += 3; // unknown
  	blob.l += 1; // font family
  	blob.l += length - 13;
  }

  /* TODO: parse rich text runs */
  function parse_RString(blob, length, opts) {
  	var end = blob.l + length;
  	var cell = parse_XLSCell(blob);
  	var cch = blob.read_shift(2);
  	var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
  	blob.l = end;
  	cell.t = 'str';
  	cell.val = str;
  	return cell;
  }
  /* from js-harb (C) 2014-present  SheetJS */
  var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
  var DBF = /*#__PURE__*/(function() {
  var dbf_codepage_map = {
  	/* Code Pages Supported by Visual FoxPro */
  	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
  	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
  	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
  	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
  	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
  	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
  	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
  	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
  	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
  	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
  	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
  	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
  	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,

  	/* shapefile DBF extension */
  	/*::[*/0x00/*::]*/: 20127,           /*::[*/0x08/*::]*/:   865,
  	/*::[*/0x09/*::]*/:   437,           /*::[*/0x0A/*::]*/:   850,
  	/*::[*/0x0B/*::]*/:   437,           /*::[*/0x0D/*::]*/:   437,
  	/*::[*/0x0E/*::]*/:   850,           /*::[*/0x0F/*::]*/:   437,
  	/*::[*/0x10/*::]*/:   850,           /*::[*/0x11/*::]*/:   437,
  	/*::[*/0x12/*::]*/:   850,           /*::[*/0x13/*::]*/:   932,
  	/*::[*/0x14/*::]*/:   850,           /*::[*/0x15/*::]*/:   437,
  	/*::[*/0x16/*::]*/:   850,           /*::[*/0x17/*::]*/:   865,
  	/*::[*/0x18/*::]*/:   437,           /*::[*/0x19/*::]*/:   437,
  	/*::[*/0x1A/*::]*/:   850,           /*::[*/0x1B/*::]*/:   437,
  	/*::[*/0x1C/*::]*/:   863,           /*::[*/0x1D/*::]*/:   850,
  	/*::[*/0x1F/*::]*/:   852,           /*::[*/0x22/*::]*/:   852,
  	/*::[*/0x23/*::]*/:   852,           /*::[*/0x24/*::]*/:   860,
  	/*::[*/0x25/*::]*/:   850,           /*::[*/0x26/*::]*/:   866,
  	/*::[*/0x37/*::]*/:   850,           /*::[*/0x40/*::]*/:   852,
  	/*::[*/0x4D/*::]*/:   936,           /*::[*/0x4E/*::]*/:   949,
  	/*::[*/0x4F/*::]*/:   950,           /*::[*/0x50/*::]*/:   874,
  	/*::[*/0x57/*::]*/:  1252,           /*::[*/0x58/*::]*/:  1252,
  	/*::[*/0x59/*::]*/:  1252,           /*::[*/0x6C/*::]*/:   863,
  	/*::[*/0x86/*::]*/:   737,           /*::[*/0x87/*::]*/:   852,
  	/*::[*/0x88/*::]*/:   857,           /*::[*/0xCC/*::]*/:  1257,

  	/*::[*/0xFF/*::]*/: 16969
  };
  var dbf_reverse_map = evert({
  	/*::[*/0x01/*::]*/:   437,           /*::[*/0x02/*::]*/:   850,
  	/*::[*/0x03/*::]*/:  1252,           /*::[*/0x04/*::]*/: 10000,
  	/*::[*/0x64/*::]*/:   852,           /*::[*/0x65/*::]*/:   866,
  	/*::[*/0x66/*::]*/:   865,           /*::[*/0x67/*::]*/:   861,
  	/*::[*/0x68/*::]*/:   895,           /*::[*/0x69/*::]*/:   620,
  	/*::[*/0x6A/*::]*/:   737,           /*::[*/0x6B/*::]*/:   857,
  	/*::[*/0x78/*::]*/:   950,           /*::[*/0x79/*::]*/:   949,
  	/*::[*/0x7A/*::]*/:   936,           /*::[*/0x7B/*::]*/:   932,
  	/*::[*/0x7C/*::]*/:   874,           /*::[*/0x7D/*::]*/:  1255,
  	/*::[*/0x7E/*::]*/:  1256,           /*::[*/0x96/*::]*/: 10007,
  	/*::[*/0x97/*::]*/: 10029,           /*::[*/0x98/*::]*/: 10006,
  	/*::[*/0xC8/*::]*/:  1250,           /*::[*/0xC9/*::]*/:  1251,
  	/*::[*/0xCA/*::]*/:  1254,           /*::[*/0xCB/*::]*/:  1253,
  	/*::[*/0x00/*::]*/: 20127
  });
  /* TODO: find an actual specification */
  function dbf_to_aoa(buf, opts)/*:AOA*/ {
  	var out/*:AOA*/ = [];
  	var d/*:Block*/ = (new_raw_buf(1)/*:any*/);
  	switch(opts.type) {
  		case 'base64': d = s2a(Base64_decode(buf)); break;
  		case 'binary': d = s2a(buf); break;
  		case 'buffer':
  		case 'array': d = buf; break;
  	}
  	prep_blob(d, 0);

  	/* header */
  	var ft = d.read_shift(1);
  	var memo = !!(ft & 0x88);
  	var vfp = false, l7 = false;
  	switch(ft) {
  		case 0x02: break; // dBASE II
  		case 0x03: break; // dBASE III
  		case 0x30: vfp = true; memo = true; break; // VFP
  		case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
  		// 0x43 dBASE IV SQL table files
  		// 0x63 dBASE IV SQL system files
  		case 0x83: break; // dBASE III with memo
  		case 0x8B: break; // dBASE IV with memo
  		case 0x8C: l7 = true; break; // dBASE Level 7 with memo
  		// case 0xCB dBASE IV SQL table files with memo
  		case 0xF5: break; // FoxPro 2.x with memo
  		// case 0xFB FoxBASE
  		default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
  	}

  	var nrow = 0, fpos = 0x0209;
  	if(ft == 0x02) nrow = d.read_shift(2);
  	d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
  	if(ft != 0x02) nrow = d.read_shift(4);
  	if(nrow > 1048576) nrow = 1e6;

  	if(ft != 0x02) fpos = d.read_shift(2); // header length
  	var rlen = d.read_shift(2); // record length

  	var /*flags = 0,*/ current_cp = opts.codepage || 1252;
  	if(ft != 0x02) { // 20 reserved bytes
  		d.l+=16;
  		/*flags = */d.read_shift(1);
  		//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));

  		/* codepage present in FoxPro and dBASE Level 7 */
  		if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
  		d.l+=1;

  		d.l+=2;
  	}
  	if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved

  /*:: type DBFField = { name:string; len:number; type:string; } */
  	var fields/*:Array<DBFField>*/ = [], field/*:DBFField*/ = ({}/*:any*/);
  	var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
  	var ww = l7 ? 32 : 11;
  	while(d.l < hend && d[d.l] != 0x0d) {
  		field = ({}/*:any*/);
  		field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
  		d.l += ww;
  		field.type = String.fromCharCode(d.read_shift(1));
  		if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
  		field.len = d.read_shift(1);
  		if(ft == 0x02) field.offset = d.read_shift(2);
  		field.dec = d.read_shift(1);
  		if(field.name.length) fields.push(field);
  		if(ft != 0x02) d.l += l7 ? 13 : 14;
  		switch(field.type) {
  			case 'B': // Double (VFP) / Binary (dBASE L7)
  				if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
  				break;
  			case 'G': // General (FoxPro and dBASE L7)
  			case 'P': // Picture (FoxPro and dBASE L7)
  				if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
  				break;
  			case '+': // Autoincrement (dBASE L7 only)
  			case '0': // _NullFlags (VFP only)
  			case '@': // Timestamp (dBASE L7 only)
  			case 'C': // Character (dBASE II)
  			case 'D': // Date (dBASE III)
  			case 'F': // Float (dBASE IV)
  			case 'I': // Long (VFP and dBASE L7)
  			case 'L': // Logical (dBASE II)
  			case 'M': // Memo (dBASE III)
  			case 'N': // Number (dBASE II)
  			case 'O': // Double (dBASE L7 only)
  			case 'T': // Datetime (VFP only)
  			case 'Y': // Currency (VFP only)
  				break;
  			default: throw new Error('Unknown Field Type: ' + field.type);
  		}
  	}

  	if(d[d.l] !== 0x0D) d.l = fpos-1;
  	if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
  	d.l = fpos;

  	/* data */
  	var R = 0, C = 0;
  	out[0] = [];
  	for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
  	while(nrow-- > 0) {
  		if(d[d.l] === 0x2A) {
  			// TODO: record marked as deleted -- create a hidden row?
  			d.l+=rlen;
  			continue;
  		}
  		++d.l;
  		out[++R] = []; C = 0;
  		for(C = 0; C != fields.length; ++C) {
  			var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
  			prep_blob(dd, 0);
  			var s = $cptable.utils.decode(current_cp, dd);
  			switch(fields[C].type) {
  				case 'C':
  					// NOTE: it is conventional to write '  /  /  ' for empty dates
  					if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
  					break;
  				case 'D':
  					if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
  					else out[R][C] = s;
  					break;
  				case 'F': out[R][C] = parseFloat(s.trim()); break;
  				case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
  				case 'L': switch(s.trim().toUpperCase()) {
  					case 'Y': case 'T': out[R][C] = true; break;
  					case 'N': case 'F': out[R][C] = false; break;
  					case '': case '?': break;
  					default: throw new Error("DBF Unrecognized L:|" + s + "|");
  					} break;
  				case 'M': /* TODO: handle memo files */
  					if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
  					out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
  					break;
  				case 'N':
  					s = s.replace(/\u0000/g,"").trim();
  					// NOTE: dBASE II interprets "  .  " as 0
  					if(s && s != ".") out[R][C] = +s || 0; break;
  				case '@':
  					// NOTE: dBASE specs appear to be incorrect
  					out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
  					break;
  				case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
  				case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
  				case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
  				case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
  					/* falls through */
  				case 'G': case 'P': dd.l += fields[C].len; break;
  				case '0':
  					if(fields[C].name === '_NullFlags') break;
  					/* falls through */
  				default: throw new Error("DBF Unsupported data type " + fields[C].type);
  			}
  		}
  	}
  	if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
  	if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
  	opts.DBF = fields;
  	return out;
  }

  function dbf_to_sheet(buf, opts)/*:Worksheet*/ {
  	var o = opts || {};
  	if(!o.dateNF) o.dateNF = "yyyymmdd";
  	var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
  	ws["!cols"] = o.DBF.map(function(field) { return {
  		wch: field.len,
  		DBF: field
  	};});
  	delete o.DBF;
  	return ws;
  }

  function dbf_to_workbook(buf, opts)/*:Workbook*/ {
  	try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
  	catch(e) { if(opts && opts.WTF) throw e; }
  	return ({SheetNames:[],Sheets:{}});
  }

  var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
  function sheet_to_dbf(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
  	var o = opts || {};
  	if(+o.codepage >= 0) set_cp(+o.codepage);
  	if(o.type == "string") throw new Error("Cannot write DBF to JS string");
  	var ba = buf_array();
  	var aoa/*:AOA*/ = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
  	var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
  	var i = 0, j = 0, hcnt = 0, rlen = 1;
  	for(i = 0; i < headers.length; ++i) {
  		if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
  		if(headers[i] == null) continue;
  		++hcnt;
  		if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
  		if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
  		if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
  			if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
  	}
  	var range = safe_decode_range(ws['!ref']);
  	var coltypes/*:Array<string>*/ = [];
  	var colwidths/*:Array<number>*/ = [];
  	var coldecimals/*:Array<number>*/ = [];
  	for(i = 0; i <= range.e.c - range.s.c; ++i) {
  		var guess = '', _guess = '', maxlen = 0;
  		var col/*:Array<any>*/ = [];
  		for(j=0; j < data.length; ++j) {
  			if(data[j][i] != null) col.push(data[j][i]);
  		}
  		if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
  		for(j = 0; j < col.length; ++j) {
  			switch(typeof col[j]) {
  				/* TODO: check if L2 compat is desired */
  				case 'number': _guess = 'B'; break;
  				case 'string': _guess = 'C'; break;
  				case 'boolean': _guess = 'L'; break;
  				case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
  				default: _guess = 'C';
  			}
  			maxlen = Math.max(maxlen, String(col[j]).length);
  			guess = guess && guess != _guess ? 'C' : _guess;
  			//if(guess == 'C') break;
  		}
  		if(maxlen > 250) maxlen = 250;
  		_guess = ((cols[i]||{}).DBF||{}).type;
  		/* TODO: more fine grained control over DBF type resolution */
  		if(_guess == 'C') {
  			if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
  		}
  		if(guess == 'B' && _guess == 'N') {
  			guess = 'N';
  			coldecimals[i] = cols[i].DBF.dec;
  			maxlen = cols[i].DBF.len;
  		}
  		colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
  		rlen += colwidths[i];
  		coltypes[i] = guess;
  	}

  	var h = ba.next(32);
  	h.write_shift(4, 0x13021130);
  	h.write_shift(4, data.length);
  	h.write_shift(2, 296 + 32 * hcnt);
  	h.write_shift(2, rlen);
  	for(i=0; i < 4; ++i) h.write_shift(4, 0);
  	h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[/*::String(*/current_ansi/*::)*/] || 0x03)<<8));

  	for(i = 0, j = 0; i < headers.length; ++i) {
  		if(headers[i] == null) continue;
  		var hf = ba.next(32);
  		var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
  		hf.write_shift(1, _f, "sbcs");
  		hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
  		hf.write_shift(4, j);
  		hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
  		hf.write_shift(1, coldecimals[i] || 0);
  		hf.write_shift(1, 0x02);
  		hf.write_shift(4, 0);
  		hf.write_shift(1, 0);
  		hf.write_shift(4, 0);
  		hf.write_shift(4, 0);
  		j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
  	}

  	var hb = ba.next(264);
  	hb.write_shift(4, 0x0000000D);
  	for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
  	for(i=0; i < data.length; ++i) {
  		var rout = ba.next(rlen);
  		rout.write_shift(1, 0);
  		for(j=0; j<headers.length; ++j) {
  			if(headers[j] == null) continue;
  			switch(coltypes[j]) {
  				case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
  				case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
  				case 'N':
  					var _n = "0";
  					if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
  					for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
  					rout.write_shift(1, _n, "sbcs");
  					break;
  				case 'D':
  					if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
  					else {
  						rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
  						rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
  						rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
  					} break;
  				case 'C':
  					var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
  					rout.write_shift(1, _s, "sbcs");
  					for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
  			}
  		}
  		// data
  	}
  	ba.next(1).write_shift(1, 0x1A);
  	return ba.end();
  }
  	return {
  		to_workbook: dbf_to_workbook,
  		to_sheet: dbf_to_sheet,
  		from_sheet: sheet_to_dbf
  	};
  })();

  var SYLK = /*#__PURE__*/(function() {
  	/* TODO: stress test sequences */
  	var sylk_escapes = ({
  		AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
  		AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
  		AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
  		AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
  		AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
  		Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
  		Ae:'è', Be:'é', Ce:'ê',         He:'ë',
  		Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
  		Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
  		Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
  		KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
  		DN:209, Dn:241, Hy:255,
  		S:169,  c:170,  R:174,  "B ":180,
  		/*::[*/0/*::]*/:176,    /*::[*/1/*::]*/:177,  /*::[*/2/*::]*/:178,
  		/*::[*/3/*::]*/:179,    /*::[*/5/*::]*/:181,  /*::[*/6/*::]*/:182,
  		/*::[*/7/*::]*/:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
  		"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
  		"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
  	}/*:any*/);
  	var sylk_char_regex = new RegExp("\u001BN(" + keys$1(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
  	var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
  	var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
  	sylk_escapes["|"] = 254;
  	/* TODO: find an actual specification */
  	function sylk_to_aoa(d/*:RawData*/, opts)/*:[AOA, Worksheet]*/ {
  		switch(opts.type) {
  			case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
  			case 'binary': return sylk_to_aoa_str(d, opts);
  			case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
  			case 'array': return sylk_to_aoa_str(cc2str(d), opts);
  		}
  		throw new Error("Unrecognized type " + opts.type);
  	}
  	function sylk_to_aoa_str(str/*:string*/, opts)/*:[AOA, Worksheet]*/ {
  		var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr/*:AOA*/ = [];
  		var formats/*:Array<string>*/ = [];
  		var next_cell_format/*:string|null*/ = null;
  		var sht = {}, rowinfo/*:Array<RowInfo>*/ = [], colinfo/*:Array<ColInfo>*/ = [], cw/*:Array<string>*/ = [];
  		var Mval = 0, j;
  		if(+opts.codepage >= 0) set_cp(+opts.codepage);
  		for (; ri !== records.length; ++ri) {
  			Mval = 0;
  			var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
  			var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
  			var RT=record[0], val;
  			if(rstr.length > 0) switch(RT) {
  			case 'ID': break; /* header */
  			case 'E': break; /* EOF */
  			case 'B': break; /* dimensions */
  			case 'O': break; /* options? */
  			case 'W': break; /* window? */
  			case 'P':
  				if(record[1].charAt(0) == 'P')
  					formats.push(rstr.slice(3).replace(/;;/g, ";"));
  				break;
  			case 'C':
  			var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
  			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
  				case 'A': break; // TODO: comment
  				case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
  				case 'Y':
  					R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
  					for(j = arr.length; j <= R; ++j) arr[j] = [];
  					break;
  				case 'K':
  					val = record[rj].slice(1);
  					if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
  					else if(val === 'TRUE') val = true;
  					else if(val === 'FALSE') val = false;
  					else if(!isNaN(fuzzynum(val))) {
  						val = fuzzynum(val);
  						if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
  					} else if(!isNaN(fuzzydate(val).getDate())) {
  						val = parseDate(val);
  					}
  					C_seen_K = true;
  					break;
  				case 'E':
  					C_seen_E = true;
  					var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
  					arr[R][C] = [arr[R][C], formula];
  					break;
  				case 'S':
  					C_seen_S = true;
  					arr[R][C] = [arr[R][C], "S5S"];
  					break;
  				case 'G': break; // unknown
  				case 'R': _R = parseInt(record[rj].slice(1))-1; break;
  				case 'C': _C = parseInt(record[rj].slice(1))-1; break;
  				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
  			}
  			if(C_seen_K) {
  				if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
  				else arr[R][C] = val;
  				next_cell_format = null;
  			}
  			if(C_seen_S) {
  				if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
  				var shrbase = _R > -1 && arr[_R][_C];
  				if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
  				arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
  			}
  			break;
  			case 'F':
  			var F_seen = 0;
  			for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
  				case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
  				case 'Y':
  					R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
  					for(j = arr.length; j <= R; ++j) arr[j] = [];
  					break;
  				case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
  				case 'F': break; /* ??? */
  				case 'G': break; /* hide grid */
  				case 'P':
  					next_cell_format = formats[parseInt(record[rj].slice(1))];
  					break;
  				case 'S': break; /* cell style */
  				case 'D': break; /* column */
  				case 'N': break; /* font */
  				case 'W':
  					cw = record[rj].slice(1).split(" ");
  					for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
  						Mval = parseInt(cw[2], 10);
  						colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
  					} break;
  				case 'C': /* default column format */
  					C = parseInt(record[rj].slice(1))-1;
  					if(!colinfo[C]) colinfo[C] = {};
  					break;
  				case 'R': /* row properties */
  					R = parseInt(record[rj].slice(1))-1;
  					if(!rowinfo[R]) rowinfo[R] = {};
  					if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
  					else if(Mval === 0) rowinfo[R].hidden = true;
  					break;
  				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
  			}
  			if(F_seen < 1) next_cell_format = null; break;
  			default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
  			}
  		}
  		if(rowinfo.length > 0) sht['!rows'] = rowinfo;
  		if(colinfo.length > 0) sht['!cols'] = colinfo;
  		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
  		return [arr, sht];
  	}

  	function sylk_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
  		var aoasht = sylk_to_aoa(d, opts);
  		var aoa = aoasht[0], ws = aoasht[1];
  		var o = aoa_to_sheet(aoa, opts);
  		keys$1(ws).forEach(function(k) { o[k] = ws[k]; });
  		return o;
  	}

  	function sylk_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }

  	function write_ws_cell_sylk(cell/*:Cell*/, ws/*:Worksheet*/, R/*:number*/, C/*:number*//*::, opts*/)/*:string*/ {
  		var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
  		switch(cell.t) {
  			case 'n':
  				o += (cell.v||0);
  				if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
  			case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
  			case 'e': o += cell.w || cell.v; break;
  			case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
  			case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
  		}
  		return o;
  	}

  	function write_ws_cols_sylk(out, cols) {
  		cols.forEach(function(col, i) {
  			var rec = "F;W" + (i+1) + " " + (i+1) + " ";
  			if(col.hidden) rec += "0";
  			else {
  				if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
  				if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
  				if(typeof col.wch == 'number') rec += Math.round(col.wch);
  			}
  			if(rec.charAt(rec.length - 1) != " ") out.push(rec);
  		});
  	}

  	function write_ws_rows_sylk(out/*:Array<string>*/, rows/*:Array<RowInfo>*/) {
  		rows.forEach(function(row, i) {
  			var rec = "F;";
  			if(row.hidden) rec += "M0;";
  			else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
  			else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
  			if(rec.length > 2) out.push(rec + "R" + (i+1));
  		});
  	}

  	function sheet_to_sylk(ws/*:Worksheet*/, opts/*:?any*/)/*:string*/ {
  		var preamble/*:Array<string>*/ = ["ID;PWXL;N;E"], o/*:Array<string>*/ = [];
  		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
  		var dense = Array.isArray(ws);
  		var RS = "\r\n";

  		preamble.push("P;PGeneral");
  		preamble.push("F;P0;DG0G8;M255");
  		if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
  		if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);

  		preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
  		for(var R = r.s.r; R <= r.e.r; ++R) {
  			for(var C = r.s.c; C <= r.e.c; ++C) {
  				var coord = encode_cell({r:R,c:C});
  				cell = dense ? (ws[R]||[])[C]: ws[coord];
  				if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
  				o.push(write_ws_cell_sylk(cell, ws, R, C));
  			}
  		}
  		return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
  	}

  	return {
  		to_workbook: sylk_to_workbook,
  		to_sheet: sylk_to_sheet,
  		from_sheet: sheet_to_sylk
  	};
  })();

  var DIF = /*#__PURE__*/(function() {
  	function dif_to_aoa(d/*:RawData*/, opts)/*:AOA*/ {
  		switch(opts.type) {
  			case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
  			case 'binary': return dif_to_aoa_str(d, opts);
  			case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
  			case 'array': return dif_to_aoa_str(cc2str(d), opts);
  		}
  		throw new Error("Unrecognized type " + opts.type);
  	}
  	function dif_to_aoa_str(str/*:string*/, opts)/*:AOA*/ {
  		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
  		for (; ri !== records.length; ++ri) {
  			if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
  			if (R < 0) continue;
  			var metadata = records[ri].trim().split(",");
  			var type = metadata[0], value = metadata[1];
  			++ri;
  			var data = records[ri] || "";
  			while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
  			data = data.trim();
  			switch (+type) {
  				case -1:
  					if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
  					else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
  					break;
  				case 0:
  					if(data === 'TRUE') arr[R][C] = true;
  					else if(data === 'FALSE') arr[R][C] = false;
  					else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
  					else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
  					else arr[R][C] = value;
  					++C; break;
  				case 1:
  					data = data.slice(1,data.length-1);
  					data = data.replace(/""/g, '"');
  					if(data && data.match(/^=".*"$/)) data = data.slice(2, -1);
  					arr[R][C++] = data !== '' ? data : null;
  					break;
  			}
  			if (data === 'EOD') break;
  		}
  		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
  		return arr;
  	}

  	function dif_to_sheet(str/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
  	function dif_to_workbook(str/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }

  	var sheet_to_dif = /*#__PURE__*/(function() {
  		var push_field = function pf(o/*:Array<string>*/, topic/*:string*/, v/*:number*/, n/*:number*/, s/*:string*/) {
  			o.push(topic);
  			o.push(v + "," + n);
  			o.push('"' + s.replace(/"/g,'""') + '"');
  		};
  		var push_value = function po(o/*:Array<string>*/, type/*:number*/, v/*:any*/, s/*:string*/) {
  			o.push(type + "," + v);
  			o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
  		};
  		return function sheet_to_dif(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
  			var o/*:Array<string>*/ = [];
  			var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
  			var dense = Array.isArray(ws);
  			push_field(o, "TABLE", 0, 1, "sheetjs");
  			push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
  			push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
  			push_field(o, "DATA", 0, 0,"");
  			for(var R = r.s.r; R <= r.e.r; ++R) {
  				push_value(o, -1, 0, "BOT");
  				for(var C = r.s.c; C <= r.e.c; ++C) {
  					var coord = encode_cell({r:R,c:C});
  					cell = dense ? (ws[R]||[])[C] : ws[coord];
  					if(!cell) { push_value(o, 1, 0, ""); continue;}
  					switch(cell.t) {
  						case 'n':
  							var val = cell.w ;
  							if(!val && cell.v != null) val = cell.v;
  							if(val == null) {
  								if(cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
  								else push_value(o, 1, 0, "");
  							}
  							else push_value(o, 0, val, "V");
  							break;
  						case 'b':
  							push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
  							break;
  						case 's':
  							push_value(o, 1, 0, (isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
  							break;
  						case 'd':
  							if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
  							push_value(o, 0, cell.w, "V");
  							break;
  						default: push_value(o, 1, 0, "");
  					}
  				}
  			}
  			push_value(o, -1, 0, "EOD");
  			var RS = "\r\n";
  			var oo = o.join(RS);
  			//while((oo.length & 0x7F) != 0) oo += "\0";
  			return oo;
  		};
  	})();
  	return {
  		to_workbook: dif_to_workbook,
  		to_sheet: dif_to_sheet,
  		from_sheet: sheet_to_dif
  	};
  })();

  var ETH = /*#__PURE__*/(function() {
  	function decode(s/*:string*/)/*:string*/ { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
  	function encode(s/*:string*/)/*:string*/ { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }

  	function eth_to_aoa(str/*:string*/, opts)/*:AOA*/ {
  		var records = str.split('\n'), R = -1, C = -1, ri = 0, arr/*:AOA*/ = [];
  		for (; ri !== records.length; ++ri) {
  			var record = records[ri].trim().split(":");
  			if(record[0] !== 'cell') continue;
  			var addr = decode_cell(record[1]);
  			if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
  			R = addr.r; C = addr.c;
  			switch(record[2]) {
  				case 't': arr[R][C] = decode(record[3]); break;
  				case 'v': arr[R][C] = +record[3]; break;
  				case 'vtf': var _f = record[record.length - 1];
  					/* falls through */
  				case 'vtc':
  					switch(record[3]) {
  						case 'nl': arr[R][C] = +record[4] ? true : false; break;
  						default: arr[R][C] = +record[4]; break;
  					}
  					if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
  			}
  		}
  		if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
  		return arr;
  	}

  	function eth_to_sheet(d/*:string*/, opts)/*:Worksheet*/ { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
  	function eth_to_workbook(d/*:string*/, opts)/*:Workbook*/ { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }

  	var header = [
  		"socialcalc:version:1.5",
  		"MIME-Version: 1.0",
  		"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  	].join("\n");

  	var sep = [
  		"--SocialCalcSpreadsheetControlSave",
  		"Content-type: text/plain; charset=UTF-8"
  	].join("\n") + "\n";

  	/* TODO: the other parts */
  	var meta = [
  		"# SocialCalc Spreadsheet Control Save",
  		"part:sheet"
  	].join("\n");

  	var end = "--SocialCalcSpreadsheetControlSave--";

  	function sheet_to_eth_data(ws/*:Worksheet*/)/*:string*/ {
  		if(!ws || !ws['!ref']) return "";
  		var o/*:Array<string>*/ = [], oo/*:Array<string>*/ = [], cell, coord = "";
  		var r = decode_range(ws['!ref']);
  		var dense = Array.isArray(ws);
  		for(var R = r.s.r; R <= r.e.r; ++R) {
  			for(var C = r.s.c; C <= r.e.c; ++C) {
  				coord = encode_cell({r:R,c:C});
  				cell = dense ? (ws[R]||[])[C] : ws[coord];
  				if(!cell || cell.v == null || cell.t === 'z') continue;
  				oo = ["cell", coord, 't'];
  				switch(cell.t) {
  					case 's': case 'str': oo.push(encode(cell.v)); break;
  					case 'n':
  						if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
  						else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
  						break;
  					case 'b':
  						oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
  						oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
  						break;
  					case 'd':
  						var t = datenum(parseDate(cell.v));
  						oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
  						oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
  						break;
  					case 'e': continue;
  				}
  				o.push(oo.join(":"));
  			}
  		}
  		o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
  		o.push("valueformat:1:text-wiki");
  		//o.push("copiedfrom:" + ws['!ref']); // clipboard only
  		return o.join("\n");
  	}

  	function sheet_to_eth(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
  		return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
  		// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
  	}

  	return {
  		to_workbook: eth_to_workbook,
  		to_sheet: eth_to_sheet,
  		from_sheet: sheet_to_eth
  	};
  })();

  var PRN = /*#__PURE__*/(function() {
  	function set_text_arr(data/*:string*/, arr/*:AOA*/, R/*:number*/, C/*:number*/, o/*:any*/) {
  		if(o.raw) arr[R][C] = data;
  		else if(data === "");
  		else if(data === 'TRUE') arr[R][C] = true;
  		else if(data === 'FALSE') arr[R][C] = false;
  		else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
  		else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
  		else arr[R][C] = data;
  	}

  	function prn_to_aoa_str(f/*:string*/, opts)/*:AOA*/ {
  		var o = opts || {};
  		var arr/*:AOA*/ = ([]/*:any*/);
  		if(!f || f.length === 0) return arr;
  		var lines = f.split(/[\r\n]/);
  		var L = lines.length - 1;
  		while(L >= 0 && lines[L].length === 0) --L;
  		var start = 10, idx = 0;
  		var R = 0;
  		for(; R <= L; ++R) {
  			idx = lines[R].indexOf(" ");
  			if(idx == -1) idx = lines[R].length; else idx++;
  			start = Math.max(start, idx);
  		}
  		for(R = 0; R <= L; ++R) {
  			arr[R] = [];
  			/* TODO: confirm that widths are always 10 */
  			var C = 0;
  			set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
  			for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
  				set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
  		}
  		if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
  		return arr;
  	}

  	// List of accepted CSV separators
  	var guess_seps = {
  		/*::[*/0x2C/*::]*/: ',',
  		/*::[*/0x09/*::]*/: "\t",
  		/*::[*/0x3B/*::]*/: ';',
  		/*::[*/0x7C/*::]*/: '|'
  	};

  	// CSV separator weights to be used in case of equal numbers
  	var guess_sep_weights = {
  		/*::[*/0x2C/*::]*/: 3,
  		/*::[*/0x09/*::]*/: 2,
  		/*::[*/0x3B/*::]*/: 1,
  		/*::[*/0x7C/*::]*/: 0
  	};

  	function guess_sep(str) {
  		var cnt = {}, instr = false, end = 0, cc = 0;
  		for(;end < str.length;++end) {
  			if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
  			else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
  		}

  		cc = [];
  		for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
  			cc.push([ cnt[end], end ]);
  		}

  		if ( !cc.length ) {
  			cnt = guess_sep_weights;
  			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
  				cc.push([ cnt[end], end ]);
  			}
  		}

  		cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });

  		return guess_seps[cc.pop()[1]] || 0x2C;
  	}

  	function dsv_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
  		var o = opts || {};
  		var sep = "";
  		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);
  		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:0}}/*:any*/);

  		if(str.slice(0,4) == "sep=") {
  			// If the line ends in \r\n
  			if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
  				sep = str.charAt(4); str = str.slice(7);
  			}
  			// If line ends in \r OR \n
  			else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
  				sep = str.charAt(4); str = str.slice(6);
  			}
  			else sep = guess_sep(str.slice(0,1024));
  		}
  		else if(o && o.FS) sep = o.FS;
  		else sep = guess_sep(str.slice(0,1024));
  		var R = 0, C = 0, v = 0;
  		var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
  		str = str.replace(/\r\n/mg, "\n");
  		var _re/*:?RegExp*/ = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
  		function finish_cell() {
  			var s = str.slice(start, end);
  			var cell = ({}/*:any*/);
  			if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
  			if(s.length === 0) cell.t = 'z';
  			else if(o.raw) { cell.t = 's'; cell.v = s; }
  			else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
  			else if(s.charCodeAt(0) == 0x3D) {
  				if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
  				else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
  				else { cell.t = 's'; cell.v = s; } }
  			else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
  			else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
  			else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
  			else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
  				cell.z = o.dateNF || table_fmt[14];
  				var k = 0;
  				if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
  				if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
  				else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
  				if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
  				if(!o.cellNF) delete cell.z;
  			} else {
  				cell.t = 's';
  				cell.v = s;
  			}
  			if(cell.t == 'z');
  			else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
  			else ws[encode_cell({c:C,r:R})] = cell;
  			start = end+1; startcc = str.charCodeAt(start);
  			if(range.e.c < C) range.e.c = C;
  			if(range.e.r < R) range.e.r = R;
  			if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
  		}
  		outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
  			case 0x22: if(startcc === 0x22) instr = !instr; break;
  			case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
  		}
  		if(end - start > 0) finish_cell();

  		ws['!ref'] = encode_range(range);
  		return ws;
  	}

  	function prn_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
  		if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
  		if(opts.FS) return dsv_to_sheet_str(str, opts);
  		if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
  		if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
  		return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
  	}

  	function prn_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
  		var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
  		switch(opts.type) {
  			case 'base64': str = Base64_decode(d); break;
  			case 'binary': str = d; break;
  			case 'buffer':
  				if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
  				else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
  				else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
  				break;
  			case 'array': str = cc2str(d); break;
  			case 'string': str = d; break;
  			default: throw new Error("Unrecognized type " + opts.type);
  		}
  		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
  		else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
  		else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
  		if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
  		return prn_to_sheet_str(str, opts);
  	}

  	function prn_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }

  	function sheet_to_prn(ws/*:Worksheet*//*::, opts:?any*/)/*:string*/ {
  		var o/*:Array<string>*/ = [];
  		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
  		var dense = Array.isArray(ws);
  		for(var R = r.s.r; R <= r.e.r; ++R) {
  			var oo/*:Array<string>*/ = [];
  			for(var C = r.s.c; C <= r.e.c; ++C) {
  				var coord = encode_cell({r:R,c:C});
  				cell = dense ? (ws[R]||[])[C] : ws[coord];
  				if(!cell || cell.v == null) { oo.push("          "); continue; }
  				var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
  				while(w.length < 10) w += " ";
  				oo.push(w + (C === 0 ? " " : ""));
  			}
  			o.push(oo.join(""));
  		}
  		return o.join("\n");
  	}

  	return {
  		to_workbook: prn_to_workbook,
  		to_sheet: prn_to_sheet,
  		from_sheet: sheet_to_prn
  	};
  })();

  /* Excel defaults to SYLK but warns if data is not valid */
  function read_wb_ID(d, opts) {
  	var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
  	try {
  		var out = SYLK.to_workbook(d, o);
  		o.WTF = OLD_WTF;
  		return out;
  	} catch(e) {
  		o.WTF = OLD_WTF;
  		if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
  		return PRN.to_workbook(d, opts);
  	}
  }

  var WK_ = /*#__PURE__*/(function() {
  	function lotushopper(data, cb/*:RecordHopperCB*/, opts/*:any*/) {
  		if(!data) return;
  		prep_blob(data, data.l || 0);
  		var Enum = opts.Enum || WK1Enum;
  		while(data.l < data.length) {
  			var RT = data.read_shift(2);
  			var R = Enum[RT] || Enum[0xFFFF];
  			var length = data.read_shift(2);
  			var tgt = data.l + length;
  			var d = R.f && R.f(data, length, opts);
  			data.l = tgt;
  			if(cb(d, R, RT)) return;
  		}
  	}

  	function lotus_to_workbook(d/*:RawData*/, opts) {
  		switch(opts.type) {
  			case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
  			case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
  			case 'buffer':
  			case 'array': return lotus_to_workbook_buf(d, opts);
  		}
  		throw "Unsupported type " + opts.type;
  	}

  	function lotus_to_workbook_buf(d, opts)/*:Workbook*/ {
  		if(!d) return d;
  		var o = opts || {};
  		var s/*:Worksheet*/ = ((o.dense ? [] : {})/*:any*/), n = "Sheet1", next_n = "", sidx = 0;
  		var sheets = {}, snames = [], realnames = [];

  		var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
  		var sheetRows = o.sheetRows || 0;

  		if(d[2] == 0x00) {
  			if(d[3] == 0x08 || d[3] == 0x09) {
  				if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
  			}
  		}

  		if(d[2] == 0x02) {
  			o.Enum = WK1Enum;
  			lotushopper(d, function(val, R, RT) { switch(RT) {
  				case 0x00: /* BOF */
  					o.vers = val;
  					if(val >= 0x1000) o.qpro = true;
  					break;
  				case 0x06: refguess = val; break; /* RANGE */
  				case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
  				case 0xDE: next_n = val; break; /* SHEETNAMELP */
  				case 0x0F: /* LABEL */
  				case 0x33: /* STRING */
  					if(!o.qpro) val[1].v = val[1].v.slice(1);
  					/* falls through */
  				case 0x0D: /* INTEGER */
  				case 0x0E: /* NUMBER */
  				case 0x10: /* FORMULA */
  					/* TODO: actual translation of the format code */
  					if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
  						val[1].z = o.dateNF || table_fmt[14];
  						if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
  					}

  					if(o.qpro) {
  						if(val[3] > sidx) {
  							s["!ref"] = encode_range(refguess);
  							sheets[n] = s;
  							snames.push(n);
  							s = (o.dense ? [] : {});
  							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
  							sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
  						}
  					}

  					var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
  					if(tmpcell) {
  						tmpcell.t = val[1].t; tmpcell.v = val[1].v;
  						if(val[1].z != null) tmpcell.z = val[1].z;
  						if(val[1].f != null) tmpcell.f = val[1].f;
  						break;
  					}
  					if(o.dense) {
  						if(!s[val[0].r]) s[val[0].r] = [];
  						s[val[0].r][val[0].c] = val[1];
  					} else s[encode_cell(val[0])] = val[1];
  					break;
  			}}, o);
  		} else if(d[2] == 0x1A || d[2] == 0x0E) {
  			o.Enum = WK3Enum;
  			if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
  			lotushopper(d, function(val, R, RT) { switch(RT) {
  				case 0xCC: n = val; break; /* SHEETNAMECS */
  				case 0x16: /* LABEL16 */
  					val[1].v = val[1].v.slice(1);
  					/* falls through */
  				case 0x17: /* NUMBER17 */
  				case 0x18: /* NUMBER18 */
  				case 0x19: /* FORMULA19 */
  				case 0x25: /* NUMBER25 */
  				case 0x27: /* NUMBER27 */
  				case 0x28: /* FORMULA28 */
  					if(val[3] > sidx) {
  						s["!ref"] = encode_range(refguess);
  						sheets[n] = s;
  						snames.push(n);
  						s = (o.dense ? [] : {});
  						refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
  						sidx = val[3]; n = "Sheet" + (sidx + 1);
  					}
  					if(sheetRows > 0 && val[0].r >= sheetRows) break;
  					if(o.dense) {
  						if(!s[val[0].r]) s[val[0].r] = [];
  						s[val[0].r][val[0].c] = val[1];
  					} else s[encode_cell(val[0])] = val[1];
  					if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
  					if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
  					break;
  				case 0x1B: /* XFORMAT */
  					if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
  					break;
  				case 0x0601: /* SHEETINFOQP */
  					realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
  			}}, o);
  		} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
  		s["!ref"] = encode_range(refguess);
  		sheets[next_n || n] = s;
  		snames.push(next_n || n);
  		if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
  		var osheets = {}, rnames = [];
  		/* TODO: verify no collisions */
  		for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
  			rnames.push(realnames[i] || snames[i]);
  			osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
  		} else {
  			rnames.push(realnames[i]);
  			osheets[realnames[i]] = ({ "!ref": "A1" });
  		}
  		return { SheetNames: rnames, Sheets: osheets };
  	}

  	function sheet_to_wk1(ws/*:Worksheet*/, opts/*:WriteOpts*/) {
  		var o = opts || {};
  		if(+o.codepage >= 0) set_cp(+o.codepage);
  		if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
  		var ba = buf_array();
  		var range = safe_decode_range(ws["!ref"]);
  		var dense = Array.isArray(ws);
  		var cols = [];

  		write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
  		write_biff_rec(ba, 0x06, write_RANGE(range));
  		var max_R = Math.min(range.e.r, 8191);
  		for(var R = range.s.r; R <= max_R; ++R) {
  			var rr = encode_row(R);
  			for(var C = range.s.c; C <= range.e.c; ++C) {
  				if(R === range.s.r) cols[C] = encode_col(C);
  				var ref = cols[C] + rr;
  				var cell = dense ? (ws[R]||[])[C] : ws[ref];
  				if(!cell || cell.t == "z") continue;
  				/* TODO: formula records */
  				if(cell.t == "n") {
  					if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
  					else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
  				} else {
  					var str = format_cell(cell);
  					write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
  				}
  			}
  		}

  		write_biff_rec(ba, 0x01);
  		return ba.end();
  	}

  	function book_to_wk3(wb/*:Workbook*/, opts/*:WriteOpts*/) {
  		var o = opts || {};
  		if(+o.codepage >= 0) set_cp(+o.codepage);
  		if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
  		var ba = buf_array();

  		write_biff_rec(ba, 0x00, write_BOF_WK3(wb));

  		for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));

  		var wsidx = 0;
  		for(i = 0; i < wb.SheetNames.length; ++i) {
  			var ws = wb.Sheets[wb.SheetNames[i]];
  			if(!ws || !ws["!ref"]) continue;
  			var range = safe_decode_range(ws["!ref"]);
  			var dense = Array.isArray(ws);
  			var cols = [];
  			var max_R = Math.min(range.e.r, 8191);
  			for(var R = range.s.r; R <= max_R; ++R) {
  				var rr = encode_row(R);
  				for(var C = range.s.c; C <= range.e.c; ++C) {
  					if(R === range.s.r) cols[C] = encode_col(C);
  					var ref = cols[C] + rr;
  					var cell = dense ? (ws[R]||[])[C] : ws[ref];
  					if(!cell || cell.t == "z") continue;
  					/* TODO: FORMULA19 NUMBER18 records */
  					if(cell.t == "n") {
  						write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
  					} else {
  						var str = format_cell(cell);
  						/* TODO: max len? */
  						write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
  					}
  				}
  			}
  			++wsidx;
  		}

  		write_biff_rec(ba, 0x01);
  		return ba.end();
  	}


  	function write_BOF_WK1(v/*:number*/) {
  		var out = new_buf(2);
  		out.write_shift(2, v);
  		return out;
  	}

  	function write_BOF_WK3(wb/*:Workbook*/) {
  		var out = new_buf(26);
  		out.write_shift(2, 0x1000);
  		out.write_shift(2, 0x0004);
  		out.write_shift(4, 0x0000);
  		var rows = 0, cols = 0, wscnt = 0;
  		for(var i = 0; i < wb.SheetNames.length; ++i) {
  			var name = wb.SheetNames[i];
  			var ws = wb.Sheets[name];
  			if(!ws || !ws["!ref"]) continue;
  			++wscnt;
  			var range = decode_range(ws["!ref"]);
  			if(rows < range.e.r) rows = range.e.r;
  			if(cols < range.e.c) cols = range.e.c;
  		}
  		if(rows > 8191) rows = 8191;
  		out.write_shift(2, rows);
  		out.write_shift(1, wscnt);
  		out.write_shift(1, cols);
  		out.write_shift(2, 0x00);
  		out.write_shift(2, 0x00);
  		out.write_shift(1, 0x01);
  		out.write_shift(1, 0x02);
  		out.write_shift(4, 0);
  		out.write_shift(4, 0);
  		return out;
  	}

  	function parse_RANGE(blob, length, opts) {
  		var o = {s:{c:0,r:0},e:{c:0,r:0}};
  		if(length == 8 && opts.qpro) {
  			o.s.c = blob.read_shift(1);
  			blob.l++;
  			o.s.r = blob.read_shift(2);
  			o.e.c = blob.read_shift(1);
  			blob.l++;
  			o.e.r = blob.read_shift(2);
  			return o;
  		}
  		o.s.c = blob.read_shift(2);
  		o.s.r = blob.read_shift(2);
  		if(length == 12 && opts.qpro) blob.l += 2;
  		o.e.c = blob.read_shift(2);
  		o.e.r = blob.read_shift(2);
  		if(length == 12 && opts.qpro) blob.l += 2;
  		if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
  		return o;
  	}
  	function write_RANGE(range) {
  		var out = new_buf(8);
  		out.write_shift(2, range.s.c);
  		out.write_shift(2, range.s.r);
  		out.write_shift(2, range.e.c);
  		out.write_shift(2, range.e.r);
  		return out;
  	}

  	function parse_cell(blob, length, opts) {
  		var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
  		if(opts.qpro && opts.vers != 0x5120) {
  			o[0].c = blob.read_shift(1);
  			o[3] = blob.read_shift(1);
  			o[0].r = blob.read_shift(2);
  			blob.l+=2;
  		} else {
  			o[2] = blob.read_shift(1);
  			o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
  		}
  		return o;
  	}

  	function parse_LABEL(blob, length, opts) {
  		var tgt = blob.l + length;
  		var o = parse_cell(blob, length, opts);
  		o[1].t = 's';
  		if(opts.vers == 0x5120) {
  			blob.l++;
  			var len = blob.read_shift(1);
  			o[1].v = blob.read_shift(len, 'utf8');
  			return o;
  		}
  		if(opts.qpro) blob.l++;
  		o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
  		return o;
  	}
  	function write_LABEL(R, C, s) {
  		/* TODO: encoding */
  		var o = new_buf(7 + s.length);
  		o.write_shift(1, 0xFF);
  		o.write_shift(2, C);
  		o.write_shift(2, R);
  		o.write_shift(1, 0x27); // ??
  		for(var i = 0; i < o.length; ++i) {
  			var cc = s.charCodeAt(i);
  			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
  		}
  		o.write_shift(1, 0);
  		return o;
  	}

  	function parse_INTEGER(blob, length, opts) {
  		var o = parse_cell(blob, length, opts);
  		o[1].v = blob.read_shift(2, 'i');
  		return o;
  	}
  	function write_INTEGER(R, C, v) {
  		var o = new_buf(7);
  		o.write_shift(1, 0xFF);
  		o.write_shift(2, C);
  		o.write_shift(2, R);
  		o.write_shift(2, v, 'i');
  		return o;
  	}

  	function parse_NUMBER(blob, length, opts) {
  		var o = parse_cell(blob, length, opts);
  		o[1].v = blob.read_shift(8, 'f');
  		return o;
  	}
  	function write_NUMBER(R, C, v) {
  		var o = new_buf(13);
  		o.write_shift(1, 0xFF);
  		o.write_shift(2, C);
  		o.write_shift(2, R);
  		o.write_shift(8, v, 'f');
  		return o;
  	}

  	function parse_FORMULA(blob, length, opts) {
  		var tgt = blob.l + length;
  		var o = parse_cell(blob, length, opts);
  		/* TODO: formula */
  		o[1].v = blob.read_shift(8, 'f');
  		if(opts.qpro) blob.l = tgt;
  		else {
  			var flen = blob.read_shift(2);
  			wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
  			blob.l += flen;
  		}
  		return o;
  	}

  	function wk1_parse_rc(B, V, col) {
  		var rel = V & 0x8000;
  		V &= ~0x8000;
  		V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
  		return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
  	}
  	/* var oprec = [
  		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
  		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
  	]; */
  	/* TODO: flesh out */
  	var FuncTab = {
  		0x33: ["FALSE", 0],
  		0x34: ["TRUE", 0],
  		0x46: ["LEN", 1],
  		0x50: ["SUM", 69],
  		0x51: ["AVERAGEA", 69],
  		0x52: ["COUNTA", 69],
  		0x53: ["MINA", 69],
  		0x54: ["MAXA", 69],
  		0x6F: ["T", 1]
  	};
  	var BinOpTab = [
  		  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
  		  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
  		"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
  		 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
  	];

  	function wk1_fmla_to_csf(blob, o) {
  		prep_blob(blob, 0);
  		var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
  		while(blob.l < blob.length) {
  			var cc = blob[blob.l++];
  			switch(cc) {
  				case 0x00: out.push(blob.read_shift(8, 'f')); break;
  				case 0x01: {
  					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
  					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
  					out.push(C + R);
  				} break;
  				case 0x02: {
  					var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
  					var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
  					C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
  					R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
  					out.push(c + r + ":" + C + R);
  				} break;
  				case 0x03:
  					if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
  					break;
  				case 0x04: out.push("(" + out.pop() + ")"); break;
  				case 0x05: out.push(blob.read_shift(2)); break;
  				case 0x06: {
  					/* TODO: text encoding */
  					var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
  					out.push('"' + Z.replace(/"/g, '""') + '"');
  				} break;

  				case 0x08: out.push("-" + out.pop()); break;
  				case 0x17: out.push("+" + out.pop()); break;
  				case 0x16: out.push("NOT(" + out.pop() + ")"); break;

  				case 0x14: case 0x15: {
  					argR = out.pop(); argL = out.pop();
  					out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
  				} break;

  				default:
  					if(cc < 0x20 && BinOpTab[cc]) {
  						argR = out.pop(); argL = out.pop();
  						out.push(argL + BinOpTab[cc] + argR);
  					} else if(FuncTab[cc]) {
  						argc = FuncTab[cc][1];
  						if(argc == 69) argc = blob[blob.l++];
  						if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
  						var args = out.slice(-argc);
  						out.length -= argc;
  						out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
  					}
  					else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
  					else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
  					else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
  					else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
  					// possible future functions ??
  					else return console.error("WK1 unrecognized opcode " + cc.toString(16));
  			}
  		}
  		if(out.length == 1) o[1].f = "" + out[0];
  		else console.error("WK1 bad formula parse |" + out.join("|") + "|");
  	}


  	function parse_cell_3(blob/*::, length*/) {
  		var o = [{c:0,r:0}, {t:'n',v:0}, 0];
  		o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
  		return o;
  	}

  	function parse_LABEL_16(blob, length) {
  		var o = parse_cell_3(blob);
  		o[1].t = 's';
  		o[1].v = blob.read_shift(length - 4, 'cstr');
  		return o;
  	}
  	function write_LABEL_16(R, C, wsidx, s) {
  		/* TODO: encoding */
  		var o = new_buf(6 + s.length);
  		o.write_shift(2, R);
  		o.write_shift(1, wsidx);
  		o.write_shift(1, C);
  		o.write_shift(1, 0x27);
  		for(var i = 0; i < s.length; ++i) {
  			var cc = s.charCodeAt(i);
  			o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
  		}
  		o.write_shift(1, 0);
  		return o;
  	}

  	function parse_NUMBER_18(blob, length) {
  		var o = parse_cell_3(blob);
  		o[1].v = blob.read_shift(2);
  		var v = o[1].v >> 1;
  		if(o[1].v & 0x1) {
  			switch(v & 0x07) {
  				case 0: v = (v >> 3) * 5000; break;
  				case 1: v = (v >> 3) * 500; break;
  				case 2: v = (v >> 3) / 20; break;
  				case 3: v = (v >> 3) / 200; break;
  				case 4: v = (v >> 3) / 2000; break;
  				case 5: v = (v >> 3) / 20000; break;
  				case 6: v = (v >> 3) / 16; break;
  				case 7: v = (v >> 3) / 64; break;
  			}
  		}
  		o[1].v = v;
  		return o;
  	}

  	function parse_NUMBER_17(blob, length) {
  		var o = parse_cell_3(blob);
  		var v1 = blob.read_shift(4);
  		var v2 = blob.read_shift(4);
  		var e = blob.read_shift(2);
  		if(e == 0xFFFF) {
  			if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
  			else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
  			else o[1].v = 0;
  			return o;
  		}
  		var s = e & 0x8000; e = (e&0x7FFF) - 16446;
  		o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
  		return o;
  	}
  	function write_NUMBER_17(R, C, wsidx, v) {
  		var o = new_buf(14);
  		o.write_shift(2, R);
  		o.write_shift(1, wsidx);
  		o.write_shift(1, C);
  		if(v == 0) {
  			o.write_shift(4, 0);
  			o.write_shift(4, 0);
  			o.write_shift(2, 0xFFFF);
  			return o;
  		}
  		var s = 0, e = 0, v1 = 0, v2 = 0;
  		if(v < 0) { s = 1; v = -v; }
  		e = Math.log2(v) | 0;
  		v /= Math.pow(2, e-31);
  		v2 = (v)>>>0;
  		if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
  		v -= v2;
  		v2 |= 0x80000000;
  		v2 >>>= 0;
  		v *= Math.pow(2, 32);
  		v1 = v>>>0;
  		o.write_shift(4, v1);
  		o.write_shift(4, v2);
  		e += 0x3FFF + (s ? 0x8000 : 0);
  		o.write_shift(2, e);
  		return o;
  	}

  	function parse_FORMULA_19(blob, length) {
  		var o = parse_NUMBER_17(blob);
  		blob.l += length - 14; /* TODO: WK3 formula */
  		return o;
  	}

  	function parse_NUMBER_25(blob, length) {
  		var o = parse_cell_3(blob);
  		var v1 = blob.read_shift(4);
  		o[1].v = v1 >> 6;
  		return o;
  	}

  	function parse_NUMBER_27(blob, length) {
  		var o = parse_cell_3(blob);
  		var v1 = blob.read_shift(8,'f');
  		o[1].v = v1;
  		return o;
  	}

  	function parse_FORMULA_28(blob, length) {
  		var o = parse_NUMBER_27(blob);
  		blob.l += length - 10; /* TODO: formula */
  		return o;
  	}

  	function parse_SHEETNAMECS(blob, length) {
  		return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
  	}

  	function parse_SHEETNAMELP(blob, length) {
  		var len = blob[blob.l++];
  		if(len > length - 1) len = length - 1;
  		var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
  		return o;
  	}

  	function parse_SHEETINFOQP(blob, length, opts) {
  		if(!opts.qpro || length < 21) return;
  		var id = blob.read_shift(1);
  		blob.l += 17;
  		blob.l += 1; //var len = blob.read_shift(1);
  		blob.l += 2;
  		var nm = blob.read_shift(length - 21, 'cstr');
  		return [id, nm];
  	}

  	function parse_XFORMAT(blob, length) {
  		var o = {}, tgt = blob.l + length;
  		while(blob.l < tgt) {
  			var dt = blob.read_shift(2);
  			if(dt == 0x36b0) {
  				o[dt] = [0, ""];
  				o[dt][0] = blob.read_shift(2);
  				while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
  			}
  			// TODO: 0x3a99 ??
  		}
  		return o;
  	}
  	function write_XFORMAT_SHEETNAME(name, wsidx) {
  		var out = new_buf(5 + name.length);
  		out.write_shift(2, 0x36b0);
  		out.write_shift(2, wsidx);
  		for(var i = 0; i < name.length; ++i) {
  			var cc = name.charCodeAt(i);
  			out[out.l++] = cc > 0x7F ? 0x5F : cc;
  		}
  		out[out.l++] = 0;
  		return out;
  	}

  	var WK1Enum = {
  		/*::[*/0x0000/*::]*/: { n:"BOF", f:parseuint16 },
  		/*::[*/0x0001/*::]*/: { n:"EOF" },
  		/*::[*/0x0002/*::]*/: { n:"CALCMODE" },
  		/*::[*/0x0003/*::]*/: { n:"CALCORDER" },
  		/*::[*/0x0004/*::]*/: { n:"SPLIT" },
  		/*::[*/0x0005/*::]*/: { n:"SYNC" },
  		/*::[*/0x0006/*::]*/: { n:"RANGE", f:parse_RANGE },
  		/*::[*/0x0007/*::]*/: { n:"WINDOW1" },
  		/*::[*/0x0008/*::]*/: { n:"COLW1" },
  		/*::[*/0x0009/*::]*/: { n:"WINTWO" },
  		/*::[*/0x000A/*::]*/: { n:"COLW2" },
  		/*::[*/0x000B/*::]*/: { n:"NAME" },
  		/*::[*/0x000C/*::]*/: { n:"BLANK" },
  		/*::[*/0x000D/*::]*/: { n:"INTEGER", f:parse_INTEGER },
  		/*::[*/0x000E/*::]*/: { n:"NUMBER", f:parse_NUMBER },
  		/*::[*/0x000F/*::]*/: { n:"LABEL", f:parse_LABEL },
  		/*::[*/0x0010/*::]*/: { n:"FORMULA", f:parse_FORMULA },
  		/*::[*/0x0018/*::]*/: { n:"TABLE" },
  		/*::[*/0x0019/*::]*/: { n:"ORANGE" },
  		/*::[*/0x001A/*::]*/: { n:"PRANGE" },
  		/*::[*/0x001B/*::]*/: { n:"SRANGE" },
  		/*::[*/0x001C/*::]*/: { n:"FRANGE" },
  		/*::[*/0x001D/*::]*/: { n:"KRANGE1" },
  		/*::[*/0x0020/*::]*/: { n:"HRANGE" },
  		/*::[*/0x0023/*::]*/: { n:"KRANGE2" },
  		/*::[*/0x0024/*::]*/: { n:"PROTEC" },
  		/*::[*/0x0025/*::]*/: { n:"FOOTER" },
  		/*::[*/0x0026/*::]*/: { n:"HEADER" },
  		/*::[*/0x0027/*::]*/: { n:"SETUP" },
  		/*::[*/0x0028/*::]*/: { n:"MARGINS" },
  		/*::[*/0x0029/*::]*/: { n:"LABELFMT" },
  		/*::[*/0x002A/*::]*/: { n:"TITLES" },
  		/*::[*/0x002B/*::]*/: { n:"SHEETJS" },
  		/*::[*/0x002D/*::]*/: { n:"GRAPH" },
  		/*::[*/0x002E/*::]*/: { n:"NGRAPH" },
  		/*::[*/0x002F/*::]*/: { n:"CALCCOUNT" },
  		/*::[*/0x0030/*::]*/: { n:"UNFORMATTED" },
  		/*::[*/0x0031/*::]*/: { n:"CURSORW12" },
  		/*::[*/0x0032/*::]*/: { n:"WINDOW" },
  		/*::[*/0x0033/*::]*/: { n:"STRING", f:parse_LABEL },
  		/*::[*/0x0037/*::]*/: { n:"PASSWORD" },
  		/*::[*/0x0038/*::]*/: { n:"LOCKED" },
  		/*::[*/0x003C/*::]*/: { n:"QUERY" },
  		/*::[*/0x003D/*::]*/: { n:"QUERYNAME" },
  		/*::[*/0x003E/*::]*/: { n:"PRINT" },
  		/*::[*/0x003F/*::]*/: { n:"PRINTNAME" },
  		/*::[*/0x0040/*::]*/: { n:"GRAPH2" },
  		/*::[*/0x0041/*::]*/: { n:"GRAPHNAME" },
  		/*::[*/0x0042/*::]*/: { n:"ZOOM" },
  		/*::[*/0x0043/*::]*/: { n:"SYMSPLIT" },
  		/*::[*/0x0044/*::]*/: { n:"NSROWS" },
  		/*::[*/0x0045/*::]*/: { n:"NSCOLS" },
  		/*::[*/0x0046/*::]*/: { n:"RULER" },
  		/*::[*/0x0047/*::]*/: { n:"NNAME" },
  		/*::[*/0x0048/*::]*/: { n:"ACOMM" },
  		/*::[*/0x0049/*::]*/: { n:"AMACRO" },
  		/*::[*/0x004A/*::]*/: { n:"PARSE" },
  		/*::[*/0x0066/*::]*/: { n:"PRANGES??" },
  		/*::[*/0x0067/*::]*/: { n:"RRANGES??" },
  		/*::[*/0x0068/*::]*/: { n:"FNAME??" },
  		/*::[*/0x0069/*::]*/: { n:"MRANGES??" },
  		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
  		/*::[*/0x00DE/*::]*/: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
  		/*::[*/0xFFFF/*::]*/: { n:"" }
  	};

  	var WK3Enum = {
  		/*::[*/0x0000/*::]*/: { n:"BOF" },
  		/*::[*/0x0001/*::]*/: { n:"EOF" },
  		/*::[*/0x0002/*::]*/: { n:"PASSWORD" },
  		/*::[*/0x0003/*::]*/: { n:"CALCSET" },
  		/*::[*/0x0004/*::]*/: { n:"WINDOWSET" },
  		/*::[*/0x0005/*::]*/: { n:"SHEETCELLPTR" },
  		/*::[*/0x0006/*::]*/: { n:"SHEETLAYOUT" },
  		/*::[*/0x0007/*::]*/: { n:"COLUMNWIDTH" },
  		/*::[*/0x0008/*::]*/: { n:"HIDDENCOLUMN" },
  		/*::[*/0x0009/*::]*/: { n:"USERRANGE" },
  		/*::[*/0x000A/*::]*/: { n:"SYSTEMRANGE" },
  		/*::[*/0x000B/*::]*/: { n:"ZEROFORCE" },
  		/*::[*/0x000C/*::]*/: { n:"SORTKEYDIR" },
  		/*::[*/0x000D/*::]*/: { n:"FILESEAL" },
  		/*::[*/0x000E/*::]*/: { n:"DATAFILLNUMS" },
  		/*::[*/0x000F/*::]*/: { n:"PRINTMAIN" },
  		/*::[*/0x0010/*::]*/: { n:"PRINTSTRING" },
  		/*::[*/0x0011/*::]*/: { n:"GRAPHMAIN" },
  		/*::[*/0x0012/*::]*/: { n:"GRAPHSTRING" },
  		/*::[*/0x0013/*::]*/: { n:"??" },
  		/*::[*/0x0014/*::]*/: { n:"ERRCELL" },
  		/*::[*/0x0015/*::]*/: { n:"NACELL" },
  		/*::[*/0x0016/*::]*/: { n:"LABEL16", f:parse_LABEL_16},
  		/*::[*/0x0017/*::]*/: { n:"NUMBER17", f:parse_NUMBER_17 },
  		/*::[*/0x0018/*::]*/: { n:"NUMBER18", f:parse_NUMBER_18 },
  		/*::[*/0x0019/*::]*/: { n:"FORMULA19", f:parse_FORMULA_19},
  		/*::[*/0x001A/*::]*/: { n:"FORMULA1A" },
  		/*::[*/0x001B/*::]*/: { n:"XFORMAT", f:parse_XFORMAT },
  		/*::[*/0x001C/*::]*/: { n:"DTLABELMISC" },
  		/*::[*/0x001D/*::]*/: { n:"DTLABELCELL" },
  		/*::[*/0x001E/*::]*/: { n:"GRAPHWINDOW" },
  		/*::[*/0x001F/*::]*/: { n:"CPA" },
  		/*::[*/0x0020/*::]*/: { n:"LPLAUTO" },
  		/*::[*/0x0021/*::]*/: { n:"QUERY" },
  		/*::[*/0x0022/*::]*/: { n:"HIDDENSHEET" },
  		/*::[*/0x0023/*::]*/: { n:"??" },
  		/*::[*/0x0025/*::]*/: { n:"NUMBER25", f:parse_NUMBER_25 },
  		/*::[*/0x0026/*::]*/: { n:"??" },
  		/*::[*/0x0027/*::]*/: { n:"NUMBER27", f:parse_NUMBER_27 },
  		/*::[*/0x0028/*::]*/: { n:"FORMULA28", f:parse_FORMULA_28 },
  		/*::[*/0x008E/*::]*/: { n:"??" },
  		/*::[*/0x0093/*::]*/: { n:"??" },
  		/*::[*/0x0096/*::]*/: { n:"??" },
  		/*::[*/0x0097/*::]*/: { n:"??" },
  		/*::[*/0x0098/*::]*/: { n:"??" },
  		/*::[*/0x0099/*::]*/: { n:"??" },
  		/*::[*/0x009A/*::]*/: { n:"??" },
  		/*::[*/0x009B/*::]*/: { n:"??" },
  		/*::[*/0x009C/*::]*/: { n:"??" },
  		/*::[*/0x00A3/*::]*/: { n:"??" },
  		/*::[*/0x00AE/*::]*/: { n:"??" },
  		/*::[*/0x00AF/*::]*/: { n:"??" },
  		/*::[*/0x00B0/*::]*/: { n:"??" },
  		/*::[*/0x00B1/*::]*/: { n:"??" },
  		/*::[*/0x00B8/*::]*/: { n:"??" },
  		/*::[*/0x00B9/*::]*/: { n:"??" },
  		/*::[*/0x00BA/*::]*/: { n:"??" },
  		/*::[*/0x00BB/*::]*/: { n:"??" },
  		/*::[*/0x00BC/*::]*/: { n:"??" },
  		/*::[*/0x00C3/*::]*/: { n:"??" },
  		/*::[*/0x00C9/*::]*/: { n:"??" },
  		/*::[*/0x00CC/*::]*/: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
  		/*::[*/0x00CD/*::]*/: { n:"??" },
  		/*::[*/0x00CE/*::]*/: { n:"??" },
  		/*::[*/0x00CF/*::]*/: { n:"??" },
  		/*::[*/0x00D0/*::]*/: { n:"??" },
  		/*::[*/0x0100/*::]*/: { n:"??" },
  		/*::[*/0x0103/*::]*/: { n:"??" },
  		/*::[*/0x0104/*::]*/: { n:"??" },
  		/*::[*/0x0105/*::]*/: { n:"??" },
  		/*::[*/0x0106/*::]*/: { n:"??" },
  		/*::[*/0x0107/*::]*/: { n:"??" },
  		/*::[*/0x0109/*::]*/: { n:"??" },
  		/*::[*/0x010A/*::]*/: { n:"??" },
  		/*::[*/0x010B/*::]*/: { n:"??" },
  		/*::[*/0x010C/*::]*/: { n:"??" },
  		/*::[*/0x010E/*::]*/: { n:"??" },
  		/*::[*/0x010F/*::]*/: { n:"??" },
  		/*::[*/0x0180/*::]*/: { n:"??" },
  		/*::[*/0x0185/*::]*/: { n:"??" },
  		/*::[*/0x0186/*::]*/: { n:"??" },
  		/*::[*/0x0189/*::]*/: { n:"??" },
  		/*::[*/0x018C/*::]*/: { n:"??" },
  		/*::[*/0x0200/*::]*/: { n:"??" },
  		/*::[*/0x0202/*::]*/: { n:"??" },
  		/*::[*/0x0201/*::]*/: { n:"??" },
  		/*::[*/0x0204/*::]*/: { n:"??" },
  		/*::[*/0x0205/*::]*/: { n:"??" },
  		/*::[*/0x0280/*::]*/: { n:"??" },
  		/*::[*/0x0281/*::]*/: { n:"??" },
  		/*::[*/0x0282/*::]*/: { n:"??" },
  		/*::[*/0x0283/*::]*/: { n:"??" },
  		/*::[*/0x0284/*::]*/: { n:"??" },
  		/*::[*/0x0285/*::]*/: { n:"??" },
  		/*::[*/0x0286/*::]*/: { n:"??" },
  		/*::[*/0x0287/*::]*/: { n:"??" },
  		/*::[*/0x0288/*::]*/: { n:"??" },
  		/*::[*/0x0292/*::]*/: { n:"??" },
  		/*::[*/0x0293/*::]*/: { n:"??" },
  		/*::[*/0x0294/*::]*/: { n:"??" },
  		/*::[*/0x0295/*::]*/: { n:"??" },
  		/*::[*/0x0296/*::]*/: { n:"??" },
  		/*::[*/0x0299/*::]*/: { n:"??" },
  		/*::[*/0x029A/*::]*/: { n:"??" },
  		/*::[*/0x0300/*::]*/: { n:"??" },
  		/*::[*/0x0304/*::]*/: { n:"??" },
  		/*::[*/0x0601/*::]*/: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
  		/*::[*/0x0640/*::]*/: { n:"??" },
  		/*::[*/0x0642/*::]*/: { n:"??" },
  		/*::[*/0x0701/*::]*/: { n:"??" },
  		/*::[*/0x0702/*::]*/: { n:"??" },
  		/*::[*/0x0703/*::]*/: { n:"??" },
  		/*::[*/0x0704/*::]*/: { n:"??" },
  		/*::[*/0x0780/*::]*/: { n:"??" },
  		/*::[*/0x0800/*::]*/: { n:"??" },
  		/*::[*/0x0801/*::]*/: { n:"??" },
  		/*::[*/0x0804/*::]*/: { n:"??" },
  		/*::[*/0x0A80/*::]*/: { n:"??" },
  		/*::[*/0x2AF6/*::]*/: { n:"??" },
  		/*::[*/0x3231/*::]*/: { n:"??" },
  		/*::[*/0x6E49/*::]*/: { n:"??" },
  		/*::[*/0x6F44/*::]*/: { n:"??" },
  		/*::[*/0xFFFF/*::]*/: { n:"" }
  	};
  	return {
  		sheet_to_wk1: sheet_to_wk1,
  		book_to_wk3: book_to_wk3,
  		to_workbook: lotus_to_workbook
  	};
  })();
  /* 18.4.7 rPr CT_RPrElt */
  function parse_rpr(rpr) {
  	var font = {}, m = rpr.match(tagregex), i = 0;
  	var pass = false;
  	if(m) for(;i!=m.length; ++i) {
  		var y = parsexmltag(m[i]);
  		switch(y[0].replace(/\w*:/g,"")) {
  			/* 18.8.12 condense CT_BooleanProperty */
  			/* ** not required . */
  			case '<condense': break;
  			/* 18.8.17 extend CT_BooleanProperty */
  			/* ** not required . */
  			case '<extend': break;
  			/* 18.8.36 shadow CT_BooleanProperty */
  			/* ** not required . */
  			case '<shadow':
  				if(!y.val) break;
  				/* falls through */
  			case '<shadow>':
  			case '<shadow/>': font.shadow = 1; break;
  			case '</shadow>': break;

  			/* 18.4.1 charset CT_IntProperty TODO */
  			case '<charset':
  				if(y.val == '1') break;
  				font.cp = CS2CP[parseInt(y.val, 10)];
  				break;

  			/* 18.4.2 outline CT_BooleanProperty TODO */
  			case '<outline':
  				if(!y.val) break;
  				/* falls through */
  			case '<outline>':
  			case '<outline/>': font.outline = 1; break;
  			case '</outline>': break;

  			/* 18.4.5 rFont CT_FontName */
  			case '<rFont': font.name = y.val; break;

  			/* 18.4.11 sz CT_FontSize */
  			case '<sz': font.sz = y.val; break;

  			/* 18.4.10 strike CT_BooleanProperty */
  			case '<strike':
  				if(!y.val) break;
  				/* falls through */
  			case '<strike>':
  			case '<strike/>': font.strike = 1; break;
  			case '</strike>': break;

  			/* 18.4.13 u CT_UnderlineProperty */
  			case '<u':
  				if(!y.val) break;
  				switch(y.val) {
  					case 'double': font.uval = "double"; break;
  					case 'singleAccounting': font.uval = "single-accounting"; break;
  					case 'doubleAccounting': font.uval = "double-accounting"; break;
  				}
  				/* falls through */
  			case '<u>':
  			case '<u/>': font.u = 1; break;
  			case '</u>': break;

  			/* 18.8.2 b */
  			case '<b':
  				if(y.val == '0') break;
  				/* falls through */
  			case '<b>':
  			case '<b/>': font.b = 1; break;
  			case '</b>': break;

  			/* 18.8.26 i */
  			case '<i':
  				if(y.val == '0') break;
  				/* falls through */
  			case '<i>':
  			case '<i/>': font.i = 1; break;
  			case '</i>': break;

  			/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
  			case '<color':
  				if(y.rgb) font.color = y.rgb.slice(2,8);
  				break;
  			case '<color>': case '<color/>': case '</color>': break;

  			/* 18.8.18 family ST_FontFamily */
  			case '<family': font.family = y.val; break;
  			case '<family>': case '<family/>': case '</family>': break;

  			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
  			case '<vertAlign': font.valign = y.val; break;
  			case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;

  			/* 18.8.35 scheme CT_FontScheme TODO */
  			case '<scheme': break;
  			case '<scheme>': case '<scheme/>': case '</scheme>': break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': break;
  			case '<ext': pass = true; break;
  			case '</ext>': pass = false; break;
  			default:
  				if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
  		}
  	}
  	return font;
  }

  var parse_rs = /*#__PURE__*/(function() {
  	var tregex = matchtag("t"), rpregex = matchtag("rPr");
  	/* 18.4.4 r CT_RElt */
  	function parse_r(r) {
  		/* 18.4.12 t ST_Xstring */
  		var t = r.match(tregex)/*, cp = 65001*/;
  		if(!t) return {t:"s", v:""};

  		var o/*:Cell*/ = ({t:'s', v:unescapexml(t[1])}/*:any*/);
  		var rpr = r.match(rpregex);
  		if(rpr) o.s = parse_rpr(rpr[1]);
  		return o;
  	}
  	var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
  	return function parse_rs(rs) {
  		return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
  	};
  })();


  /* Parse a list of <r> tags */
  var rs_to_html = /*#__PURE__*/(function parse_rs_factory() {
  	var nlregex = /(\r\n|\n)/g;
  	function parse_rpr2(font, intro, outro) {
  		var style/*:Array<string>*/ = [];

  		if(font.u) style.push("text-decoration: underline;");
  		if(font.uval) style.push("text-underline-style:" + font.uval + ";");
  		if(font.sz) style.push("font-size:" + font.sz + "pt;");
  		if(font.outline) style.push("text-effect: outline;");
  		if(font.shadow) style.push("text-shadow: auto;");
  		intro.push('<span style="' + style.join("") + '">');

  		if(font.b) { intro.push("<b>"); outro.push("</b>"); }
  		if(font.i) { intro.push("<i>"); outro.push("</i>"); }
  		if(font.strike) { intro.push("<s>"); outro.push("</s>"); }

  		var align = font.valign || "";
  		if(align == "superscript" || align == "super") align = "sup";
  		else if(align == "subscript") align = "sub";
  		if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }

  		outro.push("</span>");
  		return font;
  	}

  	/* 18.4.4 r CT_RElt */
  	function r_to_html(r) {
  		var terms/*:[Array<string>, string, Array<string>]*/ = [[],r.v,[]];
  		if(!r.v) return "";

  		if(r.s) parse_rpr2(r.s, terms[0], terms[2]);

  		return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
  	}

  	return function parse_rs(rs) {
  		return rs.map(r_to_html).join("");
  	};
  })();

  /* 18.4.8 si CT_Rst */
  var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
  var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
  function parse_si(x, opts) {
  	var html = opts ? opts.cellHTML : true;
  	var z = {};
  	if(!x) return { t: "" };
  	//var y;
  	/* 18.4.12 t ST_Xstring (Plaintext String) */
  	// TODO: is whitespace actually valid here?
  	if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
  		z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
  		z.r = utf8read(x);
  		if(html) z.h = escapehtml(z.t);
  	}
  	/* 18.4.4 r CT_RElt (Rich Text Run) */
  	else if((/*y = */x.match(sirregex))) {
  		z.r = utf8read(x);
  		z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
  		if(html) z.h = rs_to_html(parse_rs(z.r));
  	}
  	/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
  	/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
  	return z;
  }

  /* 18.4 Shared String Table */
  var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
  var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
  var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
  function parse_sst_xml(data/*:string*/, opts)/*:SST*/ {
  	var s/*:SST*/ = ([]/*:any*/), ss = "";
  	if(!data) return s;
  	/* 18.4.9 sst CT_Sst */
  	var sst = data.match(sstr0);
  	if(sst) {
  		ss = sst[2].replace(sstr1,"").split(sstr2);
  		for(var i = 0; i != ss.length; ++i) {
  			var o = parse_si(ss[i].trim(), opts);
  			if(o != null) s[s.length] = o;
  		}
  		sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
  	}
  	return s;
  }
  /* [MS-XLSB] 2.4.221 BrtBeginSst */
  function parse_BrtBeginSst(data) {
  	return [data.read_shift(4), data.read_shift(4)];
  }

  /* [MS-XLSB] 2.1.7.45 Shared Strings */
  function parse_sst_bin(data, opts)/*:SST*/ {
  	var s/*:SST*/ = ([]/*:any*/);
  	var pass = false;
  	recordhopper(data, function hopper_sst(val, R, RT) {
  		switch(RT) {
  			case 0x009F: /* BrtBeginSst */
  				s.Count = val[0]; s.Unique = val[1]; break;
  			case 0x0013: /* BrtSSTItem */
  				s.push(val); break;
  			case 0x00A0: /* BrtEndSst */
  				return true;

  			case 0x0023: /* BrtFRTBegin */
  				pass = true; break;
  			case 0x0024: /* BrtFRTEnd */
  				pass = false; break;

  			default:
  				if(R.T);
  				if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	});
  	return s;
  }
  function _JS2ANSI(str/*:string*/)/*:Array<number>*/ {
  	var o/*:Array<number>*/ = [], oo = str.split("");
  	for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.4 Version */
  function parse_CRYPTOVersion(blob, length/*:?number*/) {
  	var o/*:any*/ = {};
  	o.Major = blob.read_shift(2);
  	o.Minor = blob.read_shift(2);
  	/*:: if(length == null) return o; */
  	if(length >= 4) blob.l += length - 4;
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
  function parse_DataSpaceVersionInfo(blob) {
  	var o = {};
  	o.id = blob.read_shift(0, 'lpp4');
  	o.R = parse_CRYPTOVersion(blob, 4);
  	o.U = parse_CRYPTOVersion(blob, 4);
  	o.W = parse_CRYPTOVersion(blob, 4);
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
  function parse_DataSpaceMapEntry(blob) {
  	var len = blob.read_shift(4);
  	var end = blob.l + len - 4;
  	var o = {};
  	var cnt = blob.read_shift(4);
  	var comps/*:Array<{t:number, v:string}>*/ = [];
  	/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
  	while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
  	o.name = blob.read_shift(0, 'lpp4');
  	o.comps = comps;
  	if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
  function parse_DataSpaceMap(blob) {
  	var o = [];
  	blob.l += 4; // must be 0x8
  	var cnt = blob.read_shift(4);
  	while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
  function parse_DataSpaceDefinition(blob)/*:Array<string>*/ {
  	var o/*:Array<string>*/ = [];
  	blob.l += 4; // must be 0x8
  	var cnt = blob.read_shift(4);
  	while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
  function parse_TransformInfoHeader(blob) {
  	var o = {};
  	/*var len = */blob.read_shift(4);
  	blob.l += 4; // must be 0x1
  	o.id = blob.read_shift(0, 'lpp4');
  	o.name = blob.read_shift(0, 'lpp4');
  	o.R = parse_CRYPTOVersion(blob, 4);
  	o.U = parse_CRYPTOVersion(blob, 4);
  	o.W = parse_CRYPTOVersion(blob, 4);
  	return o;
  }

  function parse_Primary(blob) {
  	/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
  	var hdr = parse_TransformInfoHeader(blob);
  	/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
  	hdr.ename = blob.read_shift(0, '8lpp4');
  	hdr.blksz = blob.read_shift(4);
  	hdr.cmode = blob.read_shift(4);
  	if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
  	return hdr;
  }

  /* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
  function parse_EncryptionHeader(blob, length/*:number*/) {
  	var tgt = blob.l + length;
  	var o = {};
  	o.Flags = (blob.read_shift(4) & 0x3F);
  	blob.l += 4;
  	o.AlgID = blob.read_shift(4);
  	var valid = false;
  	switch(o.AlgID) {
  		case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
  		case 0x6801: valid = (o.Flags == 0x04); break;
  		case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
  		default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
  	}
  	if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
  	o.AlgIDHash = blob.read_shift(4);
  	o.KeySize = blob.read_shift(4);
  	o.ProviderType = blob.read_shift(4);
  	blob.l += 8;
  	o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
  	blob.l = tgt;
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
  function parse_EncryptionVerifier(blob, length/*:number*/) {
  	var o = {}, tgt = blob.l + length;
  	blob.l += 4; // SaltSize must be 0x10
  	o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
  	o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
  	/*var sz = */blob.read_shift(4);
  	o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
  function parse_EncryptionInfo(blob) {
  	var vers = parse_CRYPTOVersion(blob);
  	switch(vers.Minor) {
  		case 0x02: return [vers.Minor, parse_EncInfoStd(blob)];
  		case 0x03: return [vers.Minor, parse_EncInfoExt()];
  		case 0x04: return [vers.Minor, parse_EncInfoAgl(blob)];
  	}
  	throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
  }

  /* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
  function parse_EncInfoStd(blob/*::, vers*/) {
  	var flags = blob.read_shift(4);
  	if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
  	var sz = blob.read_shift(4);
  	//var tgt = blob.l + sz;
  	var hdr = parse_EncryptionHeader(blob, sz);
  	var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
  	return { t:"Std", h:hdr, v:verifier };
  }
  /* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
  function parse_EncInfoExt(/*::blob, vers*/) { throw new Error("File is password-protected: ECMA-376 Extensible"); }
  /* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
  function parse_EncInfoAgl(blob/*::, vers*/) {
  	var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
  	blob.l+=4;
  	var xml = blob.read_shift(blob.length - blob.l, 'utf8');
  	var o = {};
  	xml.replace(tagregex, function xml_agile(x) {
  		var y/*:any*/ = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<?xml': break;
  			case '<encryption': case '</encryption>': break;
  			case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
  			case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
  			case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
  			case '</keyEncryptors>': break;

  			case '<keyEncryptor': o.uri = y.uri; break;
  			case '</keyEncryptor>': break;
  			case '<encryptedKey': o.encs.push(y); break;
  			default: throw y[0];
  		}
  	});
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
  function parse_RC4CryptoHeader(blob, length/*:number*/) {
  	var o = {};
  	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
  	if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
  	if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
  	o.Flags = blob.read_shift(4); length -= 4;
  	var sz = blob.read_shift(4); length -= 4;
  	o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
  	o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
  	return o;
  }
  /* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
  function parse_RC4Header(blob/*::, length*/) {
  	var o = {};
  	var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
  	if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
  	o.Salt = blob.read_shift(16);
  	o.EncryptedVerifier = blob.read_shift(16);
  	o.EncryptedVerifierHash = blob.read_shift(16);
  	return o;
  }

  /* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
  function crypto_CreatePasswordVerifier_Method1(Password/*:string*/) {
  	var Verifier = 0x0000, PasswordArray;
  	var PasswordDecoded = _JS2ANSI(Password);
  	var len = PasswordDecoded.length + 1, i, PasswordByte;
  	var Intermediate1, Intermediate2, Intermediate3;
  	PasswordArray = new_raw_buf(len);
  	PasswordArray[0] = PasswordDecoded.length;
  	for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
  	for(i = len-1; i >= 0; --i) {
  		PasswordByte = PasswordArray[i];
  		Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
  		Intermediate2 = (Verifier << 1) & 0x7FFF;
  		Intermediate3 = Intermediate1 | Intermediate2;
  		Verifier = Intermediate3 ^ PasswordByte;
  	}
  	return Verifier ^ 0xCE4B;
  }

  /* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
  var crypto_CreateXorArray_Method1 = /*#__PURE__*/(function() {
  	var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
  	var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
  	var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
  	var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
  	var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
  	var CreateXorKey_Method1 = function(Password) {
  		var XorKey = InitialCode[Password.length - 1];
  		var CurrentElement = 0x68;
  		for(var i = Password.length-1; i >= 0; --i) {
  			var Char = Password[i];
  			for(var j = 0; j != 7; ++j) {
  				if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
  				Char *= 2; --CurrentElement;
  			}
  		}
  		return XorKey;
  	};
  	return function(password/*:string*/) {
  		var Password = _JS2ANSI(password);
  		var XorKey = CreateXorKey_Method1(Password);
  		var Index = Password.length;
  		var ObfuscationArray = new_raw_buf(16);
  		for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
  		var Temp, PasswordLastChar, PadIndex;
  		if((Index & 1) === 1) {
  			Temp = XorKey >> 8;
  			ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
  			--Index;
  			Temp = XorKey & 0xFF;
  			PasswordLastChar = Password[Password.length - 1];
  			ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
  		}
  		while(Index > 0) {
  			--Index;
  			Temp = XorKey >> 8;
  			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
  			--Index;
  			Temp = XorKey & 0xFF;
  			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
  		}
  		Index = 15;
  		PadIndex = 15 - Password.length;
  		while(PadIndex > 0) {
  			Temp = XorKey >> 8;
  			ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
  			--Index;
  			--PadIndex;
  			Temp = XorKey & 0xFF;
  			ObfuscationArray[Index] = XorRor(Password[Index], Temp);
  			--Index;
  			--PadIndex;
  		}
  		return ObfuscationArray;
  	};
  })();

  /* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
  var crypto_DecryptData_Method1 = function(password/*:string*/, Data, XorArrayIndex, XorArray, O) {
  	/* If XorArray is set, use it; if O is not set, make changes in-place */
  	if(!O) O = Data;
  	if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
  	var Index, Value;
  	for(Index = 0; Index != Data.length; ++Index) {
  		Value = Data[Index];
  		Value ^= XorArray[XorArrayIndex];
  		Value = ((Value>>5) | (Value<<3)) & 0xFF;
  		O[Index] = Value;
  		++XorArrayIndex;
  	}
  	return [O, XorArrayIndex, XorArray];
  };

  var crypto_MakeXorDecryptor = function(password/*:string*/) {
  	var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
  	return function(Data) {
  		var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
  		XorArrayIndex = O[1];
  		return O[0];
  	};
  };

  /* 2.5.343 */
  function parse_XORObfuscation(blob, length, opts, out) {
  	var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) }/*:any*/);
  	if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
  	out.valid = o.verificationBytes === o.verifier;
  	if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
  	return o;
  }

  /* 2.4.117 */
  function parse_FilePassHeader(blob, length/*:number*/, oo) {
  	var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
  	if(o.Info === 1) o.Data = parse_RC4Header(blob);
  	else o.Data = parse_RC4CryptoHeader(blob, length);
  	return o;
  }
  function parse_FilePass(blob, length/*:number*/, opts) {
  	var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }/*:any*/); /* wEncryptionType */
  	if(o.Type) parse_FilePassHeader(blob, length-2, o);
  	else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
  	return o;
  }


  var RTF = /*#__PURE__*/(function() {
  	function rtf_to_sheet(d/*:RawData*/, opts)/*:Worksheet*/ {
  		switch(opts.type) {
  			case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
  			case 'binary': return rtf_to_sheet_str(d, opts);
  			case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
  			case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
  		}
  		throw new Error("Unrecognized type " + opts.type);
  	}

  	/* TODO: this is a stub */
  	function rtf_to_sheet_str(str/*:string*/, opts)/*:Worksheet*/ {
  		var o = opts || {};
  		var ws/*:Worksheet*/ = o.dense ? ([]/*:any*/) : ({}/*:any*/);

  		var rows = str.match(/\\trowd.*?\\row\b/g);
  		if(!rows.length) throw new Error("RTF missing table");
  		var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}}/*:any*/);
  		rows.forEach(function(rowtf, R) {
  			if(Array.isArray(ws)) ws[R] = [];
  			var rtfre = /\\\w+\b/g;
  			var last_index = 0;
  			var res;
  			var C = -1;
  			while((res = rtfre.exec(rowtf))) {
  				switch(res[0]) {
  					case "\\cell":
  						var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
  						if(data[0] == " ") data = data.slice(1);
  						++C;
  						if(data.length) {
  							// TODO: value parsing, including codepage adjustments
  							var cell = {v: data, t:"s"};
  							if(Array.isArray(ws)) ws[R][C] = cell;
  							else ws[encode_cell({r:R, c:C})] = cell;
  						}
  						break;
  				}
  				last_index = rtfre.lastIndex;
  			}
  			if(C > range.e.c) range.e.c = C;
  		});
  		ws['!ref'] = encode_range(range);
  		return ws;
  	}

  	function rtf_to_workbook(d/*:RawData*/, opts)/*:Workbook*/ { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }

  	/* TODO: this is a stub */
  	function sheet_to_rtf(ws/*:Worksheet*//*::, opts*/)/*:string*/ {
  		var o = ["{\\rtf1\\ansi"];
  		var r = safe_decode_range(ws['!ref']), cell/*:Cell*/;
  		var dense = Array.isArray(ws);
  		for(var R = r.s.r; R <= r.e.r; ++R) {
  			o.push("\\trowd\\trautofit1");
  			for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
  			o.push("\\pard\\intbl");
  			for(C = r.s.c; C <= r.e.c; ++C) {
  				var coord = encode_cell({r:R,c:C});
  				cell = dense ? (ws[R]||[])[C]: ws[coord];
  				if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
  				o.push(" " + (cell.w || (format_cell(cell), cell.w)));
  				o.push("\\cell");
  			}
  			o.push("\\pard\\intbl\\row");
  		}
  		return o.join("") + "}";
  	}

  	return {
  		to_workbook: rtf_to_workbook,
  		to_sheet: rtf_to_sheet,
  		from_sheet: sheet_to_rtf
  	};
  })();
  function hex2RGB(h) {
  	var o = h.slice(h[0]==="#"?1:0).slice(0,6);
  	return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
  }
  function rgb2Hex(rgb) {
  	for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
  	return o.toString(16).toUpperCase().slice(1);
  }

  function rgb2HSL(rgb) {
  	var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
  	var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
  	if(C === 0) return [0, 0, R];

  	var H6 = 0, S = 0, L2 = (M + m);
  	S = C / (L2 > 1 ? 2 - L2 : L2);
  	switch(M){
  		case R: H6 = ((G - B) / C + 6)%6; break;
  		case G: H6 = ((B - R) / C + 2); break;
  		case B: H6 = ((R - G) / C + 4); break;
  	}
  	return [H6 / 6, S, L2 / 2];
  }

  function hsl2RGB(hsl){
  	var H = hsl[0], S = hsl[1], L = hsl[2];
  	var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
  	var rgb = [m,m,m], h6 = 6*H;

  	var X;
  	if(S !== 0) switch(h6|0) {
  		case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
  		case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
  		case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
  		case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
  		case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
  		case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
  	}
  	for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
  	return rgb;
  }

  /* 18.8.3 bgColor tint algorithm */
  function rgb_tint(hex, tint) {
  	if(tint === 0) return hex;
  	var hsl = rgb2HSL(hex2RGB(hex));
  	if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
  	else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
  	return rgb2Hex(hsl2RGB(hsl));
  }

  /* 18.3.1.13 width calculations */
  /* [MS-OI29500] 2.1.595 Column Width & Formatting */
  var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
  function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
  function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
  function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
  //function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
  //function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
  function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
  /* XLSX/XLSB/XLS specify width in units of MDW */
  function find_mdw_colw(collw) {
  	var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
  	if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
  	MDW = _MDW;
  }
  /* XLML specifies width in terms of pixels */
  /*function find_mdw_wpx(wpx) {
  	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
  	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
  		guess = char2width_(px2char_(wpx))*256;
  		guess = (guess) % 1;
  		if(guess > 0.5) guess--;
  		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
  	}
  	MDW = _MDW;
  }*/

  function process_col(coll/*:ColInfo*/) {
  	if(coll.width) {
  		coll.wpx = width2px(coll.width);
  		coll.wch = px2char(coll.wpx);
  		coll.MDW = MDW;
  	} else if(coll.wpx) {
  		coll.wch = px2char(coll.wpx);
  		coll.width = char2width(coll.wch);
  		coll.MDW = MDW;
  	} else if(typeof coll.wch == 'number') {
  		coll.width = char2width(coll.wch);
  		coll.wpx = width2px(coll.width);
  		coll.MDW = MDW;
  	}
  	if(coll.customWidth) delete coll.customWidth;
  }

  var DEF_PPI = 96, PPI = DEF_PPI;
  function px2pt(px) { return px * 96 / PPI; }
  function pt2px(pt) { return pt * PPI / 96; }

  /* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
  var XLMLPatternTypeMap = {
  	"None": "none",
  	"Solid": "solid",
  	"Gray50": "mediumGray",
  	"Gray75": "darkGray",
  	"Gray25": "lightGray",
  	"HorzStripe": "darkHorizontal",
  	"VertStripe": "darkVertical",
  	"ReverseDiagStripe": "darkDown",
  	"DiagStripe": "darkUp",
  	"DiagCross": "darkGrid",
  	"ThickDiagCross": "darkTrellis",
  	"ThinHorzStripe": "lightHorizontal",
  	"ThinVertStripe": "lightVertical",
  	"ThinReverseDiagStripe": "lightDown",
  	"ThinHorzCross": "lightGrid"
  };

  /* 18.8.5 borders CT_Borders */
  function parse_borders(t, styles, themes, opts) {
  	styles.Borders = [];
  	var border = {};
  	var pass = false;
  	(t[0].match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<borders': case '<borders>': case '</borders>': break;

  			/* 18.8.4 border CT_Border */
  			case '<border': case '<border>': case '<border/>':
  				border = /*::(*/{}/*:: :any)*/;
  				if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
  				if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
  				styles.Borders.push(border);
  				break;
  			case '</border>': break;

  			/* note: not in spec, appears to be CT_BorderPr */
  			case '<left/>': break;
  			case '<left': case '<left>': break;
  			case '</left>': break;

  			/* note: not in spec, appears to be CT_BorderPr */
  			case '<right/>': break;
  			case '<right': case '<right>': break;
  			case '</right>': break;

  			/* 18.8.43 top CT_BorderPr */
  			case '<top/>': break;
  			case '<top': case '<top>': break;
  			case '</top>': break;

  			/* 18.8.6 bottom CT_BorderPr */
  			case '<bottom/>': break;
  			case '<bottom': case '<bottom>': break;
  			case '</bottom>': break;

  			/* 18.8.13 diagonal CT_BorderPr */
  			case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
  			case '</diagonal>': break;

  			/* 18.8.25 horizontal CT_BorderPr */
  			case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
  			case '</horizontal>': break;

  			/* 18.8.44 vertical CT_BorderPr */
  			case '<vertical': case '<vertical>': case '<vertical/>': break;
  			case '</vertical>': break;

  			/* 18.8.37 start CT_BorderPr */
  			case '<start': case '<start>': case '<start/>': break;
  			case '</start>': break;

  			/* 18.8.16 end CT_BorderPr */
  			case '<end': case '<end>': case '<end/>': break;
  			case '</end>': break;

  			/* 18.8.? color CT_Color */
  			case '<color': case '<color>':
  				break;
  			case '<color/>': case '</color>': break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': break;
  			case '<ext': pass = true; break;
  			case '</ext>': pass = false; break;
  			default: if(opts && opts.WTF) {
  				if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
  			}
  		}
  	});
  }

  /* 18.8.21 fills CT_Fills */
  function parse_fills(t, styles, themes, opts) {
  	styles.Fills = [];
  	var fill = {};
  	var pass = false;
  	(t[0].match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<fills': case '<fills>': case '</fills>': break;

  			/* 18.8.20 fill CT_Fill */
  			case '<fill>': case '<fill': case '<fill/>':
  				fill = {}; styles.Fills.push(fill); break;
  			case '</fill>': break;

  			/* 18.8.24 gradientFill CT_GradientFill */
  			case '<gradientFill>': break;
  			case '<gradientFill':
  			case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;

  			/* 18.8.32 patternFill CT_PatternFill */
  			case '<patternFill': case '<patternFill>':
  				if(y.patternType) fill.patternType = y.patternType;
  				break;
  			case '<patternFill/>': case '</patternFill>': break;

  			/* 18.8.3 bgColor CT_Color */
  			case '<bgColor':
  				if(!fill.bgColor) fill.bgColor = {};
  				if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
  				if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
  				if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
  				/* Excel uses ARGB strings */
  				if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
  				break;
  			case '<bgColor/>': case '</bgColor>': break;

  			/* 18.8.19 fgColor CT_Color */
  			case '<fgColor':
  				if(!fill.fgColor) fill.fgColor = {};
  				if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
  				if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
  				/* Excel uses ARGB strings */
  				if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
  				break;
  			case '<fgColor/>': case '</fgColor>': break;

  			/* 18.8.38 stop CT_GradientStop */
  			case '<stop': case '<stop/>': break;
  			case '</stop>': break;

  			/* 18.8.? color CT_Color */
  			case '<color': case '<color/>': break;
  			case '</color>': break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': break;
  			case '<ext': pass = true; break;
  			case '</ext>': pass = false; break;
  			default: if(opts && opts.WTF) {
  				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
  			}
  		}
  	});
  }

  /* 18.8.23 fonts CT_Fonts */
  function parse_fonts(t, styles, themes, opts) {
  	styles.Fonts = [];
  	var font = {};
  	var pass = false;
  	(t[0].match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<fonts': case '<fonts>': case '</fonts>': break;

  			/* 18.8.22 font CT_Font */
  			case '<font': case '<font>': break;
  			case '</font>': case '<font/>':
  				styles.Fonts.push(font);
  				font = {};
  				break;

  			/* 18.8.29 name CT_FontName */
  			case '<name': if(y.val) font.name = utf8read(y.val); break;
  			case '<name/>': case '</name>': break;

  			/* 18.8.2  b CT_BooleanProperty */
  			case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<b/>': font.bold = 1; break;

  			/* 18.8.26 i CT_BooleanProperty */
  			case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<i/>': font.italic = 1; break;

  			/* 18.4.13 u CT_UnderlineProperty */
  			case '<u':
  				switch(y.val) {
  					case "none": font.underline = 0x00; break;
  					case "single": font.underline = 0x01; break;
  					case "double": font.underline = 0x02; break;
  					case "singleAccounting": font.underline = 0x21; break;
  					case "doubleAccounting": font.underline = 0x22; break;
  				} break;
  			case '<u/>': font.underline = 1; break;

  			/* 18.4.10 strike CT_BooleanProperty */
  			case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<strike/>': font.strike = 1; break;

  			/* 18.4.2  outline CT_BooleanProperty */
  			case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<outline/>': font.outline = 1; break;

  			/* 18.8.36 shadow CT_BooleanProperty */
  			case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<shadow/>': font.shadow = 1; break;

  			/* 18.8.12 condense CT_BooleanProperty */
  			case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<condense/>': font.condense = 1; break;

  			/* 18.8.17 extend CT_BooleanProperty */
  			case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
  			case '<extend/>': font.extend = 1; break;

  			/* 18.4.11 sz CT_FontSize */
  			case '<sz': if(y.val) font.sz = +y.val; break;
  			case '<sz/>': case '</sz>': break;

  			/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
  			case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
  			case '<vertAlign/>': case '</vertAlign>': break;

  			/* 18.8.18 family CT_FontFamily */
  			case '<family': if(y.val) font.family = parseInt(y.val,10); break;
  			case '<family/>': case '</family>': break;

  			/* 18.8.35 scheme CT_FontScheme */
  			case '<scheme': if(y.val) font.scheme = y.val; break;
  			case '<scheme/>': case '</scheme>': break;

  			/* 18.4.1 charset CT_IntProperty */
  			case '<charset':
  				if(y.val == '1') break;
  				y.codepage = CS2CP[parseInt(y.val, 10)];
  				break;

  			/* 18.?.? color CT_Color */
  			case '<color':
  				if(!font.color) font.color = {};
  				if(y.auto) font.color.auto = parsexmlbool(y.auto);

  				if(y.rgb) font.color.rgb = y.rgb.slice(-6);
  				else if(y.indexed) {
  					font.color.index = parseInt(y.indexed, 10);
  					var icv = XLSIcv[font.color.index];
  					if(font.color.index == 81) icv = XLSIcv[1];
  					if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
  					font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
  				} else if(y.theme) {
  					font.color.theme = parseInt(y.theme, 10);
  					if(y.tint) font.color.tint = parseFloat(y.tint);
  					if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
  						font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
  					}
  				}

  				break;
  			case '<color/>': case '</color>': break;

  			/* note: sometimes mc:AlternateContent appears bare */
  			case '<AlternateContent': pass = true; break;
  			case '</AlternateContent>': pass = false; break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': break;
  			case '<ext': pass = true; break;
  			case '</ext>': pass = false; break;
  			default: if(opts && opts.WTF) {
  				if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
  			}
  		}
  	});
  }

  /* 18.8.31 numFmts CT_NumFmts */
  function parse_numFmts(t, styles, opts) {
  	styles.NumberFmt = [];
  	var k/*Array<number>*/ = (keys$1(table_fmt)/*:any*/);
  	for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
  	var m = t[0].match(tagregex);
  	if(!m) return;
  	for(i=0; i < m.length; ++i) {
  		var y = parsexmltag(m[i]);
  		switch(strip_ns(y[0])) {
  			case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
  			case '<numFmt': {
  				var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
  				styles.NumberFmt[j] = f;
  				if(j>0) {
  					if(j > 0x188) {
  						for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
  						styles.NumberFmt[j] = f;
  					}
  					SSF_load(f,j);
  				}
  			} break;
  			case '</numFmt>': break;
  			default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
  		}
  	}
  }

  /* 18.8.10 cellXfs CT_CellXfs */
  var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
  var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
  function parse_cellXfs(t, styles, opts) {
  	styles.CellXf = [];
  	var xf;
  	var pass = false;
  	(t[0].match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x), i = 0;
  		switch(strip_ns(y[0])) {
  			case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;

  			/* 18.8.45 xf CT_Xf */
  			case '<xf': case '<xf/>':
  				xf = y;
  				delete xf[0];
  				for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
  					xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
  				for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
  					xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
  				if(styles.NumberFmt && xf.numFmtId > 0x188) {
  					for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
  				}
  				styles.CellXf.push(xf); break;
  			case '</xf>': break;

  			/* 18.8.1 alignment CT_CellAlignment */
  			case '<alignment': case '<alignment/>':
  				var alignment = {};
  				if(y.vertical) alignment.vertical = y.vertical;
  				if(y.horizontal) alignment.horizontal = y.horizontal;
  				if(y.textRotation != null) alignment.textRotation = y.textRotation;
  				if(y.indent) alignment.indent = y.indent;
  				if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
  				xf.alignment = alignment;
  				break;
  			case '</alignment>': break;

  			/* 18.8.33 protection CT_CellProtection */
  			case '<protection':
  				break;
  			case '</protection>': case '<protection/>': break;

  			/* note: sometimes mc:AlternateContent appears bare */
  			case '<AlternateContent': pass = true; break;
  			case '</AlternateContent>': pass = false; break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': break;
  			case '<ext': pass = true; break;
  			case '</ext>': pass = false; break;
  			default: if(opts && opts.WTF) {
  				if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
  			}
  		}
  	});
  }

  /* 18.8 Styles CT_Stylesheet*/
  var parse_sty_xml= /*#__PURE__*/(function make_pstyx() {
  var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
  var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
  var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
  var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
  var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;

  return function parse_sty_xml(data, themes, opts) {
  	var styles = {};
  	if(!data) return styles;
  	data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
  	/* 18.8.39 styleSheet CT_Stylesheet */
  	var t;

  	/* 18.8.31 numFmts CT_NumFmts ? */
  	if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);

  	/* 18.8.23 fonts CT_Fonts ? */
  	if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);

  	/* 18.8.21 fills CT_Fills ? */
  	if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);

  	/* 18.8.5  borders CT_Borders ? */
  	if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);

  	/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
  	/* 18.8.8  cellStyles CT_CellStyles ? */

  	/* 18.8.10 cellXfs CT_CellXfs ? */
  	if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);

  	/* 18.8.15 dxfs CT_Dxfs ? */
  	/* 18.8.42 tableStyles CT_TableStyles ? */
  	/* 18.8.11 colors CT_Colors ? */
  	/* 18.2.10 extLst CT_ExtensionList ? */

  	return styles;
  };
  })();
  /* [MS-XLSB] 2.4.657 BrtFmt */
  function parse_BrtFmt(data, length/*:number*/) {
  	var numFmtId = data.read_shift(2);
  	var stFmtCode = parse_XLWideString(data);
  	return [numFmtId, stFmtCode];
  }

  /* [MS-XLSB] 2.4.659 BrtFont TODO */
  function parse_BrtFont(data, length/*:number*/, opts) {
  	var out = ({}/*:any*/);

  	out.sz = data.read_shift(2) / 20;

  	var grbit = parse_FontFlags(data);
  	if(grbit.fItalic) out.italic = 1;
  	if(grbit.fCondense) out.condense = 1;
  	if(grbit.fExtend) out.extend = 1;
  	if(grbit.fShadow) out.shadow = 1;
  	if(grbit.fOutline) out.outline = 1;
  	if(grbit.fStrikeout) out.strike = 1;

  	var bls = data.read_shift(2);
  	if(bls === 0x02BC) out.bold = 1;

  	switch(data.read_shift(2)) {
  		/* case 0: out.vertAlign = "baseline"; break; */
  		case 1: out.vertAlign = "superscript"; break;
  		case 2: out.vertAlign = "subscript"; break;
  	}

  	var underline = data.read_shift(1);
  	if(underline != 0) out.underline = underline;

  	var family = data.read_shift(1);
  	if(family > 0) out.family = family;

  	var bCharSet = data.read_shift(1);
  	if(bCharSet > 0) out.charset = bCharSet;

  	data.l++;
  	out.color = parse_BrtColor(data);

  	switch(data.read_shift(1)) {
  		/* case 0: out.scheme = "none": break; */
  		case 1: out.scheme = "major"; break;
  		case 2: out.scheme = "minor"; break;
  	}

  	out.name = parse_XLWideString(data);

  	return out;
  }
  /* TODO: gradient fill representation */
  var parse_BrtFill = parsenoop;

  /* [MS-XLSB] 2.4.824 BrtXF */
  function parse_BrtXF(data, length/*:number*/) {
  	var tgt = data.l + length;
  	var ixfeParent = data.read_shift(2);
  	var ifmt = data.read_shift(2);
  	data.l = tgt;
  	return {ixfe:ixfeParent, numFmtId:ifmt };
  }
  /* [MS-XLSB] 2.4.302 BrtBorder TODO */
  var parse_BrtBorder = parsenoop;

  /* [MS-XLSB] 2.1.7.50 Styles */
  function parse_sty_bin(data, themes, opts) {
  	var styles = {};
  	styles.NumberFmt = ([]/*:any*/);
  	for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];

  	styles.CellXf = [];
  	styles.Fonts = [];
  	var state/*:Array<string>*/ = [];
  	var pass = false;
  	recordhopper(data, function hopper_sty(val, R, RT) {
  		switch(RT) {
  			case 0x002C: /* BrtFmt */
  				styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
  				break;
  			case 0x002B: /* BrtFont */
  				styles.Fonts.push(val);
  				if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
  					val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
  				}
  				break;
  			case 0x0401: /* BrtKnownFonts */ break;
  			case 0x002D: /* BrtFill */
  				break;
  			case 0x002E: /* BrtBorder */
  				break;
  			case 0x002F: /* BrtXF */
  				if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
  					styles.CellXf.push(val);
  				}
  				break;
  			case 0x0030: /* BrtStyle */
  			case 0x01FB: /* BrtDXF */
  			case 0x023C: /* BrtMRUColor */
  			case 0x01DB: /* BrtIndexedColor */
  				break;

  			case 0x0493: /* BrtDXF14 */
  			case 0x0836: /* BrtDXF15 */
  			case 0x046A: /* BrtSlicerStyleElement */
  			case 0x0200: /* BrtTableStyleElement */
  			case 0x082F: /* BrtTimelineStyleElement */
  			case 0x0C00: /* BrtUid */
  				break;

  			case 0x0023: /* BrtFRTBegin */
  				pass = true; break;
  			case 0x0024: /* BrtFRTEnd */
  				pass = false; break;
  			case 0x0025: /* BrtACBegin */
  				state.push(RT); pass = true; break;
  			case 0x0026: /* BrtACEnd */
  				state.pop(); pass = false; break;

  			default:
  				if(R.T > 0) state.push(RT);
  				else if(R.T < 0) state.pop();
  				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	});
  	return styles;
  }
  /* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
  var XLSXThemeClrScheme = [
  	'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
  	'</a:accent1>', '</a:accent2>', '</a:accent3>',
  	'</a:accent4>', '</a:accent5>', '</a:accent6>',
  	'</a:hlink>', '</a:folHlink>'
  ];
  /* 20.1.6.2 clrScheme CT_ColorScheme */
  function parse_clrScheme(t, themes, opts) {
  	themes.themeElements.clrScheme = [];
  	var color = {};
  	(t[0].match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(y[0]) {
  			/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
  			case '<a:clrScheme': case '</a:clrScheme>': break;

  			/* 20.1.2.3.32 srgbClr CT_SRgbColor */
  			case '<a:srgbClr':
  				color.rgb = y.val; break;

  			/* 20.1.2.3.33 sysClr CT_SystemColor */
  			case '<a:sysClr':
  				color.rgb = y.lastClr; break;

  			/* 20.1.4.1.1 accent1 (Accent 1) */
  			/* 20.1.4.1.2 accent2 (Accent 2) */
  			/* 20.1.4.1.3 accent3 (Accent 3) */
  			/* 20.1.4.1.4 accent4 (Accent 4) */
  			/* 20.1.4.1.5 accent5 (Accent 5) */
  			/* 20.1.4.1.6 accent6 (Accent 6) */
  			/* 20.1.4.1.9 dk1 (Dark 1) */
  			/* 20.1.4.1.10 dk2 (Dark 2) */
  			/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
  			/* 20.1.4.1.19 hlink (Hyperlink) */
  			/* 20.1.4.1.22 lt1 (Light 1) */
  			/* 20.1.4.1.23 lt2 (Light 2) */
  			case '<a:dk1>': case '</a:dk1>':
  			case '<a:lt1>': case '</a:lt1>':
  			case '<a:dk2>': case '</a:dk2>':
  			case '<a:lt2>': case '</a:lt2>':
  			case '<a:accent1>': case '</a:accent1>':
  			case '<a:accent2>': case '</a:accent2>':
  			case '<a:accent3>': case '</a:accent3>':
  			case '<a:accent4>': case '</a:accent4>':
  			case '<a:accent5>': case '</a:accent5>':
  			case '<a:accent6>': case '</a:accent6>':
  			case '<a:hlink>': case '</a:hlink>':
  			case '<a:folHlink>': case '</a:folHlink>':
  				if (y[0].charAt(1) === '/') {
  					themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
  					color = {};
  				} else {
  					color.name = y[0].slice(3, y[0].length - 1);
  				}
  				break;

  			default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
  		}
  	});
  }

  /* 20.1.4.1.18 fontScheme CT_FontScheme */
  function parse_fontScheme(/*::t, themes, opts*/) { }

  /* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
  function parse_fmtScheme(/*::t, themes, opts*/) { }

  var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
  var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
  var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;

  /* 20.1.6.10 themeElements CT_BaseStyles */
  function parse_themeElements(data, themes, opts) {
  	themes.themeElements = {};

  	var t;

  	[
  		/* clrScheme CT_ColorScheme */
  		['clrScheme', clrsregex, parse_clrScheme],
  		/* fontScheme CT_FontScheme */
  		['fontScheme', fntsregex, parse_fontScheme],
  		/* fmtScheme CT_StyleMatrix */
  		['fmtScheme', fmtsregex, parse_fmtScheme]
  	].forEach(function(m) {
  		if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
  		m[2](t, themes, opts);
  	});
  }

  var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;

  /* 14.2.7 Theme Part */
  function parse_theme_xml(data/*:string*/, opts) {
  	/* 20.1.6.9 theme CT_OfficeStyleSheet */
  	if(!data || data.length === 0) data = write_theme();

  	var t;
  	var themes = {};

  	/* themeElements CT_BaseStyles */
  	if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
  	parse_themeElements(t[0], themes, opts);
  	themes.raw = data;
  	return themes;
  }

  function write_theme(Themes, opts)/*:string*/ {
  	if(opts && opts.themeXLSX) return opts.themeXLSX;
  	if(Themes && typeof Themes.raw == "string") return Themes.raw;
  	var o = [XML_HEADER];
  	o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
  	o[o.length] =  '<a:themeElements>';

  	o[o.length] =   '<a:clrScheme name="Office">';
  	o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
  	o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
  	o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
  	o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
  	o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
  	o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
  	o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
  	o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
  	o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
  	o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
  	o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
  	o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
  	o[o.length] =   '</a:clrScheme>';

  	o[o.length] =   '<a:fontScheme name="Office">';
  	o[o.length] =    '<a:majorFont>';
  	o[o.length] =     '<a:latin typeface="Cambria"/>';
  	o[o.length] =     '<a:ea typeface=""/>';
  	o[o.length] =     '<a:cs typeface=""/>';
  	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
  	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
  	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
  	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
  	o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
  	o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
  	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
  	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
  	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
  	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
  	o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
  	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
  	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
  	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
  	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
  	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
  	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
  	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
  	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
  	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
  	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
  	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
  	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
  	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
  	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
  	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
  	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
  	o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
  	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
  	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
  	o[o.length] =    '</a:majorFont>';
  	o[o.length] =    '<a:minorFont>';
  	o[o.length] =     '<a:latin typeface="Calibri"/>';
  	o[o.length] =     '<a:ea typeface=""/>';
  	o[o.length] =     '<a:cs typeface=""/>';
  	o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
  	o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
  	o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
  	o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
  	o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
  	o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
  	o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
  	o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
  	o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
  	o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
  	o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
  	o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
  	o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
  	o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
  	o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
  	o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
  	o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
  	o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
  	o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
  	o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
  	o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
  	o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
  	o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
  	o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
  	o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
  	o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
  	o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
  	o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
  	o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
  	o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
  	o[o.length] =    '</a:minorFont>';
  	o[o.length] =   '</a:fontScheme>';

  	o[o.length] =   '<a:fmtScheme name="Office">';
  	o[o.length] =    '<a:fillStyleLst>';
  	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
  	o[o.length] =     '<a:gradFill rotWithShape="1">';
  	o[o.length] =      '<a:gsLst>';
  	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
  	o[o.length] =      '</a:gsLst>';
  	o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
  	o[o.length] =     '</a:gradFill>';
  	o[o.length] =     '<a:gradFill rotWithShape="1">';
  	o[o.length] =      '<a:gsLst>';
  	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
  	o[o.length] =      '</a:gsLst>';
  	o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
  	o[o.length] =     '</a:gradFill>';
  	o[o.length] =    '</a:fillStyleLst>';
  	o[o.length] =    '<a:lnStyleLst>';
  	o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
  	o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
  	o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
  	o[o.length] =    '</a:lnStyleLst>';
  	o[o.length] =    '<a:effectStyleLst>';
  	o[o.length] =     '<a:effectStyle>';
  	o[o.length] =      '<a:effectLst>';
  	o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
  	o[o.length] =      '</a:effectLst>';
  	o[o.length] =     '</a:effectStyle>';
  	o[o.length] =     '<a:effectStyle>';
  	o[o.length] =      '<a:effectLst>';
  	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
  	o[o.length] =      '</a:effectLst>';
  	o[o.length] =     '</a:effectStyle>';
  	o[o.length] =     '<a:effectStyle>';
  	o[o.length] =      '<a:effectLst>';
  	o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
  	o[o.length] =      '</a:effectLst>';
  	o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
  	o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
  	o[o.length] =     '</a:effectStyle>';
  	o[o.length] =    '</a:effectStyleLst>';
  	o[o.length] =    '<a:bgFillStyleLst>';
  	o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
  	o[o.length] =     '<a:gradFill rotWithShape="1">';
  	o[o.length] =      '<a:gsLst>';
  	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
  	o[o.length] =      '</a:gsLst>';
  	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
  	o[o.length] =     '</a:gradFill>';
  	o[o.length] =     '<a:gradFill rotWithShape="1">';
  	o[o.length] =      '<a:gsLst>';
  	o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
  	o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
  	o[o.length] =      '</a:gsLst>';
  	o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
  	o[o.length] =     '</a:gradFill>';
  	o[o.length] =    '</a:bgFillStyleLst>';
  	o[o.length] =   '</a:fmtScheme>';
  	o[o.length] =  '</a:themeElements>';

  	o[o.length] =  '<a:objectDefaults>';
  	o[o.length] =   '<a:spDef>';
  	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
  	o[o.length] =   '</a:spDef>';
  	o[o.length] =   '<a:lnDef>';
  	o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
  	o[o.length] =   '</a:lnDef>';
  	o[o.length] =  '</a:objectDefaults>';
  	o[o.length] =  '<a:extraClrSchemeLst/>';
  	o[o.length] = '</a:theme>';
  	return o.join("");
  }
  /* [MS-XLS] 2.4.326 TODO: payload is a zip file */
  function parse_Theme(blob, length, opts) {
  	var end = blob.l + length;
  	var dwThemeVersion = blob.read_shift(4);
  	if(dwThemeVersion === 124226) return;
  	if(!opts.cellStyles) { blob.l = end; return; }
  	var data = blob.slice(blob.l);
  	blob.l = end;
  	var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
  	var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
  	if(!themeXML) return;
  	return parse_theme_xml(themeXML, opts);
  }

  /* 2.5.49 */
  function parse_ColorTheme(blob/*::, length*/) { return blob.read_shift(4); }

  /* 2.5.155 */
  function parse_FullColorExt(blob/*::, length*/) {
  	var o = {};
  	o.xclrType = blob.read_shift(2);
  	o.nTintShade = blob.read_shift(2);
  	switch(o.xclrType) {
  		case 0: blob.l += 4; break;
  		case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
  		case 2: o.xclrValue = parse_LongRGBA(blob); break;
  		case 3: o.xclrValue = parse_ColorTheme(blob); break;
  		case 4: blob.l += 4; break;
  	}
  	blob.l += 8;
  	return o;
  }

  /* 2.5.164 TODO: read 7 bits*/
  function parse_IcvXF(blob, length) {
  	return parsenoop(blob, length);
  }

  /* 2.5.280 */
  function parse_XFExtGradient(blob, length) {
  	return parsenoop(blob, length);
  }

  /* [MS-XLS] 2.5.108 */
  function parse_ExtProp(blob/*::, length*/)/*:Array<any>*/ {
  	var extType = blob.read_shift(2);
  	var cb = blob.read_shift(2) - 4;
  	var o = [extType];
  	switch(extType) {
  		case 0x04: case 0x05: case 0x07: case 0x08:
  		case 0x09: case 0x0A: case 0x0B: case 0x0D:
  			o[1] = parse_FullColorExt(blob); break;
  		case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
  		case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
  		default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
  	}
  	return o;
  }

  /* 2.4.355 */
  function parse_XFExt(blob, length) {
  	var end = blob.l + length;
  	blob.l += 2;
  	var ixfe = blob.read_shift(2);
  	blob.l += 2;
  	var cexts = blob.read_shift(2);
  	var ext/*:AOA*/ = [];
  	while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
  	return {ixfe:ixfe, ext:ext};
  }

  /* xf is an XF, see parse_XFExt for xfext */
  function update_xfext(xf, xfext) {
  	xfext.forEach(function(xfe) {
  		switch(xfe[0]) { /* 2.5.108 extPropData */
  					}
  	});
  }

  function parse_BrtMdtinfo(data, length) {
    return {
      flags: data.read_shift(4),
      version: data.read_shift(4),
      name: parse_XLWideString(data)
    };
  }
  function parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while (cnt-- > 0)
      out.push([data.read_shift(4), data.read_shift(4)]);
    return out;
  }
  function parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
  }
  function parse_xlmeta_bin(data, name, _opts) {
    var out = { Types: [], Cell: [], Value: [] };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    recordhopper(data, function(val, R, RT) {
      switch (RT) {
        case 335:
          out.Types.push({ name: val.name });
          break;
        case 51:
          val.forEach(function(r) {
            if (metatype == 1)
              out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
            else if (metatype == 0)
              out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
          });
          break;
        case 337:
          metatype = val ? 1 : 0;
          break;
        case 338:
          metatype = 2;
          break;
        case 35:
          state.push(RT);
          pass = true;
          break;
        case 36:
          state.pop();
          pass = false;
          break;
        default:
          if (R.T) ; else if (!pass || opts.WTF && state[state.length - 1] != 35)
            throw new Error("Unexpected record 0x" + RT.toString(16));
      }
    });
    return out;
  }
  function parse_xlmeta_xml(data, name, opts) {
    var out = { Types: [], Cell: [], Value: [] };
    if (!data)
      return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace(tagregex, function(x) {
      var y = parsexmltag(x);
      switch (strip_ns(y[0])) {
        case "<?xml":
          break;
        case "<metadata":
        case "</metadata>":
          break;
        case "<metadataTypes":
        case "</metadataTypes>":
          break;
        case "<metadataType":
          out.Types.push({ name: y.name });
          break;
        case "</metadataType>":
          break;
        case "<futureMetadata":
          for (var j = 0; j < out.Types.length; ++j)
            if (out.Types[j].name == y.name)
              lastmeta = out.Types[j];
          break;
        case "</futureMetadata>":
          break;
        case "<bk>":
          break;
        case "</bk>":
          break;
        case "<rc":
          if (metatype == 1)
            out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
          else if (metatype == 0)
            out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
          break;
        case "</rc>":
          break;
        case "<cellMetadata":
          metatype = 1;
          break;
        case "</cellMetadata>":
          metatype = 2;
          break;
        case "<valueMetadata":
          metatype = 0;
          break;
        case "</valueMetadata>":
          metatype = 2;
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
        case "<extLst/>":
          break;
        case "<ext":
          pass = true;
          break;
        case "</ext>":
          pass = false;
          break;
        case "<rvb":
          if (!lastmeta)
            break;
          if (!lastmeta.offsets)
            lastmeta.offsets = [];
          lastmeta.offsets.push(+y.i);
          break;
        default:
          if (!pass && opts.WTF)
            throw new Error("unrecognized " + y[0] + " in metadata");
      }
      return x;
    });
    return out;
  }
  /* 18.6 Calculation Chain */
  function parse_cc_xml(data/*::, name, opts*/)/*:Array<any>*/ {
  	var d = [];
  	if(!data) return d;
  	var i = 1;
  	(data.match(tagregex)||[]).forEach(function(x) {
  		var y = parsexmltag(x);
  		switch(y[0]) {
  			case '<?xml': break;
  			/* 18.6.2  calcChain CT_CalcChain 1 */
  			case '<calcChain': case '<calcChain>': case '</calcChain>': break;
  			/* 18.6.1  c CT_CalcCell 1 */
  			case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
  		}
  	});
  	return d;
  }

  //function write_cc_xml(data, opts) { }

  /* [MS-XLSB] 2.6.4.1 */
  function parse_BrtCalcChainItem$(data) {
  	var out = {};
  	out.i = data.read_shift(4);
  	var cell = {};
  	cell.r = data.read_shift(4);
  	cell.c = data.read_shift(4);
  	out.r = encode_cell(cell);
  	var flags = data.read_shift(1);
  	if(flags & 0x2) out.l = '1';
  	if(flags & 0x8) out.a = '1';
  	return out;
  }

  /* 18.6 Calculation Chain */
  function parse_cc_bin(data, name, opts) {
  	var out = [];
  	recordhopper(data, function hopper_cc(val, R, RT) {
  		switch(RT) {
  			case 0x003F: /* 'BrtCalcChainItem$' */
  				out.push(val); break;

  			default:
  				if(R.T);
  				else throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	});
  	return out;
  }

  //function write_cc_bin(data, opts) { }
  /* 18.14 Supplementary Workbook Data */
  function parse_xlink_xml(/*::data, rel, name:string, _opts*/) {
  	//var opts = _opts || {};
  	//if(opts.WTF) throw "XLSX External Link";
  }

  /* [MS-XLSB] 2.1.7.25 External Link */
  function parse_xlink_bin(data, rel, name/*:string*/, _opts) {
  	if(!data) return data;
  	var opts = _opts || {};

  	var pass = false;

  	recordhopper(data, function xlink_parse(val, R, RT) {
  		switch(RT) {
  			case 0x0167: /* 'BrtSupTabs' */
  			case 0x016B: /* 'BrtExternTableStart' */
  			case 0x016C: /* 'BrtExternTableEnd' */
  			case 0x016E: /* 'BrtExternRowHdr' */
  			case 0x016F: /* 'BrtExternCellBlank' */
  			case 0x0170: /* 'BrtExternCellReal' */
  			case 0x0171: /* 'BrtExternCellBool' */
  			case 0x0172: /* 'BrtExternCellError' */
  			case 0x0173: /* 'BrtExternCellString' */
  			case 0x01D8: /* 'BrtExternValueMeta' */
  			case 0x0241: /* 'BrtSupNameStart' */
  			case 0x0242: /* 'BrtSupNameValueStart' */
  			case 0x0243: /* 'BrtSupNameValueEnd' */
  			case 0x0244: /* 'BrtSupNameNum' */
  			case 0x0245: /* 'BrtSupNameErr' */
  			case 0x0246: /* 'BrtSupNameSt' */
  			case 0x0247: /* 'BrtSupNameNil' */
  			case 0x0248: /* 'BrtSupNameBool' */
  			case 0x0249: /* 'BrtSupNameFmla' */
  			case 0x024A: /* 'BrtSupNameBits' */
  			case 0x024B: /* 'BrtSupNameEnd' */
  				break;

  			case 0x0023: /* 'BrtFRTBegin' */
  				pass = true; break;
  			case 0x0024: /* 'BrtFRTEnd' */
  				pass = false; break;

  			default:
  				if(R.T);
  				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	}, opts);
  }
  /* 20.5 DrawingML - SpreadsheetML Drawing */
  /* 20.5.2.35 wsDr CT_Drawing */
  function parse_drawing(data, rels/*:any*/) {
  	if(!data) return "??";
  	/*
  	  Chartsheet Drawing:
  	   - 20.5.2.35 wsDr CT_Drawing
  	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
  	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
  	      - 20.1.2.2.16 graphic CT_GraphicalObject
  	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
            - chart reference
  	   the actual type is based on the URI of the graphicData
  		TODO: handle embedded charts and other types of graphics
  	*/
  	var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];

  	return rels['!id'][id].Target;
  }
  function sheet_insert_comments(sheet, comments/*:Array<RawComment>*/, threaded/*:boolean*/, people/*:?Array<any>*/) {
  	var dense = Array.isArray(sheet);
  	var cell/*:Cell*/;
  	comments.forEach(function(comment) {
  		var r = decode_cell(comment.ref);
  		if(dense) {
  			if(!sheet[r.r]) sheet[r.r] = [];
  			cell = sheet[r.r][r.c];
  		} else cell = sheet[comment.ref];
  		if (!cell) {
  			cell = ({t:"z"}/*:any*/);
  			if(dense) sheet[r.r][r.c] = cell;
  			else sheet[comment.ref] = cell;
  			var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
  			if(range.s.r > r.r) range.s.r = r.r;
  			if(range.e.r < r.r) range.e.r = r.r;
  			if(range.s.c > r.c) range.s.c = r.c;
  			if(range.e.c < r.c) range.e.c = r.c;
  			var encoded = encode_range(range);
  			if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
  		}

  		if (!cell.c) cell.c = [];
  		var o/*:Comment*/ = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
  		if(comment.h) o.h = comment.h;

  		/* threaded comments always override */
  		for(var i = cell.c.length - 1; i >= 0; --i) {
  			if(!threaded && cell.c[i].T) return;
  			if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
  		}
  		if(threaded && people) for(i = 0; i < people.length; ++i) {
  			if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
  		}
  		cell.c.push(o);
  	});
  }

  /* 18.7 Comments */
  function parse_comments_xml(data/*:string*/, opts)/*:Array<RawComment>*/ {
  	/* 18.7.6 CT_Comments */
  	if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
  	var authors/*:Array<string>*/ = [];
  	var commentList/*:Array<RawComment>*/ = [];
  	var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  	if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
  		if(x === "" || x.trim() === "") return;
  		var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
  		if(a) authors.push(a[1]);
  	});
  	var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  	if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
  		if(x === "" || x.trim() === "") return;
  		var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
  		if(!cm) return;
  		var y = parsexmltag(cm[0]);
  		var comment/*:RawComment*/ = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid }/*:any*/);
  		var cell = decode_cell(y.ref);
  		if(opts.sheetRows && opts.sheetRows <= cell.r) return;
  		var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
  		var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
  		comment.r = rt.r;
  		if(rt.r == "<t></t>") rt.t = rt.h = "";
  		comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
  		if(opts.cellHTML) comment.h = rt.h;
  		commentList.push(comment);
  	});
  	return commentList;
  }

  /* [MS-XLSX] 2.1.17 */
  function parse_tcmnt_xml(data/*:string*/, opts)/*:Array<RawComment>*/ {
  	var out = [];
  	var pass = false, comment = {}, tidx = 0;
  	data.replace(tagregex, function xml_tcmnt(x, idx) {
  		var y/*:any*/ = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<?xml': break;

  			/* 2.6.207 ThreadedComments CT_ThreadedComments */
  			case '<ThreadedComments': break;
  			case '</ThreadedComments>': break;

  			/* 2.6.205 threadedComment CT_ThreadedComment */
  			case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
  			case '</threadedComment>': if(comment.t != null) out.push(comment); break;

  			case '<text>': case '<text': tidx = idx + x.length; break;
  			case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;

  			/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
  			case '<mentions': case '<mentions>': pass = true; break;
  			case '</mentions>': pass = false; break;

  			/* 2.6.202 mention CT_Mention TODO */

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
  			/* 18.2.7  ext CT_Extension + */
  			case '<ext': pass=true; break;
  			case '</ext>': pass=false; break;

  			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
  		}
  		return x;
  	});
  	return out;
  }

  /* [MS-XLSX] 2.1.18 */
  function parse_people_xml(data/*:string*/, opts) {
  	var out = [];
  	var pass = false;
  	data.replace(tagregex, function xml_tcmnt(x) {
  		var y/*:any*/ = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<?xml': break;

  			/* 2.4.85 personList CT_PersonList */
  			case '<personList': break;
  			case '</personList>': break;

  			/* 2.6.203 person CT_Person TODO: providers */
  			case '<person': out.push({name: y.displayname, id: y.id }); break;
  			case '</person>': break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
  			/* 18.2.7  ext CT_Extension + */
  			case '<ext': pass=true; break;
  			case '</ext>': pass=false; break;

  			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
  		}
  		return x;
  	});
  	return out;
  }
  /* [MS-XLSB] 2.4.28 BrtBeginComment */
  function parse_BrtBeginComment(data) {
  	var out = {};
  	out.iauthor = data.read_shift(4);
  	var rfx = parse_UncheckedRfX(data);
  	out.rfx = rfx.s;
  	out.ref = encode_cell(rfx.s);
  	data.l += 16; /*var guid = parse_GUID(data); */
  	return out;
  }

  /* [MS-XLSB] 2.4.327 BrtCommentAuthor */
  var parse_BrtCommentAuthor = parse_XLWideString;

  /* [MS-XLSB] 2.1.7.8 Comments */
  function parse_comments_bin(data, opts)/*:Array<RawComment>*/ {
  	var out/*:Array<RawComment>*/ = [];
  	var authors/*:Array<string>*/ = [];
  	var c = {};
  	var pass = false;
  	recordhopper(data, function hopper_cmnt(val, R, RT) {
  		switch(RT) {
  			case 0x0278: /* 'BrtCommentAuthor' */
  				authors.push(val); break;
  			case 0x027B: /* 'BrtBeginComment' */
  				c = val; break;
  			case 0x027D: /* 'BrtCommentText' */
  				c.t = val.t; c.h = val.h; c.r = val.r; break;
  			case 0x027C: /* 'BrtEndComment' */
  				c.author = authors[c.iauthor];
  				delete (c/*:any*/).iauthor;
  				if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
  				if(!c.t) c.t = "";
  				delete c.rfx; out.push(c); break;

  			case 0x0C00: /* 'BrtUid' */
  				break;

  			case 0x0023: /* 'BrtFRTBegin' */
  				pass = true; break;
  			case 0x0024: /* 'BrtFRTEnd' */
  				pass = false; break;
  			case 0x0025: /* 'BrtACBegin' */ break;
  			case 0x0026: /* 'BrtACEnd' */ break;


  			default:
  				if(R.T);
  				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	});
  	return out;
  }
  var CT_VBA = "application/vnd.ms-office.vbaProject";
  function make_vba_xls(cfb) {
    var newcfb = CFB.utils.cfb_new({ root: "R" });
    cfb.FullPaths.forEach(function(p, i) {
      if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
        return;
      var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return CFB.write(newcfb);
  }
  /* macro and dialog sheet stubs */
  function parse_ds_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
  function parse_ds_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'dialog'}; }
  function parse_ms_bin(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
  function parse_ms_xml(/*::data:any, opts, idx:number, rels, wb, themes, styles*/)/*:Worksheet*/ { return {'!type':'macro'}; }
  /* TODO: it will be useful to parse the function str */
  var rc_to_a1 = /*#__PURE__*/(function(){
  	var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
  	var rcbase/*:Cell*/ = ({r:0,c:0}/*:any*/);
  	function rcfunc($$,$1,$2,$3) {
  		var cRel = false, rRel = false;

  		if($2.length == 0) rRel = true;
  		else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }

  		if($3.length == 0) cRel = true;
  		else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }

  		var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;

  		if(cRel) C += rcbase.c; else --C;
  		if(rRel) R += rcbase.r; else --R;
  		return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
  	}
  	return function rc_to_a1(fstr/*:string*/, base/*:Cell*/)/*:string*/ {
  		rcbase = base;
  		return fstr.replace(rcregex, rcfunc);
  	};
  })();

  var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
  var a1_to_rc = /*#__PURE__*/(function(){
  	return function a1_to_rc(fstr/*:string*/, base/*:CellAddress*/) {
  		return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
  			var c = decode_col($3) - ($2 ? 0 : base.c);
  			var r = decode_row($5) - ($4 ? 0 : base.r);
  			var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
  			var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
  			return $1 + "R" + R + "C" + C;
  		});
  	};
  })();

  /* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
  function shift_formula_str(f/*:string*/, delta/*:Cell*/)/*:string*/ {
  	return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
  		return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
  	});
  }

  function shift_formula_xlsx(f/*:string*/, range/*:string*/, cell/*:string*/)/*:string*/ {
  	var r = decode_range(range), s = r.s, c = decode_cell(cell);
  	var delta = {r:c.r - s.r, c:c.c - s.c};
  	return shift_formula_str(f, delta);
  }

  /* TODO: parse formula */
  function fuzzyfmla(f/*:string*/)/*:boolean*/ {
  	if(f.length == 1) return false;
  	return true;
  }

  function _xlfn(f/*:string*/)/*:string*/ {
  	return f.replace(/_xlfn\./g,"");
  }
  function parseread1(blob) { blob.l+=1; return; }

  /* [MS-XLS] 2.5.51 */
  function parse_ColRelU(blob, length) {
  	var c = blob.read_shift(length == 1 ? 1 : 2);
  	return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
  }

  /* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
  function parse_RgceArea(blob, length, opts) {
  	var w = 2;
  	if(opts) {
  		if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob);
  		else if(opts.biff == 12) w = 4;
  	}
  	var r=blob.read_shift(w), R=blob.read_shift(w);
  	var c=parse_ColRelU(blob, 2);
  	var C=parse_ColRelU(blob, 2);
  	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
  }
  /* BIFF 2-5 encodes flags in the row field */
  function parse_RgceArea_BIFF2(blob/*::, length, opts*/) {
  	var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
  	var c=blob.read_shift(1);
  	var C=blob.read_shift(1);
  	return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
  }

  /* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
  function parse_RgceAreaRel(blob, length, opts) {
  	if(opts.biff < 8) return parse_RgceArea_BIFF2(blob);
  	var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
  	var c=parse_ColRelU(blob, 2);
  	var C=parse_ColRelU(blob, 2);
  	return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
  }

  /* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
  function parse_RgceLoc(blob, length, opts) {
  	if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob);
  	var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
  	var c = parse_ColRelU(blob, 2);
  	return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
  }
  function parse_RgceLoc_BIFF2(blob/*::, length, opts*/) {
  	var r = parse_ColRelU(blob, 2);
  	var c = blob.read_shift(1);
  	return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
  }

  /* [MS-XLS] 2.5.198.107, 2.5.47 */
  function parse_RgceElfLoc(blob/*::, length, opts*/) {
  	var r = blob.read_shift(2);
  	var c = blob.read_shift(2);
  	return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
  }

  /* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
  function parse_RgceLocRel(blob, length, opts) {
  	var biff = opts && opts.biff ? opts.biff : 8;
  	if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob);
  	var r = blob.read_shift(biff >= 12 ? 4 : 2);
  	var cl = blob.read_shift(2);
  	var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
  	cl &= 0x3FFF;
  	if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
  	if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
  	return {r:r,c:cl,cRel:cRel,rRel:rRel};
  }
  function parse_RgceLocRel_BIFF2(blob/*::, length:number, opts*/) {
  	var rl = blob.read_shift(2);
  	var c = blob.read_shift(1);
  	var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
  	rl &= 0x3FFF;
  	if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
  	if(cRel == 1 && c >= 0x80) c = c - 0x100;
  	return {r:rl,c:c,cRel:cRel,rRel:rRel};
  }

  /* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
  function parse_PtgArea(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
  	return [type, area];
  }

  /* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
  function parse_PtgArea3d(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	var ixti = blob.read_shift(2, 'i');
  	var w = 8;
  	if(opts) switch(opts.biff) {
  		case 5: blob.l += 12; w = 6; break;
  		case 12: w = 12; break;
  	}
  	var area = parse_RgceArea(blob, w, opts);
  	return [type, ixti, area];
  }

  /* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
  function parse_PtgAreaErr(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
  	return [type];
  }
  /* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
  function parse_PtgAreaErr3d(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	var ixti = blob.read_shift(2);
  	var w = 8;
  	if(opts) switch(opts.biff) {
  		case 5: blob.l += 12; w = 6; break;
  		case 12: w = 12; break;
  	}
  	blob.l += w;
  	return [type, ixti];
  }

  /* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
  function parse_PtgAreaN(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	var area = parse_RgceAreaRel(blob, length - 1, opts);
  	return [type, area];
  }

  /* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
  function parse_PtgArray(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
  	return [type];
  }

  /* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
  function parse_PtgAttrBaxcel(blob) {
  	var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
  	var bitBaxcel = 1;
  	blob.l += 4;
  	return [bitSemi, bitBaxcel];
  }

  /* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
  function parse_PtgAttrChoose(blob, length, opts)/*:Array<number>*/ {
  	blob.l +=2;
  	var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	var o/*:Array<number>*/ = [];
  	/* offset is 1 less than the number of elements */
  	for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
  	return o;
  }

  /* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
  function parse_PtgAttrGoto(blob, length, opts) {
  	var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
  	blob.l += 2;
  	return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
  }

  /* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
  function parse_PtgAttrIf(blob, length, opts) {
  	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
  	blob.l += 2;
  	return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
  }

  /* [MS-XLSB] 2.5.97.28 */
  function parse_PtgAttrIfError(blob) {
  	var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
  	blob.l += 2;
  	return [bitIf, blob.read_shift(2)];
  }

  /* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
  function parse_PtgAttrSemi(blob, length, opts) {
  	var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
  	blob.l += opts && opts.biff == 2 ? 3 : 4;
  	return [bitSemi];
  }

  /* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
  function parse_PtgAttrSpaceType(blob/*::, length*/) {
  	var type = blob.read_shift(1), cch = blob.read_shift(1);
  	return [type, cch];
  }

  /* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
  function parse_PtgAttrSpace(blob) {
  	blob.read_shift(2);
  	return parse_PtgAttrSpaceType(blob);
  }

  /* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
  function parse_PtgAttrSpaceSemi(blob) {
  	blob.read_shift(2);
  	return parse_PtgAttrSpaceType(blob);
  }

  /* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
  function parse_PtgRef(blob, length, opts) {
  	//var ptg = blob[blob.l] & 0x1F;
  	var type = (blob[blob.l] & 0x60)>>5;
  	blob.l += 1;
  	var loc = parse_RgceLoc(blob, 0, opts);
  	return [type, loc];
  }

  /* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
  function parse_PtgRefN(blob, length, opts) {
  	var type = (blob[blob.l] & 0x60)>>5;
  	blob.l += 1;
  	var loc = parse_RgceLocRel(blob, 0, opts);
  	return [type, loc];
  }

  /* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
  function parse_PtgRef3d(blob, length, opts) {
  	var type = (blob[blob.l] & 0x60)>>5;
  	blob.l += 1;
  	var ixti = blob.read_shift(2); // XtiIndex
  	if(opts && opts.biff == 5) blob.l += 12;
  	var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
  	return [type, ixti, loc];
  }


  /* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
  function parse_PtgFunc(blob, length, opts) {
  	//var ptg = blob[blob.l] & 0x1F;
  	var type = (blob[blob.l] & 0x60)>>5;
  	blob.l += 1;
  	var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
  	return [FtabArgc[iftab], Ftab[iftab], type];
  }
  /* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
  function parse_PtgFuncVar(blob, length, opts) {
  	var type = blob[blob.l++];
  	var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
  	return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
  }

  function parsetab(blob) {
  	return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
  }

  /* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
  function parse_PtgAttrSum(blob, length, opts) {
  	blob.l += opts && opts.biff == 2 ? 3 : 4; return;
  }

  /* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
  function parse_PtgExp(blob, length, opts) {
  	blob.l++;
  	if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
  	var row = blob.read_shift(2);
  	var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	return [row, col];
  }

  /* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
  function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }

  /* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
  function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }

  /* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
  function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}

  /* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
  function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob); }

  /* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
  function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }

  /* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
  /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
  function parse_SerAr(blob, biff/*:number*/) {
  	var val = [blob.read_shift(1)];
  	if(biff == 12) switch(val[0]) {
  		case 0x02: val[0] = 0x04; break; /* SerBool */
  		case 0x04: val[0] = 0x10; break; /* SerErr */
  		case 0x00: val[0] = 0x01; break; /* SerNum */
  		case 0x01: val[0] = 0x02; break; /* SerStr */
  	}
  	switch(val[0]) {
  		case 0x04: /* SerBool -- boolean */
  			val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
  			if(biff != 12) blob.l += 7; break;
  		case 0x25: /* appears to be an alias */
  		case 0x10: /* SerErr -- error */
  			val[1] = BErr[blob[blob.l]];
  			blob.l += ((biff == 12) ? 4 : 8); break;
  		case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
  			blob.l += 8; break;
  		case 0x01: /* SerNum -- Xnum */
  			val[1] = parse_Xnum(blob); break;
  		case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
  			val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
  		default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
  	}
  	return val;
  }

  /* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
  function parse_PtgExtraMem(blob, cce, opts) {
  	var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
  	var out/*:Array<Range>*/ = [];
  	for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob));
  	return out;
  }

  /* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
  function parse_PtgExtraArray(blob, length, opts) {
  	var rows = 0, cols = 0;
  	if(opts.biff == 12) {
  		rows = blob.read_shift(4); // DRw
  		cols = blob.read_shift(4); // DCol
  	} else {
  		cols = 1 + blob.read_shift(1); //DColByteU
  		rows = 1 + blob.read_shift(2); //DRw
  	}
  	if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
  	// $FlowIgnore
  	for(var i = 0, o/*:Array<Array<any>>*/ = []; i != rows && (o[i] = []); ++i)
  		for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
  	return o;
  }

  /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
  function parse_PtgName(blob, length, opts) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
  	var nameindex = blob.read_shift(w);
  	switch(opts.biff) {
  		case 2: blob.l += 5; break;
  		case 3: case 4: blob.l += 8; break;
  		case 5: blob.l += 12; break;
  	}
  	return [type, 0, nameindex];
  }

  /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
  function parse_PtgNameX(blob, length, opts) {
  	if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob);
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var ixti = blob.read_shift(2); // XtiIndex
  	var nameindex = blob.read_shift(4);
  	return [type, ixti, nameindex];
  }
  function parse_PtgNameX_BIFF5(blob/*::, length, opts*/) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var ixti = blob.read_shift(2, 'i'); // XtiIndex
  	blob.l += 8;
  	var nameindex = blob.read_shift(2);
  	blob.l += 12;
  	return [type, ixti, nameindex];
  }

  /* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
  function parse_PtgMemArea(blob, length, opts) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	blob.l += (opts && opts.biff == 2 ? 3 : 4);
  	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	return [type, cce];
  }

  /* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
  function parse_PtgMemFunc(blob, length, opts) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
  	return [type, cce];
  }


  /* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
  function parse_PtgRefErr(blob, length, opts) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	blob.l += 4;
  	if(opts.biff < 8) blob.l--;
  	if(opts.biff == 12) blob.l += 2;
  	return [type];
  }

  /* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
  function parse_PtgRefErr3d(blob, length, opts) {
  	var type = (blob[blob.l++] & 0x60) >> 5;
  	var ixti = blob.read_shift(2);
  	var w = 4;
  	if(opts) switch(opts.biff) {
  		case 5: w = 15; break;
  		case 12: w = 6; break;
  	}
  	blob.l += w;
  	return [type, ixti];
  }

  /* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
  var parse_PtgMemErr = parsenoop;
  /* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
  var parse_PtgMemNoMem = parsenoop;
  /* [MS-XLS] 2.5.198.92 */
  var parse_PtgTbl = parsenoop;

  function parse_PtgElfLoc(blob, length, opts) {
  	blob.l += 2;
  	return [parse_RgceElfLoc(blob)];
  }
  function parse_PtgElfNoop(blob/*::, length, opts*/) {
  	blob.l += 6;
  	return [];
  }
  /* [MS-XLS] 2.5.198.46 */
  var parse_PtgElfCol = parse_PtgElfLoc;
  /* [MS-XLS] 2.5.198.47 */
  var parse_PtgElfColS = parse_PtgElfNoop;
  /* [MS-XLS] 2.5.198.48 */
  var parse_PtgElfColSV = parse_PtgElfNoop;
  /* [MS-XLS] 2.5.198.49 */
  var parse_PtgElfColV = parse_PtgElfLoc;
  /* [MS-XLS] 2.5.198.50 */
  function parse_PtgElfLel(blob/*::, length, opts*/) {
  	blob.l += 2;
  	return [parseuint16(blob), blob.read_shift(2) & 0x01];
  }
  /* [MS-XLS] 2.5.198.51 */
  var parse_PtgElfRadical = parse_PtgElfLoc;
  /* [MS-XLS] 2.5.198.52 */
  var parse_PtgElfRadicalLel = parse_PtgElfLel;
  /* [MS-XLS] 2.5.198.53 */
  var parse_PtgElfRadicalS = parse_PtgElfNoop;
  /* [MS-XLS] 2.5.198.54 */
  var parse_PtgElfRw = parse_PtgElfLoc;
  /* [MS-XLS] 2.5.198.55 */
  var parse_PtgElfRwV = parse_PtgElfLoc;

  /* [MS-XLSB] 2.5.97.52 TODO */
  var PtgListRT = [
  	"Data",
  	"All",
  	"Headers",
  	"??",
  	"?Data2",
  	"??",
  	"?DataHeaders",
  	"??",
  	"Totals",
  	"??",
  	"??",
  	"??",
  	"?DataTotals",
  	"??",
  	"??",
  	"??",
  	"?Current"
  ];
  function parse_PtgList(blob/*::, length, opts*/) {
  	blob.l += 2;
  	var ixti = blob.read_shift(2);
  	var flags = blob.read_shift(2);
  	var idx = blob.read_shift(4);
  	var c = blob.read_shift(2);
  	var C = blob.read_shift(2);
  	var rt = PtgListRT[(flags >> 2) & 0x1F];
  	return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
  }
  /* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
  function parse_PtgSxName(blob/*::, length, opts*/) {
  	blob.l += 2;
  	return [blob.read_shift(4)];
  }

  /* [XLS] old spec */
  function parse_PtgSheet(blob, length, opts) {
  	blob.l += 5;
  	blob.l += 2;
  	blob.l += (opts.biff == 2 ? 1 : 4);
  	return ["PTGSHEET"];
  }
  function parse_PtgEndSheet(blob, length, opts) {
  	blob.l += (opts.biff == 2 ? 4 : 5);
  	return ["PTGENDSHEET"];
  }
  function parse_PtgMemAreaN(blob/*::, length, opts*/) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var cce = blob.read_shift(2);
  	return [type, cce];
  }
  function parse_PtgMemNoMemN(blob/*::, length, opts*/) {
  	var type = (blob.read_shift(1) >>> 5) & 0x03;
  	var cce = blob.read_shift(2);
  	return [type, cce];
  }
  function parse_PtgAttrNoop(blob/*::, length, opts*/) {
  	blob.l += 4;
  	return [0, 0];
  }

  /* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
  var PtgTypes = {
  	/*::[*/0x01/*::]*/: { n:'PtgExp', f:parse_PtgExp },
  	/*::[*/0x02/*::]*/: { n:'PtgTbl', f:parse_PtgTbl },
  	/*::[*/0x03/*::]*/: { n:'PtgAdd', f:parseread1 },
  	/*::[*/0x04/*::]*/: { n:'PtgSub', f:parseread1 },
  	/*::[*/0x05/*::]*/: { n:'PtgMul', f:parseread1 },
  	/*::[*/0x06/*::]*/: { n:'PtgDiv', f:parseread1 },
  	/*::[*/0x07/*::]*/: { n:'PtgPower', f:parseread1 },
  	/*::[*/0x08/*::]*/: { n:'PtgConcat', f:parseread1 },
  	/*::[*/0x09/*::]*/: { n:'PtgLt', f:parseread1 },
  	/*::[*/0x0A/*::]*/: { n:'PtgLe', f:parseread1 },
  	/*::[*/0x0B/*::]*/: { n:'PtgEq', f:parseread1 },
  	/*::[*/0x0C/*::]*/: { n:'PtgGe', f:parseread1 },
  	/*::[*/0x0D/*::]*/: { n:'PtgGt', f:parseread1 },
  	/*::[*/0x0E/*::]*/: { n:'PtgNe', f:parseread1 },
  	/*::[*/0x0F/*::]*/: { n:'PtgIsect', f:parseread1 },
  	/*::[*/0x10/*::]*/: { n:'PtgUnion', f:parseread1 },
  	/*::[*/0x11/*::]*/: { n:'PtgRange', f:parseread1 },
  	/*::[*/0x12/*::]*/: { n:'PtgUplus', f:parseread1 },
  	/*::[*/0x13/*::]*/: { n:'PtgUminus', f:parseread1 },
  	/*::[*/0x14/*::]*/: { n:'PtgPercent', f:parseread1 },
  	/*::[*/0x15/*::]*/: { n:'PtgParen', f:parseread1 },
  	/*::[*/0x16/*::]*/: { n:'PtgMissArg', f:parseread1 },
  	/*::[*/0x17/*::]*/: { n:'PtgStr', f:parse_PtgStr },
  	/*::[*/0x1A/*::]*/: { n:'PtgSheet', f:parse_PtgSheet },
  	/*::[*/0x1B/*::]*/: { n:'PtgEndSheet', f:parse_PtgEndSheet },
  	/*::[*/0x1C/*::]*/: { n:'PtgErr', f:parse_PtgErr },
  	/*::[*/0x1D/*::]*/: { n:'PtgBool', f:parse_PtgBool },
  	/*::[*/0x1E/*::]*/: { n:'PtgInt', f:parse_PtgInt },
  	/*::[*/0x1F/*::]*/: { n:'PtgNum', f:parse_PtgNum },
  	/*::[*/0x20/*::]*/: { n:'PtgArray', f:parse_PtgArray },
  	/*::[*/0x21/*::]*/: { n:'PtgFunc', f:parse_PtgFunc },
  	/*::[*/0x22/*::]*/: { n:'PtgFuncVar', f:parse_PtgFuncVar },
  	/*::[*/0x23/*::]*/: { n:'PtgName', f:parse_PtgName },
  	/*::[*/0x24/*::]*/: { n:'PtgRef', f:parse_PtgRef },
  	/*::[*/0x25/*::]*/: { n:'PtgArea', f:parse_PtgArea },
  	/*::[*/0x26/*::]*/: { n:'PtgMemArea', f:parse_PtgMemArea },
  	/*::[*/0x27/*::]*/: { n:'PtgMemErr', f:parse_PtgMemErr },
  	/*::[*/0x28/*::]*/: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
  	/*::[*/0x29/*::]*/: { n:'PtgMemFunc', f:parse_PtgMemFunc },
  	/*::[*/0x2A/*::]*/: { n:'PtgRefErr', f:parse_PtgRefErr },
  	/*::[*/0x2B/*::]*/: { n:'PtgAreaErr', f:parse_PtgAreaErr },
  	/*::[*/0x2C/*::]*/: { n:'PtgRefN', f:parse_PtgRefN },
  	/*::[*/0x2D/*::]*/: { n:'PtgAreaN', f:parse_PtgAreaN },
  	/*::[*/0x2E/*::]*/: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
  	/*::[*/0x2F/*::]*/: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
  	/*::[*/0x39/*::]*/: { n:'PtgNameX', f:parse_PtgNameX },
  	/*::[*/0x3A/*::]*/: { n:'PtgRef3d', f:parse_PtgRef3d },
  	/*::[*/0x3B/*::]*/: { n:'PtgArea3d', f:parse_PtgArea3d },
  	/*::[*/0x3C/*::]*/: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
  	/*::[*/0x3D/*::]*/: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
  	/*::[*/0xFF/*::]*/: {}
  };
  /* These are duplicated in the PtgTypes table */
  var PtgDupes = {
  	/*::[*/0x40/*::]*/: 0x20, /*::[*/0x60/*::]*/: 0x20,
  	/*::[*/0x41/*::]*/: 0x21, /*::[*/0x61/*::]*/: 0x21,
  	/*::[*/0x42/*::]*/: 0x22, /*::[*/0x62/*::]*/: 0x22,
  	/*::[*/0x43/*::]*/: 0x23, /*::[*/0x63/*::]*/: 0x23,
  	/*::[*/0x44/*::]*/: 0x24, /*::[*/0x64/*::]*/: 0x24,
  	/*::[*/0x45/*::]*/: 0x25, /*::[*/0x65/*::]*/: 0x25,
  	/*::[*/0x46/*::]*/: 0x26, /*::[*/0x66/*::]*/: 0x26,
  	/*::[*/0x47/*::]*/: 0x27, /*::[*/0x67/*::]*/: 0x27,
  	/*::[*/0x48/*::]*/: 0x28, /*::[*/0x68/*::]*/: 0x28,
  	/*::[*/0x49/*::]*/: 0x29, /*::[*/0x69/*::]*/: 0x29,
  	/*::[*/0x4A/*::]*/: 0x2A, /*::[*/0x6A/*::]*/: 0x2A,
  	/*::[*/0x4B/*::]*/: 0x2B, /*::[*/0x6B/*::]*/: 0x2B,
  	/*::[*/0x4C/*::]*/: 0x2C, /*::[*/0x6C/*::]*/: 0x2C,
  	/*::[*/0x4D/*::]*/: 0x2D, /*::[*/0x6D/*::]*/: 0x2D,
  	/*::[*/0x4E/*::]*/: 0x2E, /*::[*/0x6E/*::]*/: 0x2E,
  	/*::[*/0x4F/*::]*/: 0x2F, /*::[*/0x6F/*::]*/: 0x2F,
  	/*::[*/0x58/*::]*/: 0x22, /*::[*/0x78/*::]*/: 0x22,
  	/*::[*/0x59/*::]*/: 0x39, /*::[*/0x79/*::]*/: 0x39,
  	/*::[*/0x5A/*::]*/: 0x3A, /*::[*/0x7A/*::]*/: 0x3A,
  	/*::[*/0x5B/*::]*/: 0x3B, /*::[*/0x7B/*::]*/: 0x3B,
  	/*::[*/0x5C/*::]*/: 0x3C, /*::[*/0x7C/*::]*/: 0x3C,
  	/*::[*/0x5D/*::]*/: 0x3D, /*::[*/0x7D/*::]*/: 0x3D
  };

  var Ptg18 = {
  	/*::[*/0x01/*::]*/: { n:'PtgElfLel', f:parse_PtgElfLel },
  	/*::[*/0x02/*::]*/: { n:'PtgElfRw', f:parse_PtgElfRw },
  	/*::[*/0x03/*::]*/: { n:'PtgElfCol', f:parse_PtgElfCol },
  	/*::[*/0x06/*::]*/: { n:'PtgElfRwV', f:parse_PtgElfRwV },
  	/*::[*/0x07/*::]*/: { n:'PtgElfColV', f:parse_PtgElfColV },
  	/*::[*/0x0A/*::]*/: { n:'PtgElfRadical', f:parse_PtgElfRadical },
  	/*::[*/0x0B/*::]*/: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
  	/*::[*/0x0D/*::]*/: { n:'PtgElfColS', f:parse_PtgElfColS },
  	/*::[*/0x0F/*::]*/: { n:'PtgElfColSV', f:parse_PtgElfColSV },
  	/*::[*/0x10/*::]*/: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
  	/*::[*/0x19/*::]*/: { n:'PtgList', f:parse_PtgList },
  	/*::[*/0x1D/*::]*/: { n:'PtgSxName', f:parse_PtgSxName },
  	/*::[*/0xFF/*::]*/: {}
  };
  var Ptg19 = {
  	/*::[*/0x00/*::]*/: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
  	/*::[*/0x01/*::]*/: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
  	/*::[*/0x02/*::]*/: { n:'PtgAttrIf', f:parse_PtgAttrIf },
  	/*::[*/0x04/*::]*/: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
  	/*::[*/0x08/*::]*/: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
  	/*::[*/0x10/*::]*/: { n:'PtgAttrSum', f:parse_PtgAttrSum },
  	/*::[*/0x20/*::]*/: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
  	/*::[*/0x21/*::]*/: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
  	/*::[*/0x40/*::]*/: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
  	/*::[*/0x41/*::]*/: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
  	/*::[*/0x80/*::]*/: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
  	/*::[*/0xFF/*::]*/: {}
  };

  /* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
  function parse_RgbExtra(blob, length, rgce, opts) {
  	if(opts.biff < 8) return parsenoop(blob, length);
  	var target = blob.l + length;
  	var o = [];
  	for(var i = 0; i !== rgce.length; ++i) {
  		switch(rgce[i][0]) {
  			case 'PtgArray': /* PtgArray -> PtgExtraArray */
  				rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
  				o.push(rgce[i][1]);
  				break;
  			case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
  				rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
  				o.push(rgce[i][2]);
  				break;
  			case 'PtgExp': /* PtgExp -> PtgExtraCol */
  				if(opts && opts.biff == 12) {
  					rgce[i][1][1] = blob.read_shift(4);
  					o.push(rgce[i][1]);
  				} break;
  			case 'PtgList': /* TODO: PtgList -> PtgExtraList */
  			case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
  			case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
  			case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
  				throw "Unsupported " + rgce[i][0];
  		}
  	}
  	length = target - blob.l;
  	/* note: this is technically an error but Excel disregards */
  	//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
  	if(length !== 0) o.push(parsenoop(blob, length));
  	return o;
  }

  /* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
  function parse_Rgce(blob, length, opts) {
  	var target = blob.l + length;
  	var R, id, ptgs = [];
  	while(target != blob.l) {
  		length = target - blob.l;
  		id = blob[blob.l];
  		R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
  		if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
  		if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
  		else { ptgs.push([R.n, R.f(blob, length, opts)]); }
  	}
  	return ptgs;
  }

  function stringify_array(f/*:Array<Array<string>>*/)/*:string*/ {
  	var o/*:Array<string>*/ = [];
  	for(var i = 0; i < f.length; ++i) {
  		var x = f[i], r/*:Array<string>*/ = [];
  		for(var j = 0; j < x.length; ++j) {
  			var y = x[j];
  			if(y) switch(y[0]) {
  				// TODO: handle embedded quotes
  				case 0x02:
  					/*:: if(typeof y[1] != 'string') throw "unreachable"; */
  					r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
  				default: r.push(y[1]);
  			} else r.push("");
  		}
  		o.push(r.join(","));
  	}
  	return o.join(";");
  }

  /* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
  var PtgBinOp = {
  	PtgAdd: "+",
  	PtgConcat: "&",
  	PtgDiv: "/",
  	PtgEq: "=",
  	PtgGe: ">=",
  	PtgGt: ">",
  	PtgLe: "<=",
  	PtgLt: "<",
  	PtgMul: "*",
  	PtgNe: "<>",
  	PtgPower: "^",
  	PtgSub: "-"
  };

  // List of invalid characters needs to be tested further
  function formula_quote_sheet_name(sname/*:string*/, opts)/*:string*/ {
  	if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
  	if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
  	return sname;
  }
  function get_ixti_raw(supbooks, ixti/*:number*/, opts)/*:string*/ {
  	if(!supbooks) return "SH33TJSERR0";
  	if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
  	if(!supbooks.XTI) return "SH33TJSERR6";
  	var XTI = supbooks.XTI[ixti];
  	if(opts.biff < 8) {
  		if(ixti > 10000) ixti-= 65536;
  		if(ixti < 0) ixti = -ixti;
  		return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
  	}
  	if(!XTI) return "SH33TJSERR1";
  	var o = "";
  	if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
  		case 0x0165: /* 'BrtSupSelf' */
  			o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
  			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
  		case 0x0166: /* 'BrtSupSame' */
  			if(opts.SID != null) return supbooks.SheetNames[opts.SID];
  			return "SH33TJSSAME" + supbooks[XTI[0]][0];
  		case 0x0163: /* 'BrtSupBookSrc' */
  			/* falls through */
  		default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
  	}
  	switch(supbooks[XTI[0]][0][0]) {
  		case 0x0401:
  			o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
  			return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
  		case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
  		default:
  			if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
  			o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
  			return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
  	}
  }
  function get_ixti(supbooks, ixti/*:number*/, opts)/*:string*/ {
  	var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
  	return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
  }
  function stringify_formula(formula/*Array<any>*/, range, cell/*:any*/, supbooks, opts)/*:string*/ {
  	var biff = (opts && opts.biff) || 8;
  	var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
  	var stack/*:Array<string>*/ = [], e1, e2, /*::type,*/ c/*:CellAddress*/, ixti=0, nameidx=0, r, sname="";
  	if(!formula[0] || !formula[0][0]) return "";
  	var last_sp = -1, sp = "";
  	for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
  		var f = formula[0][ff];
  		switch(f[0]) {
  			case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
  				stack.push("-" + stack.pop()); break;
  			case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
  				stack.push("+" + stack.pop()); break;
  			case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
  				stack.push(stack.pop() + "%"); break;

  			case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
  			case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
  			case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
  			case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
  			case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
  			case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
  			case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
  			case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
  			case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
  			case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
  			case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
  			case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
  				e1 = stack.pop(); e2 = stack.pop();
  				if(last_sp >= 0) {
  					switch(formula[0][last_sp][1][0]) {
  						case 0:
  							// $FlowIgnore
  							sp = fill(" ", formula[0][last_sp][1][1]); break;
  						case 1:
  							// $FlowIgnore
  							sp = fill("\r", formula[0][last_sp][1][1]); break;
  						default:
  							sp = "";
  							// $FlowIgnore
  							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
  					}
  					e2 = e2 + sp;
  					last_sp = -1;
  				}
  				stack.push(e2+PtgBinOp[f[0]]+e1);
  				break;

  			case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
  				e1 = stack.pop(); e2 = stack.pop();
  				stack.push(e2+" "+e1);
  				break;
  			case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
  				e1 = stack.pop(); e2 = stack.pop();
  				stack.push(e2+","+e1);
  				break;
  			case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
  				e1 = stack.pop(); e2 = stack.pop();
  				stack.push(e2+":"+e1);
  				break;

  			case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
  				break;
  			case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
  				break;
  			case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
  				break;
  			case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
  				break;


  			case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
  				/*::type = f[1][0]; */c = shift_cell_xls((f[1][1]/*:any*/), _range, opts);
  				stack.push(encode_cell_xls(c, biff));
  				break;
  			case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
  				/*::type = f[1][0]; */c = cell ? shift_cell_xls((f[1][1]/*:any*/), cell, opts) : (f[1][1]/*:any*/);
  				stack.push(encode_cell_xls(c, biff));
  				break;
  			case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
  				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; c = shift_cell_xls((f[1][2]/*:any*/), _range, opts);
  				sname = get_ixti(supbooks, ixti, opts);
  				stack.push(sname + "!" + encode_cell_xls(c, biff));
  				break;

  			case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
  			case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
  				/* f[1] = [argc, func, type] */
  				var argc/*:number*/ = (f[1][0]/*:any*/), func/*:string*/ = (f[1][1]/*:any*/);
  				if(!argc) argc = 0;
  				argc &= 0x7F;
  				var args = argc == 0 ? [] : stack.slice(-argc);
  				stack.length -= argc;
  				if(func === 'User') func = args.shift();
  				stack.push(func + "(" + args.join(",") + ")");
  				break;

  			case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
  				stack.push(f[1] ? "TRUE" : "FALSE"); break;
  			case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
  				stack.push(/*::String(*/f[1]/*::)*/); break;
  			case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
  				stack.push(String(f[1])); break;
  			case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
  				// $FlowIgnore
  				stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
  			case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
  				stack.push(/*::String(*/f[1]/*::)*/); break;
  			case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
  				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
  				stack.push(encode_range_xls((r/*:any*/), opts));
  				break;
  			case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
  				/*::type = f[1][0]; */r = shift_range_xls(f[1][1], _range, opts);
  				stack.push(encode_range_xls((r/*:any*/), opts));
  				break;
  			case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
  				/*::type = f[1][0]; */ixti = /*::Number(*/f[1][1]/*::)*/; r = f[1][2];
  				sname = get_ixti(supbooks, ixti, opts);
  				stack.push(sname + "!" + encode_range_xls((r/*:any*/), opts));
  				break;
  			case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
  				stack.push("SUM(" + stack.pop() + ")");
  				break;

  			case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
  			case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
  				break;

  			case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
  				/* f[1] = type, 0, nameindex */
  				nameidx = (f[1][2]/*:any*/);
  				var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
  				var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
  				/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
  				if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
  				stack.push(name);
  				break;

  			case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
  				/* f[1] = type, ixti, nameindex */
  				var bookidx/*:number*/ = (f[1][1]/*:any*/); nameidx = (f[1][2]/*:any*/); var externbook;
  				/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
  				if(opts.biff <= 5) {
  					if(bookidx < 0) bookidx = -bookidx;
  					if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
  				} else {
  					var o = "";
  					if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01);
  					else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
  						if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
  							o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
  						}
  					}
  					else o = supbooks.SheetNames[nameidx-1]+ "!";
  					if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
  					else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
  					else {
  						var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
  						if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
  						else o += "SH33TJSERRX";
  					}
  					stack.push(o);
  					break;
  				}
  				if(!externbook) externbook = {Name: "SH33TJSERRY"};
  				stack.push(externbook.Name);
  				break;

  			case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
  				var lp = '(', rp = ')';
  				if(last_sp >= 0) {
  					sp = "";
  					switch(formula[0][last_sp][1][0]) {
  						// $FlowIgnore
  						case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
  						// $FlowIgnore
  						case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
  						// $FlowIgnore
  						case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
  						// $FlowIgnore
  						case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
  						default:
  							// $FlowIgnore
  							if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
  					}
  					last_sp = -1;
  				}
  				stack.push(lp + stack.pop() + rp); break;

  			case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
  				stack.push('#REF!'); break;

  			case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
  				stack.push('#REF!'); break;

  			case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
  				c = {c:(f[1][1]/*:any*/),r:(f[1][0]/*:any*/)};
  				var q = ({c: cell.c, r:cell.r}/*:any*/);
  				if(supbooks.sharedf[encode_cell(c)]) {
  					var parsedf = (supbooks.sharedf[encode_cell(c)]);
  					stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
  				} else {
  					var fnd = false;
  					for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
  						/* TODO: should be something like range_has */
  						e2 = supbooks.arrayf[e1];
  						if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
  						if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
  						stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
  						fnd = true;
  						break;
  					}
  					if(!fnd) stack.push(/*::String(*/f[1]/*::)*/);
  				}
  				break;

  			case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
  				stack.push("{" + stringify_array(/*::(*/f[1]/*:: :any)*/) + "}");
  				break;

  			case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
  				//stack.push("(" + f[2].map(encode_range).join(",") + ")");
  				break;

  			case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
  			case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
  				last_sp = ff;
  				break;

  			case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
  				break;

  			case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
  				break;

  			case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
  				stack.push("");
  				break;

  			case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
  				stack.push("#REF!"); break;

  			case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
  				stack.push("#REF!"); break;

  			case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
  				// $FlowIgnore
  				stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
  				break;

  			case 'PtgMemAreaN':
  			case 'PtgMemNoMemN':
  			case 'PtgAttrNoop':
  			case 'PtgSheet':
  			case 'PtgEndSheet':
  				break;

  			case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
  				break;
  			case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
  				break;

  			case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
  			case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
  			case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
  			case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
  			case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
  			case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
  			case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
  			case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
  			case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
  			case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
  				throw new Error("Unsupported ELFs");

  			case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
  				throw new Error('Unrecognized Formula Token: ' + String(f));
  			default: throw new Error('Unrecognized Formula Token: ' + String(f));
  		}
  		var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
  		if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
  			f = formula[0][last_sp];
  			var _left = true;
  			switch(f[1][0]) {
  				/* note: some bad XLSB files omit the PtgParen */
  				case 4: _left = false;
  				/* falls through */
  				case 0:
  					// $FlowIgnore
  					sp = fill(" ", f[1][1]); break;
  				case 5: _left = false;
  				/* falls through */
  				case 1:
  					// $FlowIgnore
  					sp = fill("\r", f[1][1]); break;
  				default:
  					sp = "";
  					// $FlowIgnore
  					if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
  			}
  			stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
  			last_sp = -1;
  		}
  	}
  	if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
  	return stack[0];
  }

  /* [MS-XLS] 2.5.198.1 TODO */
  function parse_ArrayParsedFormula(blob, length, opts/*::, ref*/) {
  	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
  	var rgcb, cce = blob.read_shift(len); // length of rgce
  	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
  	var rgce = parse_Rgce(blob, cce, opts);
  	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
  	blob.l = target;
  	return [rgce, rgcb];
  }

  /* [MS-XLS] 2.5.198.3 TODO */
  function parse_XLSCellParsedFormula(blob, length, opts) {
  	var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
  	var rgcb, cce = blob.read_shift(len); // length of rgce
  	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
  	var rgce = parse_Rgce(blob, cce, opts);
  	if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
  	blob.l = target;
  	return [rgce, rgcb];
  }

  /* [MS-XLS] 2.5.198.21 */
  function parse_NameParsedFormula(blob, length, opts, cce) {
  	var target = blob.l + length;
  	var rgce = parse_Rgce(blob, cce, opts);
  	var rgcb;
  	if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
  	return [rgce, rgcb];
  }

  /* [MS-XLS] 2.5.198.118 TODO */
  function parse_SharedParsedFormula(blob, length, opts) {
  	var target = blob.l + length;
  	var rgcb, cce = blob.read_shift(2); // length of rgce
  	var rgce = parse_Rgce(blob, cce, opts);
  	if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
  	if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
  	return [rgce, rgcb];
  }

  /* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
  function parse_FormulaValue(blob/*::, length*/) {
  	var b;
  	if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
  	switch(blob[blob.l]) {
  		case 0x00: blob.l += 8; return ["String", 's'];
  		case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
  		case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
  		case 0x03: blob.l += 8; return ["",'s'];
  	}
  	return [];
  }

  /* [MS-XLS] 2.4.127 TODO */
  function parse_Formula(blob, length, opts) {
  	var end = blob.l + length;
  	var cell = parse_XLSCell(blob);
  	if(opts.biff == 2) ++blob.l;
  	var val = parse_FormulaValue(blob);
  	var flags = blob.read_shift(1);
  	if(opts.biff != 2) {
  		blob.read_shift(1);
  		if(opts.biff >= 5) {
  			/*var chn = */blob.read_shift(4);
  		}
  	}
  	var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
  	return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
  }


  /* XLSB Parsed Formula records have the same shape */
  function parse_XLSBParsedFormula(data, length, opts) {
  	var cce = data.read_shift(4);
  	var rgce = parse_Rgce(data, cce, opts);
  	var cb = data.read_shift(4);
  	var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
  	return [rgce, rgcb];
  }

  /* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
  var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
  /* [MS-XLSB] 2.5.97.4 CellParsedFormula */
  var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
  /* [MS-XLSB] 2.5.97.8 DVParsedFormula */
  //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
  /* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
  //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
  /* [MS-XLSB] 2.5.97.12 NameParsedFormula */
  var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
  /* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
  var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
  var Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
  };
  var Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
  };
  var FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
  };
  /* Part 3 TODO: actually parse formulae */
  function ods_to_csf_formula(f/*:string*/)/*:string*/ {
  	if(f.slice(0,3) == "of:") f = f.slice(3);
  	/* 5.2 Basic Expressions */
  	if(f.charCodeAt(0) == 61) {
  		f = f.slice(1);
  		if(f.charCodeAt(0) == 61) f = f.slice(1);
  	}
  	f = f.replace(/COM\.MICROSOFT\./g, "");
  	/* Part 3 Section 5.8 References */
  	f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
  	/* TODO: something other than this */
  	f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
  	return f.replace(/[;~]/g,",").replace(/\|/g,";");
  }

  function ods_to_csf_3D(r/*:string*/)/*:[string, string]*/ {
  	var a = r.split(":");
  	var s = a[0].split(".")[0];
  	return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
  }

  var strs = {}; // shared strings
  var _ssfopts = {}; // spreadsheet formatting options

  function default_margins(margins/*:Margins*/, mode/*:?string*/) {
  	if(!margins) return;
  	var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
  	if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
  	if(margins.left   == null) margins.left   = defs[0];
  	if(margins.right  == null) margins.right  = defs[1];
  	if(margins.top    == null) margins.top    = defs[2];
  	if(margins.bottom == null) margins.bottom = defs[3];
  	if(margins.header == null) margins.header = defs[4];
  	if(margins.footer == null) margins.footer = defs[5];
  }

  function safe_format(p/*:Cell*/, fmtid/*:number*/, fillid/*:?number*/, opts, themes, styles) {
  	try {
  		if(opts.cellNF) p.z = table_fmt[fmtid];
  	} catch(e) { if(opts.WTF) throw e; }
  	if(p.t === 'z' && !opts.cellStyles) return;
  	if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
  	if((!opts || opts.cellText !== false) && p.t !== 'z') try {
  		if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
  		if(p.t === 'e') p.w = p.w || BErr[p.v];
  		else if(fmtid === 0) {
  			if(p.t === 'n') {
  				if((p.v|0) === p.v) p.w = p.v.toString(10);
  				else p.w = SSF_general_num(p.v);
  			}
  			else if(p.t === 'd') {
  				var dd = datenum(p.v);
  				if((dd|0) === dd) p.w = dd.toString(10);
  				else p.w = SSF_general_num(dd);
  			}
  			else if(p.v === undefined) return "";
  			else p.w = SSF_general(p.v,_ssfopts);
  		}
  		else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
  		else p.w = SSF_format(fmtid,p.v,_ssfopts);
  	} catch(e) { if(opts.WTF) throw e; }
  	if(!opts.cellStyles) return;
  	if(fillid != null) try {
  		p.s = styles.Fills[fillid];
  		if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
  			p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
  			if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
  		}
  		if (p.s.bgColor && p.s.bgColor.theme) {
  			p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
  			if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
  		}
  	} catch(e) { if(opts.WTF && styles.Fills) throw e; }
  }
  function parse_ws_xml_dim(ws/*:Worksheet*/, s/*:string*/) {
  	var d = safe_decode_range(s);
  	if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
  }
  var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
  var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
  var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
  var dimregex = /"(\w*:\w*)"/;
  var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
  var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
  var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
  var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
  var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
  var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;

  /* 18.3 Worksheets */
  function parse_ws_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
  	if(!data) return data;
  	if(!rels) rels = {'!id':{}};

  	/* 18.3.1.99 worksheet CT_Worksheet */
  	var s = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
  	var refguess/*:Range*/ = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} }/*:any*/);

  	var data1 = "", data2 = "";
  	var mtch/*:?any*/ = data.match(sheetdataregex);
  	if(mtch) {
  		data1 = data.slice(0, mtch.index);
  		data2 = data.slice(mtch.index + mtch[0].length);
  	} else data1 = data2 = data;

  	/* 18.3.1.82 sheetPr CT_SheetPr */
  	var sheetPr = data1.match(sheetprregex);
  	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
  	else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx);

  	/* 18.3.1.35 dimension CT_SheetDimension */
  	var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
  	if(ridx > 0) {
  		var ref = data1.slice(ridx,ridx+50).match(dimregex);
  		if(ref) parse_ws_xml_dim(s, ref[1]);
  	}

  	/* 18.3.1.88 sheetViews CT_SheetViews */
  	var svs = data1.match(svsregex);
  	if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);

  	/* 18.3.1.17 cols CT_Cols */
  	var columns/*:Array<ColInfo>*/ = [];
  	if(opts.cellStyles) {
  		/* 18.3.1.13 col CT_Col */
  		var cols = data1.match(colregex);
  		if(cols) parse_ws_xml_cols(columns, cols);
  	}

  	/* 18.3.1.80 sheetData CT_SheetData ? */
  	if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);

  	/* 18.3.1.2  autoFilter CT_AutoFilter */
  	var afilter = data2.match(afregex);
  	if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);

  	/* 18.3.1.55 mergeCells CT_MergeCells */
  	var merges/*:Array<Range>*/ = [];
  	var _merge = data2.match(mergecregex);
  	if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
  		merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));

  	/* 18.3.1.48 hyperlinks CT_Hyperlinks */
  	var hlink = data2.match(hlinkregex);
  	if(hlink) parse_ws_xml_hlinks(s, hlink, rels);

  	/* 18.3.1.62 pageMargins CT_PageMargins */
  	var margins = data2.match(marginregex);
  	if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));

  	if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
  	if(opts.sheetRows > 0 && s["!ref"]) {
  		var tmpref = safe_decode_range(s["!ref"]);
  		if(opts.sheetRows <= +tmpref.e.r) {
  			tmpref.e.r = opts.sheetRows - 1;
  			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
  			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
  			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
  			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
  			s["!fullref"] = s["!ref"];
  			s["!ref"] = encode_range(tmpref);
  		}
  	}
  	if(columns.length > 0) s["!cols"] = columns;
  	if(merges.length > 0) s["!merges"] = merges;
  	return s;
  }

  /* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
  function parse_ws_xml_sheetpr(sheetPr/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/) {
  	var data = parsexmltag(sheetPr);
  	if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
  	if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
  }
  function parse_ws_xml_sheetpr2(sheetPr/*:string*/, body/*:string*/, s, wb/*:WBWBProps*/, idx/*:number*/) {
  	parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
  }

  function parse_ws_xml_hlinks(s, data/*:Array<string>*/, rels) {
  	var dense = Array.isArray(s);
  	for(var i = 0; i != data.length; ++i) {
  		var val = parsexmltag(utf8read(data[i]), true);
  		if(!val.ref) return;
  		var rel = ((rels || {})['!id']||[])[val.id];
  		if(rel) {
  			val.Target = rel.Target;
  			if(val.location) val.Target += "#"+unescapexml(val.location);
  		} else {
  			val.Target = "#" + unescapexml(val.location);
  			rel = {Target: val.Target, TargetMode: 'Internal'};
  		}
  		val.Rel = rel;
  		if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
  		var rng = safe_decode_range(val.ref);
  		for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
  			var addr = encode_cell({c:C,r:R});
  			if(dense) {
  				if(!s[R]) s[R] = [];
  				if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
  				s[R][C].l = val;
  			} else {
  				if(!s[addr]) s[addr] = {t:"z",v:undefined};
  				s[addr].l = val;
  			}
  		}
  	}
  }

  function parse_ws_xml_margins(margin) {
  	var o = {};
  	["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
  		if(margin[k]) o[k] = parseFloat(margin[k]);
  	});
  	return o;
  }

  function parse_ws_xml_cols(columns, cols) {
  	var seencol = false;
  	for(var coli = 0; coli != cols.length; ++coli) {
  		var coll = parsexmltag(cols[coli], true);
  		if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
  		var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
  		if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
  		delete coll.min; delete coll.max; coll.width = +coll.width;
  		if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
  		process_col(coll);
  		while(colm <= colM) columns[colm++] = dup(coll);
  	}
  }

  function parse_ws_xml_autofilter(data/*:string*/) {
  	var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
  	return o;
  }

  /* 18.3.1.88 sheetViews CT_SheetViews */
  /* 18.3.1.87 sheetView CT_SheetView */
  var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
  function parse_ws_xml_sheetviews(data, wb/*:WBWBProps*/) {
  	if(!wb.Views) wb.Views = [{}];
  	(data.match(sviewregex)||[]).forEach(function(r/*:string*/, i/*:number*/) {
  		var tag = parsexmltag(r);
  		// $FlowIgnore
  		if(!wb.Views[i]) wb.Views[i] = {};
  		// $FlowIgnore
  		if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
  		// $FlowIgnore
  		if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
  	});
  }

  var parse_ws_xml_data = /*#__PURE__*/(function() {
  	var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
  	var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
  	var refregex = /ref=["']([^"']*)["']/;
  	var match_v = matchtag("v"), match_f = matchtag("f");

  return function parse_ws_xml_data(sdata/*:string*/, s, opts, guess/*:Range*/, themes, styles) {
  	var ri = 0, x = "", cells/*:Array<string>*/ = [], cref/*:?Array<string>*/ = [], idx=0, i=0, cc=0, d="", p/*:any*/;
  	var tag, tagr = 0, tagc = 0;
  	var sstr, ftag;
  	var fmtid = 0, fillid = 0;
  	var do_format = Array.isArray(styles.CellXf), cf;
  	var arrayf/*:Array<[Range, string]>*/ = [];
  	var sharedf = [];
  	var dense = Array.isArray(s);
  	var rows/*:Array<RowInfo>*/ = [], rowobj = {}, rowrite = false;
  	var sheetStubs = !!opts.sheetStubs;
  	for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
  		x = marr[mt].trim();
  		var xlen = x.length;
  		if(xlen === 0) continue;

  		/* 18.3.1.73 row CT_Row */
  		var rstarti = 0;
  		outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
  			case ">" /*62*/:
  				if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
  				if(opts && opts.cellStyles) {
  					// TODO: avoid duplication
  					tag = parsexmltag(x.slice(rstarti,ri), true);
  					tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
  					if(opts.sheetRows && opts.sheetRows < tagr) continue;
  					rowobj = {}; rowrite = false;
  					if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
  					if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
  					if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
  					if(rowrite) rows[tagr-1] = rowobj;
  				}
  				break;
  			case "<" /*60*/: rstarti = ri; break;
  		}
  		if(rstarti >= ri) break;
  		tag = parsexmltag(x.slice(rstarti,ri), true);
  		tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
  		if(opts.sheetRows && opts.sheetRows < tagr) continue;
  		if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
  		if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;

  		if(opts && opts.cellStyles) {
  			rowobj = {}; rowrite = false;
  			if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
  			if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
  			if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
  			if(rowrite) rows[tagr-1] = rowobj;
  		}

  		/* 18.3.1.4 c CT_Cell */
  		cells = x.slice(ri).split(cellregex);
  		for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
  		cells = cells.slice(rslice);
  		for(ri = 0; ri != cells.length; ++ri) {
  			x = cells[ri].trim();
  			if(x.length === 0) continue;
  			cref = x.match(rregex); idx = ri; i=0; cc=0;
  			x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
  			if(cref != null && cref.length === 2) {
  				idx = 0; d=cref[1];
  				for(i=0; i != d.length; ++i) {
  					if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
  					idx = 26*idx + cc;
  				}
  				--idx;
  				tagc = idx;
  			} else ++tagc;
  			for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
  			tag = parsexmltag(x.slice(0,i), true);
  			if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
  			d = x.slice(i);
  			p = ({t:""}/*:any*/);

  			if((cref=d.match(match_v))!= null && /*::cref != null && */cref[1] !== '') p.v=unescapexml(cref[1]);
  			if(opts.cellFormula) {
  				if((cref=d.match(match_f))!= null && /*::cref != null && */cref[1] !== '') {
  					/* TODO: match against XLSXFutureFunctions */
  					p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
  					if(!opts.xlfn) p.f = _xlfn(p.f);
  					if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="array"') > -1) {
  						p.F = (d.match(refregex)||[])[1];
  						if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
  					} else if(/*::cref != null && cref[0] != null && */cref[0].indexOf('t="shared"') > -1) {
  						// TODO: parse formula
  						ftag = parsexmltag(cref[0]);
  						var ___f = unescapexml(utf8read(cref[1]));
  						if(!opts.xlfn) ___f = _xlfn(___f);
  						sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
  					}
  				} else if((cref=d.match(/<f[^>]*\/>/))) {
  					ftag = parsexmltag(cref[0]);
  					if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
  				}
  				/* TODO: factor out contains logic */
  				var _tag = decode_cell(tag.r);
  				for(i = 0; i < arrayf.length; ++i)
  					if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
  						if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
  							p.F = arrayf[i][1];
  			}

  			if(tag.t == null && p.v === undefined) {
  				if(p.f || p.F) {
  					p.v = 0; p.t = "n";
  				} else if(!sheetStubs) continue;
  				else p.t = "z";
  			}
  			else p.t = tag.t || "n";
  			if(guess.s.c > tagc) guess.s.c = tagc;
  			if(guess.e.c < tagc) guess.e.c = tagc;
  			/* 18.18.11 t ST_CellType */
  			switch(p.t) {
  				case 'n':
  					if(p.v == "" || p.v == null) {
  						if(!sheetStubs) continue;
  						p.t = 'z';
  					} else p.v = parseFloat(p.v);
  					break;
  				case 's':
  					if(typeof p.v == 'undefined') {
  						if(!sheetStubs) continue;
  						p.t = 'z';
  					} else {
  						sstr = strs[parseInt(p.v, 10)];
  						p.v = sstr.t;
  						p.r = sstr.r;
  						if(opts.cellHTML) p.h = sstr.h;
  					}
  					break;
  				case 'str':
  					p.t = "s";
  					p.v = (p.v!=null) ? utf8read(p.v) : '';
  					if(opts.cellHTML) p.h = escapehtml(p.v);
  					break;
  				case 'inlineStr':
  					cref = d.match(isregex);
  					p.t = 's';
  					if(cref != null && (sstr = parse_si(cref[1]))) {
  						p.v = sstr.t;
  						if(opts.cellHTML) p.h = sstr.h;
  					} else p.v = "";
  					break;
  				case 'b': p.v = parsexmlbool(p.v); break;
  				case 'd':
  					if(opts.cellDates) p.v = parseDate(p.v, 1);
  					else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
  					break;
  				/* error string in .w, number in .v */
  				case 'e':
  					if(!opts || opts.cellText !== false) p.w = p.v;
  					p.v = RBErr[p.v]; break;
  			}
  			/* formatting */
  			fmtid = fillid = 0;
  			cf = null;
  			if(do_format && tag.s !== undefined) {
  				cf = styles.CellXf[tag.s];
  				if(cf != null) {
  					if(cf.numFmtId != null) fmtid = cf.numFmtId;
  					if(opts.cellStyles) {
  						if(cf.fillId != null) fillid = cf.fillId;
  					}
  				}
  			}
  			safe_format(p, fmtid, fillid, opts, themes, styles);
  			if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
  			if(tag.cm && opts.xlmeta) {
  				var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
  				if(cm && cm.type == 'XLDAPR') p.D = true;
  			}
  			if(dense) {
  				var _r = decode_cell(tag.r);
  				if(!s[_r.r]) s[_r.r] = [];
  				s[_r.r][_r.c] = p;
  			} else s[tag.r] = p;
  		}
  	}
  	if(rows.length > 0) s['!rows'] = rows;
  }; })();

  /* [MS-XLSB] 2.4.726 BrtRowHdr */
  function parse_BrtRowHdr(data, length) {
  	var z = ({}/*:any*/);
  	var tgt = data.l + length;
  	z.r = data.read_shift(4);
  	data.l += 4; // TODO: ixfe
  	var miyRw = data.read_shift(2);
  	data.l += 1; // TODO: top/bot padding
  	var flags = data.read_shift(1);
  	data.l = tgt;
  	if(flags & 0x07) z.level = flags & 0x07;
  	if(flags & 0x10) z.hidden = true;
  	if(flags & 0x20) z.hpt = miyRw / 20;
  	return z;
  }

  /* [MS-XLSB] 2.4.820 BrtWsDim */
  var parse_BrtWsDim = parse_UncheckedRfX;

  /* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
  function parse_BrtWsFmtInfo(/*::data, length*/) {
  }
  //function write_BrtWsFmtInfo(ws, o) { }

  /* [MS-XLSB] 2.4.823 BrtWsProp */
  function parse_BrtWsProp(data, length) {
  	var z = {};
  	var f = data[data.l]; ++data.l;
  	z.above = !(f & 0x40);
  	z.left  = !(f & 0x80);
  	/* TODO: pull flags */
  	data.l += 18;
  	z.name = parse_XLSBCodeName(data);
  	return z;
  }

  /* [MS-XLSB] 2.4.306 BrtCellBlank */
  function parse_BrtCellBlank(data) {
  	var cell = parse_XLSBCell(data);
  	return [cell];
  }
  function parse_BrtShortBlank(data) {
  	var cell = parse_XLSBShortCell(data);
  	return [cell];
  }

  /* [MS-XLSB] 2.4.307 BrtCellBool */
  function parse_BrtCellBool(data) {
  	var cell = parse_XLSBCell(data);
  	var fBool = data.read_shift(1);
  	return [cell, fBool, 'b'];
  }
  function parse_BrtShortBool(data) {
  	var cell = parse_XLSBShortCell(data);
  	var fBool = data.read_shift(1);
  	return [cell, fBool, 'b'];
  }

  /* [MS-XLSB] 2.4.308 BrtCellError */
  function parse_BrtCellError(data) {
  	var cell = parse_XLSBCell(data);
  	var bError = data.read_shift(1);
  	return [cell, bError, 'e'];
  }
  function parse_BrtShortError(data) {
  	var cell = parse_XLSBShortCell(data);
  	var bError = data.read_shift(1);
  	return [cell, bError, 'e'];
  }


  /* [MS-XLSB] 2.4.311 BrtCellIsst */
  function parse_BrtCellIsst(data) {
  	var cell = parse_XLSBCell(data);
  	var isst = data.read_shift(4);
  	return [cell, isst, 's'];
  }
  function parse_BrtShortIsst(data) {
  	var cell = parse_XLSBShortCell(data);
  	var isst = data.read_shift(4);
  	return [cell, isst, 's'];
  }

  /* [MS-XLSB] 2.4.313 BrtCellReal */
  function parse_BrtCellReal(data) {
  	var cell = parse_XLSBCell(data);
  	var value = parse_Xnum(data);
  	return [cell, value, 'n'];
  }
  function parse_BrtShortReal(data) {
  	var cell = parse_XLSBShortCell(data);
  	var value = parse_Xnum(data);
  	return [cell, value, 'n'];
  }

  /* [MS-XLSB] 2.4.314 BrtCellRk */
  function parse_BrtCellRk(data) {
  	var cell = parse_XLSBCell(data);
  	var value = parse_RkNumber(data);
  	return [cell, value, 'n'];
  }
  function parse_BrtShortRk(data) {
  	var cell = parse_XLSBShortCell(data);
  	var value = parse_RkNumber(data);
  	return [cell, value, 'n'];
  }

  /* [MS-XLSB] 2.4.323 BrtCellRString */
  function parse_BrtCellRString(data) {
  	var cell = parse_XLSBCell(data);
  	var value = parse_RichStr(data);
  	return [cell, value, 'is'];
  }

  /* [MS-XLSB] 2.4.317 BrtCellSt */
  function parse_BrtCellSt(data) {
  	var cell = parse_XLSBCell(data);
  	var value = parse_XLWideString(data);
  	return [cell, value, 'str'];
  }
  function parse_BrtShortSt(data) {
  	var cell = parse_XLSBShortCell(data);
  	var value = parse_XLWideString(data);
  	return [cell, value, 'str'];
  }

  /* [MS-XLSB] 2.4.653 BrtFmlaBool */
  function parse_BrtFmlaBool(data, length, opts) {
  	var end = data.l + length;
  	var cell = parse_XLSBCell(data);
  	cell.r = opts['!row'];
  	var value = data.read_shift(1);
  	var o = [cell, value, 'b'];
  	if(opts.cellFormula) {
  		data.l += 2;
  		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
  		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
  	}
  	else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.654 BrtFmlaError */
  function parse_BrtFmlaError(data, length, opts) {
  	var end = data.l + length;
  	var cell = parse_XLSBCell(data);
  	cell.r = opts['!row'];
  	var value = data.read_shift(1);
  	var o = [cell, value, 'e'];
  	if(opts.cellFormula) {
  		data.l += 2;
  		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
  		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
  	}
  	else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.655 BrtFmlaNum */
  function parse_BrtFmlaNum(data, length, opts) {
  	var end = data.l + length;
  	var cell = parse_XLSBCell(data);
  	cell.r = opts['!row'];
  	var value = parse_Xnum(data);
  	var o = [cell, value, 'n'];
  	if(opts.cellFormula) {
  		data.l += 2;
  		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
  		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
  	}
  	else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.656 BrtFmlaString */
  function parse_BrtFmlaString(data, length, opts) {
  	var end = data.l + length;
  	var cell = parse_XLSBCell(data);
  	cell.r = opts['!row'];
  	var value = parse_XLWideString(data);
  	var o = [cell, value, 'str'];
  	if(opts.cellFormula) {
  		data.l += 2;
  		var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
  		o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
  	}
  	else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.682 BrtMergeCell */
  var parse_BrtMergeCell = parse_UncheckedRfX;

  /* [MS-XLSB] 2.4.662 BrtHLink */
  function parse_BrtHLink(data, length/*::, opts*/) {
  	var end = data.l + length;
  	var rfx = parse_UncheckedRfX(data);
  	var relId = parse_XLNullableWideString(data);
  	var loc = parse_XLWideString(data);
  	var tooltip = parse_XLWideString(data);
  	var display = parse_XLWideString(data);
  	data.l = end;
  	var o = ({rfx:rfx, relId:relId, loc:loc, display:display}/*:any*/);
  	if(tooltip) o.Tooltip = tooltip;
  	return o;
  }

  /* [MS-XLSB] 2.4.692 BrtPane */
  function parse_BrtPane(/*data, length, opts*/) {
  }

  /* [MS-XLSB] 2.4.6 BrtArrFmla */
  function parse_BrtArrFmla(data, length, opts) {
  	var end = data.l + length;
  	var rfx = parse_RfX(data);
  	var fAlwaysCalc = data.read_shift(1);
  	var o = [rfx]; o[2] = fAlwaysCalc;
  	if(opts.cellFormula) {
  		var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
  		o[1] = formula;
  	} else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.750 BrtShrFmla */
  function parse_BrtShrFmla(data, length, opts) {
  	var end = data.l + length;
  	var rfx = parse_UncheckedRfX(data);
  	var o = [rfx];
  	if(opts.cellFormula) {
  		var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
  		o[1] = formula;
  		data.l = end;
  	} else data.l = end;
  	return o;
  }

  /* [MS-XLSB] 2.4.678 BrtMargins */
  var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
  function parse_BrtMargins(data/*::, length, opts*/)/*:Margins*/ {
  	var margins = ({}/*:any*/);
  	BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data); });
  	return margins;
  }

  /* [MS-XLSB] 2.4.299 BrtBeginWsView */
  function parse_BrtBeginWsView(data/*::, length, opts*/) {
  	var f = data.read_shift(2);
  	data.l += 28;
  	return { RTL: f & 0x20 };
  }

  function parse_BrtDVal(/*data, length, opts*/) {
  }
  function parse_BrtDVal14(/*data, length, opts*/) {
  }
  /* [MS-XLSB] 2.1.7.61 Worksheet */
  function parse_ws_bin(data, _opts, idx, rels, wb/*:WBWBProps*/, themes, styles)/*:Worksheet*/ {
  	if(!data) return data;
  	var opts = _opts || {};
  	if(!rels) rels = {'!id':{}};
  	var s/*:Worksheet*/ = (opts.dense ? [] : {});

  	var ref;
  	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
  	var pass = false, end = false;
  	var row, p, cf, R, C, addr, sstr, rr, cell/*:Cell*/;
  	var merges/*:Array<Range>*/ = [];
  	opts.biff = 12;
  	opts['!row'] = 0;

  	var ai = 0, af = false;

  	var arrayf/*:Array<[Range, string]>*/ = [];
  	var sharedf = {};
  	var supbooks = opts.supbooks || /*::(*/wb/*:: :any)*/.supbooks || ([[]]/*:any*/);
  	supbooks.sharedf = sharedf;
  	supbooks.arrayf = arrayf;
  	supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
  	if(!opts.supbooks) {
  		opts.supbooks = supbooks;
  		if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
  	}

  	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
  	var seencol = false;

  	XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };

  	var cm;

  	recordhopper(data, function ws_parse(val, RR, RT) {
  		if(end) return;
  		switch(RT) {
  			case 0x0094: /* 'BrtWsDim' */
  				ref = val; break;
  			case 0x0000: /* 'BrtRowHdr' */
  				row = val;
  				if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
  				rr = encode_row(R = row.r);
  				opts['!row'] = row.r;
  				if(val.hidden || val.hpt || val.level != null) {
  					if(val.hpt) val.hpx = pt2px(val.hpt);
  					rowinfo[val.r] = val;
  				}
  				break;

  			case 0x0002: /* 'BrtCellRk' */
  			case 0x0003: /* 'BrtCellError' */
  			case 0x0004: /* 'BrtCellBool' */
  			case 0x0005: /* 'BrtCellReal' */
  			case 0x0006: /* 'BrtCellSt' */
  			case 0x0007: /* 'BrtCellIsst' */
  			case 0x0008: /* 'BrtFmlaString' */
  			case 0x0009: /* 'BrtFmlaNum' */
  			case 0x000A: /* 'BrtFmlaBool' */
  			case 0x000B: /* 'BrtFmlaError' */
  			case 0x000D: /* 'BrtShortRk' */
  			case 0x000E: /* 'BrtShortError' */
  			case 0x000F: /* 'BrtShortBool' */
  			case 0x0010: /* 'BrtShortReal' */
  			case 0x0011: /* 'BrtShortSt' */
  			case 0x0012: /* 'BrtShortIsst' */
  			case 0x003E: /* 'BrtCellRString' */
  				p = ({t:val[2]}/*:any*/);
  				switch(val[2]) {
  					case 'n': p.v = val[1]; break;
  					case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
  					case 'b': p.v = val[1] ? true : false; break;
  					case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
  					case 'str': p.t = 's'; p.v = val[1]; break;
  					case 'is': p.t = 's'; p.v = val[1].t; break;
  				}
  				if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
  				C = val[0].c == -1 ? C + 1 : val[0].c;
  				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
  				else s[encode_col(C) + rr] = p;
  				if(opts.cellFormula) {
  					af = false;
  					for(ai = 0; ai < arrayf.length; ++ai) {
  						var aii = arrayf[ai];
  						if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
  							if(C >= aii[0].s.c && C <= aii[0].e.c) {
  								p.F = encode_range(aii[0]); af = true;
  							}
  					}
  					if(!af && val.length > 3) p.f = val[3];
  				}

  				if(refguess.s.r > row.r) refguess.s.r = row.r;
  				if(refguess.s.c > C) refguess.s.c = C;
  				if(refguess.e.r < row.r) refguess.e.r = row.r;
  				if(refguess.e.c < C) refguess.e.c = C;
  				if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
  					var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
  				}
  				if(cm) {
  					if(cm.type == 'XLDAPR') p.D = true;
  					cm = void 0;
  				}
  				break;

  			case 0x0001: /* 'BrtCellBlank' */
  			case 0x000C: /* 'BrtShortBlank' */
  				if(!opts.sheetStubs || pass) break;
  				p = ({t:'z',v:void 0}/*:any*/);
  				C = val[0].c == -1 ? C + 1 : val[0].c;
  				if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
  				else s[encode_col(C) + rr] = p;
  				if(refguess.s.r > row.r) refguess.s.r = row.r;
  				if(refguess.s.c > C) refguess.s.c = C;
  				if(refguess.e.r < row.r) refguess.e.r = row.r;
  				if(refguess.e.c < C) refguess.e.c = C;
  				if(cm) {
  					if(cm.type == 'XLDAPR') p.D = true;
  					cm = void 0;
  				}
  				break;

  			case 0x00B0: /* 'BrtMergeCell' */
  				merges.push(val); break;

  			case 0x0031: { /* 'BrtCellMeta' */
  				cm = ((opts.xlmeta||{}).Cell||[])[val-1];
  			} break;

  			case 0x01EE: /* 'BrtHLink' */
  				var rel = rels['!id'][val.relId];
  				if(rel) {
  					val.Target = rel.Target;
  					if(val.loc) val.Target += "#"+val.loc;
  					val.Rel = rel;
  				} else if(val.relId == '') {
  					val.Target = "#" + val.loc;
  				}
  				for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
  					if(opts.dense) {
  						if(!s[R]) s[R] = [];
  						if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
  						s[R][C].l = val;
  					} else {
  						addr = encode_cell({c:C,r:R});
  						if(!s[addr]) s[addr] = {t:'z',v:undefined};
  						s[addr].l = val;
  					}
  				}
  				break;

  			case 0x01AA: /* 'BrtArrFmla' */
  				if(!opts.cellFormula) break;
  				arrayf.push(val);
  				cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr])/*:any*/);
  				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
  				cell.F = encode_range(val[0]);
  				break;
  			case 0x01AB: /* 'BrtShrFmla' */
  				if(!opts.cellFormula) break;
  				sharedf[encode_cell(val[0].s)] = val[1];
  				cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
  				cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
  				break;

  			/* identical to 'ColInfo' in XLS */
  			case 0x003C: /* 'BrtColInfo' */
  				if(!opts.cellStyles) break;
  				while(val.e >= val.s) {
  					colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
  					if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
  					process_col(colinfo[val.e+1]);
  				}
  				break;

  			case 0x00A1: /* 'BrtBeginAFilter' */
  				s['!autofilter'] = { ref:encode_range(val) };
  				break;

  			case 0x01DC: /* 'BrtMargins' */
  				s['!margins'] = val;
  				break;

  			case 0x0093: /* 'BrtWsProp' */
  				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
  				if(val.name) wb.Sheets[idx].CodeName = val.name;
  				if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
  				break;

  			case 0x0089: /* 'BrtBeginWsView' */
  				if(!wb.Views) wb.Views = [{}];
  				if(!wb.Views[0]) wb.Views[0] = {};
  				if(val.RTL) wb.Views[0].RTL = true;
  				break;

  			case 0x01E5: /* 'BrtWsFmtInfo' */
  				break;

  			case 0x0040: /* 'BrtDVal' */
  			case 0x041D: /* 'BrtDVal14' */
  				break;

  			case 0x0097: /* 'BrtPane' */
  				break;
  			case 0x0098: /* 'BrtSel' */
  			case 0x00AF: /* 'BrtAFilterDateGroupItem' */
  			case 0x0284: /* 'BrtActiveX' */
  			case 0x0271: /* 'BrtBigName' */
  			case 0x0232: /* 'BrtBkHim' */
  			case 0x018C: /* 'BrtBrk' */
  			case 0x0458: /* 'BrtCFIcon' */
  			case 0x047A: /* 'BrtCFRuleExt' */
  			case 0x01D7: /* 'BrtCFVO' */
  			case 0x041A: /* 'BrtCFVO14' */
  			case 0x0289: /* 'BrtCellIgnoreEC' */
  			case 0x0451: /* 'BrtCellIgnoreEC14' */
  			case 0x024D: /* 'BrtCellSmartTagProperty' */
  			case 0x025F: /* 'BrtCellWatch' */
  			case 0x0234: /* 'BrtColor' */
  			case 0x041F: /* 'BrtColor14' */
  			case 0x00A8: /* 'BrtColorFilter' */
  			case 0x00AE: /* 'BrtCustomFilter' */
  			case 0x049C: /* 'BrtCustomFilter14' */
  			case 0x01F3: /* 'BrtDRef' */
  			case 0x01FB: /* 'BrtDXF' */
  			case 0x0226: /* 'BrtDrawing' */
  			case 0x00AB: /* 'BrtDynamicFilter' */
  			case 0x00A7: /* 'BrtFilter' */
  			case 0x0499: /* 'BrtFilter14' */
  			case 0x00A9: /* 'BrtIconFilter' */
  			case 0x049D: /* 'BrtIconFilter14' */
  			case 0x0227: /* 'BrtLegacyDrawing' */
  			case 0x0228: /* 'BrtLegacyDrawingHF' */
  			case 0x0295: /* 'BrtListPart' */
  			case 0x027F: /* 'BrtOleObject' */
  			case 0x01DE: /* 'BrtPageSetup' */
  			case 0x0219: /* 'BrtPhoneticInfo' */
  			case 0x01DD: /* 'BrtPrintOptions' */
  			case 0x0218: /* 'BrtRangeProtection' */
  			case 0x044F: /* 'BrtRangeProtection14' */
  			case 0x02A8: /* 'BrtRangeProtectionIso' */
  			case 0x0450: /* 'BrtRangeProtectionIso14' */
  			case 0x0400: /* 'BrtRwDescent' */
  			case 0x0297: /* 'BrtSheetCalcProp' */
  			case 0x0217: /* 'BrtSheetProtection' */
  			case 0x02A6: /* 'BrtSheetProtectionIso' */
  			case 0x01F8: /* 'BrtSlc' */
  			case 0x0413: /* 'BrtSparkline' */
  			case 0x01AC: /* 'BrtTable' */
  			case 0x00AA: /* 'BrtTop10Filter' */
  			case 0x0C00: /* 'BrtUid' */
  			case 0x0032: /* 'BrtValueMeta' */
  			case 0x0816: /* 'BrtWebExtension' */
  			case 0x0415: /* 'BrtWsFmtInfoEx14' */
  				break;

  			case 0x0023: /* 'BrtFRTBegin' */
  				pass = true; break;
  			case 0x0024: /* 'BrtFRTEnd' */
  				pass = false; break;
  			case 0x0025: /* 'BrtACBegin' */
   pass = true; break;
  			case 0x0026: /* 'BrtACEnd' */
   pass = false; break;

  			default:
  				if(RR.T);
  				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	}, opts);

  	delete opts.supbooks;
  	delete opts['!row'];

  	if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
  	if(opts.sheetRows && s["!ref"]) {
  		var tmpref = safe_decode_range(s["!ref"]);
  		if(opts.sheetRows <= +tmpref.e.r) {
  			tmpref.e.r = opts.sheetRows - 1;
  			if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
  			if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
  			if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
  			if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
  			s["!fullref"] = s["!ref"];
  			s["!ref"] = encode_range(tmpref);
  		}
  	}
  	if(merges.length > 0) s["!merges"] = merges;
  	if(colinfo.length > 0) s["!cols"] = colinfo;
  	if(rowinfo.length > 0) s["!rows"] = rowinfo;
  	return s;
  }
  function parse_Cache(data/*:string*/)/*:[Array<number|string>, string, ?string]*/ {
  	var col/*:Array<number|string>*/ = [];
  	var num = data.match(/^<c:numCache>/);
  	var f;

  	/* 21.2.2.150 pt CT_NumVal */
  	(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
  		var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
  		if(!q) return;
  		col[+q[1]] = num ? +q[2] : q[2];
  	});

  	/* 21.2.2.71 formatCode CT_Xstring */
  	var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);

  	(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });

  	return [col, nf, f];
  }

  /* 21.2 DrawingML - Charts */
  function parse_chart(data/*:?string*/, name/*:string*/, opts, rels, wb, csheet) {
  	var cs/*:Worksheet*/ = ((csheet || {"!type":"chart"})/*:any*/);
  	if(!data) return csheet;
  	/* 21.2.2.27 chart CT_Chart */

  	var C = 0, R = 0, col = "A";
  	var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };

  	/* 21.2.2.120 numCache CT_NumData */
  	(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
  		var cache = parse_Cache(nc);
  		refguess.s.r = refguess.s.c = 0;
  		refguess.e.c = C;
  		col = encode_col(C);
  		cache[0].forEach(function(n,i) {
  			cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
  			R = i;
  		});
  		if(refguess.e.r < R) refguess.e.r = R;
  		++C;
  	});
  	if(C > 0) cs["!ref"] = encode_range(refguess);
  	return cs;
  }
  /* 18.3 Worksheets also covers Chartsheets */
  function parse_cs_xml(data/*:?string*/, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
  	if(!data) return data;
  	/* 18.3.1.12 chartsheet CT_ChartSheet */
  	if(!rels) rels = {'!id':{}};
  	var s = ({'!type':"chart", '!drawel':null, '!rel':""}/*:any*/);
  	var m;

  	/* 18.3.1.83 sheetPr CT_ChartsheetPr */
  	var sheetPr = data.match(sheetprregex);
  	if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);

  	/* 18.3.1.36 drawing CT_Drawing */
  	if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];

  	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
  	return s;
  }

  /* [MS-XLSB] 2.4.331 BrtCsProp */
  function parse_BrtCsProp(data, length/*:number*/) {
  	data.l += 10;
  	var name = parse_XLWideString(data);
  	return { name: name };
  }

  /* [MS-XLSB] 2.1.7.7 Chart Sheet */
  function parse_cs_bin(data, opts, idx/*:number*/, rels, wb/*::, themes, styles*/)/*:Worksheet*/ {
  	if(!data) return data;
  	if(!rels) rels = {'!id':{}};
  	var s = {'!type':"chart", '!drawel':null, '!rel':""};
  	var pass = false;
  	recordhopper(data, function cs_parse(val, R, RT) {
  		switch(RT) {

  			case 0x0226: /* 'BrtDrawing' */
  				s['!rel'] = val; break;

  			case 0x028B: /* 'BrtCsProp' */
  				if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
  				if(val.name) wb.Sheets[idx].CodeName = val.name;
  				break;

  			case 0x0232: /* 'BrtBkHim' */
  			case 0x028C: /* 'BrtCsPageSetup' */
  			case 0x029D: /* 'BrtCsProtection' */
  			case 0x02A7: /* 'BrtCsProtectionIso' */
  			case 0x0227: /* 'BrtLegacyDrawing' */
  			case 0x0228: /* 'BrtLegacyDrawingHF' */
  			case 0x01DC: /* 'BrtMargins' */
  			case 0x0C00: /* 'BrtUid' */
  				break;

  			case 0x0023: /* 'BrtFRTBegin' */
  				pass = true; break;
  			case 0x0024: /* 'BrtFRTEnd' */
  				pass = false; break;
  			case 0x0025: /* 'BrtACBegin' */
   break;
  			case 0x0026: /* 'BrtACEnd' */
   break;

  			default:
  				if(R.T > 0) ;
  				else if(R.T < 0) ;
  				else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	}, opts);

  	if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
  	return s;
  }
  /* 18.2.28 (CT_WorkbookProtection) Defaults */
  var WBPropsDef = [
  	['allowRefreshQuery',           false, "bool"],
  	['autoCompressPictures',        true,  "bool"],
  	['backupFile',                  false, "bool"],
  	['checkCompatibility',          false, "bool"],
  	['CodeName',                    ''],
  	['date1904',                    false, "bool"],
  	['defaultThemeVersion',         0,      "int"],
  	['filterPrivacy',               false, "bool"],
  	['hidePivotFieldList',          false, "bool"],
  	['promptedSolutions',           false, "bool"],
  	['publishItems',                false, "bool"],
  	['refreshAllConnections',       false, "bool"],
  	['saveExternalLinkValues',      true,  "bool"],
  	['showBorderUnselectedTables',  true,  "bool"],
  	['showInkAnnotation',           true,  "bool"],
  	['showObjects',                 'all'],
  	['showPivotChartFilter',        false, "bool"],
  	['updateLinks', 'userSet']
  ];

  /* 18.2.30 (CT_BookView) Defaults */
  var WBViewDef = [
  	['activeTab',                   0,      "int"],
  	['autoFilterDateGrouping',      true,  "bool"],
  	['firstSheet',                  0,      "int"],
  	['minimized',                   false, "bool"],
  	['showHorizontalScroll',        true,  "bool"],
  	['showSheetTabs',               true,  "bool"],
  	['showVerticalScroll',          true,  "bool"],
  	['tabRatio',                    600,    "int"],
  	['visibility',                  'visible']
  	//window{Height,Width}, {x,y}Window
  ];

  /* 18.2.19 (CT_Sheet) Defaults */
  var SheetDef = [
  	//['state', 'visible']
  ];

  /* 18.2.2  (CT_CalcPr) Defaults */
  var CalcPrDef = [
  	['calcCompleted', 'true'],
  	['calcMode', 'auto'],
  	['calcOnSave', 'true'],
  	['concurrentCalc', 'true'],
  	['fullCalcOnLoad', 'false'],
  	['fullPrecision', 'true'],
  	['iterate', 'false'],
  	['iterateCount', '100'],
  	['iterateDelta', '0.001'],
  	['refMode', 'A1']
  ];

  /* 18.2.3 (CT_CustomWorkbookView) Defaults */
  /*var CustomWBViewDef = [
  	['autoUpdate', 'false'],
  	['changesSavedWin', 'false'],
  	['includeHiddenRowCol', 'true'],
  	['includePrintSettings', 'true'],
  	['maximized', 'false'],
  	['minimized', 'false'],
  	['onlySync', 'false'],
  	['personalView', 'false'],
  	['showComments', 'commIndicator'],
  	['showFormulaBar', 'true'],
  	['showHorizontalScroll', 'true'],
  	['showObjects', 'all'],
  	['showSheetTabs', 'true'],
  	['showStatusbar', 'true'],
  	['showVerticalScroll', 'true'],
  	['tabRatio', '600'],
  	['xWindow', '0'],
  	['yWindow', '0']
  ];*/

  function push_defaults_array(target, defaults) {
  	for(var j = 0; j != target.length; ++j) { var w = target[j];
  		for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
  			if(w[z[0]] == null) w[z[0]] = z[1];
  			else switch(z[2]) {
  			case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
  			case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
  			}
  		}
  	}
  }
  function push_defaults(target, defaults) {
  	for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
  		if(target[z[0]] == null) target[z[0]] = z[1];
  		else switch(z[2]) {
  			case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
  			case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
  		}
  	}
  }

  function parse_wb_defaults(wb) {
  	push_defaults(wb.WBProps, WBPropsDef);
  	push_defaults(wb.CalcPr, CalcPrDef);

  	push_defaults_array(wb.WBView, WBViewDef);
  	push_defaults_array(wb.Sheets, SheetDef);

  	_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
  }

  var badchars = /*#__PURE__*/"][*?\/\\".split("");
  function check_ws_name(n/*:string*/, safe/*:?boolean*/)/*:boolean*/ {
  	if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
  	var _good = true;
  	badchars.forEach(function(c) {
  		if(n.indexOf(c) == -1) return;
  		if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  		_good = false;
  	});
  	return _good;
  }
  /* 18.2 Workbook */
  var wbnsregex = /<\w+:workbook/;
  function parse_wb_xml(data, opts)/*:WorkbookFile*/ {
  	if(!data) throw new Error("Could not find file");
  	var wb = /*::(*/{ AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" }/*::)*/;
  	var pass = false, xmlns = "xmlns";
  	var dname = {}, dnstart = 0;
  	data.replace(tagregex, function xml_wb(x, idx) {
  		var y/*:any*/ = parsexmltag(x);
  		switch(strip_ns(y[0])) {
  			case '<?xml': break;

  			/* 18.2.27 workbook CT_Workbook 1 */
  			case '<workbook':
  				if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
  				wb.xmlns = y[xmlns];
  				break;
  			case '</workbook>': break;

  			/* 18.2.13 fileVersion CT_FileVersion ? */
  			case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
  			case '<fileVersion/>': case '</fileVersion>': break;

  			/* 18.2.12 fileSharing CT_FileSharing ? */
  			case '<fileSharing':
  				break;
  			case '<fileSharing/>': break;

  			/* 18.2.28 workbookPr CT_WorkbookPr ? */
  			case '<workbookPr':
  			case '<workbookPr/>':
  				WBPropsDef.forEach(function(w) {
  					if(y[w[0]] == null) return;
  					switch(w[2]) {
  						case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
  						case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
  						default: wb.WBProps[w[0]] = y[w[0]];
  					}
  				});
  				if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
  				break;
  			case '</workbookPr>': break;

  			/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
  			case '<workbookProtection':
  				break;
  			case '<workbookProtection/>': break;

  			/* 18.2.1  bookViews CT_BookViews ? */
  			case '<bookViews': case '<bookViews>': case '</bookViews>': break;
  			/* 18.2.30   workbookView CT_BookView + */
  			case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
  			case '</workbookView>': break;

  			/* 18.2.20 sheets CT_Sheets 1 */
  			case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
  			/* 18.2.19   sheet CT_Sheet + */
  			case '<sheet':
  				switch(y.state) {
  					case "hidden": y.Hidden = 1; break;
  					case "veryHidden": y.Hidden = 2; break;
  					default: y.Hidden = 0;
  				}
  				delete y.state;
  				y.name = unescapexml(utf8read(y.name));
  				delete y[0]; wb.Sheets.push(y); break;
  			case '</sheet>': break;

  			/* 18.2.15 functionGroups CT_FunctionGroups ? */
  			case '<functionGroups': case '<functionGroups/>': break;
  			/* 18.2.14   functionGroup CT_FunctionGroup + */
  			case '<functionGroup': break;

  			/* 18.2.9  externalReferences CT_ExternalReferences ? */
  			case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
  			/* 18.2.8    externalReference CT_ExternalReference + */
  			case '<externalReference': break;

  			/* 18.2.6  definedNames CT_DefinedNames ? */
  			case '<definedNames/>': break;
  			case '<definedNames>': case '<definedNames': pass=true; break;
  			case '</definedNames>': pass=false; break;
  			/* 18.2.5    definedName CT_DefinedName + */
  			case '<definedName': {
  				dname = {};
  				dname.Name = utf8read(y.name);
  				if(y.comment) dname.Comment = y.comment;
  				if(y.localSheetId) dname.Sheet = +y.localSheetId;
  				if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
  				dnstart = idx + x.length;
  			}	break;
  			case '</definedName>': {
  				dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
  				wb.Names.push(dname);
  			} break;
  			case '<definedName/>': break;

  			/* 18.2.2  calcPr CT_CalcPr ? */
  			case '<calcPr': delete y[0]; wb.CalcPr = y; break;
  			case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
  			case '</calcPr>': break;

  			/* 18.2.16 oleSize CT_OleSize ? (ref required) */
  			case '<oleSize': break;

  			/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
  			case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
  			/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
  			case '<customWorkbookView': case '</customWorkbookView>': break;

  			/* 18.2.18 pivotCaches CT_PivotCaches ? */
  			case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
  			/* 18.2.17 pivotCache CT_PivotCache ? */
  			case '<pivotCache': break;

  			/* 18.2.21 smartTagPr CT_SmartTagPr ? */
  			case '<smartTagPr': case '<smartTagPr/>': break;

  			/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
  			case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
  			/* 18.2.22 smartTagType CT_SmartTagType ? */
  			case '<smartTagType': break;

  			/* 18.2.24 webPublishing CT_WebPublishing ? */
  			case '<webPublishing': case '<webPublishing/>': break;

  			/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
  			case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;

  			/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
  			case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
  			/* 18.2.25 webPublishObject CT_WebPublishObject ? */
  			case '<webPublishObject': break;

  			/* 18.2.10 extLst CT_ExtensionList ? */
  			case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
  			/* 18.2.7  ext CT_Extension + */
  			case '<ext': pass=true; break; //TODO: check with versions of excel
  			case '</ext>': pass=false; break;

  			/* Others */
  			case '<ArchID': break;
  			case '<AlternateContent':
  			case '<AlternateContent>': pass=true; break;
  			case '</AlternateContent>': pass=false; break;

  			/* TODO */
  			case '<revisionPtr': break;

  			default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
  		}
  		return x;
  	});
  	if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);

  	parse_wb_defaults(wb);

  	return wb;
  }
  /* [MS-XLSB] 2.4.304 BrtBundleSh */
  function parse_BrtBundleSh(data, length/*:number*/) {
  	var z = {};
  	z.Hidden = data.read_shift(4); //hsState ST_SheetState
  	z.iTabID = data.read_shift(4);
  	z.strRelID = parse_RelID(data);
  	z.name = parse_XLWideString(data);
  	return z;
  }

  /* [MS-XLSB] 2.4.815 BrtWbProp */
  function parse_BrtWbProp(data, length)/*:WBProps*/ {
  	var o/*:WBProps*/ = ({}/*:any*/);
  	var flags = data.read_shift(4);
  	o.defaultThemeVersion = data.read_shift(4);
  	var strName = (length > 8) ? parse_XLWideString(data) : "";
  	if(strName.length > 0) o.CodeName = strName;
  	o.autoCompressPictures = !!(flags & 0x10000);
  	o.backupFile = !!(flags & 0x40);
  	o.checkCompatibility = !!(flags & 0x1000);
  	o.date1904 = !!(flags & 0x01);
  	o.filterPrivacy = !!(flags & 0x08);
  	o.hidePivotFieldList = !!(flags & 0x400);
  	o.promptedSolutions = !!(flags & 0x10);
  	o.publishItems = !!(flags & 0x800);
  	o.refreshAllConnections = !!(flags & 0x40000);
  	o.saveExternalLinkValues = !!(flags & 0x80);
  	o.showBorderUnselectedTables = !!(flags & 0x04);
  	o.showInkAnnotation = !!(flags & 0x20);
  	o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
  	o.showPivotChartFilter = !!(flags & 0x8000);
  	o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
  	return o;
  }

  function parse_BrtFRTArchID$(data, length) {
  	var o = {};
  	data.read_shift(4);
  	o.ArchID = data.read_shift(4);
  	data.l += length - 8;
  	return o;
  }

  /* [MS-XLSB] 2.4.687 BrtName */
  function parse_BrtName(data, length, opts) {
  	var end = data.l + length;
  	data.l += 4; //var flags = data.read_shift(4);
  	data.l += 1; //var chKey = data.read_shift(1);
  	var itab = data.read_shift(4);
  	var name = parse_XLNameWideString(data);
  	var formula = parse_XLSBNameParsedFormula(data, 0, opts);
  	var comment = parse_XLNullableWideString(data);
  	//if(0 /* fProc */) {
  		// unusedstring1: XLNullableWideString
  		// description: XLNullableWideString
  		// helpTopic: XLNullableWideString
  		// unusedstring2: XLNullableWideString
  	//}
  	data.l = end;
  	var out = ({Name:name, Ptg:formula}/*:any*/);
  	if(itab < 0xFFFFFFF) out.Sheet = itab;
  	if(comment) out.Comment = comment;
  	return out;
  }

  /* [MS-XLSB] 2.1.7.61 Workbook */
  function parse_wb_bin(data, opts)/*:WorkbookFile*/ {
  	var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
  	var state/*:Array<string>*/ = [];
  	var pass = false;

  	if(!opts) opts = {};
  	opts.biff = 12;

  	var Names = [];
  	var supbooks = ([[]]/*:any*/);
  	supbooks.SheetNames = [];
  	supbooks.XTI = [];

  	XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };

  	recordhopper(data, function hopper_wb(val, R, RT) {
  		switch(RT) {
  			case 0x009C: /* 'BrtBundleSh' */
  				supbooks.SheetNames.push(val.name);
  				wb.Sheets.push(val); break;

  			case 0x0099: /* 'BrtWbProp' */
  				wb.WBProps = val; break;

  			case 0x0027: /* 'BrtName' */
  				if(val.Sheet != null) opts.SID = val.Sheet;
  				val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
  				delete opts.SID;
  				delete val.Ptg;
  				Names.push(val);
  				break;
  			case 0x040C: /* 'BrtNameExt' */ break;

  			case 0x0165: /* 'BrtSupSelf' */
  			case 0x0166: /* 'BrtSupSame' */
  			case 0x0163: /* 'BrtSupBookSrc' */
  			case 0x029B: /* 'BrtSupAddin' */
  				if(!supbooks[0].length) supbooks[0] = [RT, val];
  				else supbooks.push([RT, val]);
  				supbooks[supbooks.length - 1].XTI = [];
  				break;
  			case 0x016A: /* 'BrtExternSheet' */
  				if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
  				supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
  				supbooks.XTI = supbooks.XTI.concat(val);
  				break;
  			case 0x0169: /* 'BrtPlaceholderName' */
  				break;

  			case 0x0817: /* 'BrtAbsPath15' */
  			case 0x009E: /* 'BrtBookView' */
  			case 0x008F: /* 'BrtBeginBundleShs' */
  			case 0x0298: /* 'BrtBeginFnGroup' */
  			case 0x0161: /* 'BrtBeginExternals' */
  				break;

  			/* case 'BrtModelTimeGroupingCalcCol' */
  			case 0x0C00: /* 'BrtUid' */
  			case 0x0C01: /* 'BrtRevisionPtr' */
  			case 0x0216: /* 'BrtBookProtection' */
  			case 0x02A5: /* 'BrtBookProtectionIso' */
  			case 0x009D: /* 'BrtCalcProp' */
  			case 0x0262: /* 'BrtCrashRecErr' */
  			case 0x0802: /* 'BrtDecoupledPivotCacheID' */
  			case 0x009B: /* 'BrtFileRecover' */
  			case 0x0224: /* 'BrtFileSharing' */
  			case 0x02A4: /* 'BrtFileSharingIso' */
  			case 0x0080: /* 'BrtFileVersion' */
  			case 0x0299: /* 'BrtFnGroup' */
  			case 0x0850: /* 'BrtModelRelationship' */
  			case 0x084D: /* 'BrtModelTable' */
  			case 0x0225: /* 'BrtOleSize' */
  			case 0x0805: /* 'BrtPivotTableRef' */
  			case 0x0254: /* 'BrtSmartTagType' */
  			case 0x081C: /* 'BrtTableSlicerCacheID' */
  			case 0x081B: /* 'BrtTableSlicerCacheIDs' */
  			case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
  			case 0x018D: /* 'BrtUserBookView' */
  			case 0x009A: /* 'BrtWbFactoid' */
  			case 0x045D: /* 'BrtWbProp14' */
  			case 0x0229: /* 'BrtWebOpt' */
  			case 0x082B: /* 'BrtWorkBookPr15' */
  				break;

  			case 0x0023: /* 'BrtFRTBegin' */
  				state.push(RT); pass = true; break;
  			case 0x0024: /* 'BrtFRTEnd' */
  				state.pop(); pass = false; break;
  			case 0x0025: /* 'BrtACBegin' */
  				state.push(RT); pass = true; break;
  			case 0x0026: /* 'BrtACEnd' */
  				state.pop(); pass = false; break;

  			case 0x0010: /* 'BrtFRTArchID$' */ break;

  			default:
  				if(R.T);
  				else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
  		}
  	}, opts);

  	parse_wb_defaults(wb);

  	// $FlowIgnore
  	wb.Names = Names;

  	(wb/*:any*/).supbooks = supbooks;
  	return wb;
  }
  function parse_wb(data, name/*:string*/, opts)/*:WorkbookFile*/ {
  	if(name.slice(-4)===".bin") return parse_wb_bin((data/*:any*/), opts);
  	return parse_wb_xml((data/*:any*/), opts);
  }

  function parse_ws(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
  	if(name.slice(-4)===".bin") return parse_ws_bin((data/*:any*/), opts, idx, rels, wb, themes, styles);
  	return parse_ws_xml((data/*:any*/), opts, idx, rels, wb, themes, styles);
  }

  function parse_cs(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
  	if(name.slice(-4)===".bin") return parse_cs_bin((data/*:any*/), opts, idx, rels, wb);
  	return parse_cs_xml((data/*:any*/), opts, idx, rels, wb);
  }

  function parse_ms(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
  	if(name.slice(-4)===".bin") return parse_ms_bin();
  	return parse_ms_xml();
  }

  function parse_ds(data, name/*:string*/, idx/*:number*/, opts, rels, wb, themes, styles)/*:Worksheet*/ {
  	if(name.slice(-4)===".bin") return parse_ds_bin();
  	return parse_ds_xml();
  }

  function parse_sty(data, name/*:string*/, themes, opts) {
  	if(name.slice(-4)===".bin") return parse_sty_bin((data/*:any*/), themes, opts);
  	return parse_sty_xml((data/*:any*/), themes, opts);
  }

  function parse_theme(data/*:string*/, name/*:string*/, opts) {
  	return parse_theme_xml(data, opts);
  }

  function parse_sst(data, name/*:string*/, opts)/*:SST*/ {
  	if(name.slice(-4)===".bin") return parse_sst_bin((data/*:any*/), opts);
  	return parse_sst_xml((data/*:any*/), opts);
  }

  function parse_cmnt(data, name/*:string*/, opts)/*:Array<RawComment>*/ {
  	if(name.slice(-4)===".bin") return parse_comments_bin((data/*:any*/), opts);
  	return parse_comments_xml((data/*:any*/), opts);
  }

  function parse_cc(data, name/*:string*/, opts) {
  	if(name.slice(-4)===".bin") return parse_cc_bin((data/*:any*/));
  	return parse_cc_xml((data/*:any*/));
  }

  function parse_xlink(data, rel, name/*:string*/, opts) {
  	if(name.slice(-4)===".bin") return parse_xlink_bin((data/*:any*/), rel, name, opts);
  	return parse_xlink_xml();
  }

  function parse_xlmeta(data, name/*:string*/, opts) {
  	if(name.slice(-4)===".bin") return parse_xlmeta_bin((data/*:any*/), name, opts);
  	return parse_xlmeta_xml((data/*:any*/), name, opts);
  }
  var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
  var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
  function xlml_parsexmltag(tag/*:string*/, skip_root/*:?boolean*/) {
  	var words = tag.split(/\s+/);
  	var z/*:any*/ = ([]/*:any*/); if(!skip_root) z[0] = words[0];
  	if(words.length === 1) return z;
  	var m = tag.match(attregexg2), y, j, w, i;
  	if(m) for(i = 0; i != m.length; ++i) {
  		y = m[i].match(attregex2);
  /*:: if(!y || !y[2]) continue; */
  		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
  		else {
  			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
  			else w = y[1].slice(j+1);
  			z[w] = y[2].slice(1,y[2].length-1);
  		}
  	}
  	return z;
  }
  function xlml_parsexmltagobj(tag/*:string*/) {
  	var words = tag.split(/\s+/);
  	var z = {};
  	if(words.length === 1) return z;
  	var m = tag.match(attregexg2), y, j, w, i;
  	if(m) for(i = 0; i != m.length; ++i) {
  		y = m[i].match(attregex2);
  /*:: if(!y || !y[2]) continue; */
  		if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
  		else {
  			if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
  			else w = y[1].slice(j+1);
  			z[w] = y[2].slice(1,y[2].length-1);
  		}
  	}
  	return z;
  }

  // ----

  /* map from xlml named formats to SSF TODO: localize */
  var XLMLFormatMap/*: {[string]:string}*/;

  function xlml_format(format, value)/*:string*/ {
  	var fmt = XLMLFormatMap[format] || unescapexml(format);
  	if(fmt === "General") return SSF_general(value);
  	return SSF_format(fmt, value);
  }

  function xlml_set_custprop(Custprops, key, cp, val/*:string*/) {
  	var oval/*:any*/ = val;
  	switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
  		case "boolean": oval = parsexmlbool(val); break;
  		case "i2": case "int": oval = parseInt(val, 10); break;
  		case "r4": case "float": oval = parseFloat(val); break;
  		case "date": case "dateTime.tz": oval = parseDate(val); break;
  		case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
  		default: throw new Error("bad custprop:" + cp[0]);
  	}
  	Custprops[unescapexml(key)] = oval;
  }

  function safe_format_xlml(cell/*:Cell*/, nf, o) {
  	if(cell.t === 'z') return;
  	if(!o || o.cellText !== false) try {
  		if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
  		else if(nf === "General") {
  			if(cell.t === 'n') {
  				if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
  				else cell.w = SSF_general_num(cell.v);
  			}
  			else cell.w = SSF_general(cell.v);
  		}
  		else cell.w = xlml_format(nf||"General", cell.v);
  	} catch(e) { if(o.WTF) throw e; }
  	try {
  		var z = XLMLFormatMap[nf]||nf||"General";
  		if(o.cellNF) cell.z = z;
  		if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
  			var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
  		}
  	} catch(e) { if(o.WTF) throw e; }
  }

  function process_style_xlml(styles, stag, opts) {
  	if(opts.cellStyles) {
  		if(stag.Interior) {
  			var I = stag.Interior;
  			if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
  		}
  	}
  	styles[stag.ID] = stag;
  }

  /* TODO: there must exist some form of OSP-blessed spec */
  function parse_xlml_data(xml, ss, data, cell/*:any*/, base, styles, csty, row, arrayf, o) {
  	var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
  	var interiors = [];
  	var i = 0;
  	if(sid === undefined && row) sid = row.StyleID;
  	if(sid === undefined && csty) sid = csty.StyleID;
  	while(styles[sid] !== undefined) {
  		if(styles[sid].nf) nf = styles[sid].nf;
  		if(styles[sid].Interior) interiors.push(styles[sid].Interior);
  		if(!styles[sid].Parent) break;
  		sid = styles[sid].Parent;
  	}
  	switch(data.Type) {
  		case 'Boolean':
  			cell.t = 'b';
  			cell.v = parsexmlbool(xml);
  			break;
  		case 'String':
  			cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
  			cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
  			break;
  		case 'DateTime':
  			if(xml.slice(-1) != "Z") xml += "Z";
  			cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
  			if(cell.v !== cell.v) cell.v = unescapexml(xml);
  			else if(cell.v<60) cell.v = cell.v -1;
  			if(!nf || nf == "General") nf = "yyyy-mm-dd";
  			/* falls through */
  		case 'Number':
  			if(cell.v === undefined) cell.v=+xml;
  			if(!cell.t) cell.t = 'n';
  			break;
  		case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
  		default:
  			if(xml == "" && ss == "") { cell.t = 'z'; }
  			else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
  			break;
  	}
  	safe_format_xlml(cell, nf, o);
  	if(o.cellFormula !== false) {
  		if(cell.Formula) {
  			var fstr = unescapexml(cell.Formula);
  			/* strictly speaking, the leading = is required but some writers omit */
  			if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
  			cell.f = rc_to_a1(fstr, base);
  			delete cell.Formula;
  			if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
  			else if(cell.ArrayRange) {
  				cell.F = rc_to_a1(cell.ArrayRange, base);
  				arrayf.push([safe_decode_range(cell.F), cell.F]);
  			}
  		} else {
  			for(i = 0; i < arrayf.length; ++i)
  				if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
  					if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
  						cell.F = arrayf[i][1];
  		}
  	}
  	if(o.cellStyles) {
  		interiors.forEach(function(x) {
  			if(!S.patternType && x.patternType) S.patternType = x.patternType;
  		});
  		cell.s = S;
  	}
  	if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
  }

  function xlml_clean_comment(comment/*:any*/) {
  	comment.t = comment.v || "";
  	comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
  	comment.v = comment.w = comment.ixfe = undefined;
  }

  /* TODO: Everything */
  function parse_xlml_xml(d, _opts)/*:Workbook*/ {
  	var opts = _opts || {};
  	make_ssf();
  	var str = debom(xlml_normalize(d));
  	if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
  		str = utf8read(str);
  	}
  	var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
  	opening = opening.replace(/".*?"/g, "");
  	if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
  	if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
  	if(ishtml) return html_to_workbook(str, opts);

  	XLMLFormatMap = ({
  		"General Number": "General",
  		"General Date": table_fmt[22],
  		"Long Date": "dddd, mmmm dd, yyyy",
  		"Medium Date": table_fmt[15],
  		"Short Date": table_fmt[14],
  		"Long Time": table_fmt[19],
  		"Medium Time": table_fmt[18],
  		"Short Time": table_fmt[20],
  		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  		"Fixed": table_fmt[2],
  		"Standard": table_fmt[4],
  		"Percent": table_fmt[10],
  		"Scientific": table_fmt[11],
  		"Yes/No": '"Yes";"Yes";"No";@',
  		"True/False": '"True";"True";"False";@',
  		"On/Off": '"Yes";"Yes";"No";@'
  	}/*:any*/);


  	var Rn;
  	var state = [], tmp;
  	var sheets = {}, sheetnames/*:Array<string>*/ = [], cursheet/*:Worksheet*/ = (opts.dense ? [] : {}), sheetname = "";
  	var cell = ({}/*:any*/), row = {};// eslint-disable-line no-unused-vars
  	var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
  	var c = 0, r = 0;
  	var refguess/*:Range*/ = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
  	var styles = {}, stag = {};
  	var ss = "", fidx = 0;
  	var merges/*:Array<Range>*/ = [];
  	var Props = {}, Custprops = {}, pidx = 0, cp = [];
  	var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
  	var cstys = [], csty, seencol = false;
  	var arrayf/*:Array<[Range, string]>*/ = [];
  	var rowinfo/*:Array<RowInfo>*/ = [], rowobj = {}, cc = 0, rr = 0;
  	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false} }/*:any*/), wsprops = {};
  	xlmlregex.lastIndex = 0;
  	str = str.replace(/<!--([\s\S]*?)-->/mg,"");
  	var raw_Rn3 = "";
  	while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
  		case 'data' /*case 'Data'*/:
  			if(raw_Rn3 == "data") {
  				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
  				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
  				break;
  			}
  			if(state[state.length-1][1]) break;
  			if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
  			else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
  			break;
  		case 'cell' /*case 'Cell'*/:
  			if(Rn[1]==='/'){
  				if(comments.length > 0) cell.c = comments;
  				if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
  					if(opts.dense) {
  						if(!cursheet[r]) cursheet[r] = [];
  						cursheet[r][c] = cell;
  					} else cursheet[encode_col(c) + encode_row(r)] = cell;
  				}
  				if(cell.HRef) {
  					cell.l = ({Target:unescapexml(cell.HRef)}/*:any*/);
  					if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
  					delete cell.HRef; delete cell.HRefScreenTip;
  				}
  				if(cell.MergeAcross || cell.MergeDown) {
  					cc = c + (parseInt(cell.MergeAcross,10)|0);
  					rr = r + (parseInt(cell.MergeDown,10)|0);
  					merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
  				}
  				if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
  				else if(cell.MergeAcross || cell.MergeDown) {
  					/*:: if(!cc) cc = 0; if(!rr) rr = 0; */
  					for(var cma = c; cma <= cc; ++cma) {
  						for(var cmd = r; cmd <= rr; ++cmd) {
  							if(cma > c || cmd > r) {
  								if(opts.dense) {
  									if(!cursheet[cmd]) cursheet[cmd] = [];
  									cursheet[cmd][cma] = {t:'z'};
  								} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
  							}
  						}
  					}
  					c = cc + 1;
  				}
  				else ++c;
  			} else {
  				cell = xlml_parsexmltagobj(Rn[0]);
  				if(cell.Index) c = +cell.Index - 1;
  				if(c < refguess.s.c) refguess.s.c = c;
  				if(c > refguess.e.c) refguess.e.c = c;
  				if(Rn[0].slice(-2) === "/>") ++c;
  				comments = [];
  			}
  			break;
  		case 'row' /*case 'Row'*/:
  			if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
  				if(r < refguess.s.r) refguess.s.r = r;
  				if(r > refguess.e.r) refguess.e.r = r;
  				if(Rn[0].slice(-2) === "/>") {
  					row = xlml_parsexmltag(Rn[0]);
  					if(row.Index) r = +row.Index - 1;
  				}
  				c = 0; ++r;
  			} else {
  				row = xlml_parsexmltag(Rn[0]);
  				if(row.Index) r = +row.Index - 1;
  				rowobj = {};
  				if(row.AutoFitHeight == "0" || row.Height) {
  					rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
  					rowinfo[r] = rowobj;
  				}
  				if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
  			}
  			break;
  		case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
  			if(Rn[1]==='/'){
  				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
  				sheetnames.push(sheetname);
  				if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
  					cursheet["!ref"] = encode_range(refguess);
  					if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
  						cursheet["!fullref"] = cursheet["!ref"];
  						refguess.e.r = opts.sheetRows - 1;
  						cursheet["!ref"] = encode_range(refguess);
  					}
  				}
  				if(merges.length) cursheet["!merges"] = merges;
  				if(cstys.length > 0) cursheet["!cols"] = cstys;
  				if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
  				sheets[sheetname] = cursheet;
  			} else {
  				refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
  				r = c = 0;
  				state.push([Rn[3], false]);
  				tmp = xlml_parsexmltag(Rn[0]);
  				sheetname = unescapexml(tmp.Name);
  				cursheet = (opts.dense ? [] : {});
  				merges = [];
  				arrayf = [];
  				rowinfo = [];
  				wsprops = {name:sheetname, Hidden:0};
  				Workbook.Sheets.push(wsprops);
  			}
  			break;
  		case 'table' /*case 'Table'*/:
  			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
  			else if(Rn[0].slice(-2) == "/>") break;
  			else {
  				state.push([Rn[3], false]);
  				cstys = []; seencol = false;
  			}
  			break;

  		case 'style' /*case 'Style'*/:
  			if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
  			else stag = xlml_parsexmltag(Rn[0]);
  			break;

  		case 'numberformat' /*case 'NumberFormat'*/:
  			stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
  			if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
  			for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
  			if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
  			break;

  		case 'column' /*case 'Column'*/:
  			if(state[state.length-1][0] !== /*'Table'*/'table') break;
  			csty = xlml_parsexmltag(Rn[0]);
  			if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
  			if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
  			if(!seencol && csty.wpx > 10) {
  				seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
  				for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
  			}
  			if(seencol) process_col(csty);
  			cstys[(csty.Index-1||cstys.length)] = csty;
  			for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
  			break;

  		case 'namedrange' /*case 'NamedRange'*/:
  			if(Rn[1]==='/') break;
  			if(!Workbook.Names) Workbook.Names = [];
  			var _NamedRange = parsexmltag(Rn[0]);
  			var _DefinedName/*:DefinedName*/ = ({
  				Name: _NamedRange.Name,
  				Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
  			}/*:any*/);
  			if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
  			/*:: if(Workbook.Names) */Workbook.Names.push(_DefinedName);
  			break;

  		case 'namedcell' /*case 'NamedCell'*/: break;
  		case 'b' /*case 'B'*/: break;
  		case 'i' /*case 'I'*/: break;
  		case 'u' /*case 'U'*/: break;
  		case 's' /*case 'S'*/: break;
  		case 'em' /*case 'EM'*/: break;
  		case 'h2' /*case 'H2'*/: break;
  		case 'h3' /*case 'H3'*/: break;
  		case 'sub' /*case 'Sub'*/: break;
  		case 'sup' /*case 'Sup'*/: break;
  		case 'span' /*case 'Span'*/: break;
  		case 'alignment' /*case 'Alignment'*/:
  			break;
  		case 'borders' /*case 'Borders'*/: break;
  		case 'border' /*case 'Border'*/: break;
  		case 'font' /*case 'Font'*/:
  			if(Rn[0].slice(-2) === "/>") break;
  			else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
  			else fidx = Rn.index + Rn[0].length;
  			break;
  		case 'interior' /*case 'Interior'*/:
  			if(!opts.cellStyles) break;
  			stag.Interior = xlml_parsexmltag(Rn[0]);
  			break;
  		case 'protection' /*case 'Protection'*/: break;

  		case 'author' /*case 'Author'*/:
  		case 'title' /*case 'Title'*/:
  		case 'description' /*case 'Description'*/:
  		case 'created' /*case 'Created'*/:
  		case 'keywords' /*case 'Keywords'*/:
  		case 'subject' /*case 'Subject'*/:
  		case 'category' /*case 'Category'*/:
  		case 'company' /*case 'Company'*/:
  		case 'lastauthor' /*case 'LastAuthor'*/:
  		case 'lastsaved' /*case 'LastSaved'*/:
  		case 'lastprinted' /*case 'LastPrinted'*/:
  		case 'version' /*case 'Version'*/:
  		case 'revision' /*case 'Revision'*/:
  		case 'totaltime' /*case 'TotalTime'*/:
  		case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
  		case 'manager' /*case 'Manager'*/:
  		case 'contentstatus' /*case 'ContentStatus'*/:
  		case 'identifier' /*case 'Identifier'*/:
  		case 'language' /*case 'Language'*/:
  		case 'appname' /*case 'AppName'*/:
  			if(Rn[0].slice(-2) === "/>") break;
  			else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
  			else pidx = Rn.index + Rn[0].length;
  			break;
  		case 'paragraphs' /*case 'Paragraphs'*/: break;

  		case 'styles' /*case 'Styles'*/:
  		case 'workbook' /*case 'Workbook'*/:
  			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
  			else state.push([Rn[3], false]);
  			break;

  		case 'comment' /*case 'Comment'*/:
  			if(Rn[1]==='/'){
  				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
  				xlml_clean_comment(comment);
  				comments.push(comment);
  			} else {
  				state.push([Rn[3], false]);
  				tmp = xlml_parsexmltag(Rn[0]);
  				comment = ({a:tmp.Author}/*:any*/);
  			}
  			break;

  		case 'autofilter' /*case 'AutoFilter'*/:
  			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
  			else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
  				var AutoFilter = xlml_parsexmltag(Rn[0]);
  				cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
  				state.push([Rn[3], true]);
  			}
  			break;

  		case 'name' /*case 'Name'*/: break;

  		case 'datavalidation' /*case 'DataValidation'*/:
  			if(Rn[1]==='/'){
  				if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
  			} else {
  				if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
  			}
  			break;

  		case 'pixelsperinch' /*case 'PixelsPerInch'*/:
  			break;
  		case 'componentoptions' /*case 'ComponentOptions'*/:
  		case 'documentproperties' /*case 'DocumentProperties'*/:
  		case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
  		case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
  		case 'pivottable' /*case 'PivotTable'*/:
  		case 'pivotcache' /*case 'PivotCache'*/:
  		case 'names' /*case 'Names'*/:
  		case 'mapinfo' /*case 'MapInfo'*/:
  		case 'pagebreaks' /*case 'PageBreaks'*/:
  		case 'querytable' /*case 'QueryTable'*/:
  		case 'sorting' /*case 'Sorting'*/:
  		case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
  		case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
  		case 'smarttagtype' /*case 'SmartTagType'*/:
  		case 'smarttags' /*case 'SmartTags'*/:
  		case 'excelworkbook' /*case 'ExcelWorkbook'*/:
  		case 'workbookoptions' /*case 'WorkbookOptions'*/:
  		case 'worksheetoptions' /*case 'WorksheetOptions'*/:
  			if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
  			else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
  			break;

  		case 'null' /*case 'Null'*/: break;

  		default:
  			/* FODS file root is <office:document> */
  			if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
  			/* UOS file root is <uof:UOF> */
  			if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);

  			var seen = true;
  			switch(state[state.length-1][0]) {
  				/* OfficeDocumentSettings */
  				case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
  					case 'allowpng' /*case 'AllowPNG'*/: break;
  					case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
  					case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
  					case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
  					case 'colors' /*case 'Colors'*/: break;
  					case 'color' /*case 'Color'*/: break;
  					case 'index' /*case 'Index'*/: break;
  					case 'rgb' /*case 'RGB'*/: break;
  					case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
  					case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
  					default: seen = false;
  				} break;

  				/* ComponentOptions */
  				case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
  					case 'toolbar' /*case 'Toolbar'*/: break;
  					case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
  					case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
  					case 'label' /*case 'Label'*/: break;
  					case 'caption' /*case 'Caption'*/: break;
  					case 'maxheight' /*case 'MaxHeight'*/: break;
  					case 'maxwidth' /*case 'MaxWidth'*/: break;
  					case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
  					default: seen = false;
  				} break;

  				/* ExcelWorkbook */
  				case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
  					case 'date1904' /*case 'Date1904'*/:
  						/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
  						Workbook.WBProps.date1904 = true;
  						break;
  					case 'windowheight' /*case 'WindowHeight'*/: break;
  					case 'windowwidth' /*case 'WindowWidth'*/: break;
  					case 'windowtopx' /*case 'WindowTopX'*/: break;
  					case 'windowtopy' /*case 'WindowTopY'*/: break;
  					case 'tabratio' /*case 'TabRatio'*/: break;
  					case 'protectstructure' /*case 'ProtectStructure'*/: break;
  					case 'protectwindow' /*case 'ProtectWindow'*/: break;
  					case 'protectwindows' /*case 'ProtectWindows'*/: break;
  					case 'activesheet' /*case 'ActiveSheet'*/: break;
  					case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
  					case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
  					case 'supbook' /*case 'SupBook'*/: break;
  					case 'sheetname' /*case 'SheetName'*/: break;
  					case 'sheetindex' /*case 'SheetIndex'*/: break;
  					case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
  					case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
  					case 'dll' /*case 'Dll'*/: break;
  					case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
  					case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
  					case 'iteration' /*case 'Iteration'*/: break;
  					case 'maxiterations' /*case 'MaxIterations'*/: break;
  					case 'maxchange' /*case 'MaxChange'*/: break;
  					case 'path' /*case 'Path'*/: break;
  					case 'xct' /*case 'Xct'*/: break;
  					case 'count' /*case 'Count'*/: break;
  					case 'selectedsheets' /*case 'SelectedSheets'*/: break;
  					case 'calculation' /*case 'Calculation'*/: break;
  					case 'uncalced' /*case 'Uncalced'*/: break;
  					case 'startupprompt' /*case 'StartupPrompt'*/: break;
  					case 'crn' /*case 'Crn'*/: break;
  					case 'externname' /*case 'ExternName'*/: break;
  					case 'formula' /*case 'Formula'*/: break;
  					case 'colfirst' /*case 'ColFirst'*/: break;
  					case 'collast' /*case 'ColLast'*/: break;
  					case 'wantadvise' /*case 'WantAdvise'*/: break;
  					case 'boolean' /*case 'Boolean'*/: break;
  					case 'error' /*case 'Error'*/: break;
  					case 'text' /*case 'Text'*/: break;
  					case 'ole' /*case 'OLE'*/: break;
  					case 'noautorecover' /*case 'NoAutoRecover'*/: break;
  					case 'publishobjects' /*case 'PublishObjects'*/: break;
  					case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
  					case 'number' /*case 'Number'*/: break;
  					case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
  					case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
  					default: seen = false;
  				} break;

  				/* WorkbookOptions */
  				case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
  					case 'owcversion' /*case 'OWCVersion'*/: break;
  					case 'height' /*case 'Height'*/: break;
  					case 'width' /*case 'Width'*/: break;
  					default: seen = false;
  				} break;

  				/* WorksheetOptions */
  				case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
  					case 'visible' /*case 'Visible'*/:
  						if(Rn[0].slice(-2) === "/>");
  						else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
  							case "SheetHidden": wsprops.Hidden = 1; break;
  							case "SheetVeryHidden": wsprops.Hidden = 2; break;
  						}
  						else pidx = Rn.index + Rn[0].length;
  						break;
  					case 'header' /*case 'Header'*/:
  						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
  						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
  						break;
  					case 'footer' /*case 'Footer'*/:
  						if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
  						if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
  						break;
  					case 'pagemargins' /*case 'PageMargins'*/:
  						var pagemargins = parsexmltag(Rn[0]);
  						if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
  						if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
  						if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
  						if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
  						if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
  						break;
  					case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
  						if(!Workbook.Views) Workbook.Views = [];
  						if(!Workbook.Views[0]) Workbook.Views[0] = {};
  						Workbook.Views[0].RTL = true;
  						break;

  					case 'freezepanes' /*case 'FreezePanes'*/: break;
  					case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;

  					case 'splithorizontal' /*case 'SplitHorizontal'*/:
  					case 'splitvertical' /*case 'SplitVertical'*/:
  						break;

  					case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
  						break;

  					case 'activerow' /*case 'ActiveRow'*/: break;
  					case 'activecol' /*case 'ActiveCol'*/: break;
  					case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
  					case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;

  					case 'unsynced' /*case 'Unsynced'*/: break;
  					case 'print' /*case 'Print'*/: break;
  					case 'printerrors' /*case 'PrintErrors'*/: break;
  					case 'panes' /*case 'Panes'*/: break;
  					case 'scale' /*case 'Scale'*/: break;
  					case 'pane' /*case 'Pane'*/: break;
  					case 'number' /*case 'Number'*/: break;
  					case 'layout' /*case 'Layout'*/: break;
  					case 'pagesetup' /*case 'PageSetup'*/: break;
  					case 'selected' /*case 'Selected'*/: break;
  					case 'protectobjects' /*case 'ProtectObjects'*/: break;
  					case 'enableselection' /*case 'EnableSelection'*/: break;
  					case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
  					case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
  					case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
  					case 'verticalresolution' /*case 'VerticalResolution'*/: break;
  					case 'numberofcopies' /*case 'NumberofCopies'*/: break;
  					case 'activepane' /*case 'ActivePane'*/: break;
  					case 'toprowvisible' /*case 'TopRowVisible'*/: break;
  					case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
  					case 'fittopage' /*case 'FitToPage'*/: break;
  					case 'rangeselection' /*case 'RangeSelection'*/: break;
  					case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
  					case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
  					case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
  					case 'filteron' /*case 'FilterOn'*/: break;
  					case 'fitwidth' /*case 'FitWidth'*/: break;
  					case 'fitheight' /*case 'FitHeight'*/: break;
  					case 'commentslayout' /*case 'CommentsLayout'*/: break;
  					case 'zoom' /*case 'Zoom'*/: break;
  					case 'lefttoright' /*case 'LeftToRight'*/: break;
  					case 'gridlines' /*case 'Gridlines'*/: break;
  					case 'allowsort' /*case 'AllowSort'*/: break;
  					case 'allowfilter' /*case 'AllowFilter'*/: break;
  					case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
  					case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
  					case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
  					case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
  					case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
  					case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
  					case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
  					case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
  					case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
  						if(!cursheet["!outline"]) cursheet["!outline"] = {};
  						cursheet["!outline"].above = true;
  						break;
  					case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
  					case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
  					case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
  					case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
  						if(!cursheet["!outline"]) cursheet["!outline"] = {};
  						cursheet["!outline"].left = true;
  						break;
  					case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
  					case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
  					case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
  					case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
  					case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
  					case 'noorientation' /*case 'NoOrientation'*/: break;
  					case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
  					case 'zeroheight' /*case 'ZeroHeight'*/: break;
  					case 'viewablerange' /*case 'ViewableRange'*/: break;
  					case 'selection' /*case 'Selection'*/: break;
  					case 'protectcontents' /*case 'ProtectContents'*/: break;
  					default: seen = false;
  				} break;

  				/* PivotTable */
  				case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
  					case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
  					case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
  					case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
  					case 'location' /*case 'Location'*/: break;
  					case 'pivotfield' /*case 'PivotField'*/: break;
  					case 'orientation' /*case 'Orientation'*/: break;
  					case 'layoutform' /*case 'LayoutForm'*/: break;
  					case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
  					case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
  					case 'position' /*case 'Position'*/: break;
  					case 'pivotitem' /*case 'PivotItem'*/: break;
  					case 'datatype' /*case 'DataType'*/: break;
  					case 'datafield' /*case 'DataField'*/: break;
  					case 'sourcename' /*case 'SourceName'*/: break;
  					case 'parentfield' /*case 'ParentField'*/: break;
  					case 'ptlineitems' /*case 'PTLineItems'*/: break;
  					case 'ptlineitem' /*case 'PTLineItem'*/: break;
  					case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
  					case 'item' /*case 'Item'*/: break;
  					case 'itemtype' /*case 'ItemType'*/: break;
  					case 'ptsource' /*case 'PTSource'*/: break;
  					case 'cacheindex' /*case 'CacheIndex'*/: break;
  					case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
  					case 'filename' /*case 'FileName'*/: break;
  					case 'reference' /*case 'Reference'*/: break;
  					case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
  					case 'norowgrand' /*case 'NoRowGrand'*/: break;
  					case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
  					case 'hidden' /*case 'Hidden'*/: break;
  					case 'subtotal' /*case 'Subtotal'*/: break;
  					case 'basefield' /*case 'BaseField'*/: break;
  					case 'mapchilditems' /*case 'MapChildItems'*/: break;
  					case 'function' /*case 'Function'*/: break;
  					case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
  					case 'printsettitles' /*case 'PrintSetTitles'*/: break;
  					case 'mergelabels' /*case 'MergeLabels'*/: break;
  					case 'defaultversion' /*case 'DefaultVersion'*/: break;
  					case 'refreshname' /*case 'RefreshName'*/: break;
  					case 'refreshdate' /*case 'RefreshDate'*/: break;
  					case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
  					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
  					case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
  					case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
  					case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
  					case 'calculation' /*case 'Calculation'*/: break;
  					default: seen = false;
  				} break;

  				/* PageBreaks */
  				case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
  					case 'colbreaks' /*case 'ColBreaks'*/: break;
  					case 'colbreak' /*case 'ColBreak'*/: break;
  					case 'rowbreaks' /*case 'RowBreaks'*/: break;
  					case 'rowbreak' /*case 'RowBreak'*/: break;
  					case 'colstart' /*case 'ColStart'*/: break;
  					case 'colend' /*case 'ColEnd'*/: break;
  					case 'rowend' /*case 'RowEnd'*/: break;
  					default: seen = false;
  				} break;

  				/* AutoFilter */
  				case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
  					case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
  					case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
  					case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
  					case 'autofilteror' /*case 'AutoFilterOr'*/: break;
  					default: seen = false;
  				} break;

  				/* QueryTable */
  				case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
  					case 'id' /*case 'Id'*/: break;
  					case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
  					case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
  					case 'querysource' /*case 'QuerySource'*/: break;
  					case 'querytype' /*case 'QueryType'*/: break;
  					case 'enableredirections' /*case 'EnableRedirections'*/: break;
  					case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
  					case 'urlstring' /*case 'URLString'*/: break;
  					case 'htmltables' /*case 'HTMLTables'*/: break;
  					case 'connection' /*case 'Connection'*/: break;
  					case 'commandtext' /*case 'CommandText'*/: break;
  					case 'refreshinfo' /*case 'RefreshInfo'*/: break;
  					case 'notitles' /*case 'NoTitles'*/: break;
  					case 'nextid' /*case 'NextId'*/: break;
  					case 'columninfo' /*case 'ColumnInfo'*/: break;
  					case 'overwritecells' /*case 'OverwriteCells'*/: break;
  					case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
  					case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
  					case 'source' /*case 'Source'*/: break;
  					case 'number' /*case 'Number'*/: break;
  					case 'decimal' /*case 'Decimal'*/: break;
  					case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
  					case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
  					case 'formatsettings' /*case 'FormatSettings'*/: break;
  					case 'fieldtype' /*case 'FieldType'*/: break;
  					case 'delimiters' /*case 'Delimiters'*/: break;
  					case 'tab' /*case 'Tab'*/: break;
  					case 'comma' /*case 'Comma'*/: break;
  					case 'autoformatname' /*case 'AutoFormatName'*/: break;
  					case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
  					case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
  					default: seen = false;
  				} break;

  				case 'datavalidation' /*case 'DataValidation'*/:
  				switch(Rn[3]) {
  					case 'range' /*case 'Range'*/: break;

  					case 'type' /*case 'Type'*/: break;
  					case 'min' /*case 'Min'*/: break;
  					case 'max' /*case 'Max'*/: break;
  					case 'sort' /*case 'Sort'*/: break;
  					case 'descending' /*case 'Descending'*/: break;
  					case 'order' /*case 'Order'*/: break;
  					case 'casesensitive' /*case 'CaseSensitive'*/: break;
  					case 'value' /*case 'Value'*/: break;
  					case 'errorstyle' /*case 'ErrorStyle'*/: break;
  					case 'errormessage' /*case 'ErrorMessage'*/: break;
  					case 'errortitle' /*case 'ErrorTitle'*/: break;
  					case 'inputmessage' /*case 'InputMessage'*/: break;
  					case 'inputtitle' /*case 'InputTitle'*/: break;
  					case 'combohide' /*case 'ComboHide'*/: break;
  					case 'inputhide' /*case 'InputHide'*/: break;
  					case 'condition' /*case 'Condition'*/: break;
  					case 'qualifier' /*case 'Qualifier'*/: break;
  					case 'useblank' /*case 'UseBlank'*/: break;
  					case 'value1' /*case 'Value1'*/: break;
  					case 'value2' /*case 'Value2'*/: break;
  					case 'format' /*case 'Format'*/: break;

  					case 'cellrangelist' /*case 'CellRangeList'*/: break;
  					default: seen = false;
  				} break;

  				case 'sorting' /*case 'Sorting'*/:
  				case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
  				switch(Rn[3]) {
  					case 'range' /*case 'Range'*/: break;
  					case 'type' /*case 'Type'*/: break;
  					case 'min' /*case 'Min'*/: break;
  					case 'max' /*case 'Max'*/: break;
  					case 'sort' /*case 'Sort'*/: break;
  					case 'descending' /*case 'Descending'*/: break;
  					case 'order' /*case 'Order'*/: break;
  					case 'casesensitive' /*case 'CaseSensitive'*/: break;
  					case 'value' /*case 'Value'*/: break;
  					case 'errorstyle' /*case 'ErrorStyle'*/: break;
  					case 'errormessage' /*case 'ErrorMessage'*/: break;
  					case 'errortitle' /*case 'ErrorTitle'*/: break;
  					case 'cellrangelist' /*case 'CellRangeList'*/: break;
  					case 'inputmessage' /*case 'InputMessage'*/: break;
  					case 'inputtitle' /*case 'InputTitle'*/: break;
  					case 'combohide' /*case 'ComboHide'*/: break;
  					case 'inputhide' /*case 'InputHide'*/: break;
  					case 'condition' /*case 'Condition'*/: break;
  					case 'qualifier' /*case 'Qualifier'*/: break;
  					case 'useblank' /*case 'UseBlank'*/: break;
  					case 'value1' /*case 'Value1'*/: break;
  					case 'value2' /*case 'Value2'*/: break;
  					case 'format' /*case 'Format'*/: break;
  					default: seen = false;
  				} break;

  				/* MapInfo (schema) */
  				case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
  					case 'map' /*case 'Map'*/: break;
  					case 'entry' /*case 'Entry'*/: break;
  					case 'range' /*case 'Range'*/: break;
  					case 'xpath' /*case 'XPath'*/: break;
  					case 'field' /*case 'Field'*/: break;
  					case 'xsdtype' /*case 'XSDType'*/: break;
  					case 'filteron' /*case 'FilterOn'*/: break;
  					case 'aggregate' /*case 'Aggregate'*/: break;
  					case 'elementtype' /*case 'ElementType'*/: break;
  					case 'attributetype' /*case 'AttributeType'*/: break;
  				/* These are from xsd (XML Schema Definition) */
  					case 'schema' /*case 'schema'*/:
  					case 'element' /*case 'element'*/:
  					case 'complextype' /*case 'complexType'*/:
  					case 'datatype' /*case 'datatype'*/:
  					case 'all' /*case 'all'*/:
  					case 'attribute' /*case 'attribute'*/:
  					case 'extends' /*case 'extends'*/: break;

  					case 'row' /*case 'row'*/: break;
  					default: seen = false;
  				} break;

  				/* SmartTags (can be anything) */
  				case 'smarttags' /*case 'SmartTags'*/: break;

  				default: seen = false; break;
  			}
  			if(seen) break;
  			/* CustomDocumentProperties */
  			if(Rn[3].match(/!\[CDATA/)) break;
  			if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
  			if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
  				if(Rn[0].slice(-2) === "/>") break;
  				else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
  				else { cp = Rn; pidx = Rn.index + Rn[0].length; }
  				break;
  			}
  			if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
  	}
  	var out = ({}/*:any*/);
  	if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
  	out.SheetNames = sheetnames;
  	out.Workbook = Workbook;
  	out.SSF = dup(table_fmt);
  	out.Props = Props;
  	out.Custprops = Custprops;
  	return out;
  }

  function parse_xlml(data/*:RawBytes|string*/, opts)/*:Workbook*/ {
  	fix_read_opts(opts=opts||{});
  	switch(opts.type||"base64") {
  		case "base64": return parse_xlml_xml(Base64_decode(data), opts);
  		case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
  		case "array": return parse_xlml_xml(a2s(data), opts);
  	}
  	/*:: throw new Error("unsupported type " + opts.type); */
  }
  /* [MS-OLEDS] 2.3.8 CompObjStream */
  function parse_compobj(obj/*:CFBEntry*/) {
  	var v = {};
  	var o = obj.content;
  	/*:: if(o == null) return; */

  	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
  	o.l = 28;

  	v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
  	v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);

  	if(o.length - o.l <= 4) return v;

  	var m/*:number*/ = o.read_shift(4);
  	if(m == 0 || m > 40) return v;
  	o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");

  	if(o.length - o.l <= 4) return v;
  	m = o.read_shift(4);
  	if(m !== 0x71b239f4) return v;
  	v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);

  	m = o.read_shift(4);
  	if(m == 0 || m > 40) return v;
  	o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
  }

  /*
  	Continue logic for:
  	- 2.4.58 Continue          0x003c
  	- 2.4.59 ContinueBigName   0x043c
  	- 2.4.60 ContinueFrt       0x0812
  	- 2.4.61 ContinueFrt11     0x0875
  	- 2.4.62 ContinueFrt12     0x087f
  */
  var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
  function slurp(RecordType, R, blob, length/*:number*/, opts)/*:any*/ {
  	var l = length;
  	var bufs = [];
  	var d = blob.slice(blob.l,blob.l+l);
  	if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
  	case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
  		break;
  	case 0x0085 /* BoundSheet8 */:
  		break;
  	default:
  		opts.enc.insitu(d);
  	}
  	bufs.push(d);
  	blob.l += l;
  	var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
  	var start = 0;
  	while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
  		l = __readUInt16LE(blob,blob.l+2);
  		start = blob.l + 4;
  		if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
  		else if(nextrt == 0x0875 || nextrt == 0x087f) {
  			start += 12;
  		}
  		d = blob.slice(start,blob.l+4+l);
  		bufs.push(d);
  		blob.l += 4+l;
  		next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
  	}
  	var b = (bconcat(bufs)/*:any*/);
  	prep_blob(b, 0);
  	var ll = 0; b.lens = [];
  	for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
  	if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
  	return R.f(b, b.length, opts);
  }

  function safe_format_xf(p/*:any*/, opts/*:ParseOpts*/, date1904/*:?boolean*/) {
  	if(p.t === 'z') return;
  	if(!p.XF) return;
  	var fmtid = 0;
  	try {
  		fmtid = p.z || p.XF.numFmtId || 0;
  		if(opts.cellNF) p.z = table_fmt[fmtid];
  	} catch(e) { if(opts.WTF) throw e; }
  	if(!opts || opts.cellText !== false) try {
  		if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
  		else if(fmtid === 0 || fmtid == "General") {
  			if(p.t === 'n') {
  				if((p.v|0) === p.v) p.w = p.v.toString(10);
  				else p.w = SSF_general_num(p.v);
  			}
  			else p.w = SSF_general(p.v);
  		}
  		else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
  	} catch(e) { if(opts.WTF) throw e; }
  	if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
  		var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
  	}
  }

  function make_cell(val, ixfe, t)/*:Cell*/ {
  	return ({v:val, ixfe:ixfe, t:t}/*:any*/);
  }

  // 2.3.2
  function parse_workbook(blob, options/*:ParseOpts*/)/*:Workbook*/ {
  	var wb = ({opts:{}}/*:any*/);
  	var Sheets = {};
  	var out/*:Worksheet*/ = ((options.dense ? [] : {})/*:any*/);
  	var Directory = {};
  	var range/*:Range*/ = ({}/*:any*/);
  	var last_formula = null;
  	var sst/*:SST*/ = ([]/*:any*/);
  	var cur_sheet = "";
  	var Preamble = {};
  	var lastcell, last_cell = "", cc/*:Cell*/, cmnt, rngC, rngR;
  	var sharedf = {};
  	var arrayf/*:Array<[Range, string]>*/ = [];
  	var temp_val/*:Cell*/;
  	var country;
  	var XFs = []; /* XF records */
  	var palette/*:Array<[number, number, number]>*/ = [];
  	var Workbook/*:WBWBProps*/ = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }/*:any*/), wsprops = {};
  	var get_rgb = function getrgb(icv/*:number*/)/*:[number, number, number]*/ {
  		if(icv < 8) return XLSIcv[icv];
  		if(icv < 64) return palette[icv-8] || XLSIcv[icv];
  		return XLSIcv[icv];
  	};
  	var process_cell_style = function pcs(cell, line/*:any*/, options) {
  		var xfd = line.XF.data;
  		if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
  		line.s = ({}/*:any*/);
  		line.s.patternType = xfd.patternType;
  		var t;
  		if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
  		if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
  	};
  	var addcell = function addcell(cell/*:any*/, line/*:any*/, options/*:any*/) {
  		if(file_depth > 1) return;
  		if(options.sheetRows && cell.r >= options.sheetRows) return;
  		if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
  		delete line.ixfe; delete line.XF;
  		lastcell = cell;
  		last_cell = encode_cell(cell);
  		if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
  		if(cell.r < range.s.r) range.s.r = cell.r;
  		if(cell.c < range.s.c) range.s.c = cell.c;
  		if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
  		if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
  		if(options.cellFormula && line.f) {
  			for(var afi = 0; afi < arrayf.length; ++afi) {
  				if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
  				if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
  				line.F = encode_range(arrayf[afi][0]);
  				if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
  				if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
  				break;
  			}
  		}
  		{
  			if(options.dense) {
  				if(!out[cell.r]) out[cell.r] = [];
  				out[cell.r][cell.c] = line;
  			} else out[last_cell] = line;
  		}
  	};
  	var opts = ({
  		enc: false, // encrypted
  		sbcch: 0, // cch in the preceding SupBook
  		snames: [], // sheetnames
  		sharedf: sharedf, // shared formulae by address
  		arrayf: arrayf, // array formulae array
  		rrtabid: [], // RRTabId
  		lastuser: "", // Last User from WriteAccess
  		biff: 8, // BIFF version
  		codepage: 0, // CP from CodePage record
  		winlocked: 0, // fLockWn from WinProtect
  		cellStyles: !!options && !!options.cellStyles,
  		WTF: !!options && !!options.wtf
  	}/*:any*/);
  	if(options.password) opts.password = options.password;
  	var themes;
  	var merges/*:Array<Range>*/ = [];
  	var objects = [];
  	var colinfo/*:Array<ColInfo>*/ = [], rowinfo/*:Array<RowInfo>*/ = [];
  	var seencol = false;
  	var supbooks = ([]/*:any*/); // 1-indexed, will hold extern names
  	supbooks.SheetNames = opts.snames;
  	supbooks.sharedf = opts.sharedf;
  	supbooks.arrayf = opts.arrayf;
  	supbooks.names = [];
  	supbooks.XTI = [];
  	var last_RT = 0;
  	var file_depth = 0; /* TODO: make a real stack */
  	var BIFF2Fmt = 0, BIFF2FmtTable/*:Array<string>*/ = [];
  	var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
  	var last_lbl/*:?DefinedName*/;

  	/* explicit override for some broken writers */
  	opts.codepage = 1200;
  	set_cp(1200);
  	var seen_codepage = false;
  	while(blob.l < blob.length - 1) {
  		var s = blob.l;
  		var RecordType = blob.read_shift(2);
  		if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
  		var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
  		var R = XLSRecordEnum[RecordType];
  		//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
  		//if(!R) console.log(blob.slice(blob.l, blob.l + length));
  		if(R && R.f) {
  			if(options.bookSheets) {
  				if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
  			}
  			last_RT = RecordType;
  			if(R.r === 2 || R.r == 12) {
  				var rt = blob.read_shift(2); length -= 2;
  				if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
  				if(R.r == 12){
  					blob.l += 10; length -= 10;
  				} // skip FRT
  			}
  			//console.error(R,blob.l,length,blob.length);
  			var val/*:any*/ = ({}/*:any*/);
  			if(RecordType === 0x000a /* EOF */) val = /*::(*/R.f(blob, length, opts)/*:: :any)*/;
  			else val = /*::(*/slurp(RecordType, R, blob, length, opts)/*:: :any)*/;
  			/*:: val = (val:any); */
  			if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
  			switch(RecordType) {
  				case 0x0022 /* Date1904 */:
  					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
  					wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
  				case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
  				case 0x002f /* FilePass */:
  					if(!opts.enc) blob.l = 0;
  					opts.enc = val;
  					if(!options.password) throw new Error("File is password-protected");
  					if(val.valid == null) throw new Error("Encryption scheme unsupported");
  					if(!val.valid) throw new Error("Password is incorrect");
  					break;
  				case 0x005c /* WriteAccess */: opts.lastuser = val; break;
  				case 0x0042 /* CodePage */:
  					var cpval = Number(val);
  					/* overrides based on test cases */
  					switch(cpval) {
  						case 0x5212: cpval =  1200; break;
  						case 0x8000: cpval = 10000; break;
  						case 0x8001: cpval =  1252; break;
  					}
  					set_cp(opts.codepage = cpval);
  					seen_codepage = true;
  					break;
  				case 0x013d /* RRTabId */: opts.rrtabid = val; break;
  				case 0x0019 /* WinProtect */: opts.winlocked = val; break;
  				case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
  				case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
  				case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
  				case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
  				case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
  				case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
  				case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
  				case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
  				case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
  				case 0x0081 /* WsBool */:
  					if(val.fDialog) out["!type"] = "dialog";
  					if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
  					if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
  					break; // TODO
  				case 0x00e0 /* XF */:
  					XFs.push(val); break;
  				case 0x01ae /* SupBook */:
  					supbooks.push([val]);
  					supbooks[supbooks.length-1].XTI = [];
  					break;
  				case 0x0023: case 0x0223 /* ExternName */:
  					supbooks[supbooks.length-1].push(val);
  					break;
  				case 0x0018: case 0x0218 /* Lbl */:
  					last_lbl = ({
  						Name: val.Name,
  						Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
  					}/*:DefinedName*/);
  					if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
  					supbooks.names.push(last_lbl);
  					if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
  					supbooks[supbooks.length-1].push(val);
  					if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
  						if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
  							FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
  					break;
  				case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
  				case 0x0017 /* ExternSheet */:
  					if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
  					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
  				case 0x0894 /* NameCmt */:
  					/* TODO: search for correct name */
  					if(opts.biff < 8) break;
  					if(last_lbl != null) last_lbl.Comment = val[1];
  					break;
  				case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
  				case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
  				case 0x0085 /* BoundSheet8 */: {
  					Directory[val.pos] = val;
  					opts.snames.push(val.name);
  				} break;
  				case 0x000a /* EOF */: {
  					if(--file_depth) break;
  					if(range.e) {
  						if(range.e.r > 0 && range.e.c > 0) {
  							range.e.r--; range.e.c--;
  							out["!ref"] = encode_range(range);
  							if(options.sheetRows && options.sheetRows <= range.e.r) {
  								var tmpri = range.e.r;
  								range.e.r = options.sheetRows - 1;
  								out["!fullref"] = out["!ref"];
  								out["!ref"] = encode_range(range);
  								range.e.r = tmpri;
  							}
  							range.e.r++; range.e.c++;
  						}
  						if(merges.length > 0) out["!merges"] = merges;
  						if(objects.length > 0) out["!objects"] = objects;
  						if(colinfo.length > 0) out["!cols"] = colinfo;
  						if(rowinfo.length > 0) out["!rows"] = rowinfo;
  						Workbook.Sheets.push(wsprops);
  					}
  					if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
  					out = ((options.dense ? [] : {})/*:any*/);
  				} break;
  				case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
  					if(opts.biff === 8) opts.biff = {
  						/*::[*/0x0009/*::]*/:2,
  						/*::[*/0x0209/*::]*/:3,
  						/*::[*/0x0409/*::]*/:4
  					}[RecordType] || {
  						/*::[*/0x0200/*::]*/:2,
  						/*::[*/0x0300/*::]*/:3,
  						/*::[*/0x0400/*::]*/:4,
  						/*::[*/0x0500/*::]*/:5,
  						/*::[*/0x0600/*::]*/:8,
  						/*::[*/0x0002/*::]*/:2,
  						/*::[*/0x0007/*::]*/:2
  					}[val.BIFFVer] || 8;
  					opts.biffguess = val.BIFFVer == 0;
  					if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
  					if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
  					if(file_depth++) break;
  					out = ((options.dense ? [] : {})/*:any*/);

  					if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }

  					if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
  						if(cur_sheet === "") cur_sheet = "Sheet1";
  						range = {s:{r:0,c:0},e:{r:0,c:0}};
  						/* fake BoundSheet8 */
  						var fakebs8 = {pos: blob.l - length, name:cur_sheet};
  						Directory[fakebs8.pos] = fakebs8;
  						opts.snames.push(cur_sheet);
  					}
  					else cur_sheet = (Directory[s] || {name:""}).name;
  					if(val.dt == 0x20) out["!type"] = "chart";
  					if(val.dt == 0x40) out["!type"] = "macro";
  					merges = [];
  					objects = [];
  					opts.arrayf = arrayf = [];
  					colinfo = []; rowinfo = [];
  					seencol = false;
  					wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
  				} break;
  				case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
  					if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
  					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'}/*:any*/);
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  				} break;
  				case 0x0005: case 0x0205 /* BoolErr */: {
  					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t}/*:any*/);
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  				} break;
  				case 0x027e /* RK */: {
  					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'}/*:any*/);
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  				} break;
  				case 0x00bd /* MulRk */: {
  					for(var j = val.c; j <= val.C; ++j) {
  						var ixfe = val.rkrec[j-val.c][0];
  						temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'}/*:any*/);
  						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  						safe_format_xf(temp_val, options, wb.opts.Date1904);
  						addcell({c:j, r:val.r}, temp_val, options);
  					}
  				} break;
  				case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
  					if(val.val == 'String') { last_formula = val; break; }
  					temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
  					temp_val.XF = XFs[temp_val.ixfe];
  					if(options.cellFormula) {
  						var _f = val.formula;
  						if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
  							var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
  							var _fe = encode_cell({r:_fr, c:_fc});
  							if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
  							else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
  						} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
  					}
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell(val.cell, temp_val, options);
  					last_formula = val;
  				} break;
  				case 0x0007: case 0x0207 /* String */: {
  					if(last_formula) { /* technically always true */
  						last_formula.val = val;
  						temp_val = make_cell(val, last_formula.cell.ixfe, 's');
  						temp_val.XF = XFs[temp_val.ixfe];
  						if(options.cellFormula) {
  							temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
  						}
  						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  						safe_format_xf(temp_val, options, wb.opts.Date1904);
  						addcell(last_formula.cell, temp_val, options);
  						last_formula = null;
  					} else throw new Error("String record expects Formula");
  				} break;
  				case 0x0021: case 0x0221 /* Array */: {
  					arrayf.push(val);
  					var _arraystart = encode_cell(val[0].s);
  					cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
  					if(options.cellFormula && cc) {
  						if(!last_formula) break; /* technically unreachable */
  						if(!_arraystart || !cc) break;
  						cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
  						cc.F = encode_range(val[0]);
  					}
  				} break;
  				case 0x04bc /* ShrFmla */: {
  					if(!options.cellFormula) break;
  					if(last_cell) {
  						/* TODO: capture range */
  						if(!last_formula) break; /* technically unreachable */
  						sharedf[encode_cell(last_formula.cell)]= val[0];
  						cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
  						(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
  					}
  				} break;
  				case 0x00fd /* LabelSst */:
  					temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
  					if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
  					temp_val.XF = XFs[temp_val.ixfe];
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  					break;
  				case 0x0201 /* Blank */: if(options.sheetStubs) {
  					temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'}/*:any*/);
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  				} break;
  				case 0x00be /* MulBlank */: if(options.sheetStubs) {
  					for(var _j = val.c; _j <= val.C; ++_j) {
  						var _ixfe = val.ixfe[_j-val.c];
  						temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'}/*:any*/);
  						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  						safe_format_xf(temp_val, options, wb.opts.Date1904);
  						addcell({c:_j, r:val.r}, temp_val, options);
  					}
  				} break;
  				case 0x00d6 /* RString */:
  				case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
  					temp_val=make_cell(val.val, val.ixfe, 's');
  					temp_val.XF = XFs[temp_val.ixfe];
  					if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
  					safe_format_xf(temp_val, options, wb.opts.Date1904);
  					addcell({c:val.c, r:val.r}, temp_val, options);
  					break;

  				case 0x0000: case 0x0200 /* Dimensions */: {
  					if(file_depth === 1) range = val; /* TODO: stack */
  				} break;
  				case 0x00fc /* SST */: {
  					sst = val;
  				} break;
  				case 0x041e /* Format */: { /* val = [id, fmt] */
  					if(opts.biff == 4) {
  						BIFF2FmtTable[BIFF2Fmt++] = val[1];
  						for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
  						if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
  					}
  					else SSF_load(val[1], val[0]);
  				} break;
  				case 0x001e /* BIFF2FORMAT */: {
  					BIFF2FmtTable[BIFF2Fmt++] = val;
  					for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
  					if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
  				} break;

  				case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;

  				case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
  				case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
  				case 0x007f /* ImData */: opts.lastobj.ImData = val; break;

  				case 0x01b8 /* HLink */: {
  					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
  						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
  							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
  							if(cc) cc.l = val[1];
  						}
  				} break;
  				case 0x0800 /* HLinkTooltip */: {
  					for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
  						for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
  							cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
  							if(cc && cc.l) cc.l.Tooltip = val[1];
  							}
  				} break;
  				case 0x001c /* Note */: {
  					if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
  					cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
  					var noteobj = objects[val[2]];
  					if(!cc) {
  						if(options.dense) {
  							if(!out[val[0].r]) out[val[0].r] = [];
  							cc = out[val[0].r][val[0].c] = ({t:"z"}/*:any*/);
  						} else {
  							cc = out[encode_cell(val[0])] = ({t:"z"}/*:any*/);
  						}
  						range.e.r = Math.max(range.e.r, val[0].r);
  						range.s.r = Math.min(range.s.r, val[0].r);
  						range.e.c = Math.max(range.e.c, val[0].c);
  						range.s.c = Math.min(range.s.c, val[0].c);
  					}
  					if(!cc.c) cc.c = [];
  					cmnt = {a:val[1],t:noteobj.TxO.t};
  					cc.c.push(cmnt);
  				} break;
  				case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
  				case 0x007d /* ColInfo */: {
  					if(!opts.cellStyles) break;
  					while(val.e >= val.s) {
  						colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
  						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
  						process_col(colinfo[val.e+1]);
  					}
  				} break;
  				case 0x0208 /* Row */: {
  					var rowobj = {};
  					if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
  					if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
  					if(val.hpt) {
  						rowinfo[val.r] = rowobj;
  						rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
  					}
  				} break;
  				case 0x0026 /* LeftMargin */:
  				case 0x0027 /* RightMargin */:
  				case 0x0028 /* TopMargin */:
  				case 0x0029 /* BottomMargin */:
  					if(!out['!margins']) default_margins(out['!margins'] = {});
  					out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
  					break;
  				case 0x00a1 /* Setup */: // TODO
  					if(!out['!margins']) default_margins(out['!margins'] = {});
  					out['!margins'].header = val.header;
  					out['!margins'].footer = val.footer;
  					break;
  				case 0x023e /* Window2 */: // TODO
  					// $FlowIgnore
  					if(val.RTL) Workbook.Views[0].RTL = true;
  					break;
  				case 0x0092 /* Palette */: palette = val; break;
  				case 0x0896 /* Theme */: themes = val; break;
  				case 0x008c /* Country */: country = val; break;
  				case 0x01ba /* CodeName */: {
  					/*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */
  					if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
  					else wsprops.CodeName = val || wsprops.name;
  				} break;
  			}
  		} else {
  			if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
  			blob.l += length;
  		}
  	}
  	wb.SheetNames=keys$1(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
  	if(!options.bookSheets) wb.Sheets=Sheets;
  	if(!wb.SheetNames.length && Preamble["!ref"]) {
  		wb.SheetNames.push("Sheet1");
  		/*jshint -W069 */
  		if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
  		/*jshint +W069 */
  	} else wb.Preamble=Preamble;
  	if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
  	wb.Strings = sst;
  	wb.SSF = dup(table_fmt);
  	if(opts.enc) wb.Encryption = opts.enc;
  	if(themes) wb.Themes = themes;
  	wb.Metadata = {};
  	if(country !== undefined) wb.Metadata.Country = country;
  	if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
  	wb.Workbook = Workbook;
  	return wb;
  }

  /* TODO: split props*/
  var PSCLSID = {
  	SI: "e0859ff2f94f6810ab9108002b27b3d9",
  	DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  	UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
  };
  function parse_xls_props(cfb/*:CFBContainer*/, props, o) {
  	/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
  	var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
  	if(DSI && DSI.size > 0) try {
  		var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
  		for(var d in DocSummary) props[d] = DocSummary[d];
  	} catch(e) {if(o.WTF) throw e;/* empty */}

  	/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
  	var SI = CFB.find(cfb, '/!SummaryInformation');
  	if(SI && SI.size > 0) try {
  		var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
  		for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
  	} catch(e) {if(o.WTF) throw e;/* empty */}

  	if(props.HeadingPairs && props.TitlesOfParts) {
  		load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
  		delete props.HeadingPairs; delete props.TitlesOfParts;
  	}
  }

  function parse_xlscfb(cfb/*:any*/, options/*:?ParseOpts*/)/*:Workbook*/ {
  if(!options) options = {};
  fix_read_opts(options);
  reset_cp();
  if(options.codepage) set_ansi(options.codepage);
  var CompObj/*:?CFBEntry*/, WB/*:?any*/;
  if(cfb.FullPaths) {
  	if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
  	CompObj = CFB.find(cfb, '!CompObj');
  	WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
  } else {
  	switch(options.type) {
  		case 'base64': cfb = s2a(Base64_decode(cfb)); break;
  		case 'binary': cfb = s2a(cfb); break;
  		case 'buffer': break;
  		case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
  	}
  	prep_blob(cfb, 0);
  	WB = ({content: cfb}/*:any*/);
  }
  var /*::CompObjP, */WorkbookP/*:: :Workbook = XLSX.utils.book_new(); */;

  var _data/*:?any*/;
  if(CompObj) /*::CompObjP = */parse_compobj(CompObj);
  if(options.bookProps && !options.bookSheets) WorkbookP = ({}/*:any*/);
  else/*:: if(cfb instanceof CFBContainer) */ {
  	var T = has_buf ? 'buffer' : 'array';
  	if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
  	/* Quattro Pro 7-8 */
  	else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
  	/* Quattro Pro 9 */
  	else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
  	/* Works 4 for Mac */
  	else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
  	else throw new Error("Cannot find Workbook stream");
  	if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
  }

  var props = {};
  if(cfb.FullPaths) parse_xls_props(/*::((*/cfb/*:: :any):CFBContainer)*/, props, options);

  WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
  if(options.bookFiles) WorkbookP.cfb = cfb;
  /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
  return WorkbookP;
  }
  /* [MS-XLSB] 2.3 Record Enumeration */
  var XLSBRecordEnum = {
  	/*::[*/0x0000/*::]*/: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
  	/*::[*/0x0001/*::]*/: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
  	/*::[*/0x0002/*::]*/: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
  	/*::[*/0x0003/*::]*/: { /* n:"BrtCellError", */ f:parse_BrtCellError },
  	/*::[*/0x0004/*::]*/: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
  	/*::[*/0x0005/*::]*/: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
  	/*::[*/0x0006/*::]*/: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
  	/*::[*/0x0007/*::]*/: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
  	/*::[*/0x0008/*::]*/: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
  	/*::[*/0x0009/*::]*/: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
  	/*::[*/0x000A/*::]*/: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
  	/*::[*/0x000B/*::]*/: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
  	/*::[*/0x000C/*::]*/: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
  	/*::[*/0x000D/*::]*/: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
  	/*::[*/0x000E/*::]*/: { /* n:"BrtShortError", */ f:parse_BrtShortError },
  	/*::[*/0x000F/*::]*/: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
  	/*::[*/0x0010/*::]*/: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
  	/*::[*/0x0011/*::]*/: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
  	/*::[*/0x0012/*::]*/: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
  	/*::[*/0x0013/*::]*/: { /* n:"BrtSSTItem", */ f:parse_RichStr },
  	/*::[*/0x0014/*::]*/: { /* n:"BrtPCDIMissing" */ },
  	/*::[*/0x0015/*::]*/: { /* n:"BrtPCDINumber" */ },
  	/*::[*/0x0016/*::]*/: { /* n:"BrtPCDIBoolean" */ },
  	/*::[*/0x0017/*::]*/: { /* n:"BrtPCDIError" */ },
  	/*::[*/0x0018/*::]*/: { /* n:"BrtPCDIString" */ },
  	/*::[*/0x0019/*::]*/: { /* n:"BrtPCDIDatetime" */ },
  	/*::[*/0x001A/*::]*/: { /* n:"BrtPCDIIndex" */ },
  	/*::[*/0x001B/*::]*/: { /* n:"BrtPCDIAMissing" */ },
  	/*::[*/0x001C/*::]*/: { /* n:"BrtPCDIANumber" */ },
  	/*::[*/0x001D/*::]*/: { /* n:"BrtPCDIABoolean" */ },
  	/*::[*/0x001E/*::]*/: { /* n:"BrtPCDIAError" */ },
  	/*::[*/0x001F/*::]*/: { /* n:"BrtPCDIAString" */ },
  	/*::[*/0x0020/*::]*/: { /* n:"BrtPCDIADatetime" */ },
  	/*::[*/0x0021/*::]*/: { /* n:"BrtPCRRecord" */ },
  	/*::[*/0x0022/*::]*/: { /* n:"BrtPCRRecordDt" */ },
  	/*::[*/0x0023/*::]*/: { /* n:"BrtFRTBegin", */ T:1 },
  	/*::[*/0x0024/*::]*/: { /* n:"BrtFRTEnd", */ T:-1 },
  	/*::[*/0x0025/*::]*/: { /* n:"BrtACBegin", */ T:1 },
  	/*::[*/0x0026/*::]*/: { /* n:"BrtACEnd", */ T:-1 },
  	/*::[*/0x0027/*::]*/: { /* n:"BrtName", */ f:parse_BrtName },
  	/*::[*/0x0028/*::]*/: { /* n:"BrtIndexRowBlock" */ },
  	/*::[*/0x002A/*::]*/: { /* n:"BrtIndexBlock" */ },
  	/*::[*/0x002B/*::]*/: { /* n:"BrtFont", */ f:parse_BrtFont },
  	/*::[*/0x002C/*::]*/: { /* n:"BrtFmt", */ f:parse_BrtFmt },
  	/*::[*/0x002D/*::]*/: { /* n:"BrtFill", */ f:parse_BrtFill },
  	/*::[*/0x002E/*::]*/: { /* n:"BrtBorder", */ f:parse_BrtBorder },
  	/*::[*/0x002F/*::]*/: { /* n:"BrtXF", */ f:parse_BrtXF },
  	/*::[*/0x0030/*::]*/: { /* n:"BrtStyle" */ },
  	/*::[*/0x0031/*::]*/: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
  	/*::[*/0x0032/*::]*/: { /* n:"BrtValueMeta" */ },
  	/*::[*/0x0033/*::]*/: { /* n:"BrtMdb" */ f:parse_BrtMdb },
  	/*::[*/0x0034/*::]*/: { /* n:"BrtBeginFmd", */ T:1 },
  	/*::[*/0x0035/*::]*/: { /* n:"BrtEndFmd", */ T:-1 },
  	/*::[*/0x0036/*::]*/: { /* n:"BrtBeginMdx", */ T:1 },
  	/*::[*/0x0037/*::]*/: { /* n:"BrtEndMdx", */ T:-1 },
  	/*::[*/0x0038/*::]*/: { /* n:"BrtBeginMdxTuple", */ T:1 },
  	/*::[*/0x0039/*::]*/: { /* n:"BrtEndMdxTuple", */ T:-1 },
  	/*::[*/0x003A/*::]*/: { /* n:"BrtMdxMbrIstr" */ },
  	/*::[*/0x003B/*::]*/: { /* n:"BrtStr" */ },
  	/*::[*/0x003C/*::]*/: { /* n:"BrtColInfo", */ f:parse_ColInfo },
  	/*::[*/0x003E/*::]*/: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
  	/*::[*/0x003F/*::]*/: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
  	/*::[*/0x0040/*::]*/: { /* n:"BrtDVal", */ f:parse_BrtDVal },
  	/*::[*/0x0041/*::]*/: { /* n:"BrtSxvcellNum" */ },
  	/*::[*/0x0042/*::]*/: { /* n:"BrtSxvcellStr" */ },
  	/*::[*/0x0043/*::]*/: { /* n:"BrtSxvcellBool" */ },
  	/*::[*/0x0044/*::]*/: { /* n:"BrtSxvcellErr" */ },
  	/*::[*/0x0045/*::]*/: { /* n:"BrtSxvcellDate" */ },
  	/*::[*/0x0046/*::]*/: { /* n:"BrtSxvcellNil" */ },
  	/*::[*/0x0080/*::]*/: { /* n:"BrtFileVersion" */ },
  	/*::[*/0x0081/*::]*/: { /* n:"BrtBeginSheet", */ T:1 },
  	/*::[*/0x0082/*::]*/: { /* n:"BrtEndSheet", */ T:-1 },
  	/*::[*/0x0083/*::]*/: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
  	/*::[*/0x0084/*::]*/: { /* n:"BrtEndBook", */ T:-1 },
  	/*::[*/0x0085/*::]*/: { /* n:"BrtBeginWsViews", */ T:1 },
  	/*::[*/0x0086/*::]*/: { /* n:"BrtEndWsViews", */ T:-1 },
  	/*::[*/0x0087/*::]*/: { /* n:"BrtBeginBookViews", */ T:1 },
  	/*::[*/0x0088/*::]*/: { /* n:"BrtEndBookViews", */ T:-1 },
  	/*::[*/0x0089/*::]*/: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
  	/*::[*/0x008A/*::]*/: { /* n:"BrtEndWsView", */ T:-1 },
  	/*::[*/0x008B/*::]*/: { /* n:"BrtBeginCsViews", */ T:1 },
  	/*::[*/0x008C/*::]*/: { /* n:"BrtEndCsViews", */ T:-1 },
  	/*::[*/0x008D/*::]*/: { /* n:"BrtBeginCsView", */ T:1 },
  	/*::[*/0x008E/*::]*/: { /* n:"BrtEndCsView", */ T:-1 },
  	/*::[*/0x008F/*::]*/: { /* n:"BrtBeginBundleShs", */ T:1 },
  	/*::[*/0x0090/*::]*/: { /* n:"BrtEndBundleShs", */ T:-1 },
  	/*::[*/0x0091/*::]*/: { /* n:"BrtBeginSheetData", */ T:1 },
  	/*::[*/0x0092/*::]*/: { /* n:"BrtEndSheetData", */ T:-1 },
  	/*::[*/0x0093/*::]*/: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
  	/*::[*/0x0094/*::]*/: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
  	/*::[*/0x0097/*::]*/: { /* n:"BrtPane", */ f:parse_BrtPane },
  	/*::[*/0x0098/*::]*/: { /* n:"BrtSel" */ },
  	/*::[*/0x0099/*::]*/: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
  	/*::[*/0x009A/*::]*/: { /* n:"BrtWbFactoid" */ },
  	/*::[*/0x009B/*::]*/: { /* n:"BrtFileRecover" */ },
  	/*::[*/0x009C/*::]*/: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
  	/*::[*/0x009D/*::]*/: { /* n:"BrtCalcProp" */ },
  	/*::[*/0x009E/*::]*/: { /* n:"BrtBookView" */ },
  	/*::[*/0x009F/*::]*/: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
  	/*::[*/0x00A0/*::]*/: { /* n:"BrtEndSst", */ T:-1 },
  	/*::[*/0x00A1/*::]*/: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
  	/*::[*/0x00A2/*::]*/: { /* n:"BrtEndAFilter", */ T:-1 },
  	/*::[*/0x00A3/*::]*/: { /* n:"BrtBeginFilterColumn", */ T:1 },
  	/*::[*/0x00A4/*::]*/: { /* n:"BrtEndFilterColumn", */ T:-1 },
  	/*::[*/0x00A5/*::]*/: { /* n:"BrtBeginFilters", */ T:1 },
  	/*::[*/0x00A6/*::]*/: { /* n:"BrtEndFilters", */ T:-1 },
  	/*::[*/0x00A7/*::]*/: { /* n:"BrtFilter" */ },
  	/*::[*/0x00A8/*::]*/: { /* n:"BrtColorFilter" */ },
  	/*::[*/0x00A9/*::]*/: { /* n:"BrtIconFilter" */ },
  	/*::[*/0x00AA/*::]*/: { /* n:"BrtTop10Filter" */ },
  	/*::[*/0x00AB/*::]*/: { /* n:"BrtDynamicFilter" */ },
  	/*::[*/0x00AC/*::]*/: { /* n:"BrtBeginCustomFilters", */ T:1 },
  	/*::[*/0x00AD/*::]*/: { /* n:"BrtEndCustomFilters", */ T:-1 },
  	/*::[*/0x00AE/*::]*/: { /* n:"BrtCustomFilter" */ },
  	/*::[*/0x00AF/*::]*/: { /* n:"BrtAFilterDateGroupItem" */ },
  	/*::[*/0x00B0/*::]*/: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
  	/*::[*/0x00B1/*::]*/: { /* n:"BrtBeginMergeCells", */ T:1 },
  	/*::[*/0x00B2/*::]*/: { /* n:"BrtEndMergeCells", */ T:-1 },
  	/*::[*/0x00B3/*::]*/: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
  	/*::[*/0x00B4/*::]*/: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
  	/*::[*/0x00B5/*::]*/: { /* n:"BrtBeginPCDFields", */ T:1 },
  	/*::[*/0x00B6/*::]*/: { /* n:"BrtEndPCDFields", */ T:-1 },
  	/*::[*/0x00B7/*::]*/: { /* n:"BrtBeginPCDField", */ T:1 },
  	/*::[*/0x00B8/*::]*/: { /* n:"BrtEndPCDField", */ T:-1 },
  	/*::[*/0x00B9/*::]*/: { /* n:"BrtBeginPCDSource", */ T:1 },
  	/*::[*/0x00BA/*::]*/: { /* n:"BrtEndPCDSource", */ T:-1 },
  	/*::[*/0x00BB/*::]*/: { /* n:"BrtBeginPCDSRange", */ T:1 },
  	/*::[*/0x00BC/*::]*/: { /* n:"BrtEndPCDSRange", */ T:-1 },
  	/*::[*/0x00BD/*::]*/: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
  	/*::[*/0x00BE/*::]*/: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
  	/*::[*/0x00BF/*::]*/: { /* n:"BrtBeginPCDIRun", */ T:1 },
  	/*::[*/0x00C0/*::]*/: { /* n:"BrtEndPCDIRun", */ T:-1 },
  	/*::[*/0x00C1/*::]*/: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
  	/*::[*/0x00C2/*::]*/: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
  	/*::[*/0x00C3/*::]*/: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
  	/*::[*/0x00C4/*::]*/: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
  	/*::[*/0x00C5/*::]*/: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
  	/*::[*/0x00C6/*::]*/: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
  	/*::[*/0x00C7/*::]*/: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
  	/*::[*/0x00C8/*::]*/: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
  	/*::[*/0x00C9/*::]*/: { /* n:"BrtBeginExtConnection", */ T:1 },
  	/*::[*/0x00CA/*::]*/: { /* n:"BrtEndExtConnection", */ T:-1 },
  	/*::[*/0x00CB/*::]*/: { /* n:"BrtBeginECDbProps", */ T:1 },
  	/*::[*/0x00CC/*::]*/: { /* n:"BrtEndECDbProps", */ T:-1 },
  	/*::[*/0x00CD/*::]*/: { /* n:"BrtBeginECOlapProps", */ T:1 },
  	/*::[*/0x00CE/*::]*/: { /* n:"BrtEndECOlapProps", */ T:-1 },
  	/*::[*/0x00CF/*::]*/: { /* n:"BrtBeginPCDSConsol", */ T:1 },
  	/*::[*/0x00D0/*::]*/: { /* n:"BrtEndPCDSConsol", */ T:-1 },
  	/*::[*/0x00D1/*::]*/: { /* n:"BrtBeginPCDSCPages", */ T:1 },
  	/*::[*/0x00D2/*::]*/: { /* n:"BrtEndPCDSCPages", */ T:-1 },
  	/*::[*/0x00D3/*::]*/: { /* n:"BrtBeginPCDSCPage", */ T:1 },
  	/*::[*/0x00D4/*::]*/: { /* n:"BrtEndPCDSCPage", */ T:-1 },
  	/*::[*/0x00D5/*::]*/: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
  	/*::[*/0x00D6/*::]*/: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
  	/*::[*/0x00D7/*::]*/: { /* n:"BrtBeginPCDSCSets", */ T:1 },
  	/*::[*/0x00D8/*::]*/: { /* n:"BrtEndPCDSCSets", */ T:-1 },
  	/*::[*/0x00D9/*::]*/: { /* n:"BrtBeginPCDSCSet", */ T:1 },
  	/*::[*/0x00DA/*::]*/: { /* n:"BrtEndPCDSCSet", */ T:-1 },
  	/*::[*/0x00DB/*::]*/: { /* n:"BrtBeginPCDFGroup", */ T:1 },
  	/*::[*/0x00DC/*::]*/: { /* n:"BrtEndPCDFGroup", */ T:-1 },
  	/*::[*/0x00DD/*::]*/: { /* n:"BrtBeginPCDFGItems", */ T:1 },
  	/*::[*/0x00DE/*::]*/: { /* n:"BrtEndPCDFGItems", */ T:-1 },
  	/*::[*/0x00DF/*::]*/: { /* n:"BrtBeginPCDFGRange", */ T:1 },
  	/*::[*/0x00E0/*::]*/: { /* n:"BrtEndPCDFGRange", */ T:-1 },
  	/*::[*/0x00E1/*::]*/: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
  	/*::[*/0x00E2/*::]*/: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
  	/*::[*/0x00E3/*::]*/: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
  	/*::[*/0x00E4/*::]*/: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
  	/*::[*/0x00E5/*::]*/: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
  	/*::[*/0x00E6/*::]*/: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
  	/*::[*/0x00E7/*::]*/: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
  	/*::[*/0x00E8/*::]*/: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
  	/*::[*/0x00E9/*::]*/: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
  	/*::[*/0x00EA/*::]*/: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
  	/*::[*/0x00EB/*::]*/: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
  	/*::[*/0x00EC/*::]*/: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
  	/*::[*/0x00ED/*::]*/: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
  	/*::[*/0x00EE/*::]*/: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
  	/*::[*/0x00EF/*::]*/: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
  	/*::[*/0x00F0/*::]*/: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
  	/*::[*/0x00F1/*::]*/: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
  	/*::[*/0x00F2/*::]*/: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
  	/*::[*/0x00F3/*::]*/: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
  	/*::[*/0x00F4/*::]*/: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
  	/*::[*/0x00F5/*::]*/: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
  	/*::[*/0x00F6/*::]*/: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
  	/*::[*/0x00F7/*::]*/: { /* n:"BrtBeginPRule", */ T:1 },
  	/*::[*/0x00F8/*::]*/: { /* n:"BrtEndPRule", */ T:-1 },
  	/*::[*/0x00F9/*::]*/: { /* n:"BrtBeginPRFilters", */ T:1 },
  	/*::[*/0x00FA/*::]*/: { /* n:"BrtEndPRFilters", */ T:-1 },
  	/*::[*/0x00FB/*::]*/: { /* n:"BrtBeginPRFilter", */ T:1 },
  	/*::[*/0x00FC/*::]*/: { /* n:"BrtEndPRFilter", */ T:-1 },
  	/*::[*/0x00FD/*::]*/: { /* n:"BrtBeginPNames", */ T:1 },
  	/*::[*/0x00FE/*::]*/: { /* n:"BrtEndPNames", */ T:-1 },
  	/*::[*/0x00FF/*::]*/: { /* n:"BrtBeginPName", */ T:1 },
  	/*::[*/0x0100/*::]*/: { /* n:"BrtEndPName", */ T:-1 },
  	/*::[*/0x0101/*::]*/: { /* n:"BrtBeginPNPairs", */ T:1 },
  	/*::[*/0x0102/*::]*/: { /* n:"BrtEndPNPairs", */ T:-1 },
  	/*::[*/0x0103/*::]*/: { /* n:"BrtBeginPNPair", */ T:1 },
  	/*::[*/0x0104/*::]*/: { /* n:"BrtEndPNPair", */ T:-1 },
  	/*::[*/0x0105/*::]*/: { /* n:"BrtBeginECWebProps", */ T:1 },
  	/*::[*/0x0106/*::]*/: { /* n:"BrtEndECWebProps", */ T:-1 },
  	/*::[*/0x0107/*::]*/: { /* n:"BrtBeginEcWpTables", */ T:1 },
  	/*::[*/0x0108/*::]*/: { /* n:"BrtEndECWPTables", */ T:-1 },
  	/*::[*/0x0109/*::]*/: { /* n:"BrtBeginECParams", */ T:1 },
  	/*::[*/0x010A/*::]*/: { /* n:"BrtEndECParams", */ T:-1 },
  	/*::[*/0x010B/*::]*/: { /* n:"BrtBeginECParam", */ T:1 },
  	/*::[*/0x010C/*::]*/: { /* n:"BrtEndECParam", */ T:-1 },
  	/*::[*/0x010D/*::]*/: { /* n:"BrtBeginPCDKPIs", */ T:1 },
  	/*::[*/0x010E/*::]*/: { /* n:"BrtEndPCDKPIs", */ T:-1 },
  	/*::[*/0x010F/*::]*/: { /* n:"BrtBeginPCDKPI", */ T:1 },
  	/*::[*/0x0110/*::]*/: { /* n:"BrtEndPCDKPI", */ T:-1 },
  	/*::[*/0x0111/*::]*/: { /* n:"BrtBeginDims", */ T:1 },
  	/*::[*/0x0112/*::]*/: { /* n:"BrtEndDims", */ T:-1 },
  	/*::[*/0x0113/*::]*/: { /* n:"BrtBeginDim", */ T:1 },
  	/*::[*/0x0114/*::]*/: { /* n:"BrtEndDim", */ T:-1 },
  	/*::[*/0x0115/*::]*/: { /* n:"BrtIndexPartEnd" */ },
  	/*::[*/0x0116/*::]*/: { /* n:"BrtBeginStyleSheet", */ T:1 },
  	/*::[*/0x0117/*::]*/: { /* n:"BrtEndStyleSheet", */ T:-1 },
  	/*::[*/0x0118/*::]*/: { /* n:"BrtBeginSXView", */ T:1 },
  	/*::[*/0x0119/*::]*/: { /* n:"BrtEndSXVI", */ T:-1 },
  	/*::[*/0x011A/*::]*/: { /* n:"BrtBeginSXVI", */ T:1 },
  	/*::[*/0x011B/*::]*/: { /* n:"BrtBeginSXVIs", */ T:1 },
  	/*::[*/0x011C/*::]*/: { /* n:"BrtEndSXVIs", */ T:-1 },
  	/*::[*/0x011D/*::]*/: { /* n:"BrtBeginSXVD", */ T:1 },
  	/*::[*/0x011E/*::]*/: { /* n:"BrtEndSXVD", */ T:-1 },
  	/*::[*/0x011F/*::]*/: { /* n:"BrtBeginSXVDs", */ T:1 },
  	/*::[*/0x0120/*::]*/: { /* n:"BrtEndSXVDs", */ T:-1 },
  	/*::[*/0x0121/*::]*/: { /* n:"BrtBeginSXPI", */ T:1 },
  	/*::[*/0x0122/*::]*/: { /* n:"BrtEndSXPI", */ T:-1 },
  	/*::[*/0x0123/*::]*/: { /* n:"BrtBeginSXPIs", */ T:1 },
  	/*::[*/0x0124/*::]*/: { /* n:"BrtEndSXPIs", */ T:-1 },
  	/*::[*/0x0125/*::]*/: { /* n:"BrtBeginSXDI", */ T:1 },
  	/*::[*/0x0126/*::]*/: { /* n:"BrtEndSXDI", */ T:-1 },
  	/*::[*/0x0127/*::]*/: { /* n:"BrtBeginSXDIs", */ T:1 },
  	/*::[*/0x0128/*::]*/: { /* n:"BrtEndSXDIs", */ T:-1 },
  	/*::[*/0x0129/*::]*/: { /* n:"BrtBeginSXLI", */ T:1 },
  	/*::[*/0x012A/*::]*/: { /* n:"BrtEndSXLI", */ T:-1 },
  	/*::[*/0x012B/*::]*/: { /* n:"BrtBeginSXLIRws", */ T:1 },
  	/*::[*/0x012C/*::]*/: { /* n:"BrtEndSXLIRws", */ T:-1 },
  	/*::[*/0x012D/*::]*/: { /* n:"BrtBeginSXLICols", */ T:1 },
  	/*::[*/0x012E/*::]*/: { /* n:"BrtEndSXLICols", */ T:-1 },
  	/*::[*/0x012F/*::]*/: { /* n:"BrtBeginSXFormat", */ T:1 },
  	/*::[*/0x0130/*::]*/: { /* n:"BrtEndSXFormat", */ T:-1 },
  	/*::[*/0x0131/*::]*/: { /* n:"BrtBeginSXFormats", */ T:1 },
  	/*::[*/0x0132/*::]*/: { /* n:"BrtEndSxFormats", */ T:-1 },
  	/*::[*/0x0133/*::]*/: { /* n:"BrtBeginSxSelect", */ T:1 },
  	/*::[*/0x0134/*::]*/: { /* n:"BrtEndSxSelect", */ T:-1 },
  	/*::[*/0x0135/*::]*/: { /* n:"BrtBeginISXVDRws", */ T:1 },
  	/*::[*/0x0136/*::]*/: { /* n:"BrtEndISXVDRws", */ T:-1 },
  	/*::[*/0x0137/*::]*/: { /* n:"BrtBeginISXVDCols", */ T:1 },
  	/*::[*/0x0138/*::]*/: { /* n:"BrtEndISXVDCols", */ T:-1 },
  	/*::[*/0x0139/*::]*/: { /* n:"BrtEndSXLocation", */ T:-1 },
  	/*::[*/0x013A/*::]*/: { /* n:"BrtBeginSXLocation", */ T:1 },
  	/*::[*/0x013B/*::]*/: { /* n:"BrtEndSXView", */ T:-1 },
  	/*::[*/0x013C/*::]*/: { /* n:"BrtBeginSXTHs", */ T:1 },
  	/*::[*/0x013D/*::]*/: { /* n:"BrtEndSXTHs", */ T:-1 },
  	/*::[*/0x013E/*::]*/: { /* n:"BrtBeginSXTH", */ T:1 },
  	/*::[*/0x013F/*::]*/: { /* n:"BrtEndSXTH", */ T:-1 },
  	/*::[*/0x0140/*::]*/: { /* n:"BrtBeginISXTHRws", */ T:1 },
  	/*::[*/0x0141/*::]*/: { /* n:"BrtEndISXTHRws", */ T:-1 },
  	/*::[*/0x0142/*::]*/: { /* n:"BrtBeginISXTHCols", */ T:1 },
  	/*::[*/0x0143/*::]*/: { /* n:"BrtEndISXTHCols", */ T:-1 },
  	/*::[*/0x0144/*::]*/: { /* n:"BrtBeginSXTDMPS", */ T:1 },
  	/*::[*/0x0145/*::]*/: { /* n:"BrtEndSXTDMPs", */ T:-1 },
  	/*::[*/0x0146/*::]*/: { /* n:"BrtBeginSXTDMP", */ T:1 },
  	/*::[*/0x0147/*::]*/: { /* n:"BrtEndSXTDMP", */ T:-1 },
  	/*::[*/0x0148/*::]*/: { /* n:"BrtBeginSXTHItems", */ T:1 },
  	/*::[*/0x0149/*::]*/: { /* n:"BrtEndSXTHItems", */ T:-1 },
  	/*::[*/0x014A/*::]*/: { /* n:"BrtBeginSXTHItem", */ T:1 },
  	/*::[*/0x014B/*::]*/: { /* n:"BrtEndSXTHItem", */ T:-1 },
  	/*::[*/0x014C/*::]*/: { /* n:"BrtBeginMetadata", */ T:1 },
  	/*::[*/0x014D/*::]*/: { /* n:"BrtEndMetadata", */ T:-1 },
  	/*::[*/0x014E/*::]*/: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
  	/*::[*/0x014F/*::]*/: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
  	/*::[*/0x0150/*::]*/: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
  	/*::[*/0x0151/*::]*/: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
  	/*::[*/0x0152/*::]*/: { /* n:"BrtEndEsmdb", */ T:-1 },
  	/*::[*/0x0153/*::]*/: { /* n:"BrtBeginEsfmd", */ T:1 },
  	/*::[*/0x0154/*::]*/: { /* n:"BrtEndEsfmd", */ T:-1 },
  	/*::[*/0x0155/*::]*/: { /* n:"BrtBeginSingleCells", */ T:1 },
  	/*::[*/0x0156/*::]*/: { /* n:"BrtEndSingleCells", */ T:-1 },
  	/*::[*/0x0157/*::]*/: { /* n:"BrtBeginList", */ T:1 },
  	/*::[*/0x0158/*::]*/: { /* n:"BrtEndList", */ T:-1 },
  	/*::[*/0x0159/*::]*/: { /* n:"BrtBeginListCols", */ T:1 },
  	/*::[*/0x015A/*::]*/: { /* n:"BrtEndListCols", */ T:-1 },
  	/*::[*/0x015B/*::]*/: { /* n:"BrtBeginListCol", */ T:1 },
  	/*::[*/0x015C/*::]*/: { /* n:"BrtEndListCol", */ T:-1 },
  	/*::[*/0x015D/*::]*/: { /* n:"BrtBeginListXmlCPr", */ T:1 },
  	/*::[*/0x015E/*::]*/: { /* n:"BrtEndListXmlCPr", */ T:-1 },
  	/*::[*/0x015F/*::]*/: { /* n:"BrtListCCFmla" */ },
  	/*::[*/0x0160/*::]*/: { /* n:"BrtListTrFmla" */ },
  	/*::[*/0x0161/*::]*/: { /* n:"BrtBeginExternals", */ T:1 },
  	/*::[*/0x0162/*::]*/: { /* n:"BrtEndExternals", */ T:-1 },
  	/*::[*/0x0163/*::]*/: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
  	/*::[*/0x0165/*::]*/: { /* n:"BrtSupSelf" */ },
  	/*::[*/0x0166/*::]*/: { /* n:"BrtSupSame" */ },
  	/*::[*/0x0167/*::]*/: { /* n:"BrtSupTabs" */ },
  	/*::[*/0x0168/*::]*/: { /* n:"BrtBeginSupBook", */ T:1 },
  	/*::[*/0x0169/*::]*/: { /* n:"BrtPlaceholderName" */ },
  	/*::[*/0x016A/*::]*/: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
  	/*::[*/0x016B/*::]*/: { /* n:"BrtExternTableStart" */ },
  	/*::[*/0x016C/*::]*/: { /* n:"BrtExternTableEnd" */ },
  	/*::[*/0x016E/*::]*/: { /* n:"BrtExternRowHdr" */ },
  	/*::[*/0x016F/*::]*/: { /* n:"BrtExternCellBlank" */ },
  	/*::[*/0x0170/*::]*/: { /* n:"BrtExternCellReal" */ },
  	/*::[*/0x0171/*::]*/: { /* n:"BrtExternCellBool" */ },
  	/*::[*/0x0172/*::]*/: { /* n:"BrtExternCellError" */ },
  	/*::[*/0x0173/*::]*/: { /* n:"BrtExternCellString" */ },
  	/*::[*/0x0174/*::]*/: { /* n:"BrtBeginEsmdx", */ T:1 },
  	/*::[*/0x0175/*::]*/: { /* n:"BrtEndEsmdx", */ T:-1 },
  	/*::[*/0x0176/*::]*/: { /* n:"BrtBeginMdxSet", */ T:1 },
  	/*::[*/0x0177/*::]*/: { /* n:"BrtEndMdxSet", */ T:-1 },
  	/*::[*/0x0178/*::]*/: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
  	/*::[*/0x0179/*::]*/: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
  	/*::[*/0x017A/*::]*/: { /* n:"BrtBeginMdxKPI", */ T:1 },
  	/*::[*/0x017B/*::]*/: { /* n:"BrtEndMdxKPI", */ T:-1 },
  	/*::[*/0x017C/*::]*/: { /* n:"BrtBeginEsstr", */ T:1 },
  	/*::[*/0x017D/*::]*/: { /* n:"BrtEndEsstr", */ T:-1 },
  	/*::[*/0x017E/*::]*/: { /* n:"BrtBeginPRFItem", */ T:1 },
  	/*::[*/0x017F/*::]*/: { /* n:"BrtEndPRFItem", */ T:-1 },
  	/*::[*/0x0180/*::]*/: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
  	/*::[*/0x0181/*::]*/: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
  	/*::[*/0x0182/*::]*/: { /* n:"BrtBeginPivotCacheID", */ T:1 },
  	/*::[*/0x0183/*::]*/: { /* n:"BrtEndPivotCacheID", */ T:-1 },
  	/*::[*/0x0184/*::]*/: { /* n:"BrtBeginISXVIs", */ T:1 },
  	/*::[*/0x0185/*::]*/: { /* n:"BrtEndISXVIs", */ T:-1 },
  	/*::[*/0x0186/*::]*/: { /* n:"BrtBeginColInfos", */ T:1 },
  	/*::[*/0x0187/*::]*/: { /* n:"BrtEndColInfos", */ T:-1 },
  	/*::[*/0x0188/*::]*/: { /* n:"BrtBeginRwBrk", */ T:1 },
  	/*::[*/0x0189/*::]*/: { /* n:"BrtEndRwBrk", */ T:-1 },
  	/*::[*/0x018A/*::]*/: { /* n:"BrtBeginColBrk", */ T:1 },
  	/*::[*/0x018B/*::]*/: { /* n:"BrtEndColBrk", */ T:-1 },
  	/*::[*/0x018C/*::]*/: { /* n:"BrtBrk" */ },
  	/*::[*/0x018D/*::]*/: { /* n:"BrtUserBookView" */ },
  	/*::[*/0x018E/*::]*/: { /* n:"BrtInfo" */ },
  	/*::[*/0x018F/*::]*/: { /* n:"BrtCUsr" */ },
  	/*::[*/0x0190/*::]*/: { /* n:"BrtUsr" */ },
  	/*::[*/0x0191/*::]*/: { /* n:"BrtBeginUsers", */ T:1 },
  	/*::[*/0x0193/*::]*/: { /* n:"BrtEOF" */ },
  	/*::[*/0x0194/*::]*/: { /* n:"BrtUCR" */ },
  	/*::[*/0x0195/*::]*/: { /* n:"BrtRRInsDel" */ },
  	/*::[*/0x0196/*::]*/: { /* n:"BrtRREndInsDel" */ },
  	/*::[*/0x0197/*::]*/: { /* n:"BrtRRMove" */ },
  	/*::[*/0x0198/*::]*/: { /* n:"BrtRREndMove" */ },
  	/*::[*/0x0199/*::]*/: { /* n:"BrtRRChgCell" */ },
  	/*::[*/0x019A/*::]*/: { /* n:"BrtRREndChgCell" */ },
  	/*::[*/0x019B/*::]*/: { /* n:"BrtRRHeader" */ },
  	/*::[*/0x019C/*::]*/: { /* n:"BrtRRUserView" */ },
  	/*::[*/0x019D/*::]*/: { /* n:"BrtRRRenSheet" */ },
  	/*::[*/0x019E/*::]*/: { /* n:"BrtRRInsertSh" */ },
  	/*::[*/0x019F/*::]*/: { /* n:"BrtRRDefName" */ },
  	/*::[*/0x01A0/*::]*/: { /* n:"BrtRRNote" */ },
  	/*::[*/0x01A1/*::]*/: { /* n:"BrtRRConflict" */ },
  	/*::[*/0x01A2/*::]*/: { /* n:"BrtRRTQSIF" */ },
  	/*::[*/0x01A3/*::]*/: { /* n:"BrtRRFormat" */ },
  	/*::[*/0x01A4/*::]*/: { /* n:"BrtRREndFormat" */ },
  	/*::[*/0x01A5/*::]*/: { /* n:"BrtRRAutoFmt" */ },
  	/*::[*/0x01A6/*::]*/: { /* n:"BrtBeginUserShViews", */ T:1 },
  	/*::[*/0x01A7/*::]*/: { /* n:"BrtBeginUserShView", */ T:1 },
  	/*::[*/0x01A8/*::]*/: { /* n:"BrtEndUserShView", */ T:-1 },
  	/*::[*/0x01A9/*::]*/: { /* n:"BrtEndUserShViews", */ T:-1 },
  	/*::[*/0x01AA/*::]*/: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
  	/*::[*/0x01AB/*::]*/: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
  	/*::[*/0x01AC/*::]*/: { /* n:"BrtTable" */ },
  	/*::[*/0x01AD/*::]*/: { /* n:"BrtBeginExtConnections", */ T:1 },
  	/*::[*/0x01AE/*::]*/: { /* n:"BrtEndExtConnections", */ T:-1 },
  	/*::[*/0x01AF/*::]*/: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
  	/*::[*/0x01B0/*::]*/: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
  	/*::[*/0x01B1/*::]*/: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
  	/*::[*/0x01B2/*::]*/: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
  	/*::[*/0x01B3/*::]*/: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
  	/*::[*/0x01B4/*::]*/: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
  	/*::[*/0x01B5/*::]*/: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
  	/*::[*/0x01B6/*::]*/: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
  	/*::[*/0x01B7/*::]*/: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
  	/*::[*/0x01B8/*::]*/: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
  	/*::[*/0x01B9/*::]*/: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
  	/*::[*/0x01BA/*::]*/: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
  	/*::[*/0x01BB/*::]*/: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
  	/*::[*/0x01BC/*::]*/: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
  	/*::[*/0x01BD/*::]*/: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
  	/*::[*/0x01BE/*::]*/: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
  	/*::[*/0x01BF/*::]*/: { /* n:"BrtBeginQSI", */ T:1 },
  	/*::[*/0x01C0/*::]*/: { /* n:"BrtEndQSI", */ T:-1 },
  	/*::[*/0x01C1/*::]*/: { /* n:"BrtBeginQSIR", */ T:1 },
  	/*::[*/0x01C2/*::]*/: { /* n:"BrtEndQSIR", */ T:-1 },
  	/*::[*/0x01C3/*::]*/: { /* n:"BrtBeginDeletedNames", */ T:1 },
  	/*::[*/0x01C4/*::]*/: { /* n:"BrtEndDeletedNames", */ T:-1 },
  	/*::[*/0x01C5/*::]*/: { /* n:"BrtBeginDeletedName", */ T:1 },
  	/*::[*/0x01C6/*::]*/: { /* n:"BrtEndDeletedName", */ T:-1 },
  	/*::[*/0x01C7/*::]*/: { /* n:"BrtBeginQSIFs", */ T:1 },
  	/*::[*/0x01C8/*::]*/: { /* n:"BrtEndQSIFs", */ T:-1 },
  	/*::[*/0x01C9/*::]*/: { /* n:"BrtBeginQSIF", */ T:1 },
  	/*::[*/0x01CA/*::]*/: { /* n:"BrtEndQSIF", */ T:-1 },
  	/*::[*/0x01CB/*::]*/: { /* n:"BrtBeginAutoSortScope", */ T:1 },
  	/*::[*/0x01CC/*::]*/: { /* n:"BrtEndAutoSortScope", */ T:-1 },
  	/*::[*/0x01CD/*::]*/: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
  	/*::[*/0x01CE/*::]*/: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
  	/*::[*/0x01CF/*::]*/: { /* n:"BrtBeginCFRule", */ T:1 },
  	/*::[*/0x01D0/*::]*/: { /* n:"BrtEndCFRule", */ T:-1 },
  	/*::[*/0x01D1/*::]*/: { /* n:"BrtBeginIconSet", */ T:1 },
  	/*::[*/0x01D2/*::]*/: { /* n:"BrtEndIconSet", */ T:-1 },
  	/*::[*/0x01D3/*::]*/: { /* n:"BrtBeginDatabar", */ T:1 },
  	/*::[*/0x01D4/*::]*/: { /* n:"BrtEndDatabar", */ T:-1 },
  	/*::[*/0x01D5/*::]*/: { /* n:"BrtBeginColorScale", */ T:1 },
  	/*::[*/0x01D6/*::]*/: { /* n:"BrtEndColorScale", */ T:-1 },
  	/*::[*/0x01D7/*::]*/: { /* n:"BrtCFVO" */ },
  	/*::[*/0x01D8/*::]*/: { /* n:"BrtExternValueMeta" */ },
  	/*::[*/0x01D9/*::]*/: { /* n:"BrtBeginColorPalette", */ T:1 },
  	/*::[*/0x01DA/*::]*/: { /* n:"BrtEndColorPalette", */ T:-1 },
  	/*::[*/0x01DB/*::]*/: { /* n:"BrtIndexedColor" */ },
  	/*::[*/0x01DC/*::]*/: { /* n:"BrtMargins", */ f:parse_BrtMargins },
  	/*::[*/0x01DD/*::]*/: { /* n:"BrtPrintOptions" */ },
  	/*::[*/0x01DE/*::]*/: { /* n:"BrtPageSetup" */ },
  	/*::[*/0x01DF/*::]*/: { /* n:"BrtBeginHeaderFooter", */ T:1 },
  	/*::[*/0x01E0/*::]*/: { /* n:"BrtEndHeaderFooter", */ T:-1 },
  	/*::[*/0x01E1/*::]*/: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
  	/*::[*/0x01E2/*::]*/: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
  	/*::[*/0x01E3/*::]*/: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
  	/*::[*/0x01E4/*::]*/: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
  	/*::[*/0x01E5/*::]*/: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
  	/*::[*/0x01E6/*::]*/: { /* n:"BrtBeginMgs", */ T:1 },
  	/*::[*/0x01E7/*::]*/: { /* n:"BrtEndMGs", */ T:-1 },
  	/*::[*/0x01E8/*::]*/: { /* n:"BrtBeginMGMaps", */ T:1 },
  	/*::[*/0x01E9/*::]*/: { /* n:"BrtEndMGMaps", */ T:-1 },
  	/*::[*/0x01EA/*::]*/: { /* n:"BrtBeginMG", */ T:1 },
  	/*::[*/0x01EB/*::]*/: { /* n:"BrtEndMG", */ T:-1 },
  	/*::[*/0x01EC/*::]*/: { /* n:"BrtBeginMap", */ T:1 },
  	/*::[*/0x01ED/*::]*/: { /* n:"BrtEndMap", */ T:-1 },
  	/*::[*/0x01EE/*::]*/: { /* n:"BrtHLink", */ f:parse_BrtHLink },
  	/*::[*/0x01EF/*::]*/: { /* n:"BrtBeginDCon", */ T:1 },
  	/*::[*/0x01F0/*::]*/: { /* n:"BrtEndDCon", */ T:-1 },
  	/*::[*/0x01F1/*::]*/: { /* n:"BrtBeginDRefs", */ T:1 },
  	/*::[*/0x01F2/*::]*/: { /* n:"BrtEndDRefs", */ T:-1 },
  	/*::[*/0x01F3/*::]*/: { /* n:"BrtDRef" */ },
  	/*::[*/0x01F4/*::]*/: { /* n:"BrtBeginScenMan", */ T:1 },
  	/*::[*/0x01F5/*::]*/: { /* n:"BrtEndScenMan", */ T:-1 },
  	/*::[*/0x01F6/*::]*/: { /* n:"BrtBeginSct", */ T:1 },
  	/*::[*/0x01F7/*::]*/: { /* n:"BrtEndSct", */ T:-1 },
  	/*::[*/0x01F8/*::]*/: { /* n:"BrtSlc" */ },
  	/*::[*/0x01F9/*::]*/: { /* n:"BrtBeginDXFs", */ T:1 },
  	/*::[*/0x01FA/*::]*/: { /* n:"BrtEndDXFs", */ T:-1 },
  	/*::[*/0x01FB/*::]*/: { /* n:"BrtDXF" */ },
  	/*::[*/0x01FC/*::]*/: { /* n:"BrtBeginTableStyles", */ T:1 },
  	/*::[*/0x01FD/*::]*/: { /* n:"BrtEndTableStyles", */ T:-1 },
  	/*::[*/0x01FE/*::]*/: { /* n:"BrtBeginTableStyle", */ T:1 },
  	/*::[*/0x01FF/*::]*/: { /* n:"BrtEndTableStyle", */ T:-1 },
  	/*::[*/0x0200/*::]*/: { /* n:"BrtTableStyleElement" */ },
  	/*::[*/0x0201/*::]*/: { /* n:"BrtTableStyleClient" */ },
  	/*::[*/0x0202/*::]*/: { /* n:"BrtBeginVolDeps", */ T:1 },
  	/*::[*/0x0203/*::]*/: { /* n:"BrtEndVolDeps", */ T:-1 },
  	/*::[*/0x0204/*::]*/: { /* n:"BrtBeginVolType", */ T:1 },
  	/*::[*/0x0205/*::]*/: { /* n:"BrtEndVolType", */ T:-1 },
  	/*::[*/0x0206/*::]*/: { /* n:"BrtBeginVolMain", */ T:1 },
  	/*::[*/0x0207/*::]*/: { /* n:"BrtEndVolMain", */ T:-1 },
  	/*::[*/0x0208/*::]*/: { /* n:"BrtBeginVolTopic", */ T:1 },
  	/*::[*/0x0209/*::]*/: { /* n:"BrtEndVolTopic", */ T:-1 },
  	/*::[*/0x020A/*::]*/: { /* n:"BrtVolSubtopic" */ },
  	/*::[*/0x020B/*::]*/: { /* n:"BrtVolRef" */ },
  	/*::[*/0x020C/*::]*/: { /* n:"BrtVolNum" */ },
  	/*::[*/0x020D/*::]*/: { /* n:"BrtVolErr" */ },
  	/*::[*/0x020E/*::]*/: { /* n:"BrtVolStr" */ },
  	/*::[*/0x020F/*::]*/: { /* n:"BrtVolBool" */ },
  	/*::[*/0x0210/*::]*/: { /* n:"BrtBeginCalcChain$", */ T:1 },
  	/*::[*/0x0211/*::]*/: { /* n:"BrtEndCalcChain$", */ T:-1 },
  	/*::[*/0x0212/*::]*/: { /* n:"BrtBeginSortState", */ T:1 },
  	/*::[*/0x0213/*::]*/: { /* n:"BrtEndSortState", */ T:-1 },
  	/*::[*/0x0214/*::]*/: { /* n:"BrtBeginSortCond", */ T:1 },
  	/*::[*/0x0215/*::]*/: { /* n:"BrtEndSortCond", */ T:-1 },
  	/*::[*/0x0216/*::]*/: { /* n:"BrtBookProtection" */ },
  	/*::[*/0x0217/*::]*/: { /* n:"BrtSheetProtection" */ },
  	/*::[*/0x0218/*::]*/: { /* n:"BrtRangeProtection" */ },
  	/*::[*/0x0219/*::]*/: { /* n:"BrtPhoneticInfo" */ },
  	/*::[*/0x021A/*::]*/: { /* n:"BrtBeginECTxtWiz", */ T:1 },
  	/*::[*/0x021B/*::]*/: { /* n:"BrtEndECTxtWiz", */ T:-1 },
  	/*::[*/0x021C/*::]*/: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
  	/*::[*/0x021D/*::]*/: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
  	/*::[*/0x021E/*::]*/: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
  	/*::[*/0x0224/*::]*/: { /* n:"BrtFileSharing" */ },
  	/*::[*/0x0225/*::]*/: { /* n:"BrtOleSize" */ },
  	/*::[*/0x0226/*::]*/: { /* n:"BrtDrawing", */ f:parse_RelID },
  	/*::[*/0x0227/*::]*/: { /* n:"BrtLegacyDrawing" */ },
  	/*::[*/0x0228/*::]*/: { /* n:"BrtLegacyDrawingHF" */ },
  	/*::[*/0x0229/*::]*/: { /* n:"BrtWebOpt" */ },
  	/*::[*/0x022A/*::]*/: { /* n:"BrtBeginWebPubItems", */ T:1 },
  	/*::[*/0x022B/*::]*/: { /* n:"BrtEndWebPubItems", */ T:-1 },
  	/*::[*/0x022C/*::]*/: { /* n:"BrtBeginWebPubItem", */ T:1 },
  	/*::[*/0x022D/*::]*/: { /* n:"BrtEndWebPubItem", */ T:-1 },
  	/*::[*/0x022E/*::]*/: { /* n:"BrtBeginSXCondFmt", */ T:1 },
  	/*::[*/0x022F/*::]*/: { /* n:"BrtEndSXCondFmt", */ T:-1 },
  	/*::[*/0x0230/*::]*/: { /* n:"BrtBeginSXCondFmts", */ T:1 },
  	/*::[*/0x0231/*::]*/: { /* n:"BrtEndSXCondFmts", */ T:-1 },
  	/*::[*/0x0232/*::]*/: { /* n:"BrtBkHim" */ },
  	/*::[*/0x0234/*::]*/: { /* n:"BrtColor" */ },
  	/*::[*/0x0235/*::]*/: { /* n:"BrtBeginIndexedColors", */ T:1 },
  	/*::[*/0x0236/*::]*/: { /* n:"BrtEndIndexedColors", */ T:-1 },
  	/*::[*/0x0239/*::]*/: { /* n:"BrtBeginMRUColors", */ T:1 },
  	/*::[*/0x023A/*::]*/: { /* n:"BrtEndMRUColors", */ T:-1 },
  	/*::[*/0x023C/*::]*/: { /* n:"BrtMRUColor" */ },
  	/*::[*/0x023D/*::]*/: { /* n:"BrtBeginDVals", */ T:1 },
  	/*::[*/0x023E/*::]*/: { /* n:"BrtEndDVals", */ T:-1 },
  	/*::[*/0x0241/*::]*/: { /* n:"BrtSupNameStart" */ },
  	/*::[*/0x0242/*::]*/: { /* n:"BrtSupNameValueStart" */ },
  	/*::[*/0x0243/*::]*/: { /* n:"BrtSupNameValueEnd" */ },
  	/*::[*/0x0244/*::]*/: { /* n:"BrtSupNameNum" */ },
  	/*::[*/0x0245/*::]*/: { /* n:"BrtSupNameErr" */ },
  	/*::[*/0x0246/*::]*/: { /* n:"BrtSupNameSt" */ },
  	/*::[*/0x0247/*::]*/: { /* n:"BrtSupNameNil" */ },
  	/*::[*/0x0248/*::]*/: { /* n:"BrtSupNameBool" */ },
  	/*::[*/0x0249/*::]*/: { /* n:"BrtSupNameFmla" */ },
  	/*::[*/0x024A/*::]*/: { /* n:"BrtSupNameBits" */ },
  	/*::[*/0x024B/*::]*/: { /* n:"BrtSupNameEnd" */ },
  	/*::[*/0x024C/*::]*/: { /* n:"BrtEndSupBook", */ T:-1 },
  	/*::[*/0x024D/*::]*/: { /* n:"BrtCellSmartTagProperty" */ },
  	/*::[*/0x024E/*::]*/: { /* n:"BrtBeginCellSmartTag", */ T:1 },
  	/*::[*/0x024F/*::]*/: { /* n:"BrtEndCellSmartTag", */ T:-1 },
  	/*::[*/0x0250/*::]*/: { /* n:"BrtBeginCellSmartTags", */ T:1 },
  	/*::[*/0x0251/*::]*/: { /* n:"BrtEndCellSmartTags", */ T:-1 },
  	/*::[*/0x0252/*::]*/: { /* n:"BrtBeginSmartTags", */ T:1 },
  	/*::[*/0x0253/*::]*/: { /* n:"BrtEndSmartTags", */ T:-1 },
  	/*::[*/0x0254/*::]*/: { /* n:"BrtSmartTagType" */ },
  	/*::[*/0x0255/*::]*/: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
  	/*::[*/0x0256/*::]*/: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
  	/*::[*/0x0257/*::]*/: { /* n:"BrtBeginSXFilters", */ T:1 },
  	/*::[*/0x0258/*::]*/: { /* n:"BrtEndSXFilters", */ T:-1 },
  	/*::[*/0x0259/*::]*/: { /* n:"BrtBeginSXFILTER", */ T:1 },
  	/*::[*/0x025A/*::]*/: { /* n:"BrtEndSXFilter", */ T:-1 },
  	/*::[*/0x025B/*::]*/: { /* n:"BrtBeginFills", */ T:1 },
  	/*::[*/0x025C/*::]*/: { /* n:"BrtEndFills", */ T:-1 },
  	/*::[*/0x025D/*::]*/: { /* n:"BrtBeginCellWatches", */ T:1 },
  	/*::[*/0x025E/*::]*/: { /* n:"BrtEndCellWatches", */ T:-1 },
  	/*::[*/0x025F/*::]*/: { /* n:"BrtCellWatch" */ },
  	/*::[*/0x0260/*::]*/: { /* n:"BrtBeginCRErrs", */ T:1 },
  	/*::[*/0x0261/*::]*/: { /* n:"BrtEndCRErrs", */ T:-1 },
  	/*::[*/0x0262/*::]*/: { /* n:"BrtCrashRecErr" */ },
  	/*::[*/0x0263/*::]*/: { /* n:"BrtBeginFonts", */ T:1 },
  	/*::[*/0x0264/*::]*/: { /* n:"BrtEndFonts", */ T:-1 },
  	/*::[*/0x0265/*::]*/: { /* n:"BrtBeginBorders", */ T:1 },
  	/*::[*/0x0266/*::]*/: { /* n:"BrtEndBorders", */ T:-1 },
  	/*::[*/0x0267/*::]*/: { /* n:"BrtBeginFmts", */ T:1 },
  	/*::[*/0x0268/*::]*/: { /* n:"BrtEndFmts", */ T:-1 },
  	/*::[*/0x0269/*::]*/: { /* n:"BrtBeginCellXFs", */ T:1 },
  	/*::[*/0x026A/*::]*/: { /* n:"BrtEndCellXFs", */ T:-1 },
  	/*::[*/0x026B/*::]*/: { /* n:"BrtBeginStyles", */ T:1 },
  	/*::[*/0x026C/*::]*/: { /* n:"BrtEndStyles", */ T:-1 },
  	/*::[*/0x0271/*::]*/: { /* n:"BrtBigName" */ },
  	/*::[*/0x0272/*::]*/: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
  	/*::[*/0x0273/*::]*/: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
  	/*::[*/0x0274/*::]*/: { /* n:"BrtBeginComments", */ T:1 },
  	/*::[*/0x0275/*::]*/: { /* n:"BrtEndComments", */ T:-1 },
  	/*::[*/0x0276/*::]*/: { /* n:"BrtBeginCommentAuthors", */ T:1 },
  	/*::[*/0x0277/*::]*/: { /* n:"BrtEndCommentAuthors", */ T:-1 },
  	/*::[*/0x0278/*::]*/: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
  	/*::[*/0x0279/*::]*/: { /* n:"BrtBeginCommentList", */ T:1 },
  	/*::[*/0x027A/*::]*/: { /* n:"BrtEndCommentList", */ T:-1 },
  	/*::[*/0x027B/*::]*/: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
  	/*::[*/0x027C/*::]*/: { /* n:"BrtEndComment", */ T:-1 },
  	/*::[*/0x027D/*::]*/: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
  	/*::[*/0x027E/*::]*/: { /* n:"BrtBeginOleObjects", */ T:1 },
  	/*::[*/0x027F/*::]*/: { /* n:"BrtOleObject" */ },
  	/*::[*/0x0280/*::]*/: { /* n:"BrtEndOleObjects", */ T:-1 },
  	/*::[*/0x0281/*::]*/: { /* n:"BrtBeginSxrules", */ T:1 },
  	/*::[*/0x0282/*::]*/: { /* n:"BrtEndSxRules", */ T:-1 },
  	/*::[*/0x0283/*::]*/: { /* n:"BrtBeginActiveXControls", */ T:1 },
  	/*::[*/0x0284/*::]*/: { /* n:"BrtActiveX" */ },
  	/*::[*/0x0285/*::]*/: { /* n:"BrtEndActiveXControls", */ T:-1 },
  	/*::[*/0x0286/*::]*/: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
  	/*::[*/0x0288/*::]*/: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
  	/*::[*/0x0289/*::]*/: { /* n:"BrtCellIgnoreEC" */ },
  	/*::[*/0x028A/*::]*/: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
  	/*::[*/0x028B/*::]*/: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
  	/*::[*/0x028C/*::]*/: { /* n:"BrtCsPageSetup" */ },
  	/*::[*/0x028D/*::]*/: { /* n:"BrtBeginUserCsViews", */ T:1 },
  	/*::[*/0x028E/*::]*/: { /* n:"BrtEndUserCsViews", */ T:-1 },
  	/*::[*/0x028F/*::]*/: { /* n:"BrtBeginUserCsView", */ T:1 },
  	/*::[*/0x0290/*::]*/: { /* n:"BrtEndUserCsView", */ T:-1 },
  	/*::[*/0x0291/*::]*/: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
  	/*::[*/0x0292/*::]*/: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
  	/*::[*/0x0293/*::]*/: { /* n:"BrtPCDSFCIEntry" */ },
  	/*::[*/0x0294/*::]*/: { /* n:"BrtBeginListParts", */ T:1 },
  	/*::[*/0x0295/*::]*/: { /* n:"BrtListPart" */ },
  	/*::[*/0x0296/*::]*/: { /* n:"BrtEndListParts", */ T:-1 },
  	/*::[*/0x0297/*::]*/: { /* n:"BrtSheetCalcProp" */ },
  	/*::[*/0x0298/*::]*/: { /* n:"BrtBeginFnGroup", */ T:1 },
  	/*::[*/0x0299/*::]*/: { /* n:"BrtFnGroup" */ },
  	/*::[*/0x029A/*::]*/: { /* n:"BrtEndFnGroup", */ T:-1 },
  	/*::[*/0x029B/*::]*/: { /* n:"BrtSupAddin" */ },
  	/*::[*/0x029C/*::]*/: { /* n:"BrtSXTDMPOrder" */ },
  	/*::[*/0x029D/*::]*/: { /* n:"BrtCsProtection" */ },
  	/*::[*/0x029F/*::]*/: { /* n:"BrtBeginWsSortMap", */ T:1 },
  	/*::[*/0x02A0/*::]*/: { /* n:"BrtEndWsSortMap", */ T:-1 },
  	/*::[*/0x02A1/*::]*/: { /* n:"BrtBeginRRSort", */ T:1 },
  	/*::[*/0x02A2/*::]*/: { /* n:"BrtEndRRSort", */ T:-1 },
  	/*::[*/0x02A3/*::]*/: { /* n:"BrtRRSortItem" */ },
  	/*::[*/0x02A4/*::]*/: { /* n:"BrtFileSharingIso" */ },
  	/*::[*/0x02A5/*::]*/: { /* n:"BrtBookProtectionIso" */ },
  	/*::[*/0x02A6/*::]*/: { /* n:"BrtSheetProtectionIso" */ },
  	/*::[*/0x02A7/*::]*/: { /* n:"BrtCsProtectionIso" */ },
  	/*::[*/0x02A8/*::]*/: { /* n:"BrtRangeProtectionIso" */ },
  	/*::[*/0x02A9/*::]*/: { /* n:"BrtDValList" */ },
  	/*::[*/0x0400/*::]*/: { /* n:"BrtRwDescent" */ },
  	/*::[*/0x0401/*::]*/: { /* n:"BrtKnownFonts" */ },
  	/*::[*/0x0402/*::]*/: { /* n:"BrtBeginSXTupleSet", */ T:1 },
  	/*::[*/0x0403/*::]*/: { /* n:"BrtEndSXTupleSet", */ T:-1 },
  	/*::[*/0x0404/*::]*/: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
  	/*::[*/0x0405/*::]*/: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
  	/*::[*/0x0406/*::]*/: { /* n:"BrtSXTupleSetHeaderItem" */ },
  	/*::[*/0x0407/*::]*/: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
  	/*::[*/0x0408/*::]*/: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
  	/*::[*/0x0409/*::]*/: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
  	/*::[*/0x040A/*::]*/: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
  	/*::[*/0x040B/*::]*/: { /* n:"BrtSXTupleSetRowItem" */ },
  	/*::[*/0x040C/*::]*/: { /* n:"BrtNameExt" */ },
  	/*::[*/0x040D/*::]*/: { /* n:"BrtPCDH14" */ },
  	/*::[*/0x040E/*::]*/: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
  	/*::[*/0x040F/*::]*/: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
  	/*::[*/0x0410/*::]*/: { /* n:"BrtSXTH14" */ },
  	/*::[*/0x0411/*::]*/: { /* n:"BrtBeginSparklineGroup", */ T:1 },
  	/*::[*/0x0412/*::]*/: { /* n:"BrtEndSparklineGroup", */ T:-1 },
  	/*::[*/0x0413/*::]*/: { /* n:"BrtSparkline" */ },
  	/*::[*/0x0414/*::]*/: { /* n:"BrtSXDI14" */ },
  	/*::[*/0x0415/*::]*/: { /* n:"BrtWsFmtInfoEx14" */ },
  	/*::[*/0x0416/*::]*/: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
  	/*::[*/0x0417/*::]*/: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
  	/*::[*/0x0418/*::]*/: { /* n:"BrtBeginCFRule14", */ T:1 },
  	/*::[*/0x0419/*::]*/: { /* n:"BrtEndCFRule14", */ T:-1 },
  	/*::[*/0x041A/*::]*/: { /* n:"BrtCFVO14" */ },
  	/*::[*/0x041B/*::]*/: { /* n:"BrtBeginDatabar14", */ T:1 },
  	/*::[*/0x041C/*::]*/: { /* n:"BrtBeginIconSet14", */ T:1 },
  	/*::[*/0x041D/*::]*/: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
  	/*::[*/0x041E/*::]*/: { /* n:"BrtBeginDVals14", */ T:1 },
  	/*::[*/0x041F/*::]*/: { /* n:"BrtColor14" */ },
  	/*::[*/0x0420/*::]*/: { /* n:"BrtBeginSparklines", */ T:1 },
  	/*::[*/0x0421/*::]*/: { /* n:"BrtEndSparklines", */ T:-1 },
  	/*::[*/0x0422/*::]*/: { /* n:"BrtBeginSparklineGroups", */ T:1 },
  	/*::[*/0x0423/*::]*/: { /* n:"BrtEndSparklineGroups", */ T:-1 },
  	/*::[*/0x0425/*::]*/: { /* n:"BrtSXVD14" */ },
  	/*::[*/0x0426/*::]*/: { /* n:"BrtBeginSXView14", */ T:1 },
  	/*::[*/0x0427/*::]*/: { /* n:"BrtEndSXView14", */ T:-1 },
  	/*::[*/0x0428/*::]*/: { /* n:"BrtBeginSXView16", */ T:1 },
  	/*::[*/0x0429/*::]*/: { /* n:"BrtEndSXView16", */ T:-1 },
  	/*::[*/0x042A/*::]*/: { /* n:"BrtBeginPCD14", */ T:1 },
  	/*::[*/0x042B/*::]*/: { /* n:"BrtEndPCD14", */ T:-1 },
  	/*::[*/0x042C/*::]*/: { /* n:"BrtBeginExtConn14", */ T:1 },
  	/*::[*/0x042D/*::]*/: { /* n:"BrtEndExtConn14", */ T:-1 },
  	/*::[*/0x042E/*::]*/: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
  	/*::[*/0x042F/*::]*/: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
  	/*::[*/0x0430/*::]*/: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
  	/*::[*/0x0431/*::]*/: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
  	/*::[*/0x0433/*::]*/: { /* n:"BrtBeginSlicerCache", */ T:1 },
  	/*::[*/0x0434/*::]*/: { /* n:"BrtEndSlicerCache", */ T:-1 },
  	/*::[*/0x0435/*::]*/: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
  	/*::[*/0x0436/*::]*/: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
  	/*::[*/0x0437/*::]*/: { /* n:"BrtBeginSlicersEx", */ T:1 },
  	/*::[*/0x0438/*::]*/: { /* n:"BrtEndSlicersEx", */ T:-1 },
  	/*::[*/0x0439/*::]*/: { /* n:"BrtBeginSlicerEx", */ T:1 },
  	/*::[*/0x043A/*::]*/: { /* n:"BrtEndSlicerEx", */ T:-1 },
  	/*::[*/0x043B/*::]*/: { /* n:"BrtBeginSlicer", */ T:1 },
  	/*::[*/0x043C/*::]*/: { /* n:"BrtEndSlicer", */ T:-1 },
  	/*::[*/0x043D/*::]*/: { /* n:"BrtSlicerCachePivotTables" */ },
  	/*::[*/0x043E/*::]*/: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
  	/*::[*/0x043F/*::]*/: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
  	/*::[*/0x0440/*::]*/: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
  	/*::[*/0x0441/*::]*/: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
  	/*::[*/0x0442/*::]*/: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
  	/*::[*/0x0443/*::]*/: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
  	/*::[*/0x0444/*::]*/: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
  	/*::[*/0x0445/*::]*/: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
  	/*::[*/0x0446/*::]*/: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
  	/*::[*/0x0447/*::]*/: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
  	/*::[*/0x0448/*::]*/: { /* n:"BrtSlicerCacheOlapItem" */ },
  	/*::[*/0x0449/*::]*/: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
  	/*::[*/0x044A/*::]*/: { /* n:"BrtSlicerCacheSelection" */ },
  	/*::[*/0x044B/*::]*/: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
  	/*::[*/0x044C/*::]*/: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
  	/*::[*/0x044D/*::]*/: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
  	/*::[*/0x044E/*::]*/: { /* n:"BrtSlicerCacheNativeItem" */ },
  	/*::[*/0x044F/*::]*/: { /* n:"BrtRangeProtection14" */ },
  	/*::[*/0x0450/*::]*/: { /* n:"BrtRangeProtectionIso14" */ },
  	/*::[*/0x0451/*::]*/: { /* n:"BrtCellIgnoreEC14" */ },
  	/*::[*/0x0457/*::]*/: { /* n:"BrtList14" */ },
  	/*::[*/0x0458/*::]*/: { /* n:"BrtCFIcon" */ },
  	/*::[*/0x0459/*::]*/: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
  	/*::[*/0x045A/*::]*/: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
  	/*::[*/0x045B/*::]*/: { /* n:"BrtBeginSlicers", */ T:1 },
  	/*::[*/0x045C/*::]*/: { /* n:"BrtEndSlicers", */ T:-1 },
  	/*::[*/0x045D/*::]*/: { /* n:"BrtWbProp14" */ },
  	/*::[*/0x045E/*::]*/: { /* n:"BrtBeginSXEdit", */ T:1 },
  	/*::[*/0x045F/*::]*/: { /* n:"BrtEndSXEdit", */ T:-1 },
  	/*::[*/0x0460/*::]*/: { /* n:"BrtBeginSXEdits", */ T:1 },
  	/*::[*/0x0461/*::]*/: { /* n:"BrtEndSXEdits", */ T:-1 },
  	/*::[*/0x0462/*::]*/: { /* n:"BrtBeginSXChange", */ T:1 },
  	/*::[*/0x0463/*::]*/: { /* n:"BrtEndSXChange", */ T:-1 },
  	/*::[*/0x0464/*::]*/: { /* n:"BrtBeginSXChanges", */ T:1 },
  	/*::[*/0x0465/*::]*/: { /* n:"BrtEndSXChanges", */ T:-1 },
  	/*::[*/0x0466/*::]*/: { /* n:"BrtSXTupleItems" */ },
  	/*::[*/0x0468/*::]*/: { /* n:"BrtBeginSlicerStyle", */ T:1 },
  	/*::[*/0x0469/*::]*/: { /* n:"BrtEndSlicerStyle", */ T:-1 },
  	/*::[*/0x046A/*::]*/: { /* n:"BrtSlicerStyleElement" */ },
  	/*::[*/0x046B/*::]*/: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
  	/*::[*/0x046C/*::]*/: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
  	/*::[*/0x046D/*::]*/: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
  	/*::[*/0x046E/*::]*/: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
  	/*::[*/0x046F/*::]*/: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
  	/*::[*/0x0470/*::]*/: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
  	/*::[*/0x0471/*::]*/: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
  	/*::[*/0x0472/*::]*/: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
  	/*::[*/0x0473/*::]*/: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
  	/*::[*/0x0474/*::]*/: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
  	/*::[*/0x0475/*::]*/: { /* n:"BrtPCDField14" */ },
  	/*::[*/0x0476/*::]*/: { /* n:"BrtBeginSlicerStyles", */ T:1 },
  	/*::[*/0x0477/*::]*/: { /* n:"BrtEndSlicerStyles", */ T:-1 },
  	/*::[*/0x0478/*::]*/: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
  	/*::[*/0x0479/*::]*/: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
  	/*::[*/0x047A/*::]*/: { /* n:"BrtCFRuleExt" */ },
  	/*::[*/0x047B/*::]*/: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
  	/*::[*/0x047C/*::]*/: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
  	/*::[*/0x047D/*::]*/: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
  	/*::[*/0x047E/*::]*/: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
  	/*::[*/0x0480/*::]*/: { /* n:"BrtBeginSortCond14", */ T:1 },
  	/*::[*/0x0481/*::]*/: { /* n:"BrtEndSortCond14", */ T:-1 },
  	/*::[*/0x0482/*::]*/: { /* n:"BrtEndDVals14", */ T:-1 },
  	/*::[*/0x0483/*::]*/: { /* n:"BrtEndIconSet14", */ T:-1 },
  	/*::[*/0x0484/*::]*/: { /* n:"BrtEndDatabar14", */ T:-1 },
  	/*::[*/0x0485/*::]*/: { /* n:"BrtBeginColorScale14", */ T:1 },
  	/*::[*/0x0486/*::]*/: { /* n:"BrtEndColorScale14", */ T:-1 },
  	/*::[*/0x0487/*::]*/: { /* n:"BrtBeginSxrules14", */ T:1 },
  	/*::[*/0x0488/*::]*/: { /* n:"BrtEndSxrules14", */ T:-1 },
  	/*::[*/0x0489/*::]*/: { /* n:"BrtBeginPRule14", */ T:1 },
  	/*::[*/0x048A/*::]*/: { /* n:"BrtEndPRule14", */ T:-1 },
  	/*::[*/0x048B/*::]*/: { /* n:"BrtBeginPRFilters14", */ T:1 },
  	/*::[*/0x048C/*::]*/: { /* n:"BrtEndPRFilters14", */ T:-1 },
  	/*::[*/0x048D/*::]*/: { /* n:"BrtBeginPRFilter14", */ T:1 },
  	/*::[*/0x048E/*::]*/: { /* n:"BrtEndPRFilter14", */ T:-1 },
  	/*::[*/0x048F/*::]*/: { /* n:"BrtBeginPRFItem14", */ T:1 },
  	/*::[*/0x0490/*::]*/: { /* n:"BrtEndPRFItem14", */ T:-1 },
  	/*::[*/0x0491/*::]*/: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
  	/*::[*/0x0492/*::]*/: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
  	/*::[*/0x0493/*::]*/: { /* n:"BrtDxf14" */ },
  	/*::[*/0x0494/*::]*/: { /* n:"BrtBeginDxF14s", */ T:1 },
  	/*::[*/0x0495/*::]*/: { /* n:"BrtEndDxf14s", */ T:-1 },
  	/*::[*/0x0499/*::]*/: { /* n:"BrtFilter14" */ },
  	/*::[*/0x049A/*::]*/: { /* n:"BrtBeginCustomFilters14", */ T:1 },
  	/*::[*/0x049C/*::]*/: { /* n:"BrtCustomFilter14" */ },
  	/*::[*/0x049D/*::]*/: { /* n:"BrtIconFilter14" */ },
  	/*::[*/0x049E/*::]*/: { /* n:"BrtPivotCacheConnectionName" */ },
  	/*::[*/0x0800/*::]*/: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
  	/*::[*/0x0801/*::]*/: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
  	/*::[*/0x0802/*::]*/: { /* n:"BrtDecoupledPivotCacheID" */ },
  	/*::[*/0x0803/*::]*/: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
  	/*::[*/0x0804/*::]*/: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
  	/*::[*/0x0805/*::]*/: { /* n:"BrtPivotTableRef" */ },
  	/*::[*/0x0806/*::]*/: { /* n:"BrtSlicerCacheBookPivotTables" */ },
  	/*::[*/0x0807/*::]*/: { /* n:"BrtBeginSxvcells", */ T:1 },
  	/*::[*/0x0808/*::]*/: { /* n:"BrtEndSxvcells", */ T:-1 },
  	/*::[*/0x0809/*::]*/: { /* n:"BrtBeginSxRow", */ T:1 },
  	/*::[*/0x080A/*::]*/: { /* n:"BrtEndSxRow", */ T:-1 },
  	/*::[*/0x080C/*::]*/: { /* n:"BrtPcdCalcMem15" */ },
  	/*::[*/0x0813/*::]*/: { /* n:"BrtQsi15" */ },
  	/*::[*/0x0814/*::]*/: { /* n:"BrtBeginWebExtensions", */ T:1 },
  	/*::[*/0x0815/*::]*/: { /* n:"BrtEndWebExtensions", */ T:-1 },
  	/*::[*/0x0816/*::]*/: { /* n:"BrtWebExtension" */ },
  	/*::[*/0x0817/*::]*/: { /* n:"BrtAbsPath15" */ },
  	/*::[*/0x0818/*::]*/: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
  	/*::[*/0x0819/*::]*/: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
  	/*::[*/0x081B/*::]*/: { /* n:"BrtTableSlicerCacheIDs" */ },
  	/*::[*/0x081C/*::]*/: { /* n:"BrtTableSlicerCacheID" */ },
  	/*::[*/0x081D/*::]*/: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
  	/*::[*/0x081E/*::]*/: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
  	/*::[*/0x081F/*::]*/: { /* n:"BrtSxFilter15" */ },
  	/*::[*/0x0820/*::]*/: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
  	/*::[*/0x0821/*::]*/: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
  	/*::[*/0x0822/*::]*/: { /* n:"BrtTimelineCachePivotCacheID" */ },
  	/*::[*/0x0823/*::]*/: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
  	/*::[*/0x0824/*::]*/: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
  	/*::[*/0x0825/*::]*/: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
  	/*::[*/0x0826/*::]*/: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
  	/*::[*/0x0827/*::]*/: { /* n:"BrtBeginTimelinesEx", */ T:1 },
  	/*::[*/0x0828/*::]*/: { /* n:"BrtEndTimelinesEx", */ T:-1 },
  	/*::[*/0x0829/*::]*/: { /* n:"BrtBeginTimelineEx", */ T:1 },
  	/*::[*/0x082A/*::]*/: { /* n:"BrtEndTimelineEx", */ T:-1 },
  	/*::[*/0x082B/*::]*/: { /* n:"BrtWorkBookPr15" */ },
  	/*::[*/0x082C/*::]*/: { /* n:"BrtPCDH15" */ },
  	/*::[*/0x082D/*::]*/: { /* n:"BrtBeginTimelineStyle", */ T:1 },
  	/*::[*/0x082E/*::]*/: { /* n:"BrtEndTimelineStyle", */ T:-1 },
  	/*::[*/0x082F/*::]*/: { /* n:"BrtTimelineStyleElement" */ },
  	/*::[*/0x0830/*::]*/: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
  	/*::[*/0x0831/*::]*/: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
  	/*::[*/0x0832/*::]*/: { /* n:"BrtBeginTimelineStyles", */ T:1 },
  	/*::[*/0x0833/*::]*/: { /* n:"BrtEndTimelineStyles", */ T:-1 },
  	/*::[*/0x0834/*::]*/: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
  	/*::[*/0x0835/*::]*/: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
  	/*::[*/0x0836/*::]*/: { /* n:"BrtDxf15" */ },
  	/*::[*/0x0837/*::]*/: { /* n:"BrtBeginDxfs15", */ T:1 },
  	/*::[*/0x0838/*::]*/: { /* n:"BrtEndDxfs15", */ T:-1 },
  	/*::[*/0x0839/*::]*/: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
  	/*::[*/0x083A/*::]*/: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
  	/*::[*/0x083B/*::]*/: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
  	/*::[*/0x083C/*::]*/: { /* n:"BrtItemUniqueName" */ },
  	/*::[*/0x083D/*::]*/: { /* n:"BrtBeginExtConn15", */ T:1 },
  	/*::[*/0x083E/*::]*/: { /* n:"BrtEndExtConn15", */ T:-1 },
  	/*::[*/0x083F/*::]*/: { /* n:"BrtBeginOledbPr15", */ T:1 },
  	/*::[*/0x0840/*::]*/: { /* n:"BrtEndOledbPr15", */ T:-1 },
  	/*::[*/0x0841/*::]*/: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
  	/*::[*/0x0842/*::]*/: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
  	/*::[*/0x0843/*::]*/: { /* n:"BrtTextPr15" */ },
  	/*::[*/0x0844/*::]*/: { /* n:"BrtRangePr15" */ },
  	/*::[*/0x0845/*::]*/: { /* n:"BrtDbCommand15" */ },
  	/*::[*/0x0846/*::]*/: { /* n:"BrtBeginDbTables15", */ T:1 },
  	/*::[*/0x0847/*::]*/: { /* n:"BrtEndDbTables15", */ T:-1 },
  	/*::[*/0x0848/*::]*/: { /* n:"BrtDbTable15" */ },
  	/*::[*/0x0849/*::]*/: { /* n:"BrtBeginDataModel", */ T:1 },
  	/*::[*/0x084A/*::]*/: { /* n:"BrtEndDataModel", */ T:-1 },
  	/*::[*/0x084B/*::]*/: { /* n:"BrtBeginModelTables", */ T:1 },
  	/*::[*/0x084C/*::]*/: { /* n:"BrtEndModelTables", */ T:-1 },
  	/*::[*/0x084D/*::]*/: { /* n:"BrtModelTable" */ },
  	/*::[*/0x084E/*::]*/: { /* n:"BrtBeginModelRelationships", */ T:1 },
  	/*::[*/0x084F/*::]*/: { /* n:"BrtEndModelRelationships", */ T:-1 },
  	/*::[*/0x0850/*::]*/: { /* n:"BrtModelRelationship" */ },
  	/*::[*/0x0851/*::]*/: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
  	/*::[*/0x0852/*::]*/: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
  	/*::[*/0x0853/*::]*/: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
  	/*::[*/0x0854/*::]*/: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
  	/*::[*/0x0855/*::]*/: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
  	/*::[*/0x0856/*::]*/: { /* n:"BrtFieldListActiveItem" */ },
  	/*::[*/0x0857/*::]*/: { /* n:"BrtPivotCacheIdVersion" */ },
  	/*::[*/0x0858/*::]*/: { /* n:"BrtSXDI15" */ },
  	/*::[*/0x0859/*::]*/: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
  	/*::[*/0x085A/*::]*/: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
  	/*::[*/0x085B/*::]*/: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
  	/*::[*/0x085C/*::]*/: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
  	/*::[*/0x085D/*::]*/: { /* n:"BrtModelTimeGroupingCalcCol" */ },
  	/*::[*/0x0C00/*::]*/: { /* n:"BrtUid" */ },
  	/*::[*/0x0C01/*::]*/: { /* n:"BrtRevisionPtr" */ },
  	/*::[*/0x1000/*::]*/: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
  	/*::[*/0x1001/*::]*/: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
  	/*::[*/0x138A/*::]*/: { /* n:"BrtBeginRichValueBlock", */ T:1 },
  	/*::[*/0x138B/*::]*/: { /* n:"BrtEndRichValueBlock", */ T:-1 },
  	/*::[*/0x13D9/*::]*/: { /* n:"BrtBeginRichFilters", */ T:1 },
  	/*::[*/0x13DA/*::]*/: { /* n:"BrtEndRichFilters", */ T:-1 },
  	/*::[*/0x13DB/*::]*/: { /* n:"BrtRichFilter" */ },
  	/*::[*/0x13DC/*::]*/: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
  	/*::[*/0x13DD/*::]*/: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
  	/*::[*/0x13DE/*::]*/: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
  	/*::[*/0x13DF/*::]*/: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
  	/*::[*/0x13E0/*::]*/: { /* n:"BrtCustomRichFilter" */ },
  	/*::[*/0x13E1/*::]*/: { /* n:"BrtTop10RichFilter" */ },
  	/*::[*/0x13E2/*::]*/: { /* n:"BrtDynamicRichFilter" */ },
  	/*::[*/0x13E4/*::]*/: { /* n:"BrtBeginRichSortCondition", */ T:1 },
  	/*::[*/0x13E5/*::]*/: { /* n:"BrtEndRichSortCondition", */ T:-1 },
  	/*::[*/0x13E6/*::]*/: { /* n:"BrtRichFilterDateGroupItem" */ },
  	/*::[*/0x13E7/*::]*/: { /* n:"BrtBeginCalcFeatures", */ T:1 },
  	/*::[*/0x13E8/*::]*/: { /* n:"BrtEndCalcFeatures", */ T:-1 },
  	/*::[*/0x13E9/*::]*/: { /* n:"BrtCalcFeature" */ },
  	/*::[*/0x13EB/*::]*/: { /* n:"BrtExternalLinksPr" */ },
  	/*::[*/0xFFFF/*::]*/: { n:"" }
  };

  /* [MS-XLS] 2.3 Record Enumeration (and other sources) */
  var XLSRecordEnum = {
  	/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  	/*::[*/0x0006/*::]*/: { /* n:"Formula", */ f:parse_Formula },
  	/*::[*/0x000a/*::]*/: { /* n:"EOF", */ f:parsenoop2 },
  	/*::[*/0x000c/*::]*/: { /* n:"CalcCount", */ f:parseuint16 }, //
  	/*::[*/0x000d/*::]*/: { /* n:"CalcMode", */ f:parseuint16 }, //
  	/*::[*/0x000e/*::]*/: { /* n:"CalcPrecision", */ f:parsebool }, //
  	/*::[*/0x000f/*::]*/: { /* n:"CalcRefMode", */ f:parsebool }, //
  	/*::[*/0x0010/*::]*/: { /* n:"CalcDelta", */ f:parse_Xnum }, //
  	/*::[*/0x0011/*::]*/: { /* n:"CalcIter", */ f:parsebool }, //
  	/*::[*/0x0012/*::]*/: { /* n:"Protect", */ f:parsebool },
  	/*::[*/0x0013/*::]*/: { /* n:"Password", */ f:parseuint16 },
  	/*::[*/0x0014/*::]*/: { /* n:"Header", */ f:parse_XLHeaderFooter },
  	/*::[*/0x0015/*::]*/: { /* n:"Footer", */ f:parse_XLHeaderFooter },
  	/*::[*/0x0017/*::]*/: { /* n:"ExternSheet", */ f:parse_ExternSheet },
  	/*::[*/0x0018/*::]*/: { /* n:"Lbl", */ f:parse_Lbl },
  	/*::[*/0x0019/*::]*/: { /* n:"WinProtect", */ f:parsebool },
  	/*::[*/0x001a/*::]*/: { /* n:"VerticalPageBreaks", */ },
  	/*::[*/0x001b/*::]*/: { /* n:"HorizontalPageBreaks", */ },
  	/*::[*/0x001c/*::]*/: { /* n:"Note", */ f:parse_Note },
  	/*::[*/0x001d/*::]*/: { /* n:"Selection", */ },
  	/*::[*/0x0022/*::]*/: { /* n:"Date1904", */ f:parsebool },
  	/*::[*/0x0023/*::]*/: { /* n:"ExternName", */ f:parse_ExternName },
  	/*::[*/0x0026/*::]*/: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
  	/*::[*/0x0027/*::]*/: { /* n:"RightMargin", */ f:parse_Xnum }, // *
  	/*::[*/0x0028/*::]*/: { /* n:"TopMargin", */ f:parse_Xnum }, // *
  	/*::[*/0x0029/*::]*/: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
  	/*::[*/0x002a/*::]*/: { /* n:"PrintRowCol", */ f:parsebool },
  	/*::[*/0x002b/*::]*/: { /* n:"PrintGrid", */ f:parsebool },
  	/*::[*/0x002f/*::]*/: { /* n:"FilePass", */ f:parse_FilePass },
  	/*::[*/0x0031/*::]*/: { /* n:"Font", */ f:parse_Font },
  	/*::[*/0x0033/*::]*/: { /* n:"PrintSize", */ f:parseuint16 },
  	/*::[*/0x003c/*::]*/: { /* n:"Continue", */ },
  	/*::[*/0x003d/*::]*/: { /* n:"Window1", */ f:parse_Window1 },
  	/*::[*/0x0040/*::]*/: { /* n:"Backup", */ f:parsebool },
  	/*::[*/0x0041/*::]*/: { /* n:"Pane", */ f:parse_Pane },
  	/*::[*/0x0042/*::]*/: { /* n:"CodePage", */ f:parseuint16 },
  	/*::[*/0x004d/*::]*/: { /* n:"Pls", */ },
  	/*::[*/0x0050/*::]*/: { /* n:"DCon", */ },
  	/*::[*/0x0051/*::]*/: { /* n:"DConRef", */ },
  	/*::[*/0x0052/*::]*/: { /* n:"DConName", */ },
  	/*::[*/0x0055/*::]*/: { /* n:"DefColWidth", */ f:parseuint16 },
  	/*::[*/0x0059/*::]*/: { /* n:"XCT", */ },
  	/*::[*/0x005a/*::]*/: { /* n:"CRN", */ },
  	/*::[*/0x005b/*::]*/: { /* n:"FileSharing", */ },
  	/*::[*/0x005c/*::]*/: { /* n:"WriteAccess", */ f:parse_WriteAccess },
  	/*::[*/0x005d/*::]*/: { /* n:"Obj", */ f:parse_Obj },
  	/*::[*/0x005e/*::]*/: { /* n:"Uncalced", */ },
  	/*::[*/0x005f/*::]*/: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
  	/*::[*/0x0060/*::]*/: { /* n:"Template", */ },
  	/*::[*/0x0061/*::]*/: { /* n:"Intl", */ },
  	/*::[*/0x0063/*::]*/: { /* n:"ObjProtect", */ f:parsebool },
  	/*::[*/0x007d/*::]*/: { /* n:"ColInfo", */ f:parse_ColInfo },
  	/*::[*/0x0080/*::]*/: { /* n:"Guts", */ f:parse_Guts },
  	/*::[*/0x0081/*::]*/: { /* n:"WsBool", */ f:parse_WsBool },
  	/*::[*/0x0082/*::]*/: { /* n:"GridSet", */ f:parseuint16 },
  	/*::[*/0x0083/*::]*/: { /* n:"HCenter", */ f:parsebool },
  	/*::[*/0x0084/*::]*/: { /* n:"VCenter", */ f:parsebool },
  	/*::[*/0x0085/*::]*/: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
  	/*::[*/0x0086/*::]*/: { /* n:"WriteProtect", */ },
  	/*::[*/0x008c/*::]*/: { /* n:"Country", */ f:parse_Country },
  	/*::[*/0x008d/*::]*/: { /* n:"HideObj", */ f:parseuint16 },
  	/*::[*/0x0090/*::]*/: { /* n:"Sort", */ },
  	/*::[*/0x0092/*::]*/: { /* n:"Palette", */ f:parse_Palette },
  	/*::[*/0x0097/*::]*/: { /* n:"Sync", */ },
  	/*::[*/0x0098/*::]*/: { /* n:"LPr", */ },
  	/*::[*/0x0099/*::]*/: { /* n:"DxGCol", */ },
  	/*::[*/0x009a/*::]*/: { /* n:"FnGroupName", */ },
  	/*::[*/0x009b/*::]*/: { /* n:"FilterMode", */ },
  	/*::[*/0x009c/*::]*/: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
  	/*::[*/0x009d/*::]*/: { /* n:"AutoFilterInfo", */ },
  	/*::[*/0x009e/*::]*/: { /* n:"AutoFilter", */ },
  	/*::[*/0x00a0/*::]*/: { /* n:"Scl", */ f:parse_Scl },
  	/*::[*/0x00a1/*::]*/: { /* n:"Setup", */ f:parse_Setup },
  	/*::[*/0x00ae/*::]*/: { /* n:"ScenMan", */ },
  	/*::[*/0x00af/*::]*/: { /* n:"SCENARIO", */ },
  	/*::[*/0x00b0/*::]*/: { /* n:"SxView", */ },
  	/*::[*/0x00b1/*::]*/: { /* n:"Sxvd", */ },
  	/*::[*/0x00b2/*::]*/: { /* n:"SXVI", */ },
  	/*::[*/0x00b4/*::]*/: { /* n:"SxIvd", */ },
  	/*::[*/0x00b5/*::]*/: { /* n:"SXLI", */ },
  	/*::[*/0x00b6/*::]*/: { /* n:"SXPI", */ },
  	/*::[*/0x00b8/*::]*/: { /* n:"DocRoute", */ },
  	/*::[*/0x00b9/*::]*/: { /* n:"RecipName", */ },
  	/*::[*/0x00bd/*::]*/: { /* n:"MulRk", */ f:parse_MulRk },
  	/*::[*/0x00be/*::]*/: { /* n:"MulBlank", */ f:parse_MulBlank },
  	/*::[*/0x00c1/*::]*/: { /* n:"Mms", */ f:parsenoop2 },
  	/*::[*/0x00c5/*::]*/: { /* n:"SXDI", */ },
  	/*::[*/0x00c6/*::]*/: { /* n:"SXDB", */ },
  	/*::[*/0x00c7/*::]*/: { /* n:"SXFDB", */ },
  	/*::[*/0x00c8/*::]*/: { /* n:"SXDBB", */ },
  	/*::[*/0x00c9/*::]*/: { /* n:"SXNum", */ },
  	/*::[*/0x00ca/*::]*/: { /* n:"SxBool", */ f:parsebool },
  	/*::[*/0x00cb/*::]*/: { /* n:"SxErr", */ },
  	/*::[*/0x00cc/*::]*/: { /* n:"SXInt", */ },
  	/*::[*/0x00cd/*::]*/: { /* n:"SXString", */ },
  	/*::[*/0x00ce/*::]*/: { /* n:"SXDtr", */ },
  	/*::[*/0x00cf/*::]*/: { /* n:"SxNil", */ },
  	/*::[*/0x00d0/*::]*/: { /* n:"SXTbl", */ },
  	/*::[*/0x00d1/*::]*/: { /* n:"SXTBRGIITM", */ },
  	/*::[*/0x00d2/*::]*/: { /* n:"SxTbpg", */ },
  	/*::[*/0x00d3/*::]*/: { /* n:"ObProj", */ },
  	/*::[*/0x00d5/*::]*/: { /* n:"SXStreamID", */ },
  	/*::[*/0x00d7/*::]*/: { /* n:"DBCell", */ },
  	/*::[*/0x00d8/*::]*/: { /* n:"SXRng", */ },
  	/*::[*/0x00d9/*::]*/: { /* n:"SxIsxoper", */ },
  	/*::[*/0x00da/*::]*/: { /* n:"BookBool", */ f:parseuint16 },
  	/*::[*/0x00dc/*::]*/: { /* n:"DbOrParamQry", */ },
  	/*::[*/0x00dd/*::]*/: { /* n:"ScenarioProtect", */ f:parsebool },
  	/*::[*/0x00de/*::]*/: { /* n:"OleObjectSize", */ },
  	/*::[*/0x00e0/*::]*/: { /* n:"XF", */ f:parse_XF },
  	/*::[*/0x00e1/*::]*/: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
  	/*::[*/0x00e2/*::]*/: { /* n:"InterfaceEnd", */ f:parsenoop2 },
  	/*::[*/0x00e3/*::]*/: { /* n:"SXVS", */ },
  	/*::[*/0x00e5/*::]*/: { /* n:"MergeCells", */ f:parse_MergeCells },
  	/*::[*/0x00e9/*::]*/: { /* n:"BkHim", */ },
  	/*::[*/0x00eb/*::]*/: { /* n:"MsoDrawingGroup", */ },
  	/*::[*/0x00ec/*::]*/: { /* n:"MsoDrawing", */ },
  	/*::[*/0x00ed/*::]*/: { /* n:"MsoDrawingSelection", */ },
  	/*::[*/0x00ef/*::]*/: { /* n:"PhoneticInfo", */ },
  	/*::[*/0x00f0/*::]*/: { /* n:"SxRule", */ },
  	/*::[*/0x00f1/*::]*/: { /* n:"SXEx", */ },
  	/*::[*/0x00f2/*::]*/: { /* n:"SxFilt", */ },
  	/*::[*/0x00f4/*::]*/: { /* n:"SxDXF", */ },
  	/*::[*/0x00f5/*::]*/: { /* n:"SxItm", */ },
  	/*::[*/0x00f6/*::]*/: { /* n:"SxName", */ },
  	/*::[*/0x00f7/*::]*/: { /* n:"SxSelect", */ },
  	/*::[*/0x00f8/*::]*/: { /* n:"SXPair", */ },
  	/*::[*/0x00f9/*::]*/: { /* n:"SxFmla", */ },
  	/*::[*/0x00fb/*::]*/: { /* n:"SxFormat", */ },
  	/*::[*/0x00fc/*::]*/: { /* n:"SST", */ f:parse_SST },
  	/*::[*/0x00fd/*::]*/: { /* n:"LabelSst", */ f:parse_LabelSst },
  	/*::[*/0x00ff/*::]*/: { /* n:"ExtSST", */ f:parse_ExtSST },
  	/*::[*/0x0100/*::]*/: { /* n:"SXVDEx", */ },
  	/*::[*/0x0103/*::]*/: { /* n:"SXFormula", */ },
  	/*::[*/0x0122/*::]*/: { /* n:"SXDBEx", */ },
  	/*::[*/0x0137/*::]*/: { /* n:"RRDInsDel", */ },
  	/*::[*/0x0138/*::]*/: { /* n:"RRDHead", */ },
  	/*::[*/0x013b/*::]*/: { /* n:"RRDChgCell", */ },
  	/*::[*/0x013d/*::]*/: { /* n:"RRTabId", */ f:parseuint16a },
  	/*::[*/0x013e/*::]*/: { /* n:"RRDRenSheet", */ },
  	/*::[*/0x013f/*::]*/: { /* n:"RRSort", */ },
  	/*::[*/0x0140/*::]*/: { /* n:"RRDMove", */ },
  	/*::[*/0x014a/*::]*/: { /* n:"RRFormat", */ },
  	/*::[*/0x014b/*::]*/: { /* n:"RRAutoFmt", */ },
  	/*::[*/0x014d/*::]*/: { /* n:"RRInsertSh", */ },
  	/*::[*/0x014e/*::]*/: { /* n:"RRDMoveBegin", */ },
  	/*::[*/0x014f/*::]*/: { /* n:"RRDMoveEnd", */ },
  	/*::[*/0x0150/*::]*/: { /* n:"RRDInsDelBegin", */ },
  	/*::[*/0x0151/*::]*/: { /* n:"RRDInsDelEnd", */ },
  	/*::[*/0x0152/*::]*/: { /* n:"RRDConflict", */ },
  	/*::[*/0x0153/*::]*/: { /* n:"RRDDefName", */ },
  	/*::[*/0x0154/*::]*/: { /* n:"RRDRstEtxp", */ },
  	/*::[*/0x015f/*::]*/: { /* n:"LRng", */ },
  	/*::[*/0x0160/*::]*/: { /* n:"UsesELFs", */ f:parsebool },
  	/*::[*/0x0161/*::]*/: { /* n:"DSF", */ f:parsenoop2 },
  	/*::[*/0x0191/*::]*/: { /* n:"CUsr", */ },
  	/*::[*/0x0192/*::]*/: { /* n:"CbUsr", */ },
  	/*::[*/0x0193/*::]*/: { /* n:"UsrInfo", */ },
  	/*::[*/0x0194/*::]*/: { /* n:"UsrExcl", */ },
  	/*::[*/0x0195/*::]*/: { /* n:"FileLock", */ },
  	/*::[*/0x0196/*::]*/: { /* n:"RRDInfo", */ },
  	/*::[*/0x0197/*::]*/: { /* n:"BCUsrs", */ },
  	/*::[*/0x0198/*::]*/: { /* n:"UsrChk", */ },
  	/*::[*/0x01a9/*::]*/: { /* n:"UserBView", */ },
  	/*::[*/0x01aa/*::]*/: { /* n:"UserSViewBegin", */ },
  	/*::[*/0x01ab/*::]*/: { /* n:"UserSViewEnd", */ },
  	/*::[*/0x01ac/*::]*/: { /* n:"RRDUserView", */ },
  	/*::[*/0x01ad/*::]*/: { /* n:"Qsi", */ },
  	/*::[*/0x01ae/*::]*/: { /* n:"SupBook", */ f:parse_SupBook },
  	/*::[*/0x01af/*::]*/: { /* n:"Prot4Rev", */ f:parsebool },
  	/*::[*/0x01b0/*::]*/: { /* n:"CondFmt", */ },
  	/*::[*/0x01b1/*::]*/: { /* n:"CF", */ },
  	/*::[*/0x01b2/*::]*/: { /* n:"DVal", */ },
  	/*::[*/0x01b5/*::]*/: { /* n:"DConBin", */ },
  	/*::[*/0x01b6/*::]*/: { /* n:"TxO", */ f:parse_TxO },
  	/*::[*/0x01b7/*::]*/: { /* n:"RefreshAll", */ f:parsebool }, //
  	/*::[*/0x01b8/*::]*/: { /* n:"HLink", */ f:parse_HLink },
  	/*::[*/0x01b9/*::]*/: { /* n:"Lel", */ },
  	/*::[*/0x01ba/*::]*/: { /* n:"CodeName", */ f:parse_XLUnicodeString },
  	/*::[*/0x01bb/*::]*/: { /* n:"SXFDBType", */ },
  	/*::[*/0x01bc/*::]*/: { /* n:"Prot4RevPass", */ f:parseuint16 },
  	/*::[*/0x01bd/*::]*/: { /* n:"ObNoMacros", */ },
  	/*::[*/0x01be/*::]*/: { /* n:"Dv", */ },
  	/*::[*/0x01c0/*::]*/: { /* n:"Excel9File", */ f:parsenoop2 },
  	/*::[*/0x01c1/*::]*/: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
  	/*::[*/0x01c2/*::]*/: { /* n:"EntExU2", */ f:parsenoop2 },
  	/*::[*/0x0200/*::]*/: { /* n:"Dimensions", */ f:parse_Dimensions },
  	/*::[*/0x0201/*::]*/: { /* n:"Blank", */ f:parse_Blank },
  	/*::[*/0x0203/*::]*/: { /* n:"Number", */ f:parse_Number },
  	/*::[*/0x0204/*::]*/: { /* n:"Label", */ f:parse_Label },
  	/*::[*/0x0205/*::]*/: { /* n:"BoolErr", */ f:parse_BoolErr },
  	/*::[*/0x0207/*::]*/: { /* n:"String", */ f:parse_String },
  	/*::[*/0x0208/*::]*/: { /* n:"Row", */ f:parse_Row },
  	/*::[*/0x020b/*::]*/: { /* n:"Index", */ },
  	/*::[*/0x0221/*::]*/: { /* n:"Array", */ f:parse_Array },
  	/*::[*/0x0225/*::]*/: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
  	/*::[*/0x0236/*::]*/: { /* n:"Table", */ },
  	/*::[*/0x023e/*::]*/: { /* n:"Window2", */ f:parse_Window2 },
  	/*::[*/0x027e/*::]*/: { /* n:"RK", */ f:parse_RK },
  	/*::[*/0x0293/*::]*/: { /* n:"Style", */ },
  	/*::[*/0x0418/*::]*/: { /* n:"BigName", */ },
  	/*::[*/0x041e/*::]*/: { /* n:"Format", */ f:parse_Format },
  	/*::[*/0x043c/*::]*/: { /* n:"ContinueBigName", */ },
  	/*::[*/0x04bc/*::]*/: { /* n:"ShrFmla", */ f:parse_ShrFmla },
  	/*::[*/0x0800/*::]*/: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
  	/*::[*/0x0801/*::]*/: { /* n:"WebPub", */ },
  	/*::[*/0x0802/*::]*/: { /* n:"QsiSXTag", */ },
  	/*::[*/0x0803/*::]*/: { /* n:"DBQueryExt", */ },
  	/*::[*/0x0804/*::]*/: { /* n:"ExtString", */ },
  	/*::[*/0x0805/*::]*/: { /* n:"TxtQry", */ },
  	/*::[*/0x0806/*::]*/: { /* n:"Qsir", */ },
  	/*::[*/0x0807/*::]*/: { /* n:"Qsif", */ },
  	/*::[*/0x0808/*::]*/: { /* n:"RRDTQSIF", */ },
  	/*::[*/0x0809/*::]*/: { /* n:"BOF", */ f:parse_BOF },
  	/*::[*/0x080a/*::]*/: { /* n:"OleDbConn", */ },
  	/*::[*/0x080b/*::]*/: { /* n:"WOpt", */ },
  	/*::[*/0x080c/*::]*/: { /* n:"SXViewEx", */ },
  	/*::[*/0x080d/*::]*/: { /* n:"SXTH", */ },
  	/*::[*/0x080e/*::]*/: { /* n:"SXPIEx", */ },
  	/*::[*/0x080f/*::]*/: { /* n:"SXVDTEx", */ },
  	/*::[*/0x0810/*::]*/: { /* n:"SXViewEx9", */ },
  	/*::[*/0x0812/*::]*/: { /* n:"ContinueFrt", */ },
  	/*::[*/0x0813/*::]*/: { /* n:"RealTimeData", */ },
  	/*::[*/0x0850/*::]*/: { /* n:"ChartFrtInfo", */ },
  	/*::[*/0x0851/*::]*/: { /* n:"FrtWrapper", */ },
  	/*::[*/0x0852/*::]*/: { /* n:"StartBlock", */ },
  	/*::[*/0x0853/*::]*/: { /* n:"EndBlock", */ },
  	/*::[*/0x0854/*::]*/: { /* n:"StartObject", */ },
  	/*::[*/0x0855/*::]*/: { /* n:"EndObject", */ },
  	/*::[*/0x0856/*::]*/: { /* n:"CatLab", */ },
  	/*::[*/0x0857/*::]*/: { /* n:"YMult", */ },
  	/*::[*/0x0858/*::]*/: { /* n:"SXViewLink", */ },
  	/*::[*/0x0859/*::]*/: { /* n:"PivotChartBits", */ },
  	/*::[*/0x085a/*::]*/: { /* n:"FrtFontList", */ },
  	/*::[*/0x0862/*::]*/: { /* n:"SheetExt", */ },
  	/*::[*/0x0863/*::]*/: { /* n:"BookExt", */ r:12},
  	/*::[*/0x0864/*::]*/: { /* n:"SXAddl", */ },
  	/*::[*/0x0865/*::]*/: { /* n:"CrErr", */ },
  	/*::[*/0x0866/*::]*/: { /* n:"HFPicture", */ },
  	/*::[*/0x0867/*::]*/: { /* n:"FeatHdr", */ f:parsenoop2 },
  	/*::[*/0x0868/*::]*/: { /* n:"Feat", */ },
  	/*::[*/0x086a/*::]*/: { /* n:"DataLabExt", */ },
  	/*::[*/0x086b/*::]*/: { /* n:"DataLabExtContents", */ },
  	/*::[*/0x086c/*::]*/: { /* n:"CellWatch", */ },
  	/*::[*/0x0871/*::]*/: { /* n:"FeatHdr11", */ },
  	/*::[*/0x0872/*::]*/: { /* n:"Feature11", */ },
  	/*::[*/0x0874/*::]*/: { /* n:"DropDownObjIds", */ },
  	/*::[*/0x0875/*::]*/: { /* n:"ContinueFrt11", */ },
  	/*::[*/0x0876/*::]*/: { /* n:"DConn", */ },
  	/*::[*/0x0877/*::]*/: { /* n:"List12", */ },
  	/*::[*/0x0878/*::]*/: { /* n:"Feature12", */ },
  	/*::[*/0x0879/*::]*/: { /* n:"CondFmt12", */ },
  	/*::[*/0x087a/*::]*/: { /* n:"CF12", */ },
  	/*::[*/0x087b/*::]*/: { /* n:"CFEx", */ },
  	/*::[*/0x087c/*::]*/: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
  	/*::[*/0x087d/*::]*/: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
  	/*::[*/0x087e/*::]*/: { /* n:"AutoFilter12", */ },
  	/*::[*/0x087f/*::]*/: { /* n:"ContinueFrt12", */ },
  	/*::[*/0x0884/*::]*/: { /* n:"MDTInfo", */ },
  	/*::[*/0x0885/*::]*/: { /* n:"MDXStr", */ },
  	/*::[*/0x0886/*::]*/: { /* n:"MDXTuple", */ },
  	/*::[*/0x0887/*::]*/: { /* n:"MDXSet", */ },
  	/*::[*/0x0888/*::]*/: { /* n:"MDXProp", */ },
  	/*::[*/0x0889/*::]*/: { /* n:"MDXKPI", */ },
  	/*::[*/0x088a/*::]*/: { /* n:"MDB", */ },
  	/*::[*/0x088b/*::]*/: { /* n:"PLV", */ },
  	/*::[*/0x088c/*::]*/: { /* n:"Compat12", */ f:parsebool, r:12 },
  	/*::[*/0x088d/*::]*/: { /* n:"DXF", */ },
  	/*::[*/0x088e/*::]*/: { /* n:"TableStyles", */ r:12 },
  	/*::[*/0x088f/*::]*/: { /* n:"TableStyle", */ },
  	/*::[*/0x0890/*::]*/: { /* n:"TableStyleElement", */ },
  	/*::[*/0x0892/*::]*/: { /* n:"StyleExt", */ },
  	/*::[*/0x0893/*::]*/: { /* n:"NamePublish", */ },
  	/*::[*/0x0894/*::]*/: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
  	/*::[*/0x0895/*::]*/: { /* n:"SortData", */ },
  	/*::[*/0x0896/*::]*/: { /* n:"Theme", */ f:parse_Theme, r:12 },
  	/*::[*/0x0897/*::]*/: { /* n:"GUIDTypeLib", */ },
  	/*::[*/0x0898/*::]*/: { /* n:"FnGrp12", */ },
  	/*::[*/0x0899/*::]*/: { /* n:"NameFnGrp12", */ },
  	/*::[*/0x089a/*::]*/: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
  	/*::[*/0x089b/*::]*/: { /* n:"CompressPictures", */ f:parsenoop2 },
  	/*::[*/0x089c/*::]*/: { /* n:"HeaderFooter", */ },
  	/*::[*/0x089d/*::]*/: { /* n:"CrtLayout12", */ },
  	/*::[*/0x089e/*::]*/: { /* n:"CrtMlFrt", */ },
  	/*::[*/0x089f/*::]*/: { /* n:"CrtMlFrtContinue", */ },
  	/*::[*/0x08a3/*::]*/: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
  	/*::[*/0x08a4/*::]*/: { /* n:"ShapePropsStream", */ },
  	/*::[*/0x08a5/*::]*/: { /* n:"TextPropsStream", */ },
  	/*::[*/0x08a6/*::]*/: { /* n:"RichTextStream", */ },
  	/*::[*/0x08a7/*::]*/: { /* n:"CrtLayout12A", */ },
  	/*::[*/0x1001/*::]*/: { /* n:"Units", */ },
  	/*::[*/0x1002/*::]*/: { /* n:"Chart", */ },
  	/*::[*/0x1003/*::]*/: { /* n:"Series", */ },
  	/*::[*/0x1006/*::]*/: { /* n:"DataFormat", */ },
  	/*::[*/0x1007/*::]*/: { /* n:"LineFormat", */ },
  	/*::[*/0x1009/*::]*/: { /* n:"MarkerFormat", */ },
  	/*::[*/0x100a/*::]*/: { /* n:"AreaFormat", */ },
  	/*::[*/0x100b/*::]*/: { /* n:"PieFormat", */ },
  	/*::[*/0x100c/*::]*/: { /* n:"AttachedLabel", */ },
  	/*::[*/0x100d/*::]*/: { /* n:"SeriesText", */ },
  	/*::[*/0x1014/*::]*/: { /* n:"ChartFormat", */ },
  	/*::[*/0x1015/*::]*/: { /* n:"Legend", */ },
  	/*::[*/0x1016/*::]*/: { /* n:"SeriesList", */ },
  	/*::[*/0x1017/*::]*/: { /* n:"Bar", */ },
  	/*::[*/0x1018/*::]*/: { /* n:"Line", */ },
  	/*::[*/0x1019/*::]*/: { /* n:"Pie", */ },
  	/*::[*/0x101a/*::]*/: { /* n:"Area", */ },
  	/*::[*/0x101b/*::]*/: { /* n:"Scatter", */ },
  	/*::[*/0x101c/*::]*/: { /* n:"CrtLine", */ },
  	/*::[*/0x101d/*::]*/: { /* n:"Axis", */ },
  	/*::[*/0x101e/*::]*/: { /* n:"Tick", */ },
  	/*::[*/0x101f/*::]*/: { /* n:"ValueRange", */ },
  	/*::[*/0x1020/*::]*/: { /* n:"CatSerRange", */ },
  	/*::[*/0x1021/*::]*/: { /* n:"AxisLine", */ },
  	/*::[*/0x1022/*::]*/: { /* n:"CrtLink", */ },
  	/*::[*/0x1024/*::]*/: { /* n:"DefaultText", */ },
  	/*::[*/0x1025/*::]*/: { /* n:"Text", */ },
  	/*::[*/0x1026/*::]*/: { /* n:"FontX", */ f:parseuint16 },
  	/*::[*/0x1027/*::]*/: { /* n:"ObjectLink", */ },
  	/*::[*/0x1032/*::]*/: { /* n:"Frame", */ },
  	/*::[*/0x1033/*::]*/: { /* n:"Begin", */ },
  	/*::[*/0x1034/*::]*/: { /* n:"End", */ },
  	/*::[*/0x1035/*::]*/: { /* n:"PlotArea", */ },
  	/*::[*/0x103a/*::]*/: { /* n:"Chart3d", */ },
  	/*::[*/0x103c/*::]*/: { /* n:"PicF", */ },
  	/*::[*/0x103d/*::]*/: { /* n:"DropBar", */ },
  	/*::[*/0x103e/*::]*/: { /* n:"Radar", */ },
  	/*::[*/0x103f/*::]*/: { /* n:"Surf", */ },
  	/*::[*/0x1040/*::]*/: { /* n:"RadarArea", */ },
  	/*::[*/0x1041/*::]*/: { /* n:"AxisParent", */ },
  	/*::[*/0x1043/*::]*/: { /* n:"LegendException", */ },
  	/*::[*/0x1044/*::]*/: { /* n:"ShtProps", */ f:parse_ShtProps },
  	/*::[*/0x1045/*::]*/: { /* n:"SerToCrt", */ },
  	/*::[*/0x1046/*::]*/: { /* n:"AxesUsed", */ },
  	/*::[*/0x1048/*::]*/: { /* n:"SBaseRef", */ },
  	/*::[*/0x104a/*::]*/: { /* n:"SerParent", */ },
  	/*::[*/0x104b/*::]*/: { /* n:"SerAuxTrend", */ },
  	/*::[*/0x104e/*::]*/: { /* n:"IFmtRecord", */ },
  	/*::[*/0x104f/*::]*/: { /* n:"Pos", */ },
  	/*::[*/0x1050/*::]*/: { /* n:"AlRuns", */ },
  	/*::[*/0x1051/*::]*/: { /* n:"BRAI", */ },
  	/*::[*/0x105b/*::]*/: { /* n:"SerAuxErrBar", */ },
  	/*::[*/0x105c/*::]*/: { /* n:"ClrtClient", */ f:parse_ClrtClient },
  	/*::[*/0x105d/*::]*/: { /* n:"SerFmt", */ },
  	/*::[*/0x105f/*::]*/: { /* n:"Chart3DBarShape", */ },
  	/*::[*/0x1060/*::]*/: { /* n:"Fbi", */ },
  	/*::[*/0x1061/*::]*/: { /* n:"BopPop", */ },
  	/*::[*/0x1062/*::]*/: { /* n:"AxcExt", */ },
  	/*::[*/0x1063/*::]*/: { /* n:"Dat", */ },
  	/*::[*/0x1064/*::]*/: { /* n:"PlotGrowth", */ },
  	/*::[*/0x1065/*::]*/: { /* n:"SIIndex", */ },
  	/*::[*/0x1066/*::]*/: { /* n:"GelFrame", */ },
  	/*::[*/0x1067/*::]*/: { /* n:"BopPopCustom", */ },
  	/*::[*/0x1068/*::]*/: { /* n:"Fbi2", */ },

  	/*::[*/0x0000/*::]*/: { /* n:"Dimensions", */ f:parse_Dimensions },
  	/*::[*/0x0001/*::]*/: { /* n:"BIFF2BLANK", */ },
  	/*::[*/0x0002/*::]*/: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
  	/*::[*/0x0003/*::]*/: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
  	/*::[*/0x0004/*::]*/: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
  	/*::[*/0x0005/*::]*/: { /* n:"BoolErr", */ f:parse_BoolErr },
  	/*::[*/0x0007/*::]*/: { /* n:"String", */ f:parse_BIFF2STRING },
  	/*::[*/0x0008/*::]*/: { /* n:"BIFF2ROW", */ },
  	/*::[*/0x0009/*::]*/: { /* n:"BOF", */ f:parse_BOF },
  	/*::[*/0x000b/*::]*/: { /* n:"Index", */ },
  	/*::[*/0x0016/*::]*/: { /* n:"ExternCount", */ f:parseuint16 },
  	/*::[*/0x001e/*::]*/: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
  	/*::[*/0x001f/*::]*/: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
  	/*::[*/0x0020/*::]*/: { /* n:"BIFF2COLINFO", */ },
  	/*::[*/0x0021/*::]*/: { /* n:"Array", */ f:parse_Array },
  	/*::[*/0x0024/*::]*/: { /* n:"COLWIDTH", */ },
  	/*::[*/0x0025/*::]*/: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
  	// 0x2c ??
  	// 0x2d ??
  	// 0x2e ??
  	// 0x30 FONTCOUNT: number of fonts
  	/*::[*/0x0032/*::]*/: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
  	// 0x35: INFOOPTS
  	// 0x36: TABLE (BIFF2 only)
  	// 0x37: TABLE2 (BIFF2 only)
  	// 0x38: WNDESK
  	// 0x39 ??
  	// 0x3a: BEGINPREF
  	// 0x3b: ENDPREF
  	/*::[*/0x003e/*::]*/: { /* n:"BIFF2WINDOW2", */ },
  	// 0x3f ??
  	// 0x46: SHOWSCROLL
  	// 0x47: SHOWFORMULA
  	// 0x48: STATUSBAR
  	// 0x49: SHORTMENUS
  	// 0x4A:
  	// 0x4B:
  	// 0x4C:
  	// 0x4E:
  	// 0x4F:
  	// 0x58: TOOLBAR (BIFF3)

  	/* - - - */
  	/*::[*/0x0034/*::]*/: { /* n:"DDEObjName", */ },
  	/*::[*/0x0043/*::]*/: { /* n:"BIFF2XF", */ },
  	/*::[*/0x0044/*::]*/: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
  	/*::[*/0x0045/*::]*/: { /* n:"BIFF2FONTCLR", */ },
  	/*::[*/0x0056/*::]*/: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
  	/*::[*/0x007e/*::]*/: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
  	/*::[*/0x007f/*::]*/: { /* n:"ImData", */ f:parse_ImData },
  	/*::[*/0x0087/*::]*/: { /* n:"Addin", */ },
  	/*::[*/0x0088/*::]*/: { /* n:"Edg", */ },
  	/*::[*/0x0089/*::]*/: { /* n:"Pub", */ },
  	// 0x8A
  	// 0x8B LH: alternate menu key flag (BIFF3/4)
  	// 0x8E
  	// 0x8F
  	/*::[*/0x0091/*::]*/: { /* n:"Sub", */ },
  	// 0x93 STYLE
  	/*::[*/0x0094/*::]*/: { /* n:"LHRecord", */ },
  	/*::[*/0x0095/*::]*/: { /* n:"LHNGraph", */ },
  	/*::[*/0x0096/*::]*/: { /* n:"Sound", */ },
  	// 0xA2 FNPROTO: function prototypes (BIFF4)
  	// 0xA3
  	// 0xA8
  	/*::[*/0x00a9/*::]*/: { /* n:"CoordList", */ },
  	/*::[*/0x00ab/*::]*/: { /* n:"GCW", */ },
  	/*::[*/0x00bc/*::]*/: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
  	/*::[*/0x00bf/*::]*/: { /* n:"ToolbarHdr", */ },
  	/*::[*/0x00c0/*::]*/: { /* n:"ToolbarEnd", */ },
  	/*::[*/0x00c2/*::]*/: { /* n:"AddMenu", */ },
  	/*::[*/0x00c3/*::]*/: { /* n:"DelMenu", */ },
  	/*::[*/0x00d6/*::]*/: { /* n:"RString", */ f:parse_RString },
  	/*::[*/0x00df/*::]*/: { /* n:"UDDesc", */ },
  	/*::[*/0x00ea/*::]*/: { /* n:"TabIdConf", */ },
  	/*::[*/0x0162/*::]*/: { /* n:"XL5Modify", */ },
  	/*::[*/0x01a5/*::]*/: { /* n:"FileSharing2", */ },
  	/*::[*/0x0206/*::]*/: { /* n:"Formula", */ f:parse_Formula },
  	/*::[*/0x0209/*::]*/: { /* n:"BOF", */ f:parse_BOF },
  	/*::[*/0x0218/*::]*/: { /* n:"Lbl", */ f:parse_Lbl },
  	/*::[*/0x0223/*::]*/: { /* n:"ExternName", */ f:parse_ExternName },
  	/*::[*/0x0231/*::]*/: { /* n:"Font", */ },
  	/*::[*/0x0243/*::]*/: { /* n:"BIFF3XF", */ },
  	/*::[*/0x0406/*::]*/: { /* n:"Formula", */ f:parse_Formula },
  	/*::[*/0x0409/*::]*/: { /* n:"BOF", */ f:parse_BOF },
  	/*::[*/0x0443/*::]*/: { /* n:"BIFF4XF", */ },
  	/*::[*/0x086d/*::]*/: { /* n:"FeatInfo", */ },
  	/*::[*/0x0873/*::]*/: { /* n:"FeatInfo11", */ },
  	/*::[*/0x0881/*::]*/: { /* n:"SXAddl12", */ },
  	/*::[*/0x08c0/*::]*/: { /* n:"AutoWebPub", */ },
  	/*::[*/0x08c1/*::]*/: { /* n:"ListObj", */ },
  	/*::[*/0x08c2/*::]*/: { /* n:"ListField", */ },
  	/*::[*/0x08c3/*::]*/: { /* n:"ListDV", */ },
  	/*::[*/0x08c4/*::]*/: { /* n:"ListCondFmt", */ },
  	/*::[*/0x08c5/*::]*/: { /* n:"ListCF", */ },
  	/*::[*/0x08c6/*::]*/: { /* n:"FMQry", */ },
  	/*::[*/0x08c7/*::]*/: { /* n:"FMSQry", */ },
  	/*::[*/0x08c8/*::]*/: { /* n:"PLV", */ },
  	/*::[*/0x08c9/*::]*/: { /* n:"LnExt", */ },
  	/*::[*/0x08ca/*::]*/: { /* n:"MkrExt", */ },
  	/*::[*/0x08cb/*::]*/: { /* n:"CrtCoopt", */ },
  	/*::[*/0x08d6/*::]*/: { /* n:"FRTArchId$", */ r:12 },

  	/*::[*/0x7262/*::]*/: {}
  };

  function write_biff_rec(ba/*:BufArray*/, type/*:number*/, payload, length/*:?number*/)/*:void*/ {
  	var t/*:number*/ = type;
  	if(isNaN(t)) return;
  	var len = length || (payload||[]).length || 0;
  	var o = ba.next(4);
  	o.write_shift(2, t);
  	o.write_shift(2, len);
  	if(/*:: len != null &&*/len > 0 && is_buf(payload)) ba.push(payload);
  }
  /* note: browser DOM element cannot see mso- style attrs, must parse */
  function html_to_sheet(str/*:string*/, _opts)/*:Workbook*/ {
  	var opts = _opts || {};
  	var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
  	str = str.replace(/<!--.*?-->/g, "");
  	var mtch/*:any*/ = str.match(/<table/i);
  	if(!mtch) throw new Error("Invalid HTML: could not find <table>");
  	var mtch2/*:any*/ = str.match(/<\/table/i);
  	var i/*:number*/ = mtch.index, j/*:number*/ = mtch2 && mtch2.index || str.length;
  	var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
  	var R = -1, C = 0, RS = 0, CS = 0;
  	var range/*:Range*/ = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
  	var merges/*:Array<Range>*/ = [];
  	for(i = 0; i < rows.length; ++i) {
  		var row = rows[i].trim();
  		var hd = row.slice(0,3).toLowerCase();
  		if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
  		if(hd != "<td" && hd != "<th") continue;
  		var cells = row.split(/<\/t[dh]>/i);
  		for(j = 0; j < cells.length; ++j) {
  			var cell = cells[j].trim();
  			if(!cell.match(/<t[dh]/i)) continue;
  			var m = cell, cc = 0;
  			/* TODO: parse styles etc */
  			while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
  			for(var midx = 0; midx < merges.length; ++midx) {
  				var _merge/*:Range*/ = merges[midx];
  				if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
  			}
  			var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
  			CS = tag.colspan ? +tag.colspan : 1;
  			if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
  			var _t/*:string*/ = tag.t || tag["data-t"] || "";
  			/* TODO: generate stub cells */
  			if(!m.length) { C += CS; continue; }
  			m = htmldecode(m);
  			if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
  			if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
  			if(!m.length) { C += CS; continue; }
  			var o/*:Cell*/ = {t:'s', v:m};
  			if(opts.raw || !m.trim().length || _t == 's');
  			else if(m === 'TRUE') o = {t:'b', v:true};
  			else if(m === 'FALSE') o = {t:'b', v:false};
  			else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
  			else if(!isNaN(fuzzydate(m).getDate())) {
  				o = ({t:'d', v:parseDate(m)}/*:any*/);
  				if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
  				o.z = opts.dateNF || table_fmt[14];
  			}
  			if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
  			else ws[encode_cell({r:R, c:C})] = o;
  			C += CS;
  		}
  	}
  	ws['!ref'] = encode_range(range);
  	if(merges.length) ws["!merges"] = merges;
  	return ws;
  }
  function make_html_row(ws/*:Worksheet*/, r/*:Range*/, R/*:number*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
  	var M/*:Array<Range>*/ = (ws['!merges'] ||[]);
  	var oo/*:Array<string>*/ = [];
  	for(var C = r.s.c; C <= r.e.c; ++C) {
  		var RS = 0, CS = 0;
  		for(var j = 0; j < M.length; ++j) {
  			if(M[j].s.r > R || M[j].s.c > C) continue;
  			if(M[j].e.r < R || M[j].e.c < C) continue;
  			if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
  			RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
  		}
  		if(RS < 0) continue;
  		var coord = encode_cell({r:R,c:C});
  		var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
  		/* TODO: html entities */
  		var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
  		var sp = ({}/*:any*/);
  		if(RS > 1) sp.rowspan = RS;
  		if(CS > 1) sp.colspan = CS;
  		if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
  		else if(cell) {
  			sp["data-t"] = cell && cell.t || 'z';
  			if(cell.v != null) sp["data-v"] = cell.v;
  			if(cell.z != null) sp["data-z"] = cell.z;
  			if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
  		}
  		sp.id = (o.id || "sjs") + "-" + coord;
  		oo.push(writextag('td', w, sp));
  	}
  	var preamble = "<tr>";
  	return preamble + oo.join("") + "</tr>";
  }

  var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
  var HTML_END = '</body></html>';

  function html_to_workbook(str/*:string*/, opts)/*:Workbook*/ {
  	var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  	if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
  	if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
  	var wb = book_new();
  	mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
  	return wb;
  }

  function make_html_preamble(ws/*:Worksheet*/, R/*:Range*/, o/*:Sheet2HTMLOpts*/)/*:string*/ {
  	var out/*:Array<string>*/ = [];
  	return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
  }

  function sheet_to_html(ws/*:Worksheet*/, opts/*:?Sheet2HTMLOpts*//*, wb:?Workbook*/)/*:string*/ {
  	var o = opts || {};
  	var header = o.header != null ? o.header : HTML_BEGIN;
  	var footer = o.footer != null ? o.footer : HTML_END;
  	var out/*:Array<string>*/ = [header];
  	var r = decode_range(ws['!ref']);
  	o.dense = Array.isArray(ws);
  	out.push(make_html_preamble(ws, r, o));
  	for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
  	out.push("</table>" + footer);
  	return out.join("");
  }

  function sheet_add_dom(ws/*:Worksheet*/, table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
  	var opts = _opts || {};
  	var or_R = 0, or_C = 0;
  	if(opts.origin != null) {
  		if(typeof opts.origin == 'number') or_R = opts.origin;
  		else {
  			var _origin/*:CellAddress*/ = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
  			or_R = _origin.r; or_C = _origin.c;
  		}
  	}

  	var rows/*:HTMLCollection<HTMLTableRowElement>*/ = table.getElementsByTagName('tr');
  	var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
  	var range/*:Range*/ = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
  	if(ws["!ref"]) {
  		var _range/*:Range*/ = decode_range(ws["!ref"]);
  		range.s.r = Math.min(range.s.r, _range.s.r);
  		range.s.c = Math.min(range.s.c, _range.s.c);
  		range.e.r = Math.max(range.e.r, _range.e.r);
  		range.e.c = Math.max(range.e.c, _range.e.c);
  		if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
  	}
  	var merges/*:Array<Range>*/ = [], midx = 0;
  	var rowinfo/*:Array<RowInfo>*/ = ws["!rows"] || (ws["!rows"] = []);
  	var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
  	if(!ws["!cols"]) ws['!cols'] = [];
  	for(; _R < rows.length && R < sheetRows; ++_R) {
  		var row/*:HTMLTableRowElement*/ = rows[_R];
  		if (is_dom_element_hidden(row)) {
  			if (opts.display) continue;
  			rowinfo[R] = {hidden: true};
  		}
  		var elts/*:HTMLCollection<HTMLTableCellElement>*/ = (row.children/*:any*/);
  		for(_C = C = 0; _C < elts.length; ++_C) {
  			var elt/*:HTMLTableCellElement*/ = elts[_C];
  			if (opts.display && is_dom_element_hidden(elt)) continue;
  			var v/*:?string*/ = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
  			var z/*:?string*/ = elt.getAttribute('data-z') || elt.getAttribute('z');
  			for(midx = 0; midx < merges.length; ++midx) {
  				var m/*:Range*/ = merges[midx];
  				if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
  			}
  			/* TODO: figure out how to extract nonstandard mso- style */
  			CS = +elt.getAttribute("colspan") || 1;
  			if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
  			var o/*:Cell*/ = {t:'s', v:v};
  			var _t/*:string*/ = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
  			if(v != null) {
  				if(v.length == 0) o.t = _t || 'z';
  				else if(opts.raw || v.trim().length == 0 || _t == "s");
  				else if(v === 'TRUE') o = {t:'b', v:true};
  				else if(v === 'FALSE') o = {t:'b', v:false};
  				else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
  				else if(!isNaN(fuzzydate(v).getDate())) {
  					o = ({t:'d', v:parseDate(v)}/*:any*/);
  					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)}/*:any*/);
  					o.z = opts.dateNF || table_fmt[14];
  				}
  			}
  			if(o.z === undefined && z != null) o.z = z;
  			/* The first link is used.  Links are assumed to be fully specified.
  			 * TODO: The right way to process relative links is to make a new <a> */
  			var l = "", Aelts = elt.getElementsByTagName("A");
  			if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
  				l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
  			}
  			if(l && l.charAt(0) != "#") o.l = ({ Target: l });
  			if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
  			else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
  			if(range.e.c < C + or_C) range.e.c = C + or_C;
  			C += CS;
  		}
  		++R;
  	}
  	if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
  	range.e.r = Math.max(range.e.r, R - 1 + or_R);
  	ws['!ref'] = encode_range(range);
  	if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
  	return ws;
  }

  function parse_dom_table(table/*:HTMLElement*/, _opts/*:?any*/)/*:Worksheet*/ {
  	var opts = _opts || {};
  	var ws/*:Worksheet*/ = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
  	return sheet_add_dom(ws, table, _opts);
  }

  function table_to_book(table/*:HTMLElement*/, opts/*:?any*/)/*:Workbook*/ {
  	return sheet_to_workbook(parse_dom_table(table, opts), opts);
  }

  function is_dom_element_hidden(element/*:HTMLElement*/)/*:boolean*/ {
  	var display/*:string*/ = '';
  	var get_computed_style/*:?function*/ = get_get_computed_style_function(element);
  	if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
  	if(!display) display = element.style && element.style.display;
  	return display === 'none';
  }

  /* global getComputedStyle */
  function get_get_computed_style_function(element/*:HTMLElement*/)/*:?function*/ {
  	// The proper getComputedStyle implementation is the one defined in the element window
  	if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
  	// If it is not available, try to get one from the global namespace
  	if(typeof getComputedStyle === 'function') return getComputedStyle;
  	return null;
  }
  /* OpenDocument */
  function parse_text_p(text/*:string*//*::, tag*/)/*:Array<any>*/ {
  	/* 6.1.2 White Space Characters */
  	var fixed = text
  		.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
  		.replace(/<text:s\/>/g," ")
  		.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
  		.replace(/<text:tab[^>]*\/>/g,"\t")
  		.replace(/<text:line-break\/>/g,"\n");
  	var v = unescapexml(fixed.replace(/<[^>]*>/g,""));

  	return [v];
  }

  var number_formats_ods = {
  	/* ods name: [short ssf fmt, long ssf fmt] */
  	day:           ["d",   "dd"],
  	month:         ["m",   "mm"],
  	year:          ["y",   "yy"],
  	hours:         ["h",   "hh"],
  	minutes:       ["m",   "mm"],
  	seconds:       ["s",   "ss"],
  	"am-pm":       ["A/P", "AM/PM"],
  	"day-of-week": ["ddd", "dddd"],
  	era:           ["e",   "ee"],
  	/* there is no native representation of LO "Q" format */
  	quarter:       ["\\Qm", "m\\\"th quarter\""]
  };


  function parse_content_xml(d/*:string*/, _opts)/*:Workbook*/ {
  		var opts = _opts || {};
  		var str = xlml_normalize(d);
  		var state/*:Array<any>*/ = [], tmp;
  		var tag/*:: = {}*/;
  		var NFtag = {name:""}, NF = "", pidx = 0;
  		var sheetag/*:: = {name:"", '名称':""}*/;
  		var rowtag/*:: = {'行号':""}*/;
  		var Sheets = {}, SheetNames/*:Array<string>*/ = [];
  		var ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/);
  		var Rn, q/*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/;
  		var ctag = ({value:""}/*:any*/);
  		var textp = "", textpidx = 0;
  		var textR = [];
  		var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
  		var row_ol = 0;
  		var number_format_map = {};
  		var merges/*:Array<Range>*/ = [], mrange = {}, mR = 0, mC = 0;
  		var rowinfo/*:Array<RowInfo>*/ = [], rowpeat = 1, colpeat = 1;
  		var arrayf/*:Array<[Range, string]>*/ = [];
  		var WB = {Names:[]};
  		var atag = ({}/*:any*/);
  		var _Ref/*:[string, string]*/ = ["", ""];
  		var comments/*:Array<Comment>*/ = [], comment/*:Comment*/ = ({}/*:any*/);
  		var creator = "", creatoridx = 0;
  		var isstub = false, intable = false;
  		var i = 0;
  		xlmlregex.lastIndex = 0;
  		str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
  		while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {

  			case 'table': case '工作表': // 9.1.2 <table:table>
  				if(Rn[1]==='/') {
  					if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
  					else ws['!ref'] = "A1:A1";
  					if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
  						ws['!fullref'] = ws['!ref'];
  						range.e.r = opts.sheetRows - 1;
  						ws['!ref'] = encode_range(range);
  					}
  					if(merges.length) ws['!merges'] = merges;
  					if(rowinfo.length) ws["!rows"] = rowinfo;
  					sheetag.name = sheetag['名称'] || sheetag.name;
  					if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
  					SheetNames.push(sheetag.name);
  					Sheets[sheetag.name] = ws;
  					intable = false;
  				}
  				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
  					sheetag = parsexmltag(Rn[0], false);
  					R = C = -1;
  					range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
  					ws = opts.dense ? ([]/*:any*/) : ({}/*:any*/); merges = [];
  					rowinfo = [];
  					intable = true;
  				}
  				break;

  			case 'table-row-group': // 9.1.9 <table:table-row-group>
  				if(Rn[1] === "/") --row_ol; else ++row_ol;
  				break;
  			case 'table-row': case '行': // 9.1.3 <table:table-row>
  				if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
  				rowtag = parsexmltag(Rn[0], false);
  				if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
  				rowpeat = +rowtag['number-rows-repeated'] || 1;
  				/* TODO: remove magic */
  				if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
  				C = -1; break;
  			case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
  				if(Rn[1] !== '/') ++C;
  				if(opts.sheetStubs) {
  					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
  					else ws[encode_cell({r:R,c:C})] = {t:'z'};
  				}
  				textp = ""; textR = [];
  				break; /* stub */
  			case 'table-cell': case '数据':
  				if(Rn[0].charAt(Rn[0].length-2) === '/') {
  					++C;
  					ctag = parsexmltag(Rn[0], false);
  					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
  					q = ({t:'z', v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
  					if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
  					if((ctag['数据类型'] || ctag['value-type']) == "string") {
  						q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
  						if(opts.dense) {
  							if(!ws[R]) ws[R] = [];
  							ws[R][C] = q;
  						} else {
  							ws[encode_cell({r:R,c:C})] = q;
  						}
  					}
  					C+= colpeat-1;
  				} else if(Rn[1]!=='/') {
  					++C;
  					textp = ""; textpidx = 0; textR = [];
  					colpeat = 1;
  					var rptR = rowpeat ? R + rowpeat - 1 : R;
  					if(C > range.e.c) range.e.c = C;
  					if(C < range.s.c) range.s.c = C;
  					if(R < range.s.r) range.s.r = R;
  					if(rptR > range.e.r) range.e.r = rptR;
  					ctag = parsexmltag(Rn[0], false);
  					comments = []; comment = ({}/*:any*/);
  					q = ({t:ctag['数据类型'] || ctag['value-type'], v:null/*:: , z:null, w:"",c:[]*/}/*:any*/);
  					if(opts.cellFormula) {
  						if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
  						if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
  							mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
  							mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
  							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
  							q.F = encode_range(mrange);
  							arrayf.push([mrange, q.F]);
  						}
  						if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
  						else for(i = 0; i < arrayf.length; ++i)
  							if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
  								if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
  									q.F = arrayf[i][1];
  					}
  					if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
  						mR = parseInt(ctag['number-rows-spanned'],10) || 0;
  						mC = parseInt(ctag['number-columns-spanned'],10) || 0;
  						mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
  						merges.push(mrange);
  					}

  					/* 19.675.2 table:number-columns-repeated */
  					if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);

  					/* 19.385 office:value-type */
  					switch(q.t) {
  						case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
  						case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
  						case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
  						case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
  						case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
  							if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
  							q.z = 'm/d/yy'; break;
  						case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
  							if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
  							q.z = 'HH:MM:SS'; break;
  						case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
  						default:
  							if(q.t === 'string' || q.t === 'text' || !q.t) {
  								q.t = 's';
  								if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
  							} else throw new Error('Unsupported value type ' + q.t);
  					}
  				} else {
  					isstub = false;
  					if(q.t === 's') {
  						q.v = textp || '';
  						if(textR.length) q.R = textR;
  						isstub = textpidx == 0;
  					}
  					if(atag.Target) q.l = atag;
  					if(comments.length > 0) { q.c = comments; comments = []; }
  					if(textp && opts.cellText !== false) q.w = textp;
  					if(isstub) { q.t = "z"; delete q.v; }
  					if(!isstub || opts.sheetStubs) {
  						if(!(opts.sheetRows && opts.sheetRows <= R)) {
  							for(var rpt = 0; rpt < rowpeat; ++rpt) {
  								colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
  								if(opts.dense) {
  									if(!ws[R + rpt]) ws[R + rpt] = [];
  									ws[R + rpt][C] = rpt == 0 ? q : dup(q);
  									while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
  								} else {
  									ws[encode_cell({r:R + rpt,c:C})] = q;
  									while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
  								}
  								if(range.e.c <= C) range.e.c = C;
  							}
  						}
  					}
  					colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
  					C += colpeat-1; colpeat = 0;
  					q = {/*:: t:"", v:null, z:null, w:"",c:[]*/};
  					textp = ""; textR = [];
  				}
  				atag = ({}/*:any*/);
  				break; // 9.1.4 <table:table-cell>

  			/* pure state */
  			case 'document': // TODO: <office:document> is the root for FODS
  			case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
  			case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
  			case 'scripts': // 3.12 <office:scripts>
  			case 'styles': // TODO <office:styles>
  			case 'font-face-decls': // 3.14 <office:font-face-decls>
  			case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
  				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
  				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
  				break;

  			case 'annotation': // 14.1 <office:annotation>
  				if(Rn[1]==='/'){
  					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
  					comment.t = textp;
  					if(textR.length) /*::(*/comment/*:: :any)*/.R = textR;
  					comment.a = creator;
  					comments.push(comment);
  				}
  				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
  				creator = ""; creatoridx = 0;
  				textp = ""; textpidx = 0; textR = [];
  				break;

  			case 'creator': // 4.3.2.7 <dc:creator>
  				if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
  				else creatoridx = Rn.index + Rn[0].length;
  				break;

  			/* ignore state */
  			case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
  			case 'settings': // TODO: <office:settings>
  			case 'config-item-set': // TODO: <office:config-item-set>
  			case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
  			case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
  			case 'config-item-map-named': // TODO: <office:config-item-map-entry>
  			case 'shapes': // 9.2.8 <table:shapes>
  			case 'frame': // 10.4.2 <draw:frame>
  			case 'text-box': // 10.4.3 <draw:text-box>
  			case 'image': // 10.4.4 <draw:image>
  			case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
  			case 'list-style': // 16.30 <text:list-style>
  			case 'form': // 13.13 <form:form>
  			case 'dde-links': // 9.8 <table:dde-links>
  			case 'event-listeners': // TODO
  			case 'chart': // TODO
  				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
  				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
  				textp = ""; textpidx = 0; textR = [];
  				break;

  			case 'scientific-number': // TODO: <number:scientific-number>
  				break;
  			case 'currency-symbol': // TODO: <number:currency-symbol>
  				break;
  			case 'currency-style': // TODO: <number:currency-style>
  				break;
  			case 'number-style': // 16.27.2 <number:number-style>
  			case 'percentage-style': // 16.27.9 <number:percentage-style>
  			case 'date-style': // 16.27.10 <number:date-style>
  			case 'time-style': // 16.27.18 <number:time-style>
  				if(Rn[1]==='/'){
  					number_format_map[NFtag.name] = NF;
  					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
  				} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
  					NF = "";
  					NFtag = parsexmltag(Rn[0], false);
  					state.push([Rn[3], true]);
  				} break;

  			case 'script': break; // 3.13 <office:script>
  			case 'libraries': break; // TODO: <ooo:libraries>
  			case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>

  			case 'default-style': // TODO: <style:default-style>
  			case 'page-layout': break; // TODO: <style:page-layout>
  			case 'style': // 16.2 <style:style>
  				break;
  			case 'map': break; // 16.3 <style:map>
  			case 'font-face': break; // 16.21 <style:font-face>

  			case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
  			case 'table-properties': break; // 17.15 <style:table-properties>
  			case 'table-column-properties': break; // 17.16 <style:table-column-properties>
  			case 'table-row-properties': break; // 17.17 <style:table-row-properties>
  			case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>

  			case 'number': // 16.27.3 <number:number>
  				switch(state[state.length-1][0]) {
  					case 'time-style':
  					case 'date-style':
  						tag = parsexmltag(Rn[0], false);
  						NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
  				} break;

  			case 'fraction': break; // TODO 16.27.6 <number:fraction>

  			case 'day': // 16.27.11 <number:day>
  			case 'month': // 16.27.12 <number:month>
  			case 'year': // 16.27.13 <number:year>
  			case 'era': // 16.27.14 <number:era>
  			case 'day-of-week': // 16.27.15 <number:day-of-week>
  			case 'week-of-year': // 16.27.16 <number:week-of-year>
  			case 'quarter': // 16.27.17 <number:quarter>
  			case 'hours': // 16.27.19 <number:hours>
  			case 'minutes': // 16.27.20 <number:minutes>
  			case 'seconds': // 16.27.21 <number:seconds>
  			case 'am-pm': // 16.27.22 <number:am-pm>
  				switch(state[state.length-1][0]) {
  					case 'time-style':
  					case 'date-style':
  						tag = parsexmltag(Rn[0], false);
  						NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
  				} break;

  			case 'boolean-style': break; // 16.27.23 <number:boolean-style>
  			case 'boolean': break; // 16.27.24 <number:boolean>
  			case 'text-style': break; // 16.27.25 <number:text-style>
  			case 'text': // 16.27.26 <number:text>
  				if(Rn[0].slice(-2) === "/>") break;
  				else if(Rn[1]==="/") switch(state[state.length-1][0]) {
  					case 'number-style':
  					case 'date-style':
  					case 'time-style':
  						NF += str.slice(pidx, Rn.index);
  						break;
  				}
  				else pidx = Rn.index + Rn[0].length;
  				break;

  			case 'named-range': // 9.4.12 <table:named-range>
  				tag = parsexmltag(Rn[0], false);
  				_Ref = ods_to_csf_3D(tag['cell-range-address']);
  				var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]}/*:any*/);
  				if(intable) nrange.Sheet = SheetNames.length;
  				WB.Names.push(nrange);
  				break;

  			case 'text-content': break; // 16.27.27 <number:text-content>
  			case 'text-properties': break; // 16.27.27 <style:text-properties>
  			case 'embedded-text': break; // 16.27.4 <number:embedded-text>

  			case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3

  			case 'forms': break; // 12.25.2 13.2
  			case 'table-column': break; // 9.1.6 <table:table-column>
  			case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
  			case 'table-rows': break; // 9.1.12 <table:table-rows>
  			/* TODO: outline levels */
  			case 'table-column-group': break; // 9.1.10 <table:table-column-group>
  			case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
  			case 'table-columns': break; // 9.1.12 <table:table-columns>

  			case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904

  			case 'graphic-properties': break; // 17.21 <style:graphic-properties>
  			case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
  			case 'named-expressions': break; // 9.4.11 <table:named-expressions>
  			case 'label-range': break; // 9.4.9 <table:label-range>
  			case 'label-ranges': break; // 9.4.10 <table:label-ranges>
  			case 'named-expression': break; // 9.4.13 <table:named-expression>
  			case 'sort': break; // 9.4.19 <table:sort>
  			case 'sort-by': break; // 9.4.20 <table:sort-by>
  			case 'sort-groups': break; // 9.4.22 <table:sort-groups>

  			case 'tab': break; // 6.1.4 <text:tab>
  			case 'line-break': break; // 6.1.5 <text:line-break>
  			case 'span': break; // 6.1.7 <text:span>
  			case 'p': case '文本串': // 5.1.3 <text:p>
  				if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
  				if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
  					var ptp = parse_text_p(str.slice(textpidx,Rn.index));
  					textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
  				} else { parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
  				break; // <text:p>
  			case 's': break; // <text:s>

  			case 'database-range': // 9.4.15 <table:database-range>
  				if(Rn[1]==='/') break;
  				try {
  					_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
  					Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
  				} catch(e) {/* empty */}
  				break;

  			case 'date': break; // <*:date>

  			case 'object': break; // 10.4.6.2 <draw:object>
  			case 'title': case '标题': break; // <*:title> OR <uof:标题>
  			case 'desc': break; // <*:desc>
  			case 'binary-data': break; // 10.4.5 TODO: b64 blob

  			/* 9.2 Advanced Tables */
  			case 'table-source': break; // 9.2.6
  			case 'scenario': break; // 9.2.6

  			case 'iteration': break; // 9.4.3 <table:iteration>
  			case 'content-validations': break; // 9.4.4 <table:
  			case 'content-validation': break; // 9.4.5 <table:
  			case 'help-message': break; // 9.4.6 <table:
  			case 'error-message': break; // 9.4.7 <table:
  			case 'database-ranges': break; // 9.4.14 <table:database-ranges>
  			case 'filter': break; // 9.5.2 <table:filter>
  			case 'filter-and': break; // 9.5.3 <table:filter-and>
  			case 'filter-or': break; // 9.5.4 <table:filter-or>
  			case 'filter-condition': break; // 9.5.5 <table:filter-condition>

  			case 'list-level-style-bullet': break; // 16.31 <text:
  			case 'list-level-style-number': break; // 16.32 <text:
  			case 'list-level-properties': break; // 17.19 <style:

  			/* 7.3 Document Fields */
  			case 'sender-firstname': // 7.3.6.2
  			case 'sender-lastname': // 7.3.6.3
  			case 'sender-initials': // 7.3.6.4
  			case 'sender-title': // 7.3.6.5
  			case 'sender-position': // 7.3.6.6
  			case 'sender-email': // 7.3.6.7
  			case 'sender-phone-private': // 7.3.6.8
  			case 'sender-fax': // 7.3.6.9
  			case 'sender-company': // 7.3.6.10
  			case 'sender-phone-work': // 7.3.6.11
  			case 'sender-street': // 7.3.6.12
  			case 'sender-city': // 7.3.6.13
  			case 'sender-postal-code': // 7.3.6.14
  			case 'sender-country': // 7.3.6.15
  			case 'sender-state-or-province': // 7.3.6.16
  			case 'author-name': // 7.3.7.1
  			case 'author-initials': // 7.3.7.2
  			case 'chapter': // 7.3.8
  			case 'file-name': // 7.3.9
  			case 'template-name': // 7.3.9
  			case 'sheet-name': // 7.3.9
  				break;

  			case 'event-listener':
  				break;
  			/* TODO: FODS Properties */
  			case 'initial-creator':
  			case 'creation-date':
  			case 'print-date':
  			case 'generator':
  			case 'document-statistic':
  			case 'user-defined':
  			case 'editing-duration':
  			case 'editing-cycles':
  				break;

  			/* TODO: FODS Config */
  			case 'config-item':
  				break;

  			/* TODO: style tokens */
  			case 'page-number': break; // TODO <text:page-number>
  			case 'page-count': break; // TODO <text:page-count>
  			case 'time': break; // TODO <text:time>

  			/* 9.3 Advanced Table Cells */
  			case 'cell-range-source': break; // 9.3.1 <table:
  			case 'detective': break; // 9.3.2 <table:
  			case 'operation': break; // 9.3.3 <table:
  			case 'highlighted-range': break; // 9.3.4 <table:

  			/* 9.6 Data Pilot Tables <table: */
  			case 'data-pilot-table': // 9.6.3
  			case 'source-cell-range': // 9.6.5
  			case 'source-service': // 9.6.6
  			case 'data-pilot-field': // 9.6.7
  			case 'data-pilot-level': // 9.6.8
  			case 'data-pilot-subtotals': // 9.6.9
  			case 'data-pilot-subtotal': // 9.6.10
  			case 'data-pilot-members': // 9.6.11
  			case 'data-pilot-member': // 9.6.12
  			case 'data-pilot-display-info': // 9.6.13
  			case 'data-pilot-sort-info': // 9.6.14
  			case 'data-pilot-layout-info': // 9.6.15
  			case 'data-pilot-field-reference': // 9.6.16
  			case 'data-pilot-groups': // 9.6.17
  			case 'data-pilot-group': // 9.6.18
  			case 'data-pilot-group-member': // 9.6.19
  				break;

  			/* 10.3 Drawing Shapes */
  			case 'rect': // 10.3.2
  				break;

  			/* 14.6 DDE Connections */
  			case 'dde-connection-decls': // 14.6.2 <text:
  			case 'dde-connection-decl': // 14.6.3 <text:
  			case 'dde-link': // 14.6.4 <table:
  			case 'dde-source': // 14.6.5 <office:
  				break;

  			case 'properties': break; // 13.7 <form:properties>
  			case 'property': break; // 13.8 <form:property>

  			case 'a': // 6.1.8 hyperlink
  				if(Rn[1]!== '/') {
  					atag = parsexmltag(Rn[0], false);
  					if(!atag.href) break;
  					atag.Target = unescapexml(atag.href); delete atag.href;
  					if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
  						_Ref = ods_to_csf_3D(atag.Target.slice(1));
  						atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
  					} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
  				}
  				break;

  			/* non-standard */
  			case 'table-protection': break;
  			case 'data-pilot-grand-total': break; // <table:
  			case 'office-document-common-attrs': break; // bare
  			default: switch(Rn[2]) {
  				case 'dc:':       // TODO: properties
  				case 'calcext:':  // ignore undocumented extensions
  				case 'loext:':    // ignore undocumented extensions
  				case 'ooo:':      // ignore undocumented extensions
  				case 'chartooo:': // ignore undocumented extensions
  				case 'draw:':     // TODO: drawing
  				case 'style:':    // TODO: styles
  				case 'chart:':    // TODO: charts
  				case 'form:':     // TODO: forms
  				case 'uof:':      // TODO: uof
  				case '表:':       // TODO: uof
  				case '字:':       // TODO: uof
  					break;
  				default: if(opts.WTF) throw new Error(Rn);
  			}
  		}
  		var out/*:Workbook*/ = ({
  			Sheets: Sheets,
  			SheetNames: SheetNames,
  			Workbook: WB
  		}/*:any*/);
  		if(opts.bookSheets) delete /*::(*/out/*:: :any)*/.Sheets;
  		return out;
  }

  function parse_ods(zip/*:ZIPFile*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	opts = opts || ({}/*:any*/);
  	if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
  	var content = getzipstr(zip, 'content.xml');
  	if(!content) throw new Error("Missing content.xml in ODS / UOF file");
  	var wb = parse_content_xml(utf8read(content), opts);
  	if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
  	return wb;
  }
  function parse_fods(data/*:string*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	return parse_content_xml(data, opts);
  }

  /*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
  function u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
  }
  function u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
  }
  function u8concat(u8a) {
    var len = u8a.reduce(function(acc, x) {
      return acc + x.length;
    }, 0);
    var out = new Uint8Array(len);
    var off = 0;
    u8a.forEach(function(u8) {
      out.set(u8, off);
      off += u8.length;
    });
    return out;
  }
  function popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
  }
  function readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for (var j = offset + 13; j >= offset; --j)
      mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
  }
  function parse_varint49(buf, ptr) {
    var l = ptr ? ptr[0] : 0;
    var usz = buf[l] & 127;
    varint:
      if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128)
          break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128)
          break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128)
          break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128)
          break varint;
      }
    if (ptr)
      ptr[0] = l;
    return usz;
  }
  function varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    varint:
      if (buf[l++] >= 128) {
        i32 |= (buf[l] & 127) << 7;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 14;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 21;
        if (buf[l++] < 128)
          break varint;
        i32 |= (buf[l] & 127) << 28;
      }
    return i32;
  }
  function parse_shallow(buf) {
    var out = [], ptr = [0];
    while (ptr[0] < buf.length) {
      var off = ptr[0];
      var num = parse_varint49(buf, ptr);
      var type = num & 7;
      num = Math.floor(num / 8);
      var len = 0;
      var res;
      if (num == 0)
        break;
      switch (type) {
        case 0:
          {
            var l = ptr[0];
            while (buf[ptr[0]++] >= 128)
              ;
            res = buf.slice(l, ptr[0]);
          }
          break;
        case 5:
          len = 4;
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 1:
          len = 8;
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 2:
          len = parse_varint49(buf, ptr);
          res = buf.slice(ptr[0], ptr[0] + len);
          ptr[0] += len;
          break;
        case 3:
        case 4:
        default:
          throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
      }
      var v = { data: res, type: type };
      if (out[num] == null)
        out[num] = [v];
      else
        out[num].push(v);
    }
    return out;
  }
  function mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
      return cb(d.data);
    })) || [];
  }
  function parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = [0];
    while (ptr[0] < buf.length) {
      var len = parse_varint49(buf, ptr);
      var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
      ptr[0] += len;
      var res = {
        id: varint_to_i32(ai[1][0].data),
        messages: []
      };
      ai[2].forEach(function(b) {
        var mi = parse_shallow(b.data);
        var fl = varint_to_i32(mi[3][0].data);
        res.messages.push({
          meta: mi,
          data: buf.slice(ptr[0], ptr[0] + fl)
        });
        ptr[0] += fl;
      });
      if ((_a = ai[3]) == null ? void 0 : _a[0])
        res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
      out.push(res);
    }
    return out;
  }
  function parse_snappy_chunk(type, buf) {
    if (type != 0)
      throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = [0];
    var usz = parse_varint49(buf, ptr);
    var chunks = [];
    while (ptr[0] < buf.length) {
      var tag = buf[ptr[0]] & 3;
      if (tag == 0) {
        var len = buf[ptr[0]++] >> 2;
        if (len < 60)
          ++len;
        else {
          var c = len - 59;
          len = buf[ptr[0]];
          if (c > 1)
            len |= buf[ptr[0] + 1] << 8;
          if (c > 2)
            len |= buf[ptr[0] + 2] << 16;
          if (c > 3)
            len |= buf[ptr[0] + 3] << 24;
          len >>>= 0;
          len++;
          ptr[0] += c;
        }
        chunks.push(buf.slice(ptr[0], ptr[0] + len));
        ptr[0] += len;
        continue;
      } else {
        var offset = 0, length = 0;
        if (tag == 1) {
          length = (buf[ptr[0]] >> 2 & 7) + 4;
          offset = (buf[ptr[0]++] & 224) << 3;
          offset |= buf[ptr[0]++];
        } else {
          length = (buf[ptr[0]++] >> 2) + 1;
          if (tag == 2) {
            offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
            ptr[0] += 2;
          } else {
            offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
            ptr[0] += 4;
          }
        }
        chunks = [u8concat(chunks)];
        if (offset == 0)
          throw new Error("Invalid offset 0");
        if (offset > chunks[0].length)
          throw new Error("Invalid offset beyond length");
        if (length >= offset) {
          chunks.push(chunks[0].slice(-offset));
          length -= offset;
          while (length >= chunks[chunks.length - 1].length) {
            chunks.push(chunks[chunks.length - 1]);
            length -= chunks[chunks.length - 1].length;
          }
        }
        chunks.push(chunks[0].slice(-offset, -offset + length));
      }
    }
    var o = u8concat(chunks);
    if (o.length != usz)
      throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
    return o;
  }
  function decompress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while (l < buf.length) {
      var t = buf[l++];
      var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
      l += 3;
      out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
      l += len;
    }
    if (l !== buf.length)
      throw new Error("data is not a valid framed stream!");
    return u8concat(out);
  }
  function parse_old_storage(buf, sst, rsst, v) {
    var dv = u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
    var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 512) {
      ridx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
      sidx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    if (flags & 32) {
      ieee = dv.getFloat64(data_offset, true);
      data_offset += 8;
    }
    if (flags & 64) {
      dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
      data_offset += 8;
    }
    var ret;
    switch (buf[2]) {
      case 0:
        break;
      case 2:
        ret = { t: "n", v: ieee };
        break;
      case 3:
        ret = { t: "s", v: sst[sidx] };
        break;
      case 5:
        ret = { t: "d", v: dt };
        break;
      case 6:
        ret = { t: "b", v: ieee > 0 };
        break;
      case 7:
        ret = { t: "n", v: ieee / 86400 };
        break;
      case 8:
        ret = { t: "e", v: 0 };
        break;
      case 9:
        {
          if (ridx > -1)
            ret = { t: "s", v: rsst[ridx] };
          else if (sidx > -1)
            ret = { t: "s", v: sst[sidx] };
          else if (!isNaN(ieee))
            ret = { t: "n", v: ieee };
          else
            throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
        }
        break;
      default:
        throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
    }
    return ret;
  }
  function parse_new_storage(buf, sst, rsst) {
    var dv = u8_to_dataview(buf);
    var flags = dv.getUint32(8, true);
    var data_offset = 12;
    var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
    if (flags & 1) {
      d128 = readDecimal128LE(buf, data_offset);
      data_offset += 16;
    }
    if (flags & 2) {
      ieee = dv.getFloat64(data_offset, true);
      data_offset += 8;
    }
    if (flags & 4) {
      dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
      data_offset += 8;
    }
    if (flags & 8) {
      sidx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    if (flags & 16) {
      ridx = dv.getUint32(data_offset, true);
      data_offset += 4;
    }
    var ret;
    switch (buf[1]) {
      case 0:
        break;
      case 2:
        ret = { t: "n", v: d128 };
        break;
      case 3:
        ret = { t: "s", v: sst[sidx] };
        break;
      case 5:
        ret = { t: "d", v: dt };
        break;
      case 6:
        ret = { t: "b", v: ieee > 0 };
        break;
      case 7:
        ret = { t: "n", v: ieee / 86400 };
        break;
      case 8:
        ret = { t: "e", v: 0 };
        break;
      case 9:
        {
          if (ridx > -1)
            ret = { t: "s", v: rsst[ridx] };
          else
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
        }
        break;
      case 10:
        ret = { t: "n", v: d128 };
        break;
      default:
        throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
    }
    return ret;
  }
  function parse_cell_storage(buf, sst, rsst) {
    switch (buf[0]) {
      case 0:
      case 1:
      case 2:
      case 3:
        return parse_old_storage(buf, sst, rsst, buf[0]);
      case 5:
        return parse_new_storage(buf, sst, rsst);
      default:
        throw new Error("Unsupported payload version ".concat(buf[0]));
    }
  }
  function parse_TSP_Reference(buf) {
    var pb = parse_shallow(buf);
    return parse_varint49(pb[1][0].data);
  }
  function parse_TST_TableDataList(M, root) {
    var pb = parse_shallow(root.data);
    var type = varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
      var le = parse_shallow(entry.data);
      var key = varint_to_i32(le[1][0].data) >>> 0;
      switch (type) {
        case 1:
          data[key] = u8str(le[3][0].data);
          break;
        case 8:
          {
            var rt = M[parse_TSP_Reference(le[9][0].data)][0];
            var rtp = parse_shallow(rt.data);
            var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
            var mtype = varint_to_i32(rtpref.meta[1][0].data);
            if (mtype != 2001)
              throw new Error("2000 unexpected reference to ".concat(mtype));
            var tswpsa = parse_shallow(rtpref.data);
            data[key] = tswpsa[3].map(function(x) {
              return u8str(x.data);
            }).join("");
          }
          break;
      }
    });
    return data;
  }
  function parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = parse_shallow(u8);
    var R = varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
      used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
      used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
      used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
      used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else
      throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = u8_to_dataview(used_storage_u8);
    var offsets = [];
    for (var C = 0; C < used_storage_u8.length / 2; ++C) {
      var off = used_storage_offsets.getUint16(C * 2, true);
      if (off < 65535)
        offsets.push([C, off]);
    }
    if (offsets.length != cnt)
      throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for (C = 0; C < offsets.length - 1; ++C)
      cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1)
      cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
    return { R: R, cells: cells };
  }
  function parse_TST_Tile(M, root) {
    var _a;
    var pb = parse_shallow(root.data);
    var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
    var ri = mappa(pb[5], function(u8) {
      return parse_TST_TileRowInfo(u8, storage);
    });
    return {
      nrows: varint_to_i32(pb[4][0].data) >>> 0,
      data: ri.reduce(function(acc, x) {
        if (!acc[x.R])
          acc[x.R] = [];
        x.cells.forEach(function(cell, C) {
          if (acc[x.R][C])
            throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
          acc[x.R][C] = cell;
        });
        return acc;
      }, [])
    };
  }
  function parse_TST_TableModelArchive(M, root, ws) {
    var _a;
    var pb = parse_shallow(root.data);
    var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
    range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0)
      throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0)
      throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = encode_range(range);
    var store = parse_shallow(pb[4][0].data);
    var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
    var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
    var tile = parse_shallow(store[3][0].data);
    var _R = 0;
    tile[1].forEach(function(t) {
      var tl = parse_shallow(t.data);
      var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
      var mtype = varint_to_i32(ref.meta[1][0].data);
      if (mtype != 6002)
        throw new Error("6001 unexpected reference to ".concat(mtype));
      var _tile = parse_TST_Tile(M, ref);
      _tile.data.forEach(function(row, R) {
        row.forEach(function(buf, C) {
          var addr = encode_cell({ r: _R + R, c: C });
          var res = parse_cell_storage(buf, sst, rsst);
          if (res)
            ws[addr] = res;
        });
      });
      _R += _tile.nrows;
    });
  }
  function parse_TST_TableInfoArchive(M, root) {
    var pb = parse_shallow(root.data);
    var out = { "!ref": "A1" };
    var tableref = M[parse_TSP_Reference(pb[2][0].data)];
    var mtype = varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001)
      throw new Error("6000 unexpected reference to ".concat(mtype));
    parse_TST_TableModelArchive(M, tableref[0], out);
    return out;
  }
  function parse_TN_SheetArchive(M, root) {
    var _a;
    var pb = parse_shallow(root.data);
    var out = {
      name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
      sheets: []
    };
    var shapeoffs = mappa(pb[2], parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
      M[off].forEach(function(m) {
        var mtype = varint_to_i32(m.meta[1][0].data);
        if (mtype == 6e3)
          out.sheets.push(parse_TST_TableInfoArchive(M, m));
      });
    });
    return out;
  }
  function parse_TN_DocumentArchive(M, root) {
    var out = book_new();
    var pb = parse_shallow(root.data);
    var sheetoffs = mappa(pb[1], parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
      M[off].forEach(function(m) {
        var mtype = varint_to_i32(m.meta[1][0].data);
        if (mtype == 2) {
          var root2 = parse_TN_SheetArchive(M, m);
          root2.sheets.forEach(function(sheet, idx) {
            book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
          });
        }
      });
    });
    if (out.SheetNames.length == 0)
      throw new Error("Empty NUMBERS file");
    return out;
  }
  function parse_numbers_iwa(cfb) {
    var _a, _b, _c, _d;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
      if (p.match(/\.iwpv2/))
        throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
      if (!s.name.match(/\.iwa$/))
        return;
      var o;
      try {
        o = decompress_iwa_file(s.content);
      } catch (e) {
        return console.log("?? " + s.content.length + " " + (e.message || e));
      }
      var packets;
      try {
        packets = parse_iwa_file(o);
      } catch (e) {
        return console.log("## " + (e.message || e));
      }
      packets.forEach(function(packet) {
        M[packet.id] = packet.messages;
        indices.push(packet.id);
      });
    });
    if (!indices.length)
      throw new Error("File has no messages");
    var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot)
      indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
          var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
          if (mtype == 1) {
            if (!docroot)
              docroot = iwam;
            else
              throw new Error("Document has multiple roots");
          }
        });
      });
    if (!docroot)
      throw new Error("Cannot find Document root");
    return parse_TN_DocumentArchive(M, docroot);
  }
  function fix_opts_func(defaults/*:Array<Array<any> >*/)/*:{(o:any):void}*/ {
  	return function fix_opts(opts) {
  		for(var i = 0; i != defaults.length; ++i) {
  			var d = defaults[i];
  			if(opts[d[0]] === undefined) opts[d[0]] = d[1];
  			if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
  		}
  	};
  }

  function fix_read_opts(opts) {
  fix_opts_func([
  	['cellNF', false], /* emit cell number format string as .z */
  	['cellHTML', true], /* emit html string as .h */
  	['cellFormula', true], /* emit formulae as .f */
  	['cellStyles', false], /* emits style/theme as .s */
  	['cellText', true], /* emit formatted text as .w */
  	['cellDates', false], /* emit date cells with type `d` */

  	['sheetStubs', false], /* emit empty cells */
  	['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */

  	['bookDeps', false], /* parse calculation chains */
  	['bookSheets', false], /* only try to get sheet names (no Sheets) */
  	['bookProps', false], /* only try to get properties (no Sheets) */
  	['bookFiles', false], /* include raw file structure (keys, files, cfb) */
  	['bookVBA', false], /* include vba raw data (vbaraw) */

  	['password',''], /* password */
  	['WTF', false] /* WTF mode (throws errors) */
  ])(opts);
  }
  function get_sheet_type(n/*:string*/)/*:string*/ {
  	if(RELS.WS.indexOf(n) > -1) return "sheet";
  	if(n == RELS.CS) return "chart";
  	if(n == RELS.DS) return "dialog";
  	if(n == RELS.MS) return "macro";
  	return (n && n.length) ? n : "sheet";
  }
  function safe_parse_wbrels(wbrels, sheets) {
  	if(!wbrels) return 0;
  	try {
  		wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
  	} catch(e) { return null; }
  	return !wbrels || wbrels.length === 0 ? null : wbrels;
  }

  function safe_parse_sheet(zip, path/*:string*/, relsPath/*:string*/, sheet, idx/*:number*/, sheetRels, sheets, stype/*:string*/, opts, wb, themes, styles) {
  	try {
  		sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
  		var data = getzipdata(zip, path);
  		var _ws;
  		switch(stype) {
  			case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
  			case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
  				if(!_ws || !_ws['!drawel']) break;
  				var dfile = resolve_path(_ws['!drawel'].Target, path);
  				var drelsp = get_rels_path(dfile);
  				var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
  				var chartp = resolve_path(draw, dfile);
  				var crelsp = get_rels_path(chartp);
  				_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
  				break;
  			case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
  			case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
  			default: throw new Error("Unrecognized sheet type " + stype);
  		}
  		sheets[sheet] = _ws;

  		/* scan rels for comments and threaded comments */
  		var tcomments = [];
  		if(sheetRels && sheetRels[sheet]) keys$1(sheetRels[sheet]).forEach(function(n) {
  			var dfile = "";
  			if(sheetRels[sheet][n].Type == RELS.CMNT) {
  				dfile = resolve_path(sheetRels[sheet][n].Target, path);
  				var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
  				if(!comments || !comments.length) return;
  				sheet_insert_comments(_ws, comments, false);
  			}
  			if(sheetRels[sheet][n].Type == RELS.TCMNT) {
  				dfile = resolve_path(sheetRels[sheet][n].Target, path);
  				tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
  			}
  		});
  		if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
  	} catch(e) { if(opts.WTF) throw e; }
  }

  function strip_front_slash(x/*:string*/)/*:string*/ { return x.charAt(0) == '/' ? x.slice(1) : x; }

  function parse_zip(zip/*:ZIP*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	make_ssf();
  	opts = opts || {};
  	fix_read_opts(opts);

  	/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
  	if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
  	/* UOC */
  	if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
  	/* Numbers */
  	if(safegetzipfile(zip, 'Index/Document.iwa')) {
  		if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
  		if(typeof parse_numbers_iwa != "undefined") {
  			if(zip.FileIndex) return parse_numbers_iwa(zip);
  			var _zip = CFB.utils.cfb_new();
  			zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
  			return parse_numbers_iwa(_zip);
  		}
  		throw new Error('Unsupported NUMBERS file');
  	}
  	if(!safegetzipfile(zip, '[Content_Types].xml')) {
  		if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
  		if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
  		throw new Error('Unsupported ZIP file');
  	}

  	var entries = zipentries(zip);
  	var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')/*:?any*/));
  	var xlsb = false;
  	var sheets, binname;
  	if(dir.workbooks.length === 0) {
  		binname = "xl/workbook.xml";
  		if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
  	}
  	if(dir.workbooks.length === 0) {
  		binname = "xl/workbook.bin";
  		if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
  		dir.workbooks.push(binname);
  		xlsb = true;
  	}
  	if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;

  	var themes = ({}/*:any*/);
  	var styles = ({}/*:any*/);
  	if(!opts.bookSheets && !opts.bookProps) {
  		strs = [];
  		if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }

  		if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);

  		if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
  	}

  	/*var externbooks = */dir.links.map(function(link) {
  		try {
  			var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
  			return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
  		} catch(e) {}
  	});

  	var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);

  	var props = {}, propdata = "";

  	if(dir.coreprops.length) {
  		propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
  		if(propdata) props = parse_core_props(propdata);
  		if(dir.extprops.length !== 0) {
  			propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
  			if(propdata) parse_ext_props(propdata, props, opts);
  		}
  	}

  	var custprops = {};
  	if(!opts.bookSheets || opts.bookProps) {
  		if (dir.custprops.length !== 0) {
  			propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
  			if(propdata) custprops = parse_cust_props(propdata, opts);
  		}
  	}

  	var out = ({}/*:any*/);
  	if(opts.bookSheets || opts.bookProps) {
  		if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
  		else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
  		if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
  		if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
  		if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
  	}
  	sheets = {};

  	var deps = {};
  	if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain);

  	var i=0;
  	var sheetRels = ({}/*:any*/);
  	var path, relsPath;

  	{
  		var wbsheets = wb.Sheets;
  		props.Worksheets = wbsheets.length;
  		props.SheetNames = [];
  		for(var j = 0; j != wbsheets.length; ++j) {
  			props.SheetNames[j] = wbsheets[j].name;
  		}
  	}

  	var wbext = xlsb ? "bin" : "xml";
  	var wbrelsi = dir.workbooks[0].lastIndexOf("/");
  	var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
  	if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
  	var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));

  	if((dir.metadata || []).length >= 1) {
  		/* TODO: MDX and other types of metadata */
  		opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
  	}

  	if((dir.people || []).length >= 1) {
  		opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
  	}

  	if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);

  	/* Numbers iOS hack */
  	var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
  	wsloop: for(i = 0; i != props.Worksheets; ++i) {
  		var stype = "sheet";
  		if(wbrels && wbrels[i]) {
  			path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
  			if(!safegetzipfile(zip, path)) path = wbrels[i][1];
  			if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
  			stype = wbrels[i][2];
  		} else {
  			path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
  			path = path.replace(/sheet0\./,"sheet.");
  		}
  		relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
  		if(opts && opts.sheets != null) switch(typeof opts.sheets) {
  			case "number": if(i != opts.sheets) continue wsloop; break;
  			case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
  			default: if(Array.isArray && Array.isArray(opts.sheets)) {
  				var snjseen = false;
  				for(var snj = 0; snj != opts.sheets.length; ++snj) {
  					if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
  					if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
  				}
  				if(!snjseen) continue wsloop;
  			}
  		}
  		safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
  	}

  	out = ({
  		Directory: dir,
  		Workbook: wb,
  		Props: props,
  		Custprops: custprops,
  		Deps: deps,
  		Sheets: sheets,
  		SheetNames: props.SheetNames,
  		Strings: strs,
  		Styles: styles,
  		Themes: themes,
  		SSF: dup(table_fmt)
  	}/*:any*/);
  	if(opts && opts.bookFiles) {
  		if(zip.files) {
  			out.keys = entries;
  			out.files = zip.files;
  		} else {
  			out.keys = [];
  			out.files = {};
  			zip.FullPaths.forEach(function(p, idx) {
  				p = p.replace(/^Root Entry[\/]/, "");
  				out.keys.push(p);
  				out.files[p] = zip.FileIndex[idx];
  			});
  		}
  	}
  	if(opts && opts.bookVBA) {
  		if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
  		else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
  	}
  	return out;
  }

  /* [MS-OFFCRYPTO] 2.1.1 */
  function parse_xlsxcfb(cfb, _opts/*:?ParseOpts*/)/*:Workbook*/ {
  	var opts = _opts || {};
  	var f = 'Workbook', data = CFB.find(cfb, f);
  	try {
  	f = '/!DataSpaces/Version';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
  	/*var version = */parse_DataSpaceVersionInfo(data.content);

  	/* 2.3.4.1 */
  	f = '/!DataSpaces/DataSpaceMap';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
  	var dsm = parse_DataSpaceMap(data.content);
  	if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
  		throw new Error("ECMA-376 Encrypted file bad " + f);

  	/* 2.3.4.2 */
  	f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
  	var seds = parse_DataSpaceDefinition(data.content);
  	if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
  		throw new Error("ECMA-376 Encrypted file bad " + f);

  	/* 2.3.4.3 */
  	f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
  	/*var hdr = */parse_Primary(data.content);
  	} catch(e) {}

  	f = '/EncryptionInfo';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
  	var einfo = parse_EncryptionInfo(data.content);

  	/* 2.3.4.4 */
  	f = '/EncryptedPackage';
  	data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);

  /*global decrypt_agile */
  /*:: declare var decrypt_agile:any; */
  	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
  /*global decrypt_std76 */
  /*:: declare var decrypt_std76:any; */
  	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
  	throw new Error("File is password-protected");
  }

  function firstbyte(f/*:RawData*/,o/*:?TypeOpts*/)/*:Array<number>*/ {
  	var x = "";
  	switch((o||{}).type || "base64") {
  		case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
  		case 'base64': x = Base64_decode(f.slice(0,12)); break;
  		case 'binary': x = f; break;
  		case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
  		default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
  	}
  	return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
  }

  function read_cfb(cfb/*:CFBContainer*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
  	return parse_xlscfb(cfb, opts);
  }

  function read_zip(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	var zip, d = data;
  	var o = opts||{};
  	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
  	zip = zip_read(d, o);
  	return parse_zip(zip, o);
  }

  function read_plaintext(data/*:string*/, o/*:ParseOpts*/)/*:Workbook*/ {
  	var i = 0;
  	main: while(i < data.length) switch(data.charCodeAt(i)) {
  		case 0x0A: case 0x0D: case 0x20: ++i; break;
  		case 0x3C: return parse_xlml(data.slice(i),o);
  		default: break main;
  	}
  	return PRN.to_workbook(data, o);
  }

  function read_plaintext_raw(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
  	var str = "", bytes = firstbyte(data, o);
  	switch(o.type) {
  		case 'base64': str = Base64_decode(data); break;
  		case 'binary': str = data; break;
  		case 'buffer': str = data.toString('binary'); break;
  		case 'array': str = cc2str(data); break;
  		default: throw new Error("Unrecognized type " + o.type);
  	}
  	if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
  	o.type = "binary";
  	return read_plaintext(str, o);
  }

  function read_utf16(data/*:RawData*/, o/*:ParseOpts*/)/*:Workbook*/ {
  	var d = data;
  	if(o.type == 'base64') d = Base64_decode(d);
  	d = $cptable.utils.decode(1200, d.slice(2), 'str');
  	o.type = "binary";
  	return read_plaintext(d, o);
  }

  function bstrify(data/*:string*/)/*:string*/ {
  	return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
  }

  function read_prn(data, d, o, str) {
  	if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
  	return PRN.to_workbook(d, o);
  }

  function readSync(data/*:RawData*/, opts/*:?ParseOpts*/)/*:Workbook*/ {
  	reset_cp();
  	var o = opts||{};
  	if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
  	if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
  	var d = data, n = [0,0,0,0], str = false;
  	if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
  	_ssfopts = {};
  	if(o.dateNF) _ssfopts.dateNF = o.dateNF;
  	if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
  	if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
  	if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
  	if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
  		// $FlowIgnore
  		var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
  		// $FlowIgnore
  		if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
  	}
  	switch((n = firstbyte(d, o))[0]) {
  		case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
  		case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
  		case 0x3C: return parse_xlml(d, o);
  		case 0x49:
  			if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
  			if(n[1] === 0x44) return read_wb_ID(d, o);
  			break;
  		case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
  		case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
  		case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
  		case 0xFF:
  			if(n[1] === 0xFE) { return read_utf16(d, o); }
  			else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
  			break;
  		case 0x00:
  			if(n[1] === 0x00) {
  				if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
  				if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
  			}
  			break;
  		case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
  		case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
  		case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
  		case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
  	}
  	if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
  	return read_prn(data, d, o, str);
  }
  /*::
  type MJRObject = {
  	row: any;
  	isempty: boolean;
  };
  */
  function make_json_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, header/*:number*/, hdr/*:Array<any>*/, dense/*:boolean*/, o/*:Sheet2JSONOpts*/)/*:MJRObject*/ {
  	var rr = encode_row(R);
  	var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
  	var isempty = true;
  	var row/*:any*/ = (header === 1) ? [] : {};
  	if(header !== 1) {
  		if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
  		else row.__rowNum__ = R;
  	}
  	if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
  		var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
  		if(val === undefined || val.t === undefined) {
  			if(defval === undefined) continue;
  			if(hdr[C] != null) { row[hdr[C]] = defval; }
  			continue;
  		}
  		var v = val.v;
  		switch(val.t){
  			case 'z': if(v == null) break; continue;
  			case 'e': v = (v == 0 ? null : void 0); break;
  			case 's': case 'd': case 'b': case 'n': break;
  			default: throw new Error('unrecognized type ' + val.t);
  		}
  		if(hdr[C] != null) {
  			if(v == null) {
  				if(val.t == "e" && v === null) row[hdr[C]] = null;
  				else if(defval !== undefined) row[hdr[C]] = defval;
  				else if(raw && v === null) row[hdr[C]] = null;
  				else continue;
  			} else {
  				row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
  			}
  			if(v != null) isempty = false;
  		}
  	}
  	return { row: row, isempty: isempty };
  }


  function sheet_to_json(sheet/*:Worksheet*/, opts/*:?Sheet2JSONOpts*/) {
  	if(sheet == null || sheet["!ref"] == null) return [];
  	var val = {t:'n',v:0}, header = 0, offset = 1, hdr/*:Array<any>*/ = [], v=0, vv="";
  	var r = {s:{r:0,c:0},e:{r:0,c:0}};
  	var o = opts || {};
  	var range = o.range != null ? o.range : sheet["!ref"];
  	if(o.header === 1) header = 1;
  	else if(o.header === "A") header = 2;
  	else if(Array.isArray(o.header)) header = 3;
  	else if(o.header == null) header = 0;
  	switch(typeof range) {
  		case 'string': r = safe_decode_range(range); break;
  		case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
  		default: r = range;
  	}
  	if(header > 0) offset = 0;
  	var rr = encode_row(r.s.r);
  	var cols/*:Array<string>*/ = [];
  	var out/*:Array<any>*/ = [];
  	var outi = 0, counter = 0;
  	var dense = Array.isArray(sheet);
  	var R = r.s.r, C = 0;
  	var header_cnt = {};
  	if(dense && !sheet[R]) sheet[R] = [];
  	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
  	var rowinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!rows"] || [];
  	for(C = r.s.c; C <= r.e.c; ++C) {
  		if(((colinfo[C]||{}).hidden)) continue;
  		cols[C] = encode_col(C);
  		val = dense ? sheet[R][C] : sheet[cols[C] + rr];
  		switch(header) {
  			case 1: hdr[C] = C - r.s.c; break;
  			case 2: hdr[C] = cols[C]; break;
  			case 3: hdr[C] = o.header[C - r.s.c]; break;
  			default:
  				if(val == null) val = {w: "__EMPTY", t: "s"};
  				vv = v = format_cell(val, null, o);
  				counter = header_cnt[v] || 0;
  				if(!counter) header_cnt[v] = 1;
  				else {
  					do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
  					header_cnt[vv] = 1;
  				}
  				hdr[C] = vv;
  		}
  	}
  	for (R = r.s.r + offset; R <= r.e.r; ++R) {
  		if ((rowinfo[R]||{}).hidden) continue;
  		var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
  		if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
  	}
  	out.length = outi;
  	return out;
  }

  var qreg = /"/g;
  function make_csv_row(sheet/*:Worksheet*/, r/*:Range*/, R/*:number*/, cols/*:Array<string>*/, fs/*:number*/, rs/*:number*/, FS/*:string*/, o/*:Sheet2CSVOpts*/)/*:?string*/ {
  	var isempty = true;
  	var row/*:Array<string>*/ = [], txt = "", rr = encode_row(R);
  	for(var C = r.s.c; C <= r.e.c; ++C) {
  		if (!cols[C]) continue;
  		var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
  		if(val == null) txt = "";
  		else if(val.v != null) {
  			isempty = false;
  			txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
  			for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
  			if(txt == "ID") txt = '"ID"';
  		} else if(val.f != null && !val.F) {
  			isempty = false;
  			txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
  		} else txt = "";
  		/* NOTE: Excel CSV does not support array formulae */
  		row.push(txt);
  	}
  	if(o.blankrows === false && isempty) return null;
  	return row.join(FS);
  }

  function sheet_to_csv(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/)/*:string*/ {
  	var out/*:Array<string>*/ = [];
  	var o = opts == null ? {} : opts;
  	if(sheet == null || sheet["!ref"] == null) return "";
  	var r = safe_decode_range(sheet["!ref"]);
  	var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
  	var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
  	var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
  	var row = "", cols/*:Array<string>*/ = [];
  	o.dense = Array.isArray(sheet);
  	var colinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!cols"] || [];
  	var rowinfo/*:Array<ColInfo>*/ = o.skipHidden && sheet["!rows"] || [];
  	for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
  	var w = 0;
  	for(var R = r.s.r; R <= r.e.r; ++R) {
  		if ((rowinfo[R]||{}).hidden) continue;
  		row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
  		if(row == null) { continue; }
  		if(o.strip) row = row.replace(endregex,"");
  		if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
  	}
  	delete o.dense;
  	return out.join("");
  }

  function sheet_to_txt(sheet/*:Worksheet*/, opts/*:?Sheet2CSVOpts*/) {
  	if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
  	var s = sheet_to_csv(sheet, opts);
  	return s;
  }

  function sheet_to_formulae(sheet/*:Worksheet*/)/*:Array<string>*/ {
  	var y = "", x, val="";
  	if(sheet == null || sheet["!ref"] == null) return [];
  	var r = safe_decode_range(sheet['!ref']), rr = "", cols/*:Array<string>*/ = [], C;
  	var cmds/*:Array<string>*/ = [];
  	var dense = Array.isArray(sheet);
  	for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
  	for(var R = r.s.r; R <= r.e.r; ++R) {
  		rr = encode_row(R);
  		for(C = r.s.c; C <= r.e.c; ++C) {
  			y = cols[C] + rr;
  			x = dense ? (sheet[R]||[])[C] : sheet[y];
  			val = "";
  			if(x === undefined) continue;
  			else if(x.F != null) {
  				y = x.F;
  				if(!x.f) continue;
  				val = x.f;
  				if(y.indexOf(":") == -1) y = y + ":" + y;
  			}
  			if(x.f != null) val = x.f;
  			else if(x.t == 'z') continue;
  			else if(x.t == 'n' && x.v != null) val = "" + x.v;
  			else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
  			else if(x.w !== undefined) val = "'" + x.w;
  			else if(x.v === undefined) continue;
  			else if(x.t == 's') val = "'" + x.v;
  			else val = ""+x.v;
  			cmds[cmds.length] = y + "=" + val;
  		}
  	}
  	return cmds;
  }

  function sheet_add_json(_ws/*:?Worksheet*/, js/*:Array<any>*/, opts)/*:Worksheet*/ {
  	var o = opts || {};
  	var offset = +!o.skipHeader;
  	var ws/*:Worksheet*/ = _ws || ({}/*:any*/);
  	var _R = 0, _C = 0;
  	if(ws && o.origin != null) {
  		if(typeof o.origin == 'number') _R = o.origin;
  		else {
  			var _origin/*:CellAddress*/ = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
  			_R = _origin.r; _C = _origin.c;
  		}
  	}
  	var cell/*:Cell*/;
  	var range/*:Range*/ = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}}/*:any*/);
  	if(ws['!ref']) {
  		var _range = safe_decode_range(ws['!ref']);
  		range.e.c = Math.max(range.e.c, _range.e.c);
  		range.e.r = Math.max(range.e.r, _range.e.r);
  		if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
  	} else {
  		if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
  	}
  	var hdr/*:Array<string>*/ = o.header || [], C = 0;

  	js.forEach(function (JS, R/*:number*/) {
  		keys$1(JS).forEach(function(k) {
  			if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
  			var v = JS[k];
  			var t = 'z';
  			var z = "";
  			var ref = encode_cell({c:_C + C,r:_R + R + offset});
  			cell = ws_get_cell_stub(ws, ref);
  			if(v && typeof v === 'object' && !(v instanceof Date)){
  				ws[ref] = v;
  			} else {
  				if(typeof v == 'number') t = 'n';
  				else if(typeof v == 'boolean') t = 'b';
  				else if(typeof v == 'string') t = 's';
  				else if(v instanceof Date) {
  					t = 'd';
  					if(!o.cellDates) { t = 'n'; v = datenum(v); }
  					z = (o.dateNF || table_fmt[14]);
  				}
  				else if(v === null && o.nullError) { t = 'e'; v = 0; }
  				if(!cell) ws[ref] = cell = ({t:t, v:v}/*:any*/);
  				else {
  					cell.t = t; cell.v = v;
  					delete cell.w; delete cell.R;
  					if(z) cell.z = z;
  				}
  				if(z) cell.z = z;
  			}
  		});
  	});
  	range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
  	var __R = encode_row(_R);
  	if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
  	ws['!ref'] = encode_range(range);
  	return ws;
  }
  function json_to_sheet(js/*:Array<any>*/, opts)/*:Worksheet*/ { return sheet_add_json(null, js, opts); }

  /* get cell, creating a stub if necessary */
  function ws_get_cell_stub(ws/*:Worksheet*/, R, C/*:?number*/)/*:Cell*/ {
  	/* A1 cell address */
  	if(typeof R == "string") {
  		/* dense */
  		if(Array.isArray(ws)) {
  			var RC = decode_cell(R);
  			if(!ws[RC.r]) ws[RC.r] = [];
  			return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
  		}
  		return ws[R] || (ws[R] = {t:'z'});
  	}
  	/* cell address object */
  	if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
  	/* R and C are 0-based indices */
  	return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
  }

  /* find sheet index for given name / validate index */
  function wb_sheet_idx(wb/*:Workbook*/, sh/*:number|string*/) {
  	if(typeof sh == "number") {
  		if(sh >= 0 && wb.SheetNames.length > sh) return sh;
  		throw new Error("Cannot find sheet # " + sh);
  	} else if(typeof sh == "string") {
  		var idx = wb.SheetNames.indexOf(sh);
  		if(idx > -1) return idx;
  		throw new Error("Cannot find sheet name |" + sh + "|");
  	} else throw new Error("Cannot find sheet |" + sh + "|");
  }

  /* simple blank workbook object */
  function book_new()/*:Workbook*/ {
  	return { SheetNames: [], Sheets: {} };
  }

  /* add a worksheet to the end of a given workbook */
  function book_append_sheet(wb/*:Workbook*/, ws/*:Worksheet*/, name/*:?string*/, roll/*:?boolean*/)/*:string*/ {
  	var i = 1;
  	if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
  	if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
  	if(roll && wb.SheetNames.indexOf(name) >= 0) {
  		var m = name.match(/(^.*?)(\d+)$/);
  		i = m && +m[2] || 0;
  		var root = m && m[1] || name;
  		for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
  	}
  	check_ws_name(name);
  	if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");

  	wb.SheetNames.push(name);
  	wb.Sheets[name] = ws;
  	return name;
  }

  /* set sheet visibility (visible/hidden/very hidden) */
  function book_set_sheet_visibility(wb/*:Workbook*/, sh/*:number|string*/, vis/*:number*/) {
  	if(!wb.Workbook) wb.Workbook = {};
  	if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];

  	var idx = wb_sheet_idx(wb, sh);
  	// $FlowIgnore
  	if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};

  	switch(vis) {
  		case 0: case 1: case 2: break;
  		default: throw new Error("Bad sheet visibility setting " + vis);
  	}
  	// $FlowIgnore
  	wb.Workbook.Sheets[idx].Hidden = vis;
  }

  /* set number format */
  function cell_set_number_format(cell/*:Cell*/, fmt/*:string|number*/) {
  	cell.z = fmt;
  	return cell;
  }

  /* set cell hyperlink */
  function cell_set_hyperlink(cell/*:Cell*/, target/*:string*/, tooltip/*:?string*/) {
  	if(!target) {
  		delete cell.l;
  	} else {
  		cell.l = ({ Target: target }/*:Hyperlink*/);
  		if(tooltip) cell.l.Tooltip = tooltip;
  	}
  	return cell;
  }
  function cell_set_internal_link(cell/*:Cell*/, range/*:string*/, tooltip/*:?string*/) { return cell_set_hyperlink(cell, "#" + range, tooltip); }

  /* add to cell comments */
  function cell_add_comment(cell/*:Cell*/, text/*:string*/, author/*:?string*/) {
  	if(!cell.c) cell.c = [];
  	cell.c.push({t:text, a:author||"SheetJS"});
  }

  /* set array formula and flush related cells */
  function sheet_set_array_formula(ws/*:Worksheet*/, range, formula/*:string*/, dynamic/*:boolean*/) {
  	var rng = typeof range != "string" ? range : safe_decode_range(range);
  	var rngstr = typeof range == "string" ? range : encode_range(range);
  	for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
  		var cell = ws_get_cell_stub(ws, R, C);
  		cell.t = 'n';
  		cell.F = rngstr;
  		delete cell.v;
  		if(R == rng.s.r && C == rng.s.c) {
  			cell.f = formula;
  			if(dynamic) cell.D = true;
  		}
  	}
  	return ws;
  }

  var utils/*:any*/ = {
  	encode_col: encode_col,
  	encode_row: encode_row,
  	encode_cell: encode_cell,
  	encode_range: encode_range,
  	decode_col: decode_col,
  	decode_row: decode_row,
  	split_cell: split_cell,
  	decode_cell: decode_cell,
  	decode_range: decode_range,
  	format_cell: format_cell,
  	sheet_add_aoa: sheet_add_aoa,
  	sheet_add_json: sheet_add_json,
  	sheet_add_dom: sheet_add_dom,
  	aoa_to_sheet: aoa_to_sheet,
  	json_to_sheet: json_to_sheet,
  	table_to_sheet: parse_dom_table,
  	table_to_book: table_to_book,
  	sheet_to_csv: sheet_to_csv,
  	sheet_to_txt: sheet_to_txt,
  	sheet_to_json: sheet_to_json,
  	sheet_to_html: sheet_to_html,
  	sheet_to_formulae: sheet_to_formulae,
  	sheet_to_row_object_array: sheet_to_json,
  	sheet_get_cell: ws_get_cell_stub,
  	book_new: book_new,
  	book_append_sheet: book_append_sheet,
  	book_set_sheet_visibility: book_set_sheet_visibility,
  	cell_set_number_format: cell_set_number_format,
  	cell_set_hyperlink: cell_set_hyperlink,
  	cell_set_internal_link: cell_set_internal_link,
  	cell_add_comment: cell_add_comment,
  	sheet_set_array_formula: sheet_set_array_formula,
  	consts: {
  		SHEET_VISIBLE: 0,
  		SHEET_HIDDEN: 1,
  		SHEET_VERY_HIDDEN: 2
  	}
  };

  function getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
  }
  function createContext$1(options = {}) {
    const {
      name,
      strict = true,
      hookName = "useContext",
      providerName = "Provider",
      errorMessage,
      defaultValue
    } = options;
    const Context = react.createContext(defaultValue);
    Context.displayName = name;
    function useContext() {
      var _a;
      const context = react.useContext(Context);
      if (!context && strict) {
        const error = new Error(
          errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName)
        );
        error.name = "ContextError";
        (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
        throw error;
      }
      return context;
    }
    return [Context.Provider, useContext, Context];
  }

  var [ButtonGroupProvider, useButtonGroup] = createContext$1({
    strict: false,
    name: "ButtonGroupContext"
  });

  /*

  Based off glamor's StyleSheet, thanks Sunil ❤️

  high performance StyleSheet for css-in-js systems

  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance

  // usage

  import { StyleSheet } from '@emotion/sheet'

  let styleSheet = new StyleSheet({ key: '', container: document.head })

  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet

  styleSheet.flush()
  - empties the stylesheet of all its contents

  */
  // $FlowFixMe
  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }

  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);

    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }

    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
  }

  var StyleSheet = /*#__PURE__*/function () {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
      var _this = this;

      this._insertTag = function (tag) {
        var before;

        if (_this.tags.length === 0) {
          if (_this.insertionPoint) {
            before = _this.insertionPoint.nextSibling;
          } else if (_this.prepend) {
            before = _this.container.firstChild;
          } else {
            before = _this.before;
          }
        } else {
          before = _this.tags[_this.tags.length - 1].nextSibling;
        }

        _this.container.insertBefore(tag, before);

        _this.tags.push(tag);
      };

      this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.prepend = options.prepend;
      this.insertionPoint = options.insertionPoint;
      this.before = null;
    }

    var _proto = StyleSheet.prototype;

    _proto.hydrate = function hydrate(nodes) {
      nodes.forEach(this._insertTag);
    };

    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        this._insertTag(createStyleElement(this));
      }

      var tag = this.tags[this.tags.length - 1];

      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);

        try {
          // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }

      this.ctr++;
    };

    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode && tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;
    };

    return StyleSheet;
  }();

  var MS = '-ms-';
  var MOZ = '-moz-';
  var WEBKIT = '-webkit-';

  var COMMENT = 'comm';
  var RULESET = 'rule';
  var DECLARATION = 'decl';
  var IMPORT = '@import';
  var KEYFRAMES = '@keyframes';
  var LAYER = '@layer';

  /**
   * @param {number}
   * @return {number}
   */
  var abs = Math.abs;

  /**
   * @param {number}
   * @return {string}
   */
  var from = String.fromCharCode;

  /**
   * @param {object}
   * @return {object}
   */
  var assign = Object.assign;

  /**
   * @param {string} value
   * @param {number} length
   * @return {number}
   */
  function hash$1 (value, length) {
  	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
  }

  /**
   * @param {string} value
   * @return {string}
   */
  function trim (value) {
  	return value.trim()
  }

  /**
   * @param {string} value
   * @param {RegExp} pattern
   * @return {string?}
   */
  function match (value, pattern) {
  	return (value = pattern.exec(value)) ? value[0] : value
  }

  /**
   * @param {string} value
   * @param {(string|RegExp)} pattern
   * @param {string} replacement
   * @return {string}
   */
  function replace (value, pattern, replacement) {
  	return value.replace(pattern, replacement)
  }

  /**
   * @param {string} value
   * @param {string} search
   * @return {number}
   */
  function indexof (value, search) {
  	return value.indexOf(search)
  }

  /**
   * @param {string} value
   * @param {number} index
   * @return {number}
   */
  function charat (value, index) {
  	return value.charCodeAt(index) | 0
  }

  /**
   * @param {string} value
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function substr (value, begin, end) {
  	return value.slice(begin, end)
  }

  /**
   * @param {string} value
   * @return {number}
   */
  function strlen (value) {
  	return value.length
  }

  /**
   * @param {any[]} value
   * @return {number}
   */
  function sizeof (value) {
  	return value.length
  }

  /**
   * @param {any} value
   * @param {any[]} array
   * @return {any}
   */
  function append (value, array) {
  	return array.push(value), value
  }

  /**
   * @param {string[]} array
   * @param {function} callback
   * @return {string}
   */
  function combine (array, callback) {
  	return array.map(callback).join('')
  }

  var line = 1;
  var column = 1;
  var length = 0;
  var position$1 = 0;
  var character = 0;
  var characters = '';

  /**
   * @param {string} value
   * @param {object | null} root
   * @param {object | null} parent
   * @param {string} type
   * @param {string[] | string} props
   * @param {object[] | string} children
   * @param {number} length
   */
  function node (value, root, parent, type, props, children, length) {
  	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
  }

  /**
   * @param {object} root
   * @param {object} props
   * @return {object}
   */
  function copy (root, props) {
  	return assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
  }

  /**
   * @return {number}
   */
  function char () {
  	return character
  }

  /**
   * @return {number}
   */
  function prev () {
  	character = position$1 > 0 ? charat(characters, --position$1) : 0;

  	if (column--, character === 10)
  		column = 1, line--;

  	return character
  }

  /**
   * @return {number}
   */
  function next () {
  	character = position$1 < length ? charat(characters, position$1++) : 0;

  	if (column++, character === 10)
  		column = 1, line++;

  	return character
  }

  /**
   * @return {number}
   */
  function peek () {
  	return charat(characters, position$1)
  }

  /**
   * @return {number}
   */
  function caret () {
  	return position$1
  }

  /**
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function slice (begin, end) {
  	return substr(characters, begin, end)
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function token (type) {
  	switch (type) {
  		// \0 \t \n \r \s whitespace token
  		case 0: case 9: case 10: case 13: case 32:
  			return 5
  		// ! + , / > @ ~ isolate token
  		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
  		// ; { } breakpoint token
  		case 59: case 123: case 125:
  			return 4
  		// : accompanied token
  		case 58:
  			return 3
  		// " ' ( [ opening delimit token
  		case 34: case 39: case 40: case 91:
  			return 2
  		// ) ] closing delimit token
  		case 41: case 93:
  			return 1
  	}

  	return 0
  }

  /**
   * @param {string} value
   * @return {any[]}
   */
  function alloc (value) {
  	return line = column = 1, length = strlen(characters = value), position$1 = 0, []
  }

  /**
   * @param {any} value
   * @return {any}
   */
  function dealloc (value) {
  	return characters = '', value
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function delimit (type) {
  	return trim(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function whitespace (type) {
  	while (character = peek())
  		if (character < 33)
  			next();
  		else
  			break

  	return token(type) > 2 || token(character) > 3 ? '' : ' '
  }

  /**
   * @param {number} index
   * @param {number} count
   * @return {string}
   */
  function escaping (index, count) {
  	while (--count && next())
  		// not 0-9 A-F a-f
  		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
  			break

  	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function delimiter (type) {
  	while (next())
  		switch (character) {
  			// ] ) " '
  			case type:
  				return position$1
  			// " '
  			case 34: case 39:
  				if (type !== 34 && type !== 39)
  					delimiter(character);
  				break
  			// (
  			case 40:
  				if (type === 41)
  					delimiter(type);
  				break
  			// \
  			case 92:
  				next();
  				break
  		}

  	return position$1
  }

  /**
   * @param {number} type
   * @param {number} index
   * @return {number}
   */
  function commenter (type, index) {
  	while (next())
  		// //
  		if (type + character === 47 + 10)
  			break
  		// /*
  		else if (type + character === 42 + 42 && peek() === 47)
  			break

  	return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next())
  }

  /**
   * @param {number} index
   * @return {string}
   */
  function identifier (index) {
  	while (!token(peek()))
  		next();

  	return slice(index, position$1)
  }

  /**
   * @param {string} value
   * @return {object[]}
   */
  function compile (value) {
  	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string[]} rule
   * @param {string[]} rules
   * @param {string[]} rulesets
   * @param {number[]} pseudo
   * @param {number[]} points
   * @param {string[]} declarations
   * @return {object}
   */
  function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  	var index = 0;
  	var offset = 0;
  	var length = pseudo;
  	var atrule = 0;
  	var property = 0;
  	var previous = 0;
  	var variable = 1;
  	var scanning = 1;
  	var ampersand = 1;
  	var character = 0;
  	var type = '';
  	var props = rules;
  	var children = rulesets;
  	var reference = rule;
  	var characters = type;

  	while (scanning)
  		switch (previous = character, character = next()) {
  			// (
  			case 40:
  				if (previous != 108 && charat(characters, length - 1) == 58) {
  					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
  						ampersand = -1;
  					break
  				}
  			// " ' [
  			case 34: case 39: case 91:
  				characters += delimit(character);
  				break
  			// \t \n \r \s
  			case 9: case 10: case 13: case 32:
  				characters += whitespace(previous);
  				break
  			// \
  			case 92:
  				characters += escaping(caret() - 1, 7);
  				continue
  			// /
  			case 47:
  				switch (peek()) {
  					case 42: case 47:
  						append(comment(commenter(next(), caret()), root, parent), declarations);
  						break
  					default:
  						characters += '/';
  				}
  				break
  			// {
  			case 123 * variable:
  				points[index++] = strlen(characters) * ampersand;
  			// } ; \0
  			case 125 * variable: case 59: case 0:
  				switch (character) {
  					// \0 }
  					case 0: case 125: scanning = 0;
  					// ;
  					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
  						if (property > 0 && (strlen(characters) - length))
  							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
  						break
  					// @ ;
  					case 59: characters += ';';
  					// { rule/at-rule
  					default:
  						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

  						if (character === 123)
  							if (offset === 0)
  								parse(characters, root, reference, reference, props, rulesets, length, points, children);
  							else
  								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
  									// d l m s
  									case 100: case 108: case 109: case 115:
  										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
  										break
  									default:
  										parse(characters, reference, reference, reference, [''], children, 0, points, children);
  								}
  				}

  				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
  				break
  			// :
  			case 58:
  				length = 1 + strlen(characters), property = previous;
  			default:
  				if (variable < 1)
  					if (character == 123)
  						--variable;
  					else if (character == 125 && variable++ == 0 && prev() == 125)
  						continue

  				switch (characters += from(character), character * variable) {
  					// &
  					case 38:
  						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
  						break
  					// ,
  					case 44:
  						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
  						break
  					// @
  					case 64:
  						// -
  						if (peek() === 45)
  							characters += delimit(next());

  						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
  						break
  					// -
  					case 45:
  						if (previous === 45 && strlen(characters) == 2)
  							variable = 0;
  				}
  		}

  	return rulesets
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} index
   * @param {number} offset
   * @param {string[]} rules
   * @param {number[]} points
   * @param {string} type
   * @param {string[]} props
   * @param {string[]} children
   * @param {number} length
   * @return {object}
   */
  function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
  	var post = offset - 1;
  	var rule = offset === 0 ? rules : [''];
  	var size = sizeof(rule);

  	for (var i = 0, j = 0, k = 0; i < index; ++i)
  		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
  			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
  				props[k++] = z;

  	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
  }

  /**
   * @param {number} value
   * @param {object} root
   * @param {object?} parent
   * @return {object}
   */
  function comment (value, root, parent) {
  	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} length
   * @return {object}
   */
  function declaration (value, root, parent, length) {
  	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
  }

  /**
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function serialize (children, callback) {
  	var output = '';
  	var length = sizeof(children);

  	for (var i = 0; i < length; i++)
  		output += callback(children[i], i, children, callback) || '';

  	return output
  }

  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function stringify (element, index, children, callback) {
  	switch (element.type) {
  		case LAYER: if (element.children.length) break
  		case IMPORT: case DECLARATION: return element.return = element.return || element.value
  		case COMMENT: return ''
  		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
  		case RULESET: element.value = element.props.join(',');
  	}

  	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
  }

  /**
   * @param {function[]} collection
   * @return {function}
   */
  function middleware (collection) {
  	var length = sizeof(collection);

  	return function (element, index, children, callback) {
  		var output = '';

  		for (var i = 0; i < length; i++)
  			output += collection[i](element, index, children, callback) || '';

  		return output
  	}
  }

  /**
   * @param {function} callback
   * @return {function}
   */
  function rulesheet (callback) {
  	return function (element) {
  		if (!element.root)
  			if (element = element.return)
  				callback(element);
  	}
  }

  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  function memoize$2(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;

    while (true) {
      previous = character;
      character = peek(); // &\f

      if (previous === 38 && character === 12) {
        points[index] = 1;
      }

      if (token(character)) {
        break;
      }

      next();
    }

    return slice(begin, position$1);
  };

  var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;

    do {
      switch (token(character)) {
        case 0:
          // &\f
          if (character === 38 && peek() === 12) {
            // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
          }

          parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
          break;

        case 2:
          parsed[index] += delimit(character);
          break;

        case 4:
          // comma
          if (character === 44) {
            // colon
            parsed[++index] = peek() === 58 ? '&\f' : '';
            points[index] = parsed[index].length;
            break;
          }

        // fallthrough

        default:
          parsed[index] += from(character);
      }
    } while (character = next());

    return parsed;
  };

  var getRules = function getRules(value, points) {
    return dealloc(toRules(alloc(value), points));
  }; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


  var fixedElements = /* #__PURE__ */new WeakMap();
  var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) {
      return;
    }

    var value = element.value,
        parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;

    while (parent.type !== 'rule') {
      parent = parent.parent;
      if (!parent) return;
    } // short-circuit for the simplest case


    if (element.props.length === 1 && value.charCodeAt(0) !== 58
    /* colon */
    && !fixedElements.get(parent)) {
      return;
    } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


    if (isImplicitRule) {
      return;
    }

    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;

    for (var i = 0, k = 0; i < rules.length; i++) {
      for (var j = 0; j < parentRules.length; j++, k++) {
        element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
      }
    }
  };
  var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
      var value = element.value;

      if ( // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98) {
        // this ignores label
        element["return"] = '';
        element.value = '';
      }
    }
  };

  /* eslint-disable no-fallthrough */

  function prefix(value, length) {
    switch (hash$1(value, length)) {
      // color-adjust
      case 5103:
        return WEBKIT + 'print-' + value + value;
      // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return WEBKIT + value + value;
      // appearance, user-select, transform, hyphens, text-size-adjust

      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return WEBKIT + value + MOZ + value + MS + value + value;
      // flex, flex-direction

      case 6828:
      case 4268:
        return WEBKIT + value + MS + value + value;
      // order

      case 6165:
        return WEBKIT + value + MS + 'flex-' + value + value;
      // align-items

      case 5187:
        return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
      // align-self

      case 5443:
        return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
      // align-content

      case 4675:
        return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
      // flex-shrink

      case 5548:
        return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
      // flex-basis

      case 5292:
        return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
      // flex-grow

      case 6060:
        return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
      // transition

      case 4554:
        return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
      // cursor

      case 6187:
        return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
      // background, background-image

      case 5495:
      case 3959:
        return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
      // justify-content

      case 4968:
        return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
      // (margin|padding)-inline-(start|end)

      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
      // (min|max)?(width|height|inline-size|block-size)

      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        // stretch, max-content, min-content, fill-available
        if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            // -
            if (charat(value, length + 4) !== 45) break;
          // (f)ill-available, (f)it-content

          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
          // (s)tretch

          case 115:
            return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
        }
        break;
      // position: sticky

      case 4949:
        // (s)ticky?
        if (charat(value, length + 1) !== 115) break;
      // display: (flex|inline-flex)

      case 6444:
        switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
          // stic(k)y
          case 107:
            return replace(value, ':', ':' + WEBKIT) + value;
          // (inline-)?fl(e)x

          case 101:
            return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
        }

        break;
      // writing-mode

      case 5936:
        switch (charat(value, length + 11)) {
          // vertical-l(r)
          case 114:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
          // vertical-r(l)

          case 108:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
          // horizontal(-)tb

          case 45:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
        }

        return WEBKIT + value + MS + value + value;
    }

    return value;
  }

  var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;

      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, '@', '@' + WEBKIT)
        })], callback);

      case RULESET:
        if (element.length) return combine(element.props, function (value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ':read-only':
            case ':read-write':
              return serialize([copy(element, {
                props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
              })], callback);
            // :placeholder

            case '::placeholder':
              return serialize([copy(element, {
                props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
              })], callback);
          }

          return '';
        });
    }
  };

  var defaultStylisPlugins = [prefixer];

  var createCache = function createCache(options) {
    var key = options.key;

    if (key === 'css') {
      var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
      // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
      // note this very very intentionally targets all style elements regardless of the key to ensure
      // that creating a cache works inside of render of a React component

      Array.prototype.forEach.call(ssrStyles, function (node) {
        // we want to only move elements which have a space in the data-emotion attribute value
        // because that indicates that it is an Emotion 11 server-side rendered style elements
        // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
        // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
        // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
        // will not result in the Emotion 10 styles being destroyed
        var dataEmotionAttribute = node.getAttribute('data-emotion');

        if (dataEmotionAttribute.indexOf(' ') === -1) {
          return;
        }
        document.head.appendChild(node);
        node.setAttribute('data-s', '');
      });
    }

    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

    var inserted = {};
    var container;
    var nodesToHydrate = [];

    {
      container = options.container || document.head;
      Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }

        nodesToHydrate.push(node);
      });
    }

    var _insert;

    var omnipresentPlugins = [compat, removeLabel];

    {
      var currentSheet;
      var finalizingPlugins = [stringify, rulesheet(function (rule) {
        currentSheet.insert(rule);
      })];
      var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

      var stylis = function stylis(styles) {
        return serialize(compile(styles), serializer);
      };

      _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;

        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

        if (shouldCache) {
          cache.inserted[serialized.name] = true;
        }
      };
    }

    var cache = {
      key: key,
      sheet: new StyleSheet({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy,
        prepend: options.prepend,
        insertionPoint: options.insertionPoint
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
  };

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h$1=b?Symbol.for("react.provider"):60109,k$1=b?Symbol.for("react.context"):60110,l$1=b?Symbol.for("react.async_mode"):60111,m$1=b?Symbol.for("react.concurrent_mode"):60111,n$1=b?Symbol.for("react.forward_ref"):60112,p$2=b?Symbol.for("react.suspense"):60113,q$2=b?
  Symbol.for("react.suspense_list"):60120,r$3=b?Symbol.for("react.memo"):60115,t$3=b?Symbol.for("react.lazy"):60116,v$1=b?Symbol.for("react.block"):60121,w$1=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
  function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l$1:case m$1:case e:case g:case f:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t$3:case r$3:case h$1:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m$1}var AsyncMode=l$1;var ConcurrentMode=m$1;var ContextConsumer=k$1;var ContextProvider=h$1;var Element$1=c;var ForwardRef=n$1;var Fragment=e;var Lazy=t$3;var Memo=r$3;var Portal$1=d;
  var Profiler=g;var StrictMode=f;var Suspense=p$2;var isAsyncMode=function(a){return A(a)||z(a)===l$1};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k$1};var isContextProvider=function(a){return z(a)===h$1};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n$1};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t$3};
  var isMemo=function(a){return z(a)===r$3};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p$2};
  var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m$1||a===g||a===f||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$3||a.$$typeof===r$3||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};var typeOf=z;

  var reactIs_production_min = {
  	AsyncMode: AsyncMode,
  	ConcurrentMode: ConcurrentMode,
  	ContextConsumer: ContextConsumer,
  	ContextProvider: ContextProvider,
  	Element: Element$1,
  	ForwardRef: ForwardRef,
  	Fragment: Fragment,
  	Lazy: Lazy,
  	Memo: Memo,
  	Portal: Portal$1,
  	Profiler: Profiler,
  	StrictMode: StrictMode,
  	Suspense: Suspense,
  	isAsyncMode: isAsyncMode,
  	isConcurrentMode: isConcurrentMode,
  	isContextConsumer: isContextConsumer,
  	isContextProvider: isContextProvider,
  	isElement: isElement,
  	isForwardRef: isForwardRef,
  	isFragment: isFragment,
  	isLazy: isLazy,
  	isMemo: isMemo,
  	isPortal: isPortal,
  	isProfiler: isProfiler,
  	isStrictMode: isStrictMode,
  	isSuspense: isSuspense,
  	isValidElementType: isValidElementType,
  	typeOf: typeOf
  };

  var reactIs = createCommonjsModule(function (module) {

  {
    module.exports = reactIs_production_min;
  }
  });

  var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
  };
  var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
  };
  var TYPE_STATICS = {};
  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

  var isBrowser$1 = "object" !== 'undefined';
  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className] + ";");
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }
  var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false ) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }
  };
  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;

    if (cache.inserted[serialized.name] === undefined) {
      var current = serialized;

      do {
        cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

        current = current.next;
      } while (current !== undefined);
    }
  };

  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = /* #__PURE__ */memoize$2(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

  function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) {
      return '';
    }

    if (interpolation.__emotion_styles !== undefined) {

      return interpolation;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }

          if (interpolation.styles !== undefined) {
            var next = interpolation.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = interpolation.styles + ";";

            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result);
          }

          break;
        }
    } // finalize string values (regular strings and functions interpolated into css calls)


    if (registered == null) {
      return interpolation;
    }

    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];

        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error(noComponentSelectorMessage);
          }

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);

            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {

                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
  // keyframes are stored on the SerializedStyles object as a linked list


  var cursor;
  var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings);
    } else {

      styles += strings[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i]);

      if (stringMode) {

        styles += strings[i];
      }
    }


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + // $FlowFixMe we know it's not null
      match[1];
    }

    var name = murmur2(styles) + identifierName;

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  var syncFallback = function syncFallback(create) {
    return create();
  };

  var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
  var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
  var useInsertionEffectWithLayoutFallback = useInsertionEffect || react.useLayoutEffect;

  var EmotionCacheContext = /* #__PURE__ */react.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
    key: 'css'
  }) : null);

  var CacheProvider = EmotionCacheContext.Provider;

  var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/react.forwardRef(function (props, ref) {
      // the cache will never be null in the browser
      var cache = react.useContext(EmotionCacheContext);
      return func(props, cache, ref);
    });
  };

  var ThemeContext = /* #__PURE__ */react.createContext({});

  var getTheme$1 = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
      var mergedTheme = theme(outerTheme);

      return mergedTheme;
    }

    return _extends({}, outerTheme, theme);
  };

  var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
    return weakMemoize(function (theme) {
      return getTheme$1(outerTheme, theme);
    });
  });
  var ThemeProvider$2 = function ThemeProvider(props) {
    var theme = react.useContext(ThemeContext);

    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
      value: theme
    }, props.children);
  };

  // initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
  // initial client-side render from SSR, use place of hydrating tag

  var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {

    var styles = props.styles;
    var serialized = serializeStyles([styles], undefined, react.useContext(ThemeContext));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything


    var sheetRef = react.useRef();
    useInsertionEffectWithLayoutFallback(function () {
      var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

      var sheet = new cache.sheet.constructor({
        key: key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy
      });
      var rehydrating = false; // $FlowFixMe

      var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

      if (cache.sheet.tags.length) {
        sheet.before = cache.sheet.tags[0];
      }

      if (node !== null) {
        rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

        node.setAttribute('data-emotion', key);
        sheet.hydrate([node]);
      }

      sheetRef.current = [sheet, rehydrating];
      return function () {
        sheet.flush();
      };
    }, [cache]);
    useInsertionEffectWithLayoutFallback(function () {
      var sheetRefCurrent = sheetRef.current;
      var sheet = sheetRefCurrent[0],
          rehydrating = sheetRefCurrent[1];

      if (rehydrating) {
        sheetRefCurrent[1] = false;
        return;
      }

      if (serialized.next !== undefined) {
        // insert keyframes
        insertStyles(cache, serialized.next, true);
      }

      if (sheet.tags.length) {
        // if this doesn't exist then it will be null so the style element will be appended
        var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
        sheet.before = element;
        sheet.flush();
      }

      cache.insert("", serialized, sheet, false);
    }, [cache, serialized.name]);
    return null;
  });

  function css$2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return serializeStyles(args);
  }

  var keyframes$1 = function keyframes() {
    var insertable = css$2.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe

    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  };

  function useTheme() {
    const theme = react.useContext(
      ThemeContext
    );
    if (!theme) {
      throw Error(
        "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
      );
    }
    return theme;
  }

  var ColorModeContext = react.createContext({});
  ColorModeContext.displayName = "ColorModeContext";
  function useColorMode() {
    const context = react.useContext(ColorModeContext);
    if (context === void 0) {
      throw new Error("useColorMode must be used within a ColorModeProvider");
    }
    return context;
  }

  // src/color-mode.utils.ts
  var classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
  };
  function getColorModeUtils(options = {}) {
    const { preventTransition = true } = options;
    const utils = {
      setDataset: (value) => {
        const cleanup = preventTransition ? utils.preventTransition() : void 0;
        document.documentElement.dataset.theme = value;
        document.documentElement.style.colorScheme = value;
        cleanup == null ? void 0 : cleanup();
      },
      setClassName(dark) {
        document.body.classList.add(dark ? classNames.dark : classNames.light);
        document.body.classList.remove(dark ? classNames.light : classNames.dark);
      },
      query() {
        return window.matchMedia("(prefers-color-scheme: dark)");
      },
      getSystemTheme(fallback) {
        var _a;
        const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
        return dark ? "dark" : "light";
      },
      addListener(fn) {
        const mql = utils.query();
        const listener = (e) => {
          fn(e.matches ? "dark" : "light");
        };
        if (typeof mql.addListener === "function")
          mql.addListener(listener);
        else
          mql.addEventListener("change", listener);
        return () => {
          if (typeof mql.removeListener === "function")
            mql.removeListener(listener);
          else
            mql.removeEventListener("change", listener);
        };
      },
      preventTransition() {
        const css = document.createElement("style");
        css.appendChild(
          document.createTextNode(
            `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
          )
        );
        document.head.appendChild(css);
        return () => {
          (() => window.getComputedStyle(document.body))();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              document.head.removeChild(css);
            });
          });
        };
      }
    };
    return utils;
  }

  // src/storage-manager.ts
  var STORAGE_KEY$1 = "chakra-ui-color-mode";
  function createLocalStorageManager(key) {
    return {
      ssr: false,
      type: "localStorage",
      get(init) {
        if (!(globalThis == null ? void 0 : globalThis.document))
          return init;
        let value;
        try {
          value = localStorage.getItem(key) || init;
        } catch (e) {
        }
        return value || init;
      },
      set(value) {
        try {
          localStorage.setItem(key, value);
        } catch (e) {
        }
      }
    };
  }
  var localStorageManager = createLocalStorageManager(STORAGE_KEY$1);

  var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? react.useLayoutEffect : react.useEffect;

  var noop$2 = () => {
  };
  function getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
  }
  function ColorModeProvider(props) {
    const {
      value,
      children,
      options: {
        useSystemColorMode,
        initialColorMode,
        disableTransitionOnChange
      } = {},
      colorModeManager = localStorageManager
    } = props;
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = react.useState(
      () => getTheme(colorModeManager, defaultColorMode)
    );
    const [resolvedColorMode, setResolvedColorMode] = react.useState(
      () => getTheme(colorModeManager)
    );
    const { getSystemTheme, setClassName, setDataset, addListener } = react.useMemo(
      () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
      [disableTransitionOnChange]
    );
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = react.useCallback(
      (value2) => {
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
      },
      [colorModeManager, getSystemTheme, setClassName, setDataset]
    );
    useSafeLayoutEffect(() => {
      if (initialColorMode === "system") {
        setResolvedColorMode(getSystemTheme());
      }
    }, []);
    react.useEffect(() => {
      const managerValue = colorModeManager.get();
      if (managerValue) {
        setColorMode(managerValue);
        return;
      }
      if (initialColorMode === "system") {
        setColorMode("system");
        return;
      }
      setColorMode(defaultColorMode);
    }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
    const toggleColorMode = react.useCallback(() => {
      setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [resolvedValue, setColorMode]);
    react.useEffect(() => {
      if (!useSystemColorMode)
        return;
      return addListener(setColorMode);
    }, [useSystemColorMode, addListener, setColorMode]);
    const context = react.useMemo(
      () => ({
        colorMode: value != null ? value : resolvedValue,
        toggleColorMode: value ? noop$2 : toggleColorMode,
        setColorMode: value ? noop$2 : setColorMode,
        forced: value !== void 0
      }),
      [resolvedValue, toggleColorMode, setColorMode, value]
    );
    return /* @__PURE__ */ jsxRuntime.jsx(ColorModeContext.Provider, { value: context, children });
  }
  ColorModeProvider.displayName = "ColorModeProvider";

  function useChakra() {
    const colorModeResult = useColorMode();
    const theme = useTheme();
    return { ...colorModeResult, theme };
  }

  // src/index.ts
  var cx = (...classNames) => classNames.filter(Boolean).join(" ");
  function isObject$1(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
  }
  function runIfFn$2(valueOrFn, ...args) {
    return isFunction$3(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }
  var isFunction$3 = (value) => typeof value === "function";
  var dataAttr = (condition) => condition ? "" : void 0;

  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  var lodash_mergewith = createCommonjsModule(function (module, exports) {
  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined,
      Symbol = root.Symbol,
      Uint8Array = root.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  var defineProperty = (function() {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }());

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeMax = Math.max,
      nativeNow = Date.now;

  /* Built-in method references that are verified to be native. */
  var Map = getNative(root, 'Map'),
      nativeCreate = getNative(Object, 'create');

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = (function() {
    function object() {}
    return function(proto) {
      if (!isObject(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object;
      object.prototype = undefined;
      return result;
    };
  }());

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash,
      'map': new (Map || ListCache),
      'string': new Hash
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) &&
          !(skipIndexes && (
             // Safari 9 has enumerable `arguments.length` in strict mode.
             key == 'length' ||
             // Node.js 0.10 has enumerable non-index properties on buffers.
             (isBuff && (key == 'offset' || key == 'parent')) ||
             // PhantomJS 2 has enumerable non-index properties on typed arrays.
             (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
             // Skip index properties.
             isIndex(key, length)
          ))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq(object[key], value)) ||
        (value === undefined && !(key in object))) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
      ? getRawTag(value)
      : objectToString(value);
  }

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) &&
      isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function(srcValue, key) {
      stack || (stack = new Stack);
      if (isObject(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      }
      else {
        var newValue = customizer
          ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
          : undefined;

        if (newValue === undefined) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }

  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer
      ? customizer(objValue, srcValue, (key + ''), object, source, stack)
      : undefined;

    var isCommon = newValue === undefined;

    if (isCommon) {
      var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);

      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray(objValue)) {
          newValue = objValue;
        }
        else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        }
        else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        }
        else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        }
        else {
          newValue = [];
        }
      }
      else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        }
        else if (!isObject(objValue) || isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      }
      else {
        isCommon = false;
      }
    }
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

    buffer.copy(result);
    return result;
  }

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
        length = source.length;

    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});

    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];

      var newValue = customizer
        ? customizer(object[key], source[key], key, object, source)
        : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;

      customizer = (assigner.length > 3 && typeof customizer == 'function')
        ? (length--, customizer)
        : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !isPrototype(object))
      ? baseCreate(getPrototype(object))
      : {};
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;

    return !!length &&
      (type == 'number' ||
        (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
  }

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)
        ) {
      return eq(object[index], value);
    }
    return false;
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

    return value === proto;
  }

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
      return;
    }

    if (key == '__proto__') {
      return;
    }

    return object[key];
  }

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
        lastCalled = 0;

    return function() {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
      !propertyIsEnumerable.call(value, 'callee');
  };

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor &&
      funcToString.call(Ctor) == objectCtorString;
  }

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }

  /**
   * This method is like `_.merge` except that it accepts `customizer` which
   * is invoked to produce the merged values of the destination and source
   * properties. If `customizer` returns `undefined`, merging is handled by the
   * method instead. The `customizer` is invoked with six arguments:
   * (objValue, srcValue, key, object, source, stack).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} customizer The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   if (_.isArray(objValue)) {
   *     return objValue.concat(srcValue);
   *   }
   * }
   *
   * var object = { 'a': [1], 'b': [2] };
   * var other = { 'a': [3], 'b': [4] };
   *
   * _.mergeWith(object, other, customizer);
   * // => { 'a': [1, 3], 'b': [2, 4] }
   */
  var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
  });

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function() {
      return value;
    };
  }

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = mergeWith;
  });

  // src/utils/create-transform.ts
  var isImportant = (value) => /!(important)?$/.test(value);
  var withoutImportant = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
  var tokenToCSSVar = (scale, value) => (theme) => {
    const valueStr = String(value);
    const important = isImportant(valueStr);
    const valueWithoutImportant = withoutImportant(valueStr);
    const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
    let transformed = isObject$1(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    transformed = withoutImportant(transformed);
    return important ? `${transformed} !important` : transformed;
  };
  function createTransform(options) {
    const { scale, transform: transform2, compose } = options;
    const fn = (value, theme) => {
      var _a;
      const _value = tokenToCSSVar(scale, value)(theme);
      let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
      if (compose) {
        result = compose(result, theme);
      }
      return result;
    };
    return fn;
  }

  // src/utils/pipe.ts
  var pipe$2 = (...fns) => (v) => fns.reduce((a, b) => b(a), v);

  // src/utils/prop-config.ts
  function toConfig(scale, transform2) {
    return (property) => {
      const result = { property, scale };
      result.transform = createTransform({
        scale,
        transform: transform2
      });
      return result;
    };
  }
  var getRtl = ({ rtl, ltr }) => (theme) => theme.direction === "rtl" ? rtl : ltr;
  function logical(options) {
    const { property, scale, transform: transform2 } = options;
    return {
      scale,
      property: getRtl(property),
      transform: scale ? createTransform({
        scale,
        compose: transform2
      }) : transform2
    };
  }

  // src/utils/templates.ts
  var transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
  ];
  function getTransformTemplate() {
    return [
      "translateX(var(--chakra-translate-x, 0))",
      "translateY(var(--chakra-translate-y, 0))",
      ...transformTemplate
    ].join(" ");
  }
  function getTransformGpuTemplate() {
    return [
      "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
      ...transformTemplate
    ].join(" ");
  }
  var filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
      "var(--chakra-blur)",
      "var(--chakra-brightness)",
      "var(--chakra-contrast)",
      "var(--chakra-grayscale)",
      "var(--chakra-hue-rotate)",
      "var(--chakra-invert)",
      "var(--chakra-saturate)",
      "var(--chakra-sepia)",
      "var(--chakra-drop-shadow)"
    ].join(" ")
  };
  var backdropFilterTemplate = {
    backdropFilter: [
      "var(--chakra-backdrop-blur)",
      "var(--chakra-backdrop-brightness)",
      "var(--chakra-backdrop-contrast)",
      "var(--chakra-backdrop-grayscale)",
      "var(--chakra-backdrop-hue-rotate)",
      "var(--chakra-backdrop-invert)",
      "var(--chakra-backdrop-opacity)",
      "var(--chakra-backdrop-saturate)",
      "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
  };
  function getRingTemplate(value) {
    return {
      "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
      "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
      "--chakra-ring-width": value,
      boxShadow: [
        `var(--chakra-ring-offset-shadow)`,
        `var(--chakra-ring-shadow)`,
        `var(--chakra-shadow, 0 0 #0000)`
      ].join(", ")
    };
  }
  var flexDirectionTemplate = {
    "row-reverse": {
      space: "--chakra-space-x-reverse",
      divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
      space: "--chakra-space-y-reverse",
      divide: "--chakra-divide-y-reverse"
    }
  };

  // src/utils/parse-gradient.ts
  var directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
  };
  var valueSet = new Set(Object.values(directionMap));
  var globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]);
  var trimSpace = (str) => str.trim();
  function parseGradient(value, theme) {
    if (value == null || globalSet.has(value))
      return value;
    const prevent = isCSSFunction(value) || globalSet.has(value);
    if (!prevent)
      return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results == null ? void 0 : results[1];
    const values = results == null ? void 0 : results[2];
    if (!type || !values)
      return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map(trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0)
      return value;
    const direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop) => {
      if (valueSet.has(stop))
        return stop;
      const firstStop = stop.indexOf(" ");
      const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
      const _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
      const key = `colors.${_color}`;
      const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
      return _stopOrFunc ? [
        color2,
        ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
      ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
  }
  var isCSSFunction = (value) => {
    return typeof value === "string" && value.includes("(") && value.includes(")");
  };
  var gradientTransform = (value, theme) => parseGradient(value, theme != null ? theme : {});

  // src/utils/transform-functions.ts
  function isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
  }
  var analyzeCSSValue = (value) => {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return { unitless: !unit, value: num, unit };
  };
  var wrap = (str) => (value) => `${str}(${value})`;
  var transformFunctions = {
    filter(value) {
      return value !== "auto" ? value : filterTemplate;
    },
    backdropFilter(value) {
      return value !== "auto" ? value : backdropFilterTemplate;
    },
    ring(value) {
      return getRingTemplate(transformFunctions.px(value));
    },
    bgClip(value) {
      return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
    },
    transform(value) {
      if (value === "auto")
        return getTransformTemplate();
      if (value === "auto-gpu")
        return getTransformGpuTemplate();
      return value;
    },
    vh(value) {
      return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px(value) {
      if (value == null)
        return value;
      const { unitless } = analyzeCSSValue(value);
      return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction(value) {
      return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float(value, theme) {
      const map = { left: "right", right: "left" };
      return theme.direction === "rtl" ? map[value] : value;
    },
    degree(value) {
      if (isCssVar(value) || value == null)
        return value;
      const unitless = typeof value === "string" && !value.endsWith("deg");
      return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: gradientTransform,
    blur: wrap("blur"),
    opacity: wrap("opacity"),
    brightness: wrap("brightness"),
    contrast: wrap("contrast"),
    dropShadow: wrap("drop-shadow"),
    grayscale: wrap("grayscale"),
    hueRotate: (value) => wrap("hue-rotate")(transformFunctions.degree(value)),
    invert: wrap("invert"),
    saturate: wrap("saturate"),
    sepia: wrap("sepia"),
    bgImage(value) {
      if (value == null)
        return value;
      const prevent = isCSSFunction(value) || globalSet.has(value);
      return !prevent ? `url(${value})` : value;
    },
    outline(value) {
      const isNoneOrZero = String(value) === "0" || String(value) === "none";
      return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
    },
    flexDirection(value) {
      var _a;
      const { space: space2, divide: divide2 } = (_a = flexDirectionTemplate[value]) != null ? _a : {};
      const result = { flexDirection: value };
      if (space2)
        result[space2] = 1;
      if (divide2)
        result[divide2] = 1;
      return result;
    }
  };

  // src/utils/index.ts
  var t$2 = {
    borderWidths: toConfig("borderWidths"),
    borderStyles: toConfig("borderStyles"),
    colors: toConfig("colors"),
    borders: toConfig("borders"),
    gradients: toConfig("gradients", transformFunctions.gradient),
    radii: toConfig("radii", transformFunctions.px),
    space: toConfig("space", pipe$2(transformFunctions.vh, transformFunctions.px)),
    spaceT: toConfig("space", pipe$2(transformFunctions.vh, transformFunctions.px)),
    degreeT(property) {
      return { property, transform: transformFunctions.degree };
    },
    prop(property, scale, transform2) {
      return {
        property,
        scale,
        ...scale && {
          transform: createTransform({ scale, transform: transform2 })
        }
      };
    },
    propT(property, transform2) {
      return { property, transform: transform2 };
    },
    sizes: toConfig("sizes", pipe$2(transformFunctions.vh, transformFunctions.px)),
    sizesT: toConfig("sizes", pipe$2(transformFunctions.vh, transformFunctions.fraction)),
    shadows: toConfig("shadows"),
    logical,
    blur: toConfig("blur", transformFunctions.blur)
  };

  // src/config/background.ts
  var background = {
    background: t$2.colors("background"),
    backgroundColor: t$2.colors("backgroundColor"),
    backgroundImage: t$2.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: { transform: transformFunctions.bgClip },
    bgSize: t$2.prop("backgroundSize"),
    bgPosition: t$2.prop("backgroundPosition"),
    bg: t$2.colors("background"),
    bgColor: t$2.colors("backgroundColor"),
    bgPos: t$2.prop("backgroundPosition"),
    bgRepeat: t$2.prop("backgroundRepeat"),
    bgAttachment: t$2.prop("backgroundAttachment"),
    bgGradient: t$2.gradients("backgroundImage"),
    bgClip: { transform: transformFunctions.bgClip }
  };
  Object.assign(background, {
    bgImage: background.backgroundImage,
    bgImg: background.backgroundImage
  });

  // src/config/border.ts
  var border = {
    border: t$2.borders("border"),
    borderWidth: t$2.borderWidths("borderWidth"),
    borderStyle: t$2.borderStyles("borderStyle"),
    borderColor: t$2.colors("borderColor"),
    borderRadius: t$2.radii("borderRadius"),
    borderTop: t$2.borders("borderTop"),
    borderBlockStart: t$2.borders("borderBlockStart"),
    borderTopLeftRadius: t$2.radii("borderTopLeftRadius"),
    borderStartStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderTopLeftRadius",
        rtl: "borderTopRightRadius"
      }
    }),
    borderEndStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomLeftRadius",
        rtl: "borderBottomRightRadius"
      }
    }),
    borderTopRightRadius: t$2.radii("borderTopRightRadius"),
    borderStartEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderTopRightRadius",
        rtl: "borderTopLeftRadius"
      }
    }),
    borderEndEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomRightRadius",
        rtl: "borderBottomLeftRadius"
      }
    }),
    borderRight: t$2.borders("borderRight"),
    borderInlineEnd: t$2.borders("borderInlineEnd"),
    borderBottom: t$2.borders("borderBottom"),
    borderBlockEnd: t$2.borders("borderBlockEnd"),
    borderBottomLeftRadius: t$2.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: t$2.radii("borderBottomRightRadius"),
    borderLeft: t$2.borders("borderLeft"),
    borderInlineStart: {
      property: "borderInlineStart",
      scale: "borders"
    },
    borderInlineStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
        rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
      }
    }),
    borderInlineEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
        rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
      }
    }),
    borderX: t$2.borders(["borderLeft", "borderRight"]),
    borderInline: t$2.borders("borderInline"),
    borderY: t$2.borders(["borderTop", "borderBottom"]),
    borderBlock: t$2.borders("borderBlock"),
    borderTopWidth: t$2.borderWidths("borderTopWidth"),
    borderBlockStartWidth: t$2.borderWidths("borderBlockStartWidth"),
    borderTopColor: t$2.colors("borderTopColor"),
    borderBlockStartColor: t$2.colors("borderBlockStartColor"),
    borderTopStyle: t$2.borderStyles("borderTopStyle"),
    borderBlockStartStyle: t$2.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: t$2.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: t$2.borderWidths("borderBlockEndWidth"),
    borderBottomColor: t$2.colors("borderBottomColor"),
    borderBlockEndColor: t$2.colors("borderBlockEndColor"),
    borderBottomStyle: t$2.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: t$2.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: t$2.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: t$2.borderWidths("borderInlineStartWidth"),
    borderLeftColor: t$2.colors("borderLeftColor"),
    borderInlineStartColor: t$2.colors("borderInlineStartColor"),
    borderLeftStyle: t$2.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: t$2.borderStyles("borderInlineStartStyle"),
    borderRightWidth: t$2.borderWidths("borderRightWidth"),
    borderInlineEndWidth: t$2.borderWidths("borderInlineEndWidth"),
    borderRightColor: t$2.colors("borderRightColor"),
    borderInlineEndColor: t$2.colors("borderInlineEndColor"),
    borderRightStyle: t$2.borderStyles("borderRightStyle"),
    borderInlineEndStyle: t$2.borderStyles("borderInlineEndStyle"),
    borderTopRadius: t$2.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
    borderBottomRadius: t$2.radii([
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]),
    borderLeftRadius: t$2.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
    borderRightRadius: t$2.radii([
      "borderTopRightRadius",
      "borderBottomRightRadius"
    ])
  };
  Object.assign(border, {
    rounded: border.borderRadius,
    roundedTop: border.borderTopRadius,
    roundedTopLeft: border.borderTopLeftRadius,
    roundedTopRight: border.borderTopRightRadius,
    roundedTopStart: border.borderStartStartRadius,
    roundedTopEnd: border.borderStartEndRadius,
    roundedBottom: border.borderBottomRadius,
    roundedBottomLeft: border.borderBottomLeftRadius,
    roundedBottomRight: border.borderBottomRightRadius,
    roundedBottomStart: border.borderEndStartRadius,
    roundedBottomEnd: border.borderEndEndRadius,
    roundedLeft: border.borderLeftRadius,
    roundedRight: border.borderRightRadius,
    roundedStart: border.borderInlineStartRadius,
    roundedEnd: border.borderInlineEndRadius,
    borderStart: border.borderInlineStart,
    borderEnd: border.borderInlineEnd,
    borderTopStartRadius: border.borderStartStartRadius,
    borderTopEndRadius: border.borderStartEndRadius,
    borderBottomStartRadius: border.borderEndStartRadius,
    borderBottomEndRadius: border.borderEndEndRadius,
    borderStartRadius: border.borderInlineStartRadius,
    borderEndRadius: border.borderInlineEndRadius,
    borderStartWidth: border.borderInlineStartWidth,
    borderEndWidth: border.borderInlineEndWidth,
    borderStartColor: border.borderInlineStartColor,
    borderEndColor: border.borderInlineEndColor,
    borderStartStyle: border.borderInlineStartStyle,
    borderEndStyle: border.borderInlineEndStyle
  });

  // src/config/color.ts
  var color$1 = {
    color: t$2.colors("color"),
    textColor: t$2.colors("color"),
    fill: t$2.colors("fill"),
    stroke: t$2.colors("stroke")
  };

  // src/config/effect.ts
  var effect = {
    boxShadow: t$2.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: t$2.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: t$2.prop("backgroundBlendMode"),
    opacity: true
  };
  Object.assign(effect, {
    shadow: effect.boxShadow
  });

  // src/config/filter.ts
  var filter$1 = {
    filter: { transform: transformFunctions.filter },
    blur: t$2.blur("--chakra-blur"),
    brightness: t$2.propT("--chakra-brightness", transformFunctions.brightness),
    contrast: t$2.propT("--chakra-contrast", transformFunctions.contrast),
    hueRotate: t$2.propT("--chakra-hue-rotate", transformFunctions.hueRotate),
    invert: t$2.propT("--chakra-invert", transformFunctions.invert),
    saturate: t$2.propT("--chakra-saturate", transformFunctions.saturate),
    dropShadow: t$2.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
    backdropFilter: { transform: transformFunctions.backdropFilter },
    backdropBlur: t$2.blur("--chakra-backdrop-blur"),
    backdropBrightness: t$2.propT(
      "--chakra-backdrop-brightness",
      transformFunctions.brightness
    ),
    backdropContrast: t$2.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
    backdropHueRotate: t$2.propT(
      "--chakra-backdrop-hue-rotate",
      transformFunctions.hueRotate
    ),
    backdropInvert: t$2.propT("--chakra-backdrop-invert", transformFunctions.invert),
    backdropSaturate: t$2.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
  };

  // src/config/flexbox.ts
  var flexbox = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: { transform: transformFunctions.flexDirection },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: t$2.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: t$2.space("gap"),
    rowGap: t$2.space("rowGap"),
    columnGap: t$2.space("columnGap")
  };
  Object.assign(flexbox, {
    flexDir: flexbox.flexDirection
  });

  // src/config/grid.ts
  var grid = {
    gridGap: t$2.space("gridGap"),
    gridColumnGap: t$2.space("gridColumnGap"),
    gridRowGap: t$2.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
  };

  // src/config/interactivity.ts
  var interactivity = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: { transform: transformFunctions.outline },
    outlineOffset: true,
    outlineColor: t$2.colors("outlineColor")
  };

  // src/config/layout.ts
  var layout$1 = {
    width: t$2.sizesT("width"),
    inlineSize: t$2.sizesT("inlineSize"),
    height: t$2.sizes("height"),
    blockSize: t$2.sizes("blockSize"),
    boxSize: t$2.sizes(["width", "height"]),
    minWidth: t$2.sizes("minWidth"),
    minInlineSize: t$2.sizes("minInlineSize"),
    minHeight: t$2.sizes("minHeight"),
    minBlockSize: t$2.sizes("minBlockSize"),
    maxWidth: t$2.sizes("maxWidth"),
    maxInlineSize: t$2.sizes("maxInlineSize"),
    maxHeight: t$2.sizes("maxHeight"),
    maxBlockSize: t$2.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
      scale: "breakpoints",
      transform: (value, theme) => {
        var _a, _b, _c;
        const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
        const mq = `@media screen and (min-width: ${breakpoint})`;
        return { [mq]: { display: "none" } };
      }
    },
    hideBelow: {
      scale: "breakpoints",
      transform: (value, theme) => {
        var _a, _b, _c;
        const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
        const mq = `@media screen and (max-width: ${breakpoint})`;
        return { [mq]: { display: "none" } };
      }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: t$2.propT("float", transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
  };
  Object.assign(layout$1, {
    w: layout$1.width,
    h: layout$1.height,
    minW: layout$1.minWidth,
    maxW: layout$1.maxWidth,
    minH: layout$1.minHeight,
    maxH: layout$1.maxHeight,
    overscroll: layout$1.overscrollBehavior,
    overscrollX: layout$1.overscrollBehaviorX,
    overscrollY: layout$1.overscrollBehaviorY
  });

  // src/config/list.ts
  var list = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: t$2.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: t$2.prop("listStyleImage")
  };

  // src/get.ts
  function get$1(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [path];
    for (index = 0; index < key.length; index += 1) {
      if (!obj)
        break;
      obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
  }
  var memoize$1 = (fn) => {
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index) => {
      if (typeof obj === "undefined") {
        return fn(obj, path, fallback);
      }
      if (!cache.has(obj)) {
        cache.set(obj, /* @__PURE__ */ new Map());
      }
      const map = cache.get(obj);
      if (map.has(path)) {
        return map.get(path);
      }
      const value = fn(obj, path, fallback, index);
      map.set(path, value);
      return value;
    };
    return memoizedFn;
  };
  var memoizedGet$1 = memoize$1(get$1);

  // src/config/others.ts
  var srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
  };
  var srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
  };
  var getWithPriority = (theme, key, styles) => {
    const result = {};
    const obj = memoizedGet$1(theme, key, {});
    for (const prop in obj) {
      const isInStyles = prop in styles && styles[prop] != null;
      if (!isInStyles)
        result[prop] = obj[prop];
    }
    return result;
  };
  var others = {
    srOnly: {
      transform(value) {
        if (value === true)
          return srOnly;
        if (value === "focusable")
          return srFocusable;
        return {};
      }
    },
    layerStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, value, styles)
    }
  };

  // src/config/position.ts
  var position = {
    position: true,
    pos: t$2.prop("position"),
    zIndex: t$2.prop("zIndex", "zIndices"),
    inset: t$2.spaceT("inset"),
    insetX: t$2.spaceT(["left", "right"]),
    insetInline: t$2.spaceT("insetInline"),
    insetY: t$2.spaceT(["top", "bottom"]),
    insetBlock: t$2.spaceT("insetBlock"),
    top: t$2.spaceT("top"),
    insetBlockStart: t$2.spaceT("insetBlockStart"),
    bottom: t$2.spaceT("bottom"),
    insetBlockEnd: t$2.spaceT("insetBlockEnd"),
    left: t$2.spaceT("left"),
    insetInlineStart: t$2.logical({
      scale: "space",
      property: { ltr: "left", rtl: "right" }
    }),
    right: t$2.spaceT("right"),
    insetInlineEnd: t$2.logical({
      scale: "space",
      property: { ltr: "right", rtl: "left" }
    })
  };
  Object.assign(position, {
    insetStart: position.insetInlineStart,
    insetEnd: position.insetInlineEnd
  });

  // src/config/ring.ts
  var ring = {
    ring: { transform: transformFunctions.ring },
    ringColor: t$2.colors("--chakra-ring-color"),
    ringOffset: t$2.prop("--chakra-ring-offset-width"),
    ringOffsetColor: t$2.colors("--chakra-ring-offset-color"),
    ringInset: t$2.prop("--chakra-ring-inset")
  };

  // src/config/space.ts
  var space = {
    margin: t$2.spaceT("margin"),
    marginTop: t$2.spaceT("marginTop"),
    marginBlockStart: t$2.spaceT("marginBlockStart"),
    marginRight: t$2.spaceT("marginRight"),
    marginInlineEnd: t$2.spaceT("marginInlineEnd"),
    marginBottom: t$2.spaceT("marginBottom"),
    marginBlockEnd: t$2.spaceT("marginBlockEnd"),
    marginLeft: t$2.spaceT("marginLeft"),
    marginInlineStart: t$2.spaceT("marginInlineStart"),
    marginX: t$2.spaceT(["marginInlineStart", "marginInlineEnd"]),
    marginInline: t$2.spaceT("marginInline"),
    marginY: t$2.spaceT(["marginTop", "marginBottom"]),
    marginBlock: t$2.spaceT("marginBlock"),
    padding: t$2.space("padding"),
    paddingTop: t$2.space("paddingTop"),
    paddingBlockStart: t$2.space("paddingBlockStart"),
    paddingRight: t$2.space("paddingRight"),
    paddingBottom: t$2.space("paddingBottom"),
    paddingBlockEnd: t$2.space("paddingBlockEnd"),
    paddingLeft: t$2.space("paddingLeft"),
    paddingInlineStart: t$2.space("paddingInlineStart"),
    paddingInlineEnd: t$2.space("paddingInlineEnd"),
    paddingX: t$2.space(["paddingInlineStart", "paddingInlineEnd"]),
    paddingInline: t$2.space("paddingInline"),
    paddingY: t$2.space(["paddingTop", "paddingBottom"]),
    paddingBlock: t$2.space("paddingBlock")
  };
  Object.assign(space, {
    m: space.margin,
    mt: space.marginTop,
    mr: space.marginRight,
    me: space.marginInlineEnd,
    marginEnd: space.marginInlineEnd,
    mb: space.marginBottom,
    ml: space.marginLeft,
    ms: space.marginInlineStart,
    marginStart: space.marginInlineStart,
    mx: space.marginX,
    my: space.marginY,
    p: space.padding,
    pt: space.paddingTop,
    py: space.paddingY,
    px: space.paddingX,
    pb: space.paddingBottom,
    pl: space.paddingLeft,
    ps: space.paddingInlineStart,
    paddingStart: space.paddingInlineStart,
    pr: space.paddingRight,
    pe: space.paddingInlineEnd,
    paddingEnd: space.paddingInlineEnd
  });

  // src/config/text-decoration.ts
  var textDecoration = {
    textDecorationColor: t$2.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: { property: "textDecoration" },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: t$2.shadows("textShadow")
  };

  // src/config/transform.ts
  var transform = {
    clipPath: true,
    transform: t$2.propT("transform", transformFunctions.transform),
    transformOrigin: true,
    translateX: t$2.spaceT("--chakra-translate-x"),
    translateY: t$2.spaceT("--chakra-translate-y"),
    skewX: t$2.degreeT("--chakra-skew-x"),
    skewY: t$2.degreeT("--chakra-skew-y"),
    scaleX: t$2.prop("--chakra-scale-x"),
    scaleY: t$2.prop("--chakra-scale-y"),
    scale: t$2.prop(["--chakra-scale-x", "--chakra-scale-y"]),
    rotate: t$2.degreeT("--chakra-rotate")
  };

  // src/config/transition.ts
  var transition$2 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: t$2.prop("transitionDuration", "transition.duration"),
    transitionProperty: t$2.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: t$2.prop(
      "transitionTimingFunction",
      "transition.easing"
    )
  };

  // src/config/typography.ts
  var typography$2 = {
    fontFamily: t$2.prop("fontFamily", "fonts"),
    fontSize: t$2.prop("fontSize", "fontSizes", transformFunctions.px),
    fontWeight: t$2.prop("fontWeight", "fontWeights"),
    lineHeight: t$2.prop("lineHeight", "lineHeights"),
    letterSpacing: t$2.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
      transform(value) {
        if (value === true) {
          return {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          };
        }
      }
    },
    noOfLines: {
      static: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        //@ts-ignore
        WebkitLineClamp: "var(--chakra-line-clamp)"
      },
      property: "--chakra-line-clamp"
    }
  };

  // src/config/scroll.ts
  var scroll = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: t$2.spaceT("scrollMargin"),
    scrollMarginTop: t$2.spaceT("scrollMarginTop"),
    scrollMarginBottom: t$2.spaceT("scrollMarginBottom"),
    scrollMarginLeft: t$2.spaceT("scrollMarginLeft"),
    scrollMarginRight: t$2.spaceT("scrollMarginRight"),
    scrollMarginX: t$2.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
    scrollMarginY: t$2.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
    // scroll padding
    scrollPadding: t$2.spaceT("scrollPadding"),
    scrollPaddingTop: t$2.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: t$2.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: t$2.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: t$2.spaceT("scrollPaddingRight"),
    scrollPaddingX: t$2.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
    scrollPaddingY: t$2.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
  };
  function resolveReference(operand) {
    if (isObject$1(operand) && operand.reference) {
      return operand.reference;
    }
    return String(operand);
  }
  var toExpression = (operator, ...operands) => operands.map(resolveReference).join(` ${operator} `).replace(/calc/g, "");
  var add$1 = (...operands) => `calc(${toExpression("+", ...operands)})`;
  var subtract$1 = (...operands) => `calc(${toExpression("-", ...operands)})`;
  var multiply$1 = (...operands) => `calc(${toExpression("*", ...operands)})`;
  var divide$1 = (...operands) => `calc(${toExpression("/", ...operands)})`;
  var negate$1 = (x) => {
    const value = resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) {
      return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    }
    return multiply$1(value, -1);
  };
  var calc$1 = Object.assign(
    (x) => ({
      add: (...operands) => calc$1(add$1(x, ...operands)),
      subtract: (...operands) => calc$1(subtract$1(x, ...operands)),
      multiply: (...operands) => calc$1(multiply$1(x, ...operands)),
      divide: (...operands) => calc$1(divide$1(x, ...operands)),
      negate: () => calc$1(negate$1(x)),
      toString: () => x.toString()
    }),
    {
      add: add$1,
      subtract: subtract$1,
      multiply: multiply$1,
      divide: divide$1,
      negate: negate$1
    }
  );

  // src/create-theme-vars/css-var.ts
  function replaceWhiteSpace$1(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
  }
  function escape$1(value) {
    const valueStr = replaceWhiteSpace$1(value.toString());
    return escapeSymbol(escapeDot(valueStr));
  }
  function escapeDot(value) {
    if (value.includes("\\."))
      return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
  }
  function escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
  }
  function addPrefix$1(value, prefix = "") {
    return [prefix, value].filter(Boolean).join("-");
  }
  function toVarReference(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
  }
  function toVarDefinition(value, prefix = "") {
    return escape$1(`--${addPrefix$1(value, prefix)}`);
  }
  function cssVar$1(name, fallback, cssVarPrefix) {
    const cssVariable = toVarDefinition(name, cssVarPrefix);
    return {
      variable: cssVariable,
      reference: toVarReference(cssVariable, fallback)
    };
  }
  function defineCssVars(scope, keys2) {
    const vars = {};
    for (const key of keys2) {
      if (Array.isArray(key)) {
        const [name, fallback] = key;
        vars[name] = cssVar$1(`${scope}-${name}`, fallback);
        continue;
      }
      vars[key] = cssVar$1(`${scope}-${key}`);
    }
    return vars;
  }
  function getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  function analyzeCSSValue2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return { unitless: !unit, value: num, unit };
  }
  function px$1(value) {
    if (value == null)
      return value;
    const { unitless } = analyzeCSSValue2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
  }
  var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
  var sortBps = (breakpoints) => Object.fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
  function normalize(breakpoints) {
    const sorted = sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
  }
  function keys(breakpoints) {
    const value = Object.keys(sortBps(breakpoints));
    return new Set(value);
  }
  function subtract2(value) {
    var _a;
    if (!value)
      return value;
    value = (_a = px$1(value)) != null ? _a : value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + OFFSET}`);
  }
  function toMediaQueryString(min, max) {
    const query = ["@media screen"];
    if (min)
      query.push("and", `(min-width: ${px$1(min)})`);
    if (max)
      query.push("and", `(max-width: ${px$1(max)})`);
    return query.join(" ");
  }
  function analyzeBreakpoints(breakpoints) {
    var _a;
    if (!breakpoints)
      return null;
    breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
    const normalized = normalize(breakpoints);
    const queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
      var _a2;
      let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
      maxW = parseFloat(maxW) > 0 ? subtract2(maxW) : void 0;
      return {
        _minW: subtract2(minW),
        breakpoint,
        minW,
        maxW,
        maxWQuery: toMediaQueryString(null, maxW),
        minWQuery: toMediaQueryString(minW),
        minMaxQuery: toMediaQueryString(minW, maxW)
      };
    });
    const _keys = keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
      keys: _keys,
      normalized,
      isResponsive(test) {
        const keys2 = Object.keys(test);
        return keys2.length > 0 && keys2.every((key) => _keys.has(key));
      },
      asObject: sortBps(breakpoints),
      asArray: normalize(breakpoints),
      details: queries,
      get(key) {
        return queries.find((q) => q.breakpoint === key);
      },
      media: [
        null,
        ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
      ],
      /**
       * Converts the object responsive syntax to array syntax
       *
       * @example
       * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
       */
      toArrayValue(test) {
        if (!isObject$1(test)) {
          throw new Error("toArrayValue: value must be an object");
        }
        const result = _keysArr.map((bp) => {
          var _a2;
          return (_a2 = test[bp]) != null ? _a2 : null;
        });
        while (getLastItem(result) === null) {
          result.pop();
        }
        return result;
      },
      /**
       * Converts the array responsive syntax to object syntax
       *
       * @example
       * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
       */
      toObjectValue(test) {
        if (!Array.isArray(test)) {
          throw new Error("toObjectValue: value must be an array");
        }
        return test.reduce((acc, value, index) => {
          const key = _keysArr[index];
          if (key != null && value != null)
            acc[key] = value;
          return acc;
        }, {});
      }
    };
  }

  // src/pseudos.ts
  var state = {
    hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post) => `${str}:focus-visible ${post}`,
    focusWithin: (str, post) => `${str}:focus-within ${post}`,
    active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
    indeterminate: (str, post) => `${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
    readOnly: (str, post) => `${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
    expanded: (str, post) => `${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
    placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
  };
  var toGroup = (fn) => merge((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
  var toPeer = (fn) => merge((v) => fn(v, "~ &"), "[data-peer]", ".peer");
  var merge = (fn, ...selectors) => selectors.map(fn).join(", ");
  var pseudoSelectors = {
    /**
     * Styles for CSS selector `&:hover`
     */
    _hover: "&:hover, &[data-hover]",
    /**
     * Styles for CSS Selector `&:active`
     */
    _active: "&:active, &[data-active]",
    /**
     * Styles for CSS selector `&:focus`
     *
     */
    _focus: "&:focus, &[data-focus]",
    /**
     * Styles for the highlighted state.
     */
    _highlighted: "&[data-highlighted]",
    /**
     * Styles to apply when a child of this element has received focus
     * - CSS Selector `&:focus-within`
     */
    _focusWithin: "&:focus-within",
    /**
     * Styles to apply when this element has received focus via tabbing
     * - CSS Selector `&:focus-visible`
     */
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
     * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
     * - `&[aria-disabled=true]`
     * - `&:disabled`
     * - `&[data-disabled]`
     * - `&[disabled]`
     */
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
     * Styles for CSS Selector `&:readonly`
     */
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
     * Styles for CSS selector `&::before`
     *
     * NOTE:When using this, ensure the `content` is wrapped in a backtick.
     * @example
     * ```jsx
     * <Box _before={{content:`""` }}/>
     * ```
     */
    _before: "&::before",
    /**
     * Styles for CSS selector `&::after`
     *
     * NOTE:When using this, ensure the `content` is wrapped in a backtick.
     * @example
     * ```jsx
     * <Box _after={{content:`""` }}/>
     * ```
     */
    _after: "&::after",
    /**
     * Styles for CSS selector `&:empty`
     */
    _empty: "&:empty",
    /**
     * Styles to apply when the ARIA attribute `aria-expanded` is `true`
     * - CSS selector `&[aria-expanded=true]`
     */
    _expanded: "&[aria-expanded=true], &[data-expanded]",
    /**
     * Styles to apply when the ARIA attribute `aria-checked` is `true`
     * - CSS selector `&[aria-checked=true]`
     */
    _checked: "&[aria-checked=true], &[data-checked]",
    /**
     * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
     * - CSS selector `&[aria-grabbed=true]`
     */
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
     * Styles for CSS Selector `&[aria-pressed=true]`
     * Typically used to style the current "pressed" state of toggle buttons
     */
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
     * Styles to apply when the ARIA attribute `aria-invalid` is `true`
     * - CSS selector `&[aria-invalid=true]`
     */
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
     * Styles for the valid state
     * - CSS selector `&[data-valid], &[data-state=valid]`
     */
    _valid: "&[data-valid], &[data-state=valid]",
    /**
     * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
     * Useful for styling loading states
     */
    _loading: "&[data-loading], &[aria-busy=true]",
    /**
     * Styles to apply when the ARIA attribute `aria-selected` is `true`
     *
     * - CSS selector `&[aria-selected=true]`
     */
    _selected: "&[aria-selected=true], &[data-selected]",
    /**
     * Styles for CSS Selector `[hidden=true]`
     */
    _hidden: "&[hidden], &[data-hidden]",
    /**
     * Styles for CSS Selector `&:-webkit-autofill`
     */
    _autofill: "&:-webkit-autofill",
    /**
     * Styles for CSS Selector `&:nth-child(even)`
     */
    _even: "&:nth-of-type(even)",
    /**
     * Styles for CSS Selector `&:nth-child(odd)`
     */
    _odd: "&:nth-of-type(odd)",
    /**
     * Styles for CSS Selector `&:first-of-type`
     */
    _first: "&:first-of-type",
    /**
     * Styles for CSS selector `&::first-letter`
     *
     * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
     * @example
     * ```jsx
     * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
     * ```
     */
    _firstLetter: "&::first-letter",
    /**
     * Styles for CSS Selector `&:last-of-type`
     */
    _last: "&:last-of-type",
    /**
     * Styles for CSS Selector `&:not(:first-of-type)`
     */
    _notFirst: "&:not(:first-of-type)",
    /**
     * Styles for CSS Selector `&:not(:last-of-type)`
     */
    _notLast: "&:not(:last-of-type)",
    /**
     * Styles for CSS Selector `&:visited`
     */
    _visited: "&:visited",
    /**
     * Used to style the active link in a navigation
     * Styles for CSS Selector `&[aria-current=page]`
     */
    _activeLink: "&[aria-current=page]",
    /**
     * Used to style the current step within a process
     * Styles for CSS Selector `&[aria-current=step]`
     */
    _activeStep: "&[aria-current=step]",
    /**
     * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
     * - CSS selector `&[aria-checked=mixed]`
     */
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
     */
    _groupHover: toGroup(state.hover),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
     */
    _peerHover: toPeer(state.hover),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
     */
    _groupFocus: toGroup(state.focus),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
     */
    _peerFocus: toPeer(state.focus),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
     */
    _groupFocusVisible: toGroup(state.focusVisible),
    /**
     * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
     */
    _peerFocusVisible: toPeer(state.focusVisible),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
     */
    _groupActive: toGroup(state.active),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is active
     */
    _peerActive: toPeer(state.active),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
     */
    _groupDisabled: toGroup(state.disabled),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
     */
    _peerDisabled: toPeer(state.disabled),
    /**
     *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
     */
    _groupInvalid: toGroup(state.invalid),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
     */
    _peerInvalid: toPeer(state.invalid),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
     */
    _groupChecked: toGroup(state.checked),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
     */
    _peerChecked: toPeer(state.checked),
    /**
     *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
     */
    _groupFocusWithin: toGroup(state.focusWithin),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
     */
    _peerFocusWithin: toPeer(state.focusWithin),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
     */
    _peerPlaceholderShown: toPeer(state.placeholderShown),
    /**
     * Styles for CSS Selector `&::placeholder`.
     */
    _placeholder: "&::placeholder",
    /**
     * Styles for CSS Selector `&:placeholder-shown`.
     */
    _placeholderShown: "&:placeholder-shown",
    /**
     * Styles for CSS Selector `&:fullscreen`.
     */
    _fullScreen: "&:fullscreen",
    /**
     * Styles for CSS Selector `&::selection`
     */
    _selection: "&::selection",
    /**
     * Styles for CSS Selector `[dir=rtl] &`
     * It is applied when a parent element or this element has `dir="rtl"`
     */
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
     * Styles for CSS Selector `[dir=ltr] &`
     * It is applied when a parent element or this element has `dir="ltr"`
     */
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
     * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
     * It is used when the user has requested the system use a light or dark color theme.
     */
    _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
     * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
     * It is used when the user has requested the system to reduce the amount of animations.
     */
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
     * Styles for when `data-theme` is applied to any parent of
     * this component or element.
     */
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
     * Styles for when `data-theme` is applied to any parent of
     * this component or element.
     */
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
     * Styles for the CSS Selector `&[data-orientation=horizontal]`
     */
    _horizontal: "&[data-orientation=horizontal]",
    /**
     * Styles for the CSS Selector `&[data-orientation=vertical]`
     */
    _vertical: "&[data-orientation=vertical]"
  };
  var pseudoPropNames = Object.keys(
    pseudoSelectors
  );
  function tokenToCssVar(token, prefix) {
    return cssVar$1(String(token).replace(/\./g, "-"), void 0, prefix);
  }
  function createThemeVars(flatTokens, options) {
    let cssVars = {};
    const cssMap = {};
    for (const [token, tokenValue] of Object.entries(flatTokens)) {
      const { isSemantic, value } = tokenValue;
      const { variable, reference } = tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
      if (!isSemantic) {
        if (token.startsWith("space")) {
          const keys2 = token.split(".");
          const [firstKey, ...referenceKeys] = keys2;
          const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
          const negativeValue = calc$1.negate(value);
          const negatedReference = calc$1.negate(reference);
          cssMap[negativeLookupKey] = {
            value: negativeValue,
            var: variable,
            varRef: negatedReference
          };
        }
        cssVars[variable] = value;
        cssMap[token] = {
          value,
          var: variable,
          varRef: reference
        };
        continue;
      }
      const lookupToken = (maybeToken) => {
        const scale = String(token).split(".")[0];
        const withScale = [scale, maybeToken].join(".");
        const resolvedTokenValue = flatTokens[withScale];
        if (!resolvedTokenValue)
          return maybeToken;
        const { reference: reference2 } = tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
        return reference2;
      };
      const normalizedValue = isObject$1(value) ? value : { default: value };
      cssVars = lodash_mergewith(
        cssVars,
        Object.entries(normalizedValue).reduce(
          (acc, [conditionAlias, conditionValue]) => {
            var _a, _b;
            if (!conditionValue)
              return acc;
            const tokenReference = lookupToken(`${conditionValue}`);
            if (conditionAlias === "default") {
              acc[variable] = tokenReference;
              return acc;
            }
            const conditionSelector = (_b = (_a = pseudoSelectors) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
            acc[conditionSelector] = { [variable]: tokenReference };
            return acc;
          },
          {}
        )
      );
      cssMap[token] = {
        value: reference,
        var: variable,
        varRef: reference
      };
    }
    return {
      cssVars,
      cssMap
    };
  }

  // ../../utilities/object-utils/src/omit.ts
  function omit$1(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit) {
      if (key in clone) {
        delete clone[key];
      }
    }
    return clone;
  }

  // ../../utilities/object-utils/src/pick.ts
  function pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick) {
      if (key in object) {
        result[key] = object[key];
      }
    }
    return result;
  }

  // ../../utilities/object-utils/src/walk-object.ts
  function isObject5(value) {
    return typeof value === "object" && value != null && !Array.isArray(value);
  }
  function walkObject(target, predicate, options = {}) {
    const { stop, getKey } = options;
    function inner(value, path = []) {
      var _a;
      if (isObject5(value) || Array.isArray(value)) {
        const result = {};
        for (const [prop, child] of Object.entries(value)) {
          const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
          const childPath = [...path, key];
          if (stop == null ? void 0 : stop(value, childPath)) {
            return predicate(value, path);
          }
          result[key] = inner(child, childPath);
        }
        return result;
      }
      return predicate(value, path);
    }
    return inner(target);
  }

  // src/create-theme-vars/theme-tokens.ts
  var tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
  ];
  function extractTokens(theme) {
    const _tokens = tokens;
    return pick(theme, _tokens);
  }
  function extractSemanticTokens(theme) {
    return theme.semanticTokens;
  }
  function omitVars(rawTheme) {
    const { __cssMap, __cssVars, __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
  }

  // src/create-theme-vars/flatten-tokens.ts
  var isSemanticCondition = (key) => pseudoPropNames.includes(key) || "default" === key;
  function flattenTokens({
    tokens: tokens2,
    semanticTokens
  }) {
    const result = {};
    walkObject(tokens2, (value, path) => {
      if (value == null)
        return;
      result[path.join(".")] = { isSemantic: false, value };
    });
    walkObject(
      semanticTokens,
      (value, path) => {
        if (value == null)
          return;
        result[path.join(".")] = { isSemantic: true, value };
      },
      {
        stop: (value) => Object.keys(value).every(isSemanticCondition)
      }
    );
    return result;
  }

  // src/create-theme-vars/to-css-var.ts
  function toCSSVar(rawTheme) {
    var _a;
    const theme = omitVars(rawTheme);
    const tokens2 = extractTokens(theme);
    const semanticTokens = extractSemanticTokens(theme);
    const flatTokens = flattenTokens({ tokens: tokens2, semanticTokens });
    const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
    const {
      /**
       * This is more like a dictionary of tokens users will type `green.500`,
       * and their equivalent css variable.
       */
      cssMap,
      /**
       * The extracted css variables will be stored here, and used in
       * the emotion's <Global/> component to attach variables to `:root`
       */
      cssVars
    } = createThemeVars(flatTokens, { cssVarPrefix });
    const defaultCssVars = {
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
      __cssVars: { ...defaultCssVars, ...cssVars },
      __cssMap: cssMap,
      __breakpoints: analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
  }
  var systemProps = lodash_mergewith(
    {},
    background,
    border,
    color$1,
    flexbox,
    layout$1,
    filter$1,
    ring,
    interactivity,
    grid,
    others,
    position,
    effect,
    space,
    scroll,
    typography$2,
    textDecoration,
    transform,
    list,
    transition$2
  );
  Object.assign({}, space, layout$1, flexbox, grid, position);
  var propNames = [...Object.keys(systemProps), ...pseudoPropNames];
  var styleProps = { ...systemProps, ...pseudoSelectors };
  var isStyleProp = (prop) => prop in styleProps;
  var expandResponsive = (styles) => (theme) => {
    if (!theme.__breakpoints)
      return styles;
    const { isResponsive, toArrayValue, media: medias } = theme.__breakpoints;
    const computedStyles = {};
    for (const key in styles) {
      let value = runIfFn$2(styles[key], theme);
      if (value == null)
        continue;
      value = isObject$1(value) && isResponsive(value) ? toArrayValue(value) : value;
      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }
      const queries = value.slice(0, medias.length).length;
      for (let index = 0; index < queries; index += 1) {
        const media = medias == null ? void 0 : medias[index];
        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }
        computedStyles[media] = computedStyles[media] || {};
        if (value[index] == null) {
          continue;
        }
        computedStyles[media][key] = value[index];
      }
    }
    return computedStyles;
  };

  // src/utils/split-by-comma.ts
  function splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char === "(") {
        inParens = true;
        chunk += char;
      } else if (char === ")") {
        inParens = false;
        chunk += char;
      } else if (char === "," && !inParens) {
        chunks.push(chunk);
        chunk = "";
      } else {
        chunk += char;
      }
    }
    chunk = chunk.trim();
    if (chunk) {
      chunks.push(chunk);
    }
    return chunks;
  }

  // src/css.ts
  function isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
  }
  var isCSSVariableTokenValue = (key, value) => key.startsWith("--") && typeof value === "string" && !isCssVar2(value);
  var resolveTokenValue = (theme, value) => {
    var _a, _b;
    if (value == null)
      return value;
    const getVar = (val) => {
      var _a2, _b2;
      return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
    };
    const getValue = (val) => {
      var _a2;
      return (_a2 = getVar(val)) != null ? _a2 : val;
    };
    const [tokenValue, fallbackValue] = splitByComma(value);
    value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
    return value;
  };
  function getCss(options) {
    const { configs = {}, pseudos = {}, theme } = options;
    const css2 = (stylesOrFn, nested = false) => {
      var _a, _b, _c;
      const _styles = runIfFn$2(stylesOrFn, theme);
      const styles = expandResponsive(_styles)(theme);
      let computedStyles = {};
      for (let key in styles) {
        const valueOrFn = styles[key];
        let value = runIfFn$2(valueOrFn, theme);
        if (key in pseudos) {
          key = pseudos[key];
        }
        if (isCSSVariableTokenValue(key, value)) {
          value = resolveTokenValue(theme, value);
        }
        let config = configs[key];
        if (config === true) {
          config = { property: key };
        }
        if (isObject$1(value)) {
          computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
          computedStyles[key] = lodash_mergewith(
            {},
            computedStyles[key],
            css2(value, true)
          );
          continue;
        }
        let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
        rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
        const configProperty = runIfFn$2(config == null ? void 0 : config.property, theme);
        if (!nested && (config == null ? void 0 : config.static)) {
          const staticStyles = runIfFn$2(config.static, theme);
          computedStyles = lodash_mergewith({}, computedStyles, staticStyles);
        }
        if (configProperty && Array.isArray(configProperty)) {
          for (const property of configProperty) {
            computedStyles[property] = rawValue;
          }
          continue;
        }
        if (configProperty) {
          if (configProperty === "&" && isObject$1(rawValue)) {
            computedStyles = lodash_mergewith({}, computedStyles, rawValue);
          } else {
            computedStyles[configProperty] = rawValue;
          }
          continue;
        }
        if (isObject$1(rawValue)) {
          computedStyles = lodash_mergewith({}, computedStyles, rawValue);
          continue;
        }
        computedStyles[key] = rawValue;
      }
      return computedStyles;
    };
    return css2;
  }
  var css$1 = (styles) => (theme) => {
    const cssFn = getCss({
      theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };

  // src/define-styles.ts
  function defineStyle(styles) {
    return styles;
  }
  function defineStyleConfig(config) {
    return config;
  }
  function createMultiStyleConfigHelpers(parts) {
    return {
      definePartsStyle(config) {
        return config;
      },
      defineMultiStyleConfig(config) {
        return { parts, ...config };
      }
    };
  }
  function normalize2(value, toArray) {
    if (Array.isArray(value))
      return value;
    if (isObject$1(value))
      return toArray(value);
    if (value != null)
      return [value];
  }
  function getNextIndex(values, i) {
    for (let j = i + 1; j < values.length; j++) {
      if (values[j] != null)
        return j;
    }
    return -1;
  }
  function createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
      var _a, _b;
      if (!breakpointUtil)
        return;
      const result = {};
      const normalized = normalize2(value, breakpointUtil.toArrayValue);
      if (!normalized)
        return result;
      const len = normalized.length;
      const isSingle = len === 1;
      const isMultipart = !!config.parts;
      for (let i = 0; i < len; i++) {
        const key = breakpointUtil.details[i];
        const nextKey = breakpointUtil.details[getNextIndex(normalized, i)];
        const query = toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
        const styles = runIfFn$2((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
        if (!styles)
          continue;
        if (isMultipart) {
          (_b = config.parts) == null ? void 0 : _b.forEach((part) => {
            lodash_mergewith(result, {
              [part]: isSingle ? styles[part] : { [query]: styles[part] }
            });
          });
          continue;
        }
        if (!isMultipart) {
          if (isSingle)
            lodash_mergewith(result, styles);
          else
            result[query] = styles;
          continue;
        }
        result[query] = styles;
      }
      return result;
    };
  }
  function resolveStyleConfig(config) {
    return (props) => {
      var _a;
      const { variant, size, theme } = props;
      const recipe = createResolver(theme);
      return lodash_mergewith(
        {},
        runIfFn$2((_a = config.baseStyle) != null ? _a : {}, props),
        recipe(config, "sizes", size, props),
        recipe(config, "variants", variant, props)
      );
    };
  }

  // src/theming-props.ts
  function omitThemingProps(props) {
    return omit$1(props, ["styleConfig", "size", "variant", "colorScheme"]);
  }

  // src/utils/is-chakra-theme.ts
  var requiredChakraThemeKeys = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
  ];
  function isChakraTheme(unit) {
    if (!isObject$1(unit)) {
      return false;
    }
    return requiredChakraThemeKeys.every(
      (propertyName) => Object.prototype.hasOwnProperty.call(unit, propertyName)
    );
  }

  // src/foundations/transition.ts
  var transitionProperty$1 = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
  };
  var transitionTimingFunction$1 = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
  };
  var transitionDuration$1 = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
  };
  var transition$1 = {
    property: transitionProperty$1,
    easing: transitionTimingFunction$1,
    duration: transitionDuration$1
  };
  var transition_default = transition$1;

  // src/foundations/z-index.ts
  var zIndices$1 = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
  };
  var z_index_default = zIndices$1;

  // src/foundations/borders.ts
  var borders$2 = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
  };
  var borders_default = borders$2;

  // src/foundations/breakpoints.ts
  var breakpoints$1 = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
  };
  var breakpoints_default = breakpoints$1;

  // src/foundations/colors.ts
  var colors$2 = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
      50: "rgba(255, 255, 255, 0.04)",
      100: "rgba(255, 255, 255, 0.06)",
      200: "rgba(255, 255, 255, 0.08)",
      300: "rgba(255, 255, 255, 0.16)",
      400: "rgba(255, 255, 255, 0.24)",
      500: "rgba(255, 255, 255, 0.36)",
      600: "rgba(255, 255, 255, 0.48)",
      700: "rgba(255, 255, 255, 0.64)",
      800: "rgba(255, 255, 255, 0.80)",
      900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
      50: "rgba(0, 0, 0, 0.04)",
      100: "rgba(0, 0, 0, 0.06)",
      200: "rgba(0, 0, 0, 0.08)",
      300: "rgba(0, 0, 0, 0.16)",
      400: "rgba(0, 0, 0, 0.24)",
      500: "rgba(0, 0, 0, 0.36)",
      600: "rgba(0, 0, 0, 0.48)",
      700: "rgba(0, 0, 0, 0.64)",
      800: "rgba(0, 0, 0, 0.80)",
      900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923"
    },
    red: {
      50: "#FFF5F5",
      100: "#FED7D7",
      200: "#FEB2B2",
      300: "#FC8181",
      400: "#F56565",
      500: "#E53E3E",
      600: "#C53030",
      700: "#9B2C2C",
      800: "#822727",
      900: "#63171B"
    },
    orange: {
      50: "#FFFAF0",
      100: "#FEEBC8",
      200: "#FBD38D",
      300: "#F6AD55",
      400: "#ED8936",
      500: "#DD6B20",
      600: "#C05621",
      700: "#9C4221",
      800: "#7B341E",
      900: "#652B19"
    },
    yellow: {
      50: "#FFFFF0",
      100: "#FEFCBF",
      200: "#FAF089",
      300: "#F6E05E",
      400: "#ECC94B",
      500: "#D69E2E",
      600: "#B7791F",
      700: "#975A16",
      800: "#744210",
      900: "#5F370E"
    },
    green: {
      50: "#F0FFF4",
      100: "#C6F6D5",
      200: "#9AE6B4",
      300: "#68D391",
      400: "#48BB78",
      500: "#38A169",
      600: "#2F855A",
      700: "#276749",
      800: "#22543D",
      900: "#1C4532"
    },
    teal: {
      50: "#E6FFFA",
      100: "#B2F5EA",
      200: "#81E6D9",
      300: "#4FD1C5",
      400: "#38B2AC",
      500: "#319795",
      600: "#2C7A7B",
      700: "#285E61",
      800: "#234E52",
      900: "#1D4044"
    },
    blue: {
      50: "#ebf8ff",
      100: "#bee3f8",
      200: "#90cdf4",
      300: "#63b3ed",
      400: "#4299e1",
      500: "#3182ce",
      600: "#2b6cb0",
      700: "#2c5282",
      800: "#2a4365",
      900: "#1A365D"
    },
    cyan: {
      50: "#EDFDFD",
      100: "#C4F1F9",
      200: "#9DECF9",
      300: "#76E4F7",
      400: "#0BC5EA",
      500: "#00B5D8",
      600: "#00A3C4",
      700: "#0987A0",
      800: "#086F83",
      900: "#065666"
    },
    purple: {
      50: "#FAF5FF",
      100: "#E9D8FD",
      200: "#D6BCFA",
      300: "#B794F4",
      400: "#9F7AEA",
      500: "#805AD5",
      600: "#6B46C1",
      700: "#553C9A",
      800: "#44337A",
      900: "#322659"
    },
    pink: {
      50: "#FFF5F7",
      100: "#FED7E2",
      200: "#FBB6CE",
      300: "#F687B3",
      400: "#ED64A6",
      500: "#D53F8C",
      600: "#B83280",
      700: "#97266D",
      800: "#702459",
      900: "#521B41"
    },
    linkedin: {
      50: "#E8F4F9",
      100: "#CFEDFB",
      200: "#9BDAF3",
      300: "#68C7EC",
      400: "#34B3E4",
      500: "#00A0DC",
      600: "#008CC9",
      700: "#0077B5",
      800: "#005E93",
      900: "#004471"
    },
    facebook: {
      50: "#E8F4F9",
      100: "#D9DEE9",
      200: "#B7C2DA",
      300: "#6482C0",
      400: "#4267B2",
      500: "#385898",
      600: "#314E89",
      700: "#29487D",
      800: "#223B67",
      900: "#1E355B"
    },
    messenger: {
      50: "#D0E6FF",
      100: "#B9DAFF",
      200: "#A2CDFF",
      300: "#7AB8FF",
      400: "#2E90FF",
      500: "#0078FF",
      600: "#0063D1",
      700: "#0052AC",
      800: "#003C7E",
      900: "#002C5C"
    },
    whatsapp: {
      50: "#dffeec",
      100: "#b9f5d0",
      200: "#90edb3",
      300: "#65e495",
      400: "#3cdd78",
      500: "#22c35e",
      600: "#179848",
      700: "#0c6c33",
      800: "#01421c",
      900: "#001803"
    },
    twitter: {
      50: "#E5F4FD",
      100: "#C8E9FB",
      200: "#A8DCFA",
      300: "#83CDF7",
      400: "#57BBF5",
      500: "#1DA1F2",
      600: "#1A94DA",
      700: "#1681BF",
      800: "#136B9E",
      900: "#0D4D71"
    },
    telegram: {
      50: "#E3F2F9",
      100: "#C5E4F3",
      200: "#A2D4EC",
      300: "#7AC1E4",
      400: "#47A9DA",
      500: "#0088CC",
      600: "#007AB8",
      700: "#006BA1",
      800: "#005885",
      900: "#003F5E"
    }
  };
  var colors_default = colors$2;

  // src/foundations/radius.ts
  var radii$1 = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
  };
  var radius_default = radii$1;

  // src/foundations/shadows.ts
  var shadows$1 = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
  };
  var shadows_default = shadows$1;

  // src/foundations/blur.ts
  var blur$1 = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
  };
  var blur_default = blur$1;

  // src/foundations/typography.ts
  var typography$1 = {
    letterSpacings: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeights: {
      normal: "normal",
      none: 1,
      shorter: 1.25,
      short: 1.375,
      base: 1.5,
      tall: 1.625,
      taller: "2",
      "3": ".75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "7": "1.75rem",
      "8": "2rem",
      "9": "2.25rem",
      "10": "2.5rem"
    },
    fontWeights: {
      hairline: 100,
      thin: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900
    },
    fonts: {
      heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
      "3xs": "0.45rem",
      "2xs": "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
      "7xl": "4.5rem",
      "8xl": "6rem",
      "9xl": "8rem"
    }
  };
  var typography_default = typography$1;

  // src/foundations/spacing.ts
  var spacing$1 = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
  };

  // src/foundations/sizes.ts
  var largeSizes$1 = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
  };
  var container$1 = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
  };
  var sizes$o = {
    ...spacing$1,
    ...largeSizes$1,
    container: container$1
  };
  var sizes_default = sizes$o;

  // src/foundations/index.ts
  var foundations$1 = {
    breakpoints: breakpoints_default,
    zIndices: z_index_default,
    radii: radius_default,
    blur: blur_default,
    colors: colors_default,
    ...typography_default,
    sizes: sizes_default,
    shadows: shadows_default,
    space: spacing$1,
    borders: borders_default,
    transition: transition_default
  };

  // src/components/stepper.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$p, definePartsStyle: definePartsStyle$p } = createMultiStyleConfigHelpers([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
  ]);
  var $size$4 = cssVar$1("stepper-indicator-size");
  var $iconSize = cssVar$1("stepper-icon-size");
  var $titleFontSize = cssVar$1("stepper-title-font-size");
  var $descFontSize = cssVar$1("stepper-description-font-size");
  var $accentColor = cssVar$1("stepper-accent-color");
  var baseStyle$F = definePartsStyle$p(({ colorScheme: c }) => ({
    stepper: {
      display: "flex",
      justifyContent: "space-between",
      gap: "4",
      "&[data-orientation=vertical]": {
        flexDirection: "column",
        alignItems: "flex-start"
      },
      "&[data-orientation=horizontal]": {
        flexDirection: "row",
        alignItems: "center"
      },
      [$accentColor.variable]: `colors.${c}.500`,
      _dark: {
        [$accentColor.variable]: `colors.${c}.200`
      }
    },
    title: {
      fontSize: $titleFontSize.reference,
      fontWeight: "medium"
    },
    description: {
      fontSize: $descFontSize.reference,
      color: "chakra-subtle-text"
    },
    number: {
      fontSize: $titleFontSize.reference
    },
    step: {
      flexShrink: 0,
      position: "relative",
      display: "flex",
      gap: "2",
      "&[data-orientation=horizontal]": {
        alignItems: "center"
      },
      flex: "1",
      "&:last-of-type:not([data-stretch])": {
        flex: "initial"
      }
    },
    icon: {
      flexShrink: 0,
      width: $iconSize.reference,
      height: $iconSize.reference
    },
    indicator: {
      flexShrink: 0,
      borderRadius: "full",
      width: $size$4.reference,
      height: $size$4.reference,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&[data-status=active]": {
        borderWidth: "2px",
        borderColor: $accentColor.reference
      },
      "&[data-status=complete]": {
        bg: $accentColor.reference,
        color: "chakra-inverse-text"
      },
      "&[data-status=incomplete]": {
        borderWidth: "2px"
      }
    },
    separator: {
      bg: "chakra-border-color",
      flex: "1",
      "&[data-status=complete]": {
        bg: $accentColor.reference
      },
      "&[data-orientation=horizontal]": {
        width: "100%",
        height: "2px",
        marginStart: "2"
      },
      "&[data-orientation=vertical]": {
        width: "2px",
        position: "absolute",
        height: "100%",
        maxHeight: `calc(100% - ${$size$4.reference} - 8px)`,
        top: `calc(${$size$4.reference} + 4px)`,
        insetStart: `calc(${$size$4.reference} / 2 - 1px)`
      }
    }
  }));
  var stepperTheme = defineMultiStyleConfig$p({
    baseStyle: baseStyle$F,
    sizes: {
      xs: definePartsStyle$p({
        stepper: {
          [$size$4.variable]: "sizes.4",
          [$iconSize.variable]: "sizes.3",
          [$titleFontSize.variable]: "fontSizes.xs",
          [$descFontSize.variable]: "fontSizes.xs"
        }
      }),
      sm: definePartsStyle$p({
        stepper: {
          [$size$4.variable]: "sizes.6",
          [$iconSize.variable]: "sizes.4",
          [$titleFontSize.variable]: "fontSizes.sm",
          [$descFontSize.variable]: "fontSizes.xs"
        }
      }),
      md: definePartsStyle$p({
        stepper: {
          [$size$4.variable]: "sizes.8",
          [$iconSize.variable]: "sizes.5",
          [$titleFontSize.variable]: "fontSizes.md",
          [$descFontSize.variable]: "fontSizes.sm"
        }
      }),
      lg: definePartsStyle$p({
        stepper: {
          [$size$4.variable]: "sizes.10",
          [$iconSize.variable]: "sizes.6",
          [$titleFontSize.variable]: "fontSizes.lg",
          [$descFontSize.variable]: "fontSizes.md"
        }
      })
    },
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  // src/anatomy.ts
  function anatomy(name, map = {}) {
    let called = false;
    function assert() {
      if (!called) {
        called = true;
        return;
      }
      throw new Error(
        "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
      );
    }
    function parts(...values) {
      assert();
      for (const part of values) {
        map[part] = toPart(part);
      }
      return anatomy(name, map);
    }
    function extend(...parts2) {
      for (const part of parts2) {
        if (part in map)
          continue;
        map[part] = toPart(part);
      }
      return anatomy(name, map);
    }
    function selectors() {
      const value = Object.fromEntries(
        Object.entries(map).map(([key, part]) => [key, part.selector])
      );
      return value;
    }
    function classnames() {
      const value = Object.fromEntries(
        Object.entries(map).map(([key, part]) => [key, part.className])
      );
      return value;
    }
    function toPart(part) {
      const el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
      const attr = el.filter(Boolean).join("__");
      const className = `chakra-${attr}`;
      const partObj = {
        className,
        selector: `.${className}`,
        toString: () => part
      };
      return partObj;
    }
    const __type = {};
    return {
      parts,
      toPart,
      extend,
      selectors,
      classnames,
      get keys() {
        return Object.keys(map);
      },
      __type
    };
  }

  // src/components.ts
  var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
  var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
  var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
  var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
  anatomy("button").parts();
  var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
  anatomy("progress").parts("track", "filledTrack").extend("label");
  var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
  var editableAnatomy = anatomy("editable").parts(
    "preview",
    "input",
    "textarea"
  );
  var formAnatomy = anatomy("form").parts(
    "container",
    "requiredIndicator",
    "helperText"
  );
  var formErrorAnatomy = anatomy("formError").parts("text", "icon");
  var inputAnatomy = anatomy("input").parts(
    "addon",
    "field",
    "element",
    "group"
  );
  var listAnatomy = anatomy("list").parts("container", "item", "icon");
  var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
  var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
  var numberInputAnatomy = anatomy("numberinput").parts(
    "root",
    "field",
    "stepperGroup",
    "stepper"
  );
  anatomy("pininput").parts("field");
  var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
  var progressAnatomy = anatomy("progress").parts(
    "label",
    "filledTrack",
    "track"
  );
  var radioAnatomy = anatomy("radio").parts(
    "container",
    "control",
    "label"
  );
  var selectAnatomy = anatomy("select").parts("field", "icon");
  var sliderAnatomy = anatomy("slider").parts(
    "container",
    "track",
    "thumb",
    "filledTrack",
    "mark"
  );
  var statAnatomy = anatomy("stat").parts(
    "container",
    "label",
    "helpText",
    "number",
    "icon"
  );
  var switchAnatomy = anatomy("switch").parts(
    "container",
    "track",
    "thumb",
    "label"
  );
  var tableAnatomy = anatomy("table").parts(
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    "tfoot",
    "caption"
  );
  var tabsAnatomy = anatomy("tabs").parts(
    "root",
    "tab",
    "tablist",
    "tabpanel",
    "tabpanels",
    "indicator"
  );
  var tagAnatomy = anatomy("tag").parts(
    "container",
    "label",
    "closeButton"
  );
  var cardAnatomy = anatomy("card").parts(
    "container",
    "header",
    "body",
    "footer"
  );
  anatomy("stepper").parts(
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
  );

  /**
   * A simple guard function:
   *
   * ```js
   * Math.min(Math.max(low, value), high)
   * ```
   */
  function guard(low, high, value) {
    return Math.min(Math.max(low, value), high);
  }

  class ColorError extends Error {
    constructor(color) {
      super(`Failed to parse color: "${color}"`);
    }
  }
  var ColorError$1 = ColorError;

  /**
   * Parses a color into red, gree, blue, alpha parts
   *
   * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
   */
  function parseToRgba(color) {
    if (typeof color !== 'string') throw new ColorError$1(color);
    if (color.trim().toLowerCase() === 'transparent') return [0, 0, 0, 0];
    let normalizedColor = color.trim();
    normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
    const reducedHexMatch = reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
      const arr = Array.from(reducedHexMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(r$2(x, 2), 16)), parseInt(r$2(arr[3] || 'f', 2), 16) / 255];
    }
    const hexMatch = hexRegex.exec(normalizedColor);
    if (hexMatch) {
      const arr = Array.from(hexMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(x, 16)), parseInt(arr[3] || 'ff', 16) / 255];
    }
    const rgbaMatch = rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
      const arr = Array.from(rgbaMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(x, 10)), parseFloat(arr[3] || '1')];
    }
    const hslaMatch = hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
      const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
      if (guard(0, 100, s) !== s) throw new ColorError$1(color);
      if (guard(0, 100, l) !== l) throw new ColorError$1(color);
      return [...hslToRgb(h, s, l), Number.isNaN(a) ? 1 : a];
    }
    throw new ColorError$1(color);
  }
  function hash(str) {
    let hash = 5381;
    let i = str.length;
    while (i) {
      hash = hash * 33 ^ str.charCodeAt(--i);
    }

    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
     * integers. Since we want the results to be always positive, convert the
     * signed int to an unsigned by doing an unsigned bitshift. */
    return (hash >>> 0) % 2341;
  }
  const colorToInt = x => parseInt(x.replace(/_/g, ''), 36);
  const compressedColorMap = '1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm'.split(' ').reduce((acc, next) => {
    const key = colorToInt(next.substring(0, 3));
    const hex = colorToInt(next.substring(3)).toString(16);

    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = '';
    for (let i = 0; i < 6 - hex.length; i++) {
      prefix += '0';
    }
    acc[key] = `${prefix}${hex}`;
    return acc;
  }, {});

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   */
  function nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = compressedColorMap[hash(normalizedColorName)];
    if (!result) throw new ColorError$1(color);
    return `#${result}`;
  }
  const r$2 = (str, amount) => Array.from(Array(amount)).map(() => str).join('');
  const reducedHexRegex = new RegExp(`^#${r$2('([a-f0-9])', 3)}([a-f0-9])?$`, 'i');
  const hexRegex = new RegExp(`^#${r$2('([a-f0-9]{2})', 3)}([a-f0-9]{2})?$`, 'i');
  const rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$2(',\\s*(\\d+)\\s*', 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, 'i');
  const hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
  const namedColorRegex = /^[a-z]+$/i;
  const roundColor = color => {
    return Math.round(color * 255);
  };
  const hslToRgb = (hue, saturation, lightness) => {
    let l = lightness / 100;
    if (saturation === 0) {
      // achromatic
      return [l, l, l].map(roundColor);
    }

    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
      red = chroma;
      green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      red = secondComponent;
      green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      green = chroma;
      blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      green = secondComponent;
      blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      red = secondComponent;
      blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      red = chroma;
      blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [finalRed, finalGreen, finalBlue].map(roundColor);
  };

  /**
   * Takes in rgba parts and returns an rgba string
   *
   * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
   * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
   * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
   * @param alpha Percentage of opacity, given as a decimal between 0 and 1
   */
  function rgba$1(red, green, blue, alpha) {
    return `rgba(${guard(0, 255, red).toFixed()}, ${guard(0, 255, green).toFixed()}, ${guard(0, 255, blue).toFixed()}, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
  }

  /**
   * Takes in a color and makes it more transparent by convert to `rgba` and
   * decreasing the amount in the alpha channel.
   *
   * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
   */
  function transparentize$1(color, amount) {
    const [r, g, b, a] = parseToRgba(color);
    return rgba$1(r, g, b, a - amount);
  }

  /**
   * Takes in any color and returns it as a hex code.
   */
  function toHex(color) {
    const [r, g, b, a] = parseToRgba(color);
    let hex = x => {
      const h = guard(0, 255, x).toString(16);
      // NOTE: padStart could be used here but it breaks Node 6 compat
      // https://github.com/ricokahler/color2k/issues/351
      return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ''}`;
  }

  // src/color.ts

  // ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
  function dlv_es_default(t, e, l, n, r) {
    for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)
      t = t ? t[e[n]] : r;
    return t === r ? l : t;
  }

  // src/color.ts
  var isEmptyObject = (obj) => Object.keys(obj).length === 0;
  var getColor = (theme, color, fallback) => {
    const hex = dlv_es_default(theme, `colors.${color}`, color);
    try {
      toHex(hex);
      return hex;
    } catch {
      return fallback != null ? fallback : "#000000";
    }
  };
  var getBrightness = (color) => {
    const [r, g, b] = parseToRgba(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
  };
  var tone = (color) => (theme) => {
    const hex = getColor(theme, color);
    const brightness = getBrightness(hex);
    const isDark2 = brightness < 128;
    return isDark2 ? "dark" : "light";
  };
  var isDark = (color) => (theme) => tone(color)(theme) === "dark";
  var transparentize = (color, opacity) => (theme) => {
    const raw = getColor(theme, color);
    return transparentize$1(raw, 1 - opacity);
  };
  function generateStripe(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
      backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
      backgroundSize: `${size} ${size}`
    };
  }
  var randomHex = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
  function randomColor(opts) {
    const fallback = randomHex();
    if (!opts || isEmptyObject(opts)) {
      return fallback;
    }
    if (opts.string && opts.colors) {
      return randomColorFromList(opts.string, opts.colors);
    }
    if (opts.string && !opts.colors) {
      return randomColorFromString(opts.string);
    }
    if (opts.colors && !opts.string) {
      return randomFromList(opts.colors);
    }
    return fallback;
  }
  function randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0)
      return hash.toString();
    for (let i = 0; i < str.length; i += 1) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }
    let color = "#";
    for (let j = 0; j < 3; j += 1) {
      const value = hash >> j * 8 & 255;
      color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
  }
  function randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0)
      return list[0];
    for (let i = 0; i < str.length; i += 1) {
      index = str.charCodeAt(i) + ((index << 5) - index);
      index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
  }
  function randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  // src/component.ts
  function mode(light, dark) {
    return (props) => props.colorMode === "dark" ? dark : light;
  }
  function orient(options) {
    const { orientation, vertical, horizontal } = options;
    if (!orientation)
      return {};
    return orientation === "vertical" ? vertical : horizontal;
  }

  // src/css-calc.ts
  function toRef(operand) {
    if (isObject$1(operand) && operand.reference) {
      return operand.reference;
    }
    return String(operand);
  }
  var toExpr = (operator, ...operands) => operands.map(toRef).join(` ${operator} `).replace(/calc/g, "");
  var add = (...operands) => `calc(${toExpr("+", ...operands)})`;
  var subtract = (...operands) => `calc(${toExpr("-", ...operands)})`;
  var multiply = (...operands) => `calc(${toExpr("*", ...operands)})`;
  var divide = (...operands) => `calc(${toExpr("/", ...operands)})`;
  var negate = (x) => {
    const value = toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) {
      return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    }
    return multiply(value, -1);
  };
  var calc = Object.assign(
    (x) => ({
      add: (...operands) => calc(add(x, ...operands)),
      subtract: (...operands) => calc(subtract(x, ...operands)),
      multiply: (...operands) => calc(multiply(x, ...operands)),
      divide: (...operands) => calc(divide(x, ...operands)),
      negate: () => calc(negate(x)),
      toString: () => x.toString()
    }),
    {
      add,
      subtract,
      multiply,
      divide,
      negate
    }
  );

  // src/css-var.ts
  function isDecimal(value) {
    return !Number.isInteger(parseFloat(value.toString()));
  }
  function replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
  }
  function escape(value) {
    const valueStr = replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\."))
      return value;
    return isDecimal(value) ? valueStr.replace(".", `\\.`) : value;
  }
  function addPrefix(value, prefix = "") {
    return [prefix, escape(value)].filter(Boolean).join("-");
  }
  function toVarRef(name, fallback) {
    return `var(${escape(name)}${fallback ? `, ${fallback}` : ""})`;
  }
  function toVar(value, prefix = "") {
    return `--${addPrefix(value, prefix)}`;
  }
  function cssVar(name, options) {
    const cssVariable = toVar(name, options == null ? void 0 : options.prefix);
    return {
      variable: cssVariable,
      reference: toVarRef(cssVariable, getFallback(options == null ? void 0 : options.fallback))
    };
  }
  function getFallback(fallback) {
    if (typeof fallback === "string")
      return fallback;
    return fallback == null ? void 0 : fallback.reference;
  }

  // src/components/switch.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$o, definePartsStyle: definePartsStyle$o } = createMultiStyleConfigHelpers(switchAnatomy.keys);
  var $width = cssVar("switch-track-width");
  var $height$1 = cssVar("switch-track-height");
  var $diff = cssVar("switch-track-diff");
  var diffValue = calc.subtract($width, $height$1);
  var $translateX = cssVar("switch-thumb-x");
  var $bg$f = cssVar("switch-bg");
  var baseStyleTrack$2 = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      borderRadius: "full",
      p: "0.5",
      width: [$width.reference],
      height: [$height$1.reference],
      transitionProperty: "common",
      transitionDuration: "fast",
      [$bg$f.variable]: "colors.gray.300",
      _dark: {
        [$bg$f.variable]: "colors.whiteAlpha.400"
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _checked: {
        [$bg$f.variable]: `colors.${c}.500`,
        _dark: {
          [$bg$f.variable]: `colors.${c}.200`
        }
      },
      bg: $bg$f.reference
    };
  });
  var baseStyleThumb$1 = defineStyle({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [$height$1.reference],
    height: [$height$1.reference],
    _checked: {
      transform: `translateX(${$translateX.reference})`
    }
  });
  var baseStyle$E = definePartsStyle$o((props) => ({
    container: {
      [$diff.variable]: diffValue,
      [$translateX.variable]: $diff.reference,
      _rtl: {
        [$translateX.variable]: calc($diff).negate().toString()
      }
    },
    track: baseStyleTrack$2(props),
    thumb: baseStyleThumb$1
  }));
  var sizes$n = {
    sm: definePartsStyle$o({
      container: {
        [$width.variable]: "1.375rem",
        [$height$1.variable]: "sizes.3"
      }
    }),
    md: definePartsStyle$o({
      container: {
        [$width.variable]: "1.875rem",
        [$height$1.variable]: "sizes.4"
      }
    }),
    lg: definePartsStyle$o({
      container: {
        [$width.variable]: "2.875rem",
        [$height$1.variable]: "sizes.6"
      }
    })
  };
  var switchTheme = defineMultiStyleConfig$o({
    baseStyle: baseStyle$E,
    sizes: sizes$n,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  // src/components/table.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$n, definePartsStyle: definePartsStyle$n } = createMultiStyleConfigHelpers(tableAnatomy.keys);
  var baseStyle$D = definePartsStyle$n({
    table: {
      fontVariantNumeric: "lining-nums tabular-nums",
      borderCollapse: "collapse",
      width: "full"
    },
    th: {
      fontFamily: "heading",
      fontWeight: "bold",
      textTransform: "uppercase",
      letterSpacing: "wider",
      textAlign: "start"
    },
    td: {
      textAlign: "start"
    },
    caption: {
      mt: 4,
      fontFamily: "heading",
      textAlign: "center",
      fontWeight: "medium"
    }
  });
  var numericStyles = defineStyle({
    "&[data-is-numeric=true]": {
      textAlign: "end"
    }
  });
  var variantSimple = definePartsStyle$n((props) => {
    const { colorScheme: c } = props;
    return {
      th: {
        color: mode("gray.600", "gray.400")(props),
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      td: {
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      caption: {
        color: mode("gray.600", "gray.100")(props)
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    };
  });
  var variantStripe = definePartsStyle$n((props) => {
    const { colorScheme: c } = props;
    return {
      th: {
        color: mode("gray.600", "gray.400")(props),
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      td: {
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      caption: {
        color: mode("gray.600", "gray.100")(props)
      },
      tbody: {
        tr: {
          "&:nth-of-type(odd)": {
            "th, td": {
              borderBottomWidth: "1px",
              borderColor: mode(`${c}.100`, `${c}.700`)(props)
            },
            td: {
              background: mode(`${c}.100`, `${c}.700`)(props)
            }
          }
        }
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    };
  });
  var variants$b = {
    simple: variantSimple,
    striped: variantStripe,
    unstyled: defineStyle({})
  };
  var sizes$m = {
    sm: definePartsStyle$n({
      th: {
        px: "4",
        py: "1",
        lineHeight: "4",
        fontSize: "xs"
      },
      td: {
        px: "4",
        py: "2",
        fontSize: "sm",
        lineHeight: "4"
      },
      caption: {
        px: "4",
        py: "2",
        fontSize: "xs"
      }
    }),
    md: definePartsStyle$n({
      th: {
        px: "6",
        py: "3",
        lineHeight: "4",
        fontSize: "xs"
      },
      td: {
        px: "6",
        py: "4",
        lineHeight: "5"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "sm"
      }
    }),
    lg: definePartsStyle$n({
      th: {
        px: "8",
        py: "4",
        lineHeight: "5",
        fontSize: "sm"
      },
      td: {
        px: "8",
        py: "5",
        lineHeight: "6"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "md"
      }
    })
  };
  var tableTheme = defineMultiStyleConfig$n({
    baseStyle: baseStyle$D,
    variants: variants$b,
    sizes: sizes$m,
    defaultProps: {
      variant: "simple",
      size: "md",
      colorScheme: "gray"
    }
  });

  // src/components/tabs.ts
  var $fg$5 = cssVar$1("tabs-color");
  var $bg$e = cssVar$1("tabs-bg");
  var $border$3 = cssVar$1("tabs-border-color");
  var { defineMultiStyleConfig: defineMultiStyleConfig$m, definePartsStyle: definePartsStyle$m } = createMultiStyleConfigHelpers(tabsAnatomy.keys);
  var baseStyleRoot$1 = defineStyle((props) => {
    const { orientation } = props;
    return {
      display: orientation === "vertical" ? "flex" : "block"
    };
  });
  var baseStyleTab = defineStyle((props) => {
    const { isFitted } = props;
    return {
      flex: isFitted ? 1 : void 0,
      transitionProperty: "common",
      transitionDuration: "normal",
      _focusVisible: {
        zIndex: 1,
        boxShadow: "outline"
      },
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.4
      }
    };
  });
  var baseStyleTablist = defineStyle((props) => {
    const { align = "start", orientation } = props;
    const alignments = {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    };
    return {
      justifyContent: alignments[align],
      flexDirection: orientation === "vertical" ? "column" : "row"
    };
  });
  var baseStyleTabpanel = defineStyle({
    p: 4
  });
  var baseStyle$C = definePartsStyle$m((props) => ({
    root: baseStyleRoot$1(props),
    tab: baseStyleTab(props),
    tablist: baseStyleTablist(props),
    tabpanel: baseStyleTabpanel
  }));
  var sizes$l = {
    sm: definePartsStyle$m({
      tab: {
        py: 1,
        px: 4,
        fontSize: "sm"
      }
    }),
    md: definePartsStyle$m({
      tab: {
        fontSize: "md",
        py: 2,
        px: 4
      }
    }),
    lg: definePartsStyle$m({
      tab: {
        fontSize: "lg",
        py: 3,
        px: 4
      }
    })
  };
  var variantLine = definePartsStyle$m((props) => {
    const { colorScheme: c, orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
      tablist: {
        [borderProp]: "2px solid",
        borderColor: "inherit"
      },
      tab: {
        [borderProp]: "2px solid",
        borderColor: "transparent",
        [marginProp]: "-2px",
        _selected: {
          [$fg$5.variable]: `colors.${c}.600`,
          _dark: {
            [$fg$5.variable]: `colors.${c}.300`
          },
          borderColor: "currentColor"
        },
        _active: {
          [$bg$e.variable]: "colors.gray.200",
          _dark: {
            [$bg$e.variable]: "colors.whiteAlpha.300"
          }
        },
        _disabled: {
          _active: { bg: "none" }
        },
        color: $fg$5.reference,
        bg: $bg$e.reference
      }
    };
  });
  var variantEnclosed = definePartsStyle$m((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        borderTopRadius: "md",
        border: "1px solid",
        borderColor: "transparent",
        mb: "-1px",
        [$border$3.variable]: "transparent",
        _selected: {
          [$fg$5.variable]: `colors.${c}.600`,
          [$border$3.variable]: `colors.white`,
          _dark: {
            [$fg$5.variable]: `colors.${c}.300`,
            [$border$3.variable]: `colors.gray.800`
          },
          borderColor: "inherit",
          borderBottomColor: $border$3.reference
        },
        color: $fg$5.reference
      },
      tablist: {
        mb: "-1px",
        borderBottom: "1px solid",
        borderColor: "inherit"
      }
    };
  });
  var variantEnclosedColored = definePartsStyle$m((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        border: "1px solid",
        borderColor: "inherit",
        [$bg$e.variable]: "colors.gray.50",
        _dark: {
          [$bg$e.variable]: "colors.whiteAlpha.50"
        },
        mb: "-1px",
        _notLast: {
          marginEnd: "-1px"
        },
        _selected: {
          [$bg$e.variable]: "colors.white",
          [$fg$5.variable]: `colors.${c}.600`,
          _dark: {
            [$bg$e.variable]: "colors.gray.800",
            [$fg$5.variable]: `colors.${c}.300`
          },
          borderColor: "inherit",
          borderTopColor: "currentColor",
          borderBottomColor: "transparent"
        },
        color: $fg$5.reference,
        bg: $bg$e.reference
      },
      tablist: {
        mb: "-1px",
        borderBottom: "1px solid",
        borderColor: "inherit"
      }
    };
  });
  var variantSoftRounded = definePartsStyle$m((props) => {
    const { colorScheme: c, theme } = props;
    return {
      tab: {
        borderRadius: "full",
        fontWeight: "semibold",
        color: "gray.600",
        _selected: {
          color: getColor(theme, `${c}.700`),
          bg: getColor(theme, `${c}.100`)
        }
      }
    };
  });
  var variantSolidRounded = definePartsStyle$m((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        borderRadius: "full",
        fontWeight: "semibold",
        [$fg$5.variable]: "colors.gray.600",
        _dark: {
          [$fg$5.variable]: "inherit"
        },
        _selected: {
          [$fg$5.variable]: "colors.white",
          [$bg$e.variable]: `colors.${c}.600`,
          _dark: {
            [$fg$5.variable]: "colors.gray.800",
            [$bg$e.variable]: `colors.${c}.300`
          }
        },
        color: $fg$5.reference,
        bg: $bg$e.reference
      }
    };
  });
  var variantUnstyled$2 = definePartsStyle$m({});
  var variants$a = {
    line: variantLine,
    enclosed: variantEnclosed,
    "enclosed-colored": variantEnclosedColored,
    "soft-rounded": variantSoftRounded,
    "solid-rounded": variantSolidRounded,
    unstyled: variantUnstyled$2
  };
  var tabsTheme = defineMultiStyleConfig$m({
    baseStyle: baseStyle$C,
    sizes: sizes$l,
    variants: variants$a,
    defaultProps: {
      size: "md",
      variant: "line",
      colorScheme: "blue"
    }
  });

  // src/components/badge.ts
  var vars = defineCssVars("badge", ["bg", "color", "shadow"]);
  var baseStyle$B = defineStyle({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: vars.bg.reference,
    color: vars.color.reference,
    boxShadow: vars.shadow.reference
  });
  var variantSolid$3 = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const dark = transparentize(`${c}.500`, 0.6)(theme);
    return {
      [vars.bg.variable]: `colors.${c}.500`,
      [vars.color.variable]: `colors.white`,
      _dark: {
        [vars.bg.variable]: dark,
        [vars.color.variable]: `colors.whiteAlpha.800`
      }
    };
  });
  var variantSubtle$1 = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const darkBg = transparentize(`${c}.200`, 0.16)(theme);
    return {
      [vars.bg.variable]: `colors.${c}.100`,
      [vars.color.variable]: `colors.${c}.800`,
      _dark: {
        [vars.bg.variable]: darkBg,
        [vars.color.variable]: `colors.${c}.200`
      }
    };
  });
  var variantOutline$2 = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const darkColor = transparentize(`${c}.200`, 0.8)(theme);
    return {
      [vars.color.variable]: `colors.${c}.500`,
      _dark: {
        [vars.color.variable]: darkColor
      },
      [vars.shadow.variable]: `inset 0 0 0px 1px ${vars.color.reference}`
    };
  });
  var variants$9 = {
    solid: variantSolid$3,
    subtle: variantSubtle$1,
    outline: variantOutline$2
  };
  var badgeTheme = defineStyleConfig({
    baseStyle: baseStyle$B,
    variants: variants$9,
    defaultProps: {
      variant: "subtle",
      colorScheme: "gray"
    }
  });

  var { defineMultiStyleConfig: defineMultiStyleConfig$l, definePartsStyle: definePartsStyle$l } = createMultiStyleConfigHelpers(tagAnatomy.keys);
  var $bg$d = cssVar$1("tag-bg");
  var $color = cssVar$1("tag-color");
  var $shadow$3 = cssVar$1("tag-shadow");
  var $minH = cssVar$1("tag-min-height");
  var $minW = cssVar$1("tag-min-width");
  var $fontSize$1 = cssVar$1("tag-font-size");
  var $paddingX = cssVar$1("tag-padding-inline");
  var baseStyleContainer$4 = defineStyle({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$color.variable]: vars.color.reference,
    [$bg$d.variable]: vars.bg.reference,
    [$shadow$3.variable]: vars.shadow.reference,
    color: $color.reference,
    bg: $bg$d.reference,
    boxShadow: $shadow$3.reference,
    borderRadius: "md",
    minH: $minH.reference,
    minW: $minW.reference,
    fontSize: $fontSize$1.reference,
    px: $paddingX.reference,
    _focusVisible: {
      [$shadow$3.variable]: "shadows.outline"
    }
  });
  var baseStyleLabel$4 = defineStyle({
    lineHeight: 1.2,
    overflow: "visible"
  });
  var baseStyleCloseButton$3 = defineStyle({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
      opacity: 0.4
    },
    _focusVisible: {
      boxShadow: "outline",
      bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
      opacity: 0.8
    },
    _active: {
      opacity: 1
    }
  });
  var baseStyle$A = definePartsStyle$l({
    container: baseStyleContainer$4,
    label: baseStyleLabel$4,
    closeButton: baseStyleCloseButton$3
  });
  var sizes$k = {
    sm: definePartsStyle$l({
      container: {
        [$minH.variable]: "sizes.5",
        [$minW.variable]: "sizes.5",
        [$fontSize$1.variable]: "fontSizes.xs",
        [$paddingX.variable]: "space.2"
      },
      closeButton: {
        marginEnd: "-2px",
        marginStart: "0.35rem"
      }
    }),
    md: definePartsStyle$l({
      container: {
        [$minH.variable]: "sizes.6",
        [$minW.variable]: "sizes.6",
        [$fontSize$1.variable]: "fontSizes.sm",
        [$paddingX.variable]: "space.2"
      }
    }),
    lg: definePartsStyle$l({
      container: {
        [$minH.variable]: "sizes.8",
        [$minW.variable]: "sizes.8",
        [$fontSize$1.variable]: "fontSizes.md",
        [$paddingX.variable]: "space.3"
      }
    })
  };
  var variants$8 = {
    subtle: definePartsStyle$l((props) => {
      var _a;
      return {
        container: (_a = badgeTheme.variants) == null ? void 0 : _a.subtle(props)
      };
    }),
    solid: definePartsStyle$l((props) => {
      var _a;
      return {
        container: (_a = badgeTheme.variants) == null ? void 0 : _a.solid(props)
      };
    }),
    outline: definePartsStyle$l((props) => {
      var _a;
      return {
        container: (_a = badgeTheme.variants) == null ? void 0 : _a.outline(props)
      };
    })
  };
  var tagTheme = defineMultiStyleConfig$l({
    variants: variants$8,
    baseStyle: baseStyle$A,
    sizes: sizes$k,
    defaultProps: {
      size: "md",
      variant: "subtle",
      colorScheme: "gray"
    }
  });

  // src/components/input.ts
  var { definePartsStyle: definePartsStyle$k, defineMultiStyleConfig: defineMultiStyleConfig$k } = createMultiStyleConfigHelpers(inputAnatomy.keys);
  var $height = cssVar$1("input-height");
  var $fontSize = cssVar$1("input-font-size");
  var $padding$1 = cssVar$1("input-padding");
  var $borderRadius = cssVar$1("input-border-radius");
  var baseStyle$z = definePartsStyle$k({
    addon: {
      height: $height.reference,
      fontSize: $fontSize.reference,
      px: $padding$1.reference,
      borderRadius: $borderRadius.reference
    },
    field: {
      width: "100%",
      height: $height.reference,
      fontSize: $fontSize.reference,
      px: $padding$1.reference,
      borderRadius: $borderRadius.reference,
      minWidth: 0,
      outline: 0,
      position: "relative",
      appearance: "none",
      transitionProperty: "common",
      transitionDuration: "normal",
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      }
    }
  });
  var size = {
    lg: defineStyle({
      [$fontSize.variable]: "fontSizes.lg",
      [$padding$1.variable]: "space.4",
      [$borderRadius.variable]: "radii.md",
      [$height.variable]: "sizes.12"
    }),
    md: defineStyle({
      [$fontSize.variable]: "fontSizes.md",
      [$padding$1.variable]: "space.4",
      [$borderRadius.variable]: "radii.md",
      [$height.variable]: "sizes.10"
    }),
    sm: defineStyle({
      [$fontSize.variable]: "fontSizes.sm",
      [$padding$1.variable]: "space.3",
      [$borderRadius.variable]: "radii.sm",
      [$height.variable]: "sizes.8"
    }),
    xs: defineStyle({
      [$fontSize.variable]: "fontSizes.xs",
      [$padding$1.variable]: "space.2",
      [$borderRadius.variable]: "radii.sm",
      [$height.variable]: "sizes.6"
    })
  };
  var sizes$j = {
    lg: definePartsStyle$k({
      field: size.lg,
      group: size.lg
    }),
    md: definePartsStyle$k({
      field: size.md,
      group: size.md
    }),
    sm: definePartsStyle$k({
      field: size.sm,
      group: size.sm
    }),
    xs: definePartsStyle$k({
      field: size.xs,
      group: size.xs
    })
  };
  function getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
      focusBorderColor: fc || mode("blue.500", "blue.300")(props),
      errorBorderColor: ec || mode("red.500", "red.300")(props)
    };
  }
  var variantOutline$1 = definePartsStyle$k((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        border: "1px solid",
        borderColor: "inherit",
        bg: "inherit",
        _hover: {
          borderColor: mode("gray.300", "whiteAlpha.400")(props)
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec),
          boxShadow: `0 0 0 1px ${getColor(theme, ec)}`
        },
        _focusVisible: {
          zIndex: 1,
          borderColor: getColor(theme, fc),
          boxShadow: `0 0 0 1px ${getColor(theme, fc)}`
        }
      },
      addon: {
        border: "1px solid",
        borderColor: mode("inherit", "whiteAlpha.50")(props),
        bg: mode("gray.100", "whiteAlpha.300")(props)
      }
    };
  });
  var variantFilled = definePartsStyle$k((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        border: "2px solid",
        borderColor: "transparent",
        bg: mode("gray.100", "whiteAlpha.50")(props),
        _hover: {
          bg: mode("gray.200", "whiteAlpha.100")(props)
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec)
        },
        _focusVisible: {
          bg: "transparent",
          borderColor: getColor(theme, fc)
        }
      },
      addon: {
        border: "2px solid",
        borderColor: "transparent",
        bg: mode("gray.100", "whiteAlpha.50")(props)
      }
    };
  });
  var variantFlushed = definePartsStyle$k((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        borderBottom: "1px solid",
        borderColor: "inherit",
        borderRadius: "0",
        px: "0",
        bg: "transparent",
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec),
          boxShadow: `0px 1px 0px 0px ${getColor(theme, ec)}`
        },
        _focusVisible: {
          borderColor: getColor(theme, fc),
          boxShadow: `0px 1px 0px 0px ${getColor(theme, fc)}`
        }
      },
      addon: {
        borderBottom: "2px solid",
        borderColor: "inherit",
        borderRadius: "0",
        px: "0",
        bg: "transparent"
      }
    };
  });
  var variantUnstyled$1 = definePartsStyle$k({
    field: {
      bg: "transparent",
      px: "0",
      height: "auto"
    },
    addon: {
      bg: "transparent",
      px: "0",
      height: "auto"
    }
  });
  var variants$7 = {
    outline: variantOutline$1,
    filled: variantFilled,
    flushed: variantFlushed,
    unstyled: variantUnstyled$1
  };
  var inputTheme = defineMultiStyleConfig$k({
    baseStyle: baseStyle$z,
    sizes: sizes$j,
    variants: variants$7,
    defaultProps: {
      size: "md",
      variant: "outline"
    }
  });

  var _a$3;
  var baseStyle$y = defineStyle({
    ...(_a$3 = inputTheme.baseStyle) == null ? void 0 : _a$3.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
  });
  var _a2$2, _b$2;
  var variants$6 = {
    outline: defineStyle(
      (props) => {
        var _a4, _b3;
        return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.outline(props).field) != null ? _b3 : {};
      }
    ),
    flushed: defineStyle(
      (props) => {
        var _a4, _b3;
        return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.flushed(props).field) != null ? _b3 : {};
      }
    ),
    filled: defineStyle(
      (props) => {
        var _a4, _b3;
        return (_b3 = (_a4 = inputTheme.variants) == null ? void 0 : _a4.filled(props).field) != null ? _b3 : {};
      }
    ),
    unstyled: (_b$2 = (_a2$2 = inputTheme.variants) == null ? void 0 : _a2$2.unstyled.field) != null ? _b$2 : {}
  };
  var _a3, _b2, _c$1, _d$1, _e$1, _f$1, _g$1, _h$1;
  var sizes$i = {
    xs: (_b2 = (_a3 = inputTheme.sizes) == null ? void 0 : _a3.xs.field) != null ? _b2 : {},
    sm: (_d$1 = (_c$1 = inputTheme.sizes) == null ? void 0 : _c$1.sm.field) != null ? _d$1 : {},
    md: (_f$1 = (_e$1 = inputTheme.sizes) == null ? void 0 : _e$1.md.field) != null ? _f$1 : {},
    lg: (_h$1 = (_g$1 = inputTheme.sizes) == null ? void 0 : _g$1.lg.field) != null ? _h$1 : {}
  };
  var textareaTheme = defineStyleConfig({
    baseStyle: baseStyle$y,
    sizes: sizes$i,
    variants: variants$6,
    defaultProps: {
      size: "md",
      variant: "outline"
    }
  });

  // src/components/tooltip.ts
  var $bg$c = cssVar("tooltip-bg");
  var $fg$4 = cssVar("tooltip-fg");
  var $arrowBg$1 = cssVar("popper-arrow-bg");
  var baseStyle$x = defineStyle({
    bg: $bg$c.reference,
    color: $fg$4.reference,
    [$bg$c.variable]: "colors.gray.700",
    [$fg$4.variable]: "colors.whiteAlpha.900",
    _dark: {
      [$bg$c.variable]: "colors.gray.300",
      [$fg$4.variable]: "colors.gray.900"
    },
    [$arrowBg$1.variable]: $bg$c.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
  });
  var tooltipTheme = defineStyleConfig({
    baseStyle: baseStyle$x
  });

  // src/components/progress.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$j, definePartsStyle: definePartsStyle$j } = createMultiStyleConfigHelpers(progressAnatomy.keys);
  var filledStyle = defineStyle((props) => {
    const { colorScheme: c, theme: t, isIndeterminate, hasStripe } = props;
    const stripeStyle = mode(
      generateStripe(),
      generateStripe("1rem", "rgba(0,0,0,0.1)")
    )(props);
    const bgColor = mode(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${getColor(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
      ...addStripe && stripeStyle,
      ...isIndeterminate ? { bgImage: gradient } : { bgColor }
    };
  });
  var baseStyleLabel$3 = defineStyle({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
  });
  var baseStyleTrack$1 = defineStyle((props) => {
    return {
      bg: mode("gray.100", "whiteAlpha.300")(props)
    };
  });
  var baseStyleFilledTrack$1 = defineStyle((props) => {
    return {
      transitionProperty: "common",
      transitionDuration: "slow",
      ...filledStyle(props)
    };
  });
  var baseStyle$w = definePartsStyle$j((props) => ({
    label: baseStyleLabel$3,
    filledTrack: baseStyleFilledTrack$1(props),
    track: baseStyleTrack$1(props)
  }));
  var sizes$h = {
    xs: definePartsStyle$j({
      track: { h: "1" }
    }),
    sm: definePartsStyle$j({
      track: { h: "2" }
    }),
    md: definePartsStyle$j({
      track: { h: "3" }
    }),
    lg: definePartsStyle$j({
      track: { h: "4" }
    })
  };
  var progressTheme = defineMultiStyleConfig$j({
    sizes: sizes$h,
    baseStyle: baseStyle$w,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  // src/utils/run-if-fn.ts
  var isFunction$2 = (value) => typeof value === "function";
  function runIfFn$1(valueOrFn, ...args) {
    return isFunction$2(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }

  var { definePartsStyle: definePartsStyle$i, defineMultiStyleConfig: defineMultiStyleConfig$i } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);
  var $size$3 = cssVar$1("checkbox-size");
  var baseStyleControl$1 = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      w: $size$3.reference,
      h: $size$3.reference,
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderRadius: "sm",
      borderColor: "inherit",
      color: "white",
      _checked: {
        bg: mode(`${c}.500`, `${c}.200`)(props),
        borderColor: mode(`${c}.500`, `${c}.200`)(props),
        color: mode("white", "gray.900")(props),
        _hover: {
          bg: mode(`${c}.600`, `${c}.300`)(props),
          borderColor: mode(`${c}.600`, `${c}.300`)(props)
        },
        _disabled: {
          borderColor: mode("gray.200", "transparent")(props),
          bg: mode("gray.200", "whiteAlpha.300")(props),
          color: mode("gray.500", "whiteAlpha.500")(props)
        }
      },
      _indeterminate: {
        bg: mode(`${c}.500`, `${c}.200`)(props),
        borderColor: mode(`${c}.500`, `${c}.200`)(props),
        color: mode("white", "gray.900")(props)
      },
      _disabled: {
        bg: mode("gray.100", "whiteAlpha.100")(props),
        borderColor: mode("gray.100", "transparent")(props)
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: mode("red.500", "red.300")(props)
      }
    };
  });
  var baseStyleContainer$3 = defineStyle({
    _disabled: { cursor: "not-allowed" }
  });
  var baseStyleLabel$2 = defineStyle({
    userSelect: "none",
    _disabled: { opacity: 0.4 }
  });
  var baseStyleIcon$6 = defineStyle({
    transitionProperty: "transform",
    transitionDuration: "normal"
  });
  var baseStyle$v = definePartsStyle$i((props) => ({
    icon: baseStyleIcon$6,
    container: baseStyleContainer$3,
    control: runIfFn$1(baseStyleControl$1, props),
    label: baseStyleLabel$2
  }));
  var sizes$g = {
    sm: definePartsStyle$i({
      control: { [$size$3.variable]: "sizes.3" },
      label: { fontSize: "sm" },
      icon: { fontSize: "3xs" }
    }),
    md: definePartsStyle$i({
      control: { [$size$3.variable]: "sizes.4" },
      label: { fontSize: "md" },
      icon: { fontSize: "2xs" }
    }),
    lg: definePartsStyle$i({
      control: { [$size$3.variable]: "sizes.5" },
      label: { fontSize: "lg" },
      icon: { fontSize: "2xs" }
    })
  };
  var checkboxTheme = defineMultiStyleConfig$i({
    baseStyle: baseStyle$v,
    sizes: sizes$g,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  var { defineMultiStyleConfig: defineMultiStyleConfig$h, definePartsStyle: definePartsStyle$h } = createMultiStyleConfigHelpers(radioAnatomy.keys);
  var baseStyleControl = defineStyle((props) => {
    var _a;
    const controlStyle = (_a = runIfFn$1(checkboxTheme.baseStyle, props)) == null ? void 0 : _a.control;
    return {
      ...controlStyle,
      borderRadius: "full",
      _checked: {
        ...controlStyle == null ? void 0 : controlStyle["_checked"],
        _before: {
          content: `""`,
          display: "inline-block",
          pos: "relative",
          w: "50%",
          h: "50%",
          borderRadius: "50%",
          bg: "currentColor"
        }
      }
    };
  });
  var baseStyle$u = definePartsStyle$h((props) => {
    var _a, _b, _c, _d;
    return {
      label: (_b = (_a = checkboxTheme).baseStyle) == null ? void 0 : _b.call(_a, props).label,
      container: (_d = (_c = checkboxTheme).baseStyle) == null ? void 0 : _d.call(_c, props).container,
      control: baseStyleControl(props)
    };
  });
  var sizes$f = {
    md: definePartsStyle$h({
      control: { w: "4", h: "4" },
      label: { fontSize: "md" }
    }),
    lg: definePartsStyle$h({
      control: { w: "5", h: "5" },
      label: { fontSize: "lg" }
    }),
    sm: definePartsStyle$h({
      control: { width: "3", height: "3" },
      label: { fontSize: "sm" }
    })
  };
  var radioTheme = defineMultiStyleConfig$h({
    baseStyle: baseStyle$u,
    sizes: sizes$f,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  var { defineMultiStyleConfig: defineMultiStyleConfig$g, definePartsStyle: definePartsStyle$g } = createMultiStyleConfigHelpers(selectAnatomy.keys);
  var $bg$b = cssVar$1("select-bg");
  var _a$2;
  var baseStyleField$1 = defineStyle({
    ...(_a$2 = inputTheme.baseStyle) == null ? void 0 : _a$2.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $bg$b.reference,
    [$bg$b.variable]: "colors.white",
    _dark: {
      [$bg$b.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
      bg: $bg$b.reference
    }
  });
  var baseStyleIcon$5 = defineStyle({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
      opacity: 0.5
    }
  });
  var baseStyle$t = definePartsStyle$g({
    field: baseStyleField$1,
    icon: baseStyleIcon$5
  });
  var iconSpacing = defineStyle({
    paddingInlineEnd: "8"
  });
  var _a2$1, _b$1, _c, _d, _e, _f, _g, _h;
  var sizes$e = {
    lg: {
      ...(_a2$1 = inputTheme.sizes) == null ? void 0 : _a2$1.lg,
      field: {
        ...(_b$1 = inputTheme.sizes) == null ? void 0 : _b$1.lg.field,
        ...iconSpacing
      }
    },
    md: {
      ...(_c = inputTheme.sizes) == null ? void 0 : _c.md,
      field: {
        ...(_d = inputTheme.sizes) == null ? void 0 : _d.md.field,
        ...iconSpacing
      }
    },
    sm: {
      ...(_e = inputTheme.sizes) == null ? void 0 : _e.sm,
      field: {
        ...(_f = inputTheme.sizes) == null ? void 0 : _f.sm.field,
        ...iconSpacing
      }
    },
    xs: {
      ...(_g = inputTheme.sizes) == null ? void 0 : _g.xs,
      field: {
        ...(_h = inputTheme.sizes) == null ? void 0 : _h.xs.field,
        ...iconSpacing
      },
      icon: {
        insetEnd: "1"
      }
    }
  };
  var selectTheme = defineMultiStyleConfig$g({
    baseStyle: baseStyle$t,
    sizes: sizes$e,
    variants: inputTheme.variants,
    defaultProps: inputTheme.defaultProps
  });

  // src/components/skeleton.ts
  var $startColor = cssVar$1("skeleton-start-color");
  var $endColor = cssVar$1("skeleton-end-color");
  var baseStyle$s = defineStyle({
    [$startColor.variable]: "colors.gray.100",
    [$endColor.variable]: "colors.gray.400",
    _dark: {
      [$startColor.variable]: "colors.gray.800",
      [$endColor.variable]: "colors.gray.600"
    },
    background: $startColor.reference,
    borderColor: $endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
  });
  var skeletonTheme = defineStyleConfig({
    baseStyle: baseStyle$s
  });

  // src/components/skip-link.ts
  var $bg$a = cssVar$1("skip-link-bg");
  var baseStyle$r = defineStyle({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
      boxShadow: "outline",
      padding: "4",
      position: "fixed",
      top: "6",
      insetStart: "6",
      [$bg$a.variable]: "colors.white",
      _dark: {
        [$bg$a.variable]: "colors.gray.700"
      },
      bg: $bg$a.reference
    }
  });
  var skipLinkTheme = defineStyleConfig({
    baseStyle: baseStyle$r
  });

  // src/components/slider.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$f, definePartsStyle: definePartsStyle$f } = createMultiStyleConfigHelpers(sliderAnatomy.keys);
  var $thumbSize = cssVar$1("slider-thumb-size");
  var $trackSize = cssVar$1("slider-track-size");
  var $bg$9 = cssVar$1("slider-bg");
  var baseStyleContainer$2 = defineStyle((props) => {
    const { orientation } = props;
    return {
      display: "inline-block",
      position: "relative",
      cursor: "pointer",
      _disabled: {
        opacity: 0.6,
        cursor: "default",
        pointerEvents: "none"
      },
      ...orient({
        orientation,
        vertical: { h: "100%" },
        horizontal: { w: "100%" }
      })
    };
  });
  var baseStyleTrack = defineStyle((props) => {
    const orientationStyles = orient({
      orientation: props.orientation,
      horizontal: { h: $trackSize.reference },
      vertical: { w: $trackSize.reference }
    });
    return {
      ...orientationStyles,
      overflow: "hidden",
      borderRadius: "sm",
      [$bg$9.variable]: "colors.gray.200",
      _dark: {
        [$bg$9.variable]: "colors.whiteAlpha.200"
      },
      _disabled: {
        [$bg$9.variable]: "colors.gray.300",
        _dark: {
          [$bg$9.variable]: "colors.whiteAlpha.300"
        }
      },
      bg: $bg$9.reference
    };
  });
  var baseStyleThumb = defineStyle((props) => {
    const { orientation } = props;
    const orientationStyle = orient({
      orientation,
      vertical: {
        left: "50%",
        transform: `translateX(-50%)`,
        _active: {
          transform: `translateX(-50%) scale(1.15)`
        }
      },
      horizontal: {
        top: "50%",
        transform: `translateY(-50%)`,
        _active: {
          transform: `translateY(-50%) scale(1.15)`
        }
      }
    });
    return {
      ...orientationStyle,
      w: $thumbSize.reference,
      h: $thumbSize.reference,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      outline: 0,
      zIndex: 1,
      borderRadius: "full",
      bg: "white",
      boxShadow: "base",
      border: "1px solid",
      borderColor: "transparent",
      transitionProperty: "transform",
      transitionDuration: "normal",
      _focusVisible: {
        boxShadow: "outline"
      },
      _disabled: {
        bg: "gray.300"
      }
    };
  });
  var baseStyleFilledTrack = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      width: "inherit",
      height: "inherit",
      [$bg$9.variable]: `colors.${c}.500`,
      _dark: {
        [$bg$9.variable]: `colors.${c}.200`
      },
      bg: $bg$9.reference
    };
  });
  var baseStyle$q = definePartsStyle$f((props) => ({
    container: baseStyleContainer$2(props),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb(props),
    filledTrack: baseStyleFilledTrack(props)
  }));
  var sizeLg = definePartsStyle$f({
    container: {
      [$thumbSize.variable]: `sizes.4`,
      [$trackSize.variable]: `sizes.1`
    }
  });
  var sizeMd = definePartsStyle$f({
    container: {
      [$thumbSize.variable]: `sizes.3.5`,
      [$trackSize.variable]: `sizes.1`
    }
  });
  var sizeSm = definePartsStyle$f({
    container: {
      [$thumbSize.variable]: `sizes.2.5`,
      [$trackSize.variable]: `sizes.0.5`
    }
  });
  var sizes$d = {
    lg: sizeLg,
    md: sizeMd,
    sm: sizeSm
  };
  var sliderTheme = defineMultiStyleConfig$f({
    baseStyle: baseStyle$q,
    sizes: sizes$d,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  // src/components/spinner.ts
  var $size$2 = cssVar("spinner-size");
  var baseStyle$p = defineStyle({
    width: [$size$2.reference],
    height: [$size$2.reference]
  });
  var sizes$c = {
    xs: defineStyle({
      [$size$2.variable]: "sizes.3"
    }),
    sm: defineStyle({
      [$size$2.variable]: "sizes.4"
    }),
    md: defineStyle({
      [$size$2.variable]: "sizes.6"
    }),
    lg: defineStyle({
      [$size$2.variable]: "sizes.8"
    }),
    xl: defineStyle({
      [$size$2.variable]: "sizes.12"
    })
  };
  var spinnerTheme = defineStyleConfig({
    baseStyle: baseStyle$p,
    sizes: sizes$c,
    defaultProps: {
      size: "md"
    }
  });

  // src/components/stat.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$e, definePartsStyle: definePartsStyle$e } = createMultiStyleConfigHelpers(statAnatomy.keys);
  var baseStyleLabel$1 = defineStyle({
    fontWeight: "medium"
  });
  var baseStyleHelpText = defineStyle({
    opacity: 0.8,
    marginBottom: "2"
  });
  var baseStyleNumber = defineStyle({
    verticalAlign: "baseline",
    fontWeight: "semibold"
  });
  var baseStyleIcon$4 = defineStyle({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
  });
  var baseStyle$o = definePartsStyle$e({
    container: {},
    label: baseStyleLabel$1,
    helpText: baseStyleHelpText,
    number: baseStyleNumber,
    icon: baseStyleIcon$4
  });
  var sizes$b = {
    md: definePartsStyle$e({
      label: { fontSize: "sm" },
      helpText: { fontSize: "sm" },
      number: { fontSize: "2xl" }
    })
  };
  var statTheme = defineMultiStyleConfig$e({
    baseStyle: baseStyle$o,
    sizes: sizes$b,
    defaultProps: {
      size: "md"
    }
  });

  // src/components/kbd.ts
  var $bg$8 = cssVar$1("kbd-bg");
  var baseStyle$n = defineStyle({
    [$bg$8.variable]: "colors.gray.100",
    _dark: {
      [$bg$8.variable]: "colors.whiteAlpha.100"
    },
    bg: $bg$8.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  });
  var kbdTheme = defineStyleConfig({
    baseStyle: baseStyle$n
  });

  // src/components/link.ts
  var baseStyle$m = defineStyle({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
      textDecoration: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  });
  var linkTheme = defineStyleConfig({
    baseStyle: baseStyle$m
  });

  // src/components/list.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$d, definePartsStyle: definePartsStyle$d } = createMultiStyleConfigHelpers(listAnatomy.keys);
  var baseStyleIcon$3 = defineStyle({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
  });
  var baseStyle$l = definePartsStyle$d({
    icon: baseStyleIcon$3
  });
  var listTheme = defineMultiStyleConfig$d({
    baseStyle: baseStyle$l
  });

  // src/components/menu.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$c, definePartsStyle: definePartsStyle$c } = createMultiStyleConfigHelpers(menuAnatomy.keys);
  var $bg$7 = cssVar$1("menu-bg");
  var $shadow$2 = cssVar$1("menu-shadow");
  var baseStyleList = defineStyle({
    [$bg$7.variable]: "#fff",
    [$shadow$2.variable]: "shadows.sm",
    _dark: {
      [$bg$7.variable]: "colors.gray.700",
      [$shadow$2.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px",
    bg: $bg$7.reference,
    boxShadow: $shadow$2.reference
  });
  var baseStyleItem = defineStyle({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      [$bg$7.variable]: "colors.gray.100",
      _dark: {
        [$bg$7.variable]: "colors.whiteAlpha.100"
      }
    },
    _active: {
      [$bg$7.variable]: "colors.gray.200",
      _dark: {
        [$bg$7.variable]: "colors.whiteAlpha.200"
      }
    },
    _expanded: {
      [$bg$7.variable]: "colors.gray.100",
      _dark: {
        [$bg$7.variable]: "colors.whiteAlpha.100"
      }
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    bg: $bg$7.reference
  });
  var baseStyleGroupTitle = defineStyle({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
  });
  var baseStyleIcon$2 = defineStyle({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  });
  var baseStyleCommand = defineStyle({
    opacity: 0.6
  });
  var baseStyleDivider = defineStyle({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
  });
  var baseStyleButton$1 = defineStyle({
    transitionProperty: "common",
    transitionDuration: "normal"
  });
  var baseStyle$k = definePartsStyle$c({
    button: baseStyleButton$1,
    list: baseStyleList,
    item: baseStyleItem,
    groupTitle: baseStyleGroupTitle,
    icon: baseStyleIcon$2,
    command: baseStyleCommand,
    divider: baseStyleDivider
  });
  var menuTheme = defineMultiStyleConfig$c({
    baseStyle: baseStyle$k
  });

  var { defineMultiStyleConfig: defineMultiStyleConfig$b, definePartsStyle: definePartsStyle$b } = createMultiStyleConfigHelpers(modalAnatomy.keys);
  var $bg$6 = cssVar$1("modal-bg");
  var $shadow$1 = cssVar$1("modal-shadow");
  var baseStyleOverlay$1 = defineStyle({
    bg: "blackAlpha.600",
    zIndex: "modal"
  });
  var baseStyleDialogContainer$1 = defineStyle((props) => {
    const { isCentered, scrollBehavior } = props;
    return {
      display: "flex",
      zIndex: "modal",
      justifyContent: "center",
      alignItems: isCentered ? "center" : "flex-start",
      overflow: scrollBehavior === "inside" ? "hidden" : "auto",
      overscrollBehaviorY: "none"
    };
  });
  var baseStyleDialog$1 = defineStyle((props) => {
    const { isCentered, scrollBehavior } = props;
    return {
      borderRadius: "md",
      color: "inherit",
      my: isCentered ? "auto" : "16",
      mx: isCentered ? "auto" : void 0,
      zIndex: "modal",
      maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
      [$bg$6.variable]: "colors.white",
      [$shadow$1.variable]: "shadows.lg",
      _dark: {
        [$bg$6.variable]: "colors.gray.700",
        [$shadow$1.variable]: "shadows.dark-lg"
      },
      bg: $bg$6.reference,
      boxShadow: $shadow$1.reference
    };
  });
  var baseStyleHeader$2 = defineStyle({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
  });
  var baseStyleCloseButton$2 = defineStyle({
    position: "absolute",
    top: "2",
    insetEnd: "3"
  });
  var baseStyleBody$2 = defineStyle((props) => {
    const { scrollBehavior } = props;
    return {
      px: "6",
      py: "2",
      flex: "1",
      overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
  });
  var baseStyleFooter$2 = defineStyle({
    px: "6",
    py: "4"
  });
  var baseStyle$j = definePartsStyle$b((props) => ({
    overlay: baseStyleOverlay$1,
    dialogContainer: runIfFn$1(baseStyleDialogContainer$1, props),
    dialog: runIfFn$1(baseStyleDialog$1, props),
    header: baseStyleHeader$2,
    closeButton: baseStyleCloseButton$2,
    body: runIfFn$1(baseStyleBody$2, props),
    footer: baseStyleFooter$2
  }));
  function getSize$3(value) {
    if (value === "full") {
      return definePartsStyle$b({
        dialog: {
          maxW: "100vw",
          minH: "$100vh",
          my: "0",
          borderRadius: "0"
        }
      });
    }
    return definePartsStyle$b({
      dialog: { maxW: value }
    });
  }
  var sizes$a = {
    xs: getSize$3("xs"),
    sm: getSize$3("sm"),
    md: getSize$3("md"),
    lg: getSize$3("lg"),
    xl: getSize$3("xl"),
    "2xl": getSize$3("2xl"),
    "3xl": getSize$3("3xl"),
    "4xl": getSize$3("4xl"),
    "5xl": getSize$3("5xl"),
    "6xl": getSize$3("6xl"),
    full: getSize$3("full")
  };
  var modalTheme = defineMultiStyleConfig$b({
    baseStyle: baseStyle$j,
    sizes: sizes$a,
    defaultProps: { size: "md" }
  });

  var { defineMultiStyleConfig: defineMultiStyleConfig$a, definePartsStyle: definePartsStyle$a } = createMultiStyleConfigHelpers(numberInputAnatomy.keys);
  var $stepperWidth = cssVar("number-input-stepper-width");
  var $inputPadding = cssVar("number-input-input-padding");
  var inputPaddingValue = calc($stepperWidth).add("0.5rem").toString();
  var $bg$5 = cssVar("number-input-bg");
  var $fg$3 = cssVar("number-input-color");
  var $border$2 = cssVar("number-input-border-color");
  var baseStyleRoot = defineStyle({
    [$stepperWidth.variable]: "sizes.6",
    [$inputPadding.variable]: inputPaddingValue
  });
  var baseStyleField = defineStyle(
    (props) => {
      var _a, _b;
      return (_b = (_a = runIfFn$1(inputTheme.baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
    }
  );
  var baseStyleStepperGroup = defineStyle({
    width: $stepperWidth.reference
  });
  var baseStyleStepper = defineStyle({
    borderStart: "1px solid",
    borderStartColor: $border$2.reference,
    color: $fg$3.reference,
    bg: $bg$5.reference,
    [$fg$3.variable]: "colors.chakra-body-text",
    [$border$2.variable]: "colors.chakra-border-color",
    _dark: {
      [$fg$3.variable]: "colors.whiteAlpha.800",
      [$border$2.variable]: "colors.whiteAlpha.300"
    },
    _active: {
      [$bg$5.variable]: "colors.gray.200",
      _dark: {
        [$bg$5.variable]: "colors.whiteAlpha.300"
      }
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  });
  var baseStyle$i = definePartsStyle$a((props) => {
    var _a;
    return {
      root: baseStyleRoot,
      field: (_a = runIfFn$1(baseStyleField, props)) != null ? _a : {},
      stepperGroup: baseStyleStepperGroup,
      stepper: baseStyleStepper
    };
  });
  function getSize$2(size) {
    var _a, _b, _c;
    const sizeStyle = (_a = inputTheme.sizes) == null ? void 0 : _a[size];
    const radius = {
      lg: "md",
      md: "md",
      sm: "sm",
      xs: "sm"
    };
    const _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
    const fontSize = typography_default.fontSizes[_fontSize];
    return definePartsStyle$a({
      field: {
        ...sizeStyle.field,
        paddingInlineEnd: $inputPadding.reference,
        verticalAlign: "top"
      },
      stepper: {
        fontSize: calc(fontSize).multiply(0.75).toString(),
        _first: {
          borderTopEndRadius: radius[size]
        },
        _last: {
          borderBottomEndRadius: radius[size],
          mt: "-1px",
          borderTopWidth: 1
        }
      }
    });
  }
  var sizes$9 = {
    xs: getSize$2("xs"),
    sm: getSize$2("sm"),
    md: getSize$2("md"),
    lg: getSize$2("lg")
  };
  var numberInputTheme = defineMultiStyleConfig$a({
    baseStyle: baseStyle$i,
    sizes: sizes$9,
    variants: inputTheme.variants,
    defaultProps: inputTheme.defaultProps
  });

  var _a$1;
  var baseStyle$h = defineStyle({
    ...(_a$1 = inputTheme.baseStyle) == null ? void 0 : _a$1.field,
    textAlign: "center"
  });
  var sizes$8 = {
    lg: defineStyle({
      fontSize: "lg",
      w: 12,
      h: 12,
      borderRadius: "md"
    }),
    md: defineStyle({
      fontSize: "md",
      w: 10,
      h: 10,
      borderRadius: "md"
    }),
    sm: defineStyle({
      fontSize: "sm",
      w: 8,
      h: 8,
      borderRadius: "sm"
    }),
    xs: defineStyle({
      fontSize: "xs",
      w: 6,
      h: 6,
      borderRadius: "sm"
    })
  };
  var _a2, _b;
  var variants$5 = {
    outline: defineStyle(
      (props) => {
        var _a3, _b2, _c;
        return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.outline, props)) == null ? void 0 : _b2.field) != null ? _c : {};
      }
    ),
    flushed: defineStyle(
      (props) => {
        var _a3, _b2, _c;
        return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.flushed, props)) == null ? void 0 : _b2.field) != null ? _c : {};
      }
    ),
    filled: defineStyle(
      (props) => {
        var _a3, _b2, _c;
        return (_c = (_b2 = runIfFn$1((_a3 = inputTheme.variants) == null ? void 0 : _a3.filled, props)) == null ? void 0 : _b2.field) != null ? _c : {};
      }
    ),
    unstyled: (_b = (_a2 = inputTheme.variants) == null ? void 0 : _a2.unstyled.field) != null ? _b : {}
  };
  var pinInputTheme = defineStyleConfig({
    baseStyle: baseStyle$h,
    sizes: sizes$8,
    variants: variants$5,
    defaultProps: inputTheme.defaultProps
  });

  // src/components/popover.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$9, definePartsStyle: definePartsStyle$9 } = createMultiStyleConfigHelpers(popoverAnatomy.keys);
  var $popperBg = cssVar("popper-bg");
  var $arrowBg = cssVar("popper-arrow-bg");
  var $arrowShadowColor = cssVar("popper-arrow-shadow-color");
  var baseStylePopper = defineStyle({ zIndex: 10 });
  var baseStyleContent = defineStyle({
    [$popperBg.variable]: `colors.white`,
    bg: $popperBg.reference,
    [$arrowBg.variable]: $popperBg.reference,
    [$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
      [$popperBg.variable]: `colors.gray.700`,
      [$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
      outline: 0,
      boxShadow: "outline"
    }
  });
  var baseStyleHeader$1 = defineStyle({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
  });
  var baseStyleBody$1 = defineStyle({
    px: 3,
    py: 2
  });
  var baseStyleFooter$1 = defineStyle({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
  });
  var baseStyleCloseButton$1 = defineStyle({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
  });
  var baseStyle$g = definePartsStyle$9({
    popper: baseStylePopper,
    content: baseStyleContent,
    header: baseStyleHeader$1,
    body: baseStyleBody$1,
    footer: baseStyleFooter$1,
    closeButton: baseStyleCloseButton$1
  });
  var popoverTheme = defineMultiStyleConfig$9({
    baseStyle: baseStyle$g
  });

  var { definePartsStyle: definePartsStyle$8, defineMultiStyleConfig: defineMultiStyleConfig$8 } = createMultiStyleConfigHelpers(drawerAnatomy.keys);
  var $bg$4 = cssVar$1("drawer-bg");
  var $bs = cssVar$1("drawer-box-shadow");
  function getSize$1(value) {
    if (value === "full") {
      return definePartsStyle$8({
        dialog: { maxW: "100vw", h: "100vh" }
      });
    }
    return definePartsStyle$8({
      dialog: { maxW: value }
    });
  }
  var baseStyleOverlay = defineStyle({
    bg: "blackAlpha.600",
    zIndex: "modal"
  });
  var baseStyleDialogContainer = defineStyle({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
  });
  var baseStyleDialog = defineStyle((props) => {
    const { isFullHeight } = props;
    return {
      ...isFullHeight && { height: "100vh" },
      zIndex: "modal",
      maxH: "100vh",
      color: "inherit",
      [$bg$4.variable]: "colors.white",
      [$bs.variable]: "shadows.lg",
      _dark: {
        [$bg$4.variable]: "colors.gray.700",
        [$bs.variable]: "shadows.dark-lg"
      },
      bg: $bg$4.reference,
      boxShadow: $bs.reference
    };
  });
  var baseStyleHeader = defineStyle({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
  });
  var baseStyleCloseButton = defineStyle({
    position: "absolute",
    top: "2",
    insetEnd: "3"
  });
  var baseStyleBody = defineStyle({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
  });
  var baseStyleFooter = defineStyle({
    px: "6",
    py: "4"
  });
  var baseStyle$f = definePartsStyle$8((props) => ({
    overlay: baseStyleOverlay,
    dialogContainer: baseStyleDialogContainer,
    dialog: runIfFn$1(baseStyleDialog, props),
    header: baseStyleHeader,
    closeButton: baseStyleCloseButton,
    body: baseStyleBody,
    footer: baseStyleFooter
  }));
  var sizes$7 = {
    xs: getSize$1("xs"),
    sm: getSize$1("md"),
    md: getSize$1("lg"),
    lg: getSize$1("2xl"),
    xl: getSize$1("4xl"),
    full: getSize$1("full")
  };
  var drawerTheme = defineMultiStyleConfig$8({
    baseStyle: baseStyle$f,
    sizes: sizes$7,
    defaultProps: {
      size: "xs"
    }
  });

  // src/components/editable.ts
  var { definePartsStyle: definePartsStyle$7, defineMultiStyleConfig: defineMultiStyleConfig$7 } = createMultiStyleConfigHelpers(editableAnatomy.keys);
  var baseStylePreview = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
  });
  var baseStyleInput = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: { boxShadow: "outline" },
    _placeholder: { opacity: 0.6 }
  });
  var baseStyleTextarea = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: { boxShadow: "outline" },
    _placeholder: { opacity: 0.6 }
  });
  var baseStyle$e = definePartsStyle$7({
    preview: baseStylePreview,
    input: baseStyleInput,
    textarea: baseStyleTextarea
  });
  var editableTheme = defineMultiStyleConfig$7({
    baseStyle: baseStyle$e
  });

  // src/components/form-control.ts
  var { definePartsStyle: definePartsStyle$6, defineMultiStyleConfig: defineMultiStyleConfig$6 } = createMultiStyleConfigHelpers(formAnatomy.keys);
  var $fg$2 = cssVar$1("form-control-color");
  var baseStyleRequiredIndicator = defineStyle({
    marginStart: "1",
    [$fg$2.variable]: "colors.red.500",
    _dark: {
      [$fg$2.variable]: "colors.red.300"
    },
    color: $fg$2.reference
  });
  var baseStyleHelperText = defineStyle({
    mt: "2",
    [$fg$2.variable]: "colors.gray.600",
    _dark: {
      [$fg$2.variable]: "colors.whiteAlpha.600"
    },
    color: $fg$2.reference,
    lineHeight: "normal",
    fontSize: "sm"
  });
  var baseStyle$d = definePartsStyle$6({
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: baseStyleRequiredIndicator,
    helperText: baseStyleHelperText
  });
  var formTheme = defineMultiStyleConfig$6({
    baseStyle: baseStyle$d
  });

  // src/components/form-error.ts
  var { definePartsStyle: definePartsStyle$5, defineMultiStyleConfig: defineMultiStyleConfig$5 } = createMultiStyleConfigHelpers(formErrorAnatomy.keys);
  var $fg$1 = cssVar$1("form-error-color");
  var baseStyleText = defineStyle({
    [$fg$1.variable]: `colors.red.500`,
    _dark: {
      [$fg$1.variable]: `colors.red.300`
    },
    color: $fg$1.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
  });
  var baseStyleIcon$1 = defineStyle({
    marginEnd: "0.5em",
    [$fg$1.variable]: `colors.red.500`,
    _dark: {
      [$fg$1.variable]: `colors.red.300`
    },
    color: $fg$1.reference
  });
  var baseStyle$c = definePartsStyle$5({
    text: baseStyleText,
    icon: baseStyleIcon$1
  });
  var formErrorTheme = defineMultiStyleConfig$5({
    baseStyle: baseStyle$c
  });

  // src/components/form-label.ts
  var baseStyle$b = defineStyle({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    }
  });
  var formLabelTheme = defineStyleConfig({
    baseStyle: baseStyle$b
  });

  // src/components/heading.ts
  var baseStyle$a = defineStyle({
    fontFamily: "heading",
    fontWeight: "bold"
  });
  var sizes$6 = {
    "4xl": defineStyle({
      fontSize: ["6xl", null, "7xl"],
      lineHeight: 1
    }),
    "3xl": defineStyle({
      fontSize: ["5xl", null, "6xl"],
      lineHeight: 1
    }),
    "2xl": defineStyle({
      fontSize: ["4xl", null, "5xl"],
      lineHeight: [1.2, null, 1]
    }),
    xl: defineStyle({
      fontSize: ["3xl", null, "4xl"],
      lineHeight: [1.33, null, 1.2]
    }),
    lg: defineStyle({
      fontSize: ["2xl", null, "3xl"],
      lineHeight: [1.33, null, 1.2]
    }),
    md: defineStyle({
      fontSize: "xl",
      lineHeight: 1.2
    }),
    sm: defineStyle({
      fontSize: "md",
      lineHeight: 1.2
    }),
    xs: defineStyle({
      fontSize: "sm",
      lineHeight: 1.2
    })
  };
  var headingTheme = defineStyleConfig({
    baseStyle: baseStyle$a,
    sizes: sizes$6,
    defaultProps: {
      size: "xl"
    }
  });

  // src/components/breadcrumb.ts
  var { defineMultiStyleConfig: defineMultiStyleConfig$4, definePartsStyle: definePartsStyle$4 } = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);
  var $decor = cssVar$1("breadcrumb-link-decor");
  var baseStyleLink = defineStyle({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $decor.reference,
    [$decor.variable]: "none",
    "&:not([aria-current=page])": {
      cursor: "pointer",
      _hover: {
        [$decor.variable]: "underline"
      },
      _focusVisible: {
        boxShadow: "outline"
      }
    }
  });
  var baseStyle$9 = definePartsStyle$4({
    link: baseStyleLink
  });
  var breadcrumbTheme = defineMultiStyleConfig$4({
    baseStyle: baseStyle$9
  });

  var baseStyle$8 = defineStyle({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      _disabled: {
        bg: "initial"
      }
    }
  });
  var variantGhost = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    if (c === "gray") {
      return {
        color: mode(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
          bg: mode(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: { bg: mode(`gray.200`, `whiteAlpha.300`)(props) }
      };
    }
    const darkHoverBg = transparentize(`${c}.200`, 0.12)(theme);
    const darkActiveBg = transparentize(`${c}.200`, 0.24)(theme);
    return {
      color: mode(`${c}.600`, `${c}.200`)(props),
      bg: "transparent",
      _hover: {
        bg: mode(`${c}.50`, darkHoverBg)(props)
      },
      _active: {
        bg: mode(`${c}.100`, darkActiveBg)(props)
      }
    };
  });
  var variantOutline = defineStyle((props) => {
    const { colorScheme: c } = props;
    const borderColor = mode(`gray.200`, `whiteAlpha.300`)(props);
    return {
      border: "1px solid",
      borderColor: c === "gray" ? borderColor : "currentColor",
      ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
      ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
      ...runIfFn$1(variantGhost, props)
    };
  });
  var accessibleColorMap = {
    yellow: {
      bg: "yellow.400",
      color: "black",
      hoverBg: "yellow.500",
      activeBg: "yellow.600"
    },
    cyan: {
      bg: "cyan.400",
      color: "black",
      hoverBg: "cyan.500",
      activeBg: "cyan.600"
    }
  };
  var variantSolid$2 = defineStyle((props) => {
    var _a;
    const { colorScheme: c } = props;
    if (c === "gray") {
      const bg2 = mode(`gray.100`, `whiteAlpha.200`)(props);
      return {
        bg: bg2,
        color: mode(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
          bg: mode(`gray.200`, `whiteAlpha.300`)(props),
          _disabled: {
            bg: bg2
          }
        },
        _active: { bg: mode(`gray.300`, `whiteAlpha.400`)(props) }
      };
    }
    const {
      bg = `${c}.500`,
      color = "white",
      hoverBg = `${c}.600`,
      activeBg = `${c}.700`
    } = (_a = accessibleColorMap[c]) != null ? _a : {};
    const background = mode(bg, `${c}.200`)(props);
    return {
      bg: background,
      color: mode(color, `gray.800`)(props),
      _hover: {
        bg: mode(hoverBg, `${c}.300`)(props),
        _disabled: {
          bg: background
        }
      },
      _active: { bg: mode(activeBg, `${c}.400`)(props) }
    };
  });
  var variantLink = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      padding: 0,
      height: "auto",
      lineHeight: "normal",
      verticalAlign: "baseline",
      color: mode(`${c}.500`, `${c}.200`)(props),
      _hover: {
        textDecoration: "underline",
        _disabled: {
          textDecoration: "none"
        }
      },
      _active: {
        color: mode(`${c}.700`, `${c}.500`)(props)
      }
    };
  });
  var variantUnstyled = defineStyle({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
  });
  var variants$4 = {
    ghost: variantGhost,
    outline: variantOutline,
    solid: variantSolid$2,
    link: variantLink,
    unstyled: variantUnstyled
  };
  var sizes$5 = {
    lg: defineStyle({
      h: "12",
      minW: "12",
      fontSize: "lg",
      px: "6"
    }),
    md: defineStyle({
      h: "10",
      minW: "10",
      fontSize: "md",
      px: "4"
    }),
    sm: defineStyle({
      h: "8",
      minW: "8",
      fontSize: "sm",
      px: "3"
    }),
    xs: defineStyle({
      h: "6",
      minW: "6",
      fontSize: "xs",
      px: "2"
    })
  };
  var buttonTheme = defineStyleConfig({
    baseStyle: baseStyle$8,
    variants: variants$4,
    sizes: sizes$5,
    defaultProps: {
      variant: "solid",
      size: "md",
      colorScheme: "gray"
    }
  });

  // src/components/card.ts
  var { definePartsStyle: definePartsStyle$3, defineMultiStyleConfig: defineMultiStyleConfig$3 } = createMultiStyleConfigHelpers(cardAnatomy.keys);
  var $bg$3 = cssVar$1("card-bg");
  var $padding = cssVar$1("card-padding");
  var $shadow = cssVar$1("card-shadow");
  var $radius = cssVar$1("card-radius");
  var $border$1 = cssVar$1("card-border-width", "0");
  var $borderColor = cssVar$1("card-border-color");
  var baseStyle$7 = definePartsStyle$3({
    container: {
      [$bg$3.variable]: "colors.chakra-body-bg",
      backgroundColor: $bg$3.reference,
      boxShadow: $shadow.reference,
      borderRadius: $radius.reference,
      color: "chakra-body-text",
      borderWidth: $border$1.reference,
      borderColor: $borderColor.reference
    },
    body: {
      padding: $padding.reference,
      flex: "1 1 0%"
    },
    header: {
      padding: $padding.reference
    },
    footer: {
      padding: $padding.reference
    }
  });
  var sizes$4 = {
    sm: definePartsStyle$3({
      container: {
        [$radius.variable]: "radii.base",
        [$padding.variable]: "space.3"
      }
    }),
    md: definePartsStyle$3({
      container: {
        [$radius.variable]: "radii.md",
        [$padding.variable]: "space.5"
      }
    }),
    lg: definePartsStyle$3({
      container: {
        [$radius.variable]: "radii.xl",
        [$padding.variable]: "space.7"
      }
    })
  };
  var variants$3 = {
    elevated: definePartsStyle$3({
      container: {
        [$shadow.variable]: "shadows.base",
        _dark: {
          [$bg$3.variable]: "colors.gray.700"
        }
      }
    }),
    outline: definePartsStyle$3({
      container: {
        [$border$1.variable]: "1px",
        [$borderColor.variable]: "colors.chakra-border-color"
      }
    }),
    filled: definePartsStyle$3({
      container: {
        [$bg$3.variable]: "colors.chakra-subtle-bg"
      }
    }),
    unstyled: {
      body: {
        [$padding.variable]: 0
      },
      header: {
        [$padding.variable]: 0
      },
      footer: {
        [$padding.variable]: 0
      }
    }
  };
  var cardTheme = defineMultiStyleConfig$3({
    baseStyle: baseStyle$7,
    variants: variants$3,
    sizes: sizes$4,
    defaultProps: {
      variant: "elevated",
      size: "md"
    }
  });

  // src/components/close-button.ts
  var $size$1 = cssVar("close-button-size");
  var $bg$2 = cssVar("close-button-bg");
  var baseStyle$6 = defineStyle({
    w: [$size$1.reference],
    h: [$size$1.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      [$bg$2.variable]: "colors.blackAlpha.100",
      _dark: {
        [$bg$2.variable]: "colors.whiteAlpha.100"
      }
    },
    _active: {
      [$bg$2.variable]: "colors.blackAlpha.200",
      _dark: {
        [$bg$2.variable]: "colors.whiteAlpha.200"
      }
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    bg: $bg$2.reference
  });
  var sizes$3 = {
    lg: defineStyle({
      [$size$1.variable]: "sizes.10",
      fontSize: "md"
    }),
    md: defineStyle({
      [$size$1.variable]: "sizes.8",
      fontSize: "xs"
    }),
    sm: defineStyle({
      [$size$1.variable]: "sizes.6",
      fontSize: "2xs"
    })
  };
  var closeButtonTheme = defineStyleConfig({
    baseStyle: baseStyle$6,
    sizes: sizes$3,
    defaultProps: {
      size: "md"
    }
  });

  var { variants: variants$2, defaultProps: defaultProps$1 } = badgeTheme;
  var baseStyle$5 = defineStyle({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: vars.bg.reference,
    color: vars.color.reference,
    boxShadow: vars.shadow.reference
  });
  var codeTheme = defineStyleConfig({
    baseStyle: baseStyle$5,
    variants: variants$2,
    defaultProps: defaultProps$1
  });

  // src/components/container.ts
  var baseStyle$4 = defineStyle({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
  });
  var containerTheme = defineStyleConfig({
    baseStyle: baseStyle$4
  });

  // src/components/divider.ts
  var baseStyle$3 = defineStyle({
    opacity: 0.6,
    borderColor: "inherit"
  });
  var variantSolid$1 = defineStyle({
    borderStyle: "solid"
  });
  var variantDashed = defineStyle({
    borderStyle: "dashed"
  });
  var variants$1 = {
    solid: variantSolid$1,
    dashed: variantDashed
  };
  var dividerTheme = defineStyleConfig({
    baseStyle: baseStyle$3,
    variants: variants$1,
    defaultProps: {
      variant: "solid"
    }
  });

  // src/components/accordion.ts
  var { definePartsStyle: definePartsStyle$2, defineMultiStyleConfig: defineMultiStyleConfig$2 } = createMultiStyleConfigHelpers(accordionAnatomy.keys);
  var baseStyleContainer$1 = defineStyle({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
      borderBottomWidth: "1px"
    }
  });
  var baseStyleButton = defineStyle({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
      boxShadow: "outline"
    },
    _hover: {
      bg: "blackAlpha.50"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    px: "4",
    py: "2"
  });
  var baseStylePanel = defineStyle({
    pt: "2",
    px: "4",
    pb: "5"
  });
  var baseStyleIcon = defineStyle({
    fontSize: "1.25em"
  });
  var baseStyle$2 = definePartsStyle$2({
    container: baseStyleContainer$1,
    button: baseStyleButton,
    panel: baseStylePanel,
    icon: baseStyleIcon
  });
  var accordionTheme = defineMultiStyleConfig$2({ baseStyle: baseStyle$2 });

  // src/components/alert.ts
  var { definePartsStyle: definePartsStyle$1, defineMultiStyleConfig: defineMultiStyleConfig$1 } = createMultiStyleConfigHelpers(alertAnatomy.keys);
  var $fg = cssVar$1("alert-fg");
  var $bg$1 = cssVar$1("alert-bg");
  var baseStyle$1 = definePartsStyle$1({
    container: {
      bg: $bg$1.reference,
      px: "4",
      py: "3"
    },
    title: {
      fontWeight: "bold",
      lineHeight: "6",
      marginEnd: "2"
    },
    description: {
      lineHeight: "6"
    },
    icon: {
      color: $fg.reference,
      flexShrink: 0,
      marginEnd: "3",
      w: "5",
      h: "6"
    },
    spinner: {
      color: $fg.reference,
      flexShrink: 0,
      marginEnd: "3",
      w: "5",
      h: "5"
    }
  });
  function getBg(props) {
    const { theme, colorScheme: c } = props;
    const darkBg = transparentize(`${c}.200`, 0.16)(theme);
    return {
      light: `colors.${c}.100`,
      dark: darkBg
    };
  }
  var variantSubtle = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg.variable]: `colors.${c}.600`,
        [$bg$1.variable]: bg.light,
        _dark: {
          [$fg.variable]: `colors.${c}.200`,
          [$bg$1.variable]: bg.dark
        }
      }
    };
  });
  var variantLeftAccent = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg.variable]: `colors.${c}.600`,
        [$bg$1.variable]: bg.light,
        _dark: {
          [$fg.variable]: `colors.${c}.200`,
          [$bg$1.variable]: bg.dark
        },
        paddingStart: "3",
        borderStartWidth: "4px",
        borderStartColor: $fg.reference
      }
    };
  });
  var variantTopAccent = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg.variable]: `colors.${c}.600`,
        [$bg$1.variable]: bg.light,
        _dark: {
          [$fg.variable]: `colors.${c}.200`,
          [$bg$1.variable]: bg.dark
        },
        pt: "2",
        borderTopWidth: "4px",
        borderTopColor: $fg.reference
      }
    };
  });
  var variantSolid = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    return {
      container: {
        [$fg.variable]: `colors.white`,
        [$bg$1.variable]: `colors.${c}.600`,
        _dark: {
          [$fg.variable]: `colors.gray.900`,
          [$bg$1.variable]: `colors.${c}.200`
        },
        color: $fg.reference
      }
    };
  });
  var variants = {
    subtle: variantSubtle,
    "left-accent": variantLeftAccent,
    "top-accent": variantTopAccent,
    solid: variantSolid
  };
  var alertTheme = defineMultiStyleConfig$1({
    baseStyle: baseStyle$1,
    variants,
    defaultProps: {
      variant: "subtle",
      colorScheme: "blue"
    }
  });

  var { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(avatarAnatomy.keys);
  var $border = cssVar$1("avatar-border-color");
  var $bg = cssVar$1("avatar-bg");
  var $fs = cssVar$1("avatar-font-size");
  var $size = cssVar$1("avatar-size");
  var baseStyleBadge = defineStyle({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $border.reference,
    [$border.variable]: "white",
    _dark: {
      [$border.variable]: "colors.gray.800"
    }
  });
  var baseStyleExcessLabel = defineStyle({
    bg: $bg.reference,
    fontSize: $fs.reference,
    width: $size.reference,
    height: $size.reference,
    lineHeight: "1",
    [$bg.variable]: "colors.gray.200",
    _dark: {
      [$bg.variable]: "colors.whiteAlpha.400"
    }
  });
  var baseStyleContainer = defineStyle((props) => {
    const { name, theme } = props;
    const bg = name ? randomColor({ string: name }) : "colors.gray.400";
    const isBgDark = isDark(bg)(theme);
    let color = "white";
    if (!isBgDark)
      color = "gray.800";
    return {
      bg: $bg.reference,
      fontSize: $fs.reference,
      color,
      borderColor: $border.reference,
      verticalAlign: "top",
      width: $size.reference,
      height: $size.reference,
      "&:not([data-loaded])": {
        [$bg.variable]: bg
      },
      [$border.variable]: "colors.white",
      _dark: {
        [$border.variable]: "colors.gray.800"
      }
    };
  });
  var baseStyleLabel = defineStyle({
    fontSize: $fs.reference,
    lineHeight: "1"
  });
  var baseStyle = definePartsStyle((props) => ({
    badge: runIfFn$1(baseStyleBadge, props),
    excessLabel: runIfFn$1(baseStyleExcessLabel, props),
    container: runIfFn$1(baseStyleContainer, props),
    label: baseStyleLabel
  }));
  function getSize(size) {
    const themeSize = size !== "100%" ? sizes_default[size] : void 0;
    return definePartsStyle({
      container: {
        [$size.variable]: themeSize != null ? themeSize : size,
        [$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
      },
      excessLabel: {
        [$size.variable]: themeSize != null ? themeSize : size,
        [$fs.variable]: `calc(${themeSize != null ? themeSize : size} / 2.5)`
      }
    });
  }
  var sizes$2 = {
    "2xs": getSize(4),
    xs: getSize(6),
    sm: getSize(8),
    md: getSize(12),
    lg: getSize(16),
    xl: getSize(24),
    "2xl": getSize(32),
    full: getSize("100%")
  };
  var avatarTheme = defineMultiStyleConfig({
    baseStyle,
    sizes: sizes$2,
    defaultProps: {
      size: "md"
    }
  });

  // src/components/index.ts
  var components = {
    Accordion: accordionTheme,
    Alert: alertTheme,
    Avatar: avatarTheme,
    Badge: badgeTheme,
    Breadcrumb: breadcrumbTheme,
    Button: buttonTheme,
    Checkbox: checkboxTheme,
    CloseButton: closeButtonTheme,
    Code: codeTheme,
    Container: containerTheme,
    Divider: dividerTheme,
    Drawer: drawerTheme,
    Editable: editableTheme,
    Form: formTheme,
    FormError: formErrorTheme,
    FormLabel: formLabelTheme,
    Heading: headingTheme,
    Input: inputTheme,
    Kbd: kbdTheme,
    Link: linkTheme,
    List: listTheme,
    Menu: menuTheme,
    Modal: modalTheme,
    NumberInput: numberInputTheme,
    PinInput: pinInputTheme,
    Popover: popoverTheme,
    Progress: progressTheme,
    Radio: radioTheme,
    Select: selectTheme,
    Skeleton: skeletonTheme,
    SkipLink: skipLinkTheme,
    Slider: sliderTheme,
    Spinner: spinnerTheme,
    Stat: statTheme,
    Switch: switchTheme,
    Table: tableTheme,
    Tabs: tabsTheme,
    Tag: tagTheme,
    Textarea: textareaTheme,
    Tooltip: tooltipTheme,
    Card: cardTheme,
    Stepper: stepperTheme
  };

  // src/semantic-tokens.ts
  var semanticTokens$1 = {
    colors: {
      "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
      "chakra-body-bg": { _light: "white", _dark: "gray.800" },
      "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
      "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
      "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
      "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
      "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
    }
  };

  // src/styles.ts
  var styles$1 = {
    global: {
      body: {
        fontFamily: "body",
        color: "chakra-body-text",
        bg: "chakra-body-bg",
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: "chakra-placeholder-color"
      },
      "*, *::before, &::after": {
        borderColor: "chakra-border-color"
      }
    }
  };

  // src/index.ts
  var direction$1 = "ltr";
  var config$1 = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
  };
  var theme$1 = {
    semanticTokens: semanticTokens$1,
    direction: direction$1,
    ...foundations$1,
    components,
    styles: styles$1,
    config: config$1
  };
  ({
    semanticTokens: semanticTokens$1,
    direction: direction$1,
    components: {},
    ...foundations$1,
    styles: styles$1,
    config: config$1
  });

  // src/extend-theme.ts
  function isFunction$1(value) {
    return typeof value === "function";
  }
  function pipe$1(...fns) {
    return (v) => fns.reduce((a, b) => b(a), v);
  }
  var createExtendTheme = (theme2) => {
    return function extendTheme2(...extensions) {
      let overrides = [...extensions];
      let activeTheme = extensions[extensions.length - 1];
      if (isChakraTheme(activeTheme) && // this ensures backward compatibility
      // previously only `extendTheme(override, activeTheme?)` was allowed
      overrides.length > 1) {
        overrides = overrides.slice(0, overrides.length - 1);
      } else {
        activeTheme = theme2;
      }
      return pipe$1(
        ...overrides.map(
          (extension) => (prevTheme) => isFunction$1(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
        )
      )(activeTheme);
    };
  };
  var extendTheme = createExtendTheme(theme$1);
  function mergeThemeOverride(...overrides) {
    return lodash_mergewith({}, ...overrides, mergeThemeCustomizer);
  }
  function mergeThemeCustomizer(source, override, key, object) {
    if ((isFunction$1(source) || isFunction$1(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
      return (...args) => {
        const sourceValue = isFunction$1(source) ? source(...args) : source;
        const overrideValue = isFunction$1(override) ? override(...args) : override;
        return lodash_mergewith({}, sourceValue, overrideValue, mergeThemeCustomizer);
      };
    }
    return void 0;
  }

  // src/object.ts
  function omit(object, keys) {
    const result = {};
    Object.keys(object).forEach((key) => {
      if (keys.includes(key))
        return;
      result[key] = object[key];
    });
    return result;
  }
  function get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [path];
    for (index = 0; index < key.length; index += 1) {
      if (!obj)
        break;
      obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
  }
  var memoize = (fn) => {
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index) => {
      if (typeof obj === "undefined") {
        return fn(obj, path, fallback);
      }
      if (!cache.has(obj)) {
        cache.set(obj, /* @__PURE__ */ new Map());
      }
      const map = cache.get(obj);
      if (map.has(path)) {
        return map.get(path);
      }
      const value = fn(obj, path, fallback, index);
      map.set(path, value);
      return value;
    };
    return memoizedFn;
  };
  var memoizedGet = memoize(get);
  function objectFilter(object, fn) {
    const result = {};
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const shouldPass = fn(value, key, object);
      if (shouldPass) {
        result[key] = value;
      }
    });
    return result;
  }
  var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);

  // src/assertion.ts
  function isFunction(value) {
    return typeof value === "function";
  }

  // src/function.ts
  function runIfFn(valueOrFn, ...args) {
    return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }

  /* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
  var hasElementType = typeof Element !== 'undefined';
  var hasMap = typeof Map === 'function';
  var hasSet = typeof Set === 'function';
  var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

  // Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

  function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
      if (a.constructor !== b.constructor) return false;

      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;)
          if (!equal(a[i], b[i])) return false;
        return true;
      }

      // START: Modifications:
      // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
      //    to co-exist with es5.
      // 2. Replace `for of` with es5 compliant iteration using `for`.
      //    Basically, take:
      //
      //    ```js
      //    for (i of a.entries())
      //      if (!b.has(i[0])) return false;
      //    ```
      //
      //    ... and convert to:
      //
      //    ```js
      //    it = a.entries();
      //    while (!(i = it.next()).done)
      //      if (!b.has(i.value[0])) return false;
      //    ```
      //
      //    **Note**: `i` access switches to `i.value`.
      var it;
      if (hasMap && (a instanceof Map) && (b instanceof Map)) {
        if (a.size !== b.size) return false;
        it = a.entries();
        while (!(i = it.next()).done)
          if (!b.has(i.value[0])) return false;
        it = a.entries();
        while (!(i = it.next()).done)
          if (!equal(i.value[1], b.get(i.value[0]))) return false;
        return true;
      }

      if (hasSet && (a instanceof Set) && (b instanceof Set)) {
        if (a.size !== b.size) return false;
        it = a.entries();
        while (!(i = it.next()).done)
          if (!b.has(i.value[0])) return false;
        return true;
      }
      // END: Modifications

      if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;)
          if (a[i] !== b[i]) return false;
        return true;
      }

      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      // START: Modifications:
      // Apply guards for `Object.create(null)` handling. See:
      // - https://github.com/FormidableLabs/react-fast-compare/issues/64
      // - https://github.com/epoberezkin/fast-deep-equal/issues/49
      if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
      // END: Modifications

      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;

      for (i = length; i-- !== 0;)
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      // END: fast-deep-equal

      // START: react-fast-compare
      // custom handling for DOM elements
      if (hasElementType && a instanceof Element) return false;

      // custom handling for React/Preact
      for (i = length; i-- !== 0;) {
        if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner
          // Preact-specific: avoid traversing Preact elements' __v and __o
          //    __v = $_original / $_vnode
          //    __o = $_owner
          // These properties contain circular references and are not needed when
          // comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of elements

          continue;
        }

        // all other properties should be traversed as usual
        if (!equal(a[keys[i]], b[keys[i]])) return false;
      }
      // END: react-fast-compare

      // START: fast-deep-equal
      return true;
    }

    return a !== a && b !== b;
  }
  // end fast-deep-equal

  var reactFastCompare = function isEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if (((error.message || '').match(/stack|recursion/i))) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('react-fast-compare cannot handle circular refs');
        return false;
      }
      // some other error. we should definitely know about these
      throw error;
    }
  };

  function useStyleConfigImpl(themeKey, props = {}) {
    var _a;
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme, colorMode } = useChakra();
    const themeStyleConfig = themeKey ? memoizedGet(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = lodash_mergewith(
      { theme, colorMode },
      (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {},
      filterUndefined(omit(rest, ["children"]))
    );
    const stylesRef = react.useRef({});
    if (styleConfig) {
      const getStyles = resolveStyleConfig(styleConfig);
      const styles = getStyles(mergedProps);
      const isStyleEqual = reactFastCompare(stylesRef.current, styles);
      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }
    return stylesRef.current;
  }
  function useStyleConfig(themeKey, props = {}) {
    return useStyleConfigImpl(themeKey, props);
  }
  function useMultiStyleConfig(themeKey, props = {}) {
    return useStyleConfigImpl(themeKey, props);
  }

  var allPropNames = /* @__PURE__ */ new Set([
    ...propNames,
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
  ]);
  var validHTMLProps = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
  ]);
  function shouldForwardProp(prop) {
    return validHTMLProps.has(prop) || !allPropNames.has(prop);
  }

  // src/assign-after.ts
  function assignAfter(target, ...sources) {
    if (target == null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }
    const result = { ...target };
    for (const nextSource of sources) {
      if (nextSource == null)
        continue;
      for (const nextKey in nextSource) {
        if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey))
          continue;
        if (nextKey in result)
          delete result[nextKey];
        result[nextKey] = nextSource[nextKey];
      }
    }
    return result;
  }

  // src/compact.ts
  function compact(object) {
    const clone = Object.assign({}, object);
    for (let key in clone) {
      if (clone[key] === void 0)
        delete clone[key];
    }
    return clone;
  }

  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var isPropValid = /* #__PURE__ */memoize$2(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );

  var testOmitPropsOnStringTag = isPropValid;

  var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
  };

  var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
  };
  var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;

    if (options) {
      var optionsShouldForwardProp = options.shouldForwardProp;
      shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
      } : optionsShouldForwardProp;
    }

    if (typeof shouldForwardProp !== 'function' && isReal) {
      shouldForwardProp = tag.__emotion_forwardProp;
    }

    return shouldForwardProp;
  };

  var Insertion = function Insertion(_ref) {
    var cache = _ref.cache,
        serialized = _ref.serialized,
        isStringTag = _ref.isStringTag;
    registerStyles(cache, serialized, isStringTag);
    useInsertionEffectAlwaysWithSyncFallback(function () {
      return insertStyles(cache, serialized, isStringTag);
    });

    return null;
  };

  var createStyled = function createStyled(tag, options) {

    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;

    if (options !== undefined) {
      identifierName = options.label;
      targetClassName = options.target;
    }

    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (args[0] == null || args[0].raw === undefined) {
        styles.push.apply(styles, args);
      } else {

        styles.push(args[0][0]);
        var len = args.length;
        var i = 1;

        for (; i < len; i++) {

          styles.push(args[i], args[0][i]);
        }
      } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


      var Styled = withEmotionCache(function (props, cache, ref) {
        var FinalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = react.useContext(ThemeContext);
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
        className += cache.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref;
        return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Insertion, {
          cache: cache,
          serialized: serialized,
          isStringTag: typeof FinalTag === 'string'
        }), /*#__PURE__*/react.createElement(FinalTag, newProps));
      });
      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
      Styled.defaultProps = tag.defaultProps;
      Styled.__emotion_real = Styled;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_styles = styles;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {
          if (targetClassName === undefined && "production" !== 'production') {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe: coerce undefined to string


          return "." + targetClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return createStyled(nextTag, _extends({}, options, nextOptions, {
          shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
        })).apply(void 0, styles);
      };

      return Styled;
    };
  };

  var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
  'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

  var newStyled = createStyled.bind();
  tags.forEach(function (tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    newStyled[tagName] = newStyled(tagName);
  });

  var _a;
  var emotion_styled = (_a = newStyled.default) != null ? _a : newStyled;
  var toCSSObject = ({ baseStyle }) => (props) => {
    const { theme, css: cssProp, __css, sx, ...rest } = props;
    const styleProps = objectFilter(rest, (_, prop) => isStyleProp(prop));
    const finalBaseStyle = runIfFn(baseStyle, props);
    const finalStyles = assignAfter(
      {},
      __css,
      finalBaseStyle,
      filterUndefined(styleProps),
      sx
    );
    const computedCSS = css$1(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
  function styled(component, options) {
    const { baseStyle, ...styledOptions } = options != null ? options : {};
    if (!styledOptions.shouldForwardProp) {
      styledOptions.shouldForwardProp = shouldForwardProp;
    }
    const styleObject = toCSSObject({ baseStyle });
    const Component = emotion_styled(
      component,
      styledOptions
    )(styleObject);
    const chakraComponent = react.forwardRef(function ChakraComponent(props, ref) {
      const { colorMode, forced } = useColorMode();
      return react.createElement(Component, {
        ref,
        "data-theme": forced ? colorMode : void 0,
        ...props
      });
    });
    return chakraComponent;
  }

  // src/factory.ts
  function factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy(styled, {
      /**
       * @example
       * const Div = chakra("div")
       * const WithChakra = chakra(AnotherComponent)
       */
      apply(target, thisArg, argArray) {
        return styled(...argArray);
      },
      /**
       * @example
       * <chakra.div />
       */
      get(_, element) {
        if (!cache.has(element)) {
          cache.set(element, styled(element));
        }
        return cache.get(element);
      }
    });
  }
  var chakra = factory();

  function forwardRef(component) {
    return react.forwardRef(component);
  }

  // src/context.ts
  function createContext(options = {}) {
    const {
      strict = true,
      errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
      name
    } = options;
    const Context = react.createContext(void 0);
    Context.displayName = name;
    function useContext() {
      var _a;
      const context = react.useContext(Context);
      if (!context && strict) {
        const error = new Error(errorMessage);
        error.name = "ContextError";
        (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
        throw error;
      }
      return context;
    }
    return [
      Context.Provider,
      useContext,
      Context
    ];
  }

  function ThemeProvider$1(props) {
    const { cssVarsRoot, theme, children } = props;
    const computedTheme = react.useMemo(() => toCSSVar(theme), [theme]);
    return /* @__PURE__ */ jsxRuntime.jsxs(ThemeProvider$2, { theme: computedTheme, children: [
      /* @__PURE__ */ jsxRuntime.jsx(CSSVars, { root: cssVarsRoot }),
      children
    ] });
  }
  function CSSVars({ root = ":host, :root" }) {
    const selector = [root, `[data-theme]`].join(",");
    return /* @__PURE__ */ jsxRuntime.jsx(Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
  }
  createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  });
  function GlobalStyle() {
    const { colorMode } = useColorMode();
    return /* @__PURE__ */ jsxRuntime.jsx(
      Global,
      {
        styles: (theme) => {
          const styleObjectOrFn = memoizedGet(theme, "styles.global");
          const globalStyles = runIfFn(styleObjectOrFn, { theme, colorMode });
          if (!globalStyles)
            return void 0;
          const styles = css$1(globalStyles)(theme);
          return styles;
        }
      }
    );
  }

  function useButtonType(value) {
    const [isButton, setIsButton] = react.useState(!value);
    const refCallback = react.useCallback((node) => {
      if (!node)
        return;
      setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return { ref: refCallback, type };
  }

  function ButtonIcon(props) {
    const { children, className, ...rest } = props;
    const _children = react.isValidElement(children) ? react.cloneElement(children, {
      "aria-hidden": true,
      focusable: false
    }) : children;
    const _className = cx("chakra-button__icon", className);
    return /* @__PURE__ */ jsxRuntime.jsx(
      chakra.span,
      {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
      }
    );
  }
  ButtonIcon.displayName = "ButtonIcon";

  var spin = keyframes$1({
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  });
  var Spinner = forwardRef((props, ref) => {
    const styles = useStyleConfig("Spinner", props);
    const {
      label = "Loading...",
      thickness = "2px",
      speed = "0.45s",
      emptyColor = "transparent",
      className,
      ...rest
    } = omitThemingProps(props);
    const _className = cx("chakra-spinner", className);
    const spinnerStyles = {
      display: "inline-block",
      borderColor: "currentColor",
      borderStyle: "solid",
      borderRadius: "99999px",
      borderWidth: thickness,
      borderBottomColor: emptyColor,
      borderLeftColor: emptyColor,
      animation: `${spin} ${speed} linear infinite`,
      ...styles
    };
    return /* @__PURE__ */ jsxRuntime.jsx(
      chakra.div,
      {
        ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ jsxRuntime.jsx(chakra.span, { srOnly: true, children: label })
      }
    );
  });
  Spinner.displayName = "Spinner";

  function ButtonSpinner(props) {
    const {
      label,
      placement,
      spacing = "0.5rem",
      children = /* @__PURE__ */ jsxRuntime.jsx(Spinner, { color: "currentColor", width: "1em", height: "1em" }),
      className,
      __css,
      ...rest
    } = props;
    const _className = cx("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = react.useMemo(
      () => ({
        display: "flex",
        alignItems: "center",
        position: label ? "relative" : "absolute",
        [marginProp]: label ? spacing : 0,
        fontSize: "1em",
        lineHeight: "normal",
        ...__css
      }),
      [__css, label, marginProp, spacing]
    );
    return /* @__PURE__ */ jsxRuntime.jsx(chakra.div, { className: _className, ...rest, __css: spinnerStyles, children });
  }
  ButtonSpinner.displayName = "ButtonSpinner";

  function assignRef(ref, value) {
    if (ref == null)
      return;
    if (typeof ref === "function") {
      ref(value);
      return;
    }
    try {
      ref.current = value;
    } catch (error) {
      throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
  }
  function mergeRefs(...refs) {
    return (node) => {
      refs.forEach((ref) => {
        assignRef(ref, node);
      });
    };
  }
  function useMergeRefs(...refs) {
    return react.useMemo(() => mergeRefs(...refs), refs);
  }

  var Button$1 = forwardRef((props, ref) => {
    const group = useButtonGroup();
    const styles = useStyleConfig("Button", { ...group, ...props });
    const {
      isDisabled = group == null ? void 0 : group.isDisabled,
      isLoading,
      isActive,
      children,
      leftIcon,
      rightIcon,
      loadingText,
      iconSpacing = "0.5rem",
      type,
      spinner,
      spinnerPlacement = "start",
      className,
      as,
      ...rest
    } = omitThemingProps(props);
    const buttonStyles = react.useMemo(() => {
      const _focus = { ...styles == null ? void 0 : styles["_focus"], zIndex: 1 };
      return {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        position: "relative",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        outline: "none",
        ...styles,
        ...!!group && { _focus }
      };
    }, [styles, group]);
    const { ref: _ref, type: defaultType } = useButtonType(as);
    const contentProps = { rightIcon, leftIcon, iconSpacing, children };
    return /* @__PURE__ */ jsxRuntime.jsxs(
      chakra.button,
      {
        ref: useMergeRefs(ref, _ref),
        as,
        type: type != null ? type : defaultType,
        "data-active": dataAttr(isActive),
        "data-loading": dataAttr(isLoading),
        __css: buttonStyles,
        className: cx("chakra-button", className),
        ...rest,
        disabled: isDisabled || isLoading,
        children: [
          isLoading && spinnerPlacement === "start" && /* @__PURE__ */ jsxRuntime.jsx(
            ButtonSpinner,
            {
              className: "chakra-button__spinner--start",
              label: loadingText,
              placement: "start",
              spacing: iconSpacing,
              children: spinner
            }
          ),
          isLoading ? loadingText || /* @__PURE__ */ jsxRuntime.jsx(chakra.span, { opacity: 0, children: /* @__PURE__ */ jsxRuntime.jsx(ButtonContent, { ...contentProps }) }) : /* @__PURE__ */ jsxRuntime.jsx(ButtonContent, { ...contentProps }),
          isLoading && spinnerPlacement === "end" && /* @__PURE__ */ jsxRuntime.jsx(
            ButtonSpinner,
            {
              className: "chakra-button__spinner--end",
              label: loadingText,
              placement: "end",
              spacing: iconSpacing,
              children: spinner
            }
          )
        ]
      }
    );
  });
  Button$1.displayName = "Button";
  function ButtonContent(props) {
    const { leftIcon, rightIcon, children, iconSpacing } = props;
    return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [
      leftIcon && /* @__PURE__ */ jsxRuntime.jsx(ButtonIcon, { marginEnd: iconSpacing, children: leftIcon }),
      children,
      rightIcon && /* @__PURE__ */ jsxRuntime.jsx(ButtonIcon, { marginStart: iconSpacing, children: rightIcon })
    ] });
  }

  var IconButton = forwardRef(
    (props, ref) => {
      const { icon, children, isRound, "aria-label": ariaLabel, ...rest } = props;
      const element = icon || children;
      const _children = react.isValidElement(element) ? react.cloneElement(element, {
        "aria-hidden": true,
        focusable: false
      }) : null;
      return /* @__PURE__ */ jsxRuntime.jsx(
        Button$1,
        {
          padding: "0",
          borderRadius: isRound ? "full" : void 0,
          ref,
          "aria-label": ariaLabel,
          ...rest,
          children: _children
        }
      );
    }
  );
  IconButton.displayName = "IconButton";

  var colors$1 = {
      primary: "var(--color-primary)",
      error: "var(--color-text-error)",
  };

  var sizes$1 = {
      icon: {
          small: "1em",
          medium: "1.142em",
          large: "1.71em",
      },
  };

  var classes = function (a, separator) {
      if (separator === void 0) { separator = " "; }
      return a
          .filter(function (c) { return c; })
          .map(function (c) { return c.toString().trim(); })
          .join(separator);
  };

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z$d = ".Errors-module_errors__1oEvW {\n  color: var(--color-text-error);\n  margin: var(--m-xxs) 0; }\n  .Errors-module_errors__1oEvW p {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: var(--m-xxs);\n    text-align: left; }\n\n.Errors-module_centered__1qEJ- {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 100%; }\n";
  var style$a = {"errors":"Errors-module_errors__1oEvW","centered":"Errors-module_centered__1qEJ-"};
  styleInject(css_248z$d);

  var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
  };
  var IconContext = react.createContext && react.createContext(DefaultContext);

  var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
  };
  function Tree2Element(tree) {
    return tree && tree.map(function (node, i) {
      return react.createElement(node.tag, __assign({
        key: i
      }, node.attr), Tree2Element(node.child));
    });
  }
  function GenIcon(data) {
    // eslint-disable-next-line react/display-name
    return function (props) {
      return react.createElement(IconBase, __assign({
        attr: __assign({}, data.attr)
      }, props), Tree2Element(data.child));
    };
  }
  function IconBase(props) {
    var elem = function (conf) {
      var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);
      var computedSize = size || conf.size || "1em";
      var className;
      if (conf.className) className = conf.className;
      if (props.className) className = (className ? className + " " : "") + props.className;
      return react.createElement("svg", __assign({
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0"
      }, conf.attr, attr, svgProps, {
        className: className,
        style: __assign(__assign({
          color: props.color || conf.color
        }, conf.style), props.style),
        height: computedSize,
        width: computedSize,
        xmlns: "http://www.w3.org/2000/svg"
      }), title && react.createElement("title", null, title), props.children);
    };
    return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
      return elem(conf);
    }) : elem(DefaultContext);
  }

  // THIS FILE IS AUTO GENERATED
  function PiCheckBold (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"}}]})(props);
  }function PiArrowCounterClockwise (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M224,128a96,96,0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96,96,0,0,1,224,128Z"}}]})(props);
  }function PiCaretDown (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"}}]})(props);
  }function PiDownloadSimple (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"}}]})(props);
  }function PiFile (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z"}}]})(props);
  }function PiInfo (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"}}]})(props);
  }function PiWarningCircle (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"}}]})(props);
  }function PiX (props) {
    return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 256 256","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"}}]})(props);
  }

  function Errors(_a) {
      var error = _a.error, _b = _a.centered, centered = _b === void 0 ? false : _b;
      return error ? (jsxRuntime.jsx("div", __assign$1({ className: classes([style$a.errors, centered ? style$a.centered : undefined]) }, { children: jsxRuntime.jsxs("p", { children: [jsxRuntime.jsx(PiInfo, { size: sizes$1.icon.small }), error.toString()] }) }))) : null;
  }

  var css_248z$c = ".Stepper-module_stepper__2HBhf {\n  display: flex;\n  gap: var(--m);\n  margin: var(--m-xs) auto;\n  justify-content: center; }\n  .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz {\n    display: flex;\n    gap: var(--m-xxs);\n    align-items: center;\n    transition: all 0.3s ease-out; }\n    .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz .Stepper-module_badge__hPxie {\n      border-radius: 50%;\n      border: 1px solid var(--color-border);\n      aspect-ratio: 1;\n      width: 2em;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.3s ease-out; }\n    .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz.Stepper-module_active__b7mrZ {\n      color: var(--color-primary); }\n      .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz.Stepper-module_active__b7mrZ .Stepper-module_badge__hPxie {\n        background-color: var(--color-primary);\n        color: var(--color-text-on-primary);\n        border: none; }\n    .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz.Stepper-module_done__1tk5O .Stepper-module_badge__hPxie {\n      border-color: var(--color-primary); }\n    .Stepper-module_stepper__2HBhf .Stepper-module_step__1xguz:not(:first-of-type):before {\n      content: \"\";\n      height: 1px;\n      width: calc(min(140px, 4vw));\n      background-color: var(--color-border);\n      border-radius: 2px;\n      margin-right: var(--m-xs); }\n  .Stepper-module_stepper__2HBhf .Stepper-module_stepWide__3ULer:not(:first-of-type):before {\n    width: calc(min(120px, 10vw)); }\n";
  var style$9 = {"stepper":"Stepper-module_stepper__2HBhf","step":"Stepper-module_step__1xguz","badge":"Stepper-module_badge__hPxie","active":"Stepper-module_active__b7mrZ","done":"Stepper-module_done__1tk5O","stepWide":"Stepper-module_stepWide__3ULer"};
  styleInject(css_248z$c);

  function Stepper(_a) {
      var steps = _a.steps, current = _a.current, clickable = _a.clickable, setCurrent = _a.setCurrent, skipHeader = _a.skipHeader;
      return (jsxRuntime.jsx("div", __assign$1({ className: style$9.stepper }, { children: steps.map(function (step, i) {
              if (step.disabled)
                  return null;
              var done = i < current;
              var Element = clickable ? "button" : "div";
              var buttonProps = clickable
                  ? {
                      onClick: function () { return setCurrent(i); },
                      type: "button",
                  }
                  : {};
              var displayNumber = i + 1;
              if (skipHeader && displayNumber > 1) {
                  displayNumber--;
              }
              return (jsxRuntime.jsxs(Element, __assign$1({ className: classes([style$9.step, i === current ? style$9.active : done && style$9.done, steps.length < 4 && style$9.stepWide]) }, buttonProps, { children: [jsxRuntime.jsx("div", __assign$1({ className: style$9.badge }, { children: done ? jsxRuntime.jsx(PiCheckBold, { color: colors$1.primary }) : displayNumber })), jsxRuntime.jsx("div", __assign$1({ className: style$9.label }, { children: step.label }))] }), i));
          }) })));
  }

  function useCustomStyles(customStyles) {
      react.useEffect(function () {
          if (customStyles) {
              var parsedStyles_1 = JSON.parse(customStyles);
              if (parsedStyles_1) {
                  Object.keys(parsedStyles_1).forEach(function (key) {
                      var root = document.documentElement;
                      var value = parsedStyles_1 === null || parsedStyles_1 === void 0 ? void 0 : parsedStyles_1[key];
                      root.style.setProperty("--" + key, value);
                  });
              }
          }
      }, [customStyles]);
  }

  // Allows for the user to pass in JSON as either an object or a string
  var parseObjectOrStringJSON = function (name, param) {
      if (typeof param === "undefined") {
          return "";
      }
      var parsedObj = {};
      if (typeof param === "string") {
          try {
              parsedObj = JSON.parse(param);
          }
          catch (e) {
              console.error("The '".concat(name, "' prop is not a valid JSON string. This prop can either be a JSON string or JSON object. Please check the documentation for more details."));
              return "";
          }
      }
      else {
          parsedObj = param;
      }
      // Replace % symbols with %25
      for (var key in parsedObj) {
          if (typeof parsedObj[key] === "string") {
              parsedObj[key] = parsedObj[key].replace(/%(?!25)/g, "%25");
          }
      }
      return JSON.stringify(parsedObj);
  };
  var parseObjectOrStringJSONToRecord = function (name, param) {
      if (typeof param === "undefined") {
          return {};
      }
      var parsedObj = {};
      if (typeof param === "string") {
          try {
              parsedObj = JSON.parse(param);
          }
          catch (e) {
              console.error("The '".concat(name, "' prop is not a valid JSON string. This prop can either be a JSON string or JSON object. Please check the documentation for more details."));
              return {};
          }
      }
      else {
          parsedObj = param;
      }
      return parsedObj;
  };
  var sanitizeKey = function (input) {
      var result = input.toLowerCase().replace(/\s/g, "_"); // Replace spaces with underscores
      result = result.replace(/[^a-zA-Z0-9_]/g, ""); // Remove non-alphanumeric characters except underscore
      return result;
  };
  // Check if a hex color is valid
  var isValidColor = function (color) { return /^#([0-9A-F]{3}){1,2}$/i.test(color); };
  // Expand a three-character hex to six characters
  var expandHex = function (color) {
      if (color.length === 4) {
          // #rgb => #rrggbb
          color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
      }
      return color;
  };
  // Darken a hex color by a certain percent
  var darkenColor = function (color, percent) {
      if (!isValidColor(color))
          return color;
      color = expandHex(color); // Ensure the color is in 6-character format
      var num = parseInt(color.replace("#", ""), 16), amt = Math.round(2.55 * percent), R = (num >> 16) - amt, B = ((num >> 8) & 0x00ff) - amt, G = (num & 0x0000ff) - amt;
      return ("#" +
          (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 + (G < 255 ? (G < 1 ? 0 : G) : 255))
              .toString(16)
              .slice(1));
  };

  function convertRawTemplate(rawTemplate) {
      var template = parseObjectOrStringJSONToRecord("template", rawTemplate);
      if (!template || Object.keys(template).length === 0) {
          return [null, "The parameter 'template' is required. Please check the documentation for more details."];
      }
      var columnData = template["columns"];
      if (!columnData) {
          return [null, "Invalid template: No columns provided"];
      }
      if (!Array.isArray(columnData)) {
          return [null, "Invalid template: columns should be an array of objects"];
      }
      var seenKeys = {};
      var seenSuggestedMappings = {};
      var columns = [];
      for (var i = 0; i < columnData.length; i++) {
          var item = columnData[i];
          if (typeof item !== "object") {
              return [null, "Invalid template: Each item in columns should be an object (check column ".concat(i, ")")];
          }
          var name_1 = item.name || "";
          var key = item.key || "";
          var description = item.description || "";
          var required = item.required || false;
          var suggestedMappings = item.suggested_mappings || [];
          if (name_1 === "") {
              return [null, "Invalid template: The parameter \"name\" is required for each column (check column ".concat(i, ")")];
          }
          if (key === "") {
              key = sanitizeKey(name_1);
          }
          if (seenKeys[key]) {
              return [null, "Invalid template: Duplicate keys are not allowed (check column ".concat(i, ")")];
          }
          seenKeys[key] = true;
          for (var j = 0; j < suggestedMappings.length; j++) {
              var mappingVal = suggestedMappings[j].trim();
              var lowerCaseMapping = mappingVal.toLowerCase();
              if (mappingVal === "" || seenSuggestedMappings[lowerCaseMapping]) {
                  return [null, "Invalid template: The suggested_mappings for column ".concat(name_1, " cannot contain blank values or duplicate values.")];
              }
              seenSuggestedMappings[lowerCaseMapping] = true;
              suggestedMappings[j] = mappingVal;
          }
          columns.push({
              name: name_1,
              key: key,
              description: description,
              required: required,
              suggested_mappings: suggestedMappings,
          });
      }
      if (columns.length === 0) {
          return [null, "Invalid template: No columns were provided"];
      }
      return [{ columns: columns }, null];
  }

  function useStepper(steps, initialStep, skipHeader) {
      if (initialStep === void 0) { initialStep = 0; }
      var _a = react.useState(initialStep), current = _a[0], setCurrent = _a[1];
      var step = react.useMemo(function () { return steps[current]; }, [current, steps]);
      return { steps: steps, current: current, step: step, setCurrent: setCurrent, skipHeader: skipHeader };
  }

  var Steps;
  (function (Steps) {
      Steps["Upload"] = "upload";
      Steps["RowSelection"] = "row-selection";
      Steps["MapColumns"] = "map-columns";
  })(Steps || (Steps = {}));

  function useMutableLocalStorage(key, initialValue) {
      // State to store our value
      // Pass initial state function to useState so logic is only executed once
      var getLocalStorage = function () {
          if (typeof window === "undefined") {
              return initialValue;
          }
          try {
              // Get from local storage by key
              var item = window.localStorage.getItem(key);
              // Parse stored json or if none return initialValue
              return item ? JSON.parse(item) : initialValue;
          }
          catch (error) {
              // If error also return initialValue
              console.log(error);
              return initialValue;
          }
      };
      var _a = react.useState(getLocalStorage()), storedValue = _a[0], setStoredValue = _a[1];
      react.useEffect(function () {
          setStoredValue(getLocalStorage());
      }, [key]);
      // Return a wrapped version of useState's setter function that ...
      // ... persists the new value to localStorage.
      var setValue = function (value) {
          try {
              // Allow value to be a function so we have same API as useState
              var valueToStore = value instanceof Function ? value(storedValue) : value;
              // Save state
              setStoredValue(valueToStore);
              // Save to local storage
              if (typeof window !== "undefined") {
                  window.localStorage.setItem(key, JSON.stringify(valueToStore));
              }
          }
          catch (error) {
              console.log(error);
          }
      };
      return [storedValue, setValue];
  }

  var StepEnum = {
      Upload: 0,
      RowSelection: 1,
      MapColumns: 2,
      Complete: 3,
  };
  var calculateNextStep = function (nextStep, skipHeader) {
      if (skipHeader) {
          switch (nextStep) {
              case StepEnum.Upload:
              case StepEnum.RowSelection:
                  return StepEnum.MapColumns;
              case StepEnum.MapColumns:
                  return StepEnum.Complete;
              default:
                  return nextStep;
          }
      }
      return nextStep;
  };
  var getStepConfig = function (skipHeader) {
      return [
          { label: "Upload", id: Steps.Upload },
          { label: "Select header", id: Steps.RowSelection, disabled: skipHeader },
          { label: "Map columns", id: Steps.MapColumns },
      ];
  };
  function useStepNavigation(initialStep, skipHeader) {
      var _a;
      var t = useTranslation()[0];
      var translatedSteps = getStepConfig(skipHeader).map(function (step) { return (__assign$1(__assign$1({}, step), { label: t(step.label) })); });
      var stepper = useStepper(translatedSteps, StepEnum.Upload, skipHeader);
      var _b = useMutableLocalStorage("tf_steps", ""), storageStep = _b[0], setStorageStep = _b[1];
      var _c = react.useState(initialStep), currentStep = _c[0], setCurrentStep = _c[1];
      var goBack = function (backStep) {
          if (backStep === void 0) { backStep = 0; }
          backStep = backStep || currentStep - 1 || 0;
          setStep(backStep);
      };
      var goNext = function (nextStep) {
          if (nextStep === void 0) { nextStep = 0; }
          nextStep = nextStep || currentStep + 1 || 0;
          var calculatedStep = calculateNextStep(nextStep, skipHeader);
          setStep(calculatedStep);
      };
      var setStep = function (newStep) {
          setCurrentStep(newStep);
          setStorageStep(newStep);
          stepper.setCurrent(newStep);
      };
      react.useEffect(function () {
          stepper.setCurrent(storageStep || 0);
          setCurrentStep(storageStep || 0);
      }, [storageStep]);
      return {
          currentStep: storageStep || currentStep,
          setStep: setStep,
          goBack: goBack,
          goNext: goNext,
          stepper: stepper,
          stepId: (_a = stepper === null || stepper === void 0 ? void 0 : stepper.step) === null || _a === void 0 ? void 0 : _a.id,
          setStorageStep: setStorageStep,
      };
  }

  var css_248z$b = ".Main-module_wrapper__33d9J {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 20px 8px 8px 8px; }\n\n.Main-module_content__MK50u {\n  padding: 20px;\n  flex: 1;\n  overflow: hidden; }\n\n.Main-module_status__3avFj {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--m);\n  padding: 0 var(--m-s) var(--m-s) var(--m-s); }\n\n.Main-module_spinner__1F80O {\n  border: 1px solid var(--color-border);\n  margin-top: var(--m);\n  padding: var(--m);\n  border-radius: var(--border-radius-1);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.Main-module_close__2JEc4.Main-module_close__2JEc4 {\n  position: absolute;\n  right: var(--m-xs, 0.5rem);\n  top: var(--m-xs, 0.5rem);\n  border-radius: 50%;\n  min-width: calc(var(--m-xl) * 36 / 48);\n  height: calc(var(--m-xl) * 36 / 48);\n  aspect-ratio: 1;\n  font-size: var(--font-size-xl);\n  padding: 0; }\n";
  var style$8 = {"wrapper":"Main-module_wrapper__33d9J","content":"Main-module_content__MK50u","status":"Main-module_status__3avFj","spinner":"Main-module_spinner__1F80O","close":"Main-module_close__2JEc4"};
  styleInject(css_248z$b);

  var css_248z$a = ".Box-module_box__2N2la {\n  display: block;\n  margin: 0 auto;\n  padding: var(--m);\n  background-color: var(--color-background-modal);\n  border-radius: var(--border-radius-5);\n  box-shadow: 0 0 20px var(--color-background-modal-shadow);\n  max-width: 100%; }\n  .Box-module_box__2N2la.Box-module_fluid__1HsRI {\n    max-width: none; }\n  .Box-module_box__2N2la.Box-module_mid__3uORU {\n    max-width: 440px; }\n  .Box-module_box__2N2la.Box-module_wide__3yT0U {\n    max-width: 660px; }\n  .Box-module_box__2N2la.Box-module_space-l__3PMRL {\n    padding: var(--m-l); }\n  .Box-module_box__2N2la.Box-module_space-mid__20ZhP {\n    padding: var(--m); }\n  .Box-module_box__2N2la.Box-module_space-none__1qqYy {\n    padding: 0; }\n  .Box-module_box__2N2la.Box-module_bg-shade__iTjTJ {\n    background-color: var(--color-background-modal-shade); }\n";
  var style$7 = {"box":"Box-module_box__2N2la","fluid":"Box-module_fluid__1HsRI","mid":"Box-module_mid__3uORU","wide":"Box-module_wide__3yT0U","space-l":"Box-module_space-l__3PMRL","space-mid":"Box-module_space-mid__20ZhP","space-none":"Box-module_space-none__1qqYy","bg-shade":"Box-module_bg-shade__iTjTJ"};
  styleInject(css_248z$a);

  function Box$1(_a) {
      var className = _a.className, _b = _a.variants, variants = _b === void 0 ? [] : _b, props = __rest$1(_a, ["className", "variants"]);
      var variantStyles = classes(variants.map(function (c) { return style$7[c]; }));
      var containerClasses = classes([style$7.box, variantStyles, className]);
      return jsxRuntime.jsx("div", __assign$1({}, props, { className: containerClasses }));
  }

  var css_248z$9 = ".Complete-module_content__3m2G3.Complete-module_content__3m2G3 {\n  max-width: 1000px;\n  padding-top: var(--m);\n  height: 100%;\n  flex: 1 0 100px;\n  box-shadow: none;\n  background-color: transparent;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--font-size-xl);\n  flex-direction: column;\n  gap: var(--m);\n  text-align: center;\n  position: relative; }\n  .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_icon__2C54U {\n    width: 64px;\n    height: 64px;\n    isolation: isolate;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n    .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_icon__2C54U::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      border-radius: 50%;\n      background-color: var(--color-green-ui);\n      z-index: -1; }\n    .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_icon__2C54U svg {\n      width: 38%;\n      height: 38%;\n      object-fit: contain;\n      color: var(--color-text-on-primary); }\n  .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_actions__2VXSV {\n    display: flex;\n    gap: var(--m-l);\n    align-items: center;\n    justify-content: center;\n    margin-top: var(--m-xxl); }\n    .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_actions__2VXSV > * {\n      flex: 1 0 190px; }\n    .Complete-module_content__3m2G3.Complete-module_content__3m2G3 .Complete-module_actions__2VXSV button {\n      width: 50%; }\n\n.Complete-module_spinner__3Jh8z {\n  border: 1px solid var(--color-border);\n  margin-top: var(--m);\n  padding: var(--m);\n  border-radius: var(--border-radius-1); }\n";
  var style$6 = {"content":"Complete-module_content__3m2G3","icon":"Complete-module_icon__2C54U","actions":"Complete-module_actions__2VXSV","spinner":"Complete-module_spinner__3Jh8z"};
  styleInject(css_248z$9);

  function Complete(_a) {
      var reload = _a.reload, close = _a.close, isModal = _a.isModal;
      var t = useTranslation().t;
      return (jsxRuntime.jsx(Box$1, __assign$1({ className: style$6.content }, { children: jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("span", __assign$1({ className: style$6.icon }, { children: jsxRuntime.jsx(PiCheckBold, {}) })), jsxRuntime.jsx("div", { children: t("Import successful") }), jsxRuntime.jsxs("div", __assign$1({ className: style$6.actions }, { children: [jsxRuntime.jsx(Button$1, __assign$1({ type: "button", colorScheme: "secondary", leftIcon: jsxRuntime.jsx(PiArrowCounterClockwise, {}), onClick: reload }, { children: t("Upload another file") })), isModal && (jsxRuntime.jsx(Button$1, __assign$1({ type: "button", colorScheme: "primary", leftIcon: jsxRuntime.jsx(PiCheckBold, {}), onClick: close }, { children: t("Done") })))] }))] }) })));
  }

  var css_248z$8 = ".Default-module_table__1Y-0l {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border-radius: var(--border-radius-2);\n  outline: 1px solid var(--color-border);\n  table-layout: fixed;\n  overflow: hidden; }\n  .Default-module_table__1Y-0l .Default-module_thead__317_t {\n    display: table-header-group; }\n  .Default-module_table__1Y-0l .Default-module_tbody__HWi6H {\n    display: block;\n    overflow: auto;\n    width: 100%; }\n  .Default-module_table__1Y-0l .Default-module_tr__48AXI {\n    display: flex;\n    width: 100%;\n    overflow: hidden;\n    flex-wrap: nowrap; }\n  .Default-module_table__1Y-0l .Default-module_td__35N_U {\n    display: inline-flex;\n    align-items: center;\n    height: 44px;\n    flex-shrink: 0; }\n  .Default-module_table__1Y-0l .Default-module_caption__AlaHF {\n    display: table-caption;\n    border-bottom: 1px solid var(--color-border);\n    background-color: var(--color-background-modal);\n    padding: 0 var(--m-s);\n    border-radius: var(--border-radius-2) var(--border-radius-2) 0 0; }\n  .Default-module_table__1Y-0l .Default-module_thead__317_t .Default-module_tr__48AXI .Default-module_td__35N_U {\n    font-weight: 400;\n    white-space: nowrap;\n    padding: var(--m-xxxs) var(--m-s);\n    border-bottom: 1px solid var(--color-border);\n    color: var(--color-text-secondary); }\n    .Default-module_table__1Y-0l .Default-module_thead__317_t .Default-module_tr__48AXI .Default-module_td__35N_U:first-of-type {\n      border-radius: var(--border-radius-2) 0 0 0; }\n    .Default-module_table__1Y-0l .Default-module_thead__317_t .Default-module_tr__48AXI .Default-module_td__35N_U:last-child {\n      border-radius: 0 var(--border-radius-2) 0 0; }\n  .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI .Default-module_td__35N_U {\n    vertical-align: middle;\n    padding: var(--m-xxxs) var(--m-s);\n    font-weight: 400; }\n    .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI .Default-module_td__35N_U > span,\n    .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI .Default-module_td__35N_U > small {\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      display: block;\n      overflow: hidden; }\n    .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI .Default-module_td__35N_U.Default-module_highlight__2DfrT {\n      font-weight: 500; }\n    .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI .Default-module_td__35N_U.Default-module_element__2yoCQ {\n      padding: 0 var(--m-s); }\n  .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI:hover {\n    box-shadow: 0 0 0 2px var(--color-border);\n    position: relative; }\n  .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-child {\n    border-radius: 0 0 var(--border-radius-2) var(--border-radius-2); }\n    .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-child .Default-module_td__35N_U {\n      border-bottom-color: transparent; }\n      .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-child .Default-module_td__35N_U:first-of-type {\n        border-radius: 0 0 0 var(--border-radius-2); }\n      .Default-module_table__1Y-0l .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-child .Default-module_td__35N_U:last-child {\n        border-radius: 0 0 var(--border-radius-2) 0; }\n  .Default-module_table__1Y-0l.Default-module_zebra__j674h {\n    background-color: var(--color-background-modal); }\n    .Default-module_table__1Y-0l.Default-module_zebra__j674h .Default-module_tbody__HWi6H .Default-module_tr__48AXI:nth-child(odd) .Default-module_td__35N_U {\n      background-color: var(--color-background); }\n  .Default-module_table__1Y-0l.Default-module_dark__sv4Lb {\n    background-color: var(--color-background); }\n    .Default-module_table__1Y-0l.Default-module_dark__sv4Lb .Default-module_thead__317_t .Default-module_tr__48AXI .Default-module_td__35N_U {\n      background-color: var(--color-background-modal); }\n  .Default-module_table__1Y-0l.Default-module_light__2ydXR {\n    background-color: var(--color-background-modal); }\n  .Default-module_table__1Y-0l.Default-module_transparent__1j6bz .Default-module_thead__317_t {\n    background-color: var(--color-background-modal); }\n  .Default-module_table__1Y-0l.Default-module_transparent__1j6bz .Default-module_tbody__HWi6H .Default-module_tr__48AXI:hover {\n    box-shadow: none;\n    position: static; }\n  .Default-module_table__1Y-0l.Default-module_dark__sv4Lb .Default-module_tbody__HWi6H .Default-module_tr__48AXI:hover, .Default-module_table__1Y-0l.Default-module_light__2ydXR .Default-module_tbody__HWi6H .Default-module_tr__48AXI:hover {\n    box-shadow: none;\n    position: static; }\n  .Default-module_table__1Y-0l.Default-module_dark__sv4Lb .Default-module_tbody__HWi6H .Default-module_tr__48AXI:first-of-type .Default-module_td__35N_U, .Default-module_table__1Y-0l.Default-module_light__2ydXR .Default-module_tbody__HWi6H .Default-module_tr__48AXI:first-of-type .Default-module_td__35N_U {\n    padding-top: var(--m-s);\n    height: calc(44px + var(--m-s) - var(--m-xxxs)); }\n  .Default-module_table__1Y-0l.Default-module_dark__sv4Lb .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-of-type .Default-module_td__35N_U, .Default-module_table__1Y-0l.Default-module_light__2ydXR .Default-module_tbody__HWi6H .Default-module_tr__48AXI:last-of-type .Default-module_td__35N_U {\n    padding-bottom: var(--m-s);\n    height: calc(44px + var(--m-s) - var(--m-xxxs)); }\n\n.Default-module_emptyMsg__2UoCI {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 15vh;\n  text-align: center; }\n";
  var themeDefault = {"table":"Default-module_table__1Y-0l","thead":"Default-module_thead__317_t","tbody":"Default-module_tbody__HWi6H","tr":"Default-module_tr__48AXI","td":"Default-module_td__35N_U","caption":"Default-module_caption__AlaHF","highlight":"Default-module_highlight__2DfrT","element":"Default-module_element__2yoCQ","zebra":"Default-module_zebra__j674h","dark":"Default-module_dark__sv4Lb","light":"Default-module_light__2ydXR","transparent":"Default-module_transparent__1j6bz","emptyMsg":"Default-module_emptyMsg__2UoCI"};
  styleInject(css_248z$8);

  function getStringLengthOfChildren(children) {
      if (typeof children === "string")
          return children.length;
      if (Array.isArray(children))
          return children.reduce(function (sum, child) { return sum + getStringLengthOfChildren(child); }, 0);
      // If child is a React element, process its children recursively
      if (react.isValidElement(children))
          return getStringLengthOfChildren(children.props.children);
      // If none of the above, return 0
      return 0;
  }

  var css_248z$7 = ".Tooltip-module_tooltip__20Ksd {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-xs); }\n  .Tooltip-module_tooltip__20Ksd .Tooltip-module_icon__3yL5d {\n    position: relative;\n    display: block;\n    cursor: pointer; }\n  .Tooltip-module_tooltip__20Ksd.Tooltip-module_multiline__2gGrZ .Tooltip-module_message__2CUGx {\n    width: 260px;\n    white-space: normal; }\n\n.Tooltip-module_message__2CUGx {\n  position: absolute;\n  transform: translateX(-50%);\n  background-color: var(--color-background-modal);\n  z-index: 3;\n  padding: var(--m-xxs) var(--m-xs);\n  border-radius: var(--border-radius);\n  margin-top: var(--m-xs);\n  box-shadow: 0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2);\n  max-width: 300px; }\n  .Tooltip-module_message__2CUGx::after, .Tooltip-module_message__2CUGx::before {\n    position: absolute;\n    top: calc($height * -1);\n    left: 50%;\n    border-left: var(--m-xxxs) solid transparent;\n    border-right: var(--m-xxxs) solid transparent;\n    border-bottom: calc($side * 1.732) solid var(--color-border);\n    content: \"\";\n    font-size: 0;\n    line-height: 0;\n    width: 0;\n    transform: translateX(-50%); }\n  .Tooltip-module_message__2CUGx::after {\n    top: calc($height * -1 + 2px);\n    border-bottom: calc($side * 1.732) solid var(--color-background-modal); }\n";
  var style$5 = {"tooltip":"Tooltip-module_tooltip__20Ksd","icon":"Tooltip-module_icon__3yL5d","multiline":"Tooltip-module_multiline__2gGrZ","message":"Tooltip-module_message__2CUGx"};
  styleInject(css_248z$7);

  function Tooltip(_a) {
      var as = _a.as, className = _a.className, title = _a.title, children = _a.children, _b = _a.icon, icon = _b === void 0 ? jsxRuntime.jsx(PiInfo, {}) : _b, props = __rest$1(_a, ["as", "className", "title", "children", "icon"]);
      var Tag = as || "span";
      var length = getStringLengthOfChildren(title);
      var wrapperClasses = classes([style$5.tooltip, className, length > 30 && style$5.multiline]);
      var _c = react.useState(false), tooltipVisible = _c[0], setTooltipVisible = _c[1];
      var _d = react.useState({ top: 0, left: 0 }), position = _d[0], setPosition = _d[1];
      var targetRef = react.useRef(null);
      // Create a ref to attach the tooltip portal to
      var tooltipContainer = react.useRef(document.createElement("div"));
      react.useEffect(function () {
          // Appending the tooltip container to the body on mount
          document.body.appendChild(tooltipContainer.current);
          // Removing the tooltip container from the body on unmount
          return function () {
              document.body.removeChild(tooltipContainer.current);
          };
      }, []);
      var showTooltip = function () {
          if (targetRef.current) {
              var rect = targetRef.current.getBoundingClientRect();
              setPosition({
                  top: rect.bottom + window.scrollY,
                  left: rect.left + rect.width / 2 + window.scrollX,
              });
              setTooltipVisible(true);
          }
      };
      var hideTooltip = function () {
          setTooltipVisible(false);
      };
      var tooltipMessage = tooltipVisible && (jsxRuntime.jsx("span", __assign$1({ className: style$5.message, style: { position: "fixed", top: "".concat(position.top, "px"), left: "".concat(position.left, "px") } }, { children: title })));
      return (jsxRuntime.jsxs(Tag, __assign$1({}, props, { className: wrapperClasses }, { children: [children, jsxRuntime.jsxs("span", __assign$1({ className: style$5.icon, onMouseEnter: showTooltip, onMouseLeave: hideTooltip, ref: targetRef }, { children: [icon, tooltipMessage] }))] })));
  }

  var TableContext = react.createContext({});
  function Table(_a) {
      // THEME
      // Tables receive a full CSS module as theme or applies default styles
      // depending on mergeThemes being true it will merge both themes or use only the custom one
      // use a copy of ./style/Default.module.scss as base to make a custom theme
      // another example of the theme lives in src/features/contents/versions/style/TableTheme.module.scss
      var data = _a.data, // An array of objects with the data to be displayed
      _b = _a.keyAsId, // An array of objects with the data to be displayed
      keyAsId = _b === void 0 ? "id" : _b, // Has to be a unique property in the data array to be used as key
      theme = _a.theme, // A CSS module object to style the table
      mergeThemes = _a.mergeThemes, // Should 'theme' be the only style applied (false) or be merged with the default style (true)
      highlightColumns = _a.highlightColumns, // Columns that should use the highlighted style
      _c = _a.hideColumns, // Columns that should use the highlighted style
      hideColumns = _c === void 0 ? ["id"] : _c, // Array of columns to be hidden in the display
      emptyState = _a.emptyState, heading = _a.heading, _d = _a.background, background = _d === void 0 ? "zebra" : _d, _e = _a.columnWidths, columnWidths = _e === void 0 ? [] : _e, _f = _a.columnAlignments, columnAlignments = _f === void 0 ? [] : _f, _g = _a.fixHeader, fixHeader = _g === void 0 ? false : _g, onRowClick = _a.onRowClick;
      var style = !theme ? themeDefault : mergeThemes ? __assign$1(__assign$1({}, themeDefault), theme) : theme;
      // TABLE HEADINGS
      // Hide column title if the item has an action (action button) or the title starts with underscore
      var modelDatum = data === null || data === void 0 ? void 0 : data[0];
      var thead = modelDatum
          ? Object.keys(modelDatum).map(function (k) {
              var value = modelDatum[k];
              if (k.indexOf("_") === 0) {
                  return "";
              }
              if (typeof value === "object" && (value === null || value === void 0 ? void 0 : value.captionInfo)) {
                  return { key: k, captionInfo: value.captionInfo };
              }
              return k;
          })
          : {};
      var context = {
          style: style,
          highlightColumns: highlightColumns,
          hideColumns: hideColumns,
          columnWidths: columnWidths,
          columnAlignments: columnAlignments,
      };
      if (!data || !(data === null || data === void 0 ? void 0 : data.length))
          return jsxRuntime.jsx("div", __assign$1({ className: style.emptyMsg }, { children: emptyState || null }));
      var tableStyle = classes([style === null || style === void 0 ? void 0 : style.table, style === null || style === void 0 ? void 0 : style[background], fixHeader && (style === null || style === void 0 ? void 0 : style.fixHeader)]);
      var headingContent = heading ? (jsxRuntime.jsx("div", __assign$1({ className: style.caption }, { children: heading }))) : (jsxRuntime.jsx("div", __assign$1({ className: style.thead, role: "rowgroup" }, { children: jsxRuntime.jsx(Row, { datum: thead, isHeading: true }) })));
      return (jsxRuntime.jsxs(TableContext.Provider, __assign$1({ value: context }, { children: [jsxRuntime.jsxs("div", __assign$1({ className: tableStyle, role: "table" }, { children: [headingContent, jsxRuntime.jsx("div", __assign$1({ className: style.tbody, role: "rowgroup" }, { children: data.map(function (d, i) {
                              var key = keyAsId && (d === null || d === void 0 ? void 0 : d[keyAsId]) ? d[keyAsId] : i;
                              var props = { datum: d, onClick: onRowClick };
                              return react.createElement(Row, __assign$1({}, props, { key: key === null || key === void 0 ? void 0 : key.toString() }));
                          }) }))] })), !data.length && (jsxRuntime.jsx("div", __assign$1({ className: style.emptyMsg, role: "empty-query" }, { children: jsxRuntime.jsx("p", { children: "Empty" }) })))] })));
  }
  var Row = function (_a) {
      var datum = _a.datum, onClick = _a.onClick, isHeading = _a.isHeading;
      var _b = react.useContext(TableContext), style = _b.style, highlightColumns = _b.highlightColumns, hideColumns = _b.hideColumns, columnWidths = _b.columnWidths, columnAlignments = _b.columnAlignments;
      var className = classes([style === null || style === void 0 ? void 0 : style.tr]);
      return (jsxRuntime.jsx("div", __assign$1({ className: className, role: "row", onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(datum); } }, { children: Object.keys(datum)
              .filter(function (k) { return !hideColumns.includes(datum[k]) && !hideColumns.includes(k); })
              .map(function (k, i) {
              var _a, _b, _c, _d;
              // datum is the row
              // datum[k] is the content for the cell
              // If it is an object with the 'content' property, use that as content (can be JSX or a primitive)
              // Another 'raw' property with a primitive value is used to sort and search
              var content = ((_a = datum[k]) === null || _a === void 0 ? void 0 : _a.content) || datum[k];
              var tooltip = (_b = datum[k]) === null || _b === void 0 ? void 0 : _b.tooltip;
              var captionInfo = isHeading ? (_c = datum[k]) === null || _c === void 0 ? void 0 : _c.captionInfo : null;
              var headingKey = isHeading ? (_d = datum[k]) === null || _d === void 0 ? void 0 : _d.key : null;
              content = isHeading && captionInfo ? jsxRuntime.jsx(Tooltip, __assign$1({ title: captionInfo }, { children: headingKey })) : content;
              var wrappedContent = content && typeof content === "string" ? jsxRuntime.jsx("span", { children: content }) : content;
              var cellClass = classes([
                  (highlightColumns === null || highlightColumns === void 0 ? void 0 : highlightColumns.includes(k)) && style.highlight,
                  !wrappedContent && style.empty,
                  typeof content !== "string" && style.element,
              ]);
              var cellStyle = { width: (columnWidths === null || columnWidths === void 0 ? void 0 : columnWidths[i]) || "auto", textAlign: (columnAlignments === null || columnAlignments === void 0 ? void 0 : columnAlignments[i]) || "left" };
              return (jsxRuntime.jsx(Cell, __assign$1({ cellClass: cellClass, cellStyle: cellStyle, tooltip: tooltip || "" }, { children: wrappedContent }), k));
          }) })));
  };
  var Cell = function (_a) {
      var children = _a.children, cellClass = _a.cellClass, cellStyle = _a.cellStyle, tooltip = _a.tooltip;
      var style = react.useContext(TableContext).style;
      var cellProps = __assign$1({ className: classes([style === null || style === void 0 ? void 0 : style.td, cellClass, !children && (style === null || style === void 0 ? void 0 : style.empty)]), role: "cell", style: cellStyle }, (tooltip ? { title: tooltip } : {}));
      return jsxRuntime.jsx("div", __assign$1({}, cellProps, { children: children }));
  };

  var css_248z$6 = ".Checkbox-module_container__3vMh6 {\n  display: inline-block;\n  gap: var(--m-xs);\n  align-items: center; }\n  .Checkbox-module_container__3vMh6:has(input:not(:disabled)) {\n    cursor: pointer; }\n  .Checkbox-module_container__3vMh6 input[type=\"checkbox\"] {\n    -webkit-appearance: none;\n    appearance: none;\n    background-color: transparent;\n    margin: 0;\n    color: var(--color-primary);\n    width: var(--m);\n    height: var(--m);\n    border: 2px solid var(--color-border);\n    display: grid;\n    place-content: center;\n    border-radius: var(--border-radius-1);\n    cursor: pointer; }\n    .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]::before {\n      content: \"\";\n      width: var(--m-xs);\n      height: var(--m-xs); }\n    .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]:checked {\n      background-color: var(--color-primary);\n      border-color: var(--color-primary); }\n    .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]:checked::before {\n      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n      box-shadow: inset 1em 1em var(--color-text-on-primary); }\n    .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]:not(:disabled):focus-visible {\n      outline: 1px solid var(--color-border);\n      outline-offset: 3px; }\n    .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]:disabled {\n      --container-color: var(--container-disabled);\n      color: var(--container-disabled);\n      cursor: default;\n      background-color: var(--color-input-disabled);\n      border-color: var(--color-border-soft); }\n      .Checkbox-module_container__3vMh6 input[type=\"checkbox\"]:disabled:checked::before {\n        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n        box-shadow: inset 1em 1em var(--color-border-soft); }\n";
  var style$4 = {"container":"Checkbox-module_container__3vMh6"};
  styleInject(css_248z$6);

  function Checkbox(_a) {
      var label = _a.label, className = _a.className, props = __rest$1(_a, ["label", "className"]);
      var containerClasses = classes([style$4.container, className]);
      return (jsxRuntime.jsxs("label", __assign$1({ className: containerClasses }, { children: [jsxRuntime.jsx("input", __assign$1({ type: "checkbox" }, props)), jsxRuntime.jsx("span", { children: label })] })));
  }

  function useClickOutside(ref, callback) {
      var staticCallback = react.useCallback(callback, []);
      react.useEffect(function () {
          var handleClickOutside = function (event) {
              if (ref && (ref === null || ref === void 0 ? void 0 : ref.current) && !ref.current.contains(event.target))
                  staticCallback(false);
          };
          document.addEventListener("mousedown", handleClickOutside);
          return function () {
              document.removeEventListener("mousedown", handleClickOutside);
          };
      }, [ref, staticCallback]);
  }

  var useIsomorphicLayoutEffect$1 = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;

  function useEventListener(eventName, handler, element) {
      // Create a ref that stores handler
      var savedHandler = react.useRef(handler);
      useIsomorphicLayoutEffect$1(function () {
          savedHandler.current = handler;
      }, [handler]);
      react.useEffect(function () {
          // Define the listening target
          var targetElement = (element === null || element === void 0 ? void 0 : element.current) || window;
          if (!(targetElement && targetElement.addEventListener)) {
              return;
          }
          // Create event listener that calls handler function stored in ref
          var eventListener = function (event) { return savedHandler.current(event); };
          targetElement.addEventListener(eventName, eventListener);
          // Remove event listener on cleanup
          return function () {
              targetElement.removeEventListener(eventName, eventListener);
          };
      }, [eventName, element]);
  }

  function useRect() {
      // Mutable values like 'ref.current' aren't valid dependencies
      // because mutating them doesn't re-render the component.
      // Instead, we use a state as a ref to be reactive.
      var _a = react.useState(null), ref = _a[0], setRef = _a[1];
      var _b = react.useState({ x: 0, y: 0, width: 0, height: 0, top: 0, right: 0, bottom: 0, left: 0 }), size = _b[0], setSize = _b[1];
      // Prevent too many rendering using useCallback
      var updateRect = react.useCallback(function () {
          ref && setSize(ref.getBoundingClientRect());
      }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
      useEventListener("resize", updateRect);
      useIsomorphicLayoutEffect$1(function () {
          updateRect();
      }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
      react.useLayoutEffect(function () {
          window.addEventListener("mresize", updateRect);
          return function () { return window.removeEventListener("mresize", updateRect); };
      }, []);
      return [setRef, size, updateRect];
  }

  function useWindowSize() {
      var _a = react.useState([0, 0]), size = _a[0], setSize = _a[1];
      react.useLayoutEffect(function () {
          function updateSize() {
              setSize([window.innerWidth, window.innerHeight]);
          }
          window.addEventListener("resize", updateSize);
          updateSize();
          return function () { return window.removeEventListener("resize", updateSize); };
      }, []);
      return size;
  }

  var css_248z$5 = ".Input-module_container__1XTe4 {\n  margin-bottom: var(--m);\n  text-align: left; }\n  .Input-module_container__1XTe4:only-child {\n    margin: var(--m-xxs) 0; }\n  .Input-module_container__1XTe4:has(input[disabled]) .Input-module_label__29dnI {\n    cursor: default; }\n  .Input-module_container__1XTe4 > label {\n    font: inherit;\n    color: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    background-color: transparent;\n    border: none;\n    text-align: inherit;\n    padding: 0;\n    font-size: inherit;\n    accent-color: var(--color-primary); }\n\n.Input-module_label__29dnI {\n  display: inline-block;\n  margin-bottom: var(--m-xxs);\n  cursor: pointer;\n  line-height: 1;\n  font-weight: 500;\n  font-family: var(--font-family-1);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.Input-module_inputWrapper__kTFd1 {\n  background-color: var(--color-input-background);\n  border-radius: var(--border-radius-2);\n  outline: 1px solid transparent;\n  padding: calc(var(--m-xxs) / 2);\n  border: 1px solid var(--color-border);\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  min-width: 270px;\n  position: relative; }\n  .Input-module_inputWrapper__kTFd1:focus-within, .Input-module_inputWrapper__kTFd1:has(.Input-module_open__eHajs) {\n    outline-color: var(--color-text);\n    z-index: 11; }\n    .Input-module_inputWrapper__kTFd1:focus-within .Input-module_icon__2wYwj svg:not([data-stroke=\"no-stroke\"]) path, .Input-module_inputWrapper__kTFd1:has(.Input-module_open__eHajs) .Input-module_icon__2wYwj svg:not([data-stroke=\"no-stroke\"]) path {\n      stroke: var(--color-text); }\n    .Input-module_inputWrapper__kTFd1:focus-within .Input-module_options__2BmH1, .Input-module_inputWrapper__kTFd1:has(.Input-module_open__eHajs) .Input-module_options__2BmH1 {\n      display: flex; }\n  .Input-module_inputWrapper__kTFd1:has(> [error]), .Input-module_inputWrapper__kTFd1.Input-module_hasError__3tYlx {\n    border-color: var(--color-text-error); }\n    .Input-module_inputWrapper__kTFd1:has(> [error]) .Input-module_icon__2wYwj svg:not([data-stroke=\"no-stroke\"]) path, .Input-module_inputWrapper__kTFd1.Input-module_hasError__3tYlx .Input-module_icon__2wYwj svg:not([data-stroke=\"no-stroke\"]) path {\n      stroke: var(--color-text-error); }\n  .Input-module_inputWrapper__kTFd1:has(> [disabled]) {\n    background-color: var(--color-input-disabled);\n    color: var(--color-input-text-disabled);\n    border-color: var(--color-border-soft); }\n    .Input-module_inputWrapper__kTFd1:has(> [disabled]) .Input-module_icon__2wYwj.Input-module_dropdownIcon__VI9xh {\n      cursor: default; }\n  .Input-module_inputWrapper__kTFd1 .Input-module_icon__2wYwj {\n    padding: 0 var(--m-xxxs);\n    cursor: pointer;\n    display: flex; }\n    .Input-module_inputWrapper__kTFd1 .Input-module_icon__2wYwj button {\n      background: none;\n      padding: 0;\n      border: none;\n      cursor: pointer; }\n    .Input-module_inputWrapper__kTFd1 .Input-module_icon__2wYwj svg:not([data-stroke=\"no-stroke\"]) path {\n      display: block;\n      stroke: var(--color-text-soft); }\n  .Input-module_inputWrapper__kTFd1 input,\n  .Input-module_inputWrapper__kTFd1 select,\n  .Input-module_inputWrapper__kTFd1 textarea {\n    -webkit-tap-highlight-color: transparent;\n    appearance: none;\n    resize: none;\n    width: 100%;\n    display: block;\n    padding: calc(var(--m-xxs) / 2);\n    border: none;\n    background-color: transparent;\n    flex-grow: 1;\n    color: var(--color-text);\n    font: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    accent-color: var(--color-primary); }\n    .Input-module_inputWrapper__kTFd1 input::-webkit-input-placeholder, .Input-module_inputWrapper__kTFd1 select::-webkit-input-placeholder, .Input-module_inputWrapper__kTFd1 textarea::-webkit-input-placeholder {\n      color: var(--color-text-soft); }\n    .Input-module_inputWrapper__kTFd1 input:-moz-placeholder, .Input-module_inputWrapper__kTFd1 select:-moz-placeholder, .Input-module_inputWrapper__kTFd1 textarea:-moz-placeholder {\n      color: var(--color-text-soft); }\n    .Input-module_inputWrapper__kTFd1 input::-moz-placeholder, .Input-module_inputWrapper__kTFd1 select::-moz-placeholder, .Input-module_inputWrapper__kTFd1 textarea::-moz-placeholder {\n      color: var(--color-text-soft); }\n    .Input-module_inputWrapper__kTFd1 input:-ms-input-placeholder, .Input-module_inputWrapper__kTFd1 select:-ms-input-placeholder, .Input-module_inputWrapper__kTFd1 textarea:-ms-input-placeholder {\n      color: var(--color-text-soft); }\n    .Input-module_inputWrapper__kTFd1 input option:disabled,\n    .Input-module_inputWrapper__kTFd1 select option:disabled,\n    .Input-module_inputWrapper__kTFd1 textarea option:disabled {\n      color: var(--color-text-soft); }\n    .Input-module_inputWrapper__kTFd1 input option:not([value]),\n    .Input-module_inputWrapper__kTFd1 select option:not([value]),\n    .Input-module_inputWrapper__kTFd1 textarea option:not([value]) {\n      display: none; }\n    .Input-module_inputWrapper__kTFd1 input:focus,\n    .Input-module_inputWrapper__kTFd1 select:focus,\n    .Input-module_inputWrapper__kTFd1 textarea:focus {\n      outline: none; }\n  .Input-module_inputWrapper__kTFd1 select option {\n    background-color: var(--color-input-background);\n    border: none;\n    padding: var(--m); }\n  .Input-module_fluid__13vpB .Input-module_inputWrapper__kTFd1 {\n    min-width: auto; }\n  .Input-module_small__2il6w .Input-module_inputWrapper__kTFd1 {\n    padding: 0 var(--m-xxxs);\n    min-width: auto;\n    border-radius: var(--border-radius-1); }\n    .Input-module_small__2il6w .Input-module_inputWrapper__kTFd1 .Input-module_options__2BmH1 {\n      border-radius: var(--border-radius-1); }\n      .Input-module_small__2il6w .Input-module_inputWrapper__kTFd1 .Input-module_options__2BmH1 .Input-module_option__3wDSe {\n        border-radius: var(--border-radius-1); }\n  .Input-module_inputWrapper__kTFd1 .Input-module_optionsRef__dAvSG {\n    display: flex;\n    position: absolute;\n    top: 100%;\n    right: 0;\n    left: 0; }\n  .Input-module_inputWrapper__kTFd1 .Input-module_select__2mTop:not([disabled]) {\n    cursor: pointer; }\n\n.Input-module_options__2BmH1 {\n  position: fixed;\n  top: 100%;\n  right: 0;\n  left: 0;\n  z-index: 1000; }\n  .Input-module_options__2BmH1 .Input-module_inner__GHWwx {\n    display: flex;\n    background-color: var(--color-input-background);\n    border-radius: var(--border-radius-2);\n    padding: var(--m-xxxxs);\n    outline: 1px solid var(--color-border);\n    display: flex;\n    flex-direction: column;\n    gap: var(--m-xxxxs);\n    max-height: calc(100vh - 8px);\n    overflow-y: auto;\n    margin-top: var(--m-xxxxs);\n    width: 100%; }\n  .Input-module_options__2BmH1 .Input-module_option__3wDSe {\n    padding: var(--m-xxs) var(--m-xxs);\n    border-radius: var(--border-radius-2);\n    background-color: transparent;\n    border: none; }\n    .Input-module_options__2BmH1 .Input-module_option__3wDSe[disabled] {\n      color: var(--color-text-soft); }\n    .Input-module_options__2BmH1 .Input-module_option__3wDSe:not([disabled]) {\n      cursor: pointer; }\n      .Input-module_options__2BmH1 .Input-module_option__3wDSe:not([disabled]):hover, .Input-module_options__2BmH1 .Input-module_option__3wDSe:not([disabled]):focus, .Input-module_options__2BmH1 .Input-module_option__3wDSe:not([disabled]).Input-module_selected__AvnEx {\n        background-color: var(--color-background-menu-hover); }\n      .Input-module_options__2BmH1 .Input-module_option__3wDSe:not([disabled]).Input-module_placeholder__1PC3s {\n        color: var(--color-text-soft); }\n    .Input-module_options__2BmH1 .Input-module_option__3wDSe .Input-module_requiredMark__12uur {\n      color: var(--color-text-error); }\n\n.Input-module_error__b8jvx {\n  color: var(--color-text-error);\n  margin-top: var(--m-xxs);\n  line-height: 1;\n  font-weight: 400; }\n\n.Input-module_footer__1JRLh {\n  color: var(--color-text-soft);\n  margin-top: var(--m-xxs);\n  line-height: 1;\n  font-weight: 400; }\n";
  var style$3 = {"container":"Input-module_container__1XTe4","label":"Input-module_label__29dnI","inputWrapper":"Input-module_inputWrapper__kTFd1","open":"Input-module_open__eHajs","icon":"Input-module_icon__2wYwj","options":"Input-module_options__2BmH1","hasError":"Input-module_hasError__3tYlx","dropdownIcon":"Input-module_dropdownIcon__VI9xh","fluid":"Input-module_fluid__13vpB","small":"Input-module_small__2il6w","option":"Input-module_option__3wDSe","optionsRef":"Input-module_optionsRef__dAvSG","select":"Input-module_select__2mTop","inner":"Input-module_inner__GHWwx","selected":"Input-module_selected__AvnEx","placeholder":"Input-module_placeholder__1PC3s","requiredMark":"Input-module_requiredMark__12uur","error":"Input-module_error__b8jvx","footer":"Input-module_footer__1JRLh"};
  styleInject(css_248z$5);

  function Input(_a) {
      var _b = _a.as, as = _b === void 0 ? "input" : _b, label = _a.label, icon = _a.icon, iconAfter = _a.iconAfter, error = _a.error, options = _a.options, className = _a.className, _c = _a.variants, variants = _c === void 0 ? [] : _c, children = _a.children, props = __rest$1(_a, ["as", "label", "icon", "iconAfter", "error", "options", "className", "variants", "children"]);
      var Element = as;
      var variantStyles = classes(variants.map(function (c) { return style$3[c]; }));
      var containerClassName = classes([style$3.container, variantStyles, className]);
      var icon1 = icon && jsxRuntime.jsx("span", __assign$1({ className: style$3.icon }, { children: icon }));
      var icon2 = iconAfter ? (jsxRuntime.jsx("span", __assign$1({ className: style$3.icon }, { children: iconAfter }))) : (error && (jsxRuntime.jsx("span", __assign$1({ className: style$3.icon }, { children: jsxRuntime.jsx(PiInfo, {}) }))));
      var iconSelect = options && (jsxRuntime.jsx("span", __assign$1({ className: classes([style$3.icon, style$3.dropdownIcon]) }, { children: jsxRuntime.jsx(PiCaretDown, {}) })));
      var selectElement = options && options && jsxRuntime.jsx(Select, __assign$1({ options: options }, props));
      var inputWrapper = (jsxRuntime.jsxs("div", __assign$1({ className: classes([style$3.inputWrapper, error && style$3.hasError]) }, { children: [icon1, selectElement || jsxRuntime.jsx(Element, __assign$1({}, props, (options ? { type: "text" } : {}))), iconSelect, icon2] })));
      return (jsxRuntime.jsxs("div", __assign$1({ className: containerClassName }, { children: [jsxRuntime.jsxs("label", { children: [label ? jsxRuntime.jsx("span", __assign$1({ className: style$3.label }, { children: label })) : null, inputWrapper] }), error && jsxRuntime.jsx("div", __assign$1({ className: style$3.error }, { children: error })), children && jsxRuntime.jsx("div", __assign$1({ className: style$3.footer }, { children: children }))] })));
  }
  function Select(_a) {
      var _b = _a.options, options = _b === void 0 ? {} : _b, placeholder = _a.placeholder, props = __rest$1(_a, ["options", "placeholder"]);
      var _c = react.useState(false), open = _c[0], setOpen = _c[1];
      var onChangeOption = function (e) {
          var value = e.target.value;
          (props === null || props === void 0 ? void 0 : props.onChange) && (props === null || props === void 0 ? void 0 : props.onChange(value));
          e.stopPropagation();
          e.preventDefault();
          onBlur();
      };
      var selectedKey = Object.keys(options).find(function (k) { return options[k].value === props.value; }) || "";
      var _d = useRect(), setRef = _d[0], size = _d[1], updateRect = _d[2];
      var _e = useRect(), setRefPortal = _e[0], sizePortal = _e[1], updatePortalRect = _e[2];
      var windowSize = useWindowSize();
      var top = size.y + sizePortal.height > windowSize[1] - 4 ? windowSize[1] - sizePortal.height - 4 : size.y + 4;
      var optionsPosition = {
          top: "".concat(top, "px"),
          left: "".concat(size === null || size === void 0 ? void 0 : size.x, "px"),
          width: "".concat((size === null || size === void 0 ? void 0 : size.right) - (size === null || size === void 0 ? void 0 : size.left), "px"),
      };
      var onFocus = function () {
          updateRect();
          updatePortalRect();
          setOpen(true);
      };
      var onBlur = function () {
          setOpen(false);
      };
      var ref = react.useRef(null);
      useClickOutside(ref, onBlur);
      return (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx("input", __assign$1({}, props, { value: selectedKey, className: classes([style$3.select, open && style$3.open]), readOnly: true, onFocus: onFocus, placeholder: placeholder })), jsxRuntime.jsx("div", { className: style$3.optionsRef, ref: setRef }), open && (jsxRuntime.jsx("div", __assign$1({ className: style$3.options, style: optionsPosition, ref: setRefPortal }, { children: jsxRuntime.jsxs("div", __assign$1({ className: style$3.inner, ref: ref }, { children: [placeholder && (jsxRuntime.jsx("button", __assign$1({ className: classes([style$3.option, style$3.placeholder]), onClick: onChangeOption }, { children: placeholder }), -1)), Object.keys(options).map(function (k, i) { return (jsxRuntime.jsxs("button", __assign$1({ className: classes([style$3.option, options[k].value === props.value && style$3.selected]), type: "button" }, options[k], { onClick: onChangeOption, autoFocus: i === 0 }, { children: [k, " ", options[k].required && jsxRuntime.jsx("span", __assign$1({ className: style$3.requiredMark }, { children: "*" }))] }), k)); })] })) })))] }));
  }

  function DropdownFields(_a) {
      var options = _a.options, value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, selectedValues = _a.selectedValues, updateSelectedValues = _a.updateSelectedValues;
      var _b = react.useState(value), selectedOption = _b[0], setSelectedOption = _b[1];
      var _c = react.useState({}), filteredOptions = _c[0], setFilteredOptions = _c[1];
      react.useEffect(function () {
          setSelectedOption(value);
      }, [selectedValues]);
      react.useEffect(function () {
          filterOptions();
      }, [options, selectedValues]);
      var handleInputChange = function (event) {
          var newValue = event;
          var updatedSelectedValues = selectedValues.map(function (item) {
              if (item.key === selectedOption) {
                  return __assign$1(__assign$1({}, item), { selected: false });
              }
              else if (item.key === newValue) {
                  return __assign$1(__assign$1({}, item), { selected: true });
              }
              return item;
          });
          setSelectedOption(newValue);
          updateSelectedValues(__spreadArray([], updatedSelectedValues, true));
          onChange(newValue);
      };
      var filterOptions = function () {
          var newFilteredOptions = {};
          var _loop_1 = function (key) {
              var option = options[key];
              var isSelected = selectedValues.some(function (item) { return item.key === (option === null || option === void 0 ? void 0 : option.value) && item.selected && option.value !== value; });
              if (!isSelected) {
                  newFilteredOptions[key] = option;
              }
          };
          for (var key in options) {
              _loop_1(key);
          }
          setFilteredOptions(newFilteredOptions);
      };
      return (jsxRuntime.jsx(Input, { options: filteredOptions, value: selectedOption, placeholder: placeholder, variants: ["small"], onChange: handleInputChange, disabled: Object.keys(filteredOptions).length === 0 }));
  }

  function stringsSimilarity(s1, s2) {
      var words = s1.split(" ");
      var words2 = s2.split(" ");
      var highestSimilarity = words.reduce(function (acc, word) {
          var highestSimilarity = words2.reduce(function (acc2, word2) {
              var wordSimilarity = similarity(word, word2);
              return wordSimilarity > acc2 ? wordSimilarity : acc2;
          }, 0);
          return highestSimilarity > acc ? highestSimilarity : acc;
      }, 0);
      return highestSimilarity;
  }
  // From https://stackoverflow.com/a/36566052
  function similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
          longer = s2;
          shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength === 0) {
          return 1.0;
      }
      return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength.toString());
  }
  function editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      var costs = new Array(s2.length + 1);
      for (var i = 0; i <= s1.length; i++) {
          var lastValue = i;
          for (var j = 0; j <= s2.length; j++) {
              if (i === 0)
                  costs[j] = j;
              else {
                  if (j > 0) {
                      var newValue = costs[j - 1];
                      if (s1.charAt(i - 1) !== s2.charAt(j - 1))
                          newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
                      costs[j - 1] = lastValue;
                      lastValue = newValue;
                  }
              }
          }
          if (i > 0)
              costs[s2.length] = lastValue;
      }
      return costs[s2.length];
  }

  var css_248z$4 = ".MapColumns-module_content__20ZZ4 {\n  height: 100%; }\n  .MapColumns-module_content__20ZZ4 form {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: var(--m); }\n    .MapColumns-module_content__20ZZ4 form .MapColumns-module_tableWrapper___b5Fy {\n      display: flex;\n      height: 100%;\n      overflow-y: auto;\n      padding: 1px;\n      margin-right: -20px;\n      padding-right: 21px; }\n    .MapColumns-module_content__20ZZ4 form .MapColumns-module_actions__YEtCJ {\n      display: flex;\n      justify-content: space-between; }\n\n.MapColumns-module_samples__3WzLx {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1;\n  white-space: nowrap; }\n  .MapColumns-module_samples__3WzLx > small {\n    background-color: var(--color-input-background);\n    font-family: monospace;\n    padding: var(--m-xxxxs);\n    border-radius: var(--border-radius-1);\n    font-size: var(--font-size-xs);\n    display: inline-block; }\n    .MapColumns-module_samples__3WzLx > small + small {\n      margin-left: var(--m-xxxxs); }\n\n.MapColumns-module_spinner__2-3WS {\n  border: 1px solid var(--color-border);\n  margin-top: var(--m);\n  padding: var(--m);\n  border-radius: var(--border-radius-1); }\n\n.MapColumns-module_errorContainer__1FAaD {\n  display: flex;\n  justify-content: center;\n  max-width: 60vw; }\n\n.MapColumns-module_schemalessTextInput__2JguD {\n  width: 210px; }\n";
  var style$2 = {"content":"MapColumns-module_content__20ZZ4","tableWrapper":"MapColumns-module_tableWrapper___b5Fy","actions":"MapColumns-module_actions__YEtCJ","samples":"MapColumns-module_samples__3WzLx","spinner":"MapColumns-module_spinner__2-3WS","errorContainer":"MapColumns-module_errorContainer__1FAaD","schemalessTextInput":"MapColumns-module_schemalessTextInput__2JguD"};
  styleInject(css_248z$4);

  function useMapColumnsTable(uploadColumns, templateColumns, columnsValues, isLoading) {
      if (templateColumns === void 0) { templateColumns = []; }
      var t = useTranslation().t;
      react.useEffect(function () {
          Object.keys(columnsValues).map(function (uploadColumnIndexStr) {
              var uploadColumnIndex = Number(uploadColumnIndexStr);
              var templateKey = columnsValues[uploadColumnIndex].key;
              handleTemplateChange(uploadColumnIndex, templateKey);
          });
      }, []);
      var checkSimilarity = function (templateColumnKey, uploadColumnName) {
          var templateColumnKeyFormatted = templateColumnKey.replace(/_/g, " ");
          return stringsSimilarity(templateColumnKeyFormatted, uploadColumnName.toLowerCase()) > 0.9;
      };
      var isSuggestedMapping = function (templateColumn, uploadColumnName) {
          if (!(templateColumn === null || templateColumn === void 0 ? void 0 : templateColumn.suggested_mappings)) {
              return false;
          }
          return templateColumn.suggested_mappings.some(function (suggestion) { return suggestion.toLowerCase() === uploadColumnName.toLowerCase(); });
      };
      var _a = react.useState(function () {
          var usedTemplateColumns = new Set();
          var initialObject = {};
          return uploadColumns.reduce(function (acc, uc) {
              var matchedSuggestedTemplateColumn = templateColumns === null || templateColumns === void 0 ? void 0 : templateColumns.find(function (tc) { return isSuggestedMapping(tc, uc.name); });
              if (matchedSuggestedTemplateColumn && matchedSuggestedTemplateColumn.key) {
                  usedTemplateColumns.add(matchedSuggestedTemplateColumn.key);
                  acc[uc.index] = { key: matchedSuggestedTemplateColumn.key, include: true };
                  return acc;
              }
              var similarTemplateColumn = templateColumns === null || templateColumns === void 0 ? void 0 : templateColumns.find(function (tc) {
                  if (tc.key && !usedTemplateColumns.has(tc.key) && checkSimilarity(tc.key, uc.name)) {
                      usedTemplateColumns.add(tc.key);
                      return true;
                  }
                  return false;
              });
              acc[uc.index] = {
                  key: (similarTemplateColumn === null || similarTemplateColumn === void 0 ? void 0 : similarTemplateColumn.key) || "",
                  include: !!(similarTemplateColumn === null || similarTemplateColumn === void 0 ? void 0 : similarTemplateColumn.key),
                  selected: !!(similarTemplateColumn === null || similarTemplateColumn === void 0 ? void 0 : similarTemplateColumn.key),
              };
              return acc;
          }, initialObject);
      }), values = _a[0], setValues = _a[1];
      var _b = react.useState(Object.values(values).map(function (_a) {
          var key = _a.key, selected = _a.selected;
          return ({ key: key, selected: selected });
      })), selectedValues = _b[0], setSelectedValues = _b[1];
      var templateFields = react.useMemo(function () { return templateColumns.reduce(function (acc, tc) {
          var _a;
          return (__assign$1(__assign$1({}, acc), (_a = {}, _a[tc.name] = { value: tc.key, required: tc.required }, _a)));
      }, {}); }, [JSON.stringify(templateColumns)]);
      var handleTemplateChange = function (uploadColumnIndex, key) {
          setValues(function (prev) {
              var _a;
              var templatesFields = __assign$1(__assign$1({}, prev), (_a = {}, _a[uploadColumnIndex] = __assign$1(__assign$1({}, prev[uploadColumnIndex]), { key: key, include: !!key, selected: !!key }), _a));
              var templateFieldsObj = Object.values(templatesFields).map(function (_a) {
                  var key = _a.key, selected = _a.selected;
                  return ({ key: key, selected: selected });
              });
              setSelectedValues(templateFieldsObj);
              return templatesFields;
          });
      };
      var handleUseChange = function (id, value) {
          setValues(function (prev) {
              var _a;
              return (__assign$1(__assign$1({}, prev), (_a = {}, _a[id] = __assign$1(__assign$1({}, prev[id]), { include: !!prev[id].key && value }), _a)));
          });
      };
      var yourFileColumn = t("Your file column");
      var yourSampleData = t("Your sample data");
      var destinationColumn = t("Destination column");
      var include = t("Include");
      var rows = react.useMemo(function () {
          return uploadColumns.map(function (uc, index) {
              var _a;
              var name = uc.name, sample_data = uc.sample_data;
              var suggestion = (values === null || values === void 0 ? void 0 : values[index]) || {};
              var samples = sample_data.filter(function (d) { return d; });
              return _a = {},
                  _a[yourFileColumn] = {
                      raw: name || false,
                      content: name || jsxRuntime.jsx("em", { children: t("- empty -") }),
                  },
                  _a[yourSampleData] = {
                      raw: "",
                      content: (jsxRuntime.jsx("div", __assign$1({ title: samples.join(", "), className: style$2.samples }, { children: samples.map(function (d, i) { return (jsxRuntime.jsx("small", { children: d }, i)); }) }))),
                  },
                  _a[destinationColumn] = {
                      raw: "",
                      content: (jsxRuntime.jsx(DropdownFields, { options: templateFields, value: suggestion.key, placeholder: t("- Select one -"), onChange: function (key) { return handleTemplateChange(index, key); }, selectedValues: selectedValues, updateSelectedValues: setSelectedValues })),
                  },
                  _a[include] = {
                      raw: false,
                      content: (jsxRuntime.jsx(Checkbox, { checked: suggestion.include, disabled: !suggestion.key || isLoading, onChange: function (e) { return handleUseChange(index, e.target.checked); } })),
                  },
                  _a;
          });
      }, [values, isLoading]);
      return { rows: rows, formValues: values };
  }

  function MapColumns(_a) {
      var _b;
      var template = _a.template, data = _a.data, columnMapping = _a.columnMapping, selectedHeaderRow = _a.selectedHeaderRow, skipHeaderRowSelection = _a.skipHeaderRowSelection, onSuccess = _a.onSuccess, onCancel = _a.onCancel, isSubmitting = _a.isSubmitting;
      if (data.rows.length === 0) {
          return null;
      }
      var t = useTranslation().t;
      var headerRowIndex = selectedHeaderRow ? selectedHeaderRow : 0;
      var sampleDataRows = data.rows.slice(headerRowIndex + 1, headerRowIndex + 4);
      var uploadColumns = (_b = data.rows[headerRowIndex]) === null || _b === void 0 ? void 0 : _b.values.map(function (cell, index) {
          var sample_data = sampleDataRows.map(function (row) { return row.values[index]; });
          return {
              index: index,
              name: cell,
              sample_data: sample_data,
          };
      });
      var _c = useMapColumnsTable(uploadColumns, template.columns, columnMapping, isSubmitting), rows = _c.rows, formValues = _c.formValues;
      var _d = react.useState(null), error = _d[0], setError = _d[1];
      var verifyRequiredColumns = function (template, formValues) {
          var requiredColumns = template.columns.filter(function (column) { return column.required; });
          var includedValues = Object.values(formValues).filter(function (value) { return value.include; });
          return requiredColumns.every(function (requiredColumn) { return includedValues.some(function (includedValue) { return includedValue.key === requiredColumn.key; }); });
      };
      var onSubmit = function (e) {
          e.preventDefault();
          setError(null);
          var columns = Object.entries(formValues).reduce(function (acc, _a) {
              var _b;
              var index = _a[0], columnMapping = _a[1];
              return columnMapping.include
                  ? __assign$1(__assign$1({}, acc), (_b = {}, _b[index] = columnMapping, _b)) : acc;
          }, {});
          var isRequiredColumnsIncluded = verifyRequiredColumns(template, formValues);
          if (!isRequiredColumnsIncluded) {
              setError(t("Please include all required columns"));
              return;
          }
          onSuccess(columns);
      };
      return (jsxRuntime.jsx("div", __assign$1({ className: style$2.content }, { children: jsxRuntime.jsxs("form", __assign$1({ onSubmit: onSubmit }, { children: [data ? (jsxRuntime.jsx("div", __assign$1({ className: style$2.tableWrapper }, { children: jsxRuntime.jsx(Table, { data: rows, background: "dark", fixHeader: true, columnWidths: ["20%", "30%", "30%", "20%"], columnAlignments: ["", "", "", "center"] }) }))) : (jsxRuntime.jsx(jsxRuntime.Fragment, { children: t("Loading...") })), jsxRuntime.jsxs("div", __assign$1({ className: style$2.actions }, { children: [jsxRuntime.jsx(Button$1, __assign$1({ type: "button", colorScheme: "secondary", onClick: onCancel, isDisabled: isSubmitting }, { children: skipHeaderRowSelection ? t("Cancel") : t("Back") })), !!error && (jsxRuntime.jsx("div", __assign$1({ className: style$2.errorContainer }, { children: jsxRuntime.jsx(Errors, { error: error }) }))), jsxRuntime.jsx(Button$1, __assign$1({ colorScheme: "primary", isLoading: isSubmitting, type: "submit" }, { children: t("Submit") }))] }))] })) })));
  }

  var fallbackIcon = {
    path: /* @__PURE__ */ jsxRuntime.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
      /* @__PURE__ */ jsxRuntime.jsx(
        "path",
        {
          strokeLinecap: "round",
          fill: "none",
          d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
        }
      ),
      /* @__PURE__ */ jsxRuntime.jsx(
        "path",
        {
          fill: "currentColor",
          strokeLinecap: "round",
          d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
        }
      ),
      /* @__PURE__ */ jsxRuntime.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
    ] }),
    viewBox: "0 0 24 24"
  };
  var Icon = forwardRef((props, ref) => {
    const {
      as: element,
      viewBox,
      color = "currentColor",
      focusable = false,
      children,
      className,
      __css,
      ...rest
    } = props;
    const _className = cx("chakra-icon", className);
    const customStyles = useStyleConfig("Icon", props);
    const styles = {
      w: "1em",
      h: "1em",
      display: "inline-block",
      lineHeight: "1em",
      flexShrink: 0,
      color,
      ...__css,
      ...customStyles
    };
    const shared = {
      ref,
      focusable,
      className: _className,
      __css: styles
    };
    const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
    if (element && typeof element !== "string") {
      return /* @__PURE__ */ jsxRuntime.jsx(chakra.svg, { as: element, ...shared, ...rest });
    }
    const _path = children != null ? children : fallbackIcon.path;
    return /* @__PURE__ */ jsxRuntime.jsx(chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
  });
  Icon.displayName = "Icon";

  function CheckIcon(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntime.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
      }
    ) });
  }
  function InfoIcon(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntime.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
      }
    ) });
  }
  function WarningIcon(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntime.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
      }
    ) });
  }

  var [AlertProvider, useAlertContext] = createContext$1({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
  });
  var [AlertStylesProvider, useAlertStyles] = createContext$1({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
  });
  var STATUSES = {
    info: { icon: InfoIcon, colorScheme: "blue" },
    warning: { icon: WarningIcon, colorScheme: "orange" },
    success: { icon: CheckIcon, colorScheme: "green" },
    error: { icon: WarningIcon, colorScheme: "red" },
    loading: { icon: Spinner, colorScheme: "blue" }
  };
  function getStatusColorScheme(status) {
    return STATUSES[status].colorScheme;
  }
  function getStatusIcon(status) {
    return STATUSES[status].icon;
  }

  var AlertDescription = forwardRef(
    function AlertDescription2(props, ref) {
      const styles = useAlertStyles();
      const { status } = useAlertContext();
      const descriptionStyles = {
        display: "inline",
        ...styles.description
      };
      return /* @__PURE__ */ jsxRuntime.jsx(
        chakra.div,
        {
          ref,
          "data-status": status,
          ...props,
          className: cx("chakra-alert__desc", props.className),
          __css: descriptionStyles
        }
      );
    }
  );
  AlertDescription.displayName = "AlertDescription";

  function AlertIcon(props) {
    const { status } = useAlertContext();
    const BaseIcon = getStatusIcon(status);
    const styles = useAlertStyles();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ jsxRuntime.jsx(
      chakra.span,
      {
        display: "inherit",
        "data-status": status,
        ...props,
        className: cx("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ jsxRuntime.jsx(BaseIcon, { h: "100%", w: "100%" })
      }
    );
  }
  AlertIcon.displayName = "AlertIcon";

  var AlertTitle = forwardRef(
    function AlertTitle2(props, ref) {
      const styles = useAlertStyles();
      const { status } = useAlertContext();
      return /* @__PURE__ */ jsxRuntime.jsx(
        chakra.div,
        {
          ref,
          "data-status": status,
          ...props,
          className: cx("chakra-alert__title", props.className),
          __css: styles.title
        }
      );
    }
  );
  AlertTitle.displayName = "AlertTitle";

  var Alert$1 = forwardRef(function Alert2(props, ref) {
    var _a;
    const { status = "info", addRole = true, ...rest } = omitThemingProps(props);
    const colorScheme = (_a = props.colorScheme) != null ? _a : getStatusColorScheme(status);
    const styles = useMultiStyleConfig("Alert", { ...props, colorScheme });
    const alertStyles = {
      width: "100%",
      display: "flex",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      ...styles.container
    };
    return /* @__PURE__ */ jsxRuntime.jsx(AlertProvider, { value: { status }, children: /* @__PURE__ */ jsxRuntime.jsx(AlertStylesProvider, { value: styles, children: /* @__PURE__ */ jsxRuntime.jsx(
      chakra.div,
      {
        "data-status": status,
        role: addRole ? "alert" : void 0,
        ref,
        ...rest,
        className: cx("chakra-alert", props.className),
        __css: alertStyles
      }
    ) }) });
  });
  Alert$1.displayName = "Alert";

  var css_248z$3 = ".RowSelection-module_content__1PR_8 {\n  flex-grow: 1;\n  height: 100%; }\n  .RowSelection-module_content__1PR_8 form {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    gap: var(--m); }\n    .RowSelection-module_content__1PR_8 form .RowSelection-module_tableWrapper__2xHWU {\n      display: flex;\n      overflow-y: auto;\n      padding: 1px;\n      margin-right: -20px;\n      padding-right: 21px;\n      height: calc(100vh - 160px); }\n    .RowSelection-module_content__1PR_8 form .RowSelection-module_actions__1zprO {\n      display: flex;\n      justify-content: space-between; }\n\n.RowSelection-module_samples__2sQGP {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1;\n  white-space: nowrap; }\n  .RowSelection-module_samples__2sQGP > small {\n    background-color: var(--color-input-background);\n    font-family: monospace;\n    padding: var(--m-xxxxs);\n    border-radius: var(--border-radius-1);\n    font-size: var(--font-size-xs);\n    display: inline-block; }\n    .RowSelection-module_samples__2sQGP > small + small {\n      margin-left: var(--m-xxxxs); }\n\n.RowSelection-module_spinner__2yCHV {\n  border: 1px solid var(--color-border);\n  margin-top: var(--m);\n  padding: var(--m);\n  border-radius: var(--border-radius-1); }\n\n.RowSelection-module_inputRadio__3td6N {\n  margin-right: 10px; }\n\n.RowSelection-module_headingCaption__3CLAP {\n  padding: 12px 0 10px 0;\n  color: var(--color-text-secondary);\n  font-weight: 400;\n  height: 48px;\n  vertical-align: middle;\n  text-align: center; }\n  .RowSelection-module_headingCaption__3CLAP span > span:nth-child(1) > span {\n    font-weight: 400; }\n\n.RowSelection-module_warningIcon__3B01J {\n  margin-right: 7px; }\n";
  var style$1 = {"content":"RowSelection-module_content__1PR_8","tableWrapper":"RowSelection-module_tableWrapper__2xHWU","actions":"RowSelection-module_actions__1zprO","samples":"RowSelection-module_samples__2sQGP","spinner":"RowSelection-module_spinner__2yCHV","inputRadio":"RowSelection-module_inputRadio__3td6N","headingCaption":"RowSelection-module_headingCaption__3CLAP","warningIcon":"RowSelection-module_warningIcon__3B01J"};
  styleInject(css_248z$3);

  function RowSelection(_a) {
      var _b, _c;
      var data = _a.data, onSuccess = _a.onSuccess, onCancel = _a.onCancel, selectedHeaderRow = _a.selectedHeaderRow, setSelectedHeaderRow = _a.setSelectedHeaderRow;
      var t = useTranslation().t;
      var _d = react.useState(false), isLoading = _d[0], setIsLoading = _d[1];
      var handleRadioChange = function (e) {
          setSelectedHeaderRow(Number(e.target.value));
      };
      var rowLimit = 50;
      var dataWithRadios = data.rows.slice(0, rowLimit).map(function (row) {
          var _a;
          var nameWithRadio = (jsxRuntime.jsxs("span", { children: [jsxRuntime.jsx("input", { type: "radio", id: "radio-".concat(row.index), className: style$1.inputRadio, name: "rowSelection", value: row.index, checked: selectedHeaderRow === row.index, onChange: handleRadioChange }), (_a = row.values) === null || _a === void 0 ? void 0 : _a[0]] }));
          var mappedRow = Object.entries(row.values).map(function (_a) {
              var key = _a[0], value = _a[1];
              return [
                  key,
                  {
                      raw: value,
                      content: key === "0" ? nameWithRadio : jsxRuntime.jsx("span", { children: value }),
                      tooltip: value,
                  },
              ];
          });
          return Object.fromEntries(mappedRow);
      });
      var maxNumberOfColumns = 7;
      var uploadRow = (_b = data.rows[0]) !== null && _b !== void 0 ? _b : { values: {} };
      var numberOfColumns = Math.min(Object.keys(uploadRow.values).length, maxNumberOfColumns);
      var widthPercentage = 100 / numberOfColumns;
      var columnWidths = Array(numberOfColumns).fill("".concat(widthPercentage, "%"));
      var hasMultipleExcelSheets = ((_c = data.sheetList.length) !== null && _c !== void 0 ? _c : 0) > 1;
      var handleNextClick = function (e) {
          e.preventDefault();
          setIsLoading(true);
          onSuccess();
          setIsLoading(false);
      };
      return (jsxRuntime.jsx("div", __assign$1({ className: style$1.content }, { children: jsxRuntime.jsxs("form", { children: [data ? (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [hasMultipleExcelSheets ? (jsxRuntime.jsxs(Alert$1, __assign$1({ status: "info" }, { children: [jsxRuntime.jsx(PiWarningCircle, { className: style$1.warningIcon }), t("Only the first sheet (&quot;{{sheet}}&quot;) of the Excel file will be imported. To import multiple sheets, please upload each sheet individually.", { sheet: data.sheetList[0] })] }))) : null, jsxRuntime.jsx("div", __assign$1({ className: style$1.tableWrapper }, { children: jsxRuntime.jsx(Table, { fixHeader: true, mergeThemes: true, data: dataWithRadios || [], heading: jsxRuntime.jsx("div", __assign$1({ className: style$1.headingCaption }, { children: jsxRuntime.jsx(Tooltip, __assign$1({ title: t("Select the row which contains the column headers") }, { children: t("Select header row") })) })), keyAsId: "index", background: "zebra", columnWidths: columnWidths, columnAlignments: Array(numberOfColumns).fill("left"), onRowClick: function (row) { return setSelectedHeaderRow((dataWithRadios === null || dataWithRadios === void 0 ? void 0 : dataWithRadios.indexOf(row)) || 0); } }) }))] })) : (jsxRuntime.jsx(jsxRuntime.Fragment, { children: t("Loading...") })), jsxRuntime.jsxs("div", __assign$1({ className: style$1.actions }, { children: [jsxRuntime.jsx(Button$1, __assign$1({ type: "button", colorScheme: "secondary", onClick: onCancel, isDisabled: isLoading }, { children: t("Cancel") })), jsxRuntime.jsx(Button$1, __assign$1({ colorScheme: "primary", onClick: handleNextClick, isLoading: isLoading, type: "submit" }, { children: t("Continue") }))] }))] }) })));
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

  var ReactPropTypesSecret = ReactPropTypesSecret_1;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */



  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error(
        'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
        'Use PropTypes.checkPropTypes() to call them. ' +
        'Read more at http://fb.me/use-check-prop-types'
      );
      err.name = 'Invariant Violation';
      throw err;
    }  shim.isRequired = shim;
    function getShim() {
      return shim;
    }  // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bigint: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,

      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,

      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };

    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var require$$0 = factoryWithThrowingShims;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var propTypes = createCommonjsModule(function (module) {
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = require$$0();
  }
  });

  var PropTypes = propTypes;

  var COMMON_MIME_TYPES = new Map([
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
      ['aac', 'audio/aac'],
      ['abw', 'application/x-abiword'],
      ['arc', 'application/x-freearc'],
      ['avif', 'image/avif'],
      ['avi', 'video/x-msvideo'],
      ['azw', 'application/vnd.amazon.ebook'],
      ['bin', 'application/octet-stream'],
      ['bmp', 'image/bmp'],
      ['bz', 'application/x-bzip'],
      ['bz2', 'application/x-bzip2'],
      ['cda', 'application/x-cdf'],
      ['csh', 'application/x-csh'],
      ['css', 'text/css'],
      ['csv', 'text/csv'],
      ['doc', 'application/msword'],
      ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
      ['eot', 'application/vnd.ms-fontobject'],
      ['epub', 'application/epub+zip'],
      ['gz', 'application/gzip'],
      ['gif', 'image/gif'],
      ['heic', 'image/heic'],
      ['heif', 'image/heif'],
      ['htm', 'text/html'],
      ['html', 'text/html'],
      ['ico', 'image/vnd.microsoft.icon'],
      ['ics', 'text/calendar'],
      ['jar', 'application/java-archive'],
      ['jpeg', 'image/jpeg'],
      ['jpg', 'image/jpeg'],
      ['js', 'text/javascript'],
      ['json', 'application/json'],
      ['jsonld', 'application/ld+json'],
      ['mid', 'audio/midi'],
      ['midi', 'audio/midi'],
      ['mjs', 'text/javascript'],
      ['mp3', 'audio/mpeg'],
      ['mp4', 'video/mp4'],
      ['mpeg', 'video/mpeg'],
      ['mpkg', 'application/vnd.apple.installer+xml'],
      ['odp', 'application/vnd.oasis.opendocument.presentation'],
      ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
      ['odt', 'application/vnd.oasis.opendocument.text'],
      ['oga', 'audio/ogg'],
      ['ogv', 'video/ogg'],
      ['ogx', 'application/ogg'],
      ['opus', 'audio/opus'],
      ['otf', 'font/otf'],
      ['png', 'image/png'],
      ['pdf', 'application/pdf'],
      ['php', 'application/x-httpd-php'],
      ['ppt', 'application/vnd.ms-powerpoint'],
      ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
      ['rar', 'application/vnd.rar'],
      ['rtf', 'application/rtf'],
      ['sh', 'application/x-sh'],
      ['svg', 'image/svg+xml'],
      ['swf', 'application/x-shockwave-flash'],
      ['tar', 'application/x-tar'],
      ['tif', 'image/tiff'],
      ['tiff', 'image/tiff'],
      ['ts', 'video/mp2t'],
      ['ttf', 'font/ttf'],
      ['txt', 'text/plain'],
      ['vsd', 'application/vnd.visio'],
      ['wav', 'audio/wav'],
      ['weba', 'audio/webm'],
      ['webm', 'video/webm'],
      ['webp', 'image/webp'],
      ['woff', 'font/woff'],
      ['woff2', 'font/woff2'],
      ['xhtml', 'application/xhtml+xml'],
      ['xls', 'application/vnd.ms-excel'],
      ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
      ['xml', 'application/xml'],
      ['xul', 'application/vnd.mozilla.xul+xml'],
      ['zip', 'application/zip'],
      ['7z', 'application/x-7z-compressed'],
      // Others
      ['mkv', 'video/x-matroska'],
      ['mov', 'video/quicktime'],
      ['msg', 'application/vnd.ms-outlook']
  ]);
  function toFileWithPath(file, path) {
      var f = withMimeType(file);
      if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
          var webkitRelativePath = file.webkitRelativePath;
          Object.defineProperty(f, 'path', {
              value: typeof path === 'string'
                  ? path
                  // If <input webkitdirectory> is set,
                  // the File will have a {webkitRelativePath} property
                  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                  : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                      ? webkitRelativePath
                      : file.name,
              writable: false,
              configurable: false,
              enumerable: true
          });
      }
      return f;
  }
  function withMimeType(file) {
      var name = file.name;
      var hasExtension = name && name.lastIndexOf('.') !== -1;
      if (hasExtension && !file.type) {
          var ext = name.split('.')
              .pop().toLowerCase();
          var type = COMMON_MIME_TYPES.get(ext);
          if (type) {
              Object.defineProperty(file, 'type', {
                  value: type,
                  writable: false,
                  configurable: false,
                  enumerable: true
              });
          }
      }
      return file;
  }

  var FILES_TO_IGNORE = [
      // Thumbnail cache files for macOS and Windows
      '.DS_Store',
      'Thumbs.db' // Windows
  ];
  /**
   * Convert a DragEvent's DataTrasfer object to a list of File objects
   * NOTE: If some of the items are folders,
   * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
   *
   * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
   * and a list of File objects will be returned.
   *
   * @param evt
   */
  function fromEvent(evt) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                  return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
              }
              else if (isChangeEvt(evt)) {
                  return [2 /*return*/, getInputFiles(evt)];
              }
              else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                  return [2 /*return*/, getFsHandleFiles(evt)];
              }
              return [2 /*return*/, []];
          });
      });
  }
  function isDataTransfer(value) {
      return isObject(value);
  }
  function isChangeEvt(value) {
      return isObject(value) && isObject(value.target);
  }
  function isObject(v) {
      return typeof v === 'object' && v !== null;
  }
  function getInputFiles(evt) {
      return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
  }
  // Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
  function getFsHandleFiles(handles) {
      return __awaiter(this, void 0, void 0, function () {
          var files;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                  case 1:
                      files = _a.sent();
                      return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
              }
          });
      });
  }
  function getDataTransferFiles(dt, type) {
      return __awaiter(this, void 0, void 0, function () {
          var items, files;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0:
                      if (!dt.items) return [3 /*break*/, 2];
                      items = fromList(dt.items)
                          .filter(function (item) { return item.kind === 'file'; });
                      // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                      // only 'dragstart' and 'drop' has access to the data (source node)
                      if (type !== 'drop') {
                          return [2 /*return*/, items];
                      }
                      return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                  case 1:
                      files = _a.sent();
                      return [2 /*return*/, noIgnoredFiles(flatten(files))];
                  case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                          .map(function (file) { return toFileWithPath(file); }))];
              }
          });
      });
  }
  function noIgnoredFiles(files) {
      return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
  }
  // IE11 does not support Array.from()
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
  // https://developer.mozilla.org/en-US/docs/Web/API/FileList
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
  function fromList(items) {
      if (items === null) {
          return [];
      }
      var files = [];
      // tslint:disable: prefer-for-of
      for (var i = 0; i < items.length; i++) {
          var file = items[i];
          files.push(file);
      }
      return files;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
  function toFilePromises(item) {
      if (typeof item.webkitGetAsEntry !== 'function') {
          return fromDataTransferItem(item);
      }
      var entry = item.webkitGetAsEntry();
      // Safari supports dropping an image node from a different window and can be retrieved using
      // the DataTransferItem.getAsFile() API
      // NOTE: FileSystemEntry.file() throws if trying to get the file
      if (entry && entry.isDirectory) {
          return fromDirEntry(entry);
      }
      return fromDataTransferItem(item);
  }
  function flatten(items) {
      return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
  }
  function fromDataTransferItem(item) {
      var file = item.getAsFile();
      if (!file) {
          return Promise.reject("".concat(item, " is not a File"));
      }
      var fwp = toFileWithPath(file);
      return Promise.resolve(fwp);
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
  function fromEntry(entry) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
          });
      });
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
  function fromDirEntry(entry) {
      var reader = entry.createReader();
      return new Promise(function (resolve, reject) {
          var entries = [];
          function readEntries() {
              var _this = this;
              // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
              // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
              reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                  var files, err_1, items;
                  return __generator(this, function (_a) {
                      switch (_a.label) {
                          case 0:
                              if (!!batch.length) return [3 /*break*/, 5];
                              _a.label = 1;
                          case 1:
                              _a.trys.push([1, 3, , 4]);
                              return [4 /*yield*/, Promise.all(entries)];
                          case 2:
                              files = _a.sent();
                              resolve(files);
                              return [3 /*break*/, 4];
                          case 3:
                              err_1 = _a.sent();
                              reject(err_1);
                              return [3 /*break*/, 4];
                          case 4: return [3 /*break*/, 6];
                          case 5:
                              items = Promise.all(batch.map(fromEntry));
                              entries.push(items);
                              // Continue reading
                              readEntries();
                              _a.label = 6;
                          case 6: return [2 /*return*/];
                      }
                  });
              }); }, function (err) {
                  reject(err);
              });
          }
          readEntries();
      });
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
  function fromFileEntry(entry) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              return [2 /*return*/, new Promise(function (resolve, reject) {
                      entry.file(function (file) {
                          var fwp = toFileWithPath(file, entry.fullPath);
                          resolve(fwp);
                      }, function (err) {
                          reject(err);
                      });
                  })];
          });
      });
  }

  var _default = function (file, acceptedFiles) {
    if (file && acceptedFiles) {
      var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
      var fileName = file.name || '';
      var mimeType = (file.type || '').toLowerCase();
      var baseMimeType = mimeType.replace(/\/.*$/, '');
      return acceptedFilesArray.some(function (type) {
        var validType = type.trim().toLowerCase();

        if (validType.charAt(0) === '.') {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith('/*')) {
          // This is something like a image/* mime type
          return baseMimeType === validType.replace(/\/.*$/, '');
        }

        return mimeType === validType;
      });
    }

    return true;
  };

  var accepts = _default;

  function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

  function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

  function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

  function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

  var FILE_INVALID_TYPE = "file-invalid-type";
  var FILE_TOO_LARGE = "file-too-large";
  var FILE_TOO_SMALL = "file-too-small";
  var TOO_MANY_FILES = "too-many-files";

  var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
      code: FILE_INVALID_TYPE,
      message: "File type must be ".concat(messageSuffix)
    };
  };
  var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
    return {
      code: FILE_TOO_LARGE,
      message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
  };
  var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
    return {
      code: FILE_TOO_SMALL,
      message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
  };
  var TOO_MANY_FILES_REJECTION = {
    code: TOO_MANY_FILES,
    message: "Too many files"
  }; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
  // that MIME type will always be accepted

  function fileAccepted(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept);
    return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
  }
  function fileMatchSize(file, minSize, maxSize) {
    if (isDefined(file.size)) {
      if (isDefined(minSize) && isDefined(maxSize)) {
        if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
        if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
      } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
    }

    return [true, null];
  }

  function isDefined(value) {
    return value !== undefined && value !== null;
  }
  /**
   *
   * @param {object} options
   * @param {File[]} options.files
   * @param {string|string[]} [options.accept]
   * @param {number} [options.minSize]
   * @param {number} [options.maxSize]
   * @param {boolean} [options.multiple]
   * @param {number} [options.maxFiles]
   * @param {(f: File) => FileError|FileError[]|null} [options.validator]
   * @returns
   */


  function allFilesAccepted(_ref) {
    var files = _ref.files,
        accept = _ref.accept,
        minSize = _ref.minSize,
        maxSize = _ref.maxSize,
        multiple = _ref.multiple,
        maxFiles = _ref.maxFiles,
        validator = _ref.validator;

    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
      return false;
    }

    return files.every(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
          accepted = _fileAccepted2[0];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
          sizeMatch = _fileMatchSize2[0];

      var customErrors = validator ? validator(file) : null;
      return accepted && sizeMatch && !customErrors;
    });
  } // React's synthetic events has event.isPropagationStopped,
  // but to remain compatibility with other libs (Preact) fall back
  // to check event.cancelBubble

  function isPropagationStopped(event) {
    if (typeof event.isPropagationStopped === "function") {
      return event.isPropagationStopped();
    } else if (typeof event.cancelBubble !== "undefined") {
      return event.cancelBubble;
    }

    return false;
  }
  function isEvtWithFiles(event) {
    if (!event.dataTransfer) {
      return !!event.target && !!event.target.files;
    } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


    return Array.prototype.some.call(event.dataTransfer.types, function (type) {
      return type === "Files" || type === "application/x-moz-file";
    });
  }

  function onDocumentDragOver(event) {
    event.preventDefault();
  }

  function isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
  }

  function isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
  }

  function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
  }
  /**
   * This is intended to be used to compose event handlers
   * They are executed in order until one of them calls `event.isPropagationStopped()`.
   * Note that the check is done on the first invoke too,
   * meaning that if propagation was stopped before invoking the fns,
   * no handlers will be executed.
   *
   * @param {Function} fns the event hanlder functions
   * @return {Function} the event handler to add to an element
   */

  function composeEventHandlers() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return function (event) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return fns.some(function (fn) {
        if (!isPropagationStopped(event) && fn) {
          fn.apply(void 0, [event].concat(args));
        }

        return isPropagationStopped(event);
      });
    };
  }
  /**
   * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
   * is supported by the browser.
   * @returns {boolean}
   */

  function canUseFileSystemAccessAPI() {
    return "showOpenFilePicker" in window;
  }
  /**
   * Convert the `{accept}` dropzone prop to the
   * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
   *
   * @param {AcceptProp} accept
   * @returns {{accept: string[]}[]}
   */

  function pickerOptionsFromAccept(accept) {
    if (isDefined(accept)) {
      var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
        var _ref3 = _slicedToArray$1(_ref2, 2),
            mimeType = _ref3[0],
            ext = _ref3[1];

        var ok = true;

        if (!isMIMEType(mimeType)) {
          console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
          ok = false;
        }

        if (!Array.isArray(ext) || !ext.every(isExt)) {
          console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
          ok = false;
        }

        return ok;
      }).reduce(function (agg, _ref4) {
        var _ref5 = _slicedToArray$1(_ref4, 2),
            mimeType = _ref5[0],
            ext = _ref5[1];

        return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
      }, {});
      return [{
        // description is required due to https://crbug.com/1264708
        description: "Files",
        accept: acceptForPicker
      }];
    }

    return accept;
  }
  /**
   * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
   * @param {AcceptProp} accept
   * @returns {string}
   */

  function acceptPropAsAcceptAttr(accept) {
    if (isDefined(accept)) {
      return Object.entries(accept).reduce(function (a, _ref6) {
        var _ref7 = _slicedToArray$1(_ref6, 2),
            mimeType = _ref7[0],
            ext = _ref7[1];

        return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
      }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
      .filter(function (v) {
        return isMIMEType(v) || isExt(v);
      }).join(",");
    }

    return undefined;
  }
  /**
   * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
   * @param {any} v
   * @returns {boolean} True if v is an abort exception.
   */

  function isAbort(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
  }
  /**
   * Check if v is a security error.
   *
   * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
   * @param {any} v
   * @returns {boolean} True if v is a security error.
   */

  function isSecurityError(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
  }
  /**
   * Check if v is a MIME type string.
   *
   * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
   *
   * @param {string} v
   */

  function isMIMEType(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
  }
  /**
   * Check if v is a file extension.
   * @param {string} v
   */

  function isExt(v) {
    return /^.*\.[\w]+$/.test(v);
  }
  /**
   * @typedef {Object.<string, string[]>} AcceptProp
   */

  /**
   * @typedef {object} FileError
   * @property {string} message
   * @property {ErrorCode|string} code
   */

  /**
   * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
   */

  var _excluded = ["children"],
      _excluded2 = ["open"],
      _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
      _excluded4 = ["refKey", "onChange", "onClick"];

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
  /**
   * Convenience wrapper component for the `useDropzone` hook
   *
   * ```jsx
   * <Dropzone>
   *   {({getRootProps, getInputProps}) => (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag 'n' drop some files here, or click to select files</p>
   *     </div>
   *   )}
   * </Dropzone>
   * ```
   */

  var Dropzone = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
    var children = _ref.children,
        params = _objectWithoutProperties(_ref, _excluded);

    var _useDropzone = useDropzone(params),
        open = _useDropzone.open,
        props = _objectWithoutProperties(_useDropzone, _excluded2);

    react.useImperativeHandle(ref, function () {
      return {
        open: open
      };
    }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

    return /*#__PURE__*/react.createElement(react.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
      open: open
    })));
  });
  Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

  var defaultProps = {
    disabled: false,
    getFilesFromEvent: fromEvent,
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
  };
  Dropzone.defaultProps = defaultProps;
  Dropzone.propTypes = {
    /**
     * Render function that exposes the dropzone state and prop getter fns
     *
     * @param {object} params
     * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
     * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
     * @param {Function} params.open Open the native file selection dialog
     * @param {boolean} params.isFocused Dropzone area is in focus
     * @param {boolean} params.isFileDialogActive File dialog is opened
     * @param {boolean} params.isDragActive Active drag is in progress
     * @param {boolean} params.isDragAccept Dragged files are accepted
     * @param {boolean} params.isDragReject Some dragged files are rejected
     * @param {File[]} params.acceptedFiles Accepted files
     * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
     */
    children: PropTypes.func,

    /**
     * Set accepted file types.
     * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
     * Keep in mind that mime type determination is not reliable across platforms. CSV files,
     * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
     * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
     */
    accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),

    /**
     * Allow drag 'n' drop (or selection from the file dialog) of multiple files
     */
    multiple: PropTypes.bool,

    /**
     * If false, allow dropped items to take over the current browser window
     */
    preventDropOnDocument: PropTypes.bool,

    /**
     * If true, disables click to open the native file selection dialog
     */
    noClick: PropTypes.bool,

    /**
     * If true, disables SPACE/ENTER to open the native file selection dialog.
     * Note that it also stops tracking the focus state.
     */
    noKeyboard: PropTypes.bool,

    /**
     * If true, disables drag 'n' drop
     */
    noDrag: PropTypes.bool,

    /**
     * If true, stops drag event propagation to parents
     */
    noDragEventsBubbling: PropTypes.bool,

    /**
     * Minimum file size (in bytes)
     */
    minSize: PropTypes.number,

    /**
     * Maximum file size (in bytes)
     */
    maxSize: PropTypes.number,

    /**
     * Maximum accepted number of files
     * The default value is 0 which means there is no limitation to how many files are accepted.
     */
    maxFiles: PropTypes.number,

    /**
     * Enable/disable the dropzone
     */
    disabled: PropTypes.bool,

    /**
     * Use this to provide a custom file aggregator
     *
     * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
     */
    getFilesFromEvent: PropTypes.func,

    /**
     * Cb for when closing the file dialog with no selection
     */
    onFileDialogCancel: PropTypes.func,

    /**
     * Cb for when opening the file dialog
     */
    onFileDialogOpen: PropTypes.func,

    /**
     * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
     * to open the file picker instead of using an `<input type="file">` click event.
     */
    useFsAccessApi: PropTypes.bool,

    /**
     * Set to true to focus the root element on render
     */
    autoFocus: PropTypes.bool,

    /**
     * Cb for when the `dragenter` event occurs.
     *
     * @param {DragEvent} event
     */
    onDragEnter: PropTypes.func,

    /**
     * Cb for when the `dragleave` event occurs
     *
     * @param {DragEvent} event
     */
    onDragLeave: PropTypes.func,

    /**
     * Cb for when the `dragover` event occurs
     *
     * @param {DragEvent} event
     */
    onDragOver: PropTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
     *
     * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
     * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
     * If `multiple` is set to false and additional files are dropped,
     * all files besides the first will be rejected.
     * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
     *
     * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
     * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
     *
     * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
     * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
     *
     * ```js
     * function onDrop(acceptedFiles) {
     *   const req = request.post('/upload')
     *   acceptedFiles.forEach(file => {
     *     req.attach(file.name, file)
     *   })
     *   req.end(callback)
     * }
     * ```
     *
     * @param {File[]} acceptedFiles
     * @param {FileRejection[]} fileRejections
     * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
     */
    onDrop: PropTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that if no files are accepted, this callback is not invoked.
     *
     * @param {File[]} files
     * @param {(DragEvent|Event)} event
     */
    onDropAccepted: PropTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that if no files are rejected, this callback is not invoked.
     *
     * @param {FileRejection[]} fileRejections
     * @param {(DragEvent|Event)} event
     */
    onDropRejected: PropTypes.func,

    /**
     * Cb for when there's some error from any of the promises.
     *
     * @param {Error} error
     */
    onError: PropTypes.func,

    /**
     * Custom validation function. It must return null if there's no errors.
     * @param {File} file
     * @returns {FileError|FileError[]|null}
     */
    validator: PropTypes.func
  };
  /**
   * A function that is invoked for the `dragenter`,
   * `dragover` and `dragleave` events.
   * It is not invoked if the items are not files (such as link, text, etc.).
   *
   * @callback dragCb
   * @param {DragEvent} event
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   * It is not invoked if the items are not files (such as link, text, etc.).
   *
   * @callback dropCb
   * @param {File[]} acceptedFiles List of accepted files
   * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   * It is not invoked if the items are files (such as link, text, etc.).
   *
   * @callback dropAcceptedCb
   * @param {File[]} files List of accepted files that meet the given criteria
   * (`accept`, `multiple`, `minSize`, `maxSize`)
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   *
   * @callback dropRejectedCb
   * @param {File[]} files List of rejected files that do not meet the given criteria
   * (`accept`, `multiple`, `minSize`, `maxSize`)
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is used aggregate files,
   * in a asynchronous fashion, from drag or input change events.
   *
   * @callback getFilesFromEvent
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   * @returns {(File[]|Promise<File[]>)}
   */

  /**
   * An object with the current dropzone state.
   *
   * @typedef {object} DropzoneState
   * @property {boolean} isFocused Dropzone area is in focus
   * @property {boolean} isFileDialogActive File dialog is opened
   * @property {boolean} isDragActive Active drag is in progress
   * @property {boolean} isDragAccept Dragged files are accepted
   * @property {boolean} isDragReject Some dragged files are rejected
   * @property {File[]} acceptedFiles Accepted files
   * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
   */

  /**
   * An object with the dropzone methods.
   *
   * @typedef {object} DropzoneMethods
   * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
   * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
   * @property {Function} open Open the native file selection dialog
   */

  var initialState$1 = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
  };
  /**
   * A React hook that creates a drag 'n' drop area.
   *
   * ```jsx
   * function MyDropzone(props) {
   *   const {getRootProps, getInputProps} = useDropzone({
   *     onDrop: acceptedFiles => {
   *       // do something with the File objects, e.g. upload to some server
   *     }
   *   });
   *   return (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag and drop some files here, or click to select files</p>
   *     </div>
   *   )
   * }
   * ```
   *
   * @function useDropzone
   *
   * @param {object} props
   * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
   * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
   * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
   * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
   * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
   * @param {number} [props.minSize=0] Minimum file size (in bytes)
   * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
   * @param {boolean} [props.disabled=false] Enable/disable the dropzone
   * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
   * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
   * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   * @param {boolean} autoFocus Set to true to auto focus the root element.
   * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
   * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
   * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
   * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
   * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   * @param {dropAcceptedCb} [props.onDropAccepted]
   * @param {dropRejectedCb} [props.onDropRejected]
   * @param {(error: Error) => void} [props.onError]
   *
   * @returns {DropzoneState & DropzoneMethods}
   */

  function useDropzone() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
        accept = _defaultProps$props.accept,
        disabled = _defaultProps$props.disabled,
        getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
        maxSize = _defaultProps$props.maxSize,
        minSize = _defaultProps$props.minSize,
        multiple = _defaultProps$props.multiple,
        maxFiles = _defaultProps$props.maxFiles,
        onDragEnter = _defaultProps$props.onDragEnter,
        onDragLeave = _defaultProps$props.onDragLeave,
        onDragOver = _defaultProps$props.onDragOver,
        onDrop = _defaultProps$props.onDrop,
        onDropAccepted = _defaultProps$props.onDropAccepted,
        onDropRejected = _defaultProps$props.onDropRejected,
        onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
        onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
        useFsAccessApi = _defaultProps$props.useFsAccessApi,
        autoFocus = _defaultProps$props.autoFocus,
        preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
        noClick = _defaultProps$props.noClick,
        noKeyboard = _defaultProps$props.noKeyboard,
        noDrag = _defaultProps$props.noDrag,
        noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
        onError = _defaultProps$props.onError,
        validator = _defaultProps$props.validator;

    var acceptAttr = react.useMemo(function () {
      return acceptPropAsAcceptAttr(accept);
    }, [accept]);
    var pickerTypes = react.useMemo(function () {
      return pickerOptionsFromAccept(accept);
    }, [accept]);
    var onFileDialogOpenCb = react.useMemo(function () {
      return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$1;
    }, [onFileDialogOpen]);
    var onFileDialogCancelCb = react.useMemo(function () {
      return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$1;
    }, [onFileDialogCancel]);
    /**
     * @constant
     * @type {React.MutableRefObject<HTMLElement>}
     */

    var rootRef = react.useRef(null);
    var inputRef = react.useRef(null);

    var _useReducer = react.useReducer(reducer, initialState$1),
        _useReducer2 = _slicedToArray(_useReducer, 2),
        state = _useReducer2[0],
        dispatch = _useReducer2[1];

    var isFocused = state.isFocused,
        isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = react.useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

    var onWindowFocus = function onWindowFocus() {
      // Execute the timeout only if the file dialog is opened in the browser
      if (!fsAccessApiWorksRef.current && isFileDialogActive) {
        setTimeout(function () {
          if (inputRef.current) {
            var files = inputRef.current.files;

            if (!files.length) {
              dispatch({
                type: "closeDialog"
              });
              onFileDialogCancelCb();
            }
          }
        }, 300);
      }
    };

    react.useEffect(function () {
      window.addEventListener("focus", onWindowFocus, false);
      return function () {
        window.removeEventListener("focus", onWindowFocus, false);
      };
    }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
    var dragTargetsRef = react.useRef([]);

    var onDocumentDrop = function onDocumentDrop(event) {
      if (rootRef.current && rootRef.current.contains(event.target)) {
        // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }

      event.preventDefault();
      dragTargetsRef.current = [];
    };

    react.useEffect(function () {
      if (preventDropOnDocument) {
        document.addEventListener("dragover", onDocumentDragOver, false);
        document.addEventListener("drop", onDocumentDrop, false);
      }

      return function () {
        if (preventDropOnDocument) {
          document.removeEventListener("dragover", onDocumentDragOver);
          document.removeEventListener("drop", onDocumentDrop);
        }
      };
    }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

    react.useEffect(function () {
      if (!disabled && autoFocus && rootRef.current) {
        rootRef.current.focus();
      }

      return function () {};
    }, [rootRef, autoFocus, disabled]);
    var onErrCb = react.useCallback(function (e) {
      if (onError) {
        onError(e);
      } else {
        // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
      }
    }, [onError]);
    var onDragEnterCb = react.useCallback(function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event)).then(function (files) {
          if (isPropagationStopped(event) && !noDragEventsBubbling) {
            return;
          }

          var fileCount = files.length;
          var isDragAccept = fileCount > 0 && allFilesAccepted({
            files: files,
            accept: acceptAttr,
            minSize: minSize,
            maxSize: maxSize,
            multiple: multiple,
            maxFiles: maxFiles,
            validator: validator
          });
          var isDragReject = fileCount > 0 && !isDragAccept;
          dispatch({
            isDragAccept: isDragAccept,
            isDragReject: isDragReject,
            isDragActive: true,
            type: "setDraggedFiles"
          });

          if (onDragEnter) {
            onDragEnter(event);
          }
        }).catch(function (e) {
          return onErrCb(e);
        });
      }
    }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
    var onDragOverCb = react.useCallback(function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event);
      var hasFiles = isEvtWithFiles(event);

      if (hasFiles && event.dataTransfer) {
        try {
          event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        /* eslint-disable-line no-empty */

      }

      if (hasFiles && onDragOver) {
        onDragOver(event);
      }

      return false;
    }, [onDragOver, noDragEventsBubbling]);
    var onDragLeaveCb = react.useCallback(function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event); // Only deactivate once the dropzone and all children have been left

      var targets = dragTargetsRef.current.filter(function (target) {
        return rootRef.current && rootRef.current.contains(target);
      }); // Make sure to remove a target present multiple times only once
      // (Firefox may fire dragenter/dragleave multiple times on the same element)

      var targetIdx = targets.indexOf(event.target);

      if (targetIdx !== -1) {
        targets.splice(targetIdx, 1);
      }

      dragTargetsRef.current = targets;

      if (targets.length > 0) {
        return;
      }

      dispatch({
        type: "setDraggedFiles",
        isDragActive: false,
        isDragAccept: false,
        isDragReject: false
      });

      if (isEvtWithFiles(event) && onDragLeave) {
        onDragLeave(event);
      }
    }, [rootRef, onDragLeave, noDragEventsBubbling]);
    var setFiles = react.useCallback(function (files, event) {
      var acceptedFiles = [];
      var fileRejections = [];
      files.forEach(function (file) {
        var _fileAccepted = fileAccepted(file, acceptAttr),
            _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
            accepted = _fileAccepted2[0],
            acceptError = _fileAccepted2[1];

        var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
            _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
            sizeMatch = _fileMatchSize2[0],
            sizeError = _fileMatchSize2[1];

        var customErrors = validator ? validator(file) : null;

        if (accepted && sizeMatch && !customErrors) {
          acceptedFiles.push(file);
        } else {
          var errors = [acceptError, sizeError];

          if (customErrors) {
            errors = errors.concat(customErrors);
          }

          fileRejections.push({
            file: file,
            errors: errors.filter(function (e) {
              return e;
            })
          });
        }
      });

      if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
        // Reject everything and empty accepted files
        acceptedFiles.forEach(function (file) {
          fileRejections.push({
            file: file,
            errors: [TOO_MANY_FILES_REJECTION]
          });
        });
        acceptedFiles.splice(0);
      }

      dispatch({
        acceptedFiles: acceptedFiles,
        fileRejections: fileRejections,
        type: "setFiles"
      });

      if (onDrop) {
        onDrop(acceptedFiles, fileRejections, event);
      }

      if (fileRejections.length > 0 && onDropRejected) {
        onDropRejected(fileRejections, event);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted(acceptedFiles, event);
      }
    }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
    var onDropCb = react.useCallback(function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [];

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event)).then(function (files) {
          if (isPropagationStopped(event) && !noDragEventsBubbling) {
            return;
          }

          setFiles(files, event);
        }).catch(function (e) {
          return onErrCb(e);
        });
      }

      dispatch({
        type: "reset"
      });
    }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

    var openFileDialog = react.useCallback(function () {
      // No point to use FS access APIs if context is not secure
      // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
      if (fsAccessApiWorksRef.current) {
        dispatch({
          type: "openDialog"
        });
        onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

        var opts = {
          multiple: multiple,
          types: pickerTypes
        };
        window.showOpenFilePicker(opts).then(function (handles) {
          return getFilesFromEvent(handles);
        }).then(function (files) {
          setFiles(files, null);
          dispatch({
            type: "closeDialog"
          });
        }).catch(function (e) {
          // AbortError means the user canceled
          if (isAbort(e)) {
            onFileDialogCancelCb(e);
            dispatch({
              type: "closeDialog"
            });
          } else if (isSecurityError(e)) {
            fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
            // Try using the input

            if (inputRef.current) {
              inputRef.current.value = null;
              inputRef.current.click();
            } else {
              onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
            }
          } else {
            onErrCb(e);
          }
        });
        return;
      }

      if (inputRef.current) {
        dispatch({
          type: "openDialog"
        });
        onFileDialogOpenCb();
        inputRef.current.value = null;
        inputRef.current.click();
      }
    }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

    var onKeyDownCb = react.useCallback(function (event) {
      // Ignore keyboard events bubbling up the DOM tree
      if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
        return;
      }

      if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        openFileDialog();
      }
    }, [rootRef, openFileDialog]); // Update focus state for the dropzone

    var onFocusCb = react.useCallback(function () {
      dispatch({
        type: "focus"
      });
    }, []);
    var onBlurCb = react.useCallback(function () {
      dispatch({
        type: "blur"
      });
    }, []); // Cb to open the file dialog when click occurs on the dropzone

    var onClickCb = react.useCallback(function () {
      if (noClick) {
        return;
      } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
      // to ensure React can handle state changes
      // See: https://github.com/react-dropzone/react-dropzone/issues/450


      if (isIeOrEdge()) {
        setTimeout(openFileDialog, 0);
      } else {
        openFileDialog();
      }
    }, [noClick, openFileDialog]);

    var composeHandler = function composeHandler(fn) {
      return disabled ? null : fn;
    };

    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
      return noKeyboard ? null : composeHandler(fn);
    };

    var composeDragHandler = function composeDragHandler(fn) {
      return noDrag ? null : composeHandler(fn);
    };

    var stopPropagation = function stopPropagation(event) {
      if (noDragEventsBubbling) {
        event.stopPropagation();
      }
    };

    var getRootProps = react.useMemo(function () {
      return function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$refKey = _ref2.refKey,
            refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
            role = _ref2.role,
            onKeyDown = _ref2.onKeyDown,
            onFocus = _ref2.onFocus,
            onBlur = _ref2.onBlur,
            onClick = _ref2.onClick,
            onDragEnter = _ref2.onDragEnter,
            onDragOver = _ref2.onDragOver,
            onDragLeave = _ref2.onDragLeave,
            onDrop = _ref2.onDrop,
            rest = _objectWithoutProperties(_ref2, _excluded3);

        return _objectSpread(_objectSpread(_defineProperty({
          onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
          onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
          onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
          onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
          onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
          onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
          onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
          onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
          role: typeof role === "string" && role !== "" ? role : "presentation"
        }, refKey, rootRef), !disabled && !noKeyboard ? {
          tabIndex: 0
        } : {}), rest);
      };
    }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
    var onInputElementClick = react.useCallback(function (event) {
      event.stopPropagation();
    }, []);
    var getInputProps = react.useMemo(function () {
      return function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$refKey = _ref3.refKey,
            refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
            onChange = _ref3.onChange,
            onClick = _ref3.onClick,
            rest = _objectWithoutProperties(_ref3, _excluded4);

        var inputProps = _defineProperty({
          accept: acceptAttr,
          multiple: multiple,
          type: "file",
          style: {
            display: "none"
          },
          onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
          onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
          tabIndex: -1
        }, refKey, inputRef);

        return _objectSpread(_objectSpread({}, inputProps), rest);
      };
    }, [inputRef, accept, multiple, onDropCb, disabled]);
    return _objectSpread(_objectSpread({}, state), {}, {
      isFocused: isFocused && !disabled,
      getRootProps: getRootProps,
      getInputProps: getInputProps,
      rootRef: rootRef,
      inputRef: inputRef,
      open: composeHandler(openFileDialog)
    });
  }
  /**
   * @param {DropzoneState} state
   * @param {{type: string} & DropzoneState} action
   * @returns {DropzoneState}
   */

  function reducer(state, action) {
    /* istanbul ignore next */
    switch (action.type) {
      case "focus":
        return _objectSpread(_objectSpread({}, state), {}, {
          isFocused: true
        });

      case "blur":
        return _objectSpread(_objectSpread({}, state), {}, {
          isFocused: false
        });

      case "openDialog":
        return _objectSpread(_objectSpread({}, initialState$1), {}, {
          isFileDialogActive: true
        });

      case "closeDialog":
        return _objectSpread(_objectSpread({}, state), {}, {
          isFileDialogActive: false
        });

      case "setDraggedFiles":
        return _objectSpread(_objectSpread({}, state), {}, {
          isDragActive: action.isDragActive,
          isDragAccept: action.isDragAccept,
          isDragReject: action.isDragReject
        });

      case "setFiles":
        return _objectSpread(_objectSpread({}, state), {}, {
          acceptedFiles: action.acceptedFiles,
          fileRejections: action.fileRejections
        });

      case "reset":
        return _objectSpread({}, initialState$1);

      default:
        return state;
    }
  }

  function noop$1() {}

  var css = String.raw;
  var vhPolyfill = css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
  var CSSPolyfill = () => /* @__PURE__ */ jsxRuntime.jsx(Global, { styles: vhPolyfill });
  var CSSReset = ({ scope = "" }) => /* @__PURE__ */ jsxRuntime.jsx(
    Global,
    {
      styles: css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${vhPolyfill}
    `
    }
  );

  var [PortalManagerContextProvider, usePortalManager] = createContext$1({
    strict: false,
    name: "PortalManagerContext"
  });
  function PortalManager(props) {
    const { children, zIndex } = props;
    return /* @__PURE__ */ jsxRuntime.jsx(PortalManagerContextProvider, { value: { zIndex }, children });
  }
  PortalManager.displayName = "PortalManager";

  var [PortalContextProvider, usePortalContext] = createContext$1({
    strict: false,
    name: "PortalContext"
  });
  var PORTAL_CLASSNAME = "chakra-portal";
  var PORTAL_SELECTOR = `.chakra-portal`;
  var Container = (props) => /* @__PURE__ */ jsxRuntime.jsx(
    "div",
    {
      className: "chakra-portal-zIndex",
      style: {
        position: "absolute",
        zIndex: props.zIndex,
        top: 0,
        left: 0,
        right: 0
        // NB: Don't add `bottom: 0`, it makes the entire app unusable
        // @see https://github.com/chakra-ui/chakra-ui/issues/3201
      },
      children: props.children
    }
  );
  var DefaultPortal = (props) => {
    const { appendToParentPortal, children } = props;
    const [tempNode, setTempNode] = react.useState(null);
    const portal = react.useRef(null);
    const [, forceUpdate] = react.useState({});
    react.useEffect(() => forceUpdate({}), []);
    const parentPortal = usePortalContext();
    const manager = usePortalManager();
    useSafeLayoutEffect(() => {
      if (!tempNode)
        return;
      const doc = tempNode.ownerDocument;
      const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
      if (!host)
        return;
      portal.current = doc.createElement("div");
      portal.current.className = PORTAL_CLASSNAME;
      host.appendChild(portal.current);
      forceUpdate({});
      const portalNode = portal.current;
      return () => {
        if (host.contains(portalNode)) {
          host.removeChild(portalNode);
        }
      };
    }, [tempNode]);
    const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ jsxRuntime.jsx(Container, { zIndex: manager == null ? void 0 : manager.zIndex, children }) : children;
    return portal.current ? reactDom.createPortal(
      /* @__PURE__ */ jsxRuntime.jsx(PortalContextProvider, { value: portal.current, children: _children }),
      portal.current
    ) : /* @__PURE__ */ jsxRuntime.jsx(
      "span",
      {
        ref: (el) => {
          if (el)
            setTempNode(el);
        }
      }
    );
  };
  var ContainerPortal = (props) => {
    const { children, containerRef, appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
    const portal = react.useMemo(() => {
      const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
      if (node)
        node.className = PORTAL_CLASSNAME;
      return node;
    }, [containerEl]);
    const [, forceUpdate] = react.useState({});
    useSafeLayoutEffect(() => forceUpdate({}), []);
    useSafeLayoutEffect(() => {
      if (!portal || !host)
        return;
      host.appendChild(portal);
      return () => {
        host.removeChild(portal);
      };
    }, [portal, host]);
    if (host && portal) {
      return reactDom.createPortal(
        /* @__PURE__ */ jsxRuntime.jsx(PortalContextProvider, { value: appendToParentPortal ? portal : null, children }),
        portal
      );
    }
    return null;
  };
  function Portal(props) {
    const portalProps = {
      appendToParentPortal: true,
      ...props
    };
    const { containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ jsxRuntime.jsx(ContainerPortal, { containerRef, ...rest }) : /* @__PURE__ */ jsxRuntime.jsx(DefaultPortal, { ...rest });
  }
  Portal.className = PORTAL_CLASSNAME;
  Portal.selector = PORTAL_SELECTOR;
  Portal.displayName = "Portal";

  var EnvironmentContext = react.createContext({
    getDocument() {
      return document;
    },
    getWindow() {
      return window;
    }
  });
  EnvironmentContext.displayName = "EnvironmentContext";
  function EnvironmentProvider(props) {
    const { children, environment: environmentProp, disabled } = props;
    const ref = react.useRef(null);
    const context = react.useMemo(() => {
      if (environmentProp)
        return environmentProp;
      return {
        getDocument: () => {
          var _a, _b;
          return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
        },
        getWindow: () => {
          var _a, _b;
          return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
        }
      };
    }, [environmentProp]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ jsxRuntime.jsxs(EnvironmentContext.Provider, { value: context, children: [
      children,
      showSpan && /* @__PURE__ */ jsxRuntime.jsx("span", { id: "__chakra_env", hidden: true, ref })
    ] });
  }
  EnvironmentProvider.displayName = "EnvironmentProvider";

  var ChakraProvider$1 = (props) => {
    const {
      children,
      colorModeManager,
      portalZIndex,
      resetScope,
      resetCSS = true,
      theme = {},
      environment,
      cssVarsRoot,
      disableEnvironment,
      disableGlobalStyle
    } = props;
    const _children = /* @__PURE__ */ jsxRuntime.jsx(
      EnvironmentProvider,
      {
        environment,
        disabled: disableEnvironment,
        children
      }
    );
    return /* @__PURE__ */ jsxRuntime.jsx(ThemeProvider$1, { theme, cssVarsRoot, children: /* @__PURE__ */ jsxRuntime.jsxs(
      ColorModeProvider,
      {
        colorModeManager,
        options: theme.config,
        children: [
          resetCSS ? /* @__PURE__ */ jsxRuntime.jsx(CSSReset, { scope: resetScope }) : /* @__PURE__ */ jsxRuntime.jsx(CSSPolyfill, {}),
          !disableGlobalStyle && /* @__PURE__ */ jsxRuntime.jsx(GlobalStyle, {}),
          portalZIndex ? /* @__PURE__ */ jsxRuntime.jsx(PortalManager, { zIndex: portalZIndex, children: _children }) : _children
        ]
      }
    ) });
  };

  // src/toast.utils.ts
  var findById = (arr, id) => arr.find((toast) => toast.id === id);
  function findToast(toasts, id) {
    const position = getToastPosition(toasts, id);
    const index = position ? toasts[position].findIndex((toast) => toast.id === id) : -1;
    return {
      position,
      index
    };
  }
  function getToastPosition(toasts, id) {
    for (const [position, values] of Object.entries(toasts)) {
      if (findById(values, id)) {
        return position;
      }
    }
  }
  function getToastStyle(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty)
      alignItems = "flex-end";
    if (isLefty)
      alignItems = "flex-start";
    return {
      display: "flex",
      flexDirection: "column",
      alignItems
    };
  }
  function getToastListStyle(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
      position: "fixed",
      zIndex: "var(--toast-z-index, 5500)",
      pointerEvents: "none",
      display: "flex",
      flexDirection: "column",
      margin,
      top,
      bottom,
      right,
      left
    };
  }

  function useCallbackRef(callback, deps = []) {
    const callbackRef = react.useRef(callback);
    react.useEffect(() => {
      callbackRef.current = callback;
    });
    return react.useCallback((...args) => {
      var _a;
      return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
    }, deps);
  }

  function useTimeout(callback, delay) {
    const fn = useCallbackRef(callback);
    react.useEffect(() => {
      if (delay == null)
        return void 0;
      let timeoutId = null;
      timeoutId = window.setTimeout(() => {
        fn();
      }, delay);
      return () => {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
      };
    }, [delay, fn]);
  }

  function useUpdateEffect(callback, deps) {
    const renderCycleRef = react.useRef(false);
    const effectCycleRef = react.useRef(false);
    react.useEffect(() => {
      const mounted = renderCycleRef.current;
      const run = mounted && effectCycleRef.current;
      if (run) {
        return callback();
      }
      effectCycleRef.current = true;
    }, deps);
    react.useEffect(() => {
      renderCycleRef.current = true;
      return () => {
        renderCycleRef.current = false;
      };
    }, []);
  }

  /**
   * @public
   */
  const MotionConfigContext = react.createContext({
      transformPagePoint: (p) => p,
      isStatic: false,
      reducedMotion: "never",
  });

  const MotionContext = react.createContext({});

  /**
   * @public
   */
  const PresenceContext = react.createContext(null);

  const isBrowser = typeof document !== "undefined";

  const useIsomorphicLayoutEffect = isBrowser ? react.useLayoutEffect : react.useEffect;

  const LazyContext = react.createContext({ strict: false });

  /**
   * Convert camelCase to dash-case properties.
   */
  const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

  const optimizedAppearDataId = "framerAppearId";
  const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

  function useVisualElement(Component, visualState, props, createVisualElement) {
      const { visualElement: parent } = react.useContext(MotionContext);
      const lazyContext = react.useContext(LazyContext);
      const presenceContext = react.useContext(PresenceContext);
      const reducedMotionConfig = react.useContext(MotionConfigContext).reducedMotion;
      const visualElementRef = react.useRef();
      /**
       * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
       */
      createVisualElement = createVisualElement || lazyContext.renderer;
      if (!visualElementRef.current && createVisualElement) {
          visualElementRef.current = createVisualElement(Component, {
              visualState,
              parent,
              props,
              presenceContext,
              blockInitialAnimation: presenceContext
                  ? presenceContext.initial === false
                  : false,
              reducedMotionConfig,
          });
      }
      const visualElement = visualElementRef.current;
      react.useInsertionEffect(() => {
          visualElement && visualElement.update(props, presenceContext);
      });
      /**
       * Cache this value as we want to know whether HandoffAppearAnimations
       * was present on initial render - it will be deleted after this.
       */
      const wantsHandoff = react.useRef(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
      useIsomorphicLayoutEffect(() => {
          if (!visualElement)
              return;
          visualElement.render();
          /**
           * Ideally this function would always run in a useEffect.
           *
           * However, if we have optimised appear animations to handoff from,
           * it needs to happen synchronously to ensure there's no flash of
           * incorrect styles in the event of a hydration error.
           *
           * So if we detect a situtation where optimised appear animations
           * are running, we use useLayoutEffect to trigger animations.
           */
          if (wantsHandoff.current && visualElement.animationState) {
              visualElement.animationState.animateChanges();
          }
      });
      react.useEffect(() => {
          if (!visualElement)
              return;
          visualElement.updateFeatures();
          if (!wantsHandoff.current && visualElement.animationState) {
              visualElement.animationState.animateChanges();
          }
          if (wantsHandoff.current) {
              wantsHandoff.current = false;
              // This ensures all future calls to animateChanges() will run in useEffect
              window.HandoffComplete = true;
          }
      });
      return visualElement;
  }

  function isRefObject(ref) {
      return (ref &&
          typeof ref === "object" &&
          Object.prototype.hasOwnProperty.call(ref, "current"));
  }

  /**
   * Creates a ref function that, when called, hydrates the provided
   * external ref and VisualElement.
   */
  function useMotionRef(visualState, visualElement, externalRef) {
      return react.useCallback((instance) => {
          instance && visualState.mount && visualState.mount(instance);
          if (visualElement) {
              instance
                  ? visualElement.mount(instance)
                  : visualElement.unmount();
          }
          if (externalRef) {
              if (typeof externalRef === "function") {
                  externalRef(instance);
              }
              else if (isRefObject(externalRef)) {
                  externalRef.current = instance;
              }
          }
      }, 
      /**
       * Only pass a new ref callback to React if we've received a visual element
       * factory. Otherwise we'll be mounting/remounting every time externalRef
       * or other dependencies change.
       */
      [visualElement]);
  }

  /**
   * Decides if the supplied variable is variant label
   */
  function isVariantLabel(v) {
      return typeof v === "string" || Array.isArray(v);
  }

  function isAnimationControls(v) {
      return (v !== null &&
          typeof v === "object" &&
          typeof v.start === "function");
  }

  const variantPriorityOrder = [
      "animate",
      "whileInView",
      "whileFocus",
      "whileHover",
      "whileTap",
      "whileDrag",
      "exit",
  ];
  const variantProps = ["initial", ...variantPriorityOrder];

  function isControllingVariants(props) {
      return (isAnimationControls(props.animate) ||
          variantProps.some((name) => isVariantLabel(props[name])));
  }
  function isVariantNode(props) {
      return Boolean(isControllingVariants(props) || props.variants);
  }

  function getCurrentTreeVariants(props, context) {
      if (isControllingVariants(props)) {
          const { initial, animate } = props;
          return {
              initial: initial === false || isVariantLabel(initial)
                  ? initial
                  : undefined,
              animate: isVariantLabel(animate) ? animate : undefined,
          };
      }
      return props.inherit !== false ? context : {};
  }

  function useCreateMotionContext(props) {
      const { initial, animate } = getCurrentTreeVariants(props, react.useContext(MotionContext));
      return react.useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
  }
  function variantLabelsAsDependency(prop) {
      return Array.isArray(prop) ? prop.join(" ") : prop;
  }

  const featureProps = {
      animation: [
          "animate",
          "variants",
          "whileHover",
          "whileTap",
          "exit",
          "whileInView",
          "whileFocus",
          "whileDrag",
      ],
      exit: ["exit"],
      drag: ["drag", "dragControls"],
      focus: ["whileFocus"],
      hover: ["whileHover", "onHoverStart", "onHoverEnd"],
      tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
      pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
      inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
      layout: ["layout", "layoutId"],
  };
  const featureDefinitions = {};
  for (const key in featureProps) {
      featureDefinitions[key] = {
          isEnabled: (props) => featureProps[key].some((name) => !!props[name]),
      };
  }

  function loadFeatures(features) {
      for (const key in features) {
          featureDefinitions[key] = {
              ...featureDefinitions[key],
              ...features[key],
          };
      }
  }

  const LayoutGroupContext = react.createContext({});

  /**
   * Internal, exported only for usage in Framer
   */
  const SwitchLayoutGroupContext = react.createContext({});

  const motionComponentSymbol = Symbol.for("motionComponentSymbol");

  /**
   * Create a `motion` component.
   *
   * This function accepts a Component argument, which can be either a string (ie "div"
   * for `motion.div`), or an actual React component.
   *
   * Alongside this is a config option which provides a way of rendering the provided
   * component "offline", or outside the React render cycle.
   */
  function createMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component, }) {
      preloadedFeatures && loadFeatures(preloadedFeatures);
      function MotionComponent(props, externalRef) {
          /**
           * If we need to measure the element we load this functionality in a
           * separate class component in order to gain access to getSnapshotBeforeUpdate.
           */
          let MeasureLayout;
          const configAndProps = {
              ...react.useContext(MotionConfigContext),
              ...props,
              layoutId: useLayoutId(props),
          };
          const { isStatic } = configAndProps;
          const context = useCreateMotionContext(props);
          const visualState = useVisualState(props, isStatic);
          if (!isStatic && isBrowser) {
              /**
               * Create a VisualElement for this component. A VisualElement provides a common
               * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
               * providing a way of rendering to these APIs outside of the React render loop
               * for more performant animations and interactions
               */
              context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
              /**
               * Load Motion gesture and animation features. These are rendered as renderless
               * components so each feature can optionally make use of React lifecycle methods.
               */
              const initialLayoutGroupConfig = react.useContext(SwitchLayoutGroupContext);
              const isStrict = react.useContext(LazyContext).strict;
              if (context.visualElement) {
                  MeasureLayout = context.visualElement.loadFeatures(
                  // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                  configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
              }
          }
          /**
           * The mount order and hierarchy is specific to ensure our element ref
           * is hydrated by the time features fire their effects.
           */
          return (react.createElement(MotionContext.Provider, { value: context },
              MeasureLayout && context.visualElement ? (react.createElement(MeasureLayout, { visualElement: context.visualElement, ...configAndProps })) : null,
              useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)));
      }
      const ForwardRefComponent = react.forwardRef(MotionComponent);
      ForwardRefComponent[motionComponentSymbol] = Component;
      return ForwardRefComponent;
  }
  function useLayoutId({ layoutId }) {
      const layoutGroupId = react.useContext(LayoutGroupContext).id;
      return layoutGroupId && layoutId !== undefined
          ? layoutGroupId + "-" + layoutId
          : layoutId;
  }

  /**
   * Convert any React component into a `motion` component. The provided component
   * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
   *
   * ```jsx
   * const Component = React.forwardRef((props, ref) => {
   *   return <div ref={ref} />
   * })
   *
   * const MotionComponent = motion(Component)
   * ```
   *
   * @public
   */
  function createMotionProxy(createConfig) {
      function custom(Component, customMotionComponentConfig = {}) {
          return createMotionComponent(createConfig(Component, customMotionComponentConfig));
      }
      if (typeof Proxy === "undefined") {
          return custom;
      }
      /**
       * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
       * Rather than generating them anew every render.
       */
      const componentCache = new Map();
      return new Proxy(custom, {
          /**
           * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
           * The prop name is passed through as `key` and we can use that to generate a `motion`
           * DOM component with that name.
           */
          get: (_target, key) => {
              /**
               * If this element doesn't exist in the component cache, create it and cache.
               */
              if (!componentCache.has(key)) {
                  componentCache.set(key, custom(key));
              }
              return componentCache.get(key);
          },
      });
  }

  /**
   * We keep these listed seperately as we use the lowercase tag names as part
   * of the runtime bundle to detect SVG components
   */
  const lowercaseSVGElements = [
      "animate",
      "circle",
      "defs",
      "desc",
      "ellipse",
      "g",
      "image",
      "line",
      "filter",
      "marker",
      "mask",
      "metadata",
      "path",
      "pattern",
      "polygon",
      "polyline",
      "rect",
      "stop",
      "switch",
      "symbol",
      "svg",
      "text",
      "tspan",
      "use",
      "view",
  ];

  function isSVGComponent(Component) {
      if (
      /**
       * If it's not a string, it's a custom React component. Currently we only support
       * HTML custom React components.
       */
      typeof Component !== "string" ||
          /**
           * If it contains a dash, the element is a custom HTML webcomponent.
           */
          Component.includes("-")) {
          return false;
      }
      else if (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      lowercaseSVGElements.indexOf(Component) > -1 ||
          /**
           * If it contains a capital letter, it's an SVG component
           */
          /[A-Z]/.test(Component)) {
          return true;
      }
      return false;
  }

  const scaleCorrectors = {};
  function addScaleCorrector(correctors) {
      Object.assign(scaleCorrectors, correctors);
  }

  /**
   * Generate a list of every possible transform key.
   */
  const transformPropOrder = [
      "transformPerspective",
      "x",
      "y",
      "z",
      "translateX",
      "translateY",
      "translateZ",
      "scale",
      "scaleX",
      "scaleY",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "skew",
      "skewX",
      "skewY",
  ];
  /**
   * A quick lookup for transform props.
   */
  const transformProps = new Set(transformPropOrder);

  function isForcedMotionValue(key, { layout, layoutId }) {
      return (transformProps.has(key) ||
          key.startsWith("origin") ||
          ((layout || layoutId !== undefined) &&
              (!!scaleCorrectors[key] || key === "opacity")));
  }

  const isMotionValue = (value) => Boolean(value && value.getVelocity);

  const translateAlias = {
      x: "translateX",
      y: "translateY",
      z: "translateZ",
      transformPerspective: "perspective",
  };
  const numTransforms = transformPropOrder.length;
  /**
   * Build a CSS transform style from individual x/y/scale etc properties.
   *
   * This outputs with a default order of transforms/scales/rotations, this can be customised by
   * providing a transformTemplate function.
   */
  function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
      // The transform string we're going to build into.
      let transformString = "";
      /**
       * Loop over all possible transforms in order, adding the ones that
       * are present to the transform string.
       */
      for (let i = 0; i < numTransforms; i++) {
          const key = transformPropOrder[i];
          if (transform[key] !== undefined) {
              const transformName = translateAlias[key] || key;
              transformString += `${transformName}(${transform[key]}) `;
          }
      }
      if (enableHardwareAcceleration && !transform.z) {
          transformString += "translateZ(0)";
      }
      transformString = transformString.trim();
      // If we have a custom `transform` template, pass our transform values and
      // generated transformString to that before returning
      if (transformTemplate) {
          transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
      }
      else if (allowTransformNone && transformIsDefault) {
          transformString = "none";
      }
      return transformString;
  }

  const checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
  const isCSSVariableName = checkStringStartsWith("--");
  const isCSSVariableToken = checkStringStartsWith("var(--");
  const cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

  /**
   * Provided a value and a ValueType, returns the value as that value type.
   */
  const getValueAsType = (value, type) => {
      return type && typeof value === "number"
          ? type.transform(value)
          : value;
  };

  const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

  const number = {
      test: (v) => typeof v === "number",
      parse: parseFloat,
      transform: (v) => v,
  };
  const alpha = {
      ...number,
      transform: (v) => clamp(0, 1, v),
  };
  const scale = {
      ...number,
      default: 1,
  };

  /**
   * TODO: When we move from string as a source of truth to data models
   * everything in this folder should probably be referred to as models vs types
   */
  // If this number is a decimal, make it just five decimal places
  // to avoid exponents
  const sanitize = (v) => Math.round(v * 100000) / 100000;
  const floatRegex = /(-)?([\d]*\.?[\d])+/g;
  const colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
  const singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
  function isString(v) {
      return typeof v === "string";
  }

  const createUnitType = (unit) => ({
      test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
      parse: parseFloat,
      transform: (v) => `${v}${unit}`,
  });
  const degrees = createUnitType("deg");
  const percent = createUnitType("%");
  const px = createUnitType("px");
  const vh = createUnitType("vh");
  const vw = createUnitType("vw");
  const progressPercentage = {
      ...percent,
      parse: (v) => percent.parse(v) / 100,
      transform: (v) => percent.transform(v * 100),
  };

  const int = {
      ...number,
      transform: Math.round,
  };

  const numberValueTypes = {
      // Border props
      borderWidth: px,
      borderTopWidth: px,
      borderRightWidth: px,
      borderBottomWidth: px,
      borderLeftWidth: px,
      borderRadius: px,
      radius: px,
      borderTopLeftRadius: px,
      borderTopRightRadius: px,
      borderBottomRightRadius: px,
      borderBottomLeftRadius: px,
      // Positioning props
      width: px,
      maxWidth: px,
      height: px,
      maxHeight: px,
      size: px,
      top: px,
      right: px,
      bottom: px,
      left: px,
      // Spacing props
      padding: px,
      paddingTop: px,
      paddingRight: px,
      paddingBottom: px,
      paddingLeft: px,
      margin: px,
      marginTop: px,
      marginRight: px,
      marginBottom: px,
      marginLeft: px,
      // Transform props
      rotate: degrees,
      rotateX: degrees,
      rotateY: degrees,
      rotateZ: degrees,
      scale,
      scaleX: scale,
      scaleY: scale,
      scaleZ: scale,
      skew: degrees,
      skewX: degrees,
      skewY: degrees,
      distance: px,
      translateX: px,
      translateY: px,
      translateZ: px,
      x: px,
      y: px,
      z: px,
      perspective: px,
      transformPerspective: px,
      opacity: alpha,
      originX: progressPercentage,
      originY: progressPercentage,
      originZ: px,
      // Misc
      zIndex: int,
      // SVG
      fillOpacity: alpha,
      strokeOpacity: alpha,
      numOctaves: int,
  };

  function buildHTMLStyles(state, latestValues, options, transformTemplate) {
      const { style, vars, transform, transformOrigin } = state;
      // Track whether we encounter any transform or transformOrigin values.
      let hasTransform = false;
      let hasTransformOrigin = false;
      // Does the calculated transform essentially equal "none"?
      let transformIsNone = true;
      /**
       * Loop over all our latest animated values and decide whether to handle them
       * as a style or CSS variable.
       *
       * Transforms and transform origins are kept seperately for further processing.
       */
      for (const key in latestValues) {
          const value = latestValues[key];
          /**
           * If this is a CSS variable we don't do any further processing.
           */
          if (isCSSVariableName(key)) {
              vars[key] = value;
              continue;
          }
          // Convert the value to its default value type, ie 0 -> "0px"
          const valueType = numberValueTypes[key];
          const valueAsType = getValueAsType(value, valueType);
          if (transformProps.has(key)) {
              // If this is a transform, flag to enable further transform processing
              hasTransform = true;
              transform[key] = valueAsType;
              // If we already know we have a non-default transform, early return
              if (!transformIsNone)
                  continue;
              // Otherwise check to see if this is a default transform
              if (value !== (valueType.default || 0))
                  transformIsNone = false;
          }
          else if (key.startsWith("origin")) {
              // If this is a transform origin, flag and enable further transform-origin processing
              hasTransformOrigin = true;
              transformOrigin[key] = valueAsType;
          }
          else {
              style[key] = valueAsType;
          }
      }
      if (!latestValues.transform) {
          if (hasTransform || transformTemplate) {
              style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
          }
          else if (style.transform) {
              /**
               * If we have previously created a transform but currently don't have any,
               * reset transform style to none.
               */
              style.transform = "none";
          }
      }
      /**
       * Build a transformOrigin style. Uses the same defaults as the browser for
       * undefined origins.
       */
      if (hasTransformOrigin) {
          const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
          style.transformOrigin = `${originX} ${originY} ${originZ}`;
      }
  }

  const createHtmlRenderState = () => ({
      style: {},
      transform: {},
      transformOrigin: {},
      vars: {},
  });

  function copyRawValuesOnly(target, source, props) {
      for (const key in source) {
          if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
              target[key] = source[key];
          }
      }
  }
  function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
      return react.useMemo(() => {
          const state = createHtmlRenderState();
          buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
          return Object.assign({}, state.vars, state.style);
      }, [visualState]);
  }
  function useStyle(props, visualState, isStatic) {
      const styleProp = props.style || {};
      const style = {};
      /**
       * Copy non-Motion Values straight into style
       */
      copyRawValuesOnly(style, styleProp, props);
      Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
      return props.transformValues ? props.transformValues(style) : style;
  }
  function useHTMLProps(props, visualState, isStatic) {
      // The `any` isn't ideal but it is the type of createElement props argument
      const htmlProps = {};
      const style = useStyle(props, visualState, isStatic);
      if (props.drag && props.dragListener !== false) {
          // Disable the ghost element when a user drags
          htmlProps.draggable = false;
          // Disable text selection
          style.userSelect =
              style.WebkitUserSelect =
                  style.WebkitTouchCallout =
                      "none";
          // Disable scrolling on the draggable direction
          style.touchAction =
              props.drag === true
                  ? "none"
                  : `pan-${props.drag === "x" ? "y" : "x"}`;
      }
      if (props.tabIndex === undefined &&
          (props.onTap || props.onTapStart || props.whileTap)) {
          htmlProps.tabIndex = 0;
      }
      htmlProps.style = style;
      return htmlProps;
  }

  /**
   * A list of all valid MotionProps.
   *
   * @privateRemarks
   * This doesn't throw if a `MotionProp` name is missing - it should.
   */
  const validMotionProps = new Set([
      "animate",
      "exit",
      "variants",
      "initial",
      "style",
      "values",
      "variants",
      "transition",
      "transformTemplate",
      "transformValues",
      "custom",
      "inherit",
      "onBeforeLayoutMeasure",
      "onAnimationStart",
      "onAnimationComplete",
      "onUpdate",
      "onDragStart",
      "onDrag",
      "onDragEnd",
      "onMeasureDragConstraints",
      "onDirectionLock",
      "onDragTransitionEnd",
      "_dragX",
      "_dragY",
      "onHoverStart",
      "onHoverEnd",
      "onViewportEnter",
      "onViewportLeave",
      "globalTapTarget",
      "ignoreStrict",
      "viewport",
  ]);
  /**
   * Check whether a prop name is a valid `MotionProp` key.
   *
   * @param key - Name of the property to check
   * @returns `true` is key is a valid `MotionProp`.
   *
   * @public
   */
  function isValidMotionProp(key) {
      return (key.startsWith("while") ||
          (key.startsWith("drag") && key !== "draggable") ||
          key.startsWith("layout") ||
          key.startsWith("onTap") ||
          key.startsWith("onPan") ||
          key.startsWith("onLayout") ||
          validMotionProps.has(key));
  }

  let shouldForward = (key) => !isValidMotionProp(key);
  function loadExternalIsValidProp(isValidProp) {
      if (!isValidProp)
          return;
      // Explicitly filter our events
      shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
  }
  /**
   * Emotion and Styled Components both allow users to pass through arbitrary props to their components
   * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
   * of these should be passed to the underlying DOM node.
   *
   * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
   * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
   * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
   * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
   *
   * By making it an optionalDependency we can offer this functionality only in the situations where it's
   * actually required.
   */
  try {
      /**
       * We attempt to import this package but require won't be defined in esm environments, in that case
       * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
       * in favour of explicit injection.
       */
      loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
  }
  catch (_a) {
      // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
  }
  function filterProps(props, isDom, forwardMotionProps) {
      const filteredProps = {};
      for (const key in props) {
          /**
           * values is considered a valid prop by Emotion, so if it's present
           * this will be rendered out to the DOM unless explicitly filtered.
           *
           * We check the type as it could be used with the `feColorMatrix`
           * element, which we support.
           */
          if (key === "values" && typeof props.values === "object")
              continue;
          if (shouldForward(key) ||
              (forwardMotionProps === true && isValidMotionProp(key)) ||
              (!isDom && !isValidMotionProp(key)) ||
              // If trying to use native HTML drag events, forward drag listeners
              (props["draggable"] && key.startsWith("onDrag"))) {
              filteredProps[key] = props[key];
          }
      }
      return filteredProps;
  }

  function calcOrigin$1(origin, offset, size) {
      return typeof origin === "string"
          ? origin
          : px.transform(offset + size * origin);
  }
  /**
   * The SVG transform origin defaults are different to CSS and is less intuitive,
   * so we use the measured dimensions of the SVG to reconcile these.
   */
  function calcSVGTransformOrigin(dimensions, originX, originY) {
      const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
      const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
      return `${pxOriginX} ${pxOriginY}`;
  }

  const dashKeys = {
      offset: "stroke-dashoffset",
      array: "stroke-dasharray",
  };
  const camelKeys = {
      offset: "strokeDashoffset",
      array: "strokeDasharray",
  };
  /**
   * Build SVG path properties. Uses the path's measured length to convert
   * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
   * and stroke-dasharray attributes.
   *
   * This function is mutative to reduce per-frame GC.
   */
  function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
      // Normalise path length by setting SVG attribute pathLength to 1
      attrs.pathLength = 1;
      // We use dash case when setting attributes directly to the DOM node and camel case
      // when defining props on a React component.
      const keys = useDashCase ? dashKeys : camelKeys;
      // Build the dash offset
      attrs[keys.offset] = px.transform(-offset);
      // Build the dash array
      const pathLength = px.transform(length);
      const pathSpacing = px.transform(spacing);
      attrs[keys.array] = `${pathLength} ${pathSpacing}`;
  }

  /**
   * Build SVG visual attrbutes, like cx and style.transform
   */
  function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
  // This is object creation, which we try to avoid per-frame.
  ...latest }, options, isSVGTag, transformTemplate) {
      buildHTMLStyles(state, latest, options, transformTemplate);
      /**
       * For svg tags we just want to make sure viewBox is animatable and treat all the styles
       * as normal HTML tags.
       */
      if (isSVGTag) {
          if (state.style.viewBox) {
              state.attrs.viewBox = state.style.viewBox;
          }
          return;
      }
      state.attrs = state.style;
      state.style = {};
      const { attrs, style, dimensions } = state;
      /**
       * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
       * and copy it into style.
       */
      if (attrs.transform) {
          if (dimensions)
              style.transform = attrs.transform;
          delete attrs.transform;
      }
      // Parse transformOrigin
      if (dimensions &&
          (originX !== undefined || originY !== undefined || style.transform)) {
          style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
      }
      // Render attrX/attrY/attrScale as attributes
      if (attrX !== undefined)
          attrs.x = attrX;
      if (attrY !== undefined)
          attrs.y = attrY;
      if (attrScale !== undefined)
          attrs.scale = attrScale;
      // Build SVG path if one has been defined
      if (pathLength !== undefined) {
          buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
      }
  }

  const createSvgRenderState = () => ({
      ...createHtmlRenderState(),
      attrs: {},
  });

  const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

  function useSVGProps(props, visualState, _isStatic, Component) {
      const visualProps = react.useMemo(() => {
          const state = createSvgRenderState();
          buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
          return {
              ...state.attrs,
              style: { ...state.style },
          };
      }, [visualState]);
      if (props.style) {
          const rawStyles = {};
          copyRawValuesOnly(rawStyles, props.style, props);
          visualProps.style = { ...rawStyles, ...visualProps.style };
      }
      return visualProps;
  }

  function createUseRender(forwardMotionProps = false) {
      const useRender = (Component, props, ref, { latestValues }, isStatic) => {
          const useVisualProps = isSVGComponent(Component)
              ? useSVGProps
              : useHTMLProps;
          const visualProps = useVisualProps(props, latestValues, isStatic, Component);
          const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
          const elementProps = {
              ...filteredProps,
              ...visualProps,
              ref,
          };
          /**
           * If component has been handed a motion value as its child,
           * memoise its initial value and render that. Subsequent updates
           * will be handled by the onChange handler
           */
          const { children } = props;
          const renderedChildren = react.useMemo(() => (isMotionValue(children) ? children.get() : children), [children]);
          return react.createElement(Component, {
              ...elementProps,
              children: renderedChildren,
          });
      };
      return useRender;
  }

  function renderHTML(element, { style, vars }, styleProp, projection) {
      Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
      // Loop over any CSS variables and assign those.
      for (const key in vars) {
          element.style.setProperty(key, vars[key]);
      }
  }

  /**
   * A set of attribute names that are always read/written as camel case.
   */
  const camelCaseAttributes = new Set([
      "baseFrequency",
      "diffuseConstant",
      "kernelMatrix",
      "kernelUnitLength",
      "keySplines",
      "keyTimes",
      "limitingConeAngle",
      "markerHeight",
      "markerWidth",
      "numOctaves",
      "targetX",
      "targetY",
      "surfaceScale",
      "specularConstant",
      "specularExponent",
      "stdDeviation",
      "tableValues",
      "viewBox",
      "gradientTransform",
      "pathLength",
      "startOffset",
      "textLength",
      "lengthAdjust",
  ]);

  function renderSVG(element, renderState, _styleProp, projection) {
      renderHTML(element, renderState, undefined, projection);
      for (const key in renderState.attrs) {
          element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
      }
  }

  function scrapeMotionValuesFromProps$1(props, prevProps) {
      const { style } = props;
      const newValues = {};
      for (const key in style) {
          if (isMotionValue(style[key]) ||
              (prevProps.style && isMotionValue(prevProps.style[key])) ||
              isForcedMotionValue(key, props)) {
              newValues[key] = style[key];
          }
      }
      return newValues;
  }

  function scrapeMotionValuesFromProps(props, prevProps) {
      const newValues = scrapeMotionValuesFromProps$1(props, prevProps);
      for (const key in props) {
          if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
              const targetKey = transformPropOrder.indexOf(key) !== -1
                  ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                  : key;
              newValues[targetKey] = props[key];
          }
      }
      return newValues;
  }

  function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
      /**
       * If the variant definition is a function, resolve.
       */
      if (typeof definition === "function") {
          definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
      }
      /**
       * If the variant definition is a variant label, or
       * the function returned a variant label, resolve.
       */
      if (typeof definition === "string") {
          definition = props.variants && props.variants[definition];
      }
      /**
       * At this point we've resolved both functions and variant labels,
       * but the resolved variant label might itself have been a function.
       * If so, resolve. This can only have returned a valid target object.
       */
      if (typeof definition === "function") {
          definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
      }
      return definition;
  }

  /**
   * Creates a constant value over the lifecycle of a component.
   *
   * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
   * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
   * you can ensure that initialisers don't execute twice or more.
   */
  function useConstant(init) {
      const ref = react.useRef(null);
      if (ref.current === null) {
          ref.current = init();
      }
      return ref.current;
  }

  const isKeyframesTarget = (v) => {
      return Array.isArray(v);
  };

  const isCustomValue = (v) => {
      return Boolean(v && typeof v === "object" && v.mix && v.toValue);
  };
  const resolveFinalValueInKeyframes = (v) => {
      // TODO maybe throw if v.length - 1 is placeholder token?
      return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
  };

  /**
   * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
   *
   * TODO: Remove and move to library
   */
  function resolveMotionValue(value) {
      const unwrappedValue = isMotionValue(value) ? value.get() : value;
      return isCustomValue(unwrappedValue)
          ? unwrappedValue.toValue()
          : unwrappedValue;
  }

  function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
      const state = {
          latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
          renderState: createRenderState(),
      };
      if (onMount) {
          state.mount = (instance) => onMount(props, instance, state);
      }
      return state;
  }
  const makeUseVisualState = (config) => (props, isStatic) => {
      const context = react.useContext(MotionContext);
      const presenceContext = react.useContext(PresenceContext);
      const make = () => makeState(config, props, context, presenceContext);
      return isStatic ? make() : useConstant(make);
  };
  function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
      const values = {};
      const motionValues = scrapeMotionValues(props, {});
      for (const key in motionValues) {
          values[key] = resolveMotionValue(motionValues[key]);
      }
      let { initial, animate } = props;
      const isControllingVariants$1 = isControllingVariants(props);
      const isVariantNode$1 = isVariantNode(props);
      if (context &&
          isVariantNode$1 &&
          !isControllingVariants$1 &&
          props.inherit !== false) {
          if (initial === undefined)
              initial = context.initial;
          if (animate === undefined)
              animate = context.animate;
      }
      let isInitialAnimationBlocked = presenceContext
          ? presenceContext.initial === false
          : false;
      isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
      const variantToSet = isInitialAnimationBlocked ? animate : initial;
      if (variantToSet &&
          typeof variantToSet !== "boolean" &&
          !isAnimationControls(variantToSet)) {
          const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
          list.forEach((definition) => {
              const resolved = resolveVariantFromProps(props, definition);
              if (!resolved)
                  return;
              const { transitionEnd, transition, ...target } = resolved;
              for (const key in target) {
                  let valueTarget = target[key];
                  if (Array.isArray(valueTarget)) {
                      /**
                       * Take final keyframe if the initial animation is blocked because
                       * we want to initialise at the end of that blocked animation.
                       */
                      const index = isInitialAnimationBlocked
                          ? valueTarget.length - 1
                          : 0;
                      valueTarget = valueTarget[index];
                  }
                  if (valueTarget !== null) {
                      values[key] = valueTarget;
                  }
              }
              for (const key in transitionEnd)
                  values[key] = transitionEnd[key];
          });
      }
      return values;
  }

  const noop = (any) => any;

  class Queue {
      constructor() {
          this.order = [];
          this.scheduled = new Set();
      }
      add(process) {
          if (!this.scheduled.has(process)) {
              this.scheduled.add(process);
              this.order.push(process);
              return true;
          }
      }
      remove(process) {
          const index = this.order.indexOf(process);
          if (index !== -1) {
              this.order.splice(index, 1);
              this.scheduled.delete(process);
          }
      }
      clear() {
          this.order.length = 0;
          this.scheduled.clear();
      }
  }
  function createRenderStep(runNextFrame) {
      /**
       * We create and reuse two queues, one to queue jobs for the current frame
       * and one for the next. We reuse to avoid triggering GC after x frames.
       */
      let thisFrame = new Queue();
      let nextFrame = new Queue();
      let numToRun = 0;
      /**
       * Track whether we're currently processing jobs in this step. This way
       * we can decide whether to schedule new jobs for this frame or next.
       */
      let isProcessing = false;
      let flushNextFrame = false;
      /**
       * A set of processes which were marked keepAlive when scheduled.
       */
      const toKeepAlive = new WeakSet();
      const step = {
          /**
           * Schedule a process to run on the next frame.
           */
          schedule: (callback, keepAlive = false, immediate = false) => {
              const addToCurrentFrame = immediate && isProcessing;
              const queue = addToCurrentFrame ? thisFrame : nextFrame;
              if (keepAlive)
                  toKeepAlive.add(callback);
              if (queue.add(callback) && addToCurrentFrame && isProcessing) {
                  // If we're adding it to the currently running queue, update its measured size
                  numToRun = thisFrame.order.length;
              }
              return callback;
          },
          /**
           * Cancel the provided callback from running on the next frame.
           */
          cancel: (callback) => {
              nextFrame.remove(callback);
              toKeepAlive.delete(callback);
          },
          /**
           * Execute all schedule callbacks.
           */
          process: (frameData) => {
              /**
               * If we're already processing we've probably been triggered by a flushSync
               * inside an existing process. Instead of executing, mark flushNextFrame
               * as true and ensure we flush the following frame at the end of this one.
               */
              if (isProcessing) {
                  flushNextFrame = true;
                  return;
              }
              isProcessing = true;
              [thisFrame, nextFrame] = [nextFrame, thisFrame];
              // Clear the next frame queue
              nextFrame.clear();
              // Execute this frame
              numToRun = thisFrame.order.length;
              if (numToRun) {
                  for (let i = 0; i < numToRun; i++) {
                      const callback = thisFrame.order[i];
                      callback(frameData);
                      if (toKeepAlive.has(callback)) {
                          step.schedule(callback);
                          runNextFrame();
                      }
                  }
              }
              isProcessing = false;
              if (flushNextFrame) {
                  flushNextFrame = false;
                  step.process(frameData);
              }
          },
      };
      return step;
  }

  const stepsOrder = [
      "prepare",
      "read",
      "update",
      "preRender",
      "render",
      "postRender",
  ];
  const maxElapsed = 40;
  function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
      let runNextFrame = false;
      let useDefaultElapsed = true;
      const state = {
          delta: 0,
          timestamp: 0,
          isProcessing: false,
      };
      const steps = stepsOrder.reduce((acc, key) => {
          acc[key] = createRenderStep(() => (runNextFrame = true));
          return acc;
      }, {});
      const processStep = (stepId) => steps[stepId].process(state);
      const processBatch = () => {
          const timestamp = performance.now();
          runNextFrame = false;
          state.delta = useDefaultElapsed
              ? 1000 / 60
              : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
          state.timestamp = timestamp;
          state.isProcessing = true;
          stepsOrder.forEach(processStep);
          state.isProcessing = false;
          if (runNextFrame && allowKeepAlive) {
              useDefaultElapsed = false;
              scheduleNextBatch(processBatch);
          }
      };
      const wake = () => {
          runNextFrame = true;
          useDefaultElapsed = true;
          if (!state.isProcessing) {
              scheduleNextBatch(processBatch);
          }
      };
      const schedule = stepsOrder.reduce((acc, key) => {
          const step = steps[key];
          acc[key] = (process, keepAlive = false, immediate = false) => {
              if (!runNextFrame)
                  wake();
              return step.schedule(process, keepAlive, immediate);
          };
          return acc;
      }, {});
      const cancel = (process) => stepsOrder.forEach((key) => steps[key].cancel(process));
      return { schedule, cancel, state, steps };
  }

  const { schedule: frame, cancel: cancelFrame, state: frameData, steps, } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);

  const svgMotionConfig = {
      useVisualState: makeUseVisualState({
          scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
          createRenderState: createSvgRenderState,
          onMount: (props, instance, { renderState, latestValues }) => {
              frame.read(() => {
                  try {
                      renderState.dimensions =
                          typeof instance.getBBox ===
                              "function"
                              ? instance.getBBox()
                              : instance.getBoundingClientRect();
                  }
                  catch (e) {
                      // Most likely trying to measure an unrendered element under Firefox
                      renderState.dimensions = {
                          x: 0,
                          y: 0,
                          width: 0,
                          height: 0,
                      };
                  }
              });
              frame.render(() => {
                  buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
                  renderSVG(instance, renderState);
              });
          },
      }),
  };

  const htmlMotionConfig = {
      useVisualState: makeUseVisualState({
          scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
          createRenderState: createHtmlRenderState,
      }),
  };

  function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
      const baseConfig = isSVGComponent(Component)
          ? svgMotionConfig
          : htmlMotionConfig;
      return {
          ...baseConfig,
          preloadedFeatures,
          useRender: createUseRender(forwardMotionProps),
          createVisualElement,
          Component,
      };
  }

  function addDomEvent(target, eventName, handler, options = { passive: true }) {
      target.addEventListener(eventName, handler, options);
      return () => target.removeEventListener(eventName, handler);
  }

  const isPrimaryPointer = (event) => {
      if (event.pointerType === "mouse") {
          return typeof event.button !== "number" || event.button <= 0;
      }
      else {
          /**
           * isPrimary is true for all mice buttons, whereas every touch point
           * is regarded as its own input. So subsequent concurrent touch points
           * will be false.
           *
           * Specifically match against false here as incomplete versions of
           * PointerEvents in very old browser might have it set as undefined.
           */
          return event.isPrimary !== false;
      }
  };

  function extractEventInfo(event, pointType = "page") {
      return {
          point: {
              x: event[pointType + "X"],
              y: event[pointType + "Y"],
          },
      };
  }
  const addPointerInfo = (handler) => {
      return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
  };

  function addPointerEvent(target, eventName, handler, options) {
      return addDomEvent(target, eventName, addPointerInfo(handler), options);
  }

  /**
   * Pipe
   * Compose other transformers to run linearily
   * pipe(min(20), max(40))
   * @param  {...functions} transformers
   * @return {function}
   */
  const combineFunctions = (a, b) => (v) => b(a(v));
  const pipe = (...transformers) => transformers.reduce(combineFunctions);

  function createLock(name) {
      let lock = null;
      return () => {
          const openLock = () => {
              lock = null;
          };
          if (lock === null) {
              lock = name;
              return openLock;
          }
          return false;
      };
  }
  const globalHorizontalLock = createLock("dragHorizontal");
  const globalVerticalLock = createLock("dragVertical");
  function getGlobalLock(drag) {
      let lock = false;
      if (drag === "y") {
          lock = globalVerticalLock();
      }
      else if (drag === "x") {
          lock = globalHorizontalLock();
      }
      else {
          const openHorizontal = globalHorizontalLock();
          const openVertical = globalVerticalLock();
          if (openHorizontal && openVertical) {
              lock = () => {
                  openHorizontal();
                  openVertical();
              };
          }
          else {
              // Release the locks because we don't use them
              if (openHorizontal)
                  openHorizontal();
              if (openVertical)
                  openVertical();
          }
      }
      return lock;
  }
  function isDragActive() {
      // Check the gesture lock - if we get it, it means no drag gesture is active
      // and we can safely fire the tap gesture.
      const openGestureLock = getGlobalLock(true);
      if (!openGestureLock)
          return true;
      openGestureLock();
      return false;
  }

  class Feature {
      constructor(node) {
          this.isMounted = false;
          this.node = node;
      }
      update() { }
  }

  function addHoverEvent(node, isActive) {
      const eventName = "pointer" + (isActive ? "enter" : "leave");
      const callbackName = "onHover" + (isActive ? "Start" : "End");
      const handleEvent = (event, info) => {
          if (event.pointerType === "touch" || isDragActive())
              return;
          const props = node.getProps();
          if (node.animationState && props.whileHover) {
              node.animationState.setActive("whileHover", isActive);
          }
          if (props[callbackName]) {
              frame.update(() => props[callbackName](event, info));
          }
      };
      return addPointerEvent(node.current, eventName, handleEvent, {
          passive: !node.getProps()[callbackName],
      });
  }
  class HoverGesture extends Feature {
      mount() {
          this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
      }
      unmount() { }
  }

  class FocusGesture extends Feature {
      constructor() {
          super(...arguments);
          this.isActive = false;
      }
      onFocus() {
          let isFocusVisible = false;
          /**
           * If this element doesn't match focus-visible then don't
           * apply whileHover. But, if matches throws that focus-visible
           * is not a valid selector then in that browser outline styles will be applied
           * to the element by default and we want to match that behaviour with whileFocus.
           */
          try {
              isFocusVisible = this.node.current.matches(":focus-visible");
          }
          catch (e) {
              isFocusVisible = true;
          }
          if (!isFocusVisible || !this.node.animationState)
              return;
          this.node.animationState.setActive("whileFocus", true);
          this.isActive = true;
      }
      onBlur() {
          if (!this.isActive || !this.node.animationState)
              return;
          this.node.animationState.setActive("whileFocus", false);
          this.isActive = false;
      }
      mount() {
          this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
      }
      unmount() { }
  }

  /**
   * Recursively traverse up the tree to check whether the provided child node
   * is the parent or a descendant of it.
   *
   * @param parent - Element to find
   * @param child - Element to test against parent
   */
  const isNodeOrChild = (parent, child) => {
      if (!child) {
          return false;
      }
      else if (parent === child) {
          return true;
      }
      else {
          return isNodeOrChild(parent, child.parentElement);
      }
  };

  function fireSyntheticPointerEvent(name, handler) {
      if (!handler)
          return;
      const syntheticPointerEvent = new PointerEvent("pointer" + name);
      handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
  }
  class PressGesture extends Feature {
      constructor() {
          super(...arguments);
          this.removeStartListeners = noop;
          this.removeEndListeners = noop;
          this.removeAccessibleListeners = noop;
          this.startPointerPress = (startEvent, startInfo) => {
              if (this.isPressing)
                  return;
              this.removeEndListeners();
              const props = this.node.getProps();
              const endPointerPress = (endEvent, endInfo) => {
                  if (!this.checkPressEnd())
                      return;
                  const { onTap, onTapCancel, globalTapTarget } = this.node.getProps();
                  frame.update(() => {
                      /**
                       * We only count this as a tap gesture if the event.target is the same
                       * as, or a child of, this component's element
                       */
                      !globalTapTarget &&
                          !isNodeOrChild(this.node.current, endEvent.target)
                          ? onTapCancel && onTapCancel(endEvent, endInfo)
                          : onTap && onTap(endEvent, endInfo);
                  });
              };
              const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, { passive: !(props.onTap || props["onPointerUp"]) });
              const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props["onPointerCancel"]) });
              this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
              this.startPress(startEvent, startInfo);
          };
          this.startAccessiblePress = () => {
              const handleKeydown = (keydownEvent) => {
                  if (keydownEvent.key !== "Enter" || this.isPressing)
                      return;
                  const handleKeyup = (keyupEvent) => {
                      if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
                          return;
                      fireSyntheticPointerEvent("up", (event, info) => {
                          const { onTap } = this.node.getProps();
                          if (onTap) {
                              frame.update(() => onTap(event, info));
                          }
                      });
                  };
                  this.removeEndListeners();
                  this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
                  fireSyntheticPointerEvent("down", (event, info) => {
                      this.startPress(event, info);
                  });
              };
              const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
              const handleBlur = () => {
                  if (!this.isPressing)
                      return;
                  fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
              };
              const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
              this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
          };
      }
      startPress(event, info) {
          this.isPressing = true;
          const { onTapStart, whileTap } = this.node.getProps();
          /**
           * Ensure we trigger animations before firing event callback
           */
          if (whileTap && this.node.animationState) {
              this.node.animationState.setActive("whileTap", true);
          }
          if (onTapStart) {
              frame.update(() => onTapStart(event, info));
          }
      }
      checkPressEnd() {
          this.removeEndListeners();
          this.isPressing = false;
          const props = this.node.getProps();
          if (props.whileTap && this.node.animationState) {
              this.node.animationState.setActive("whileTap", false);
          }
          return !isDragActive();
      }
      cancelPress(event, info) {
          if (!this.checkPressEnd())
              return;
          const { onTapCancel } = this.node.getProps();
          if (onTapCancel) {
              frame.update(() => onTapCancel(event, info));
          }
      }
      mount() {
          const props = this.node.getProps();
          const removePointerListener = addPointerEvent(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props["onPointerStart"]) });
          const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
          this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
      }
      unmount() {
          this.removeStartListeners();
          this.removeEndListeners();
          this.removeAccessibleListeners();
      }
  }

  /**
   * Map an IntersectionHandler callback to an element. We only ever make one handler for one
   * element, so even though these handlers might all be triggered by different
   * observers, we can keep them in the same map.
   */
  const observerCallbacks = new WeakMap();
  /**
   * Multiple observers can be created for multiple element/document roots. Each with
   * different settings. So here we store dictionaries of observers to each root,
   * using serialised settings (threshold/margin) as lookup keys.
   */
  const observers = new WeakMap();
  const fireObserverCallback = (entry) => {
      const callback = observerCallbacks.get(entry.target);
      callback && callback(entry);
  };
  const fireAllObserverCallbacks = (entries) => {
      entries.forEach(fireObserverCallback);
  };
  function initIntersectionObserver({ root, ...options }) {
      const lookupRoot = root || document;
      /**
       * If we don't have an observer lookup map for this root, create one.
       */
      if (!observers.has(lookupRoot)) {
          observers.set(lookupRoot, {});
      }
      const rootObservers = observers.get(lookupRoot);
      const key = JSON.stringify(options);
      /**
       * If we don't have an observer for this combination of root and settings,
       * create one.
       */
      if (!rootObservers[key]) {
          rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
      }
      return rootObservers[key];
  }
  function observeIntersection(element, options, callback) {
      const rootInteresectionObserver = initIntersectionObserver(options);
      observerCallbacks.set(element, callback);
      rootInteresectionObserver.observe(element);
      return () => {
          observerCallbacks.delete(element);
          rootInteresectionObserver.unobserve(element);
      };
  }

  const thresholdNames = {
      some: 0,
      all: 1,
  };
  class InViewFeature extends Feature {
      constructor() {
          super(...arguments);
          this.hasEnteredView = false;
          this.isInView = false;
      }
      startObserver() {
          this.unmount();
          const { viewport = {} } = this.node.getProps();
          const { root, margin: rootMargin, amount = "some", once } = viewport;
          const options = {
              root: root ? root.current : undefined,
              rootMargin,
              threshold: typeof amount === "number" ? amount : thresholdNames[amount],
          };
          const onIntersectionUpdate = (entry) => {
              const { isIntersecting } = entry;
              /**
               * If there's been no change in the viewport state, early return.
               */
              if (this.isInView === isIntersecting)
                  return;
              this.isInView = isIntersecting;
              /**
               * Handle hasEnteredView. If this is only meant to run once, and
               * element isn't visible, early return. Otherwise set hasEnteredView to true.
               */
              if (once && !isIntersecting && this.hasEnteredView) {
                  return;
              }
              else if (isIntersecting) {
                  this.hasEnteredView = true;
              }
              if (this.node.animationState) {
                  this.node.animationState.setActive("whileInView", isIntersecting);
              }
              /**
               * Use the latest committed props rather than the ones in scope
               * when this observer is created
               */
              const { onViewportEnter, onViewportLeave } = this.node.getProps();
              const callback = isIntersecting ? onViewportEnter : onViewportLeave;
              callback && callback(entry);
          };
          return observeIntersection(this.node.current, options, onIntersectionUpdate);
      }
      mount() {
          this.startObserver();
      }
      update() {
          if (typeof IntersectionObserver === "undefined")
              return;
          const { props, prevProps } = this.node;
          const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
          if (hasOptionsChanged) {
              this.startObserver();
          }
      }
      unmount() { }
  }
  function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
      return (name) => viewport[name] !== prevViewport[name];
  }

  const gestureAnimations = {
      inView: {
          Feature: InViewFeature,
      },
      tap: {
          Feature: PressGesture,
      },
      focus: {
          Feature: FocusGesture,
      },
      hover: {
          Feature: HoverGesture,
      },
  };

  function shallowCompare(next, prev) {
      if (!Array.isArray(prev))
          return false;
      const prevLength = prev.length;
      if (prevLength !== next.length)
          return false;
      for (let i = 0; i < prevLength; i++) {
          if (prev[i] !== next[i])
              return false;
      }
      return true;
  }

  /**
   * Creates an object containing the latest state of every MotionValue on a VisualElement
   */
  function getCurrent(visualElement) {
      const current = {};
      visualElement.values.forEach((value, key) => (current[key] = value.get()));
      return current;
  }
  /**
   * Creates an object containing the latest velocity of every MotionValue on a VisualElement
   */
  function getVelocity$1(visualElement) {
      const velocity = {};
      visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
      return velocity;
  }
  function resolveVariant(visualElement, definition, custom) {
      const props = visualElement.getProps();
      return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
  }

  let warning = noop;
  let invariant = noop;

  /**
   * Converts seconds to milliseconds
   *
   * @param seconds - Time in seconds.
   * @return milliseconds - Converted time in milliseconds.
   */
  const secondsToMilliseconds = (seconds) => seconds * 1000;
  const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

  const instantAnimationState = {
      current: false,
  };

  const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

  function isWaapiSupportedEasing(easing) {
      return Boolean(!easing ||
          (typeof easing === "string" && supportedWaapiEasing[easing]) ||
          isBezierDefinition(easing) ||
          (Array.isArray(easing) && easing.every(isWaapiSupportedEasing)));
  }
  const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
  const supportedWaapiEasing = {
      linear: "linear",
      ease: "ease",
      easeIn: "ease-in",
      easeOut: "ease-out",
      easeInOut: "ease-in-out",
      circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
      circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
      backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
      backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
  };
  function mapEasingToNativeEasing(easing) {
      if (!easing)
          return undefined;
      return isBezierDefinition(easing)
          ? cubicBezierAsString(easing)
          : Array.isArray(easing)
              ? easing.map(mapEasingToNativeEasing)
              : supportedWaapiEasing[easing];
  }

  function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
      const keyframeOptions = { [valueName]: keyframes };
      if (times)
          keyframeOptions.offset = times;
      const easing = mapEasingToNativeEasing(ease);
      /**
       * If this is an easing array, apply to keyframes, not animation as a whole
       */
      if (Array.isArray(easing))
          keyframeOptions.easing = easing;
      return element.animate(keyframeOptions, {
          delay,
          duration,
          easing: !Array.isArray(easing) ? easing : "linear",
          fill: "both",
          iterations: repeat + 1,
          direction: repeatType === "reverse" ? "alternate" : "normal",
      });
  }

  function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }) {
      const index = repeat && repeatType !== "loop" && repeat % 2 === 1
          ? 0
          : keyframes.length - 1;
      return keyframes[index];
  }

  /*
    Bezier function generator
    This has been modified from Gaëtan Renaudeau's BezierEasing
    https://github.com/gre/bezier-easing/blob/master/src/index.js
    https://github.com/gre/bezier-easing/blob/master/LICENSE
    
    I've removed the newtonRaphsonIterate algo because in benchmarking it
    wasn't noticiably faster than binarySubdivision, indeed removing it
    usually improved times, depending on the curve.
    I also removed the lookup table, as for the added bundle size and loop we're
    only cutting ~4 or so subdivision iterations. I bumped the max iterations up
    to 12 to compensate and this still tended to be faster for no perceivable
    loss in accuracy.
    Usage
      const easeOut = cubicBezier(.17,.67,.83,.67);
      const x = easeOut(0.5); // returns 0.627...
  */
  // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
  const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
      t;
  const subdivisionPrecision = 0.0000001;
  const subdivisionMaxIterations = 12;
  function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
      let currentX;
      let currentT;
      let i = 0;
      do {
          currentT = lowerBound + (upperBound - lowerBound) / 2.0;
          currentX = calcBezier(currentT, mX1, mX2) - x;
          if (currentX > 0.0) {
              upperBound = currentT;
          }
          else {
              lowerBound = currentT;
          }
      } while (Math.abs(currentX) > subdivisionPrecision &&
          ++i < subdivisionMaxIterations);
      return currentT;
  }
  function cubicBezier(mX1, mY1, mX2, mY2) {
      // If this is a linear gradient, return linear easing
      if (mX1 === mY1 && mX2 === mY2)
          return noop;
      const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
      // If animation is at start/end, return t without easing
      return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
  }

  const easeIn = cubicBezier(0.42, 0, 1, 1);
  const easeOut = cubicBezier(0, 0, 0.58, 1);
  const easeInOut = cubicBezier(0.42, 0, 0.58, 1);

  const isEasingArray = (ease) => {
      return Array.isArray(ease) && typeof ease[0] !== "number";
  };

  // Accepts an easing function and returns a new one that outputs mirrored values for
  // the second half of the animation. Turns easeIn into easeInOut.
  const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

  // Accepts an easing function and returns a new one that outputs reversed values.
  // Turns easeIn into easeOut.
  const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

  const circIn = (p) => 1 - Math.sin(Math.acos(p));
  const circOut = reverseEasing(circIn);
  const circInOut = mirrorEasing(circIn);

  const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
  const backIn = reverseEasing(backOut);
  const backInOut = mirrorEasing(backIn);

  const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

  const easingLookup = {
      linear: noop,
      easeIn,
      easeInOut,
      easeOut,
      circIn,
      circInOut,
      circOut,
      backIn,
      backInOut,
      backOut,
      anticipate,
  };
  const easingDefinitionToFunction = (definition) => {
      if (Array.isArray(definition)) {
          // If cubic bezier definition, create bezier curve
          invariant(definition.length === 4);
          const [x1, y1, x2, y2] = definition;
          return cubicBezier(x1, y1, x2, y2);
      }
      else if (typeof definition === "string") {
          return easingLookup[definition];
      }
      return definition;
  };

  /**
   * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
   * but false if a number or multiple colors
   */
  const isColorString = (type, testProp) => (v) => {
      return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
          (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
  };
  const splitColor = (aName, bName, cName) => (v) => {
      if (!isString(v))
          return v;
      const [a, b, c, alpha] = v.match(floatRegex);
      return {
          [aName]: parseFloat(a),
          [bName]: parseFloat(b),
          [cName]: parseFloat(c),
          alpha: alpha !== undefined ? parseFloat(alpha) : 1,
      };
  };

  const clampRgbUnit = (v) => clamp(0, 255, v);
  const rgbUnit = {
      ...number,
      transform: (v) => Math.round(clampRgbUnit(v)),
  };
  const rgba = {
      test: isColorString("rgb", "red"),
      parse: splitColor("red", "green", "blue"),
      transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
          rgbUnit.transform(red) +
          ", " +
          rgbUnit.transform(green) +
          ", " +
          rgbUnit.transform(blue) +
          ", " +
          sanitize(alpha.transform(alpha$1)) +
          ")",
  };

  function parseHex(v) {
      let r = "";
      let g = "";
      let b = "";
      let a = "";
      // If we have 6 characters, ie #FF0000
      if (v.length > 5) {
          r = v.substring(1, 3);
          g = v.substring(3, 5);
          b = v.substring(5, 7);
          a = v.substring(7, 9);
          // Or we have 3 characters, ie #F00
      }
      else {
          r = v.substring(1, 2);
          g = v.substring(2, 3);
          b = v.substring(3, 4);
          a = v.substring(4, 5);
          r += r;
          g += g;
          b += b;
          a += a;
      }
      return {
          red: parseInt(r, 16),
          green: parseInt(g, 16),
          blue: parseInt(b, 16),
          alpha: a ? parseInt(a, 16) / 255 : 1,
      };
  }
  const hex = {
      test: isColorString("#"),
      parse: parseHex,
      transform: rgba.transform,
  };

  const hsla = {
      test: isColorString("hsl", "hue"),
      parse: splitColor("hue", "saturation", "lightness"),
      transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
          return ("hsla(" +
              Math.round(hue) +
              ", " +
              percent.transform(sanitize(saturation)) +
              ", " +
              percent.transform(sanitize(lightness)) +
              ", " +
              sanitize(alpha.transform(alpha$1)) +
              ")");
      },
  };

  const color = {
      test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
      parse: (v) => {
          if (rgba.test(v)) {
              return rgba.parse(v);
          }
          else if (hsla.test(v)) {
              return hsla.parse(v);
          }
          else {
              return hex.parse(v);
          }
      },
      transform: (v) => {
          return isString(v)
              ? v
              : v.hasOwnProperty("red")
                  ? rgba.transform(v)
                  : hsla.transform(v);
      },
  };

  /*
    Value in range from progress

    Given a lower limit and an upper limit, we return the value within
    that range as expressed by progress (usually a number from 0 to 1)

    So progress = 0.5 would change

    from -------- to

    to

    from ---- to

    E.g. from = 10, to = 20, progress = 0.5 => 15

    @param [number]: Lower limit of range
    @param [number]: Upper limit of range
    @param [number]: The progress between lower and upper limits expressed 0-1
    @return [number]: Value as calculated from progress within range (not limited within range)
  */
  const mix = (from, to, progress) => -progress * from + progress * to + from;

  // Adapted from https://gist.github.com/mjackson/5311256
  function hueToRgb(p, q, t) {
      if (t < 0)
          t += 1;
      if (t > 1)
          t -= 1;
      if (t < 1 / 6)
          return p + (q - p) * 6 * t;
      if (t < 1 / 2)
          return q;
      if (t < 2 / 3)
          return p + (q - p) * (2 / 3 - t) * 6;
      return p;
  }
  function hslaToRgba({ hue, saturation, lightness, alpha }) {
      hue /= 360;
      saturation /= 100;
      lightness /= 100;
      let red = 0;
      let green = 0;
      let blue = 0;
      if (!saturation) {
          red = green = blue = lightness;
      }
      else {
          const q = lightness < 0.5
              ? lightness * (1 + saturation)
              : lightness + saturation - lightness * saturation;
          const p = 2 * lightness - q;
          red = hueToRgb(p, q, hue + 1 / 3);
          green = hueToRgb(p, q, hue);
          blue = hueToRgb(p, q, hue - 1 / 3);
      }
      return {
          red: Math.round(red * 255),
          green: Math.round(green * 255),
          blue: Math.round(blue * 255),
          alpha,
      };
  }

  // Linear color space blending
  // Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
  // Demonstrated http://codepen.io/osublake/pen/xGVVaN
  const mixLinearColor = (from, to, v) => {
      const fromExpo = from * from;
      return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
  };
  const colorTypes = [hex, rgba, hsla];
  const getColorType = (v) => colorTypes.find((type) => type.test(v));
  function asRGBA(color) {
      const type = getColorType(color);
      let model = type.parse(color);
      if (type === hsla) {
          // TODO Remove this cast - needed since Framer Motion's stricter typing
          model = hslaToRgba(model);
      }
      return model;
  }
  const mixColor = (from, to) => {
      const fromRGBA = asRGBA(from);
      const toRGBA = asRGBA(to);
      const blended = { ...fromRGBA };
      return (v) => {
          blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
          blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
          blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
          blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
          return rgba.transform(blended);
      };
  };

  function test(v) {
      var _a, _b;
      return (isNaN(v) &&
          isString(v) &&
          (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
              (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
              0);
  }
  const cssVarTokeniser = {
      regex: cssVariableRegex,
      countKey: "Vars",
      token: "${v}",
      parse: noop,
  };
  const colorTokeniser = {
      regex: colorRegex,
      countKey: "Colors",
      token: "${c}",
      parse: color.parse,
  };
  const numberTokeniser = {
      regex: floatRegex,
      countKey: "Numbers",
      token: "${n}",
      parse: number.parse,
  };
  function tokenise(info, { regex, countKey, token, parse }) {
      const matches = info.tokenised.match(regex);
      if (!matches)
          return;
      info["num" + countKey] = matches.length;
      info.tokenised = info.tokenised.replace(regex, token);
      info.values.push(...matches.map(parse));
  }
  function analyseComplexValue(value) {
      const originalValue = value.toString();
      const info = {
          value: originalValue,
          tokenised: originalValue,
          values: [],
          numVars: 0,
          numColors: 0,
          numNumbers: 0,
      };
      if (info.value.includes("var(--"))
          tokenise(info, cssVarTokeniser);
      tokenise(info, colorTokeniser);
      tokenise(info, numberTokeniser);
      return info;
  }
  function parseComplexValue(v) {
      return analyseComplexValue(v).values;
  }
  function createTransformer(source) {
      const { values, numColors, numVars, tokenised } = analyseComplexValue(source);
      const numValues = values.length;
      return (v) => {
          let output = tokenised;
          for (let i = 0; i < numValues; i++) {
              if (i < numVars) {
                  output = output.replace(cssVarTokeniser.token, v[i]);
              }
              else if (i < numVars + numColors) {
                  output = output.replace(colorTokeniser.token, color.transform(v[i]));
              }
              else {
                  output = output.replace(numberTokeniser.token, sanitize(v[i]));
              }
          }
          return output;
      };
  }
  const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
  function getAnimatableNone$1(v) {
      const parsed = parseComplexValue(v);
      const transformer = createTransformer(v);
      return transformer(parsed.map(convertNumbersToZero));
  }
  const complex = {
      test,
      parse: parseComplexValue,
      createTransformer,
      getAnimatableNone: getAnimatableNone$1,
  };

  const mixImmediate = (origin, target) => (p) => `${p > 0 ? target : origin}`;
  function getMixer(origin, target) {
      if (typeof origin === "number") {
          return (v) => mix(origin, target, v);
      }
      else if (color.test(origin)) {
          return mixColor(origin, target);
      }
      else {
          return origin.startsWith("var(")
              ? mixImmediate(origin, target)
              : mixComplex(origin, target);
      }
  }
  const mixArray = (from, to) => {
      const output = [...from];
      const numValues = output.length;
      const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
      return (v) => {
          for (let i = 0; i < numValues; i++) {
              output[i] = blendValue[i](v);
          }
          return output;
      };
  };
  const mixObject = (origin, target) => {
      const output = { ...origin, ...target };
      const blendValue = {};
      for (const key in output) {
          if (origin[key] !== undefined && target[key] !== undefined) {
              blendValue[key] = getMixer(origin[key], target[key]);
          }
      }
      return (v) => {
          for (const key in blendValue) {
              output[key] = blendValue[key](v);
          }
          return output;
      };
  };
  const mixComplex = (origin, target) => {
      const template = complex.createTransformer(target);
      const originStats = analyseComplexValue(origin);
      const targetStats = analyseComplexValue(target);
      const canInterpolate = originStats.numVars === targetStats.numVars &&
          originStats.numColors === targetStats.numColors &&
          originStats.numNumbers >= targetStats.numNumbers;
      if (canInterpolate) {
          return pipe(mixArray(originStats.values, targetStats.values), template);
      }
      else {
          warning(true);
          return mixImmediate(origin, target);
      }
  };

  /*
    Progress within given range

    Given a lower limit and an upper limit, we return the progress
    (expressed as a number 0-1) represented by the given value, and
    limit that progress to within 0-1.

    @param [number]: Lower limit
    @param [number]: Upper limit
    @param [number]: Value to find progress within given range
    @return [number]: Progress of value within range as expressed 0-1
  */
  const progress = (from, to, value) => {
      const toFromDifference = to - from;
      return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
  };

  const mixNumber = (from, to) => (p) => mix(from, to, p);
  function detectMixerFactory(v) {
      if (typeof v === "number") {
          return mixNumber;
      }
      else if (typeof v === "string") {
          return color.test(v) ? mixColor : mixComplex;
      }
      else if (Array.isArray(v)) {
          return mixArray;
      }
      else if (typeof v === "object") {
          return mixObject;
      }
      return mixNumber;
  }
  function createMixers(output, ease, customMixer) {
      const mixers = [];
      const mixerFactory = customMixer || detectMixerFactory(output[0]);
      const numMixers = output.length - 1;
      for (let i = 0; i < numMixers; i++) {
          let mixer = mixerFactory(output[i], output[i + 1]);
          if (ease) {
              const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
              mixer = pipe(easingFunction, mixer);
          }
          mixers.push(mixer);
      }
      return mixers;
  }
  /**
   * Create a function that maps from a numerical input array to a generic output array.
   *
   * Accepts:
   *   - Numbers
   *   - Colors (hex, hsl, hsla, rgb, rgba)
   *   - Complex (combinations of one or more numbers or strings)
   *
   * ```jsx
   * const mixColor = interpolate([0, 1], ['#fff', '#000'])
   *
   * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
   * ```
   *
   * TODO Revist this approach once we've moved to data models for values,
   * probably not needed to pregenerate mixer functions.
   *
   * @public
   */
  function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
      const inputLength = input.length;
      invariant(inputLength === output.length);
      /**
       * If we're only provided a single input, we can just make a function
       * that returns the output.
       */
      if (inputLength === 1)
          return () => output[0];
      // If input runs highest -> lowest, reverse both arrays
      if (input[0] > input[inputLength - 1]) {
          input = [...input].reverse();
          output = [...output].reverse();
      }
      const mixers = createMixers(output, ease, mixer);
      const numMixers = mixers.length;
      const interpolator = (v) => {
          let i = 0;
          if (numMixers > 1) {
              for (; i < input.length - 2; i++) {
                  if (v < input[i + 1])
                      break;
              }
          }
          const progressInRange = progress(input[i], input[i + 1], v);
          return mixers[i](progressInRange);
      };
      return isClamp
          ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
          : interpolator;
  }

  function fillOffset(offset, remaining) {
      const min = offset[offset.length - 1];
      for (let i = 1; i <= remaining; i++) {
          const offsetProgress = progress(0, remaining, i);
          offset.push(mix(min, 1, offsetProgress));
      }
  }

  function defaultOffset(arr) {
      const offset = [0];
      fillOffset(offset, arr.length - 1);
      return offset;
  }

  function convertOffsetToTimes(offset, duration) {
      return offset.map((o) => o * duration);
  }

  function defaultEasing(values, easing) {
      return values.map(() => easing || easeInOut).splice(0, values.length - 1);
  }
  function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut", }) {
      /**
       * Easing functions can be externally defined as strings. Here we convert them
       * into actual functions.
       */
      const easingFunctions = isEasingArray(ease)
          ? ease.map(easingDefinitionToFunction)
          : easingDefinitionToFunction(ease);
      /**
       * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
       * to reduce GC during animation.
       */
      const state = {
          done: false,
          value: keyframeValues[0],
      };
      /**
       * Create a times array based on the provided 0-1 offsets
       */
      const absoluteTimes = convertOffsetToTimes(
      // Only use the provided offsets if they're the correct length
      // TODO Maybe we should warn here if there's a length mismatch
      times && times.length === keyframeValues.length
          ? times
          : defaultOffset(keyframeValues), duration);
      const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
          ease: Array.isArray(easingFunctions)
              ? easingFunctions
              : defaultEasing(keyframeValues, easingFunctions),
      });
      return {
          calculatedDuration: duration,
          next: (t) => {
              state.value = mapTimeToKeyframe(t);
              state.done = t >= duration;
              return state;
          },
      };
  }

  /*
    Convert velocity into velocity per second

    @param [number]: Unit per frame
    @param [number]: Frame duration in ms
  */
  function velocityPerSecond(velocity, frameDuration) {
      return frameDuration ? velocity * (1000 / frameDuration) : 0;
  }

  const velocitySampleDuration = 5; // ms
  function calcGeneratorVelocity(resolveValue, t, current) {
      const prevT = Math.max(t - velocitySampleDuration, 0);
      return velocityPerSecond(current - resolveValue(prevT), t - prevT);
  }

  const safeMin = 0.001;
  const minDuration = 0.01;
  const maxDuration$1 = 10.0;
  const minDamping = 0.05;
  const maxDamping = 1;
  function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
      let envelope;
      let derivative;
      warning(duration <= secondsToMilliseconds(maxDuration$1));
      let dampingRatio = 1 - bounce;
      /**
       * Restrict dampingRatio and duration to within acceptable ranges.
       */
      dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
      duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
      if (dampingRatio < 1) {
          /**
           * Underdamped spring
           */
          envelope = (undampedFreq) => {
              const exponentialDecay = undampedFreq * dampingRatio;
              const delta = exponentialDecay * duration;
              const a = exponentialDecay - velocity;
              const b = calcAngularFreq(undampedFreq, dampingRatio);
              const c = Math.exp(-delta);
              return safeMin - (a / b) * c;
          };
          derivative = (undampedFreq) => {
              const exponentialDecay = undampedFreq * dampingRatio;
              const delta = exponentialDecay * duration;
              const d = delta * velocity + velocity;
              const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
              const f = Math.exp(-delta);
              const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
              const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
              return (factor * ((d - e) * f)) / g;
          };
      }
      else {
          /**
           * Critically-damped spring
           */
          envelope = (undampedFreq) => {
              const a = Math.exp(-undampedFreq * duration);
              const b = (undampedFreq - velocity) * duration + 1;
              return -safeMin + a * b;
          };
          derivative = (undampedFreq) => {
              const a = Math.exp(-undampedFreq * duration);
              const b = (velocity - undampedFreq) * (duration * duration);
              return a * b;
          };
      }
      const initialGuess = 5 / duration;
      const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
      duration = secondsToMilliseconds(duration);
      if (isNaN(undampedFreq)) {
          return {
              stiffness: 100,
              damping: 10,
              duration,
          };
      }
      else {
          const stiffness = Math.pow(undampedFreq, 2) * mass;
          return {
              stiffness,
              damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
              duration,
          };
      }
  }
  const rootIterations = 12;
  function approximateRoot(envelope, derivative, initialGuess) {
      let result = initialGuess;
      for (let i = 1; i < rootIterations; i++) {
          result = result - envelope(result) / derivative(result);
      }
      return result;
  }
  function calcAngularFreq(undampedFreq, dampingRatio) {
      return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
  }

  const durationKeys = ["duration", "bounce"];
  const physicsKeys = ["stiffness", "damping", "mass"];
  function isSpringType(options, keys) {
      return keys.some((key) => options[key] !== undefined);
  }
  function getSpringOptions(options) {
      let springOptions = {
          velocity: 0.0,
          stiffness: 100,
          damping: 10,
          mass: 1.0,
          isResolvedFromDuration: false,
          ...options,
      };
      // stiffness/damping/mass overrides duration/bounce
      if (!isSpringType(options, physicsKeys) &&
          isSpringType(options, durationKeys)) {
          const derived = findSpring(options);
          springOptions = {
              ...springOptions,
              ...derived,
              mass: 1.0,
          };
          springOptions.isResolvedFromDuration = true;
      }
      return springOptions;
  }
  function spring({ keyframes, restDelta, restSpeed, ...options }) {
      const origin = keyframes[0];
      const target = keyframes[keyframes.length - 1];
      /**
       * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
       * to reduce GC during animation.
       */
      const state = { done: false, value: origin };
      const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration, } = getSpringOptions({
          ...options,
          velocity: -millisecondsToSeconds(options.velocity || 0),
      });
      const initialVelocity = velocity || 0.0;
      const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
      const initialDelta = target - origin;
      const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
      /**
       * If we're working on a granular scale, use smaller defaults for determining
       * when the spring is finished.
       *
       * These defaults have been selected emprically based on what strikes a good
       * ratio between feeling good and finishing as soon as changes are imperceptible.
       */
      const isGranularScale = Math.abs(initialDelta) < 5;
      restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
      restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
      let resolveSpring;
      if (dampingRatio < 1) {
          const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
          // Underdamped spring
          resolveSpring = (t) => {
              const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
              return (target -
                  envelope *
                      (((initialVelocity +
                          dampingRatio * undampedAngularFreq * initialDelta) /
                          angularFreq) *
                          Math.sin(angularFreq * t) +
                          initialDelta * Math.cos(angularFreq * t)));
          };
      }
      else if (dampingRatio === 1) {
          // Critically damped spring
          resolveSpring = (t) => target -
              Math.exp(-undampedAngularFreq * t) *
                  (initialDelta +
                      (initialVelocity + undampedAngularFreq * initialDelta) * t);
      }
      else {
          // Overdamped spring
          const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
          resolveSpring = (t) => {
              const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
              // When performing sinh or cosh values can hit Infinity so we cap them here
              const freqForT = Math.min(dampedAngularFreq * t, 300);
              return (target -
                  (envelope *
                      ((initialVelocity +
                          dampingRatio * undampedAngularFreq * initialDelta) *
                          Math.sinh(freqForT) +
                          dampedAngularFreq *
                              initialDelta *
                              Math.cosh(freqForT))) /
                      dampedAngularFreq);
          };
      }
      return {
          calculatedDuration: isResolvedFromDuration ? duration || null : null,
          next: (t) => {
              const current = resolveSpring(t);
              if (!isResolvedFromDuration) {
                  let currentVelocity = initialVelocity;
                  if (t !== 0) {
                      /**
                       * We only need to calculate velocity for under-damped springs
                       * as over- and critically-damped springs can't overshoot, so
                       * checking only for displacement is enough.
                       */
                      if (dampingRatio < 1) {
                          currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
                      }
                      else {
                          currentVelocity = 0;
                      }
                  }
                  const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                  const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                  state.done =
                      isBelowVelocityThreshold && isBelowDisplacementThreshold;
              }
              else {
                  state.done = t >= duration;
              }
              state.value = state.done ? target : current;
              return state;
          },
      };
  }

  function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed, }) {
      const origin = keyframes[0];
      const state = {
          done: false,
          value: origin,
      };
      const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
      const nearestBoundary = (v) => {
          if (min === undefined)
              return max;
          if (max === undefined)
              return min;
          return Math.abs(min - v) < Math.abs(max - v) ? min : max;
      };
      let amplitude = power * velocity;
      const ideal = origin + amplitude;
      const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
      /**
       * If the target has changed we need to re-calculate the amplitude, otherwise
       * the animation will start from the wrong position.
       */
      if (target !== ideal)
          amplitude = target - origin;
      const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
      const calcLatest = (t) => target + calcDelta(t);
      const applyFriction = (t) => {
          const delta = calcDelta(t);
          const latest = calcLatest(t);
          state.done = Math.abs(delta) <= restDelta;
          state.value = state.done ? target : latest;
      };
      /**
       * Ideally this would resolve for t in a stateless way, we could
       * do that by always precalculating the animation but as we know
       * this will be done anyway we can assume that spring will
       * be discovered during that.
       */
      let timeReachedBoundary;
      let spring$1;
      const checkCatchBoundary = (t) => {
          if (!isOutOfBounds(state.value))
              return;
          timeReachedBoundary = t;
          spring$1 = spring({
              keyframes: [state.value, nearestBoundary(state.value)],
              velocity: calcGeneratorVelocity(calcLatest, t, state.value),
              damping: bounceDamping,
              stiffness: bounceStiffness,
              restDelta,
              restSpeed,
          });
      };
      checkCatchBoundary(0);
      return {
          calculatedDuration: null,
          next: (t) => {
              /**
               * We need to resolve the friction to figure out if we need a
               * spring but we don't want to do this twice per frame. So here
               * we flag if we updated for this frame and later if we did
               * we can skip doing it again.
               */
              let hasUpdatedFrame = false;
              if (!spring$1 && timeReachedBoundary === undefined) {
                  hasUpdatedFrame = true;
                  applyFriction(t);
                  checkCatchBoundary(t);
              }
              /**
               * If we have a spring and the provided t is beyond the moment the friction
               * animation crossed the min/max boundary, use the spring.
               */
              if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
                  return spring$1.next(t - timeReachedBoundary);
              }
              else {
                  !hasUpdatedFrame && applyFriction(t);
                  return state;
              }
          },
      };
  }

  const frameloopDriver = (update) => {
      const passTimestamp = ({ timestamp }) => update(timestamp);
      return {
          start: () => frame.update(passTimestamp, true),
          stop: () => cancelFrame(passTimestamp),
          /**
           * If we're processing this frame we can use the
           * framelocked timestamp to keep things in sync.
           */
          now: () => frameData.isProcessing ? frameData.timestamp : performance.now(),
      };
  };

  /**
   * Implement a practical max duration for keyframe generation
   * to prevent infinite loops
   */
  const maxGeneratorDuration = 20000;
  function calcGeneratorDuration(generator) {
      let duration = 0;
      const timeStep = 50;
      let state = generator.next(duration);
      while (!state.done && duration < maxGeneratorDuration) {
          duration += timeStep;
          state = generator.next(duration);
      }
      return duration >= maxGeneratorDuration ? Infinity : duration;
  }

  const types = {
      decay: inertia,
      inertia,
      tween: keyframes,
      keyframes: keyframes,
      spring,
  };
  /**
   * Animate a single value on the main thread.
   *
   * This function is written, where functionality overlaps,
   * to be largely spec-compliant with WAAPI to allow fungibility
   * between the two.
   */
  function animateValue({ autoplay = true, delay = 0, driver = frameloopDriver, keyframes: keyframes$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options }) {
      let speed = 1;
      let hasStopped = false;
      let resolveFinishedPromise;
      let currentFinishedPromise;
      /**
       * Resolve the current Promise every time we enter the
       * finished state. This is WAAPI-compatible behaviour.
       */
      const updateFinishedPromise = () => {
          currentFinishedPromise = new Promise((resolve) => {
              resolveFinishedPromise = resolve;
          });
      };
      // Create the first finished promise
      updateFinishedPromise();
      let animationDriver;
      const generatorFactory = types[type] || keyframes;
      /**
       * If this isn't the keyframes generator and we've been provided
       * strings as keyframes, we need to interpolate these.
       */
      let mapNumbersToKeyframes;
      if (generatorFactory !== keyframes &&
          typeof keyframes$1[0] !== "number") {
          mapNumbersToKeyframes = interpolate([0, 100], keyframes$1, {
              clamp: false,
          });
          keyframes$1 = [0, 100];
      }
      const generator = generatorFactory({ ...options, keyframes: keyframes$1 });
      let mirroredGenerator;
      if (repeatType === "mirror") {
          mirroredGenerator = generatorFactory({
              ...options,
              keyframes: [...keyframes$1].reverse(),
              velocity: -(options.velocity || 0),
          });
      }
      let playState = "idle";
      let holdTime = null;
      let startTime = null;
      let cancelTime = null;
      /**
       * If duration is undefined and we have repeat options,
       * we need to calculate a duration from the generator.
       *
       * We set it to the generator itself to cache the duration.
       * Any timeline resolver will need to have already precalculated
       * the duration by this step.
       */
      if (generator.calculatedDuration === null && repeat) {
          generator.calculatedDuration = calcGeneratorDuration(generator);
      }
      const { calculatedDuration } = generator;
      let resolvedDuration = Infinity;
      let totalDuration = Infinity;
      if (calculatedDuration !== null) {
          resolvedDuration = calculatedDuration + repeatDelay;
          totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
      }
      let currentTime = 0;
      const tick = (timestamp) => {
          if (startTime === null)
              return;
          /**
           * requestAnimationFrame timestamps can come through as lower than
           * the startTime as set by performance.now(). Here we prevent this,
           * though in the future it could be possible to make setting startTime
           * a pending operation that gets resolved here.
           */
          if (speed > 0)
              startTime = Math.min(startTime, timestamp);
          if (speed < 0)
              startTime = Math.min(timestamp - totalDuration / speed, startTime);
          if (holdTime !== null) {
              currentTime = holdTime;
          }
          else {
              // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
              // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
              // example.
              currentTime = Math.round(timestamp - startTime) * speed;
          }
          // Rebase on delay
          const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
          const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
          currentTime = Math.max(timeWithoutDelay, 0);
          /**
           * If this animation has finished, set the current time
           * to the total duration.
           */
          if (playState === "finished" && holdTime === null) {
              currentTime = totalDuration;
          }
          let elapsed = currentTime;
          let frameGenerator = generator;
          if (repeat) {
              /**
               * Get the current progress (0-1) of the animation. If t is >
               * than duration we'll get values like 2.5 (midway through the
               * third iteration)
               */
              const progress = Math.min(currentTime, totalDuration) / resolvedDuration;
              /**
               * Get the current iteration (0 indexed). For instance the floor of
               * 2.5 is 2.
               */
              let currentIteration = Math.floor(progress);
              /**
               * Get the current progress of the iteration by taking the remainder
               * so 2.5 is 0.5 through iteration 2
               */
              let iterationProgress = progress % 1.0;
              /**
               * If iteration progress is 1 we count that as the end
               * of the previous iteration.
               */
              if (!iterationProgress && progress >= 1) {
                  iterationProgress = 1;
              }
              iterationProgress === 1 && currentIteration--;
              currentIteration = Math.min(currentIteration, repeat + 1);
              /**
               * Reverse progress if we're not running in "normal" direction
               */
              const isOddIteration = Boolean(currentIteration % 2);
              if (isOddIteration) {
                  if (repeatType === "reverse") {
                      iterationProgress = 1 - iterationProgress;
                      if (repeatDelay) {
                          iterationProgress -= repeatDelay / resolvedDuration;
                      }
                  }
                  else if (repeatType === "mirror") {
                      frameGenerator = mirroredGenerator;
                  }
              }
              elapsed = clamp(0, 1, iterationProgress) * resolvedDuration;
          }
          /**
           * If we're in negative time, set state as the initial keyframe.
           * This prevents delay: x, duration: 0 animations from finishing
           * instantly.
           */
          const state = isInDelayPhase
              ? { done: false, value: keyframes$1[0] }
              : frameGenerator.next(elapsed);
          if (mapNumbersToKeyframes) {
              state.value = mapNumbersToKeyframes(state.value);
          }
          let { done } = state;
          if (!isInDelayPhase && calculatedDuration !== null) {
              done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
          }
          const isAnimationFinished = holdTime === null &&
              (playState === "finished" || (playState === "running" && done));
          if (onUpdate) {
              onUpdate(state.value);
          }
          if (isAnimationFinished) {
              finish();
          }
          return state;
      };
      const stopAnimationDriver = () => {
          animationDriver && animationDriver.stop();
          animationDriver = undefined;
      };
      const cancel = () => {
          playState = "idle";
          stopAnimationDriver();
          resolveFinishedPromise();
          updateFinishedPromise();
          startTime = cancelTime = null;
      };
      const finish = () => {
          playState = "finished";
          onComplete && onComplete();
          stopAnimationDriver();
          resolveFinishedPromise();
      };
      const play = () => {
          if (hasStopped)
              return;
          if (!animationDriver)
              animationDriver = driver(tick);
          const now = animationDriver.now();
          onPlay && onPlay();
          if (holdTime !== null) {
              startTime = now - holdTime;
          }
          else if (!startTime || playState === "finished") {
              startTime = now;
          }
          if (playState === "finished") {
              updateFinishedPromise();
          }
          cancelTime = startTime;
          holdTime = null;
          /**
           * Set playState to running only after we've used it in
           * the previous logic.
           */
          playState = "running";
          animationDriver.start();
      };
      if (autoplay) {
          play();
      }
      const controls = {
          then(resolve, reject) {
              return currentFinishedPromise.then(resolve, reject);
          },
          get time() {
              return millisecondsToSeconds(currentTime);
          },
          set time(newTime) {
              newTime = secondsToMilliseconds(newTime);
              currentTime = newTime;
              if (holdTime !== null || !animationDriver || speed === 0) {
                  holdTime = newTime;
              }
              else {
                  startTime = animationDriver.now() - newTime / speed;
              }
          },
          get duration() {
              const duration = generator.calculatedDuration === null
                  ? calcGeneratorDuration(generator)
                  : generator.calculatedDuration;
              return millisecondsToSeconds(duration);
          },
          get speed() {
              return speed;
          },
          set speed(newSpeed) {
              if (newSpeed === speed || !animationDriver)
                  return;
              speed = newSpeed;
              controls.time = millisecondsToSeconds(currentTime);
          },
          get state() {
              return playState;
          },
          play,
          pause: () => {
              playState = "paused";
              holdTime = currentTime;
          },
          stop: () => {
              hasStopped = true;
              if (playState === "idle")
                  return;
              playState = "idle";
              onStop && onStop();
              cancel();
          },
          cancel: () => {
              if (cancelTime !== null)
                  tick(cancelTime);
              cancel();
          },
          complete: () => {
              playState = "finished";
          },
          sample: (elapsed) => {
              startTime = 0;
              return tick(elapsed);
          },
      };
      return controls;
  }

  function memo(callback) {
      let result;
      return () => {
          if (result === undefined)
              result = callback();
          return result;
      };
  }

  const supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
  /**
   * A list of values that can be hardware-accelerated.
   */
  const acceleratedValues = new Set([
      "opacity",
      "clipPath",
      "filter",
      "transform",
      "backgroundColor",
  ]);
  /**
   * 10ms is chosen here as it strikes a balance between smooth
   * results (more than one keyframe per frame at 60fps) and
   * keyframe quantity.
   */
  const sampleDelta = 10; //ms
  /**
   * Implement a practical max duration for keyframe generation
   * to prevent infinite loops
   */
  const maxDuration = 20000;
  const requiresPregeneratedKeyframes = (valueName, options) => options.type === "spring" ||
      valueName === "backgroundColor" ||
      !isWaapiSupportedEasing(options.ease);
  function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
      const canAccelerateAnimation = supportsWaapi() &&
          acceleratedValues.has(valueName) &&
          !options.repeatDelay &&
          options.repeatType !== "mirror" &&
          options.damping !== 0 &&
          options.type !== "inertia";
      if (!canAccelerateAnimation)
          return false;
      /**
       * TODO: Unify with js/index
       */
      let hasStopped = false;
      let resolveFinishedPromise;
      let currentFinishedPromise;
      /**
       * Cancelling an animation will write to the DOM. For safety we want to defer
       * this until the next `update` frame lifecycle. This flag tracks whether we
       * have a pending cancel, if so we shouldn't allow animations to finish.
       */
      let pendingCancel = false;
      /**
       * Resolve the current Promise every time we enter the
       * finished state. This is WAAPI-compatible behaviour.
       */
      const updateFinishedPromise = () => {
          currentFinishedPromise = new Promise((resolve) => {
              resolveFinishedPromise = resolve;
          });
      };
      // Create the first finished promise
      updateFinishedPromise();
      let { keyframes, duration = 300, ease, times } = options;
      /**
       * If this animation needs pre-generated keyframes then generate.
       */
      if (requiresPregeneratedKeyframes(valueName, options)) {
          const sampleAnimation = animateValue({
              ...options,
              repeat: 0,
              delay: 0,
          });
          let state = { done: false, value: keyframes[0] };
          const pregeneratedKeyframes = [];
          /**
           * Bail after 20 seconds of pre-generated keyframes as it's likely
           * we're heading for an infinite loop.
           */
          let t = 0;
          while (!state.done && t < maxDuration) {
              state = sampleAnimation.sample(t);
              pregeneratedKeyframes.push(state.value);
              t += sampleDelta;
          }
          times = undefined;
          keyframes = pregeneratedKeyframes;
          duration = t - sampleDelta;
          ease = "linear";
      }
      const animation = animateStyle(value.owner.current, valueName, keyframes, {
          ...options,
          duration,
          /**
           * This function is currently not called if ease is provided
           * as a function so the cast is safe.
           *
           * However it would be possible for a future refinement to port
           * in easing pregeneration from Motion One for browsers that
           * support the upcoming `linear()` easing function.
           */
          ease: ease,
          times,
      });
      const cancelAnimation = () => {
          pendingCancel = false;
          animation.cancel();
      };
      const safeCancel = () => {
          pendingCancel = true;
          frame.update(cancelAnimation);
          resolveFinishedPromise();
          updateFinishedPromise();
      };
      /**
       * Prefer the `onfinish` prop as it's more widely supported than
       * the `finished` promise.
       *
       * Here, we synchronously set the provided MotionValue to the end
       * keyframe. If we didn't, when the WAAPI animation is finished it would
       * be removed from the element which would then revert to its old styles.
       */
      animation.onfinish = () => {
          if (pendingCancel)
              return;
          value.set(getFinalKeyframe(keyframes, options));
          onComplete && onComplete();
          safeCancel();
      };
      /**
       * Animation interrupt callback.
       */
      const controls = {
          then(resolve, reject) {
              return currentFinishedPromise.then(resolve, reject);
          },
          attachTimeline(timeline) {
              animation.timeline = timeline;
              animation.onfinish = null;
              return noop;
          },
          get time() {
              return millisecondsToSeconds(animation.currentTime || 0);
          },
          set time(newTime) {
              animation.currentTime = secondsToMilliseconds(newTime);
          },
          get speed() {
              return animation.playbackRate;
          },
          set speed(newSpeed) {
              animation.playbackRate = newSpeed;
          },
          get duration() {
              return millisecondsToSeconds(duration);
          },
          play: () => {
              if (hasStopped)
                  return;
              animation.play();
              /**
               * Cancel any pending cancel tasks
               */
              cancelFrame(cancelAnimation);
          },
          pause: () => animation.pause(),
          stop: () => {
              hasStopped = true;
              if (animation.playState === "idle")
                  return;
              /**
               * WAAPI doesn't natively have any interruption capabilities.
               *
               * Rather than read commited styles back out of the DOM, we can
               * create a renderless JS animation and sample it twice to calculate
               * its current value, "previous" value, and therefore allow
               * Motion to calculate velocity for any subsequent animation.
               */
              const { currentTime } = animation;
              if (currentTime) {
                  const sampleAnimation = animateValue({
                      ...options,
                      autoplay: false,
                  });
                  value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
              }
              safeCancel();
          },
          complete: () => {
              if (pendingCancel)
                  return;
              animation.finish();
          },
          cancel: safeCancel,
      };
      return controls;
  }

  function createInstantAnimation({ keyframes, delay, onUpdate, onComplete, }) {
      const setValue = () => {
          onUpdate && onUpdate(keyframes[keyframes.length - 1]);
          onComplete && onComplete();
          /**
           * TODO: As this API grows it could make sense to always return
           * animateValue. This will be a bigger project as animateValue
           * is frame-locked whereas this function resolves instantly.
           * This is a behavioural change and also has ramifications regarding
           * assumptions within tests.
           */
          return {
              time: 0,
              speed: 1,
              duration: 0,
              play: (noop),
              pause: (noop),
              stop: (noop),
              then: (resolve) => {
                  resolve();
                  return Promise.resolve();
              },
              cancel: (noop),
              complete: (noop),
          };
      };
      return delay
          ? animateValue({
              keyframes: [0, 1],
              duration: 0,
              delay,
              onComplete: setValue,
          })
          : setValue();
  }

  const underDampedSpring = {
      type: "spring",
      stiffness: 500,
      damping: 25,
      restSpeed: 10,
  };
  const criticallyDampedSpring = (target) => ({
      type: "spring",
      stiffness: 550,
      damping: target === 0 ? 2 * Math.sqrt(550) : 30,
      restSpeed: 10,
  });
  const keyframesTransition = {
      type: "keyframes",
      duration: 0.8,
  };
  /**
   * Default easing curve is a slightly shallower version of
   * the default browser easing curve.
   */
  const ease = {
      type: "keyframes",
      ease: [0.25, 0.1, 0.35, 1],
      duration: 0.3,
  };
  const getDefaultTransition = (valueKey, { keyframes }) => {
      if (keyframes.length > 2) {
          return keyframesTransition;
      }
      else if (transformProps.has(valueKey)) {
          return valueKey.startsWith("scale")
              ? criticallyDampedSpring(keyframes[1])
              : underDampedSpring;
      }
      return ease;
  };

  /**
   * Check if a value is animatable. Examples:
   *
   * ✅: 100, "100px", "#fff"
   * ❌: "block", "url(2.jpg)"
   * @param value
   *
   * @internal
   */
  const isAnimatable = (key, value) => {
      // If the list of keys tat might be non-animatable grows, replace with Set
      if (key === "zIndex")
          return false;
      // If it's a number or a keyframes array, we can animate it. We might at some point
      // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
      // but for now lets leave it like this for performance reasons
      if (typeof value === "number" || Array.isArray(value))
          return true;
      if (typeof value === "string" && // It's animatable if we have a string
          (complex.test(value) || value === "0") && // And it contains numbers and/or colors
          !value.startsWith("url(") // Unless it starts with "url("
      ) {
          return true;
      }
      return false;
  };

  /**
   * Properties that should default to 1 or 100%
   */
  const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
  function applyDefaultFilter(v) {
      const [name, value] = v.slice(0, -1).split("(");
      if (name === "drop-shadow")
          return v;
      const [number] = value.match(floatRegex) || [];
      if (!number)
          return v;
      const unit = value.replace(number, "");
      let defaultValue = maxDefaults.has(name) ? 1 : 0;
      if (number !== value)
          defaultValue *= 100;
      return name + "(" + defaultValue + unit + ")";
  }
  const functionRegex = /([a-z-]*)\(.*?\)/g;
  const filter = {
      ...complex,
      getAnimatableNone: (v) => {
          const functions = v.match(functionRegex);
          return functions ? functions.map(applyDefaultFilter).join(" ") : v;
      },
  };

  /**
   * A map of default value types for common values
   */
  const defaultValueTypes = {
      ...numberValueTypes,
      // Color props
      color,
      backgroundColor: color,
      outlineColor: color,
      fill: color,
      stroke: color,
      // Border props
      borderColor: color,
      borderTopColor: color,
      borderRightColor: color,
      borderBottomColor: color,
      borderLeftColor: color,
      filter,
      WebkitFilter: filter,
  };
  /**
   * Gets the default ValueType for the provided value key
   */
  const getDefaultValueType = (key) => defaultValueTypes[key];

  function getAnimatableNone(key, value) {
      let defaultValueType = getDefaultValueType(key);
      if (defaultValueType !== filter)
          defaultValueType = complex;
      // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
      return defaultValueType.getAnimatableNone
          ? defaultValueType.getAnimatableNone(value)
          : undefined;
  }

  /**
   * Check if the value is a zero value string like "0px" or "0%"
   */
  const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);

  function isNone(value) {
      if (typeof value === "number") {
          return value === 0;
      }
      else if (value !== null) {
          return value === "none" || value === "0" || isZeroValueString(value);
      }
  }

  function getKeyframes(value, valueName, target, transition) {
      const isTargetAnimatable = isAnimatable(valueName, target);
      let keyframes;
      if (Array.isArray(target)) {
          keyframes = [...target];
      }
      else {
          keyframes = [null, target];
      }
      const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
      let animatableTemplateValue = undefined;
      const noneKeyframeIndexes = [];
      for (let i = 0; i < keyframes.length; i++) {
          /**
           * Fill null/wildcard keyframes
           */
          if (keyframes[i] === null) {
              keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
          }
          if (isNone(keyframes[i])) {
              noneKeyframeIndexes.push(i);
          }
          // TODO: Clean this conditional, it works for now
          if (typeof keyframes[i] === "string" &&
              keyframes[i] !== "none" &&
              keyframes[i] !== "0") {
              animatableTemplateValue = keyframes[i];
          }
      }
      if (isTargetAnimatable &&
          noneKeyframeIndexes.length &&
          animatableTemplateValue) {
          for (let i = 0; i < noneKeyframeIndexes.length; i++) {
              const index = noneKeyframeIndexes[i];
              keyframes[index] = getAnimatableNone(valueName, animatableTemplateValue);
          }
      }
      return keyframes;
  }

  /**
   * Decide whether a transition is defined on a given Transition.
   * This filters out orchestration options and returns true
   * if any options are left.
   */
  function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
      return !!Object.keys(transition).length;
  }
  function getValueTransition(transition, key) {
      return transition[key] || transition["default"] || transition;
  }

  const MotionGlobalConfig = {
      skipAnimations: false,
  };

  const animateMotionValue = (valueName, value, target, transition = {}) => {
      return (onComplete) => {
          const valueTransition = getValueTransition(transition, valueName) || {};
          /**
           * Most transition values are currently completely overwritten by value-specific
           * transitions. In the future it'd be nicer to blend these transitions. But for now
           * delay actually does inherit from the root transition if not value-specific.
           */
          const delay = valueTransition.delay || transition.delay || 0;
          /**
           * Elapsed isn't a public transition option but can be passed through from
           * optimized appear effects in milliseconds.
           */
          let { elapsed = 0 } = transition;
          elapsed = elapsed - secondsToMilliseconds(delay);
          const keyframes = getKeyframes(value, valueName, target, valueTransition);
          /**
           * Check if we're able to animate between the start and end keyframes,
           * and throw a warning if we're attempting to animate between one that's
           * animatable and another that isn't.
           */
          const originKeyframe = keyframes[0];
          const targetKeyframe = keyframes[keyframes.length - 1];
          const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
          const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
          warning(isOriginAnimatable === isTargetAnimatable);
          let options = {
              keyframes,
              velocity: value.getVelocity(),
              ease: "easeOut",
              ...valueTransition,
              delay: -elapsed,
              onUpdate: (v) => {
                  value.set(v);
                  valueTransition.onUpdate && valueTransition.onUpdate(v);
              },
              onComplete: () => {
                  onComplete();
                  valueTransition.onComplete && valueTransition.onComplete();
              },
          };
          /**
           * If there's no transition defined for this value, we can generate
           * unqiue transition settings for this value.
           */
          if (!isTransitionDefined(valueTransition)) {
              options = {
                  ...options,
                  ...getDefaultTransition(valueName, options),
              };
          }
          /**
           * Both WAAPI and our internal animation functions use durations
           * as defined by milliseconds, while our external API defines them
           * as seconds.
           */
          if (options.duration) {
              options.duration = secondsToMilliseconds(options.duration);
          }
          if (options.repeatDelay) {
              options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
          }
          if (!isOriginAnimatable ||
              !isTargetAnimatable ||
              instantAnimationState.current ||
              valueTransition.type === false ||
              MotionGlobalConfig.skipAnimations) {
              /**
               * If we can't animate this value, or the global instant animation flag is set,
               * or this is simply defined as an instant transition, return an instant transition.
               */
              return createInstantAnimation(instantAnimationState.current
                  ? { ...options, delay: 0 }
                  : options);
          }
          /**
           * Animate via WAAPI if possible.
           */
          if (
          /**
           * If this is a handoff animation, the optimised animation will be running via
           * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
           * optimised animation.
           */
          !transition.isHandoff &&
              value.owner &&
              value.owner.current instanceof HTMLElement &&
              /**
               * If we're outputting values to onUpdate then we can't use WAAPI as there's
               * no way to read the value from WAAPI every frame.
               */
              !value.owner.getProps().onUpdate) {
              const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
              if (acceleratedAnimation)
                  return acceleratedAnimation;
          }
          /**
           * If we didn't create an accelerated animation, create a JS animation
           */
          return animateValue(options);
      };
  };

  function isWillChangeMotionValue(value) {
      return Boolean(isMotionValue(value) && value.add);
  }

  /**
   * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
   */
  const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);

  function addUniqueItem(arr, item) {
      if (arr.indexOf(item) === -1)
          arr.push(item);
  }
  function removeItem(arr, item) {
      const index = arr.indexOf(item);
      if (index > -1)
          arr.splice(index, 1);
  }

  class SubscriptionManager {
      constructor() {
          this.subscriptions = [];
      }
      add(handler) {
          addUniqueItem(this.subscriptions, handler);
          return () => removeItem(this.subscriptions, handler);
      }
      notify(a, b, c) {
          const numSubscriptions = this.subscriptions.length;
          if (!numSubscriptions)
              return;
          if (numSubscriptions === 1) {
              /**
               * If there's only a single handler we can just call it without invoking a loop.
               */
              this.subscriptions[0](a, b, c);
          }
          else {
              for (let i = 0; i < numSubscriptions; i++) {
                  /**
                   * Check whether the handler exists before firing as it's possible
                   * the subscriptions were modified during this loop running.
                   */
                  const handler = this.subscriptions[i];
                  handler && handler(a, b, c);
              }
          }
      }
      getSize() {
          return this.subscriptions.length;
      }
      clear() {
          this.subscriptions.length = 0;
      }
  }

  const isFloat = (value) => {
      return !isNaN(parseFloat(value));
  };
  /**
   * `MotionValue` is used to track the state and velocity of motion values.
   *
   * @public
   */
  class MotionValue {
      /**
       * @param init - The initiating value
       * @param config - Optional configuration options
       *
       * -  `transformer`: A function to transform incoming values with.
       *
       * @internal
       */
      constructor(init, options = {}) {
          /**
           * This will be replaced by the build step with the latest version number.
           * When MotionValues are provided to motion components, warn if versions are mixed.
           */
          this.version = "10.18.0";
          /**
           * Duration, in milliseconds, since last updating frame.
           *
           * @internal
           */
          this.timeDelta = 0;
          /**
           * Timestamp of the last time this `MotionValue` was updated.
           *
           * @internal
           */
          this.lastUpdated = 0;
          /**
           * Tracks whether this value can output a velocity. Currently this is only true
           * if the value is numerical, but we might be able to widen the scope here and support
           * other value types.
           *
           * @internal
           */
          this.canTrackVelocity = false;
          /**
           * An object containing a SubscriptionManager for each active event.
           */
          this.events = {};
          this.updateAndNotify = (v, render = true) => {
              this.prev = this.current;
              this.current = v;
              // Update timestamp
              const { delta, timestamp } = frameData;
              if (this.lastUpdated !== timestamp) {
                  this.timeDelta = delta;
                  this.lastUpdated = timestamp;
                  frame.postRender(this.scheduleVelocityCheck);
              }
              // Update update subscribers
              if (this.prev !== this.current && this.events.change) {
                  this.events.change.notify(this.current);
              }
              // Update velocity subscribers
              if (this.events.velocityChange) {
                  this.events.velocityChange.notify(this.getVelocity());
              }
              // Update render subscribers
              if (render && this.events.renderRequest) {
                  this.events.renderRequest.notify(this.current);
              }
          };
          /**
           * Schedule a velocity check for the next frame.
           *
           * This is an instanced and bound function to prevent generating a new
           * function once per frame.
           *
           * @internal
           */
          this.scheduleVelocityCheck = () => frame.postRender(this.velocityCheck);
          /**
           * Updates `prev` with `current` if the value hasn't been updated this frame.
           * This ensures velocity calculations return `0`.
           *
           * This is an instanced and bound function to prevent generating a new
           * function once per frame.
           *
           * @internal
           */
          this.velocityCheck = ({ timestamp }) => {
              if (timestamp !== this.lastUpdated) {
                  this.prev = this.current;
                  if (this.events.velocityChange) {
                      this.events.velocityChange.notify(this.getVelocity());
                  }
              }
          };
          this.hasAnimated = false;
          this.prev = this.current = init;
          this.canTrackVelocity = isFloat(this.current);
          this.owner = options.owner;
      }
      /**
       * Adds a function that will be notified when the `MotionValue` is updated.
       *
       * It returns a function that, when called, will cancel the subscription.
       *
       * When calling `onChange` inside a React component, it should be wrapped with the
       * `useEffect` hook. As it returns an unsubscribe function, this should be returned
       * from the `useEffect` function to ensure you don't add duplicate subscribers..
       *
       * ```jsx
       * export const MyComponent = () => {
       *   const x = useMotionValue(0)
       *   const y = useMotionValue(0)
       *   const opacity = useMotionValue(1)
       *
       *   useEffect(() => {
       *     function updateOpacity() {
       *       const maxXY = Math.max(x.get(), y.get())
       *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
       *       opacity.set(newOpacity)
       *     }
       *
       *     const unsubscribeX = x.on("change", updateOpacity)
       *     const unsubscribeY = y.on("change", updateOpacity)
       *
       *     return () => {
       *       unsubscribeX()
       *       unsubscribeY()
       *     }
       *   }, [])
       *
       *   return <motion.div style={{ x }} />
       * }
       * ```
       *
       * @param subscriber - A function that receives the latest value.
       * @returns A function that, when called, will cancel this subscription.
       *
       * @deprecated
       */
      onChange(subscription) {
          return this.on("change", subscription);
      }
      on(eventName, callback) {
          if (!this.events[eventName]) {
              this.events[eventName] = new SubscriptionManager();
          }
          const unsubscribe = this.events[eventName].add(callback);
          if (eventName === "change") {
              return () => {
                  unsubscribe();
                  /**
                   * If we have no more change listeners by the start
                   * of the next frame, stop active animations.
                   */
                  frame.read(() => {
                      if (!this.events.change.getSize()) {
                          this.stop();
                      }
                  });
              };
          }
          return unsubscribe;
      }
      clearListeners() {
          for (const eventManagers in this.events) {
              this.events[eventManagers].clear();
          }
      }
      /**
       * Attaches a passive effect to the `MotionValue`.
       *
       * @internal
       */
      attach(passiveEffect, stopPassiveEffect) {
          this.passiveEffect = passiveEffect;
          this.stopPassiveEffect = stopPassiveEffect;
      }
      /**
       * Sets the state of the `MotionValue`.
       *
       * @remarks
       *
       * ```jsx
       * const x = useMotionValue(0)
       * x.set(10)
       * ```
       *
       * @param latest - Latest value to set.
       * @param render - Whether to notify render subscribers. Defaults to `true`
       *
       * @public
       */
      set(v, render = true) {
          if (!render || !this.passiveEffect) {
              this.updateAndNotify(v, render);
          }
          else {
              this.passiveEffect(v, this.updateAndNotify);
          }
      }
      setWithVelocity(prev, current, delta) {
          this.set(current);
          this.prev = prev;
          this.timeDelta = delta;
      }
      /**
       * Set the state of the `MotionValue`, stopping any active animations,
       * effects, and resets velocity to `0`.
       */
      jump(v) {
          this.updateAndNotify(v);
          this.prev = v;
          this.stop();
          if (this.stopPassiveEffect)
              this.stopPassiveEffect();
      }
      /**
       * Returns the latest state of `MotionValue`
       *
       * @returns - The latest state of `MotionValue`
       *
       * @public
       */
      get() {
          return this.current;
      }
      /**
       * @public
       */
      getPrevious() {
          return this.prev;
      }
      /**
       * Returns the latest velocity of `MotionValue`
       *
       * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
       *
       * @public
       */
      getVelocity() {
          // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
          return this.canTrackVelocity
              ? // These casts could be avoided if parseFloat would be typed better
                  velocityPerSecond(parseFloat(this.current) -
                      parseFloat(this.prev), this.timeDelta)
              : 0;
      }
      /**
       * Registers a new animation to control this `MotionValue`. Only one
       * animation can drive a `MotionValue` at one time.
       *
       * ```jsx
       * value.start()
       * ```
       *
       * @param animation - A function that starts the provided animation
       *
       * @internal
       */
      start(startAnimation) {
          this.stop();
          return new Promise((resolve) => {
              this.hasAnimated = true;
              this.animation = startAnimation(resolve);
              if (this.events.animationStart) {
                  this.events.animationStart.notify();
              }
          }).then(() => {
              if (this.events.animationComplete) {
                  this.events.animationComplete.notify();
              }
              this.clearAnimation();
          });
      }
      /**
       * Stop the currently active animation.
       *
       * @public
       */
      stop() {
          if (this.animation) {
              this.animation.stop();
              if (this.events.animationCancel) {
                  this.events.animationCancel.notify();
              }
          }
          this.clearAnimation();
      }
      /**
       * Returns `true` if this value is currently animating.
       *
       * @public
       */
      isAnimating() {
          return !!this.animation;
      }
      clearAnimation() {
          delete this.animation;
      }
      /**
       * Destroy and clean up subscribers to this `MotionValue`.
       *
       * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
       * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
       * created a `MotionValue` via the `motionValue` function.
       *
       * @public
       */
      destroy() {
          this.clearListeners();
          this.stop();
          if (this.stopPassiveEffect) {
              this.stopPassiveEffect();
          }
      }
  }
  function motionValue(init, options) {
      return new MotionValue(init, options);
  }

  /**
   * Tests a provided value against a ValueType
   */
  const testValueType = (v) => (type) => type.test(v);

  /**
   * ValueType for "auto"
   */
  const auto = {
      test: (v) => v === "auto",
      parse: (v) => v,
  };

  /**
   * A list of value types commonly used for dimensions
   */
  const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
  /**
   * Tests a dimensional value against the list of dimension ValueTypes
   */
  const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

  /**
   * A list of all ValueTypes
   */
  const valueTypes = [...dimensionValueTypes, color, complex];
  /**
   * Tests a value against the list of ValueTypes
   */
  const findValueType = (v) => valueTypes.find(testValueType(v));

  /**
   * Set VisualElement's MotionValue, creating a new MotionValue for it if
   * it doesn't exist.
   */
  function setMotionValue(visualElement, key, value) {
      if (visualElement.hasValue(key)) {
          visualElement.getValue(key).set(value);
      }
      else {
          visualElement.addValue(key, motionValue(value));
      }
  }
  function setTarget(visualElement, definition) {
      const resolved = resolveVariant(visualElement, definition);
      let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
      target = { ...target, ...transitionEnd };
      for (const key in target) {
          const value = resolveFinalValueInKeyframes(target[key]);
          setMotionValue(visualElement, key, value);
      }
  }
  function checkTargetForNewValues(visualElement, target, origin) {
      var _a, _b;
      const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
      const numNewValues = newValueKeys.length;
      if (!numNewValues)
          return;
      for (let i = 0; i < numNewValues; i++) {
          const key = newValueKeys[i];
          const targetValue = target[key];
          let value = null;
          /**
           * If the target is a series of keyframes, we can use the first value
           * in the array. If this first value is null, we'll still need to read from the DOM.
           */
          if (Array.isArray(targetValue)) {
              value = targetValue[0];
          }
          /**
           * If the target isn't keyframes, or the first keyframe was null, we need to
           * first check if an origin value was explicitly defined in the transition as "from",
           * if not read the value from the DOM. As an absolute fallback, take the defined target value.
           */
          if (value === null) {
              value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
          }
          /**
           * If value is still undefined or null, ignore it. Preferably this would throw,
           * but this was causing issues in Framer.
           */
          if (value === undefined || value === null)
              continue;
          if (typeof value === "string" &&
              (isNumericalString(value) || isZeroValueString(value))) {
              // If this is a number read as a string, ie "0" or "200", convert it to a number
              value = parseFloat(value);
          }
          else if (!findValueType(value) && complex.test(targetValue)) {
              value = getAnimatableNone(key, targetValue);
          }
          visualElement.addValue(key, motionValue(value, { owner: visualElement }));
          if (origin[key] === undefined) {
              origin[key] = value;
          }
          if (value !== null)
              visualElement.setBaseTarget(key, value);
      }
  }
  function getOriginFromTransition(key, transition) {
      if (!transition)
          return;
      const valueTransition = transition[key] || transition["default"] || transition;
      return valueTransition.from;
  }
  function getOrigin(target, transition, visualElement) {
      const origin = {};
      for (const key in target) {
          const transitionOrigin = getOriginFromTransition(key, transition);
          if (transitionOrigin !== undefined) {
              origin[key] = transitionOrigin;
          }
          else {
              const value = visualElement.getValue(key);
              if (value) {
                  origin[key] = value.get();
              }
          }
      }
      return origin;
  }

  /**
   * Decide whether we should block this animation. Previously, we achieved this
   * just by checking whether the key was listed in protectedKeys, but this
   * posed problems if an animation was triggered by afterChildren and protectedKeys
   * had been set to true in the meantime.
   */
  function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
      const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
      needsAnimating[key] = false;
      return shouldBlock;
  }
  function hasKeyframesChanged(value, target) {
      const current = value.get();
      if (Array.isArray(target)) {
          for (let i = 0; i < target.length; i++) {
              if (target[i] !== current)
                  return true;
          }
      }
      else {
          return current !== target;
      }
  }
  function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
      let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
      const willChange = visualElement.getValue("willChange");
      if (transitionOverride)
          transition = transitionOverride;
      const animations = [];
      const animationTypeState = type &&
          visualElement.animationState &&
          visualElement.animationState.getState()[type];
      for (const key in target) {
          const value = visualElement.getValue(key);
          const valueTarget = target[key];
          if (!value ||
              valueTarget === undefined ||
              (animationTypeState &&
                  shouldBlockAnimation(animationTypeState, key))) {
              continue;
          }
          const valueTransition = {
              delay,
              elapsed: 0,
              ...getValueTransition(transition || {}, key),
          };
          /**
           * If this is the first time a value is being animated, check
           * to see if we're handling off from an existing animation.
           */
          if (window.HandoffAppearAnimations) {
              const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
              if (appearId) {
                  const elapsed = window.HandoffAppearAnimations(appearId, key, value, frame);
                  if (elapsed !== null) {
                      valueTransition.elapsed = elapsed;
                      valueTransition.isHandoff = true;
                  }
              }
          }
          let canSkip = !valueTransition.isHandoff &&
              !hasKeyframesChanged(value, valueTarget);
          if (valueTransition.type === "spring" &&
              (value.getVelocity() || valueTransition.velocity)) {
              canSkip = false;
          }
          /**
           * Temporarily disable skipping animations if there's an animation in
           * progress. Better would be to track the current target of a value
           * and compare that against valueTarget.
           */
          if (value.animation) {
              canSkip = false;
          }
          if (canSkip)
              continue;
          value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key)
              ? { type: false }
              : valueTransition));
          const animation = value.animation;
          if (isWillChangeMotionValue(willChange)) {
              willChange.add(key);
              animation.then(() => willChange.remove(key));
          }
          animations.push(animation);
      }
      if (transitionEnd) {
          Promise.all(animations).then(() => {
              transitionEnd && setTarget(visualElement, transitionEnd);
          });
      }
      return animations;
  }

  function animateVariant(visualElement, variant, options = {}) {
      const resolved = resolveVariant(visualElement, variant, options.custom);
      let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
      if (options.transitionOverride) {
          transition = options.transitionOverride;
      }
      /**
       * If we have a variant, create a callback that runs it as an animation.
       * Otherwise, we resolve a Promise immediately for a composable no-op.
       */
      const getAnimation = resolved
          ? () => Promise.all(animateTarget(visualElement, resolved, options))
          : () => Promise.resolve();
      /**
       * If we have children, create a callback that runs all their animations.
       * Otherwise, we resolve a Promise immediately for a composable no-op.
       */
      const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size
          ? (forwardDelay = 0) => {
              const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
              return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
          }
          : () => Promise.resolve();
      /**
       * If the transition explicitly defines a "when" option, we need to resolve either
       * this animation or all children animations before playing the other.
       */
      const { when } = transition;
      if (when) {
          const [first, last] = when === "beforeChildren"
              ? [getAnimation, getChildAnimations]
              : [getChildAnimations, getAnimation];
          return first().then(() => last());
      }
      else {
          return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
      }
  }
  function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
      const animations = [];
      const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
      const generateStaggerDuration = staggerDirection === 1
          ? (i = 0) => i * staggerChildren
          : (i = 0) => maxStaggerDuration - i * staggerChildren;
      Array.from(visualElement.variantChildren)
          .sort(sortByTreeOrder)
          .forEach((child, i) => {
          child.notify("AnimationStart", variant);
          animations.push(animateVariant(child, variant, {
              ...options,
              delay: delayChildren + generateStaggerDuration(i),
          }).then(() => child.notify("AnimationComplete", variant)));
      });
      return Promise.all(animations);
  }
  function sortByTreeOrder(a, b) {
      return a.sortNodePosition(b);
  }

  function animateVisualElement(visualElement, definition, options = {}) {
      visualElement.notify("AnimationStart", definition);
      let animation;
      if (Array.isArray(definition)) {
          const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
          animation = Promise.all(animations);
      }
      else if (typeof definition === "string") {
          animation = animateVariant(visualElement, definition, options);
      }
      else {
          const resolvedDefinition = typeof definition === "function"
              ? resolveVariant(visualElement, definition, options.custom)
              : definition;
          animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
      }
      return animation.then(() => visualElement.notify("AnimationComplete", definition));
  }

  const reversePriorityOrder = [...variantPriorityOrder].reverse();
  const numAnimationTypes = variantPriorityOrder.length;
  function animateList(visualElement) {
      return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
  }
  function createAnimationState(visualElement) {
      let animate = animateList(visualElement);
      const state = createState();
      let isInitialRender = true;
      /**
       * This function will be used to reduce the animation definitions for
       * each active animation type into an object of resolved values for it.
       */
      const buildResolvedTypeValues = (acc, definition) => {
          const resolved = resolveVariant(visualElement, definition);
          if (resolved) {
              const { transition, transitionEnd, ...target } = resolved;
              acc = { ...acc, ...target, ...transitionEnd };
          }
          return acc;
      };
      /**
       * This just allows us to inject mocked animation functions
       * @internal
       */
      function setAnimateFunction(makeAnimator) {
          animate = makeAnimator(visualElement);
      }
      /**
       * When we receive new props, we need to:
       * 1. Create a list of protected keys for each type. This is a directory of
       *    value keys that are currently being "handled" by types of a higher priority
       *    so that whenever an animation is played of a given type, these values are
       *    protected from being animated.
       * 2. Determine if an animation type needs animating.
       * 3. Determine if any values have been removed from a type and figure out
       *    what to animate those to.
       */
      function animateChanges(options, changedActiveType) {
          const props = visualElement.getProps();
          const context = visualElement.getVariantContext(true) || {};
          /**
           * A list of animations that we'll build into as we iterate through the animation
           * types. This will get executed at the end of the function.
           */
          const animations = [];
          /**
           * Keep track of which values have been removed. Then, as we hit lower priority
           * animation types, we can check if they contain removed values and animate to that.
           */
          const removedKeys = new Set();
          /**
           * A dictionary of all encountered keys. This is an object to let us build into and
           * copy it without iteration. Each time we hit an animation type we set its protected
           * keys - the keys its not allowed to animate - to the latest version of this object.
           */
          let encounteredKeys = {};
          /**
           * If a variant has been removed at a given index, and this component is controlling
           * variant animations, we want to ensure lower-priority variants are forced to animate.
           */
          let removedVariantIndex = Infinity;
          /**
           * Iterate through all animation types in reverse priority order. For each, we want to
           * detect which values it's handling and whether or not they've changed (and therefore
           * need to be animated). If any values have been removed, we want to detect those in
           * lower priority props and flag for animation.
           */
          for (let i = 0; i < numAnimationTypes; i++) {
              const type = reversePriorityOrder[i];
              const typeState = state[type];
              const prop = props[type] !== undefined ? props[type] : context[type];
              const propIsVariant = isVariantLabel(prop);
              /**
               * If this type has *just* changed isActive status, set activeDelta
               * to that status. Otherwise set to null.
               */
              const activeDelta = type === changedActiveType ? typeState.isActive : null;
              if (activeDelta === false)
                  removedVariantIndex = i;
              /**
               * If this prop is an inherited variant, rather than been set directly on the
               * component itself, we want to make sure we allow the parent to trigger animations.
               *
               * TODO: Can probably change this to a !isControllingVariants check
               */
              let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
              /**
               *
               */
              if (isInherited &&
                  isInitialRender &&
                  visualElement.manuallyAnimateOnMount) {
                  isInherited = false;
              }
              /**
               * Set all encountered keys so far as the protected keys for this type. This will
               * be any key that has been animated or otherwise handled by active, higher-priortiy types.
               */
              typeState.protectedKeys = { ...encounteredKeys };
              // Check if we can skip analysing this prop early
              if (
              // If it isn't active and hasn't *just* been set as inactive
              (!typeState.isActive && activeDelta === null) ||
                  // If we didn't and don't have any defined prop for this animation type
                  (!prop && !typeState.prevProp) ||
                  // Or if the prop doesn't define an animation
                  isAnimationControls(prop) ||
                  typeof prop === "boolean") {
                  continue;
              }
              /**
               * As we go look through the values defined on this type, if we detect
               * a changed value or a value that was removed in a higher priority, we set
               * this to true and add this prop to the animation list.
               */
              const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
              let shouldAnimateType = variantDidChange ||
                  // If we're making this variant active, we want to always make it active
                  (type === changedActiveType &&
                      typeState.isActive &&
                      !isInherited &&
                      propIsVariant) ||
                  // If we removed a higher-priority variant (i is in reverse order)
                  (i > removedVariantIndex && propIsVariant);
              let handledRemovedValues = false;
              /**
               * As animations can be set as variant lists, variants or target objects, we
               * coerce everything to an array if it isn't one already
               */
              const definitionList = Array.isArray(prop) ? prop : [prop];
              /**
               * Build an object of all the resolved values. We'll use this in the subsequent
               * animateChanges calls to determine whether a value has changed.
               */
              let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
              if (activeDelta === false)
                  resolvedValues = {};
              /**
               * Now we need to loop through all the keys in the prev prop and this prop,
               * and decide:
               * 1. If the value has changed, and needs animating
               * 2. If it has been removed, and needs adding to the removedKeys set
               * 3. If it has been removed in a higher priority type and needs animating
               * 4. If it hasn't been removed in a higher priority but hasn't changed, and
               *    needs adding to the type's protectedKeys list.
               */
              const { prevResolvedValues = {} } = typeState;
              const allKeys = {
                  ...prevResolvedValues,
                  ...resolvedValues,
              };
              const markToAnimate = (key) => {
                  shouldAnimateType = true;
                  if (removedKeys.has(key)) {
                      handledRemovedValues = true;
                      removedKeys.delete(key);
                  }
                  typeState.needsAnimating[key] = true;
              };
              for (const key in allKeys) {
                  const next = resolvedValues[key];
                  const prev = prevResolvedValues[key];
                  // If we've already handled this we can just skip ahead
                  if (encounteredKeys.hasOwnProperty(key))
                      continue;
                  /**
                   * If the value has changed, we probably want to animate it.
                   */
                  let valueHasChanged = false;
                  if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                      valueHasChanged = !shallowCompare(next, prev);
                  }
                  else {
                      valueHasChanged = next !== prev;
                  }
                  if (valueHasChanged) {
                      if (next !== undefined) {
                          // If next is defined and doesn't equal prev, it needs animating
                          markToAnimate(key);
                      }
                      else {
                          // If it's undefined, it's been removed.
                          removedKeys.add(key);
                      }
                  }
                  else if (next !== undefined && removedKeys.has(key)) {
                      /**
                       * If next hasn't changed and it isn't undefined, we want to check if it's
                       * been removed by a higher priority
                       */
                      markToAnimate(key);
                  }
                  else {
                      /**
                       * If it hasn't changed, we add it to the list of protected values
                       * to ensure it doesn't get animated.
                       */
                      typeState.protectedKeys[key] = true;
                  }
              }
              /**
               * Update the typeState so next time animateChanges is called we can compare the
               * latest prop and resolvedValues to these.
               */
              typeState.prevProp = prop;
              typeState.prevResolvedValues = resolvedValues;
              /**
               *
               */
              if (typeState.isActive) {
                  encounteredKeys = { ...encounteredKeys, ...resolvedValues };
              }
              if (isInitialRender && visualElement.blockInitialAnimation) {
                  shouldAnimateType = false;
              }
              /**
               * If this is an inherited prop we want to hard-block animations
               */
              if (shouldAnimateType && (!isInherited || handledRemovedValues)) {
                  animations.push(...definitionList.map((animation) => ({
                      animation: animation,
                      options: { type, ...options },
                  })));
              }
          }
          /**
           * If there are some removed value that haven't been dealt with,
           * we need to create a new animation that falls back either to the value
           * defined in the style prop, or the last read value.
           */
          if (removedKeys.size) {
              const fallbackAnimation = {};
              removedKeys.forEach((key) => {
                  const fallbackTarget = visualElement.getBaseTarget(key);
                  if (fallbackTarget !== undefined) {
                      fallbackAnimation[key] = fallbackTarget;
                  }
              });
              animations.push({ animation: fallbackAnimation });
          }
          let shouldAnimate = Boolean(animations.length);
          if (isInitialRender &&
              (props.initial === false || props.initial === props.animate) &&
              !visualElement.manuallyAnimateOnMount) {
              shouldAnimate = false;
          }
          isInitialRender = false;
          return shouldAnimate ? animate(animations) : Promise.resolve();
      }
      /**
       * Change whether a certain animation type is active.
       */
      function setActive(type, isActive, options) {
          var _a;
          // If the active state hasn't changed, we can safely do nothing here
          if (state[type].isActive === isActive)
              return Promise.resolve();
          // Propagate active change to children
          (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
          state[type].isActive = isActive;
          const animations = animateChanges(options, type);
          for (const key in state) {
              state[key].protectedKeys = {};
          }
          return animations;
      }
      return {
          animateChanges,
          setActive,
          setAnimateFunction,
          getState: () => state,
      };
  }
  function checkVariantsDidChange(prev, next) {
      if (typeof next === "string") {
          return next !== prev;
      }
      else if (Array.isArray(next)) {
          return !shallowCompare(next, prev);
      }
      return false;
  }
  function createTypeState(isActive = false) {
      return {
          isActive,
          protectedKeys: {},
          needsAnimating: {},
          prevResolvedValues: {},
      };
  }
  function createState() {
      return {
          animate: createTypeState(true),
          whileInView: createTypeState(),
          whileHover: createTypeState(),
          whileTap: createTypeState(),
          whileDrag: createTypeState(),
          whileFocus: createTypeState(),
          exit: createTypeState(),
      };
  }

  class AnimationFeature extends Feature {
      /**
       * We dynamically generate the AnimationState manager as it contains a reference
       * to the underlying animation library. We only want to load that if we load this,
       * so people can optionally code split it out using the `m` component.
       */
      constructor(node) {
          super(node);
          node.animationState || (node.animationState = createAnimationState(node));
      }
      updateAnimationControlsSubscription() {
          const { animate } = this.node.getProps();
          this.unmount();
          if (isAnimationControls(animate)) {
              this.unmount = animate.subscribe(this.node);
          }
      }
      /**
       * Subscribe any provided AnimationControls to the component's VisualElement
       */
      mount() {
          this.updateAnimationControlsSubscription();
      }
      update() {
          const { animate } = this.node.getProps();
          const { animate: prevAnimate } = this.node.prevProps || {};
          if (animate !== prevAnimate) {
              this.updateAnimationControlsSubscription();
          }
      }
      unmount() { }
  }

  let id$1 = 0;
  class ExitAnimationFeature extends Feature {
      constructor() {
          super(...arguments);
          this.id = id$1++;
      }
      update() {
          if (!this.node.presenceContext)
              return;
          const { isPresent, onExitComplete, custom } = this.node.presenceContext;
          const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
          if (!this.node.animationState || isPresent === prevIsPresent) {
              return;
          }
          const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom });
          if (onExitComplete && !isPresent) {
              exitAnimation.then(() => onExitComplete(this.id));
          }
      }
      mount() {
          const { register } = this.node.presenceContext || {};
          if (register) {
              this.unmount = register(this.id);
          }
      }
      unmount() { }
  }

  const animations = {
      animation: {
          Feature: AnimationFeature,
      },
      exit: {
          Feature: ExitAnimationFeature,
      },
  };

  const distance = (a, b) => Math.abs(a - b);
  function distance2D(a, b) {
      // Multi-dimensional
      const xDelta = distance(a.x, b.x);
      const yDelta = distance(a.y, b.y);
      return Math.sqrt(xDelta ** 2 + yDelta ** 2);
  }

  /**
   * @internal
   */
  class PanSession {
      constructor(event, handlers, { transformPagePoint, contextWindow, dragSnapToOrigin = false } = {}) {
          /**
           * @internal
           */
          this.startEvent = null;
          /**
           * @internal
           */
          this.lastMoveEvent = null;
          /**
           * @internal
           */
          this.lastMoveEventInfo = null;
          /**
           * @internal
           */
          this.handlers = {};
          /**
           * @internal
           */
          this.contextWindow = window;
          this.updatePoint = () => {
              if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                  return;
              const info = getPanInfo(this.lastMoveEventInfo, this.history);
              const isPanStarted = this.startEvent !== null;
              // Only start panning if the offset is larger than 3 pixels. If we make it
              // any larger than this we'll want to reset the pointer history
              // on the first update to avoid visual snapping to the cursoe.
              const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
              if (!isPanStarted && !isDistancePastThreshold)
                  return;
              const { point } = info;
              const { timestamp } = frameData;
              this.history.push({ ...point, timestamp });
              const { onStart, onMove } = this.handlers;
              if (!isPanStarted) {
                  onStart && onStart(this.lastMoveEvent, info);
                  this.startEvent = this.lastMoveEvent;
              }
              onMove && onMove(this.lastMoveEvent, info);
          };
          this.handlePointerMove = (event, info) => {
              this.lastMoveEvent = event;
              this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
              // Throttle mouse move event to once per frame
              frame.update(this.updatePoint, true);
          };
          this.handlePointerUp = (event, info) => {
              this.end();
              const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
              if (this.dragSnapToOrigin)
                  resumeAnimation && resumeAnimation();
              if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                  return;
              const panInfo = getPanInfo(event.type === "pointercancel"
                  ? this.lastMoveEventInfo
                  : transformPoint(info, this.transformPagePoint), this.history);
              if (this.startEvent && onEnd) {
                  onEnd(event, panInfo);
              }
              onSessionEnd && onSessionEnd(event, panInfo);
          };
          // If we have more than one touch, don't start detecting this gesture
          if (!isPrimaryPointer(event))
              return;
          this.dragSnapToOrigin = dragSnapToOrigin;
          this.handlers = handlers;
          this.transformPagePoint = transformPagePoint;
          this.contextWindow = contextWindow || window;
          const info = extractEventInfo(event);
          const initialInfo = transformPoint(info, this.transformPagePoint);
          const { point } = initialInfo;
          const { timestamp } = frameData;
          this.history = [{ ...point, timestamp }];
          const { onSessionStart } = handlers;
          onSessionStart &&
              onSessionStart(event, getPanInfo(initialInfo, this.history));
          this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
      }
      updateHandlers(handlers) {
          this.handlers = handlers;
      }
      end() {
          this.removeListeners && this.removeListeners();
          cancelFrame(this.updatePoint);
      }
  }
  function transformPoint(info, transformPagePoint) {
      return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
  }
  function subtractPoint(a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
  }
  function getPanInfo({ point }, history) {
      return {
          point,
          delta: subtractPoint(point, lastDevicePoint(history)),
          offset: subtractPoint(point, startDevicePoint(history)),
          velocity: getVelocity(history, 0.1),
      };
  }
  function startDevicePoint(history) {
      return history[0];
  }
  function lastDevicePoint(history) {
      return history[history.length - 1];
  }
  function getVelocity(history, timeDelta) {
      if (history.length < 2) {
          return { x: 0, y: 0 };
      }
      let i = history.length - 1;
      let timestampedPoint = null;
      const lastPoint = lastDevicePoint(history);
      while (i >= 0) {
          timestampedPoint = history[i];
          if (lastPoint.timestamp - timestampedPoint.timestamp >
              secondsToMilliseconds(timeDelta)) {
              break;
          }
          i--;
      }
      if (!timestampedPoint) {
          return { x: 0, y: 0 };
      }
      const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
      if (time === 0) {
          return { x: 0, y: 0 };
      }
      const currentVelocity = {
          x: (lastPoint.x - timestampedPoint.x) / time,
          y: (lastPoint.y - timestampedPoint.y) / time,
      };
      if (currentVelocity.x === Infinity) {
          currentVelocity.x = 0;
      }
      if (currentVelocity.y === Infinity) {
          currentVelocity.y = 0;
      }
      return currentVelocity;
  }

  function calcLength(axis) {
      return axis.max - axis.min;
  }
  function isNear(value, target = 0, maxDistance = 0.01) {
      return Math.abs(value - target) <= maxDistance;
  }
  function calcAxisDelta(delta, source, target, origin = 0.5) {
      delta.origin = origin;
      delta.originPoint = mix(source.min, source.max, delta.origin);
      delta.scale = calcLength(target) / calcLength(source);
      if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
          delta.scale = 1;
      delta.translate =
          mix(target.min, target.max, delta.origin) - delta.originPoint;
      if (isNear(delta.translate) || isNaN(delta.translate))
          delta.translate = 0;
  }
  function calcBoxDelta(delta, source, target, origin) {
      calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
      calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
  }
  function calcRelativeAxis(target, relative, parent) {
      target.min = parent.min + relative.min;
      target.max = target.min + calcLength(relative);
  }
  function calcRelativeBox(target, relative, parent) {
      calcRelativeAxis(target.x, relative.x, parent.x);
      calcRelativeAxis(target.y, relative.y, parent.y);
  }
  function calcRelativeAxisPosition(target, layout, parent) {
      target.min = layout.min - parent.min;
      target.max = target.min + calcLength(layout);
  }
  function calcRelativePosition(target, layout, parent) {
      calcRelativeAxisPosition(target.x, layout.x, parent.x);
      calcRelativeAxisPosition(target.y, layout.y, parent.y);
  }

  /**
   * Apply constraints to a point. These constraints are both physical along an
   * axis, and an elastic factor that determines how much to constrain the point
   * by if it does lie outside the defined parameters.
   */
  function applyConstraints(point, { min, max }, elastic) {
      if (min !== undefined && point < min) {
          // If we have a min point defined, and this is outside of that, constrain
          point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
      }
      else if (max !== undefined && point > max) {
          // If we have a max point defined, and this is outside of that, constrain
          point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
      }
      return point;
  }
  /**
   * Calculate constraints in terms of the viewport when defined relatively to the
   * measured axis. This is measured from the nearest edge, so a max constraint of 200
   * on an axis with a max value of 300 would return a constraint of 500 - axis length
   */
  function calcRelativeAxisConstraints(axis, min, max) {
      return {
          min: min !== undefined ? axis.min + min : undefined,
          max: max !== undefined
              ? axis.max + max - (axis.max - axis.min)
              : undefined,
      };
  }
  /**
   * Calculate constraints in terms of the viewport when
   * defined relatively to the measured bounding box.
   */
  function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
      return {
          x: calcRelativeAxisConstraints(layoutBox.x, left, right),
          y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
      };
  }
  /**
   * Calculate viewport constraints when defined as another viewport-relative axis
   */
  function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
      let min = constraintsAxis.min - layoutAxis.min;
      let max = constraintsAxis.max - layoutAxis.max;
      // If the constraints axis is actually smaller than the layout axis then we can
      // flip the constraints
      if (constraintsAxis.max - constraintsAxis.min <
          layoutAxis.max - layoutAxis.min) {
          [min, max] = [max, min];
      }
      return { min, max };
  }
  /**
   * Calculate viewport constraints when defined as another viewport-relative box
   */
  function calcViewportConstraints(layoutBox, constraintsBox) {
      return {
          x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
          y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
      };
  }
  /**
   * Calculate a transform origin relative to the source axis, between 0-1, that results
   * in an asthetically pleasing scale/transform needed to project from source to target.
   */
  function calcOrigin(source, target) {
      let origin = 0.5;
      const sourceLength = calcLength(source);
      const targetLength = calcLength(target);
      if (targetLength > sourceLength) {
          origin = progress(target.min, target.max - sourceLength, source.min);
      }
      else if (sourceLength > targetLength) {
          origin = progress(source.min, source.max - targetLength, target.min);
      }
      return clamp(0, 1, origin);
  }
  /**
   * Rebase the calculated viewport constraints relative to the layout.min point.
   */
  function rebaseAxisConstraints(layout, constraints) {
      const relativeConstraints = {};
      if (constraints.min !== undefined) {
          relativeConstraints.min = constraints.min - layout.min;
      }
      if (constraints.max !== undefined) {
          relativeConstraints.max = constraints.max - layout.min;
      }
      return relativeConstraints;
  }
  const defaultElastic = 0.35;
  /**
   * Accepts a dragElastic prop and returns resolved elastic values for each axis.
   */
  function resolveDragElastic(dragElastic = defaultElastic) {
      if (dragElastic === false) {
          dragElastic = 0;
      }
      else if (dragElastic === true) {
          dragElastic = defaultElastic;
      }
      return {
          x: resolveAxisElastic(dragElastic, "left", "right"),
          y: resolveAxisElastic(dragElastic, "top", "bottom"),
      };
  }
  function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
      return {
          min: resolvePointElastic(dragElastic, minLabel),
          max: resolvePointElastic(dragElastic, maxLabel),
      };
  }
  function resolvePointElastic(dragElastic, label) {
      return typeof dragElastic === "number"
          ? dragElastic
          : dragElastic[label] || 0;
  }

  const createAxisDelta = () => ({
      translate: 0,
      scale: 1,
      origin: 0,
      originPoint: 0,
  });
  const createDelta = () => ({
      x: createAxisDelta(),
      y: createAxisDelta(),
  });
  const createAxis = () => ({ min: 0, max: 0 });
  const createBox = () => ({
      x: createAxis(),
      y: createAxis(),
  });

  function eachAxis(callback) {
      return [callback("x"), callback("y")];
  }

  /**
   * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
   * it's easier to consider each axis individually. This function returns a bounding box
   * as a map of single-axis min/max values.
   */
  function convertBoundingBoxToBox({ top, left, right, bottom, }) {
      return {
          x: { min: left, max: right },
          y: { min: top, max: bottom },
      };
  }
  function convertBoxToBoundingBox({ x, y }) {
      return { top: y.min, right: x.max, bottom: y.max, left: x.min };
  }
  /**
   * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
   * provided by Framer to allow measured points to be corrected for device scaling. This is used
   * when measuring DOM elements and DOM event points.
   */
  function transformBoxPoints(point, transformPoint) {
      if (!transformPoint)
          return point;
      const topLeft = transformPoint({ x: point.left, y: point.top });
      const bottomRight = transformPoint({ x: point.right, y: point.bottom });
      return {
          top: topLeft.y,
          left: topLeft.x,
          bottom: bottomRight.y,
          right: bottomRight.x,
      };
  }

  function isIdentityScale(scale) {
      return scale === undefined || scale === 1;
  }
  function hasScale({ scale, scaleX, scaleY }) {
      return (!isIdentityScale(scale) ||
          !isIdentityScale(scaleX) ||
          !isIdentityScale(scaleY));
  }
  function hasTransform(values) {
      return (hasScale(values) ||
          has2DTranslate(values) ||
          values.z ||
          values.rotate ||
          values.rotateX ||
          values.rotateY);
  }
  function has2DTranslate(values) {
      return is2DTranslate(values.x) || is2DTranslate(values.y);
  }
  function is2DTranslate(value) {
      return value && value !== "0%";
  }

  /**
   * Scales a point based on a factor and an originPoint
   */
  function scalePoint(point, scale, originPoint) {
      const distanceFromOrigin = point - originPoint;
      const scaled = scale * distanceFromOrigin;
      return originPoint + scaled;
  }
  /**
   * Applies a translate/scale delta to a point
   */
  function applyPointDelta(point, translate, scale, originPoint, boxScale) {
      if (boxScale !== undefined) {
          point = scalePoint(point, boxScale, originPoint);
      }
      return scalePoint(point, scale, originPoint) + translate;
  }
  /**
   * Applies a translate/scale delta to an axis
   */
  function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
      axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
      axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
  }
  /**
   * Applies a translate/scale delta to a box
   */
  function applyBoxDelta(box, { x, y }) {
      applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
      applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
  }
  /**
   * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
   * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
   *
   * This is the final nested loop within updateLayoutDelta for future refactoring
   */
  function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
      const treeLength = treePath.length;
      if (!treeLength)
          return;
      // Reset the treeScale
      treeScale.x = treeScale.y = 1;
      let node;
      let delta;
      for (let i = 0; i < treeLength; i++) {
          node = treePath[i];
          delta = node.projectionDelta;
          /**
           * TODO: Prefer to remove this, but currently we have motion components with
           * display: contents in Framer.
           */
          const instance = node.instance;
          if (instance &&
              instance.style &&
              instance.style.display === "contents") {
              continue;
          }
          if (isSharedTransition &&
              node.options.layoutScroll &&
              node.scroll &&
              node !== node.root) {
              transformBox(box, {
                  x: -node.scroll.offset.x,
                  y: -node.scroll.offset.y,
              });
          }
          if (delta) {
              // Incoporate each ancestor's scale into a culmulative treeScale for this component
              treeScale.x *= delta.x.scale;
              treeScale.y *= delta.y.scale;
              // Apply each ancestor's calculated delta into this component's recorded layout box
              applyBoxDelta(box, delta);
          }
          if (isSharedTransition && hasTransform(node.latestValues)) {
              transformBox(box, node.latestValues);
          }
      }
      /**
       * Snap tree scale back to 1 if it's within a non-perceivable threshold.
       * This will help reduce useless scales getting rendered.
       */
      treeScale.x = snapToDefault(treeScale.x);
      treeScale.y = snapToDefault(treeScale.y);
  }
  function snapToDefault(scale) {
      if (Number.isInteger(scale))
          return scale;
      return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
  }
  function translateAxis(axis, distance) {
      axis.min = axis.min + distance;
      axis.max = axis.max + distance;
  }
  /**
   * Apply a transform to an axis from the latest resolved motion values.
   * This function basically acts as a bridge between a flat motion value map
   * and applyAxisDelta
   */
  function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
      const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
      const originPoint = mix(axis.min, axis.max, axisOrigin);
      // Apply the axis delta to the final axis
      applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
  }
  /**
   * The names of the motion values we want to apply as translation, scale and origin.
   */
  const xKeys$1 = ["x", "scaleX", "originX"];
  const yKeys$1 = ["y", "scaleY", "originY"];
  /**
   * Apply a transform to a box from the latest resolved motion values.
   */
  function transformBox(box, transform) {
      transformAxis(box.x, transform, xKeys$1);
      transformAxis(box.y, transform, yKeys$1);
  }

  function measureViewportBox(instance, transformPoint) {
      return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
  }
  function measurePageBox(element, rootProjectionNode, transformPagePoint) {
      const viewportBox = measureViewportBox(element, transformPagePoint);
      const { scroll } = rootProjectionNode;
      if (scroll) {
          translateAxis(viewportBox.x, scroll.offset.x);
          translateAxis(viewportBox.y, scroll.offset.y);
      }
      return viewportBox;
  }

  // Fixes https://github.com/framer/motion/issues/2270
  const getContextWindow = ({ current }) => {
      return current ? current.ownerDocument.defaultView : null;
  };

  const elementDragControls = new WeakMap();
  /**
   *
   */
  // let latestPointerEvent: PointerEvent
  class VisualElementDragControls {
      constructor(visualElement) {
          // This is a reference to the global drag gesture lock, ensuring only one component
          // can "capture" the drag of one or both axes.
          // TODO: Look into moving this into pansession?
          this.openGlobalLock = null;
          this.isDragging = false;
          this.currentDirection = null;
          this.originPoint = { x: 0, y: 0 };
          /**
           * The permitted boundaries of travel, in pixels.
           */
          this.constraints = false;
          this.hasMutatedConstraints = false;
          /**
           * The per-axis resolved elastic values.
           */
          this.elastic = createBox();
          this.visualElement = visualElement;
      }
      start(originEvent, { snapToCursor = false } = {}) {
          /**
           * Don't start dragging if this component is exiting
           */
          const { presenceContext } = this.visualElement;
          if (presenceContext && presenceContext.isPresent === false)
              return;
          const onSessionStart = (event) => {
              const { dragSnapToOrigin } = this.getProps();
              // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
              // the component.
              dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
              if (snapToCursor) {
                  this.snapToCursor(extractEventInfo(event, "page").point);
              }
          };
          const onStart = (event, info) => {
              // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
              const { drag, dragPropagation, onDragStart } = this.getProps();
              if (drag && !dragPropagation) {
                  if (this.openGlobalLock)
                      this.openGlobalLock();
                  this.openGlobalLock = getGlobalLock(drag);
                  // If we don 't have the lock, don't start dragging
                  if (!this.openGlobalLock)
                      return;
              }
              this.isDragging = true;
              this.currentDirection = null;
              this.resolveConstraints();
              if (this.visualElement.projection) {
                  this.visualElement.projection.isAnimationBlocked = true;
                  this.visualElement.projection.target = undefined;
              }
              /**
               * Record gesture origin
               */
              eachAxis((axis) => {
                  let current = this.getAxisMotionValue(axis).get() || 0;
                  /**
                   * If the MotionValue is a percentage value convert to px
                   */
                  if (percent.test(current)) {
                      const { projection } = this.visualElement;
                      if (projection && projection.layout) {
                          const measuredAxis = projection.layout.layoutBox[axis];
                          if (measuredAxis) {
                              const length = calcLength(measuredAxis);
                              current = length * (parseFloat(current) / 100);
                          }
                      }
                  }
                  this.originPoint[axis] = current;
              });
              // Fire onDragStart event
              if (onDragStart) {
                  frame.update(() => onDragStart(event, info), false, true);
              }
              const { animationState } = this.visualElement;
              animationState && animationState.setActive("whileDrag", true);
          };
          const onMove = (event, info) => {
              // latestPointerEvent = event
              const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
              // If we didn't successfully receive the gesture lock, early return.
              if (!dragPropagation && !this.openGlobalLock)
                  return;
              const { offset } = info;
              // Attempt to detect drag direction if directionLock is true
              if (dragDirectionLock && this.currentDirection === null) {
                  this.currentDirection = getCurrentDirection(offset);
                  // If we've successfully set a direction, notify listener
                  if (this.currentDirection !== null) {
                      onDirectionLock && onDirectionLock(this.currentDirection);
                  }
                  return;
              }
              // Update each point with the latest position
              this.updateAxis("x", info.point, offset);
              this.updateAxis("y", info.point, offset);
              /**
               * Ideally we would leave the renderer to fire naturally at the end of
               * this frame but if the element is about to change layout as the result
               * of a re-render we want to ensure the browser can read the latest
               * bounding box to ensure the pointer and element don't fall out of sync.
               */
              this.visualElement.render();
              /**
               * This must fire after the render call as it might trigger a state
               * change which itself might trigger a layout update.
               */
              onDrag && onDrag(event, info);
          };
          const onSessionEnd = (event, info) => this.stop(event, info);
          const resumeAnimation = () => eachAxis((axis) => {
              var _a;
              return this.getAnimationState(axis) === "paused" &&
                  ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
          });
          const { dragSnapToOrigin } = this.getProps();
          this.panSession = new PanSession(originEvent, {
              onSessionStart,
              onStart,
              onMove,
              onSessionEnd,
              resumeAnimation,
          }, {
              transformPagePoint: this.visualElement.getTransformPagePoint(),
              dragSnapToOrigin,
              contextWindow: getContextWindow(this.visualElement),
          });
      }
      stop(event, info) {
          const isDragging = this.isDragging;
          this.cancel();
          if (!isDragging)
              return;
          const { velocity } = info;
          this.startAnimation(velocity);
          const { onDragEnd } = this.getProps();
          if (onDragEnd) {
              frame.update(() => onDragEnd(event, info));
          }
      }
      cancel() {
          this.isDragging = false;
          const { projection, animationState } = this.visualElement;
          if (projection) {
              projection.isAnimationBlocked = false;
          }
          this.panSession && this.panSession.end();
          this.panSession = undefined;
          const { dragPropagation } = this.getProps();
          if (!dragPropagation && this.openGlobalLock) {
              this.openGlobalLock();
              this.openGlobalLock = null;
          }
          animationState && animationState.setActive("whileDrag", false);
      }
      updateAxis(axis, _point, offset) {
          const { drag } = this.getProps();
          // If we're not dragging this axis, do an early return.
          if (!offset || !shouldDrag(axis, drag, this.currentDirection))
              return;
          const axisValue = this.getAxisMotionValue(axis);
          let next = this.originPoint[axis] + offset[axis];
          // Apply constraints
          if (this.constraints && this.constraints[axis]) {
              next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
          }
          axisValue.set(next);
      }
      resolveConstraints() {
          var _a;
          const { dragConstraints, dragElastic } = this.getProps();
          const layout = this.visualElement.projection &&
              !this.visualElement.projection.layout
              ? this.visualElement.projection.measure(false)
              : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
          const prevConstraints = this.constraints;
          if (dragConstraints && isRefObject(dragConstraints)) {
              if (!this.constraints) {
                  this.constraints = this.resolveRefConstraints();
              }
          }
          else {
              if (dragConstraints && layout) {
                  this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
              }
              else {
                  this.constraints = false;
              }
          }
          this.elastic = resolveDragElastic(dragElastic);
          /**
           * If we're outputting to external MotionValues, we want to rebase the measured constraints
           * from viewport-relative to component-relative.
           */
          if (prevConstraints !== this.constraints &&
              layout &&
              this.constraints &&
              !this.hasMutatedConstraints) {
              eachAxis((axis) => {
                  if (this.getAxisMotionValue(axis)) {
                      this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                  }
              });
          }
      }
      resolveRefConstraints() {
          const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
          if (!constraints || !isRefObject(constraints))
              return false;
          const constraintsElement = constraints.current;
          const { projection } = this.visualElement;
          // TODO
          if (!projection || !projection.layout)
              return false;
          const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
          let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
          /**
           * If there's an onMeasureDragConstraints listener we call it and
           * if different constraints are returned, set constraints to that
           */
          if (onMeasureDragConstraints) {
              const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
              this.hasMutatedConstraints = !!userConstraints;
              if (userConstraints) {
                  measuredConstraints = convertBoundingBoxToBox(userConstraints);
              }
          }
          return measuredConstraints;
      }
      startAnimation(velocity) {
          const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
          const constraints = this.constraints || {};
          const momentumAnimations = eachAxis((axis) => {
              if (!shouldDrag(axis, drag, this.currentDirection)) {
                  return;
              }
              let transition = (constraints && constraints[axis]) || {};
              if (dragSnapToOrigin)
                  transition = { min: 0, max: 0 };
              /**
               * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
               * of spring animations so we should look into adding a disable spring option to `inertia`.
               * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
               * using the value of `dragElastic`.
               */
              const bounceStiffness = dragElastic ? 200 : 1000000;
              const bounceDamping = dragElastic ? 40 : 10000000;
              const inertia = {
                  type: "inertia",
                  velocity: dragMomentum ? velocity[axis] : 0,
                  bounceStiffness,
                  bounceDamping,
                  timeConstant: 750,
                  restDelta: 1,
                  restSpeed: 10,
                  ...dragTransition,
                  ...transition,
              };
              // If we're not animating on an externally-provided `MotionValue` we can use the
              // component's animation controls which will handle interactions with whileHover (etc),
              // otherwise we just have to animate the `MotionValue` itself.
              return this.startAxisValueAnimation(axis, inertia);
          });
          // Run all animations and then resolve the new drag constraints.
          return Promise.all(momentumAnimations).then(onDragTransitionEnd);
      }
      startAxisValueAnimation(axis, transition) {
          const axisValue = this.getAxisMotionValue(axis);
          return axisValue.start(animateMotionValue(axis, axisValue, 0, transition));
      }
      stopAnimation() {
          eachAxis((axis) => this.getAxisMotionValue(axis).stop());
      }
      pauseAnimation() {
          eachAxis((axis) => { var _a; return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause(); });
      }
      getAnimationState(axis) {
          var _a;
          return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
      }
      /**
       * Drag works differently depending on which props are provided.
       *
       * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
       * - Otherwise, we apply the delta to the x/y motion values.
       */
      getAxisMotionValue(axis) {
          const dragKey = "_drag" + axis.toUpperCase();
          const props = this.visualElement.getProps();
          const externalMotionValue = props[dragKey];
          return externalMotionValue
              ? externalMotionValue
              : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
      }
      snapToCursor(point) {
          eachAxis((axis) => {
              const { drag } = this.getProps();
              // If we're not dragging this axis, do an early return.
              if (!shouldDrag(axis, drag, this.currentDirection))
                  return;
              const { projection } = this.visualElement;
              const axisValue = this.getAxisMotionValue(axis);
              if (projection && projection.layout) {
                  const { min, max } = projection.layout.layoutBox[axis];
                  axisValue.set(point[axis] - mix(min, max, 0.5));
              }
          });
      }
      /**
       * When the viewport resizes we want to check if the measured constraints
       * have changed and, if so, reposition the element within those new constraints
       * relative to where it was before the resize.
       */
      scalePositionWithinConstraints() {
          if (!this.visualElement.current)
              return;
          const { drag, dragConstraints } = this.getProps();
          const { projection } = this.visualElement;
          if (!isRefObject(dragConstraints) || !projection || !this.constraints)
              return;
          /**
           * Stop current animations as there can be visual glitching if we try to do
           * this mid-animation
           */
          this.stopAnimation();
          /**
           * Record the relative position of the dragged element relative to the
           * constraints box and save as a progress value.
           */
          const boxProgress = { x: 0, y: 0 };
          eachAxis((axis) => {
              const axisValue = this.getAxisMotionValue(axis);
              if (axisValue) {
                  const latest = axisValue.get();
                  boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
              }
          });
          /**
           * Update the layout of this element and resolve the latest drag constraints
           */
          const { transformTemplate } = this.visualElement.getProps();
          this.visualElement.current.style.transform = transformTemplate
              ? transformTemplate({}, "")
              : "none";
          projection.root && projection.root.updateScroll();
          projection.updateLayout();
          this.resolveConstraints();
          /**
           * For each axis, calculate the current progress of the layout axis
           * within the new constraints.
           */
          eachAxis((axis) => {
              if (!shouldDrag(axis, drag, null))
                  return;
              /**
               * Calculate a new transform based on the previous box progress
               */
              const axisValue = this.getAxisMotionValue(axis);
              const { min, max } = this.constraints[axis];
              axisValue.set(mix(min, max, boxProgress[axis]));
          });
      }
      addListeners() {
          if (!this.visualElement.current)
              return;
          elementDragControls.set(this.visualElement, this);
          const element = this.visualElement.current;
          /**
           * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
           */
          const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
              const { drag, dragListener = true } = this.getProps();
              drag && dragListener && this.start(event);
          });
          const measureDragConstraints = () => {
              const { dragConstraints } = this.getProps();
              if (isRefObject(dragConstraints)) {
                  this.constraints = this.resolveRefConstraints();
              }
          };
          const { projection } = this.visualElement;
          const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
          if (projection && !projection.layout) {
              projection.root && projection.root.updateScroll();
              projection.updateLayout();
          }
          measureDragConstraints();
          /**
           * Attach a window resize listener to scale the draggable target within its defined
           * constraints as the window resizes.
           */
          const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
          /**
           * If the element's layout changes, calculate the delta and apply that to
           * the drag gesture's origin point.
           */
          const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
              if (this.isDragging && hasLayoutChanged) {
                  eachAxis((axis) => {
                      const motionValue = this.getAxisMotionValue(axis);
                      if (!motionValue)
                          return;
                      this.originPoint[axis] += delta[axis].translate;
                      motionValue.set(motionValue.get() + delta[axis].translate);
                  });
                  this.visualElement.render();
              }
          }));
          return () => {
              stopResizeListener();
              stopPointerListener();
              stopMeasureLayoutListener();
              stopLayoutUpdateListener && stopLayoutUpdateListener();
          };
      }
      getProps() {
          const props = this.visualElement.getProps();
          const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
          return {
              ...props,
              drag,
              dragDirectionLock,
              dragPropagation,
              dragConstraints,
              dragElastic,
              dragMomentum,
          };
      }
  }
  function shouldDrag(direction, drag, currentDirection) {
      return ((drag === true || drag === direction) &&
          (currentDirection === null || currentDirection === direction));
  }
  /**
   * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
   * than the provided threshold, return `null`.
   *
   * @param offset - The x/y offset from origin.
   * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
   */
  function getCurrentDirection(offset, lockThreshold = 10) {
      let direction = null;
      if (Math.abs(offset.y) > lockThreshold) {
          direction = "y";
      }
      else if (Math.abs(offset.x) > lockThreshold) {
          direction = "x";
      }
      return direction;
  }

  class DragGesture extends Feature {
      constructor(node) {
          super(node);
          this.removeGroupControls = noop;
          this.removeListeners = noop;
          this.controls = new VisualElementDragControls(node);
      }
      mount() {
          // If we've been provided a DragControls for manual control over the drag gesture,
          // subscribe this component to it on mount.
          const { dragControls } = this.node.getProps();
          if (dragControls) {
              this.removeGroupControls = dragControls.subscribe(this.controls);
          }
          this.removeListeners = this.controls.addListeners() || noop;
      }
      unmount() {
          this.removeGroupControls();
          this.removeListeners();
      }
  }

  const asyncHandler = (handler) => (event, info) => {
      if (handler) {
          frame.update(() => handler(event, info));
      }
  };
  class PanGesture extends Feature {
      constructor() {
          super(...arguments);
          this.removePointerDownListener = noop;
      }
      onPointerDown(pointerDownEvent) {
          this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
              transformPagePoint: this.node.getTransformPagePoint(),
              contextWindow: getContextWindow(this.node),
          });
      }
      createPanHandlers() {
          const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
          return {
              onSessionStart: asyncHandler(onPanSessionStart),
              onStart: asyncHandler(onPanStart),
              onMove: onPan,
              onEnd: (event, info) => {
                  delete this.session;
                  if (onPanEnd) {
                      frame.update(() => onPanEnd(event, info));
                  }
              },
          };
      }
      mount() {
          this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
      }
      update() {
          this.session && this.session.updateHandlers(this.createPanHandlers());
      }
      unmount() {
          this.removePointerDownListener();
          this.session && this.session.end();
      }
  }

  /**
   * When a component is the child of `AnimatePresence`, it can use `usePresence`
   * to access information about whether it's still present in the React tree.
   *
   * ```jsx
   * import { usePresence } from "framer-motion"
   *
   * export const Component = () => {
   *   const [isPresent, safeToRemove] = usePresence()
   *
   *   useEffect(() => {
   *     !isPresent && setTimeout(safeToRemove, 1000)
   *   }, [isPresent])
   *
   *   return <div />
   * }
   * ```
   *
   * If `isPresent` is `false`, it means that a component has been removed the tree, but
   * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
   *
   * @public
   */
  function usePresence() {
      const context = react.useContext(PresenceContext);
      if (context === null)
          return [true, null];
      const { isPresent, onExitComplete, register } = context;
      // It's safe to call the following hooks conditionally (after an early return) because the context will always
      // either be null or non-null for the lifespan of the component.
      const id = react.useId();
      react.useEffect(() => register(id), []);
      const safeToRemove = () => onExitComplete && onExitComplete(id);
      return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
  }
  /**
   * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
   * There is no `safeToRemove` function.
   *
   * ```jsx
   * import { useIsPresent } from "framer-motion"
   *
   * export const Component = () => {
   *   const isPresent = useIsPresent()
   *
   *   useEffect(() => {
   *     !isPresent && console.log("I've been removed!")
   *   }, [isPresent])
   *
   *   return <div />
   * }
   * ```
   *
   * @public
   */
  function useIsPresent() {
      return isPresent(react.useContext(PresenceContext));
  }
  function isPresent(context) {
      return context === null ? true : context.isPresent;
  }

  /**
   * This should only ever be modified on the client otherwise it'll
   * persist through server requests. If we need instanced states we
   * could lazy-init via root.
   */
  const globalProjectionState = {
      /**
       * Global flag as to whether the tree has animated since the last time
       * we resized the window
       */
      hasAnimatedSinceResize: true,
      /**
       * We set this to true once, on the first update. Any nodes added to the tree beyond that
       * update will be given a `data-projection-id` attribute.
       */
      hasEverUpdated: false,
  };

  function pixelsToPercent(pixels, axis) {
      if (axis.max === axis.min)
          return 0;
      return (pixels / (axis.max - axis.min)) * 100;
  }
  /**
   * We always correct borderRadius as a percentage rather than pixels to reduce paints.
   * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
   * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
   * borderRadius in both states. If we animate between the two in pixels that will trigger
   * a paint each time. If we animate between the two in percentage we'll avoid a paint.
   */
  const correctBorderRadius = {
      correct: (latest, node) => {
          if (!node.target)
              return latest;
          /**
           * If latest is a string, if it's a percentage we can return immediately as it's
           * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
           */
          if (typeof latest === "string") {
              if (px.test(latest)) {
                  latest = parseFloat(latest);
              }
              else {
                  return latest;
              }
          }
          /**
           * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
           * pixel value as a percentage of each axis
           */
          const x = pixelsToPercent(latest, node.target.x);
          const y = pixelsToPercent(latest, node.target.y);
          return `${x}% ${y}%`;
      },
  };

  const correctBoxShadow = {
      correct: (latest, { treeScale, projectionDelta }) => {
          const original = latest;
          const shadow = complex.parse(latest);
          // TODO: Doesn't support multiple shadows
          if (shadow.length > 5)
              return original;
          const template = complex.createTransformer(latest);
          const offset = typeof shadow[0] !== "number" ? 1 : 0;
          // Calculate the overall context scale
          const xScale = projectionDelta.x.scale * treeScale.x;
          const yScale = projectionDelta.y.scale * treeScale.y;
          shadow[0 + offset] /= xScale;
          shadow[1 + offset] /= yScale;
          /**
           * Ideally we'd correct x and y scales individually, but because blur and
           * spread apply to both we have to take a scale average and apply that instead.
           * We could potentially improve the outcome of this by incorporating the ratio between
           * the two scales.
           */
          const averageScale = mix(xScale, yScale, 0.5);
          // Blur
          if (typeof shadow[2 + offset] === "number")
              shadow[2 + offset] /= averageScale;
          // Spread
          if (typeof shadow[3 + offset] === "number")
              shadow[3 + offset] /= averageScale;
          return template(shadow);
      },
  };

  class MeasureLayoutWithContext extends react.Component {
      /**
       * This only mounts projection nodes for components that
       * need measuring, we might want to do it for all components
       * in order to incorporate transforms
       */
      componentDidMount() {
          const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
          const { projection } = visualElement;
          addScaleCorrector(defaultScaleCorrectors);
          if (projection) {
              if (layoutGroup.group)
                  layoutGroup.group.add(projection);
              if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                  switchLayoutGroup.register(projection);
              }
              projection.root.didUpdate();
              projection.addEventListener("animationComplete", () => {
                  this.safeToRemove();
              });
              projection.setOptions({
                  ...projection.options,
                  onExitComplete: () => this.safeToRemove(),
              });
          }
          globalProjectionState.hasEverUpdated = true;
      }
      getSnapshotBeforeUpdate(prevProps) {
          const { layoutDependency, visualElement, drag, isPresent } = this.props;
          const projection = visualElement.projection;
          if (!projection)
              return null;
          /**
           * TODO: We use this data in relegate to determine whether to
           * promote a previous element. There's no guarantee its presence data
           * will have updated by this point - if a bug like this arises it will
           * have to be that we markForRelegation and then find a new lead some other way,
           * perhaps in didUpdate
           */
          projection.isPresent = isPresent;
          if (drag ||
              prevProps.layoutDependency !== layoutDependency ||
              layoutDependency === undefined) {
              projection.willUpdate();
          }
          else {
              this.safeToRemove();
          }
          if (prevProps.isPresent !== isPresent) {
              if (isPresent) {
                  projection.promote();
              }
              else if (!projection.relegate()) {
                  /**
                   * If there's another stack member taking over from this one,
                   * it's in charge of the exit animation and therefore should
                   * be in charge of the safe to remove. Otherwise we call it here.
                   */
                  frame.postRender(() => {
                      const stack = projection.getStack();
                      if (!stack || !stack.members.length) {
                          this.safeToRemove();
                      }
                  });
              }
          }
          return null;
      }
      componentDidUpdate() {
          const { projection } = this.props.visualElement;
          if (projection) {
              projection.root.didUpdate();
              queueMicrotask(() => {
                  if (!projection.currentAnimation && projection.isLead()) {
                      this.safeToRemove();
                  }
              });
          }
      }
      componentWillUnmount() {
          const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
          const { projection } = visualElement;
          if (projection) {
              projection.scheduleCheckAfterUnmount();
              if (layoutGroup && layoutGroup.group)
                  layoutGroup.group.remove(projection);
              if (promoteContext && promoteContext.deregister)
                  promoteContext.deregister(projection);
          }
      }
      safeToRemove() {
          const { safeToRemove } = this.props;
          safeToRemove && safeToRemove();
      }
      render() {
          return null;
      }
  }
  function MeasureLayout(props) {
      const [isPresent, safeToRemove] = usePresence();
      const layoutGroup = react.useContext(LayoutGroupContext);
      return (react.createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: react.useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
  }
  const defaultScaleCorrectors = {
      borderRadius: {
          ...correctBorderRadius,
          applyTo: [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
          ],
      },
      borderTopLeftRadius: correctBorderRadius,
      borderTopRightRadius: correctBorderRadius,
      borderBottomLeftRadius: correctBorderRadius,
      borderBottomRightRadius: correctBorderRadius,
      boxShadow: correctBoxShadow,
  };

  const borders$1 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
  const numBorders = borders$1.length;
  const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
  const isPx = (value) => typeof value === "number" || px.test(value);
  function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
      if (shouldCrossfadeOpacity) {
          target.opacity = mix(0, 
          // TODO Reinstate this if only child
          lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
          target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
      }
      else if (isOnlyMember) {
          target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
      }
      /**
       * Mix border radius
       */
      for (let i = 0; i < numBorders; i++) {
          const borderLabel = `border${borders$1[i]}Radius`;
          let followRadius = getRadius(follow, borderLabel);
          let leadRadius = getRadius(lead, borderLabel);
          if (followRadius === undefined && leadRadius === undefined)
              continue;
          followRadius || (followRadius = 0);
          leadRadius || (leadRadius = 0);
          const canMix = followRadius === 0 ||
              leadRadius === 0 ||
              isPx(followRadius) === isPx(leadRadius);
          if (canMix) {
              target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
              if (percent.test(leadRadius) || percent.test(followRadius)) {
                  target[borderLabel] += "%";
              }
          }
          else {
              target[borderLabel] = leadRadius;
          }
      }
      /**
       * Mix rotation
       */
      if (follow.rotate || lead.rotate) {
          target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
      }
  }
  function getRadius(values, radiusName) {
      return values[radiusName] !== undefined
          ? values[radiusName]
          : values.borderRadius;
  }
  // /**
  //  * We only want to mix the background color if there's a follow element
  //  * that we're not crossfading opacity between. For instance with switch
  //  * AnimateSharedLayout animations, this helps the illusion of a continuous
  //  * element being animated but also cuts down on the number of paints triggered
  //  * for elements where opacity is doing that work for us.
  //  */
  // if (
  //     !hasFollowElement &&
  //     latestLeadValues.backgroundColor &&
  //     latestFollowValues.backgroundColor
  // ) {
  //     /**
  //      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
  //      * We could probably create a mixer that runs at the start of the animation but
  //      * the idea behind the crossfader is that it runs dynamically between two potentially
  //      * changing targets (ie opacity or borderRadius may be animating independently via variants)
  //      */
  //     leadState.backgroundColor = followState.backgroundColor = mixColor(
  //         latestFollowValues.backgroundColor as string,
  //         latestLeadValues.backgroundColor as string
  //     )(p)
  // }
  const easeCrossfadeIn = compress(0, 0.5, circOut);
  const easeCrossfadeOut = compress(0.5, 0.95, noop);
  function compress(min, max, easing) {
      return (p) => {
          // Could replace ifs with clamp
          if (p < min)
              return 0;
          if (p > max)
              return 1;
          return easing(progress(min, max, p));
      };
  }

  /**
   * Reset an axis to the provided origin box.
   *
   * This is a mutative operation.
   */
  function copyAxisInto(axis, originAxis) {
      axis.min = originAxis.min;
      axis.max = originAxis.max;
  }
  /**
   * Reset a box to the provided origin box.
   *
   * This is a mutative operation.
   */
  function copyBoxInto(box, originBox) {
      copyAxisInto(box.x, originBox.x);
      copyAxisInto(box.y, originBox.y);
  }

  /**
   * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
   */
  function removePointDelta(point, translate, scale, originPoint, boxScale) {
      point -= translate;
      point = scalePoint(point, 1 / scale, originPoint);
      if (boxScale !== undefined) {
          point = scalePoint(point, 1 / boxScale, originPoint);
      }
      return point;
  }
  /**
   * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
   */
  function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
      if (percent.test(translate)) {
          translate = parseFloat(translate);
          const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
          translate = relativeProgress - sourceAxis.min;
      }
      if (typeof translate !== "number")
          return;
      let originPoint = mix(originAxis.min, originAxis.max, origin);
      if (axis === originAxis)
          originPoint -= translate;
      axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
      axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
  }
  /**
   * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
   * and acts as a bridge between motion values and removeAxisDelta
   */
  function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
      removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
  }
  /**
   * The names of the motion values we want to apply as translation, scale and origin.
   */
  const xKeys = ["x", "scaleX", "originX"];
  const yKeys = ["y", "scaleY", "originY"];
  /**
   * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
   * and acts as a bridge between motion values and removeAxisDelta
   */
  function removeBoxTransforms(box, transforms, originBox, sourceBox) {
      removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
      removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
  }

  function isAxisDeltaZero(delta) {
      return delta.translate === 0 && delta.scale === 1;
  }
  function isDeltaZero(delta) {
      return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
  }
  function boxEquals(a, b) {
      return (a.x.min === b.x.min &&
          a.x.max === b.x.max &&
          a.y.min === b.y.min &&
          a.y.max === b.y.max);
  }
  function boxEqualsRounded(a, b) {
      return (Math.round(a.x.min) === Math.round(b.x.min) &&
          Math.round(a.x.max) === Math.round(b.x.max) &&
          Math.round(a.y.min) === Math.round(b.y.min) &&
          Math.round(a.y.max) === Math.round(b.y.max));
  }
  function aspectRatio(box) {
      return calcLength(box.x) / calcLength(box.y);
  }

  class NodeStack {
      constructor() {
          this.members = [];
      }
      add(node) {
          addUniqueItem(this.members, node);
          node.scheduleRender();
      }
      remove(node) {
          removeItem(this.members, node);
          if (node === this.prevLead) {
              this.prevLead = undefined;
          }
          if (node === this.lead) {
              const prevLead = this.members[this.members.length - 1];
              if (prevLead) {
                  this.promote(prevLead);
              }
          }
      }
      relegate(node) {
          const indexOfNode = this.members.findIndex((member) => node === member);
          if (indexOfNode === 0)
              return false;
          /**
           * Find the next projection node that is present
           */
          let prevLead;
          for (let i = indexOfNode; i >= 0; i--) {
              const member = this.members[i];
              if (member.isPresent !== false) {
                  prevLead = member;
                  break;
              }
          }
          if (prevLead) {
              this.promote(prevLead);
              return true;
          }
          else {
              return false;
          }
      }
      promote(node, preserveFollowOpacity) {
          const prevLead = this.lead;
          if (node === prevLead)
              return;
          this.prevLead = prevLead;
          this.lead = node;
          node.show();
          if (prevLead) {
              prevLead.instance && prevLead.scheduleRender();
              node.scheduleRender();
              node.resumeFrom = prevLead;
              if (preserveFollowOpacity) {
                  node.resumeFrom.preserveOpacity = true;
              }
              if (prevLead.snapshot) {
                  node.snapshot = prevLead.snapshot;
                  node.snapshot.latestValues =
                      prevLead.animationValues || prevLead.latestValues;
              }
              if (node.root && node.root.isUpdating) {
                  node.isLayoutDirty = true;
              }
              const { crossfade } = node.options;
              if (crossfade === false) {
                  prevLead.hide();
              }
              /**
               * TODO:
               *   - Test border radius when previous node was deleted
               *   - boxShadow mixing
               *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
               *   - Shared between element A in transformed container and element B (transform stays the same or changes)
               *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
               * ---
               *   - Crossfade opacity of root nodes
               *   - layoutId changes after animation
               *   - layoutId changes mid animation
               */
          }
      }
      exitAnimationComplete() {
          this.members.forEach((node) => {
              const { options, resumingFrom } = node;
              options.onExitComplete && options.onExitComplete();
              if (resumingFrom) {
                  resumingFrom.options.onExitComplete &&
                      resumingFrom.options.onExitComplete();
              }
          });
      }
      scheduleRender() {
          this.members.forEach((node) => {
              node.instance && node.scheduleRender(false);
          });
      }
      /**
       * Clear any leads that have been removed this render to prevent them from being
       * used in future animations and to prevent memory leaks
       */
      removeLeadSnapshot() {
          if (this.lead && this.lead.snapshot) {
              this.lead.snapshot = undefined;
          }
      }
  }

  function buildProjectionTransform(delta, treeScale, latestTransform) {
      let transform = "";
      /**
       * The translations we use to calculate are always relative to the viewport coordinate space.
       * But when we apply scales, we also scale the coordinate space of an element and its children.
       * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
       * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
       */
      const xTranslate = delta.x.translate / treeScale.x;
      const yTranslate = delta.y.translate / treeScale.y;
      if (xTranslate || yTranslate) {
          transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
      }
      /**
       * Apply scale correction for the tree transform.
       * This will apply scale to the screen-orientated axes.
       */
      if (treeScale.x !== 1 || treeScale.y !== 1) {
          transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
      }
      if (latestTransform) {
          const { rotate, rotateX, rotateY } = latestTransform;
          if (rotate)
              transform += `rotate(${rotate}deg) `;
          if (rotateX)
              transform += `rotateX(${rotateX}deg) `;
          if (rotateY)
              transform += `rotateY(${rotateY}deg) `;
      }
      /**
       * Apply scale to match the size of the element to the size we want it.
       * This will apply scale to the element-orientated axes.
       */
      const elementScaleX = delta.x.scale * treeScale.x;
      const elementScaleY = delta.y.scale * treeScale.y;
      if (elementScaleX !== 1 || elementScaleY !== 1) {
          transform += `scale(${elementScaleX}, ${elementScaleY})`;
      }
      return transform || "none";
  }

  const compareByDepth = (a, b) => a.depth - b.depth;

  class FlatTree {
      constructor() {
          this.children = [];
          this.isDirty = false;
      }
      add(child) {
          addUniqueItem(this.children, child);
          this.isDirty = true;
      }
      remove(child) {
          removeItem(this.children, child);
          this.isDirty = true;
      }
      forEach(callback) {
          this.isDirty && this.children.sort(compareByDepth);
          this.isDirty = false;
          this.children.forEach(callback);
      }
  }

  /**
   * Timeout defined in ms
   */
  function delay(callback, timeout) {
      const start = performance.now();
      const checkElapsed = ({ timestamp }) => {
          const elapsed = timestamp - start;
          if (elapsed >= timeout) {
              cancelFrame(checkElapsed);
              callback(elapsed - timeout);
          }
      };
      frame.read(checkElapsed, true);
      return () => cancelFrame(checkElapsed);
  }

  function record(data) {
      if (window.MotionDebug) {
          window.MotionDebug.record(data);
      }
  }

  function isSVGElement(element) {
      return element instanceof SVGElement && element.tagName !== "svg";
  }

  function animateSingleValue(value, keyframes, options) {
      const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
      motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
      return motionValue$1.animation;
  }

  const transformAxes = ["", "X", "Y", "Z"];
  const hiddenVisibility = { visibility: "hidden" };
  /**
   * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
   * which has a noticeable difference in spring animations
   */
  const animationTarget = 1000;
  let id = 0;
  /**
   * Use a mutable data object for debug data so as to not create a new
   * object every frame.
   */
  const projectionFrameData = {
      type: "projectionFrame",
      totalNodes: 0,
      resolvedTargetDeltas: 0,
      recalculatedProjection: 0,
  };
  function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
      return class ProjectionNode {
          constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
              /**
               * A unique ID generated for every projection node.
               */
              this.id = id++;
              /**
               * An id that represents a unique session instigated by startUpdate.
               */
              this.animationId = 0;
              /**
               * A Set containing all this component's children. This is used to iterate
               * through the children.
               *
               * TODO: This could be faster to iterate as a flat array stored on the root node.
               */
              this.children = new Set();
              /**
               * Options for the node. We use this to configure what kind of layout animations
               * we should perform (if any).
               */
              this.options = {};
              /**
               * We use this to detect when its safe to shut down part of a projection tree.
               * We have to keep projecting children for scale correction and relative projection
               * until all their parents stop performing layout animations.
               */
              this.isTreeAnimating = false;
              this.isAnimationBlocked = false;
              /**
               * Flag to true if we think this layout has been changed. We can't always know this,
               * currently we set it to true every time a component renders, or if it has a layoutDependency
               * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
               * and if one node is dirtied, they all are.
               */
              this.isLayoutDirty = false;
              /**
               * Flag to true if we think the projection calculations for this node needs
               * recalculating as a result of an updated transform or layout animation.
               */
              this.isProjectionDirty = false;
              /**
               * Flag to true if the layout *or* transform has changed. This then gets propagated
               * throughout the projection tree, forcing any element below to recalculate on the next frame.
               */
              this.isSharedProjectionDirty = false;
              /**
               * Flag transform dirty. This gets propagated throughout the whole tree but is only
               * respected by shared nodes.
               */
              this.isTransformDirty = false;
              /**
               * Block layout updates for instant layout transitions throughout the tree.
               */
              this.updateManuallyBlocked = false;
              this.updateBlockedByResize = false;
              /**
               * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
               * call.
               */
              this.isUpdating = false;
              /**
               * If this is an SVG element we currently disable projection transforms
               */
              this.isSVG = false;
              /**
               * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
               * its projection styles.
               */
              this.needsReset = false;
              /**
               * Flags whether this node should have its transform reset prior to measuring.
               */
              this.shouldResetTransform = false;
              /**
               * An object representing the calculated contextual/accumulated/tree scale.
               * This will be used to scale calculcated projection transforms, as these are
               * calculated in screen-space but need to be scaled for elements to layoutly
               * make it to their calculated destinations.
               *
               * TODO: Lazy-init
               */
              this.treeScale = { x: 1, y: 1 };
              /**
               *
               */
              this.eventHandlers = new Map();
              this.hasTreeAnimated = false;
              // Note: Currently only running on root node
              this.updateScheduled = false;
              this.projectionUpdateScheduled = false;
              this.checkUpdateFailed = () => {
                  if (this.isUpdating) {
                      this.isUpdating = false;
                      this.clearAllSnapshots();
                  }
              };
              /**
               * This is a multi-step process as shared nodes might be of different depths. Nodes
               * are sorted by depth order, so we need to resolve the entire tree before moving to
               * the next step.
               */
              this.updateProjection = () => {
                  this.projectionUpdateScheduled = false;
                  /**
                   * Reset debug counts. Manually resetting rather than creating a new
                   * object each frame.
                   */
                  projectionFrameData.totalNodes =
                      projectionFrameData.resolvedTargetDeltas =
                          projectionFrameData.recalculatedProjection =
                              0;
                  this.nodes.forEach(propagateDirtyNodes);
                  this.nodes.forEach(resolveTargetDelta);
                  this.nodes.forEach(calcProjection);
                  this.nodes.forEach(cleanDirtyNodes);
                  record(projectionFrameData);
              };
              this.hasProjected = false;
              this.isVisible = true;
              this.animationProgress = 0;
              /**
               * Shared layout
               */
              // TODO Only running on root node
              this.sharedNodes = new Map();
              this.latestValues = latestValues;
              this.root = parent ? parent.root || parent : this;
              this.path = parent ? [...parent.path, parent] : [];
              this.parent = parent;
              this.depth = parent ? parent.depth + 1 : 0;
              for (let i = 0; i < this.path.length; i++) {
                  this.path[i].shouldResetTransform = true;
              }
              if (this.root === this)
                  this.nodes = new FlatTree();
          }
          addEventListener(name, handler) {
              if (!this.eventHandlers.has(name)) {
                  this.eventHandlers.set(name, new SubscriptionManager());
              }
              return this.eventHandlers.get(name).add(handler);
          }
          notifyListeners(name, ...args) {
              const subscriptionManager = this.eventHandlers.get(name);
              subscriptionManager && subscriptionManager.notify(...args);
          }
          hasListeners(name) {
              return this.eventHandlers.has(name);
          }
          /**
           * Lifecycles
           */
          mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
              if (this.instance)
                  return;
              this.isSVG = isSVGElement(instance);
              this.instance = instance;
              const { layoutId, layout, visualElement } = this.options;
              if (visualElement && !visualElement.current) {
                  visualElement.mount(instance);
              }
              this.root.nodes.add(this);
              this.parent && this.parent.children.add(this);
              if (isLayoutDirty && (layout || layoutId)) {
                  this.isLayoutDirty = true;
              }
              if (attachResizeListener) {
                  let cancelDelay;
                  const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                  attachResizeListener(instance, () => {
                      this.root.updateBlockedByResize = true;
                      cancelDelay && cancelDelay();
                      cancelDelay = delay(resizeUnblockUpdate, 250);
                      if (globalProjectionState.hasAnimatedSinceResize) {
                          globalProjectionState.hasAnimatedSinceResize = false;
                          this.nodes.forEach(finishAnimation);
                      }
                  });
              }
              if (layoutId) {
                  this.root.registerSharedNode(layoutId, this);
              }
              // Only register the handler if it requires layout animation
              if (this.options.animate !== false &&
                  visualElement &&
                  (layoutId || layout)) {
                  this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                      if (this.isTreeAnimationBlocked()) {
                          this.target = undefined;
                          this.relativeTarget = undefined;
                          return;
                      }
                      // TODO: Check here if an animation exists
                      const layoutTransition = this.options.transition ||
                          visualElement.getDefaultTransition() ||
                          defaultLayoutTransition;
                      const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                      /**
                       * The target layout of the element might stay the same,
                       * but its position relative to its parent has changed.
                       */
                      const targetChanged = !this.targetLayout ||
                          !boxEqualsRounded(this.targetLayout, newLayout) ||
                          hasRelativeTargetChanged;
                      /**
                       * If the layout hasn't seemed to have changed, it might be that the
                       * element is visually in the same place in the document but its position
                       * relative to its parent has indeed changed. So here we check for that.
                       */
                      const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                      if (this.options.layoutRoot ||
                          (this.resumeFrom && this.resumeFrom.instance) ||
                          hasOnlyRelativeTargetChanged ||
                          (hasLayoutChanged &&
                              (targetChanged || !this.currentAnimation))) {
                          if (this.resumeFrom) {
                              this.resumingFrom = this.resumeFrom;
                              this.resumingFrom.resumingFrom = undefined;
                          }
                          this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                          const animationOptions = {
                              ...getValueTransition(layoutTransition, "layout"),
                              onPlay: onLayoutAnimationStart,
                              onComplete: onLayoutAnimationComplete,
                          };
                          if (visualElement.shouldReduceMotion ||
                              this.options.layoutRoot) {
                              animationOptions.delay = 0;
                              animationOptions.type = false;
                          }
                          this.startAnimation(animationOptions);
                      }
                      else {
                          /**
                           * If the layout hasn't changed and we have an animation that hasn't started yet,
                           * finish it immediately. Otherwise it will be animating from a location
                           * that was probably never commited to screen and look like a jumpy box.
                           */
                          if (!hasLayoutChanged) {
                              finishAnimation(this);
                          }
                          if (this.isLead() && this.options.onExitComplete) {
                              this.options.onExitComplete();
                          }
                      }
                      this.targetLayout = newLayout;
                  });
              }
          }
          unmount() {
              this.options.layoutId && this.willUpdate();
              this.root.nodes.remove(this);
              const stack = this.getStack();
              stack && stack.remove(this);
              this.parent && this.parent.children.delete(this);
              this.instance = undefined;
              cancelFrame(this.updateProjection);
          }
          // only on the root
          blockUpdate() {
              this.updateManuallyBlocked = true;
          }
          unblockUpdate() {
              this.updateManuallyBlocked = false;
          }
          isUpdateBlocked() {
              return this.updateManuallyBlocked || this.updateBlockedByResize;
          }
          isTreeAnimationBlocked() {
              return (this.isAnimationBlocked ||
                  (this.parent && this.parent.isTreeAnimationBlocked()) ||
                  false);
          }
          // Note: currently only running on root node
          startUpdate() {
              if (this.isUpdateBlocked())
                  return;
              this.isUpdating = true;
              this.nodes && this.nodes.forEach(resetRotation);
              this.animationId++;
          }
          getTransformTemplate() {
              const { visualElement } = this.options;
              return visualElement && visualElement.getProps().transformTemplate;
          }
          willUpdate(shouldNotifyListeners = true) {
              this.root.hasTreeAnimated = true;
              if (this.root.isUpdateBlocked()) {
                  this.options.onExitComplete && this.options.onExitComplete();
                  return;
              }
              !this.root.isUpdating && this.root.startUpdate();
              if (this.isLayoutDirty)
                  return;
              this.isLayoutDirty = true;
              for (let i = 0; i < this.path.length; i++) {
                  const node = this.path[i];
                  node.shouldResetTransform = true;
                  node.updateScroll("snapshot");
                  if (node.options.layoutRoot) {
                      node.willUpdate(false);
                  }
              }
              const { layoutId, layout } = this.options;
              if (layoutId === undefined && !layout)
                  return;
              const transformTemplate = this.getTransformTemplate();
              this.prevTransformTemplateValue = transformTemplate
                  ? transformTemplate(this.latestValues, "")
                  : undefined;
              this.updateSnapshot();
              shouldNotifyListeners && this.notifyListeners("willUpdate");
          }
          update() {
              this.updateScheduled = false;
              const updateWasBlocked = this.isUpdateBlocked();
              // When doing an instant transition, we skip the layout update,
              // but should still clean up the measurements so that the next
              // snapshot could be taken correctly.
              if (updateWasBlocked) {
                  this.unblockUpdate();
                  this.clearAllSnapshots();
                  this.nodes.forEach(clearMeasurements);
                  return;
              }
              if (!this.isUpdating) {
                  this.nodes.forEach(clearIsLayoutDirty);
              }
              this.isUpdating = false;
              /**
               * Write
               */
              this.nodes.forEach(resetTransformStyle);
              /**
               * Read ==================
               */
              // Update layout measurements of updated children
              this.nodes.forEach(updateLayout);
              /**
               * Write
               */
              // Notify listeners that the layout is updated
              this.nodes.forEach(notifyLayoutUpdate);
              this.clearAllSnapshots();
              /**
               * Manually flush any pending updates. Ideally
               * we could leave this to the following requestAnimationFrame but this seems
               * to leave a flash of incorrectly styled content.
               */
              const now = performance.now();
              frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
              frameData.timestamp = now;
              frameData.isProcessing = true;
              steps.update.process(frameData);
              steps.preRender.process(frameData);
              steps.render.process(frameData);
              frameData.isProcessing = false;
          }
          didUpdate() {
              if (!this.updateScheduled) {
                  this.updateScheduled = true;
                  queueMicrotask(() => this.update());
              }
          }
          clearAllSnapshots() {
              this.nodes.forEach(clearSnapshot);
              this.sharedNodes.forEach(removeLeadSnapshots);
          }
          scheduleUpdateProjection() {
              if (!this.projectionUpdateScheduled) {
                  this.projectionUpdateScheduled = true;
                  frame.preRender(this.updateProjection, false, true);
              }
          }
          scheduleCheckAfterUnmount() {
              /**
               * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
               * we manually call didUpdate to give a chance to the siblings to animate.
               * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
               */
              frame.postRender(() => {
                  if (this.isLayoutDirty) {
                      this.root.didUpdate();
                  }
                  else {
                      this.root.checkUpdateFailed();
                  }
              });
          }
          /**
           * Update measurements
           */
          updateSnapshot() {
              if (this.snapshot || !this.instance)
                  return;
              this.snapshot = this.measure();
          }
          updateLayout() {
              if (!this.instance)
                  return;
              // TODO: Incorporate into a forwarded scroll offset
              this.updateScroll();
              if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                  !this.isLayoutDirty) {
                  return;
              }
              /**
               * When a node is mounted, it simply resumes from the prevLead's
               * snapshot instead of taking a new one, but the ancestors scroll
               * might have updated while the prevLead is unmounted. We need to
               * update the scroll again to make sure the layout we measure is
               * up to date.
               */
              if (this.resumeFrom && !this.resumeFrom.instance) {
                  for (let i = 0; i < this.path.length; i++) {
                      const node = this.path[i];
                      node.updateScroll();
                  }
              }
              const prevLayout = this.layout;
              this.layout = this.measure(false);
              this.layoutCorrected = createBox();
              this.isLayoutDirty = false;
              this.projectionDelta = undefined;
              this.notifyListeners("measure", this.layout.layoutBox);
              const { visualElement } = this.options;
              visualElement &&
                  visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
          }
          updateScroll(phase = "measure") {
              let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
              if (this.scroll &&
                  this.scroll.animationId === this.root.animationId &&
                  this.scroll.phase === phase) {
                  needsMeasurement = false;
              }
              if (needsMeasurement) {
                  this.scroll = {
                      animationId: this.root.animationId,
                      phase,
                      isRoot: checkIsScrollRoot(this.instance),
                      offset: measureScroll(this.instance),
                  };
              }
          }
          resetTransform() {
              if (!resetTransform)
                  return;
              const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
              const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
              const transformTemplate = this.getTransformTemplate();
              const transformTemplateValue = transformTemplate
                  ? transformTemplate(this.latestValues, "")
                  : undefined;
              const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
              if (isResetRequested &&
                  (hasProjection ||
                      hasTransform(this.latestValues) ||
                      transformTemplateHasChanged)) {
                  resetTransform(this.instance, transformTemplateValue);
                  this.shouldResetTransform = false;
                  this.scheduleRender();
              }
          }
          measure(removeTransform = true) {
              const pageBox = this.measurePageBox();
              let layoutBox = this.removeElementScroll(pageBox);
              /**
               * Measurements taken during the pre-render stage
               * still have transforms applied so we remove them
               * via calculation.
               */
              if (removeTransform) {
                  layoutBox = this.removeTransform(layoutBox);
              }
              roundBox(layoutBox);
              return {
                  animationId: this.root.animationId,
                  measuredBox: pageBox,
                  layoutBox,
                  latestValues: {},
                  source: this.id,
              };
          }
          measurePageBox() {
              const { visualElement } = this.options;
              if (!visualElement)
                  return createBox();
              const box = visualElement.measureViewportBox();
              // Remove viewport scroll to give page-relative coordinates
              const { scroll } = this.root;
              if (scroll) {
                  translateAxis(box.x, scroll.offset.x);
                  translateAxis(box.y, scroll.offset.y);
              }
              return box;
          }
          removeElementScroll(box) {
              const boxWithoutScroll = createBox();
              copyBoxInto(boxWithoutScroll, box);
              /**
               * Performance TODO: Keep a cumulative scroll offset down the tree
               * rather than loop back up the path.
               */
              for (let i = 0; i < this.path.length; i++) {
                  const node = this.path[i];
                  const { scroll, options } = node;
                  if (node !== this.root && scroll && options.layoutScroll) {
                      /**
                       * If this is a new scroll root, we want to remove all previous scrolls
                       * from the viewport box.
                       */
                      if (scroll.isRoot) {
                          copyBoxInto(boxWithoutScroll, box);
                          const { scroll: rootScroll } = this.root;
                          /**
                           * Undo the application of page scroll that was originally added
                           * to the measured bounding box.
                           */
                          if (rootScroll) {
                              translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                              translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                          }
                      }
                      translateAxis(boxWithoutScroll.x, scroll.offset.x);
                      translateAxis(boxWithoutScroll.y, scroll.offset.y);
                  }
              }
              return boxWithoutScroll;
          }
          applyTransform(box, transformOnly = false) {
              const withTransforms = createBox();
              copyBoxInto(withTransforms, box);
              for (let i = 0; i < this.path.length; i++) {
                  const node = this.path[i];
                  if (!transformOnly &&
                      node.options.layoutScroll &&
                      node.scroll &&
                      node !== node.root) {
                      transformBox(withTransforms, {
                          x: -node.scroll.offset.x,
                          y: -node.scroll.offset.y,
                      });
                  }
                  if (!hasTransform(node.latestValues))
                      continue;
                  transformBox(withTransforms, node.latestValues);
              }
              if (hasTransform(this.latestValues)) {
                  transformBox(withTransforms, this.latestValues);
              }
              return withTransforms;
          }
          removeTransform(box) {
              const boxWithoutTransform = createBox();
              copyBoxInto(boxWithoutTransform, box);
              for (let i = 0; i < this.path.length; i++) {
                  const node = this.path[i];
                  if (!node.instance)
                      continue;
                  if (!hasTransform(node.latestValues))
                      continue;
                  hasScale(node.latestValues) && node.updateSnapshot();
                  const sourceBox = createBox();
                  const nodeBox = node.measurePageBox();
                  copyBoxInto(sourceBox, nodeBox);
                  removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
              }
              if (hasTransform(this.latestValues)) {
                  removeBoxTransforms(boxWithoutTransform, this.latestValues);
              }
              return boxWithoutTransform;
          }
          setTargetDelta(delta) {
              this.targetDelta = delta;
              this.root.scheduleUpdateProjection();
              this.isProjectionDirty = true;
          }
          setOptions(options) {
              this.options = {
                  ...this.options,
                  ...options,
                  crossfade: options.crossfade !== undefined ? options.crossfade : true,
              };
          }
          clearMeasurements() {
              this.scroll = undefined;
              this.layout = undefined;
              this.snapshot = undefined;
              this.prevTransformTemplateValue = undefined;
              this.targetDelta = undefined;
              this.target = undefined;
              this.isLayoutDirty = false;
          }
          forceRelativeParentToResolveTarget() {
              if (!this.relativeParent)
                  return;
              /**
               * If the parent target isn't up-to-date, force it to update.
               * This is an unfortunate de-optimisation as it means any updating relative
               * projection will cause all the relative parents to recalculate back
               * up the tree.
               */
              if (this.relativeParent.resolvedRelativeTargetAt !==
                  frameData.timestamp) {
                  this.relativeParent.resolveTargetDelta(true);
              }
          }
          resolveTargetDelta(forceRecalculation = false) {
              var _a;
              /**
               * Once the dirty status of nodes has been spread through the tree, we also
               * need to check if we have a shared node of a different depth that has itself
               * been dirtied.
               */
              const lead = this.getLead();
              this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
              this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
              this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
              const isShared = Boolean(this.resumingFrom) || this !== lead;
              /**
               * We don't use transform for this step of processing so we don't
               * need to check whether any nodes have changed transform.
               */
              const canSkip = !(forceRecalculation ||
                  (isShared && this.isSharedProjectionDirty) ||
                  this.isProjectionDirty ||
                  ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) ||
                  this.attemptToResolveRelativeTarget);
              if (canSkip)
                  return;
              const { layout, layoutId } = this.options;
              /**
               * If we have no layout, we can't perform projection, so early return
               */
              if (!this.layout || !(layout || layoutId))
                  return;
              this.resolvedRelativeTargetAt = frameData.timestamp;
              /**
               * If we don't have a targetDelta but do have a layout, we can attempt to resolve
               * a relativeParent. This will allow a component to perform scale correction
               * even if no animation has started.
               */
              // TODO If this is unsuccessful this currently happens every frame
              if (!this.targetDelta && !this.relativeTarget) {
                  // TODO: This is a semi-repetition of further down this function, make DRY
                  const relativeParent = this.getClosestProjectingParent();
                  if (relativeParent &&
                      relativeParent.layout &&
                      this.animationProgress !== 1) {
                      this.relativeParent = relativeParent;
                      this.forceRelativeParentToResolveTarget();
                      this.relativeTarget = createBox();
                      this.relativeTargetOrigin = createBox();
                      calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                      copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                  }
                  else {
                      this.relativeParent = this.relativeTarget = undefined;
                  }
              }
              /**
               * If we have no relative target or no target delta our target isn't valid
               * for this frame.
               */
              if (!this.relativeTarget && !this.targetDelta)
                  return;
              /**
               * Lazy-init target data structure
               */
              if (!this.target) {
                  this.target = createBox();
                  this.targetWithTransforms = createBox();
              }
              /**
               * If we've got a relative box for this component, resolve it into a target relative to the parent.
               */
              if (this.relativeTarget &&
                  this.relativeTargetOrigin &&
                  this.relativeParent &&
                  this.relativeParent.target) {
                  this.forceRelativeParentToResolveTarget();
                  calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                  /**
                   * If we've only got a targetDelta, resolve it into a target
                   */
              }
              else if (this.targetDelta) {
                  if (Boolean(this.resumingFrom)) {
                      // TODO: This is creating a new object every frame
                      this.target = this.applyTransform(this.layout.layoutBox);
                  }
                  else {
                      copyBoxInto(this.target, this.layout.layoutBox);
                  }
                  applyBoxDelta(this.target, this.targetDelta);
              }
              else {
                  /**
                   * If no target, use own layout as target
                   */
                  copyBoxInto(this.target, this.layout.layoutBox);
              }
              /**
               * If we've been told to attempt to resolve a relative target, do so.
               */
              if (this.attemptToResolveRelativeTarget) {
                  this.attemptToResolveRelativeTarget = false;
                  const relativeParent = this.getClosestProjectingParent();
                  if (relativeParent &&
                      Boolean(relativeParent.resumingFrom) ===
                          Boolean(this.resumingFrom) &&
                      !relativeParent.options.layoutScroll &&
                      relativeParent.target &&
                      this.animationProgress !== 1) {
                      this.relativeParent = relativeParent;
                      this.forceRelativeParentToResolveTarget();
                      this.relativeTarget = createBox();
                      this.relativeTargetOrigin = createBox();
                      calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                      copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                  }
                  else {
                      this.relativeParent = this.relativeTarget = undefined;
                  }
              }
              /**
               * Increase debug counter for resolved target deltas
               */
              projectionFrameData.resolvedTargetDeltas++;
          }
          getClosestProjectingParent() {
              if (!this.parent ||
                  hasScale(this.parent.latestValues) ||
                  has2DTranslate(this.parent.latestValues)) {
                  return undefined;
              }
              if (this.parent.isProjecting()) {
                  return this.parent;
              }
              else {
                  return this.parent.getClosestProjectingParent();
              }
          }
          isProjecting() {
              return Boolean((this.relativeTarget ||
                  this.targetDelta ||
                  this.options.layoutRoot) &&
                  this.layout);
          }
          calcProjection() {
              var _a;
              const lead = this.getLead();
              const isShared = Boolean(this.resumingFrom) || this !== lead;
              let canSkip = true;
              /**
               * If this is a normal layout animation and neither this node nor its nearest projecting
               * is dirty then we can't skip.
               */
              if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
                  canSkip = false;
              }
              /**
               * If this is a shared layout animation and this node's shared projection is dirty then
               * we can't skip.
               */
              if (isShared &&
                  (this.isSharedProjectionDirty || this.isTransformDirty)) {
                  canSkip = false;
              }
              /**
               * If we have resolved the target this frame we must recalculate the
               * projection to ensure it visually represents the internal calculations.
               */
              if (this.resolvedRelativeTargetAt === frameData.timestamp) {
                  canSkip = false;
              }
              if (canSkip)
                  return;
              const { layout, layoutId } = this.options;
              /**
               * If this section of the tree isn't animating we can
               * delete our target sources for the following frame.
               */
              this.isTreeAnimating = Boolean((this.parent && this.parent.isTreeAnimating) ||
                  this.currentAnimation ||
                  this.pendingAnimation);
              if (!this.isTreeAnimating) {
                  this.targetDelta = this.relativeTarget = undefined;
              }
              if (!this.layout || !(layout || layoutId))
                  return;
              /**
               * Reset the corrected box with the latest values from box, as we're then going
               * to perform mutative operations on it.
               */
              copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
              /**
               * Record previous tree scales before updating.
               */
              const prevTreeScaleX = this.treeScale.x;
              const prevTreeScaleY = this.treeScale.y;
              /**
               * Apply all the parent deltas to this box to produce the corrected box. This
               * is the layout box, as it will appear on screen as a result of the transforms of its parents.
               */
              applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
              /**
               * If this layer needs to perform scale correction but doesn't have a target,
               * use the layout as the target.
               */
              if (lead.layout &&
                  !lead.target &&
                  (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                  lead.target = lead.layout.layoutBox;
              }
              const { target } = lead;
              if (!target) {
                  /**
                   * If we don't have a target to project into, but we were previously
                   * projecting, we want to remove the stored transform and schedule
                   * a render to ensure the elements reflect the removed transform.
                   */
                  if (this.projectionTransform) {
                      this.projectionDelta = createDelta();
                      this.projectionTransform = "none";
                      this.scheduleRender();
                  }
                  return;
              }
              if (!this.projectionDelta) {
                  this.projectionDelta = createDelta();
                  this.projectionDeltaWithTransform = createDelta();
              }
              const prevProjectionTransform = this.projectionTransform;
              /**
               * Update the delta between the corrected box and the target box before user-set transforms were applied.
               * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
               * for our layout reprojection, but still allow them to be scaled correctly by the user.
               * It might be that to simplify this we may want to accept that user-set scale is also corrected
               * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
               * to allow people to choose whether these styles are corrected based on just the
               * layout reprojection or the final bounding box.
               */
              calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
              this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
              if (this.projectionTransform !== prevProjectionTransform ||
                  this.treeScale.x !== prevTreeScaleX ||
                  this.treeScale.y !== prevTreeScaleY) {
                  this.hasProjected = true;
                  this.scheduleRender();
                  this.notifyListeners("projectionUpdate", target);
              }
              /**
               * Increase debug counter for recalculated projections
               */
              projectionFrameData.recalculatedProjection++;
          }
          hide() {
              this.isVisible = false;
              // TODO: Schedule render
          }
          show() {
              this.isVisible = true;
              // TODO: Schedule render
          }
          scheduleRender(notifyAll = true) {
              this.options.scheduleRender && this.options.scheduleRender();
              if (notifyAll) {
                  const stack = this.getStack();
                  stack && stack.scheduleRender();
              }
              if (this.resumingFrom && !this.resumingFrom.instance) {
                  this.resumingFrom = undefined;
              }
          }
          setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
              const snapshot = this.snapshot;
              const snapshotLatestValues = snapshot
                  ? snapshot.latestValues
                  : {};
              const mixedValues = { ...this.latestValues };
              const targetDelta = createDelta();
              if (!this.relativeParent ||
                  !this.relativeParent.options.layoutRoot) {
                  this.relativeTarget = this.relativeTargetOrigin = undefined;
              }
              this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
              const relativeLayout = createBox();
              const snapshotSource = snapshot ? snapshot.source : undefined;
              const layoutSource = this.layout ? this.layout.source : undefined;
              const isSharedLayoutAnimation = snapshotSource !== layoutSource;
              const stack = this.getStack();
              const isOnlyMember = !stack || stack.members.length <= 1;
              const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                  !isOnlyMember &&
                  this.options.crossfade === true &&
                  !this.path.some(hasOpacityCrossfade));
              this.animationProgress = 0;
              let prevRelativeTarget;
              this.mixTargetDelta = (latest) => {
                  const progress = latest / 1000;
                  mixAxisDelta(targetDelta.x, delta.x, progress);
                  mixAxisDelta(targetDelta.y, delta.y, progress);
                  this.setTargetDelta(targetDelta);
                  if (this.relativeTarget &&
                      this.relativeTargetOrigin &&
                      this.layout &&
                      this.relativeParent &&
                      this.relativeParent.layout) {
                      calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                      mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                      /**
                       * If this is an unchanged relative target we can consider the
                       * projection not dirty.
                       */
                      if (prevRelativeTarget &&
                          boxEquals(this.relativeTarget, prevRelativeTarget)) {
                          this.isProjectionDirty = false;
                      }
                      if (!prevRelativeTarget)
                          prevRelativeTarget = createBox();
                      copyBoxInto(prevRelativeTarget, this.relativeTarget);
                  }
                  if (isSharedLayoutAnimation) {
                      this.animationValues = mixedValues;
                      mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                  }
                  this.root.scheduleUpdateProjection();
                  this.scheduleRender();
                  this.animationProgress = progress;
              };
              this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
          }
          startAnimation(options) {
              this.notifyListeners("animationStart");
              this.currentAnimation && this.currentAnimation.stop();
              if (this.resumingFrom && this.resumingFrom.currentAnimation) {
                  this.resumingFrom.currentAnimation.stop();
              }
              if (this.pendingAnimation) {
                  cancelFrame(this.pendingAnimation);
                  this.pendingAnimation = undefined;
              }
              /**
               * Start the animation in the next frame to have a frame with progress 0,
               * where the target is the same as when the animation started, so we can
               * calculate the relative positions correctly for instant transitions.
               */
              this.pendingAnimation = frame.update(() => {
                  globalProjectionState.hasAnimatedSinceResize = true;
                  this.currentAnimation = animateSingleValue(0, animationTarget, {
                      ...options,
                      onUpdate: (latest) => {
                          this.mixTargetDelta(latest);
                          options.onUpdate && options.onUpdate(latest);
                      },
                      onComplete: () => {
                          options.onComplete && options.onComplete();
                          this.completeAnimation();
                      },
                  });
                  if (this.resumingFrom) {
                      this.resumingFrom.currentAnimation = this.currentAnimation;
                  }
                  this.pendingAnimation = undefined;
              });
          }
          completeAnimation() {
              if (this.resumingFrom) {
                  this.resumingFrom.currentAnimation = undefined;
                  this.resumingFrom.preserveOpacity = undefined;
              }
              const stack = this.getStack();
              stack && stack.exitAnimationComplete();
              this.resumingFrom =
                  this.currentAnimation =
                      this.animationValues =
                          undefined;
              this.notifyListeners("animationComplete");
          }
          finishAnimation() {
              if (this.currentAnimation) {
                  this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                  this.currentAnimation.stop();
              }
              this.completeAnimation();
          }
          applyTransformsToTarget() {
              const lead = this.getLead();
              let { targetWithTransforms, target, layout, latestValues } = lead;
              if (!targetWithTransforms || !target || !layout)
                  return;
              /**
               * If we're only animating position, and this element isn't the lead element,
               * then instead of projecting into the lead box we instead want to calculate
               * a new target that aligns the two boxes but maintains the layout shape.
               */
              if (this !== lead &&
                  this.layout &&
                  layout &&
                  shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                  target = this.target || createBox();
                  const xLength = calcLength(this.layout.layoutBox.x);
                  target.x.min = lead.target.x.min;
                  target.x.max = target.x.min + xLength;
                  const yLength = calcLength(this.layout.layoutBox.y);
                  target.y.min = lead.target.y.min;
                  target.y.max = target.y.min + yLength;
              }
              copyBoxInto(targetWithTransforms, target);
              /**
               * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
               * This is the final box that we will then project into by calculating a transform delta and
               * applying it to the corrected box.
               */
              transformBox(targetWithTransforms, latestValues);
              /**
               * Update the delta between the corrected box and the final target box, after
               * user-set transforms are applied to it. This will be used by the renderer to
               * create a transform style that will reproject the element from its layout layout
               * into the desired bounding box.
               */
              calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
          }
          registerSharedNode(layoutId, node) {
              if (!this.sharedNodes.has(layoutId)) {
                  this.sharedNodes.set(layoutId, new NodeStack());
              }
              const stack = this.sharedNodes.get(layoutId);
              stack.add(node);
              const config = node.options.initialPromotionConfig;
              node.promote({
                  transition: config ? config.transition : undefined,
                  preserveFollowOpacity: config && config.shouldPreserveFollowOpacity
                      ? config.shouldPreserveFollowOpacity(node)
                      : undefined,
              });
          }
          isLead() {
              const stack = this.getStack();
              return stack ? stack.lead === this : true;
          }
          getLead() {
              var _a;
              const { layoutId } = this.options;
              return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
          }
          getPrevLead() {
              var _a;
              const { layoutId } = this.options;
              return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
          }
          getStack() {
              const { layoutId } = this.options;
              if (layoutId)
                  return this.root.sharedNodes.get(layoutId);
          }
          promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
              const stack = this.getStack();
              if (stack)
                  stack.promote(this, preserveFollowOpacity);
              if (needsReset) {
                  this.projectionDelta = undefined;
                  this.needsReset = true;
              }
              if (transition)
                  this.setOptions({ transition });
          }
          relegate() {
              const stack = this.getStack();
              if (stack) {
                  return stack.relegate(this);
              }
              else {
                  return false;
              }
          }
          resetRotation() {
              const { visualElement } = this.options;
              if (!visualElement)
                  return;
              // If there's no detected rotation values, we can early return without a forced render.
              let hasRotate = false;
              /**
               * An unrolled check for rotation values. Most elements don't have any rotation and
               * skipping the nested loop and new object creation is 50% faster.
               */
              const { latestValues } = visualElement;
              if (latestValues.rotate ||
                  latestValues.rotateX ||
                  latestValues.rotateY ||
                  latestValues.rotateZ) {
                  hasRotate = true;
              }
              // If there's no rotation values, we don't need to do any more.
              if (!hasRotate)
                  return;
              const resetValues = {};
              // Check the rotate value of all axes and reset to 0
              for (let i = 0; i < transformAxes.length; i++) {
                  const key = "rotate" + transformAxes[i];
                  // Record the rotation and then temporarily set it to 0
                  if (latestValues[key]) {
                      resetValues[key] = latestValues[key];
                      visualElement.setStaticValue(key, 0);
                  }
              }
              // Force a render of this element to apply the transform with all rotations
              // set to 0.
              visualElement.render();
              // Put back all the values we reset
              for (const key in resetValues) {
                  visualElement.setStaticValue(key, resetValues[key]);
              }
              // Schedule a render for the next frame. This ensures we won't visually
              // see the element with the reset rotate value applied.
              visualElement.scheduleRender();
          }
          getProjectionStyles(styleProp) {
              var _a, _b;
              if (!this.instance || this.isSVG)
                  return undefined;
              if (!this.isVisible) {
                  return hiddenVisibility;
              }
              const styles = {
                  visibility: "",
              };
              const transformTemplate = this.getTransformTemplate();
              if (this.needsReset) {
                  this.needsReset = false;
                  styles.opacity = "";
                  styles.pointerEvents =
                      resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                  styles.transform = transformTemplate
                      ? transformTemplate(this.latestValues, "")
                      : "none";
                  return styles;
              }
              const lead = this.getLead();
              if (!this.projectionDelta || !this.layout || !lead.target) {
                  const emptyStyles = {};
                  if (this.options.layoutId) {
                      emptyStyles.opacity =
                          this.latestValues.opacity !== undefined
                              ? this.latestValues.opacity
                              : 1;
                      emptyStyles.pointerEvents =
                          resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                  }
                  if (this.hasProjected && !hasTransform(this.latestValues)) {
                      emptyStyles.transform = transformTemplate
                          ? transformTemplate({}, "")
                          : "none";
                      this.hasProjected = false;
                  }
                  return emptyStyles;
              }
              const valuesToRender = lead.animationValues || lead.latestValues;
              this.applyTransformsToTarget();
              styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
              if (transformTemplate) {
                  styles.transform = transformTemplate(valuesToRender, styles.transform);
              }
              const { x, y } = this.projectionDelta;
              styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
              if (lead.animationValues) {
                  /**
                   * If the lead component is animating, assign this either the entering/leaving
                   * opacity
                   */
                  styles.opacity =
                      lead === this
                          ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1
                          : this.preserveOpacity
                              ? this.latestValues.opacity
                              : valuesToRender.opacityExit;
              }
              else {
                  /**
                   * Or we're not animating at all, set the lead component to its layout
                   * opacity and other components to hidden.
                   */
                  styles.opacity =
                      lead === this
                          ? valuesToRender.opacity !== undefined
                              ? valuesToRender.opacity
                              : ""
                          : valuesToRender.opacityExit !== undefined
                              ? valuesToRender.opacityExit
                              : 0;
              }
              /**
               * Apply scale correction
               */
              for (const key in scaleCorrectors) {
                  if (valuesToRender[key] === undefined)
                      continue;
                  const { correct, applyTo } = scaleCorrectors[key];
                  /**
                   * Only apply scale correction to the value if we have an
                   * active projection transform. Otherwise these values become
                   * vulnerable to distortion if the element changes size without
                   * a corresponding layout animation.
                   */
                  const corrected = styles.transform === "none"
                      ? valuesToRender[key]
                      : correct(valuesToRender[key], lead);
                  if (applyTo) {
                      const num = applyTo.length;
                      for (let i = 0; i < num; i++) {
                          styles[applyTo[i]] = corrected;
                      }
                  }
                  else {
                      styles[key] = corrected;
                  }
              }
              /**
               * Disable pointer events on follow components. This is to ensure
               * that if a follow component covers a lead component it doesn't block
               * pointer events on the lead.
               */
              if (this.options.layoutId) {
                  styles.pointerEvents =
                      lead === this
                          ? resolveMotionValue(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || ""
                          : "none";
              }
              return styles;
          }
          clearSnapshot() {
              this.resumeFrom = this.snapshot = undefined;
          }
          // Only run on root
          resetTree() {
              this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
              this.root.nodes.forEach(clearMeasurements);
              this.root.sharedNodes.clear();
          }
      };
  }
  function updateLayout(node) {
      node.updateLayout();
  }
  function notifyLayoutUpdate(node) {
      var _a;
      const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
      if (node.isLead() &&
          node.layout &&
          snapshot &&
          node.hasListeners("didUpdate")) {
          const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
          const { animationType } = node.options;
          const isShared = snapshot.source !== node.layout.source;
          // TODO Maybe we want to also resize the layout snapshot so we don't trigger
          // animations for instance if layout="size" and an element has only changed position
          if (animationType === "size") {
              eachAxis((axis) => {
                  const axisSnapshot = isShared
                      ? snapshot.measuredBox[axis]
                      : snapshot.layoutBox[axis];
                  const length = calcLength(axisSnapshot);
                  axisSnapshot.min = layout[axis].min;
                  axisSnapshot.max = axisSnapshot.min + length;
              });
          }
          else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
              eachAxis((axis) => {
                  const axisSnapshot = isShared
                      ? snapshot.measuredBox[axis]
                      : snapshot.layoutBox[axis];
                  const length = calcLength(layout[axis]);
                  axisSnapshot.max = axisSnapshot.min + length;
                  /**
                   * Ensure relative target gets resized and rerendererd
                   */
                  if (node.relativeTarget && !node.currentAnimation) {
                      node.isProjectionDirty = true;
                      node.relativeTarget[axis].max =
                          node.relativeTarget[axis].min + length;
                  }
              });
          }
          const layoutDelta = createDelta();
          calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
          const visualDelta = createDelta();
          if (isShared) {
              calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
          }
          else {
              calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
          }
          const hasLayoutChanged = !isDeltaZero(layoutDelta);
          let hasRelativeTargetChanged = false;
          if (!node.resumeFrom) {
              const relativeParent = node.getClosestProjectingParent();
              /**
               * If the relativeParent is itself resuming from a different element then
               * the relative snapshot is not relavent
               */
              if (relativeParent && !relativeParent.resumeFrom) {
                  const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                  if (parentSnapshot && parentLayout) {
                      const relativeSnapshot = createBox();
                      calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                      const relativeLayout = createBox();
                      calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                      if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
                          hasRelativeTargetChanged = true;
                      }
                      if (relativeParent.options.layoutRoot) {
                          node.relativeTarget = relativeLayout;
                          node.relativeTargetOrigin = relativeSnapshot;
                          node.relativeParent = relativeParent;
                      }
                  }
              }
          }
          node.notifyListeners("didUpdate", {
              layout,
              snapshot,
              delta: visualDelta,
              layoutDelta,
              hasLayoutChanged,
              hasRelativeTargetChanged,
          });
      }
      else if (node.isLead()) {
          const { onExitComplete } = node.options;
          onExitComplete && onExitComplete();
      }
      /**
       * Clearing transition
       * TODO: Investigate why this transition is being passed in as {type: false } from Framer
       * and why we need it at all
       */
      node.options.transition = undefined;
  }
  function propagateDirtyNodes(node) {
      /**
       * Increase debug counter for nodes encountered this frame
       */
      projectionFrameData.totalNodes++;
      if (!node.parent)
          return;
      /**
       * If this node isn't projecting, propagate isProjectionDirty. It will have
       * no performance impact but it will allow the next child that *is* projecting
       * but *isn't* dirty to just check its parent to see if *any* ancestor needs
       * correcting.
       */
      if (!node.isProjecting()) {
          node.isProjectionDirty = node.parent.isProjectionDirty;
      }
      /**
       * Propagate isSharedProjectionDirty and isTransformDirty
       * throughout the whole tree. A future revision can take another look at
       * this but for safety we still recalcualte shared nodes.
       */
      node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty ||
          node.parent.isProjectionDirty ||
          node.parent.isSharedProjectionDirty));
      node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
  }
  function cleanDirtyNodes(node) {
      node.isProjectionDirty =
          node.isSharedProjectionDirty =
              node.isTransformDirty =
                  false;
  }
  function clearSnapshot(node) {
      node.clearSnapshot();
  }
  function clearMeasurements(node) {
      node.clearMeasurements();
  }
  function clearIsLayoutDirty(node) {
      node.isLayoutDirty = false;
  }
  function resetTransformStyle(node) {
      const { visualElement } = node.options;
      if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
          visualElement.notify("BeforeLayoutMeasure");
      }
      node.resetTransform();
  }
  function finishAnimation(node) {
      node.finishAnimation();
      node.targetDelta = node.relativeTarget = node.target = undefined;
      node.isProjectionDirty = true;
  }
  function resolveTargetDelta(node) {
      node.resolveTargetDelta();
  }
  function calcProjection(node) {
      node.calcProjection();
  }
  function resetRotation(node) {
      node.resetRotation();
  }
  function removeLeadSnapshots(stack) {
      stack.removeLeadSnapshot();
  }
  function mixAxisDelta(output, delta, p) {
      output.translate = mix(delta.translate, 0, p);
      output.scale = mix(delta.scale, 1, p);
      output.origin = delta.origin;
      output.originPoint = delta.originPoint;
  }
  function mixAxis(output, from, to, p) {
      output.min = mix(from.min, to.min, p);
      output.max = mix(from.max, to.max, p);
  }
  function mixBox(output, from, to, p) {
      mixAxis(output.x, from.x, to.x, p);
      mixAxis(output.y, from.y, to.y, p);
  }
  function hasOpacityCrossfade(node) {
      return (node.animationValues && node.animationValues.opacityExit !== undefined);
  }
  const defaultLayoutTransition = {
      duration: 0.45,
      ease: [0.4, 0, 0.1, 1],
  };
  const userAgentContains = (string) => typeof navigator !== "undefined" &&
      navigator.userAgent.toLowerCase().includes(string);
  /**
   * Measured bounding boxes must be rounded in Safari and
   * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
   * can appear to jump.
   */
  const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/")
      ? Math.round
      : noop;
  function roundAxis(axis) {
      // Round to the nearest .5 pixels to support subpixel layouts
      axis.min = roundPoint(axis.min);
      axis.max = roundPoint(axis.max);
  }
  function roundBox(box) {
      roundAxis(box.x);
      roundAxis(box.y);
  }
  function shouldAnimatePositionOnly(animationType, snapshot, layout) {
      return (animationType === "position" ||
          (animationType === "preserve-aspect" &&
              !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
  }

  const DocumentProjectionNode = createProjectionNode({
      attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
      measureScroll: () => ({
          x: document.documentElement.scrollLeft || document.body.scrollLeft,
          y: document.documentElement.scrollTop || document.body.scrollTop,
      }),
      checkIsScrollRoot: () => true,
  });

  const rootProjectionNode = {
      current: undefined,
  };
  const HTMLProjectionNode = createProjectionNode({
      measureScroll: (instance) => ({
          x: instance.scrollLeft,
          y: instance.scrollTop,
      }),
      defaultParent: () => {
          if (!rootProjectionNode.current) {
              const documentNode = new DocumentProjectionNode({});
              documentNode.mount(window);
              documentNode.setOptions({ layoutScroll: true });
              rootProjectionNode.current = documentNode;
          }
          return rootProjectionNode.current;
      },
      resetTransform: (instance, value) => {
          instance.style.transform = value !== undefined ? value : "none";
      },
      checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
  });

  const drag = {
      pan: {
          Feature: PanGesture,
      },
      drag: {
          Feature: DragGesture,
          ProjectionNode: HTMLProjectionNode,
          MeasureLayout,
      },
  };

  /**
   * Parse Framer's special CSS variable format into a CSS token and a fallback.
   *
   * ```
   * `var(--foo, #fff)` => [`--foo`, '#fff']
   * ```
   *
   * @param current
   */
  const splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
  function parseCSSVariable(current) {
      const match = splitCSSVariableRegex.exec(current);
      if (!match)
          return [,];
      const [, token, fallback] = match;
      return [token, fallback];
  }
  function getVariableValue(current, element, depth = 1) {
      const [token, fallback] = parseCSSVariable(current);
      // No CSS variable detected
      if (!token)
          return;
      // Attempt to read this CSS variable off the element
      const resolved = window.getComputedStyle(element).getPropertyValue(token);
      if (resolved) {
          const trimmed = resolved.trim();
          return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
      }
      else if (isCSSVariableToken(fallback)) {
          // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
          return getVariableValue(fallback, element, depth + 1);
      }
      else {
          return fallback;
      }
  }
  /**
   * Resolve CSS variables from
   *
   * @internal
   */
  function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
      const element = visualElement.current;
      if (!(element instanceof Element))
          return { target, transitionEnd };
      // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
      // only if they change but I think this reads clearer and this isn't a performance-critical path.
      if (transitionEnd) {
          transitionEnd = { ...transitionEnd };
      }
      // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
      visualElement.values.forEach((value) => {
          const current = value.get();
          if (!isCSSVariableToken(current))
              return;
          const resolved = getVariableValue(current, element);
          if (resolved)
              value.set(resolved);
      });
      // Cycle through every target property and resolve CSS variables. Currently
      // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
      for (const key in target) {
          const current = target[key];
          if (!isCSSVariableToken(current))
              continue;
          const resolved = getVariableValue(current, element);
          if (!resolved)
              continue;
          // Clone target if it hasn't already been
          target[key] = resolved;
          if (!transitionEnd)
              transitionEnd = {};
          // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
          // CSS variable. This will ensure that after the animation the component will reflect
          // changes in the value of the CSS variable.
          if (transitionEnd[key] === undefined) {
              transitionEnd[key] = current;
          }
      }
      return { target, transitionEnd };
  }

  const positionalKeys = new Set([
      "width",
      "height",
      "top",
      "left",
      "right",
      "bottom",
      "x",
      "y",
      "translateX",
      "translateY",
  ]);
  const isPositionalKey = (key) => positionalKeys.has(key);
  const hasPositionalKey = (target) => {
      return Object.keys(target).some(isPositionalKey);
  };
  const isNumOrPxType = (v) => v === number || v === px;
  const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
  const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
      if (transform === "none" || !transform)
          return 0;
      const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
      if (matrix3d) {
          return getPosFromMatrix(matrix3d[1], pos3);
      }
      else {
          const matrix = transform.match(/^matrix\((.+)\)$/);
          if (matrix) {
              return getPosFromMatrix(matrix[1], pos2);
          }
          else {
              return 0;
          }
      }
  };
  const transformKeys = new Set(["x", "y", "z"]);
  const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
  function removeNonTranslationalTransform(visualElement) {
      const removedTransforms = [];
      nonTranslationalTransformKeys.forEach((key) => {
          const value = visualElement.getValue(key);
          if (value !== undefined) {
              removedTransforms.push([key, value.get()]);
              value.set(key.startsWith("scale") ? 1 : 0);
          }
      });
      // Apply changes to element before measurement
      if (removedTransforms.length)
          visualElement.render();
      return removedTransforms;
  }
  const positionalValues = {
      // Dimensions
      width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
      height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
      top: (_bbox, { top }) => parseFloat(top),
      left: (_bbox, { left }) => parseFloat(left),
      bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
      right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
      // Transform
      x: getTranslateFromMatrix(4, 13),
      y: getTranslateFromMatrix(5, 14),
  };
  // Alias translate longform names
  positionalValues.translateX = positionalValues.x;
  positionalValues.translateY = positionalValues.y;
  const convertChangedValueTypes = (target, visualElement, changedKeys) => {
      const originBbox = visualElement.measureViewportBox();
      const element = visualElement.current;
      const elementComputedStyle = getComputedStyle(element);
      const { display } = elementComputedStyle;
      const origin = {};
      // If the element is currently set to display: "none", make it visible before
      // measuring the target bounding box
      if (display === "none") {
          visualElement.setStaticValue("display", target.display || "block");
      }
      /**
       * Record origins before we render and update styles
       */
      changedKeys.forEach((key) => {
          origin[key] = positionalValues[key](originBbox, elementComputedStyle);
      });
      // Apply the latest values (as set in checkAndConvertChangedValueTypes)
      visualElement.render();
      const targetBbox = visualElement.measureViewportBox();
      changedKeys.forEach((key) => {
          // Restore styles to their **calculated computed style**, not their actual
          // originally set style. This allows us to animate between equivalent pixel units.
          const value = visualElement.getValue(key);
          value && value.jump(origin[key]);
          target[key] = positionalValues[key](targetBbox, elementComputedStyle);
      });
      return target;
  };
  const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
      target = { ...target };
      transitionEnd = { ...transitionEnd };
      const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
      // We want to remove any transform values that could affect the element's bounding box before
      // it's measured. We'll reapply these later.
      let removedTransformValues = [];
      let hasAttemptedToRemoveTransformValues = false;
      const changedValueTypeKeys = [];
      targetPositionalKeys.forEach((key) => {
          const value = visualElement.getValue(key);
          if (!visualElement.hasValue(key))
              return;
          let from = origin[key];
          let fromType = findDimensionValueType(from);
          const to = target[key];
          let toType;
          // TODO: The current implementation of this basically throws an error
          // if you try and do value conversion via keyframes. There's probably
          // a way of doing this but the performance implications would need greater scrutiny,
          // as it'd be doing multiple resize-remeasure operations.
          if (isKeyframesTarget(to)) {
              const numKeyframes = to.length;
              const fromIndex = to[0] === null ? 1 : 0;
              from = to[fromIndex];
              fromType = findDimensionValueType(from);
              for (let i = fromIndex; i < numKeyframes; i++) {
                  /**
                   * Don't allow wildcard keyframes to be used to detect
                   * a difference in value types.
                   */
                  if (to[i] === null)
                      break;
                  if (!toType) {
                      toType = findDimensionValueType(to[i]);
                  }
                  else {
                      invariant(findDimensionValueType(to[i]) === toType);
                  }
              }
          }
          else {
              toType = findDimensionValueType(to);
          }
          if (fromType !== toType) {
              // If they're both just number or px, convert them both to numbers rather than
              // relying on resize/remeasure to convert (which is wasteful in this situation)
              if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                  const current = value.get();
                  if (typeof current === "string") {
                      value.set(parseFloat(current));
                  }
                  if (typeof to === "string") {
                      target[key] = parseFloat(to);
                  }
                  else if (Array.isArray(to) && toType === px) {
                      target[key] = to.map(parseFloat);
                  }
              }
              else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                  (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                  (from === 0 || to === 0)) {
                  // If one or the other value is 0, it's safe to coerce it to the
                  // type of the other without measurement
                  if (from === 0) {
                      value.set(toType.transform(from));
                  }
                  else {
                      target[key] = fromType.transform(to);
                  }
              }
              else {
                  // If we're going to do value conversion via DOM measurements, we first
                  // need to remove non-positional transform values that could affect the bbox measurements.
                  if (!hasAttemptedToRemoveTransformValues) {
                      removedTransformValues =
                          removeNonTranslationalTransform(visualElement);
                      hasAttemptedToRemoveTransformValues = true;
                  }
                  changedValueTypeKeys.push(key);
                  transitionEnd[key] =
                      transitionEnd[key] !== undefined
                          ? transitionEnd[key]
                          : target[key];
                  value.jump(to);
              }
          }
      });
      if (changedValueTypeKeys.length) {
          const scrollY = changedValueTypeKeys.indexOf("height") >= 0
              ? window.pageYOffset
              : null;
          const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
          // If we removed transform values, reapply them before the next render
          if (removedTransformValues.length) {
              removedTransformValues.forEach(([key, value]) => {
                  visualElement.getValue(key).set(value);
              });
          }
          // Reapply original values
          visualElement.render();
          // Restore scroll position
          if (isBrowser && scrollY !== null) {
              window.scrollTo({ top: scrollY });
          }
          return { target: convertedTarget, transitionEnd };
      }
      else {
          return { target, transitionEnd };
      }
  };
  /**
   * Convert value types for x/y/width/height/top/left/bottom/right
   *
   * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
   *
   * @internal
   */
  function unitConversion(visualElement, target, origin, transitionEnd) {
      return hasPositionalKey(target)
          ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
          : { target, transitionEnd };
  }

  /**
   * Parse a DOM variant to make it animatable. This involves resolving CSS variables
   * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
   */
  const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
      const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
      target = resolved.target;
      transitionEnd = resolved.transitionEnd;
      return unitConversion(visualElement, target, origin, transitionEnd);
  };

  // Does this device prefer reduced motion? Returns `null` server-side.
  const prefersReducedMotion = { current: null };
  const hasReducedMotionListener = { current: false };

  function initPrefersReducedMotion() {
      hasReducedMotionListener.current = true;
      if (!isBrowser)
          return;
      if (window.matchMedia) {
          const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
          const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
          motionMediaQuery.addListener(setReducedMotionPreferences);
          setReducedMotionPreferences();
      }
      else {
          prefersReducedMotion.current = false;
      }
  }

  function updateMotionValuesFromProps(element, next, prev) {
      const { willChange } = next;
      for (const key in next) {
          const nextValue = next[key];
          const prevValue = prev[key];
          if (isMotionValue(nextValue)) {
              /**
               * If this is a motion value found in props or style, we want to add it
               * to our visual element's motion value map.
               */
              element.addValue(key, nextValue);
              if (isWillChangeMotionValue(willChange)) {
                  willChange.add(key);
              }
          }
          else if (isMotionValue(prevValue)) {
              /**
               * If we're swapping from a motion value to a static value,
               * create a new motion value from that
               */
              element.addValue(key, motionValue(nextValue, { owner: element }));
              if (isWillChangeMotionValue(willChange)) {
                  willChange.remove(key);
              }
          }
          else if (prevValue !== nextValue) {
              /**
               * If this is a flat value that has changed, update the motion value
               * or create one if it doesn't exist. We only want to do this if we're
               * not handling the value with our animation state.
               */
              if (element.hasValue(key)) {
                  const existingValue = element.getValue(key);
                  // TODO: Only update values that aren't being animated or even looked at
                  !existingValue.hasAnimated && existingValue.set(nextValue);
              }
              else {
                  const latestValue = element.getStaticValue(key);
                  element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, { owner: element }));
              }
          }
      }
      // Handle removed values
      for (const key in prev) {
          if (next[key] === undefined)
              element.removeValue(key);
      }
      return next;
  }

  const visualElementStore = new WeakMap();

  const featureNames = Object.keys(featureDefinitions);
  const numFeatures = featureNames.length;
  const propEventHandlers = [
      "AnimationStart",
      "AnimationComplete",
      "Update",
      "BeforeLayoutMeasure",
      "LayoutMeasure",
      "LayoutAnimationStart",
      "LayoutAnimationComplete",
  ];
  const numVariantProps = variantProps.length;
  /**
   * A VisualElement is an imperative abstraction around UI elements such as
   * HTMLElement, SVGElement, Three.Object3D etc.
   */
  class VisualElement {
      constructor({ parent, props, presenceContext, reducedMotionConfig, visualState, }, options = {}) {
          /**
           * A reference to the current underlying Instance, e.g. a HTMLElement
           * or Three.Mesh etc.
           */
          this.current = null;
          /**
           * A set containing references to this VisualElement's children.
           */
          this.children = new Set();
          /**
           * Determine what role this visual element should take in the variant tree.
           */
          this.isVariantNode = false;
          this.isControllingVariants = false;
          /**
           * Decides whether this VisualElement should animate in reduced motion
           * mode.
           *
           * TODO: This is currently set on every individual VisualElement but feels
           * like it could be set globally.
           */
          this.shouldReduceMotion = null;
          /**
           * A map of all motion values attached to this visual element. Motion
           * values are source of truth for any given animated value. A motion
           * value might be provided externally by the component via props.
           */
          this.values = new Map();
          /**
           * Cleanup functions for active features (hover/tap/exit etc)
           */
          this.features = {};
          /**
           * A map of every subscription that binds the provided or generated
           * motion values onChange listeners to this visual element.
           */
          this.valueSubscriptions = new Map();
          /**
           * A reference to the previously-provided motion values as returned
           * from scrapeMotionValuesFromProps. We use the keys in here to determine
           * if any motion values need to be removed after props are updated.
           */
          this.prevMotionValues = {};
          /**
           * An object containing a SubscriptionManager for each active event.
           */
          this.events = {};
          /**
           * An object containing an unsubscribe function for each prop event subscription.
           * For example, every "Update" event can have multiple subscribers via
           * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
           */
          this.propEventSubscriptions = {};
          this.notifyUpdate = () => this.notify("Update", this.latestValues);
          this.render = () => {
              if (!this.current)
                  return;
              this.triggerBuild();
              this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
          };
          this.scheduleRender = () => frame.render(this.render, false, true);
          const { latestValues, renderState } = visualState;
          this.latestValues = latestValues;
          this.baseTarget = { ...latestValues };
          this.initialValues = props.initial ? { ...latestValues } : {};
          this.renderState = renderState;
          this.parent = parent;
          this.props = props;
          this.presenceContext = presenceContext;
          this.depth = parent ? parent.depth + 1 : 0;
          this.reducedMotionConfig = reducedMotionConfig;
          this.options = options;
          this.isControllingVariants = isControllingVariants(props);
          this.isVariantNode = isVariantNode(props);
          if (this.isVariantNode) {
              this.variantChildren = new Set();
          }
          this.manuallyAnimateOnMount = Boolean(parent && parent.current);
          /**
           * Any motion values that are provided to the element when created
           * aren't yet bound to the element, as this would technically be impure.
           * However, we iterate through the motion values and set them to the
           * initial values for this component.
           *
           * TODO: This is impure and we should look at changing this to run on mount.
           * Doing so will break some tests but this isn't neccessarily a breaking change,
           * more a reflection of the test.
           */
          const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
          for (const key in initialMotionValues) {
              const value = initialMotionValues[key];
              if (latestValues[key] !== undefined && isMotionValue(value)) {
                  value.set(latestValues[key], false);
                  if (isWillChangeMotionValue(willChange)) {
                      willChange.add(key);
                  }
              }
          }
      }
      /**
       * This method takes React props and returns found MotionValues. For example, HTML
       * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
       *
       * This isn't an abstract method as it needs calling in the constructor, but it is
       * intended to be one.
       */
      scrapeMotionValuesFromProps(_props, _prevProps) {
          return {};
      }
      mount(instance) {
          this.current = instance;
          visualElementStore.set(instance, this);
          if (this.projection && !this.projection.instance) {
              this.projection.mount(instance);
          }
          if (this.parent && this.isVariantNode && !this.isControllingVariants) {
              this.removeFromVariantTree = this.parent.addVariantChild(this);
          }
          this.values.forEach((value, key) => this.bindToMotionValue(key, value));
          if (!hasReducedMotionListener.current) {
              initPrefersReducedMotion();
          }
          this.shouldReduceMotion =
              this.reducedMotionConfig === "never"
                  ? false
                  : this.reducedMotionConfig === "always"
                      ? true
                      : prefersReducedMotion.current;
          if (this.parent)
              this.parent.children.add(this);
          this.update(this.props, this.presenceContext);
      }
      unmount() {
          visualElementStore.delete(this.current);
          this.projection && this.projection.unmount();
          cancelFrame(this.notifyUpdate);
          cancelFrame(this.render);
          this.valueSubscriptions.forEach((remove) => remove());
          this.removeFromVariantTree && this.removeFromVariantTree();
          this.parent && this.parent.children.delete(this);
          for (const key in this.events) {
              this.events[key].clear();
          }
          for (const key in this.features) {
              this.features[key].unmount();
          }
          this.current = null;
      }
      bindToMotionValue(key, value) {
          const valueIsTransform = transformProps.has(key);
          const removeOnChange = value.on("change", (latestValue) => {
              this.latestValues[key] = latestValue;
              this.props.onUpdate &&
                  frame.update(this.notifyUpdate, false, true);
              if (valueIsTransform && this.projection) {
                  this.projection.isTransformDirty = true;
              }
          });
          const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
          this.valueSubscriptions.set(key, () => {
              removeOnChange();
              removeOnRenderRequest();
          });
      }
      sortNodePosition(other) {
          /**
           * If these nodes aren't even of the same type we can't compare their depth.
           */
          if (!this.current ||
              !this.sortInstanceNodePosition ||
              this.type !== other.type) {
              return 0;
          }
          return this.sortInstanceNodePosition(this.current, other.current);
      }
      loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
          let ProjectionNodeConstructor;
          let MeasureLayout;
          for (let i = 0; i < numFeatures; i++) {
              const name = featureNames[i];
              const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent, } = featureDefinitions[name];
              if (ProjectionNode)
                  ProjectionNodeConstructor = ProjectionNode;
              if (isEnabled(renderedProps)) {
                  if (!this.features[name] && FeatureConstructor) {
                      this.features[name] = new FeatureConstructor(this);
                  }
                  if (MeasureLayoutComponent) {
                      MeasureLayout = MeasureLayoutComponent;
                  }
              }
          }
          if ((this.type === "html" || this.type === "svg") &&
              !this.projection &&
              ProjectionNodeConstructor) {
              this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
              const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot, } = renderedProps;
              this.projection.setOptions({
                  layoutId,
                  layout,
                  alwaysMeasureLayout: Boolean(drag) ||
                      (dragConstraints && isRefObject(dragConstraints)),
                  visualElement: this,
                  scheduleRender: () => this.scheduleRender(),
                  /**
                   * TODO: Update options in an effect. This could be tricky as it'll be too late
                   * to update by the time layout animations run.
                   * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                   * ensuring it gets called if there's no potential layout animations.
                   *
                   */
                  animationType: typeof layout === "string" ? layout : "both",
                  initialPromotionConfig: initialLayoutGroupConfig,
                  layoutScroll,
                  layoutRoot,
              });
          }
          return MeasureLayout;
      }
      updateFeatures() {
          for (const key in this.features) {
              const feature = this.features[key];
              if (feature.isMounted) {
                  feature.update();
              }
              else {
                  feature.mount();
                  feature.isMounted = true;
              }
          }
      }
      triggerBuild() {
          this.build(this.renderState, this.latestValues, this.options, this.props);
      }
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox() {
          return this.current
              ? this.measureInstanceViewportBox(this.current, this.props)
              : createBox();
      }
      getStaticValue(key) {
          return this.latestValues[key];
      }
      setStaticValue(key, value) {
          this.latestValues[key] = value;
      }
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable(target, canMutate = true) {
          return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
      }
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      update(props, presenceContext) {
          if (props.transformTemplate || this.props.transformTemplate) {
              this.scheduleRender();
          }
          this.prevProps = this.props;
          this.props = props;
          this.prevPresenceContext = this.presenceContext;
          this.presenceContext = presenceContext;
          /**
           * Update prop event handlers ie onAnimationStart, onAnimationComplete
           */
          for (let i = 0; i < propEventHandlers.length; i++) {
              const key = propEventHandlers[i];
              if (this.propEventSubscriptions[key]) {
                  this.propEventSubscriptions[key]();
                  delete this.propEventSubscriptions[key];
              }
              const listener = props["on" + key];
              if (listener) {
                  this.propEventSubscriptions[key] = this.on(key, listener);
              }
          }
          this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
          if (this.handleChildMotionValue) {
              this.handleChildMotionValue();
          }
      }
      getProps() {
          return this.props;
      }
      /**
       * Returns the variant definition with a given name.
       */
      getVariant(name) {
          return this.props.variants ? this.props.variants[name] : undefined;
      }
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition() {
          return this.props.transition;
      }
      getTransformPagePoint() {
          return this.props.transformPagePoint;
      }
      getClosestVariantNode() {
          return this.isVariantNode
              ? this
              : this.parent
                  ? this.parent.getClosestVariantNode()
                  : undefined;
      }
      getVariantContext(startAtParent = false) {
          if (startAtParent) {
              return this.parent ? this.parent.getVariantContext() : undefined;
          }
          if (!this.isControllingVariants) {
              const context = this.parent
                  ? this.parent.getVariantContext() || {}
                  : {};
              if (this.props.initial !== undefined) {
                  context.initial = this.props.initial;
              }
              return context;
          }
          const context = {};
          for (let i = 0; i < numVariantProps; i++) {
              const name = variantProps[i];
              const prop = this.props[name];
              if (isVariantLabel(prop) || prop === false) {
                  context[name] = prop;
              }
          }
          return context;
      }
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild(child) {
          const closestVariantNode = this.getClosestVariantNode();
          if (closestVariantNode) {
              closestVariantNode.variantChildren &&
                  closestVariantNode.variantChildren.add(child);
              return () => closestVariantNode.variantChildren.delete(child);
          }
      }
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue(key, value) {
          // Remove existing value if it exists
          if (value !== this.values.get(key)) {
              this.removeValue(key);
              this.bindToMotionValue(key, value);
          }
          this.values.set(key, value);
          this.latestValues[key] = value.get();
      }
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue(key) {
          this.values.delete(key);
          const unsubscribe = this.valueSubscriptions.get(key);
          if (unsubscribe) {
              unsubscribe();
              this.valueSubscriptions.delete(key);
          }
          delete this.latestValues[key];
          this.removeValueFromRenderState(key, this.renderState);
      }
      /**
       * Check whether we have a motion value for this key
       */
      hasValue(key) {
          return this.values.has(key);
      }
      getValue(key, defaultValue) {
          if (this.props.values && this.props.values[key]) {
              return this.props.values[key];
          }
          let value = this.values.get(key);
          if (value === undefined && defaultValue !== undefined) {
              value = motionValue(defaultValue, { owner: this });
              this.addValue(key, value);
          }
          return value;
      }
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue(key) {
          var _a;
          return this.latestValues[key] !== undefined || !this.current
              ? this.latestValues[key]
              : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
      }
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget(key, value) {
          this.baseTarget[key] = value;
      }
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget(key) {
          var _a;
          const { initial } = this.props;
          const valueFromInitial = typeof initial === "string" || typeof initial === "object"
              ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
              : undefined;
          /**
           * If this value still exists in the current initial variant, read that.
           */
          if (initial && valueFromInitial !== undefined) {
              return valueFromInitial;
          }
          /**
           * Alternatively, if this VisualElement config has defined a getBaseTarget
           * so we can read the value from an alternative source, try that.
           */
          const target = this.getBaseTargetFromProps(this.props, key);
          if (target !== undefined && !isMotionValue(target))
              return target;
          /**
           * If the value was initially defined on initial, but it doesn't any more,
           * return undefined. Otherwise return the value as initially read from the DOM.
           */
          return this.initialValues[key] !== undefined &&
              valueFromInitial === undefined
              ? undefined
              : this.baseTarget[key];
      }
      on(eventName, callback) {
          if (!this.events[eventName]) {
              this.events[eventName] = new SubscriptionManager();
          }
          return this.events[eventName].add(callback);
      }
      notify(eventName, ...args) {
          if (this.events[eventName]) {
              this.events[eventName].notify(...args);
          }
      }
  }

  class DOMVisualElement extends VisualElement {
      sortInstanceNodePosition(a, b) {
          /**
           * compareDocumentPosition returns a bitmask, by using the bitwise &
           * we're returning true if 2 in that bitmask is set to true. 2 is set
           * to true if b preceeds a.
           */
          return a.compareDocumentPosition(b) & 2 ? 1 : -1;
      }
      getBaseTargetFromProps(props, key) {
          return props.style ? props.style[key] : undefined;
      }
      removeValueFromRenderState(key, { vars, style }) {
          delete vars[key];
          delete style[key];
      }
      makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
          let origin = getOrigin(target, transition || {}, this);
          /**
           * If Framer has provided a function to convert `Color` etc value types, convert them
           */
          if (transformValues) {
              if (transitionEnd)
                  transitionEnd = transformValues(transitionEnd);
              if (target)
                  target = transformValues(target);
              if (origin)
                  origin = transformValues(origin);
          }
          if (isMounted) {
              checkTargetForNewValues(this, target, origin);
              const parsed = parseDomVariant(this, target, origin, transitionEnd);
              transitionEnd = parsed.transitionEnd;
              target = parsed.target;
          }
          return {
              transition,
              transitionEnd,
              ...target,
          };
      }
  }

  function getComputedStyle$1(element) {
      return window.getComputedStyle(element);
  }
  class HTMLVisualElement extends DOMVisualElement {
      constructor() {
          super(...arguments);
          this.type = "html";
      }
      readValueFromInstance(instance, key) {
          if (transformProps.has(key)) {
              const defaultType = getDefaultValueType(key);
              return defaultType ? defaultType.default || 0 : 0;
          }
          else {
              const computedStyle = getComputedStyle$1(instance);
              const value = (isCSSVariableName(key)
                  ? computedStyle.getPropertyValue(key)
                  : computedStyle[key]) || 0;
              return typeof value === "string" ? value.trim() : value;
          }
      }
      measureInstanceViewportBox(instance, { transformPagePoint }) {
          return measureViewportBox(instance, transformPagePoint);
      }
      build(renderState, latestValues, options, props) {
          buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
      }
      scrapeMotionValuesFromProps(props, prevProps) {
          return scrapeMotionValuesFromProps$1(props, prevProps);
      }
      handleChildMotionValue() {
          if (this.childSubscription) {
              this.childSubscription();
              delete this.childSubscription;
          }
          const { children } = this.props;
          if (isMotionValue(children)) {
              this.childSubscription = children.on("change", (latest) => {
                  if (this.current)
                      this.current.textContent = `${latest}`;
              });
          }
      }
      renderInstance(instance, renderState, styleProp, projection) {
          renderHTML(instance, renderState, styleProp, projection);
      }
  }

  class SVGVisualElement extends DOMVisualElement {
      constructor() {
          super(...arguments);
          this.type = "svg";
          this.isSVGTag = false;
      }
      getBaseTargetFromProps(props, key) {
          return props[key];
      }
      readValueFromInstance(instance, key) {
          if (transformProps.has(key)) {
              const defaultType = getDefaultValueType(key);
              return defaultType ? defaultType.default || 0 : 0;
          }
          key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
          return instance.getAttribute(key);
      }
      measureInstanceViewportBox() {
          return createBox();
      }
      scrapeMotionValuesFromProps(props, prevProps) {
          return scrapeMotionValuesFromProps(props, prevProps);
      }
      build(renderState, latestValues, options, props) {
          buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
      }
      renderInstance(instance, renderState, styleProp, projection) {
          renderSVG(instance, renderState, styleProp, projection);
      }
      mount(instance) {
          this.isSVGTag = isSVGTag(instance.tagName);
          super.mount(instance);
      }
  }

  const createDomVisualElement = (Component, options) => {
      return isSVGComponent(Component)
          ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
          : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
  };

  const layout = {
      layout: {
          ProjectionNode: HTMLProjectionNode,
          MeasureLayout,
      },
  };

  const preloadedFeatures = {
      ...animations,
      ...gestureAnimations,
      ...drag,
      ...layout,
  };
  /**
   * HTML & SVG components, optimised for use with gestures and animation. These can be used as
   * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
   *
   * @public
   */
  const motion = /*@__PURE__*/ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, preloadedFeatures, createDomVisualElement));

  function useIsMounted() {
      const isMounted = react.useRef(false);
      useIsomorphicLayoutEffect(() => {
          isMounted.current = true;
          return () => {
              isMounted.current = false;
          };
      }, []);
      return isMounted;
  }

  function useForceUpdate() {
      const isMounted = useIsMounted();
      const [forcedRenderCount, setForcedRenderCount] = react.useState(0);
      const forceRender = react.useCallback(() => {
          isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
      }, [forcedRenderCount]);
      /**
       * Defer this to the end of the next animation frame in case there are multiple
       * synchronous calls.
       */
      const deferredForceRender = react.useCallback(() => frame.postRender(forceRender), [forceRender]);
      return [deferredForceRender, forcedRenderCount];
  }

  /**
   * Measurement functionality has to be within a separate component
   * to leverage snapshot lifecycle.
   */
  class PopChildMeasure extends react.Component {
      getSnapshotBeforeUpdate(prevProps) {
          const element = this.props.childRef.current;
          if (element && prevProps.isPresent && !this.props.isPresent) {
              const size = this.props.sizeRef.current;
              size.height = element.offsetHeight || 0;
              size.width = element.offsetWidth || 0;
              size.top = element.offsetTop;
              size.left = element.offsetLeft;
          }
          return null;
      }
      /**
       * Required with getSnapshotBeforeUpdate to stop React complaining.
       */
      componentDidUpdate() { }
      render() {
          return this.props.children;
      }
  }
  function PopChild({ children, isPresent }) {
      const id = react.useId();
      const ref = react.useRef(null);
      const size = react.useRef({
          width: 0,
          height: 0,
          top: 0,
          left: 0,
      });
      /**
       * We create and inject a style block so we can apply this explicit
       * sizing in a non-destructive manner by just deleting the style block.
       *
       * We can't apply size via render as the measurement happens
       * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
       * styles directly on the DOM node, we might be overwriting
       * styles set via the style prop.
       */
      react.useInsertionEffect(() => {
          const { width, height, top, left } = size.current;
          if (isPresent || !ref.current || !width || !height)
              return;
          ref.current.dataset.motionPopId = id;
          const style = document.createElement("style");
          document.head.appendChild(style);
          if (style.sheet) {
              style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
          }
          return () => {
              document.head.removeChild(style);
          };
      }, [isPresent]);
      return (react.createElement(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size }, react.cloneElement(children, { ref })));
  }

  const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
      const presenceChildren = useConstant(newChildrenMap);
      const id = react.useId();
      const context = react.useMemo(() => ({
          id,
          initial,
          isPresent,
          custom,
          onExitComplete: (childId) => {
              presenceChildren.set(childId, true);
              for (const isComplete of presenceChildren.values()) {
                  if (!isComplete)
                      return; // can stop searching when any is incomplete
              }
              onExitComplete && onExitComplete();
          },
          register: (childId) => {
              presenceChildren.set(childId, false);
              return () => presenceChildren.delete(childId);
          },
      }), 
      /**
       * If the presence of a child affects the layout of the components around it,
       * we want to make a new context value to ensure they get re-rendered
       * so they can detect that layout change.
       */
      presenceAffectsLayout ? undefined : [isPresent]);
      react.useMemo(() => {
          presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
      }, [isPresent]);
      /**
       * If there's no `motion` components to fire exit animations, we want to remove this
       * component immediately.
       */
      react.useEffect(() => {
          !isPresent &&
              !presenceChildren.size &&
              onExitComplete &&
              onExitComplete();
      }, [isPresent]);
      if (mode === "popLayout") {
          children = react.createElement(PopChild, { isPresent: isPresent }, children);
      }
      return (react.createElement(PresenceContext.Provider, { value: context }, children));
  };
  function newChildrenMap() {
      return new Map();
  }

  function useUnmountEffect(callback) {
      return react.useEffect(() => () => callback(), []);
  }

  const getChildKey = (child) => child.key || "";
  function updateChildLookup(children, allChildren) {
      children.forEach((child) => {
          const key = getChildKey(child);
          allChildren.set(key, child);
      });
  }
  function onlyElements(children) {
      const filtered = [];
      // We use forEach here instead of map as map mutates the component key by preprending `.$`
      react.Children.forEach(children, (child) => {
          if (react.isValidElement(child))
              filtered.push(child);
      });
      return filtered;
  }
  /**
   * `AnimatePresence` enables the animation of components that have been removed from the tree.
   *
   * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
   *
   * Any `motion` components that have an `exit` property defined will animate out when removed from
   * the tree.
   *
   * ```jsx
   * import { motion, AnimatePresence } from 'framer-motion'
   *
   * export const Items = ({ items }) => (
   *   <AnimatePresence>
   *     {items.map(item => (
   *       <motion.div
   *         key={item.id}
   *         initial={{ opacity: 0 }}
   *         animate={{ opacity: 1 }}
   *         exit={{ opacity: 0 }}
   *       />
   *     ))}
   *   </AnimatePresence>
   * )
   * ```
   *
   * You can sequence exit animations throughout a tree using variants.
   *
   * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
   * once all `motion` components have finished animating out. Likewise, any components using
   * `usePresence` all need to call `safeToRemove`.
   *
   * @public
   */
  const AnimatePresence = ({ children, custom, initial = true, onExitComplete, exitBeforeEnter, presenceAffectsLayout = true, mode = "sync", }) => {
      invariant(!exitBeforeEnter);
      // We want to force a re-render once all exiting animations have finished. We
      // either use a local forceRender function, or one from a parent context if it exists.
      const forceRender = react.useContext(LayoutGroupContext).forceRender || useForceUpdate()[0];
      const isMounted = useIsMounted();
      // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
      const filteredChildren = onlyElements(children);
      let childrenToRender = filteredChildren;
      const exitingChildren = react.useRef(new Map()).current;
      // Keep a living record of the children we're actually rendering so we
      // can diff to figure out which are entering and exiting
      const presentChildren = react.useRef(childrenToRender);
      // A lookup table to quickly reference components by key
      const allChildren = react.useRef(new Map()).current;
      // If this is the initial component render, just deal with logic surrounding whether
      // we play onMount animations or not.
      const isInitialRender = react.useRef(true);
      useIsomorphicLayoutEffect(() => {
          isInitialRender.current = false;
          updateChildLookup(filteredChildren, allChildren);
          presentChildren.current = childrenToRender;
      });
      useUnmountEffect(() => {
          isInitialRender.current = true;
          allChildren.clear();
          exitingChildren.clear();
      });
      if (isInitialRender.current) {
          return (react.createElement(react.Fragment, null, childrenToRender.map((child) => (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child)))));
      }
      // If this is a subsequent render, deal with entering and exiting children
      childrenToRender = [...childrenToRender];
      // Diff the keys of the currently-present and target children to update our
      // exiting list.
      const presentKeys = presentChildren.current.map(getChildKey);
      const targetKeys = filteredChildren.map(getChildKey);
      // Diff the present children with our target children and mark those that are exiting
      const numPresent = presentKeys.length;
      for (let i = 0; i < numPresent; i++) {
          const key = presentKeys[i];
          if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) {
              exitingChildren.set(key, undefined);
          }
      }
      // If we currently have exiting children, and we're deferring rendering incoming children
      // until after all current children have exiting, empty the childrenToRender array
      if (mode === "wait" && exitingChildren.size) {
          childrenToRender = [];
      }
      // Loop through all currently exiting components and clone them to overwrite `animate`
      // with any `exit` prop they might have defined.
      exitingChildren.forEach((component, key) => {
          // If this component is actually entering again, early return
          if (targetKeys.indexOf(key) !== -1)
              return;
          const child = allChildren.get(key);
          if (!child)
              return;
          const insertionIndex = presentKeys.indexOf(key);
          let exitingComponent = component;
          if (!exitingComponent) {
              const onExit = () => {
                  // clean up the exiting children map
                  exitingChildren.delete(key);
                  // compute the keys of children that were rendered once but are no longer present
                  // this could happen in case of too many fast consequent renderings
                  // @link https://github.com/framer/motion/issues/2023
                  const leftOverKeys = Array.from(allChildren.keys()).filter((childKey) => !targetKeys.includes(childKey));
                  // clean up the all children map
                  leftOverKeys.forEach((leftOverKey) => allChildren.delete(leftOverKey));
                  // make sure to render only the children that are actually visible
                  presentChildren.current = filteredChildren.filter((presentChild) => {
                      const presentChildKey = getChildKey(presentChild);
                      return (
                      // filter out the node exiting
                      presentChildKey === key ||
                          // filter out the leftover children
                          leftOverKeys.includes(presentChildKey));
                  });
                  // Defer re-rendering until all exiting children have indeed left
                  if (!exitingChildren.size) {
                      if (isMounted.current === false)
                          return;
                      forceRender();
                      onExitComplete && onExitComplete();
                  }
              };
              exitingComponent = (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
              exitingChildren.set(key, exitingComponent);
          }
          childrenToRender.splice(insertionIndex, 0, exitingComponent);
      });
      // Add `MotionContext` even to children that don't need it to ensure we're rendering
      // the same tree between renders
      childrenToRender = childrenToRender.map((child) => {
          const key = child.key;
          return exitingChildren.has(key) ? (child) : (react.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
      });
      return (react.createElement(react.Fragment, null, exitingChildren.size
          ? childrenToRender
          : childrenToRender.map((child) => react.cloneElement(child))));
  };

  var toastMotionVariants = {
    initial: (props) => {
      const { position } = props;
      const dir = ["top", "bottom"].includes(position) ? "y" : "x";
      let factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
      if (position === "bottom")
        factor = 1;
      return {
        opacity: 0,
        [dir]: factor * 24
      };
    },
    animate: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: [0.4, 0, 0.2, 1]
      }
    },
    exit: {
      opacity: 0,
      scale: 0.85,
      transition: {
        duration: 0.2,
        ease: [0.4, 0, 1, 1]
      }
    }
  };
  var ToastComponent = react.memo((props) => {
    const {
      id,
      message,
      onCloseComplete,
      onRequestRemove,
      requestClose = false,
      position = "bottom",
      duration = 5e3,
      containerStyle,
      motionVariants = toastMotionVariants,
      toastSpacing = "0.5rem"
    } = props;
    const [delay, setDelay] = react.useState(duration);
    const isPresent = useIsPresent();
    useUpdateEffect(() => {
      if (!isPresent) {
        onCloseComplete == null ? void 0 : onCloseComplete();
      }
    }, [isPresent]);
    useUpdateEffect(() => {
      setDelay(duration);
    }, [duration]);
    const onMouseEnter = () => setDelay(null);
    const onMouseLeave = () => setDelay(duration);
    const close = () => {
      if (isPresent)
        onRequestRemove();
    };
    react.useEffect(() => {
      if (isPresent && requestClose) {
        onRequestRemove();
      }
    }, [isPresent, requestClose, onRequestRemove]);
    useTimeout(close, delay);
    const containerStyles = react.useMemo(
      () => ({
        pointerEvents: "auto",
        maxWidth: 560,
        minWidth: 300,
        margin: toastSpacing,
        ...containerStyle
      }),
      [containerStyle, toastSpacing]
    );
    const toastStyle = react.useMemo(() => getToastStyle(position), [position]);
    return /* @__PURE__ */ jsxRuntime.jsx(
      motion.div,
      {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: { position },
        style: toastStyle,
        children: /* @__PURE__ */ jsxRuntime.jsx(
          chakra.div,
          {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: runIfFn$2(message, { id, onClose: close })
          }
        )
      }
    );
  });
  ToastComponent.displayName = "ToastComponent";

  function CloseIcon(props) {
    return /* @__PURE__ */ jsxRuntime.jsx(Icon, { focusable: "false", "aria-hidden": true, ...props, children: /* @__PURE__ */ jsxRuntime.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
      }
    ) });
  }
  var CloseButton = forwardRef(
    function CloseButton2(props, ref) {
      const styles = useStyleConfig("CloseButton", props);
      const { children, isDisabled, __css, ...rest } = omitThemingProps(props);
      const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      };
      return /* @__PURE__ */ jsxRuntime.jsx(
        chakra.button,
        {
          type: "button",
          "aria-label": "Close",
          ref,
          disabled: isDisabled,
          __css: {
            ...baseStyle,
            ...styles,
            ...__css
          },
          ...rest,
          children: children || /* @__PURE__ */ jsxRuntime.jsx(CloseIcon, { width: "1em", height: "1em" })
        }
      );
    }
  );
  CloseButton.displayName = "CloseButton";

  // src/toast.store.ts
  var initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
  };
  var toastStore = createStore$1(initialState);
  function createStore$1(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn) => {
      state = setStateFn(state);
      listeners.forEach((l) => l());
    };
    return {
      getState: () => state,
      subscribe: (listener) => {
        listeners.add(listener);
        return () => {
          setState(() => initialState2);
          listeners.delete(listener);
        };
      },
      /**
       * Delete a toast record at its position
       */
      removeToast: (id, position) => {
        setState((prevState) => ({
          ...prevState,
          // id may be string or number
          // eslint-disable-next-line eqeqeq
          [position]: prevState[position].filter((toast) => toast.id != id)
        }));
      },
      notify: (message, options) => {
        const toast = createToast(message, options);
        const { position, id } = toast;
        setState((prevToasts) => {
          var _a, _b;
          const isTop = position.includes("top");
          const toasts = isTop ? [toast, ...(_a = prevToasts[position]) != null ? _a : []] : [...(_b = prevToasts[position]) != null ? _b : [], toast];
          return {
            ...prevToasts,
            [position]: toasts
          };
        });
        return id;
      },
      update: (id, options) => {
        if (!id)
          return;
        setState((prevState) => {
          const nextState = { ...prevState };
          const { position, index } = findToast(nextState, id);
          if (position && index !== -1) {
            nextState[position][index] = {
              ...nextState[position][index],
              ...options,
              message: createRenderToast(options)
            };
          }
          return nextState;
        });
      },
      closeAll: ({ positions } = {}) => {
        setState((prev) => {
          const allPositions = [
            "bottom",
            "bottom-right",
            "bottom-left",
            "top",
            "top-left",
            "top-right"
          ];
          const positionsToClose = positions != null ? positions : allPositions;
          return positionsToClose.reduce(
            (acc, position) => {
              acc[position] = prev[position].map((toast) => ({
                ...toast,
                requestClose: true
              }));
              return acc;
            },
            { ...prev }
          );
        });
      },
      close: (id) => {
        setState((prevState) => {
          const position = getToastPosition(prevState, id);
          if (!position)
            return prevState;
          return {
            ...prevState,
            [position]: prevState[position].map((toast) => {
              if (toast.id == id) {
                return {
                  ...toast,
                  requestClose: true
                };
              }
              return toast;
            })
          };
        });
      },
      isActive: (id) => Boolean(findToast(toastStore.getState(), id).position)
    };
  }
  var counter = 0;
  function createToast(message, options = {}) {
    var _a, _b;
    counter += 1;
    const id = (_a = options.id) != null ? _a : counter;
    const position = (_b = options.position) != null ? _b : "bottom";
    return {
      id,
      message,
      position,
      duration: options.duration,
      onCloseComplete: options.onCloseComplete,
      onRequestRemove: () => toastStore.removeToast(String(id), position),
      status: options.status,
      requestClose: false,
      containerStyle: options.containerStyle
    };
  }
  var Toast = (props) => {
    const {
      status,
      variant = "solid",
      id,
      title,
      isClosable,
      onClose,
      description,
      colorScheme,
      icon
    } = props;
    const ids = id ? {
      root: `toast-${id}`,
      title: `toast-${id}-title`,
      description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ jsxRuntime.jsxs(
      Alert$1,
      {
        addRole: false,
        status,
        variant,
        id: ids == null ? void 0 : ids.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme,
        children: [
          /* @__PURE__ */ jsxRuntime.jsx(AlertIcon, { children: icon }),
          /* @__PURE__ */ jsxRuntime.jsxs(chakra.div, { flex: "1", maxWidth: "100%", children: [
            title && /* @__PURE__ */ jsxRuntime.jsx(AlertTitle, { id: ids == null ? void 0 : ids.title, children: title }),
            description && /* @__PURE__ */ jsxRuntime.jsx(AlertDescription, { id: ids == null ? void 0 : ids.description, display: "block", children: description })
          ] }),
          isClosable && /* @__PURE__ */ jsxRuntime.jsx(
            CloseButton,
            {
              size: "sm",
              onClick: onClose,
              position: "absolute",
              insetEnd: 1,
              top: 1
            }
          )
        ]
      }
    );
  };
  function createRenderToast(options = {}) {
    const { render, toastComponent: ToastComponent = Toast } = options;
    const renderToast = (props) => {
      if (typeof render === "function") {
        return render({ ...props, ...options });
      }
      return /* @__PURE__ */ jsxRuntime.jsx(ToastComponent, { ...props, ...options });
    };
    return renderToast;
  }

  var [ToastOptionProvider, useToastOptionContext] = createContext$1({
    name: `ToastOptionsContext`,
    strict: false
  });
  var ToastProvider = (props) => {
    const state = react.useSyncExternalStore(
      toastStore.subscribe,
      toastStore.getState,
      toastStore.getState
    );
    const {
      motionVariants,
      component: Component = ToastComponent,
      portalProps
    } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position) => {
      const toasts = state[position];
      return /* @__PURE__ */ jsxRuntime.jsx(
        "div",
        {
          role: "region",
          "aria-live": "polite",
          "aria-label": `Notifications-${position}`,
          id: `chakra-toast-manager-${position}`,
          style: getToastListStyle(position),
          children: /* @__PURE__ */ jsxRuntime.jsx(AnimatePresence, { initial: false, children: toasts.map((toast) => /* @__PURE__ */ jsxRuntime.jsx(
            Component,
            {
              motionVariants,
              ...toast
            },
            toast.id
          )) })
        },
        position
      );
    });
    return /* @__PURE__ */ jsxRuntime.jsx(Portal, { ...portalProps, children: toastList });
  };

  var createChakraProvider = (providerTheme) => {
    return function ChakraProvider2({
      children,
      theme = providerTheme,
      toastOptions,
      ...restProps
    }) {
      return /* @__PURE__ */ jsxRuntime.jsxs(ChakraProvider$1, { theme, ...restProps, children: [
        /* @__PURE__ */ jsxRuntime.jsx(ToastOptionProvider, { value: toastOptions == null ? void 0 : toastOptions.defaultOptions, children }),
        /* @__PURE__ */ jsxRuntime.jsx(ToastProvider, { ...toastOptions })
      ] });
    };
  };
  var ChakraProvider = createChakraProvider(theme$1);

  var Text = forwardRef(function Text2(props, ref) {
    const styles = useStyleConfig("Text", props);
    const { className, align, decoration, casing, ...rest } = omitThemingProps(props);
    const aliasedProps = compact({
      textAlign: props.align,
      textDecoration: props.decoration,
      textTransform: props.casing
    });
    return /* @__PURE__ */ jsxRuntime.jsx(
      chakra.p,
      {
        ref,
        className: cx("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
      }
    );
  });
  Text.displayName = "Text";

  var Box = chakra("div");
  Box.displayName = "Box";
  var Square = forwardRef(function Square2(props, ref) {
    const { size, centerContent = true, ...rest } = props;
    const styles = centerContent ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
    return /* @__PURE__ */ jsxRuntime.jsx(
      Box,
      {
        ref,
        boxSize: size,
        __css: {
          ...styles,
          flexShrink: 0,
          flexGrow: 0
        },
        ...rest
      }
    );
  });
  Square.displayName = "Square";
  var Circle = forwardRef(function Circle2(props, ref) {
    const { size, ...rest } = props;
    return /* @__PURE__ */ jsxRuntime.jsx(Square, { size, ref, borderRadius: "9999px", ...rest });
  });
  Circle.displayName = "Circle";

  const createStoreImpl = (createState) => {
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace) => {
      const nextState = typeof partial === "function" ? partial(state) : partial;
      if (!Object.is(nextState, state)) {
        const previousState = state;
        state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
        listeners.forEach((listener) => listener(state, previousState));
      }
    };
    const getState = () => state;
    const getInitialState = () => initialState;
    const subscribe = (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    };
    const destroy = () => {
      if ((undefined ? undefined.MODE : void 0) !== "production") {
        console.warn(
          "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
        );
      }
      listeners.clear();
    };
    const api = { setState, getState, getInitialState, subscribe, destroy };
    const initialState = state = createState(setState, getState, api);
    return api;
  };
  const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;

  /**
   * @license React
   * use-sync-external-store-shim.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=react.useState,m=react.useEffect,n=react.useLayoutEffect,p$1=react.useDebugValue;function q$1(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r$1(c)&&g({inst:c});},[a,d,b]);m(function(){r$1(c)&&g({inst:c});return a(function(){r$1(c)&&g({inst:c});})},[a]);p$1(d);return d}
  function r$1(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t$1(a,b){return b()}var u$1="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t$1:q$1;var useSyncExternalStore=void 0!==react.useSyncExternalStore?react.useSyncExternalStore:u$1;

  var useSyncExternalStoreShim_production_min = {
  	useSyncExternalStore: useSyncExternalStore
  };

  var shim = createCommonjsModule(function (module) {

  {
    module.exports = useSyncExternalStoreShim_production_min;
  }
  });

  /**
   * @license React
   * use-sync-external-store-shim/with-selector.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=shim.useSyncExternalStore,t=react.useRef,u=react.useEffect,v=react.useMemo,w=react.useDebugValue;
  var useSyncExternalStoreWithSelector$1=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f;}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return [function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
  u(function(){f.hasValue=!0;f.value=d;},[d]);w(d);return d};

  var withSelector_production_min = {
  	useSyncExternalStoreWithSelector: useSyncExternalStoreWithSelector$1
  };

  var withSelector = createCommonjsModule(function (module) {

  {
    module.exports = withSelector_production_min;
  }
  });

  const { useDebugValue } = react;
  const { useSyncExternalStoreWithSelector } = withSelector;
  let didWarnAboutEqualityFn = false;
  const identity = (arg) => arg;
  function useStore(api, selector = identity, equalityFn) {
    if ((undefined ? undefined.MODE : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
      console.warn(
        "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
      );
      didWarnAboutEqualityFn = true;
    }
    const slice = useSyncExternalStoreWithSelector(
      api.subscribe,
      api.getState,
      api.getServerState || api.getInitialState,
      selector,
      equalityFn
    );
    useDebugValue(slice);
    return slice;
  }
  const createImpl = (createState) => {
    if ((undefined ? undefined.MODE : void 0) !== "production" && typeof createState !== "function") {
      console.warn(
        "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
      );
    }
    const api = typeof createState === "function" ? createStore(createState) : createState;
    const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
  };
  const create = (createState) => createState ? createImpl(createState) : createImpl;

  function createJSONStorage(getStorage, options) {
    let storage;
    try {
      storage = getStorage();
    } catch (e) {
      return;
    }
    const persistStorage = {
      getItem: (name) => {
        var _a;
        const parse = (str2) => {
          if (str2 === null) {
            return null;
          }
          return JSON.parse(str2, options == null ? void 0 : options.reviver);
        };
        const str = (_a = storage.getItem(name)) != null ? _a : null;
        if (str instanceof Promise) {
          return str.then(parse);
        }
        return parse(str);
      },
      setItem: (name, newValue) => storage.setItem(
        name,
        JSON.stringify(newValue, options == null ? void 0 : options.replacer)
      ),
      removeItem: (name) => storage.removeItem(name)
    };
    return persistStorage;
  }
  const toThenable = (fn) => (input) => {
    try {
      const result = fn(input);
      if (result instanceof Promise) {
        return result;
      }
      return {
        then(onFulfilled) {
          return toThenable(onFulfilled)(result);
        },
        catch(_onRejected) {
          return this;
        }
      };
    } catch (e) {
      return {
        then(_onFulfilled) {
          return this;
        },
        catch(onRejected) {
          return toThenable(onRejected)(e);
        }
      };
    }
  };
  const oldImpl = (config, baseOptions) => (set, get, api) => {
    let options = {
      getStorage: () => localStorage,
      serialize: JSON.stringify,
      deserialize: JSON.parse,
      partialize: (state) => state,
      version: 0,
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...persistedState
      }),
      ...baseOptions
    };
    let hasHydrated = false;
    const hydrationListeners = /* @__PURE__ */ new Set();
    const finishHydrationListeners = /* @__PURE__ */ new Set();
    let storage;
    try {
      storage = options.getStorage();
    } catch (e) {
    }
    if (!storage) {
      return config(
        (...args) => {
          console.warn(
            `[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`
          );
          set(...args);
        },
        get,
        api
      );
    }
    const thenableSerialize = toThenable(options.serialize);
    const setItem = () => {
      const state = options.partialize({ ...get() });
      let errorInSync;
      const thenable = thenableSerialize({ state, version: options.version }).then(
        (serializedValue) => storage.setItem(options.name, serializedValue)
      ).catch((e) => {
        errorInSync = e;
      });
      if (errorInSync) {
        throw errorInSync;
      }
      return thenable;
    };
    const savedSetState = api.setState;
    api.setState = (state, replace) => {
      savedSetState(state, replace);
      void setItem();
    };
    const configResult = config(
      (...args) => {
        set(...args);
        void setItem();
      },
      get,
      api
    );
    let stateFromStorage;
    const hydrate = () => {
      var _a;
      if (!storage)
        return;
      hasHydrated = false;
      hydrationListeners.forEach((cb) => cb(get()));
      const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
      return toThenable(storage.getItem.bind(storage))(options.name).then((storageValue) => {
        if (storageValue) {
          return options.deserialize(storageValue);
        }
      }).then((deserializedStorageValue) => {
        if (deserializedStorageValue) {
          if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
            if (options.migrate) {
              return options.migrate(
                deserializedStorageValue.state,
                deserializedStorageValue.version
              );
            }
            console.error(
              `State loaded from storage couldn't be migrated since no migrate function was provided`
            );
          } else {
            return deserializedStorageValue.state;
          }
        }
      }).then((migratedState) => {
        var _a2;
        stateFromStorage = options.merge(
          migratedState,
          (_a2 = get()) != null ? _a2 : configResult
        );
        set(stateFromStorage, true);
        return setItem();
      }).then(() => {
        postRehydrationCallback == null ? void 0 : postRehydrationCallback(stateFromStorage, void 0);
        hasHydrated = true;
        finishHydrationListeners.forEach((cb) => cb(stateFromStorage));
      }).catch((e) => {
        postRehydrationCallback == null ? void 0 : postRehydrationCallback(void 0, e);
      });
    };
    api.persist = {
      setOptions: (newOptions) => {
        options = {
          ...options,
          ...newOptions
        };
        if (newOptions.getStorage) {
          storage = newOptions.getStorage();
        }
      },
      clearStorage: () => {
        storage == null ? void 0 : storage.removeItem(options.name);
      },
      getOptions: () => options,
      rehydrate: () => hydrate(),
      hasHydrated: () => hasHydrated,
      onHydrate: (cb) => {
        hydrationListeners.add(cb);
        return () => {
          hydrationListeners.delete(cb);
        };
      },
      onFinishHydration: (cb) => {
        finishHydrationListeners.add(cb);
        return () => {
          finishHydrationListeners.delete(cb);
        };
      }
    };
    hydrate();
    return stateFromStorage || configResult;
  };
  const newImpl = (config, baseOptions) => (set, get, api) => {
    let options = {
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => state,
      version: 0,
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...persistedState
      }),
      ...baseOptions
    };
    let hasHydrated = false;
    const hydrationListeners = /* @__PURE__ */ new Set();
    const finishHydrationListeners = /* @__PURE__ */ new Set();
    let storage = options.storage;
    if (!storage) {
      return config(
        (...args) => {
          console.warn(
            `[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`
          );
          set(...args);
        },
        get,
        api
      );
    }
    const setItem = () => {
      const state = options.partialize({ ...get() });
      return storage.setItem(options.name, {
        state,
        version: options.version
      });
    };
    const savedSetState = api.setState;
    api.setState = (state, replace) => {
      savedSetState(state, replace);
      void setItem();
    };
    const configResult = config(
      (...args) => {
        set(...args);
        void setItem();
      },
      get,
      api
    );
    api.getInitialState = () => configResult;
    let stateFromStorage;
    const hydrate = () => {
      var _a, _b;
      if (!storage)
        return;
      hasHydrated = false;
      hydrationListeners.forEach((cb) => {
        var _a2;
        return cb((_a2 = get()) != null ? _a2 : configResult);
      });
      const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
      return toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue) => {
        if (deserializedStorageValue) {
          if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
            if (options.migrate) {
              return options.migrate(
                deserializedStorageValue.state,
                deserializedStorageValue.version
              );
            }
            console.error(
              `State loaded from storage couldn't be migrated since no migrate function was provided`
            );
          } else {
            return deserializedStorageValue.state;
          }
        }
      }).then((migratedState) => {
        var _a2;
        stateFromStorage = options.merge(
          migratedState,
          (_a2 = get()) != null ? _a2 : configResult
        );
        set(stateFromStorage, true);
        return setItem();
      }).then(() => {
        postRehydrationCallback == null ? void 0 : postRehydrationCallback(stateFromStorage, void 0);
        stateFromStorage = get();
        hasHydrated = true;
        finishHydrationListeners.forEach((cb) => cb(stateFromStorage));
      }).catch((e) => {
        postRehydrationCallback == null ? void 0 : postRehydrationCallback(void 0, e);
      });
    };
    api.persist = {
      setOptions: (newOptions) => {
        options = {
          ...options,
          ...newOptions
        };
        if (newOptions.storage) {
          storage = newOptions.storage;
        }
      },
      clearStorage: () => {
        storage == null ? void 0 : storage.removeItem(options.name);
      },
      getOptions: () => options,
      rehydrate: () => hydrate(),
      hasHydrated: () => hasHydrated,
      onHydrate: (cb) => {
        hydrationListeners.add(cb);
        return () => {
          hydrationListeners.delete(cb);
        };
      },
      onFinishHydration: (cb) => {
        finishHydrationListeners.add(cb);
        return () => {
          finishHydrationListeners.delete(cb);
        };
      }
    };
    if (!options.skipHydration) {
      hydrate();
    }
    return stateFromStorage || configResult;
  };
  const persistImpl = (config, baseOptions) => {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
      if ((undefined ? undefined.MODE : void 0) !== "production") {
        console.warn(
          "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
        );
      }
      return oldImpl(config, baseOptions);
    }
    return newImpl(config, baseOptions);
  };
  const persist = persistImpl;

  var STORAGE_KEY = "csv-importer-theme";
  var useThemeStore = create()(persist(function (set) { return ({
      theme: typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : "light",
      setTheme: function (newTheme) {
          return set(function (state) {
              var theme = newTheme || (state.theme === "light" ? "dark" : "light");
              return { theme: theme };
          });
      },
  }); }, {
      name: STORAGE_KEY,
  }));

  function UploaderWrapper(_a) {
      var _this = this;
      var onSuccess = _a.onSuccess, setDataError = _a.setDataError; __rest$1(_a, ["onSuccess", "setDataError"]);
      var _b = react.useState(false), loading = _b[0], setLoading = _b[1];
      var theme = useThemeStore(function (state) { return state.theme; });
      var t = useTranslation().t;
      var _c = useDropzone({
          noClick: true,
          noKeyboard: true,
          maxFiles: 1,
          // maxSize: 1 * Math.pow(1024, 3),
          accept: {
              "application/vnd.ms-excel": [".xls"],
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              "text/csv": [".csv"],
          },
          onDropRejected: function (fileRejections) {
              setLoading(false);
              // const errorMessage = fileRejections.map((fileRejection) => fileRejection.errors[0].message).join(", ");
              var errorMessage = fileRejections[0].errors[0].message;
              setDataError(errorMessage);
          },
          onDropAccepted: function (_a) {
              var file = _a[0];
              return __awaiter(_this, void 0, void 0, function () {
                  return __generator(this, function (_b) {
                      setLoading(true);
                      onSuccess(file);
                      setLoading(false);
                      return [2 /*return*/];
                  });
              });
          },
      }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive, open = _c.open;
      return (jsxRuntime.jsx(Box, __assign$1({ padding: "15px", border: "1px solid var(--color-border)", borderRadius: "var(--border-radius-2)" }, { children: jsxRuntime.jsxs(Box, __assign$1({}, getRootProps(), { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", flex: 1, border: "2px dashed var(--color-border)", borderRadius: "var(--border-radius-2)" }, { children: [jsxRuntime.jsx("input", __assign$1({}, getInputProps())), isDragActive ? (jsxRuntime.jsx(Text, { children: t("Drop your file here") })) : loading ? (jsxRuntime.jsx(Text, { children: t("Loading...") })) : (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(Text, { children: t("Drop your file here") }), jsxRuntime.jsx(Text, { children: t("or") }), jsxRuntime.jsx(Button$1, __assign$1({ leftIcon: jsxRuntime.jsx(PiFile, {}), onClick: open, mt: "6px", colorScheme: "secondary", variant: theme === "light" ? "outline" : "solid", _hover: theme === "light"
                                  ? {
                                      background: "var(--color-border)",
                                      color: "var(--color-text)",
                                  }
                                  : undefined }, { children: t("Browse files") }))] }))] })) })));
  }

  function useTemplateTable(fields) {
      if (fields === void 0) { fields = []; }
      if (!fields) {
          return [];
      }
      var t = useTranslation().t;
      var expectedColumnKey = t("Expected column");
      var requiredKey = t("Required");
      var result = react.useMemo(function () {
          return fields.map(function (item) {
              var _a;
              return (_a = {},
                  _a[expectedColumnKey] = (item === null || item === void 0 ? void 0 : item.description)
                      ? {
                          raw: item.name,
                          content: (jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Tooltip, __assign$1({ title: item === null || item === void 0 ? void 0 : item.description }, { children: item.name })) })),
                      }
                      : item.name,
                  _a[requiredKey] = { raw: (item === null || item === void 0 ? void 0 : item.required) ? 1 : 0, content: (item === null || item === void 0 ? void 0 : item.required) ? jsxRuntime.jsx(PiCheckBold, {}) : jsxRuntime.jsx(jsxRuntime.Fragment, {}) },
                  _a);
          });
      }, [fields]);
      return result;
  }

  var css_248z$2 = ".Uploader-module_content__eUqiV {\n  display: flex;\n  gap: var(--m);\n  height: 100%; }\n  .Uploader-module_content__eUqiV > *:first-child {\n    flex: 1 1 500px;\n    overflow: hidden; }\n  .Uploader-module_content__eUqiV > *:last-child {\n    flex-basis: 38%; }\n\n.Uploader-module_box__15kh2 {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-s); }\n\n.Uploader-module_tableContainer__2lhD- {\n  overflow: hidden;\n  overflow-y: scroll;\n  height: 100%;\n  border: 1px solid var(--color-border);\n  border-radius: var(--border-radius-2); }\n  .Uploader-module_tableContainer__2lhD- > div {\n    outline: none; }\n  .Uploader-module_tableContainer__2lhD- .Uploader-module_tbody__15pwJ {\n    overflow: auto; }\n";
  var style = {"content":"Uploader-module_content__eUqiV","box":"Uploader-module_box__15kh2","tableContainer":"Uploader-module_tableContainer__2lhD-","tbody":"Uploader-module_tbody__15pwJ"};
  styleInject(css_248z$2);

  function Uploader(_a) {
      var template = _a.template, skipHeaderRowSelection = _a.skipHeaderRowSelection, onSuccess = _a.onSuccess, showDownloadTemplateButton = _a.showDownloadTemplateButton, setDataError = _a.setDataError;
      var fields = useTemplateTable(template.columns);
      var theme = useThemeStore(function (state) { return state.theme; });
      var uploaderWrapper = jsxRuntime.jsx(UploaderWrapper, { onSuccess: onSuccess, skipHeaderRowSelection: skipHeaderRowSelection, setDataError: setDataError });
      showDownloadTemplateButton = showDownloadTemplateButton !== null && showDownloadTemplateButton !== void 0 ? showDownloadTemplateButton : true;
      var t = useTranslation().t;
      function downloadTemplate() {
          const link = document.createElement("a");
          link.href = "/static/data/import_template.csv";
          link.download = "import_template.csv";
          link.click();
      }
      var downloadTemplateButton = showDownloadTemplateButton ? (jsxRuntime.jsx(Button$1, __assign$1({ width: "100%", leftIcon: jsxRuntime.jsx(PiDownloadSimple, {}), onClick: downloadTemplate, colorScheme: "secondary", variant: theme === "light" ? "outline" : "solid", _hover: theme === "light"
              ? {
                  background: "var(--color-border)",
                  color: "var(--color-text)",
              }
              : undefined }, { children: t("Download template") }))) : null;
      return (jsxRuntime.jsxs("div", __assign$1({ className: style.content }, { children: [uploaderWrapper, jsxRuntime.jsxs("div", __assign$1({ className: style.box }, { children: [jsxRuntime.jsx("div", __assign$1({ className: style.tableContainer }, { children: jsxRuntime.jsx(Table, { fixHeader: true, data: fields, background: "transparent", columnWidths: ["65%", "35%"], columnAlignments: ["", "center"] }) })), downloadTemplateButton] }))] })));
  }

  function Main(props) {
      var _this = this;
      var _a = props.isModal, isModal = _a === void 0 ? true : _a, _b = props.modalOnCloseTriggered, modalOnCloseTriggered = _b === void 0 ? function () { return null; } : _b, template = props.template, onComplete = props.onComplete, customStyles = props.customStyles, showDownloadTemplateButton = props.showDownloadTemplateButton, skipHeaderRowSelection = props.skipHeaderRowSelection;
      var skipHeader = skipHeaderRowSelection !== null && skipHeaderRowSelection !== void 0 ? skipHeaderRowSelection : false;
      var t = useTranslation().t;
      // Apply custom styles
      useCustomStyles(parseObjectOrStringJSON("customStyles", customStyles));
      // Stepper handler
      var _c = useStepNavigation(StepEnum.Upload, skipHeader), currentStep = _c.currentStep, setStep = _c.setStep, goNext = _c.goNext, goBack = _c.goBack, stepper = _c.stepper;
      // Error handling
      var _d = react.useState(null), initializationError = _d[0], setInitializationError = _d[1];
      var _e = react.useState(null), dataError = _e[0], setDataError = _e[1];
      // File data
      var emptyData = {
          fileName: "",
          rows: [],
          sheetList: [],
          errors: [],
      };
      var _f = react.useState(emptyData), data = _f[0], setData = _f[1];
      // Header row selection state
      var _g = react.useState(0), selectedHeaderRow = _g[0], setSelectedHeaderRow = _g[1];
      // Map of upload column index -> TemplateColumnMapping
      var _h = react.useState({}), columnMapping = _h[0], setColumnMapping = _h[1];
      // Used in the final step to show a loading indicator while the data is submitting
      var _j = react.useState(false), isSubmitting = _j[0], setIsSubmitting = _j[1];
      var _k = react.useState({
          columns: [],
      }), parsedTemplate = _k[0], setParsedTemplate = _k[1];
      react.useEffect(function () {
          var _a = convertRawTemplate(template), parsedTemplate = _a[0], parsedTemplateError = _a[1];
          if (parsedTemplateError) {
              setInitializationError(parsedTemplateError);
          }
          else if (parsedTemplate) {
              setParsedTemplate(parsedTemplate);
          }
      }, [template]);
      react.useEffect(function () {
          // TODO (client-sdk): Have the importer continue where left off if closed
          // Temporary solution to reload state if closed and opened again
          if (data.rows.length === 0 && currentStep !== StepEnum.Upload) {
              reload();
          }
      }, [data]);
      // Actions
      var reload = function () {
          setData(emptyData);
          setSelectedHeaderRow(0);
          setColumnMapping({});
          setDataError(null);
          setStep(StepEnum.Upload);
      };
      var requestClose = function () {
          if (!isModal) {
              return;
          }
          modalOnCloseTriggered && modalOnCloseTriggered();
          if (currentStep === StepEnum.Complete) {
              reload();
          }
      };
      if (initializationError) {
          return (jsxRuntime.jsx("div", __assign$1({ className: style$8.wrapper }, { children: jsxRuntime.jsx(Errors, { error: initializationError, centered: true }) })));
      }
      var renderContent = function () {
          switch (currentStep) {
              case StepEnum.Upload:
                  return (jsxRuntime.jsx(Uploader, { template: parsedTemplate, skipHeaderRowSelection: skipHeader || false, showDownloadTemplateButton: showDownloadTemplateButton, setDataError: setDataError, onSuccess: function (file) { return __awaiter(_this, void 0, void 0, function () {
                          var fileType, reader, isNotBlankRow;
                          var _this = this;
                          return __generator(this, function (_a) {
                              setDataError(null);
                              fileType = file.name.slice(file.name.lastIndexOf(".") + 1);
                              if (!["csv", "xls", "xlsx"].includes(fileType)) {
                                  setDataError(t("Only CSV, XLS, and XLSX files can be uploaded"));
                                  return [2 /*return*/];
                              }
                              reader = new FileReader();
                              isNotBlankRow = function (row) { return row.some(function (cell) { return cell.toString().trim() !== ""; }); };
                              reader.onload = function (e) { return __awaiter(_this, void 0, void 0, function () {
                                  var bstr, workbook, sheetList, data_1, rows;
                                  var _a;
                                  return __generator(this, function (_b) {
                                      bstr = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result;
                                      if (!bstr) {
                                          return [2 /*return*/];
                                      }
                                      switch (fileType) {
                                          case "csv":
                                              papaparse_min.parse(bstr.toString(), {
                                                  complete: function (results) {
                                                      var csvData = results.data;
                                                      var rows = csvData.filter(isNotBlankRow).map(function (row, index) { return ({ index: index, values: row }); });
                                                      setData({
                                                          fileName: file.name,
                                                          rows: rows,
                                                          sheetList: [],
                                                          errors: results.errors.map(function (error) { return error.message; }),
                                                      });
                                                      goNext();
                                                  },
                                              });
                                              break;
                                          case "xlsx":
                                          case "xls":
                                              workbook = readSync(bstr, { type: "binary" });
                                              sheetList = workbook.SheetNames;
                                              data_1 = utils.sheet_to_json(workbook.Sheets[sheetList[0]], { header: 1 });
                                              rows = data_1.filter(isNotBlankRow).map(function (row, index) { return ({ index: index, values: row }); });
                                              setData({
                                                  fileName: file.name,
                                                  rows: rows,
                                                  sheetList: sheetList,
                                                  errors: [], // TODO: Handle any parsing errors
                                              });
                                              goNext();
                                              break;
                                      }
                                      return [2 /*return*/];
                                  });
                              }); };
                              switch (fileType) {
                                  case "csv":
                                      reader.readAsText(file, "utf-8");
                                      break;
                                  case "xlsx":
                                  case "xls":
                                      reader.readAsBinaryString(file);
                                      break;
                              }
                              return [2 /*return*/];
                          });
                      }); } }));
              case StepEnum.RowSelection:
                  return (jsxRuntime.jsx(RowSelection, { data: data, onCancel: reload, onSuccess: function () { return goNext(); }, selectedHeaderRow: selectedHeaderRow, setSelectedHeaderRow: setSelectedHeaderRow }));
              case StepEnum.MapColumns:
                  return (jsxRuntime.jsx(MapColumns, { template: parsedTemplate, data: data, columnMapping: columnMapping, skipHeaderRowSelection: skipHeader, selectedHeaderRow: selectedHeaderRow, onSuccess: function (columnMapping) {
                          setIsSubmitting(true);
                          setColumnMapping(columnMapping);
                          var startIndex = (selectedHeaderRow || 0) + 1;
                          var mappedRows = [];
                          data.rows.slice(startIndex).forEach(function (row) {
                              var resultingRow = {
                                  index: row.index - startIndex,
                                  values: {},
                              };
                              row.values.forEach(function (value, valueIndex) {
                                  var mapping = columnMapping[valueIndex];
                                  if (mapping && mapping.include) {
                                      resultingRow.values[mapping.key] = value;
                                  }
                              });
                              mappedRows.push(resultingRow);
                          });
                          var includedColumns = Object.values(columnMapping).filter(function (_a) {
                              var include = _a.include;
                              return include;
                          });
                          var onCompleteData = {
                              num_rows: mappedRows.length,
                              num_columns: includedColumns.length,
                              error: null,
                              // TODO (client-sdk): Either remove "name" or change it to the be the name of the original upload column
                              columns: includedColumns.map(function (_a) {
                                  var key = _a.key;
                                  return ({ key: key, name: key });
                              }),
                              rows: mappedRows,
                          };
                          onComplete && onComplete(onCompleteData);
                          setIsSubmitting(false);
                          goNext();
                      }, isSubmitting: isSubmitting, onCancel: skipHeader ? reload : function () { return goBack(StepEnum.RowSelection); } }));
              case StepEnum.Complete:
                  return jsxRuntime.jsx(Complete, { reload: reload, close: requestClose, isModal: isModal });
              default:
                  return null;
          }
      };
      return (jsxRuntime.jsxs("div", __assign$1({ className: style$8.wrapper }, { children: [jsxRuntime.jsx("div", { children: jsxRuntime.jsx(Stepper, __assign$1({}, stepper)) }), jsxRuntime.jsx("div", __assign$1({ className: style$8.content }, { children: renderContent() })), !!dataError && (jsxRuntime.jsxs("div", __assign$1({ className: style$8.status }, { children: [jsxRuntime.jsx("div", {}), jsxRuntime.jsx(Errors, { error: dataError, centered: true }), jsxRuntime.jsx("div", {})] }))), isModal && jsxRuntime.jsx(IconButton, { isRound: true, className: style$8.close, colorScheme: "secondary", "aria-label": "Close", icon: jsxRuntime.jsx(PiX, {}), onClick: requestClose })] })));
  }

  var Alert = defineStyleConfig({
      baseStyle: function (props) { return ({
          container: {
              backgroundColor: props.status === "info" ? "var(--color-background-modal)" : "",
              border: "1px solid var(--color-border)",
              borderRadius: "var(--border-radius-2)",
              fontWeight: "400",
          },
          title: {
              color: "inherit",
          },
          description: {
              color: "inherit",
          },
          icon: {
              color: "inherit",
          },
      }); },
  });

  var Button = defineStyleConfig({
      // The styles all buttons have in common
      baseStyle: {
          fontWeight: "normal",
          borderRadius: "base",
          height: "auto",
          lineHeight: "1",
          fontSize: "inherit",
          border: "none",
          cursor: "pointer",
      },
      sizes: {
          sm: {
              fontSize: "sm",
              px: 4,
              py: 3,
          },
          md: {
              fontSize: "md",
              px: 6,
              py: 4,
          },
      },
      variants: {
          solid: function (props) {
              if (props.colorScheme === "secondary") {
                  return {
                      _hover: {
                          backgroundColor: "var(--external-colors-secondary-300)",
                      },
                      color: "var(--color-text-on-secondary)",
                  };
              }
              return {
                  color: "var(--color-text-on-primary)",
                  _hover: {
                      backgroundColor: "var(--external-colors-primary-300)",
                  },
              };
          },
      },
      defaultProps: {
      // variant: "outline",
      },
  });

  var blur = {
      none: 0,
      sm: "4px",
      base: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px",
  };

  var borders = {
      none: 0,
      "1px": "1px solid",
      "2px": "2px solid",
      "4px": "4px solid",
      "8px": "8px solid",
  };

  var breakpoints = {
      base: "0em",
      sm: "30em",
      md: "48em",
      lg: "62em",
      xl: "80em",
      "2xl": "96em",
  };

  var colors = {
      transparent: "transparent",
      current: "currentColor",
      black: "#000000",
      white: "#FFFFFF",
      primary: {
          50: "var(--color-primary)",
          100: "var(--color-primary)",
          200: "var(--color-primary)",
          300: "var(--color-primary-hover)",
          400: "var(--color-primary)",
          500: "var(--color-primary)",
          600: "var(--color-primary)",
          700: "var(--color-primary)",
          800: "var(--color-primary)",
          900: "var(--color-primary)",
      },
      secondary: {
          50: "var(--color-secondary)",
          100: "var(--color-secondary)",
          200: "var(--color-secondary)",
          300: "var(--color-secondary-hover)",
          400: "var(--color-secondary)",
          500: "var(--color-secondary)",
          600: "var(--color-secondary)",
          700: "var(--color-secondary)",
          800: "var(--color-secondary)",
          900: "var(--color-secondary)",
      },
      whiteAlpha: {
          50: "rgba(255, 255, 255, 0.04)",
          100: "rgba(255, 255, 255, 0.06)",
          200: "rgba(255, 255, 255, 0.08)",
          300: "rgba(255, 255, 255, 0.16)",
          400: "rgba(255, 255, 255, 0.24)",
          500: "rgba(255, 255, 255, 0.36)",
          600: "rgba(255, 255, 255, 0.48)",
          700: "rgba(255, 255, 255, 0.64)",
          800: "rgba(255, 255, 255, 0.80)",
          900: "rgba(255, 255, 255, 0.92)",
      },
      blackAlpha: {
          50: "rgba(0, 0, 0, 0.04)",
          100: "rgba(0, 0, 0, 0.06)",
          200: "rgba(0, 0, 0, 0.08)",
          300: "rgba(0, 0, 0, 0.16)",
          400: "rgba(0, 0, 0, 0.24)",
          500: "rgba(0, 0, 0, 0.36)",
          600: "rgba(0, 0, 0, 0.48)",
          700: "rgba(0, 0, 0, 0.64)",
          800: "rgba(0, 0, 0, 0.80)",
          900: "rgba(0, 0, 0, 0.92)",
      },
      gray: {
          50: "#F7FAFC",
          100: "#EDF2F7",
          200: "#E2E8F0",
          300: "#CBD5E0",
          400: "#A0AEC0",
          500: "#718096",
          600: "#4A5568",
          700: "#2D3748",
          800: "#1A202C",
          900: "#171923",
      },
      red: {
          50: "#FFF5F5",
          100: "#FED7D7",
          200: "#FEB2B2",
          300: "#FC8181",
          400: "#F56565",
          500: "#E53E3E",
          600: "#C53030",
          700: "#9B2C2C",
          800: "#822727",
          900: "#63171B",
      },
      orange: {
          50: "#FFFAF0",
          100: "#FEEBC8",
          200: "#FBD38D",
          300: "#F6AD55",
          400: "#ED8936",
          500: "#DD6B20",
          600: "#C05621",
          700: "#9C4221",
          800: "#7B341E",
          900: "#652B19",
      },
      yellow: {
          50: "#FFFFF0",
          100: "#FEFCBF",
          200: "#FAF089",
          300: "#F6E05E",
          400: "#ECC94B",
          500: "#D69E2E",
          600: "#B7791F",
          700: "#975A16",
          800: "#744210",
          900: "#5F370E",
      },
      green: {
          50: "#F0FFF4",
          100: "#C6F6D5",
          200: "#9AE6B4",
          300: "#68D391",
          400: "#48BB78",
          500: "#38A169",
          600: "#2F855A",
          700: "#276749",
          800: "#22543D",
          900: "#1C4532",
      },
      teal: {
          50: "#E6FFFA",
          100: "#B2F5EA",
          200: "#81E6D9",
          300: "#4FD1C5",
          400: "#38B2AC",
          500: "#319795",
          600: "#2C7A7B",
          700: "#285E61",
          800: "#234E52",
          900: "#1D4044",
      },
      blue: {
          50: "#ebf8ff",
          100: "#bee3f8",
          200: "#90cdf4",
          300: "#63b3ed",
          400: "#4299e1",
          500: "#3182ce",
          600: "#2b6cb0",
          700: "#2c5282",
          800: "#2a4365",
          900: "#1A365D",
      },
      cyan: {
          50: "#EDFDFD",
          100: "#C4F1F9",
          200: "#9DECF9",
          300: "#76E4F7",
          400: "#0BC5EA",
          500: "#00B5D8",
          600: "#00A3C4",
          700: "#0987A0",
          800: "#086F83",
          900: "#065666",
      },
      purple: {
          50: "#FAF5FF",
          100: "#E9D8FD",
          200: "#D6BCFA",
          300: "#B794F4",
          400: "#9F7AEA",
          500: "#805AD5",
          600: "#6B46C1",
          700: "#553C9A",
          800: "#44337A",
          900: "#322659",
      },
      pink: {
          50: "#FFF5F7",
          100: "#FED7E2",
          200: "#FBB6CE",
          300: "#F687B3",
          400: "#ED64A6",
          500: "#D53F8C",
          600: "#B83280",
          700: "#97266D",
          800: "#702459",
          900: "#521B41",
      },
      linkedin: {
          50: "#E8F4F9",
          100: "#CFEDFB",
          200: "#9BDAF3",
          300: "#68C7EC",
          400: "#34B3E4",
          500: "#00A0DC",
          600: "#008CC9",
          700: "#0077B5",
          800: "#005E93",
          900: "#004471",
      },
      facebook: {
          50: "#E8F4F9",
          100: "#D9DEE9",
          200: "#B7C2DA",
          300: "#6482C0",
          400: "#4267B2",
          500: "#385898",
          600: "#314E89",
          700: "#29487D",
          800: "#223B67",
          900: "#1E355B",
      },
      messenger: {
          50: "#D0E6FF",
          100: "#B9DAFF",
          200: "#A2CDFF",
          300: "#7AB8FF",
          400: "#2E90FF",
          500: "#0078FF",
          600: "#0063D1",
          700: "#0052AC",
          800: "#003C7E",
          900: "#002C5C",
      },
      whatsapp: {
          50: "#dffeec",
          100: "#b9f5d0",
          200: "#90edb3",
          300: "#65e495",
          400: "#3cdd78",
          500: "#22c35e",
          600: "#179848",
          700: "#0c6c33",
          800: "#01421c",
          900: "#001803",
      },
      twitter: {
          50: "#E5F4FD",
          100: "#C8E9FB",
          200: "#A8DCFA",
          300: "#83CDF7",
          400: "#57BBF5",
          500: "#1DA1F2",
          600: "#1A94DA",
          700: "#1681BF",
          800: "#136B9E",
          900: "#0D4D71",
      },
      telegram: {
          50: "#E3F2F9",
          100: "#C5E4F3",
          200: "#A2D4EC",
          300: "#7AC1E4",
          400: "#47A9DA",
          500: "#0088CC",
          600: "#007AB8",
          700: "#006BA1",
          800: "#005885",
          900: "#003F5E",
      },
  };

  var radii = {
      none: "0",
      sm: "var(--border-radius)",
      base: "var(--border-radius-2)",
      md: "var(--border-radius-3)",
      lg: "var(--border-radius-4)",
      xl: "var(--border-radius-5)",
      "2xl": "calc(var(--border-radius-5) * 1.5)",
      "3xl": "calc(var(--border-radius-5) * 2)",
      full: "9999px",
  };

  var shadows = {
      xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
      sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
      md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
      inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
      none: "none",
      "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px",
  };

  var spacing = {
      px: "1px",
      0.5: "calc(var(--base-spacing) * 0.083)",
      1: "calc(var(--base-spacing) * 0.167)",
      1.5: "calc(var(--base-spacing) * 1)",
      2: "calc(var(--base-spacing) * 0.333)",
      2.5: "calc(var(--base-spacing) * 0.417)",
      3: "calc(var(--base-spacing) * 0.5)",
      3.5: "calc(var(--base-spacing) * 0.583)",
      4: "calc(var(--base-spacing) * 0.667)",
      5: "calc(var(--base-spacing) * 0.833)",
      6: "calc(var(--base-spacing) * 1)",
      7: "calc(var(--base-spacing) * 1.167)",
      8: "calc(var(--base-spacing) * 1.333)",
      9: "calc(var(--base-spacing) * 1.5)",
      10: "calc(var(--base-spacing) * 1.667)",
      12: "calc(var(--base-spacing) * 2)",
      14: "calc(var(--base-spacing) * 2.333)",
      16: "calc(var(--base-spacing) * 2.667)",
      20: "calc(var(--base-spacing) * 3.333)",
      24: "calc(var(--base-spacing) * 4)",
      28: "calc(var(--base-spacing) * 4.667)",
      32: "calc(var(--base-spacing) * 5.333)",
      36: "calc(var(--base-spacing) * 6)",
      40: "calc(var(--base-spacing) * 6.667)",
      44: "calc(var(--base-spacing) * 7.333)",
      48: "calc(var(--base-spacing) * 8)",
      52: "calc(var(--base-spacing) * 8.667)",
      56: "calc(var(--base-spacing) * 9.333)",
      60: "calc(var(--base-spacing) * 10)",
      64: "calc(var(--base-spacing) * 10.667)",
      72: "calc(var(--base-spacing) * 12)",
      80: "calc(var(--base-spacing) * 13.333)",
      96: "calc(var(--base-spacing) * 16)",
  };

  var largeSizes = {
      max: "max-content",
      min: "min-content",
      full: "100%",
      "3xs": "14rem",
      "2xs": "16rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      "8xl": "90rem",
      prose: "60ch",
  };
  var container = {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
  };
  var sizes = __assign$1(__assign$1(__assign$1({}, spacing), largeSizes), { container: container });

  var transitionProperty = {
      common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
      colors: "background-color, border-color, color, fill, stroke",
      dimensions: "width, height",
      position: "left, right, top, bottom",
      background: "background-color, background-image, background-position",
  };
  var transitionTimingFunction = {
      "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
      "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
      "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
  };
  var transitionDuration = {
      "ultra-fast": "50ms",
      faster: "100ms",
      fast: "150ms",
      normal: "200ms",
      slow: "300ms",
      slower: "400ms",
      "ultra-slow": "500ms",
  };
  var transition = {
      property: transitionProperty,
      easing: transitionTimingFunction,
      duration: transitionDuration,
  };

  var typography = {
      letterSpacings: {
          tighter: "-0.05em",
          tight: "-0.025em",
          normal: "0",
          wide: "0.025em",
          wider: "0.05em",
          widest: "0.1em",
      },
      lineHeights: {
          normal: "normal",
          none: 1,
          shorter: 1.25,
          short: 1.375,
          base: 1.5,
          tall: 1.625,
          taller: "2",
          "3": ".75rem",
          "4": "1rem",
          "5": "1.25rem",
          "6": "1.5rem",
          "7": "1.75rem",
          "8": "2rem",
          "9": "2.25rem",
          "10": "2.5rem",
      },
      fontWeights: {
          hairline: 100,
          thin: 200,
          light: 300,
          normal: 400,
          medium: 500,
          semibold: 600,
          bold: 700,
          extrabold: 800,
          black: 900,
      },
      fonts: {
          heading: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
          body: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
          mono: "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace",
      },
      fontSizes: {
          "3xs": "calc(var(--font-size) * 0.45)",
          "2xs": "calc(var(--font-size) * 0.625)",
          xs: "calc(var(--font-size) * 0.75)",
          sm: "calc(var(--font-size) * 0.875)",
          md: "calc(var(--font-size) * 1)",
          lg: "calc(var(--font-size) * 1.125)",
          xl: "calc(var(--font-size) * 1.25)",
          "2xl": "calc(var(--font-size) * 1.5)",
          "3xl": "calc(var(--font-size) * 1.875)",
          "4xl": "calc(var(--font-size) * 2.25)",
          "5xl": "calc(var(--font-size) * 3)",
          "6xl": "calc(var(--font-size) * 3.75)",
          "7xl": "calc(var(--font-size) * 4.5)",
          "8xl": "calc(var(--font-size) * 6)",
          "9xl": "calc(var(--font-size) * 8)",
      },
  };

  var zIndices = {
      hide: -1,
      auto: "auto",
      base: 0,
      docked: 10,
      dropdown: 1000,
      sticky: 1100,
      banner: 1200,
      overlay: 1300,
      modal: 1400,
      popover: 1500,
      skipLink: 1600,
      toast: 1700,
      tooltip: 1800,
  };

  var foundations = __assign$1(__assign$1({ breakpoints: breakpoints, zIndices: zIndices, radii: radii, blur: blur, colors: colors }, typography), { sizes: sizes, shadows: shadows, space: spacing, borders: borders, transition: transition });

  var semanticTokens = {
      colors: {
          "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
          "chakra-body-bg": { _light: "white", _dark: "gray.800" },
          "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
          "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
          "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
          "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
          "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" },
      },
  };

  var styles = {};

  var direction = "ltr";
  var config = {
      useSystemColorMode: false,
      initialColorMode: "light",
      cssVarPrefix: "external",
  };
  var theme = __assign$1(__assign$1({ semanticTokens: semanticTokens, direction: direction }, foundations), { styles: styles, config: config, components: {
          Button: Button,
          Alert: Alert,
      } });

  var myCache = createCache({
      key: "csv-importer",
  });
  var chakraTheme = extendTheme(theme);
  function ThemeProvider(_a) {
      var children = _a.children;
      return (jsxRuntime.jsx(CacheProvider, __assign$1({ value: myCache }, { children: jsxRuntime.jsx(ChakraProvider, __assign$1({ resetCSS: false, disableGlobalStyle: true, theme: chakraTheme }, { children: jsxRuntime.jsx(IconContext.Provider, __assign$1({ value: { className: "react-icon", size: sizes$1.icon.medium } }, { children: children })) })) })));
  }

  function Providers(_a) {
      var children = _a.children;
      return jsxRuntime.jsx(ThemeProvider, { children: children });
  }

  var css_248z$1 = ":root {\n  --base-spacing: 24px;\n  --m-xxxxs: calc(var(--base-spacing) / 5);\n  --m-xxxs: calc(var(--base-spacing) / 4);\n  --m-xxs: calc(var(--base-spacing) / 3);\n  --m-xs: calc(var(--base-spacing) / 2);\n  --m-s: calc(var(--base-spacing) * 2 / 3);\n  --m: var(--base-spacing);\n  --m-mm: calc(var(--base-spacing) * 3 / 2);\n  --m-l: calc(var(--base-spacing) * 5 / 3);\n  --m-xl: calc(var(--base-spacing) * 2);\n  --m-xxl: calc(var(--base-spacing) * 5 / 2);\n  --m-xxxl: calc(var(--base-spacing) * 3);\n  --font-size-xs: calc(var(--font-size) * 16 / 17);\n  --font-size-s: calc(var(--font-size) * 13 / 14);\n  --font-size: 0.875rem;\n  --font-size-l: calc(var(--font-size) * 8 / 7);\n  --font-size-xl: calc(var(--font-size) * 9 / 7);\n  --font-size-xxl: calc(var(--font-size) * 12 / 7);\n  --font-size-xxxl: calc(var(--font-size) * 18 / 7);\n  --font-size-h: calc(var(--font-size) * 24 / 7);\n  --font-family: \"Inter\", sans-serif;\n  --font-family-1: var(--font-family);\n  --font-family-2: \"Laxan\", sans-serif;\n  --border-radius: 4px;\n  --border-radius-1: var(--border-radius);\n  --border-radius-2: calc(var(--border-radius) * 2);\n  --border-radius-3: calc(var(--border-radius) * 3);\n  --border-radius-4: calc(var(--border-radius) * 4);\n  --border-radius-5: calc(var(--border-radius) * 5);\n  --border-radius-r: 50%;\n  --fast: 0.3s;\n  --speed: 0.4s;\n  --slow: 0.9s;\n  --ease: ease-out;\n  --transition-ui: background-color var(--fast) var(--ease), border-color var(--fast) var(--ease), opacity var(--fast) var(--ease),\n    transform var(--fast) var(--ease), color var(--fast) var(--ease);\n  --blurred: 5px; }\n\n:root {\n  --color-primary: #7a5ef8;\n  --color-primary-hover: #664ecf;\n  --color-primary-focus: #7a5ef8;\n  --color-primary-disabled: #d3c9fd;\n  --color-primary-button-disabled: #3f3b55;\n  --color-secondary: #1d2939;\n  --color-secondary-hover: #475467;\n  --color-secondary-focus: #1d2939;\n  --color-secondary-disabled: #344054;\n  --color-text-on-primary: #ffffff;\n  --color-text-on-primary-disabled: #667085;\n  --color-text-on-primary-button-disabled: #ffffff;\n  --color-text-on-secondary: #f2f4f7;\n  --color-text-on-secondary-disabled: #475467;\n  --color-progress-bar: #099250;\n  --color-success: rgba(18, 183, 106, 0.88);\n  --color-emphasis: #0ba5ec;\n  --color-error: rgba(252, 93, 93, 0.88);\n  --color-attention: rgba(248, 203, 44, 0.88);\n  --color-importer-link: #2275d7;\n  --blue-light-500: #0ba5ec;\n  --color-green-ui: var(--color-progress-bar);\n  --color-green: var(--color-success);\n  --color-blue: #0ba5ec;\n  --color-red: rgba(252, 93, 93, 0.88);\n  --color-yellow: rgba(248, 203, 44, 0.88);\n  --importer-link: var(--color-importer-link); }\n\n.CSVImporter-dark {\n  color-scheme: dark;\n  --color-background: #0e1116;\n  --color-background-main: var(--color-background);\n  --color-background-modal: #171a20;\n  --color-background-modal-hover: #2e323c;\n  --color-background-modal-veil: #0e1116;\n  --color-background-modal-shadow: #0e1116;\n  --color-background-modal-shade: #171a20;\n  --color-tertiary: #101828;\n  --color-tertiary-hover: #1d2939;\n  --color-tertiary-focus: #1d2939;\n  --color-tertiary-disabled: #eaecf0;\n  --color-background-menu: #101828;\n  --color-background-menu-hover: #1d2939;\n  --color-text-strong: #f2f4f7;\n  --color-text: #d0d5dd;\n  --color-text-soft: #667085;\n  --color-text-on-tertiary: #ffffff;\n  --color-text-on-tertiary-disabled: #667085;\n  --color-error: #912018;\n  --color-text-error: #f04438;\n  --color-background-error: #f04438;\n  --color-background-error-hover: #d92d20;\n  --color-background-error-soft: #fecdca;\n  --color-input-background: #101828;\n  --color-input-background-soft: #1d2939;\n  --color-input-border: #344054;\n  --color-input-placeholder: #344054;\n  --color-input-text-disabled: #344054;\n  --color-input-disabled: #171a20;\n  --color-border: #1d2939;\n  --color-background-small-button-selected: #344054;\n  --color-background-small-button-hover: #101828;\n  --color-text-small-button: $base-white;\n  --color-button: #f9f5ff;\n  --color-button-hover: #e4dffe;\n  --color-button-disabled: #e4dffe;\n  --color-button-text: #171a20;\n  --color-button-text-disabled: lighter(#171a20, 10);\n  --color-button-border: transparent;\n  --color-border: #344054;\n  --color-border-soft: #1d2939;\n  --color-icon: #d0d5dd;\n  --color-bisel: rgba(255, 255, 255, 0.05);\n  --color-csv-import-text: var(--color-text);\n  --color-stepper: #30374f;\n  --color-stepper-active: #6ce9a6; }\n\n.CSVImporter-light {\n  color-scheme: light;\n  --color-background: #f2f4f7;\n  --color-background-main: #ffffff;\n  --color-background-modal: #ffffff;\n  --color-background-modal-hover: #ffffff;\n  --color-background-modal-veil: #0e1116;\n  --color-background-modal-shadow: transparent;\n  --color-background-modal-shade: #f2f4f7;\n  --color-tertiary: #ffffff;\n  --color-tertiary-hover: #f2f4f7;\n  --color-tertiary-focus: #ffffff;\n  --color-tertiary-disabled: #eaecf0;\n  --color-background-menu: #ffffff;\n  --color-background-menu-hover: #f2f4f7;\n  --color-text-strong: #101828;\n  --color-text: #1d2939;\n  --color-text-soft: #667085;\n  --color-text-on-tertiary: #344054;\n  --color-text-on-tertiary-disabled: #667085;\n  --color-error: #fecdca;\n  --color-text-error: #f04438;\n  --color-background-error: #f04438;\n  --color-background-error-hover: #d92d20;\n  --color-background-error-soft: #fecdca;\n  --color-input-background: #ffffff;\n  --color-input-background-soft: #d0d5dd;\n  --color-input-border: #344054;\n  --color-input-placeholder: #344054;\n  --color-input-text-disabled: #344054;\n  --color-input-disabled: #f9fafb;\n  --color-border: #1d2939;\n  --color-background-small-button-selected: #f2f4f7;\n  --color-background-small-button-hover: #f9fafb;\n  --color-text-small-button: var(--color-text);\n  --color-button: #ffffff;\n  --color-button-hover: #f2f4f7;\n  --color-button-disabled: #fcfcfd;\n  --color-button-text: var(--color-text-soft);\n  --color-button-text-disabled: #d0d5dd;\n  --color-button-border: #d0d5dd;\n  --color-border: #d0d5dd;\n  --color-border-soft: #eaecf0;\n  --color-icon: #101323;\n  --color-bisel: rgba(0, 0, 0, 0.05);\n  --color-csv-import-text: #130638;\n  --color-stepper: #b9c0d4;\n  --color-stepper-active: #6ce9a6; }\n\n.csv-importer {\n  font-family: var(--font-family-1);\n  background-color: var(--color-background);\n  color: var(--color-text);\n  font-size: var(--font-size);\n  font-weight: 500;\n  line-height: 1.5; }\n  .csv-importer * {\n    box-sizing: border-box; }\n  .csv-importer .container {\n    max-width: 1300px;\n    margin: 0 auto; }\n";
  styleInject(css_248z$1);

  var css_248z = ".CSVImporter {\n  border: none;\n  background-color: transparent;\n  padding: 0 1rem;\n  border-radius: 1.2rem;\n  color: inherit;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  /* height: 2.4rem; */\n  display: inline-flex;\n  gap: 0.5rem;\n  align-items: center;\n  transition: filter 0.2s ease-out;\n}\n\n.CSVImporter svg {\n  display: block;\n}\n\n.CSVImporter svg path {\n  stroke: currentColor !important;\n}\n\n.CSVImporter:hover,\n.CSVImporter:active {\n  filter: brightness(1.2);\n}\n\n.CSVImporter-dialog::backdrop {\n  background-color: rgba(0, 0, 0, 0.85);\n}\n\n.CSVImporter-dialog {\n  border-radius: 1rem;\n  width: 80vw;\n  height: 100vh;\n  min-width: 907px;\n  border: none;\n  position: fixed;\n  inset: 0;\n  padding: 0;\n  margin: auto;\n}\n\n.CSVImporter-div {\n  border: none;\n  display: block;\n  width: 100%;\n  height: 98vh;\n  overflow-y: hidden;\n}\n\n@media (max-width: 768px) {\n  .CSVImporter-dialog {\n    width: 90vw;\n    min-width: 950px;\n  }\n}\n";
  styleInject(css_248z);

  var CSVImporter = react.forwardRef(function (importerProps, forwardRef) {
      var _a = importerProps.isModal, isModal = _a === void 0 ? true : _a, _b = importerProps.modalIsOpen, modalIsOpen = _b === void 0 ? true : _b, _c = importerProps.modalOnCloseTriggered, modalOnCloseTriggered = _c === void 0 ? function () { return null; } : _c, modalCloseOnOutsideClick = importerProps.modalCloseOnOutsideClick; importerProps.template; var _d = importerProps.darkMode, darkMode = _d === void 0 ? false : _d, _e = importerProps.primaryColor, primaryColor = _e === void 0 ? "#7a5ef8" : _e, className = importerProps.className; importerProps.onComplete; importerProps.customStyles; importerProps.showDownloadTemplateButton; importerProps.skipHeaderRowSelection; var language = importerProps.language, customTranslations = importerProps.customTranslations, props = __rest$1(importerProps, ["isModal", "modalIsOpen", "modalOnCloseTriggered", "modalCloseOnOutsideClick", "template", "darkMode", "primaryColor", "className", "onComplete", "customStyles", "showDownloadTemplateButton", "skipHeaderRowSelection", "language", "customTranslations"]);
      var ref = forwardRef !== null && forwardRef !== void 0 ? forwardRef : react.useRef(null);
      var _f = useTranslation(); _f.t; var i18n = _f.i18n;
      var current = ref === null || ref === void 0 ? void 0 : ref.current;
      react.useEffect(function () {
          i18n.changeLanguage(language);
      }, [language]);
      react.useEffect(function () {
          if (customTranslations) {
              Object.keys(customTranslations).forEach(function (language) {
                  i18n.addResourceBundle(language, "translation", customTranslations[language], true, true);
              });
          }
      }, [customTranslations]);
      react.useEffect(function () {
          var _a, _b;
          if (isModal && current) {
              if (modalIsOpen)
                  (_a = current === null || current === void 0 ? void 0 : current.showModal) === null || _a === void 0 ? void 0 : _a.call(current);
              else
                  (_b = current === null || current === void 0 ? void 0 : current.close) === null || _b === void 0 ? void 0 : _b.call(current);
          }
      }, [isModal, modalIsOpen, current]);
      var baseClass = "CSVImporter";
      var themeClass = darkMode ? "".concat(baseClass, "-dark") : "".concat(baseClass, "-light");
      var domElementClass = ["csv-importer", "".concat(baseClass, "-").concat(isModal ? "dialog" : "div"), themeClass, className].filter(function (i) { return i; }).join(" ");
      // Set Light/Dark mode
      var setTheme = useThemeStore(function (state) { return state.setTheme; });
      react.useEffect(function () {
          var theme = darkMode ? "dark" : "light";
          setTheme(theme);
      }, [darkMode]);
      // Apply primary color
      react.useEffect(function () {
          if (primaryColor && isValidColor(primaryColor)) {
              var root = document.documentElement;
              root.style.setProperty("--color-primary", primaryColor);
              root.style.setProperty("--color-primary-hover", darkenColor(primaryColor, 20));
          }
      }, [primaryColor]);
      var backdropClick = function (event) {
          if (modalCloseOnOutsideClick && event.target === current) {
              modalOnCloseTriggered();
          }
      };
      current === null || current === void 0 ? void 0 : current.addEventListener("cancel", function () {
          modalOnCloseTriggered();
      });
      var elementProps = __assign$1(__assign$1(__assign$1({ ref: ref }, (isModal ? { onClick: backdropClick } : {})), { className: domElementClass, "data-theme": darkMode ? "dark" : "light", style: { colorScheme: darkMode ? "dark" : "light" } }), props);
      var ImporterComponent = function () { return (jsxRuntime.jsx(Providers, { children: jsxRuntime.jsx(Main, __assign$1({}, importerProps)) })); };
      return isModal ? (jsxRuntime.jsx("div", __assign$1({ className: "csvImporter" }, { children: jsxRuntime.jsx("dialog", __assign$1({}, elementProps, { children: jsxRuntime.jsx(ImporterComponent, {}) })) }))) : (jsxRuntime.jsx("div", __assign$1({}, elementProps, { children: jsxRuntime.jsx(ImporterComponent, {}) })));
  });

  function createCSVImporter(props) {
      var ref = react.createRef();
      var domElement = props.domElement || document.body;
      reactDom.render(jsxRuntime.jsx(CSVImporter, __assign$1({ ref: ref }, props)), domElement);
      return {
          instance: ref.current,
          showModal: function () {
              var _a, _b;
              (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showModal) === null || _b === void 0 ? void 0 : _b.call(_a);
          },
          closeModal: function () {
              var _a, _b;
              (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close) === null || _b === void 0 ? void 0 : _b.call(_a);
          },
      };
  }

  exports.createCSVImporter = createCSVImporter;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.js.map
